
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kId2E", function(module, exports) {
/* ForYou.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $cO1el = parcelRequire("cO1el");


var $hnvzE = parcelRequire("hnvzE");





var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $6mKj3 = parcelRequire("6mKj3");

/**
 * @generated SignedSource<<7754502190c9fc986412bf30016d40a0>>
 * @relayHash 1863df8f5b437509db01b53adb690a5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 562db4f12c4ad9eae28ba6c51ae8da8b69fd2ce5bffe3434f22e60bb0283413f
const $bdc4704ef838d750$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "team"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPersonalSpace"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsEligibleForPersonalizedTemplatesV2GetPersonalSpaceKeyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsEligibleForPersonalizedTemplatesV2GetPersonalSpaceKeyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1863df8f5b437509db01b53adb690a5e",
            "id": "562db4f12c4ad9eae28ba6c51ae8da8b69fd2ce5bffe3434f22e60bb0283413f",
            "metadata": {},
            "name": "useIsEligibleForPersonalizedTemplatesV2GetPersonalSpaceKeyQuery",
            "operationKind": "query",
            "text": "query useIsEligibleForPersonalizedTemplatesV2GetPersonalSpaceKeyQuery{user:confluence_atlassianUser(current:true){id,team,confluence{hasPersonalSpace,space{id,key}}}}"
        }
    };
}();
$bdc4704ef838d750$var$node.hash = "c5200736e1bf2cb94aae4951d21860dd";
var $bdc4704ef838d750$export$2e2bcd8739ae039 = $bdc4704ef838d750$var$node;






var $917iu = parcelRequire("917iu");


var $bQm3c = parcelRequire("bQm3c");








var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");

var $1gy7x = parcelRequire("1gy7x");


var $dCb9P = parcelRequire("dCb9P");


var $2FNNv = parcelRequire("2FNNv");


var $1ytiN = parcelRequire("1ytiN");


var $7c4rV = parcelRequire("7c4rV");


var $jMyy4 = parcelRequire("jMyy4");

const $c40f927ec91fa029$export$ec209108e9c3bdab = (0, $bdc4704ef838d750$export$2e2bcd8739ae039);
const $c40f927ec91fa029$export$1cb684a5f5ad885 = ()=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isEstablishedUserTraitName = (0, $2FNNv.useIsEstablishedUserTraitName)();
    (0, $42omo.useEffect)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.ONBOARDING_PERSONALIZED_TEMPLATES_V2)
        });
    }, [
        experienceTracker
    ]);
    // First check if they are even a founding admin
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
        ...Object.values((0, $1gy7x.PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS))
    ], !isSiteAdmin);
    const { data: personalSpaceKeyData, loading: personalSpaceKeyLoading, error: personalSpaceKeyError } = (0, $jMyy4.useQueryInterop)($c40f927ec91fa029$export$ec209108e9c3bdab, {
        skip: !userId,
        __callerPackage__: "@confluence/experiment-personalized-templates-v2"
    });
    const { data: accountTraitsData, loading: accountTraitsLoading, error: accountTraitsError } = (0, $7c4rV.useAtlassianAccountTraits)({
        skipBootstrap: !isSiteAdmin
    });
    const { isFoundingAdmin: isFoundingAdmin, takeoverSeenAt: takeoverSeenAt, hasDismissedOnboardingActions: hasDismissedOnboardingActions, isTemplateListDismissed: isTemplateListDismissed } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const personalSpaceKey = personalSpaceKeyData?.user?.confluence?.hasPersonalSpace && personalSpaceKeyData?.user?.confluence?.space?.key || '';
    const hasDismissedTakeover = hasDismissedOnboardingActions && isTemplateListDismissed;
    const isInOnboardingPeriod = Boolean(takeoverSeenAt) && (0, $917iu.default)(new Date(), new Date(takeoverSeenAt)) <= 14;
    const takeoverExpired = Boolean(takeoverSeenAt) && (0, $917iu.default)(new Date(), new Date(takeoverSeenAt)) > 14;
    const isEstablishedUser = accountTraitsData?.attributes?.find((attr)=>attr?.name === isEstablishedUserTraitName)?.value === 'true';
    const potentiallyEligibleUserForPTV2 = isFoundingAdmin && !takeoverExpired && !hasDismissedTakeover && !isEstablishedUser;
    // If both founding admin + !established user, then we can check if they are a land founding admin
    const { isLandUser: isLandUser, isXflowUser: isXflowUser, error: userTypeError, loading: userTypeLoading } = (0, $dCb9P.useUserByLicensedProducts)({
        skip: !potentiallyEligibleUserForPTV2
    });
    /**
   * 1. If they have seen it, then they are simply eligible for the takeover.
   * 2. If they haven't seen it yet,  then we need to check the other eligibility conditions
   * 		to determine if we should set `takeoverSeenAt` later -> show the takeover.
   *   a. They need to be not established
   *   b. They need to be a founding admin
   *   c. They need to have a personal space
   */ const isGenerallyEligible = takeoverSeenAt !== undefined || Boolean(isFoundingAdmin && !isEstablishedUser && Boolean(personalSpaceKey));
    if (personalSpaceKeyLoading || userTypeLoading || onboardingStateLoading || accountTraitsLoading) return {
        isEligibleForLand: false,
        isEligibleForXflow: false,
        loading: true,
        isVisible: false
    };
    if (userTypeError || onboardingStateError || personalSpaceKeyError || accountTraitsError) experienceTracker.stopOnError({
        name: (0, $irVI7.ONBOARDING_PERSONALIZED_TEMPLATES_V2),
        error: userTypeError || onboardingStateError || personalSpaceKeyError || accountTraitsError
    });
    return {
        isEligibleForLand: isLandUser && isGenerallyEligible,
        isEligibleForXflow: isXflowUser && isGenerallyEligible,
        loading: false,
        isVisible: (isLandUser || isXflowUser) && isGenerallyEligible && (takeoverSeenAt === undefined || isInOnboardingPeriod) && !hasDismissedTakeover,
        wasPTV2TakeoverSeen: Boolean(takeoverSeenAt)
    };
};


/**
 * @generated SignedSource<<314ed35f652731cebaedbd0043886a30>>
 * @relayHash fcde14ee9d1ec0e3c9fb1781be4474aa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8a83ab43de8aebd4391c278fd211b54d395b77175a7c7ef77e1d6783a481d13a
const $a0f70f5b02f4883d$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "team"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPersonalSpace"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fcde14ee9d1ec0e3c9fb1781be4474aa",
            "id": "8a83ab43de8aebd4391c278fd211b54d395b77175a7c7ef77e1d6783a481d13a",
            "metadata": {},
            "name": "useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery",
            "operationKind": "query",
            "text": "query useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery{user:confluence_atlassianUser(current:true){id,team,confluence{hasPersonalSpace,space{id,key}}}}"
        }
    };
}();
$a0f70f5b02f4883d$var$node.hash = "2d292d6e6d3ff58f591364b4a8548ff0";
var $a0f70f5b02f4883d$export$2e2bcd8739ae039 = $a0f70f5b02f4883d$var$node;












var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $95rLf = parcelRequire("95rLf");


var $9wGTI = parcelRequire("9wGTI");





var $eyUJP = parcelRequire("eyUJP");







var $d9tcB = parcelRequire("d9tcB");


var $JCGnt = parcelRequire("JCGnt");





var $c8Y4F = parcelRequire("c8Y4F");




const $7464c4ddf12420b1$var$useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery = (0, $c8Y4F.default);
const $7464c4ddf12420b1$export$4c79b4b8a009727d = (skip)=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($7464c4ddf12420b1$var$useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery, {
        skip: skip,
        __callerPackage__: "@confluence/experiment-personalized-templates-v2"
    });
    const licensedUserCount = data?.license?.licenseConsumingUserCount ?? 0;
    return {
        loading: loading,
        error: error,
        licensedUserCount: licensedUserCount
    };
};


const $d7cf94dbebfcc162$var$useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery = (0, $a0f70f5b02f4883d$export$2e2bcd8739ae039);
const $d7cf94dbebfcc162$export$4fd12986b310e943 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isLicensedUser = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)(Object.values({
        IS_FOUNDING_ADMIN: (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
        ...(0, $eyUJP.NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS)
    }), !isLicensedUser || !(0, $9wGTI.fg)('cc-enable-nth-user-home-onboarding-revamp'));
    const { isFoundingAdmin: isFoundingAdmin, takeoverSeenAt: takeoverSeenAt } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const isNthUser = isLicensedUser && !onboardingStateLoading && !onboardingStateError && !isFoundingAdmin;
    const { licensedUserCount: licensedUserCount, loading: userCountDataLoading, error: userCountDataError } = (0, $7464c4ddf12420b1$export$4c79b4b8a009727d)(!isNthUser || !(0, $9wGTI.fg)('cc-enable-nth-user-home-onboarding-revamp'));
    const { isNewUser: isNewUser, loading: isNewUserLoading } = (0, $JCGnt.useIsNewUser)({
        activeDaysThreshold: 15
    }, !isNthUser || !(0, $9wGTI.fg)('cc-activation-unify-home-onboarding-kill-switch'));
    const isOverTenUserInstance = Boolean(licensedUserCount && licensedUserCount > 10);
    const { data: userData, loading: userDataLoading, error: userDataError } = (0, $jMyy4.useQueryInterop)($d7cf94dbebfcc162$var$useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery, {
        skip: !isNthUser || !(0, $9wGTI.fg)('cc-enable-nth-user-home-onboarding-revamp'),
        __callerPackage__: "@confluence/experiment-personalized-templates-v2"
    });
    const personalSpaceKey = userData?.user?.confluence?.hasPersonalSpace && userData?.user?.confluence?.space?.key;
    const isExperienceWithinFourteenDays = (0, $42omo.useMemo)(()=>{
        if (!takeoverSeenAt) return true;
        return (0, $917iu.default)(new Date(), new Date(takeoverSeenAt)) <= 14;
    }, [
        takeoverSeenAt
    ]);
    const eligibilityError = onboardingStateError || userCountDataError || userDataError;
    if (eligibilityError && ((0, $1uFM6.isUnauthorizedError)(eligibilityError) || (0, $95rLf.isExpectedApolloError)(eligibilityError))) (0, $7Sm4c.markErrorAsHandled)(eligibilityError);
    const loading = onboardingStateLoading || userCountDataLoading || userDataLoading || Boolean(isNewUserLoading);
    const isEligible = Boolean(!eligibilityError && !loading && isNthUser && isOverTenUserInstance && !!personalSpaceKey && isNewUser && !(0, $6mKj3.expValEquals)('cc-activation-unify-home-onboarding-nth-user', 'cohort', 'experiment'));
    return {
        isEligible: isEligible,
        isVisible: isEligible && isExperienceWithinFourteenDays,
        loading: loading,
        error: eligibilityError
    };
};



















var $lvvx5 = parcelRequire("lvvx5");

var $cTaz1 = parcelRequire("cTaz1");

var $cFEpk = parcelRequire("cFEpk");

const $105c1ec9298e5371$export$1d2f395a0e4c4b9f = (timestamp)=>{
    if (!timestamp || timestamp.trim() === '') return false;
    const timestampDate = new Date(timestamp);
    if (!(0, $cFEpk.default)(timestampDate)) return false;
    const now = new Date();
    // If the date is in the future, check if it's within 2 weeks from now
    if ((0, $cTaz1.default)(timestampDate)) return (0, $lvvx5.default)(timestampDate, now) < 2;
    // If the date is in the past, check if it's within 2 weeks ago
    return (0, $lvvx5.default)(now, timestampDate) < 2;
};





const $6f0db1142174f95f$export$93613d399942f4cb = ()=>{
    const { data: data, loading: onboardingLoading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
        (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).VIEWED_AT,
        (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).DISMISSED_HEADER
    ], !(0, $9wGTI.fg)('use-cases-onboarding-state-retrieval-kill-switch'));
    const { isFoundingAdmin: isFoundingAdmin, viewedAt: viewedAt, headerDismissed: headerDismissed } = (0, $ivb8S.deserializeState)(data);
    const isNthUser = !onboardingLoading && !error && !isFoundingAdmin;
    const { licensedUserCount: licensedUserCount, loading: userCountDataLoading, error: userCountDataError } = (0, $7464c4ddf12420b1$export$4c79b4b8a009727d)(!isNthUser || !(0, $9wGTI.fg)('cc-activation-unify-home-onboarding-kill-switch'));
    const { isNewUser: isNewUser, loading: isNewUserLoading } = (0, $JCGnt.useIsNewUser)({}, !isNthUser || !(0, $9wGTI.fg)('cc-activation-unify-home-onboarding-kill-switch'));
    const isOverTenUserInstance = Boolean(licensedUserCount && licensedUserCount > 10);
    const isUnifyHomeOnboardingExperimentEligible = !userCountDataError && !userCountDataLoading && !isNewUserLoading && isOverTenUserInstance && isNewUser && (0, $9wGTI.fg)('cc-activation-unify-home-onboarding-kill-switch');
    const isWithinValidTimeWindow = (0, $42omo.useMemo)(()=>{
        if (isUnifyHomeOnboardingExperimentEligible && (0, $6mKj3.expValEquals)('cc-activation-unify-home-onboarding-nth-user', 'cohort', 'experiment')) // Experiment users: Since they are not exposed to Account Setup Scrren viewedAt is set to null.
        return !viewedAt || viewedAt.trim() === '' || (0, $105c1ec9298e5371$export$1d2f395a0e4c4b9f)(viewedAt);
        // Regular users: must be within 14 days
        return (0, $105c1ec9298e5371$export$1d2f395a0e4c4b9f)(viewedAt);
    }, [
        viewedAt,
        isUnifyHomeOnboardingExperimentEligible
    ]);
    // We only want to show useCasesInNthUserOnboarding if we are within the 14 days onboarding period
    // and the header has not already been dismissed.
    const isEligibleForUseCasesHomeChanges = isWithinValidTimeWindow && !headerDismissed && !error;
    return {
        loading: onboardingLoading || userCountDataLoading || Boolean(isNewUserLoading),
        isEligible: isEligibleForUseCasesHomeChanges,
        error: error || userCountDataError
    };
};



var $aDe4X = parcelRequire("aDe4X");

function $f869c0d94495260f$export$fa48385168985af8() {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isEligible: v2NthUserEligible, loading: v2NthUserLoading, isVisible: v2NthUserVisible } = (0, $aDe4X.useNthUserHomeOnboardingTakeoverV2Eligibility)();
    const { isEligibleForLand: ptv2Eligible, isEligibleForXflow: ptv2EligibleXflow, loading: ptv2Loading, isVisible: isPTV2Visible } = (0, $c40f927ec91fa029$export$1cb684a5f5ad885)();
    const { isEligible: nthUserHomeOnboardingRevampEligible, loading: nthUserHomeOnboardingRevampLoading, isVisible: nthUserHomeOnboardingRevampVisible } = (0, $d7cf94dbebfcc162$export$4fd12986b310e943)();
    const { loading: useCasesLoading, isEligible: isEligibleForUseCasesHomeChanges } = (0, $6f0db1142174f95f$export$93613d399942f4cb)();
    (0, $42omo.useEffect)(()=>{
        if (!ptv2Loading && !(ptv2Eligible || ptv2EligibleXflow)) experienceTracker.abort({
            name: (0, $irVI7.ONBOARDING_PERSONALIZED_TEMPLATES_V2),
            reason: 'Not eligible for v2 takeover'
        });
    }, [
        ptv2Eligible,
        ptv2EligibleXflow,
        ptv2Loading,
        experienceTracker
    ]);
    // Early return for loading states
    const loading = [
        ptv2Loading,
        nthUserHomeOnboardingRevampLoading,
        useCasesLoading,
        v2NthUserLoading
    ];
    if (loading.some(Boolean)) return {
        onboardingTakeoverType: null,
        loading: true
    };
    if (isEligibleForUseCasesHomeChanges) return {
        onboardingTakeoverType: 'use-cases-in-nth-user-onboarding'
    };
    // Check for nth user home onboarding revamp
    if (nthUserHomeOnboardingRevampEligible && (0, $6mKj3.expValEquals)('cc-nth-user-home-onboarding-revamp', 'cohort', 'experiment')) {
        if (nthUserHomeOnboardingRevampVisible) return {
            onboardingTakeoverType: 'nth-user-home-onboarding-revamp'
        };
        return {
            onboardingTakeoverType: null
        };
    }
    if (ptv2Eligible) return isPTV2Visible ? {
        onboardingTakeoverType: 'personalized-templates-v2'
    } : {
        onboardingTakeoverType: null
    };
    else if (ptv2EligibleXflow) return isPTV2Visible ? {
        onboardingTakeoverType: 'personalized-templates-v2-xflow'
    } : {
        onboardingTakeoverType: null
    };
    if (v2NthUserEligible) return v2NthUserVisible ? {
        onboardingTakeoverType: 'nth-user'
    } : {
        onboardingTakeoverType: null
    };
    return {
        onboardingTakeoverType: null
    };
}



var $dS3n9 = parcelRequire("dS3n9");


var $eCryJ = parcelRequire("eCryJ");


var $3IBnw = parcelRequire("3IBnw");





var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");


var $1A7bE = parcelRequire("1A7bE");


var $aJPUt = parcelRequire("aJPUt");


var $iqPSe = parcelRequire("iqPSe");


var $7boqA = parcelRequire("7boqA");


var $bxcP5 = parcelRequire("bxcP5");


var $kLaAt = parcelRequire("kLaAt");


var $eSLr0 = parcelRequire("eSLr0");


var $i1Y90 = parcelRequire("i1Y90");


var $lt6Lx = parcelRequire("lt6Lx");




var $4Cx0V = parcelRequire("4Cx0V");






var $5mBfb = parcelRequire("5mBfb");




var $jmjWc = parcelRequire("jmjWc");


const $f8c0187a09ac9108$export$76c223fce296f63d = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EsZsn",
    name: "LazyAutomationExecutionLimit",
    loader: async ()=>(await (parcelRequire("aaVos"))).AutomationExecutionLimitMessageComponent
});









var $gkVDU = parcelRequire("gkVDU");

/* RightPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $b3j2Y = parcelRequire("b3j2Y");


var $kvJHJ = parcelRequire("kvJHJ");





var $h1Vf7 = parcelRequire("h1Vf7");





var $gdv5Z = parcelRequire("gdv5Z");








var $4PPzL = parcelRequire("4PPzL");













var $7Ndnw = parcelRequire("7Ndnw");


var $4vC63 = parcelRequire("4vC63");


var $7QUD1 = parcelRequire("7QUD1");


var $9fBoq = parcelRequire("9fBoq");


var $dizL5 = parcelRequire("dizL5");


var $4lbme = parcelRequire("4lbme");

const $c911dd4d390b4089$var$CollapsibleForgeApps = ({ forgeApps: forgeApps })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [appInitialStates, setAppInitialStates] = (0, $42omo.useState)(new Map());
    const onInitialRender = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.HOME_RIGHT_PANEL_FORGE_EXPERIENCE)
        });
    }, [
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, forgeApps.map((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
            key: app.id,
            module: app
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4lbme.CollapsibleSection), {
            sectionId: app.id,
            header: (0, $9fBoq.extensionTitle)(app),
            initialStateOverride: appInitialStates.get(app.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.HOME_RIGHT_PANEL_FORGE_EXPERIENCE),
            id: app.id
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            padding: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.HomepageFeedForgeApp), {
            app: app,
            extensionData: {
                type: (0, $7Ndnw.FORGE_MODULE_HOMEPAGE_FEED)
            },
            onInitialRender: onInitialRender
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
            module: app,
            action: ()=>{
                const oldValue = appInitialStates.get(app.id);
                const newValue = oldValue === 'EXPANDED' ? 'COLLAPSED' : 'EXPANDED';
                setAppInitialStates(new Map(appInitialStates.set(app.id, newValue)));
            }
        }))));
};
const $c911dd4d390b4089$export$48874bdb6736064e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_HOMEPAGE_FEED),
        render: (forgeModules, loading, error)=>{
            if (loading) return null;
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
                return null;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).DISCO
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c911dd4d390b4089$var$CollapsibleForgeApps, {
                forgeApps: forgeModules
            }));
        }
    });
};


/* RightPanelDragHandle.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $edb12c54129d5bfa$var$dragHandleStyles = {
    default: "_v5641038 _1kl75u6v _1bsb19bv _4t3i1osq _154iidpf _kqswstnw _80om11mm _18u0xmi2 _4cvxa755",
    isDown: "_1h6da755"
};
const $edb12c54129d5bfa$export$47ecfdcf2282c863 = ({ onResizeDrag: onResizeDrag, onResizeComplete: onResizeComplete })=>{
    const handleRef = (0, $42omo.useRef)(null);
    const [isDown, setIsDown] = (0, $42omo.useState)(false);
    const previousUpdate = (0, $42omo.useRef)({
        clientX: 0,
        time: 0
    });
    (0, $42omo.useEffect)(()=>{
        const downListener = (e)=>{
            if (e.button !== 0) return;
            setIsDown(true);
            previousUpdate.current = {
                clientX: e.clientX,
                time: Date.now()
            };
            document.body.style.cursor = 'col-resize';
            e.preventDefault();
        };
        const handleRefCurrent = handleRef.current;
        handleRefCurrent?.addEventListener('mousedown', downListener);
        return ()=>{
            document.body.style.cursor = 'default';
            handleRefCurrent?.removeEventListener('mousedown', downListener);
        };
    }, []);
    (0, $42omo.useEffect)(()=>{
        const upListener = (e)=>{
            if (e.button !== 0) return;
            setIsDown(false);
            document.body.style.cursor = 'default';
            onResizeComplete();
        };
        const moveListener = (e)=>{
            if (e.button !== 0) return;
            if (isDown) {
                const now = Date.now();
                if (now - previousUpdate.current.time > 30) {
                    onResizeDrag(e.clientX - previousUpdate.current.clientX);
                    previousUpdate.current = {
                        clientX: e.clientX,
                        time: now
                    };
                }
                e.preventDefault();
            }
        };
        window.addEventListener('mouseup', upListener);
        window.addEventListener('mousemove', moveListener);
        return ()=>{
            window.removeEventListener('mouseup', upListener);
            window.removeEventListener('mousemove', moveListener);
        };
    }, [
        isDown,
        onResizeDrag,
        onResizeComplete
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: handleRef,
        "data-testid": "resize-handle",
        className: (0, $gMc0m.default)([
            $edb12c54129d5bfa$var$dragHandleStyles['default'],
            $edb12c54129d5bfa$var$dragHandleStyles['isDown']
        ])
    });
};



var $jYZYm = parcelRequire("jYZYm");

/* eslint react-hooks/exhaustive-deps: 0 */ 



var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $58fab37e09524ad2$export$f94783f43423b3cb = 'right-panel-compact';
const $58fab37e09524ad2$export$430e07f935c066f6 = ({ rightPanelRef: rightPanelRef, defaultWidth: defaultWidth, minWidth: minWidth, maxWidth: maxWidth, compactThreshold: compactThreshold })=>{
    const totalOffset = (0, $42omo.useRef)(0);
    const [initialWidth, setInitialWidth] = (0, $42omo.useState)(parseInt((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).HOME_SIDEBAR_WIDTH)) || defaultWidth);
    const applyCompactStyling = ()=>{
        if (!rightPanelRef.current) return;
        if (rightPanelRef.current.offsetWidth < compactThreshold) rightPanelRef.current.classList.add($58fab37e09524ad2$export$f94783f43423b3cb);
        else rightPanelRef.current.classList.remove($58fab37e09524ad2$export$f94783f43423b3cb);
    };
    const onResizeDrag = (0, $42omo.useCallback)((offset)=>{
        totalOffset.current += offset;
        const newWidth = Math.max(Math.min(initialWidth - totalOffset.current, maxWidth), minWidth);
        requestAnimationFrame(()=>{
            rightPanelRef.current.style.setProperty('width', `${newWidth}px`);
            applyCompactStyling();
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        rightPanelRef,
        totalOffset,
        initialWidth
    ]);
    const onResizeComplete = (0, $42omo.useCallback)(()=>{
        // Tests require this fallback to style.width because jsdom doesn't give elements an actual width
        const finalWidth = rightPanelRef.current.offsetWidth || parseInt(rightPanelRef.current.style.width || '');
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).HOME_SIDEBAR_WIDTH, finalWidth);
        setInitialWidth(finalWidth);
        totalOffset.current = 0;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        totalOffset,
        (0, $17wUi.confluenceLocalStorageInstance)
    ]);
    (0, $42omo.useEffect)(()=>{
        applyCompactStyling();
        const resizeListener = ()=>{
            applyCompactStyling();
        };
        window.addEventListener('resize', resizeListener);
        return ()=>window.removeEventListener('resize', resizeListener);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        rightPanelRef: rightPanelRef,
        onResizeDrag: onResizeDrag,
        onResizeComplete: onResizeComplete,
        initialWidth: initialWidth
    };
};


const $6a570c156dcdbd2e$var$DEFAULT_WIDTH = 475;
const $6a570c156dcdbd2e$var$MIN_WIDTH = 350;
const $6a570c156dcdbd2e$var$MAX_WIDTH = 818;
const $6a570c156dcdbd2e$var$POPULAR_COMPACT_THRESHOLD = 500;
const $6a570c156dcdbd2e$var$resizeablePanelStyles = null;
const $6a570c156dcdbd2e$var$panelContainerStyles = null;
const $6a570c156dcdbd2e$var$collectRightPanelExperiences = (events, experience)=>{
    (0, $1A7bE.collectAll)([
        (0, $irVI7.HOME_RIGHT_PANEL_WELCOME_MESSAGE_EXPERIENCE),
        (0, $irVI7.HOME_RIGHT_PANEL_APPS_EXPERIENCE),
        (0, $irVI7.HOME_SPACES_EXPERIENCE)
    ])(events, experience);
};
const $6a570c156dcdbd2e$export$364a989a35814102 = ({ widthMode: widthMode = 'resizable' })=>{
    const rightPanelRef = (0, $42omo.useRef)(null);
    const { shouldShowForgeApps: shouldShowForgeApps } = (0, $jYZYm.useRightPanelVisible)();
    const { onResizeDrag: onResizeDrag, onResizeComplete: onResizeComplete, initialWidth: initialWidth } = (0, $58fab37e09524ad2$export$430e07f935c066f6)({
        rightPanelRef: rightPanelRef,
        defaultWidth: $6a570c156dcdbd2e$var$DEFAULT_WIDTH,
        minWidth: $6a570c156dcdbd2e$var$MIN_WIDTH,
        maxWidth: $6a570c156dcdbd2e$var$MAX_WIDTH,
        compactThreshold: $6a570c156dcdbd2e$var$POPULAR_COMPACT_THRESHOLD
    }); // Query for widget state here so that the data is ready by the time the CollapsibleSections render
    const { error: error, loading: preferencesLoading } = (0, $h1Vf7.useHomeWidgetState)('right-panel');
    const widthStyle = $6a570c156dcdbd2e$var$useWidthStyle(widthMode, initialWidth);
    if (preferencesLoading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("aside", {
        ref: rightPanelRef,
        style: widthStyle,
        className: (0, $gMc0m.default)([
            widthMode === 'resizable' && "_1yt4utpp _vchhusvi _4t3i1osq _18m91wug _1nmz1hna _bfhkhp5a",
            widthMode !== 'resizable' && "_vchhusvi _4t3izd3w _1nmz1hna _otyr1ejb"
        ]),
        "data-vc": "5Vpyhj2p"
    }, widthMode === 'resizable' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $edb12c54129d5bfa$export$47ecfdcf2282c863), {
        onResizeDrag: onResizeDrag,
        onResizeComplete: onResizeComplete
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.HOME_RIGHT_PANEL_EXPERIENCE),
        collect: $6a570c156dcdbd2e$var$collectRightPanelExperiences
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "right-panel-content"
    }, shouldShowForgeApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c911dd4d390b4089$export$48874bdb6736064e), null)), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $gkVDU.HOME_OVERVIEW_RIGHT_PANEL_PAGE_SEGMENT)
    })));
};
const $6a570c156dcdbd2e$var$useWidthStyle = (widthMode, initialWidth)=>{
    const width = widthMode === 'fullwidth' ? 'auto' : initialWidth;
    return {
        width: width
    };
};









const $caf885298d603c5d$export$cae2a62921ed768b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "t5WgZ",
    name: "HomeWelcomeMessage",
    loader: async ()=>(await (parcelRequire("hYbgt"))).HomeWelcomeMessage
});









var $inPa6 = parcelRequire("inPa6");


var $bDjCi = parcelRequire("bDjCi");













const $33df235db03da5e3$var$CALENDARS_SECTION_ID = 'com.atlassian.confluence.extra.team-calendars:newDashboadUpcomingEvents';
const $33df235db03da5e3$var$i18n = (0, $aXWIB.defineMessages)({
    heading: {
        id: "home.calendar.title",
        defaultMessage: "Calendars"
    }
});
const $33df235db03da5e3$export$39d78c94fb91ad03 = /*#__PURE__*/ (0, $42omo.memo)(({ completeKey: completeKey, noCollapse: noCollapse = false, inRightPanel: inRightPanel = false })=>{
    const header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $33df235db03da5e3$var$i18n.heading);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { widgetState: widgetState } = (0, $h1Vf7.useHomeWidgetState)(completeKey);
    const isCollapsed = widgetState === 'COLLAPSED';
    const firedRenderedEventRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (isCollapsed) firedRenderedEventRef.current = false;
        else if (!firedRenderedEventRef.current && inRightPanel) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'rendered',
                    actionSubject: 'collapsibleSectionContent',
                    actionSubjectId: $33df235db03da5e3$var$CALENDARS_SECTION_ID,
                    source: 'rightPanel',
                    attributes: {
                        homeVersion: '1.5'
                    }
                }
            }).fire();
            firedRenderedEventRef.current = true;
        }
    }, [
        isCollapsed,
        inRightPanel,
        createAnalyticsEvent
    ]);
    if (inRightPanel) {
        if (noCollapse) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bDjCi.LazyHomepageCard), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.HOME_RIGHT_PANEL_CALENDARS_EXPERIENCE)
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4lbme.CollapsibleSection), {
            sectionId: completeKey,
            header: header,
            key: completeKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bDjCi.LazyHomepageCard), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.HOME_RIGHT_PANEL_CALENDARS_EXPERIENCE)
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bDjCi.LazyHomepageCard), null);
});






const $65ae8040b45ec07e$export$480e92afeb9f3ea1 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "FYF0E",
    name: "LazyCalendarIcon",
    loader: async ()=>(await Promise.resolve((parcelRequire("8DN9t")))).default
});

const $65ae8040b45ec07e$export$eaac0a9bd05d5448 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "D2S7I",
    name: "LazyFeedbackIcon",
    loader: async ()=>(await Promise.resolve((parcelRequire("6fjxX")))).default
});


/* HomeBannerContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 





/* OnboardingTakeover.tsx generated by @compiled/babel-plugin v0.36.1 */ 





/**
 * @generated SignedSource<<70e6a9b6294615e018b08ddf5e08df6a>>
 * @relayHash 516e6c99eaf113013654fcd3aebcb5e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e4ababbba22834a265c1eaaf1331c05b72e39c2b8563b507658ba567e9e28678
const $a2d98364ec0cb107$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPersonalSpace"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "NthUserHomeOnboardingTakeoverGetPersonalSpaceKeyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "NthUserHomeOnboardingTakeoverGetPersonalSpaceKeyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "516e6c99eaf113013654fcd3aebcb5e2",
            "id": "e4ababbba22834a265c1eaaf1331c05b72e39c2b8563b507658ba567e9e28678",
            "metadata": {},
            "name": "NthUserHomeOnboardingTakeoverGetPersonalSpaceKeyQuery",
            "operationKind": "query",
            "text": "query NthUserHomeOnboardingTakeoverGetPersonalSpaceKeyQuery{user:confluence_atlassianUser(current:true){id,confluence{hasPersonalSpace,space{id,key}}}}"
        }
    };
}();
$a2d98364ec0cb107$var$node.hash = "5891a9fd74f90ddceb310fcec3a040ef";
var $a2d98364ec0cb107$export$2e2bcd8739ae039 = $a2d98364ec0cb107$var$node;















var $1s5hv = parcelRequire("1s5hv");


var $6iqYo = parcelRequire("6iqYo");


var $ccHMk = parcelRequire("ccHMk");


var $2AytZ = parcelRequire("2AytZ");


var $ghftu = parcelRequire("ghftu");














var $hSqtY = parcelRequire("hSqtY");





var $gfIPU = parcelRequire("gfIPU");









var $b4VFP = parcelRequire("b4VFP");

/* HTV2NthUserLearningOpportunityCardsList.tsx generated by @compiled/babel-plugin v0.36.1 */ 








var $d8SNb = parcelRequire("d8SNb");

var $eyWa4 = parcelRequire("eyWa4");





var $hmuev = parcelRequire("hmuev");


var $1qfLF = parcelRequire("1qfLF");














var $bUlM5 = parcelRequire("bUlM5");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $7p4As = parcelRequire("7p4As");




const $de74dc0c412c0211$var$contentContainerStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.200',
    paddingRight: 'space.200',
    height: '100%'
});
const $de74dc0c412c0211$var$cardStyles = (0, $ecnYn.xcss)({
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: 'radius.large',
    background: "var(--ds-surface, #FFFFFF)"
});
const $de74dc0c412c0211$export$95f80ed95aeb19f6 = ({ title: title, description: description, cta: cta, link: link, onboardingPeriodDay: onboardingPeriodDay })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'homeOnboardingTakeoverNthUserlearningOpportunityCta',
                attributes: {
                    onboardingPeriodDay: onboardingPeriodDay,
                    learningOpportunity: title.defaultMessage
                },
                source: 'onboarding'
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "column",
        xcss: $de74dc0c412c0211$var$cardStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $de74dc0c412c0211$var$contentContainerStyles,
        direction: "column",
        gap: "space.100",
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        onClick: handleClick,
        href: link,
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), cta)))));
};



var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");

const $ad82bda774949b47$var$HTV2Store = (0, $1P1Tu.createStore)({
    initialState: {
        takeoverType: 'v2-land',
        personalSpaceKey: ''
    },
    actions: {
        getIsLandTakeoverType: ()=>({ getState: getState })=>getState().takeoverType === 'v2-land',
        getIsXflowTakeoverType: ()=>({ getState: getState })=>getState().takeoverType === 'v2-xflow'
    },
    name: 'htv2Store'
});
const $ad82bda774949b47$export$a6c1b621697476fb = (0, $9zUhf.createActionsHook)($ad82bda774949b47$var$HTV2Store);
const $ad82bda774949b47$export$40b715800492930d = (0, $9zUhf.createStateHook)($ad82bda774949b47$var$HTV2Store);
const $ad82bda774949b47$export$23a4a1a2301bbb22 = (0, $FOT9i.createContainer)($ad82bda774949b47$var$HTV2Store, {
    onInit: ()=>({ setState: setState }, { takeoverType: takeoverType, personalSpaceKey: personalSpaceKey })=>{
            setState({
                takeoverType: takeoverType,
                personalSpaceKey: personalSpaceKey
            });
        }
});


const $38041ee5c4c2068e$var$gridStyles = {
    root: "_yv0e32yx"
};
const $38041ee5c4c2068e$export$a0b6e8d3a8b5e662 = 'https://university.atlassian.com/student/collection/850385/path/1083904?utm_source=in-product-banner&utm_medium=inapp&utm_campaign=P:uni-ondemand*O:university*W:confluence*H:fy25-q1*I:in-product-onboarding-confluence*';
const $38041ee5c4c2068e$export$4aafac32beb7c015 = 'https://support.atlassian.com/confluence-cloud/';
const $38041ee5c4c2068e$export$417c8e846f672c6a = 'https://community.atlassian.com/forums/New-to-Confluence/gh-p/newtoconfluence';
const $38041ee5c4c2068e$var$i18n = (0, $aXWIB.defineMessages)({
    learningPathTitle: {
        id: "experiment-home-onboarding-takeover-v2.learning-path.title",
        defaultMessage: "Free learning path on Atlassian University"
    },
    learningPathDescription: {
        id: "experiment-home-onboarding-takeover-v2.learning-path.description",
        defaultMessage: "Follow short, self-paced courses to get up and running in Confluence quickly."
    },
    learningPathCta: {
        id: "experiment-home-onboarding-takeover-v2.learning-path.cta",
        defaultMessage: "Get started"
    },
    supportResourcesTitle: {
        id: "experiment-home-onboarding-takeover-v2.support-resources.title",
        defaultMessage: "Discover Atlassian Support resources"
    },
    supportResourcesDescription: {
        id: "experiment-home-onboarding-takeover-v2.support-resources.description",
        defaultMessage: "Browse articles on all things Confluence on the Atlassian Support site."
    },
    supportResourcesCta: {
        id: "experiment-home-onboarding-takeover-v2.support-resources.cta",
        defaultMessage: "Learn more"
    },
    joinCommunityTitle: {
        id: "experiment-home-onboarding-takeover-v2.join-community.title",
        defaultMessage: "Join users like you on Atlassian Community"
    },
    joinCommunityDescription: {
        id: "experiment-home-onboarding-takeover-v2.join-community.description",
        defaultMessage: "Learn from new users like you or share your wisdom with others in the community."
    },
    joinCommunityCta: {
        id: "experiment-home-onboarding-takeover-v2.join-community.cta",
        defaultMessage: "Join Community"
    },
    heading: {
        id: "experiment-home-onboarding-takeover-v2.nth-user-learning-opportunity.heading",
        defaultMessage: "Learn with more resources"
    },
    dismissLearningResources: {
        id: "experiment-home-onboarding-takeover-v2.nth-user-learning-opportunity.dismiss-learning-resources",
        defaultMessage: "Dismiss learning resources"
    }
});
const $38041ee5c4c2068e$var$HTV2NthUserLearningOpportunityCards = [
    {
        title: $38041ee5c4c2068e$var$i18n.learningPathTitle,
        description: $38041ee5c4c2068e$var$i18n.learningPathDescription,
        cta: $38041ee5c4c2068e$var$i18n.learningPathCta,
        link: $38041ee5c4c2068e$export$a0b6e8d3a8b5e662
    },
    {
        title: $38041ee5c4c2068e$var$i18n.joinCommunityTitle,
        description: $38041ee5c4c2068e$var$i18n.joinCommunityDescription,
        cta: $38041ee5c4c2068e$var$i18n.joinCommunityCta,
        link: $38041ee5c4c2068e$export$417c8e846f672c6a
    },
    {
        title: $38041ee5c4c2068e$var$i18n.supportResourcesTitle,
        description: $38041ee5c4c2068e$var$i18n.supportResourcesDescription,
        cta: $38041ee5c4c2068e$var$i18n.supportResourcesCta,
        link: $38041ee5c4c2068e$export$4aafac32beb7c015
    }
];
const $38041ee5c4c2068e$export$a7dd6259deee6f55 = ({ onboardingPeriodDay: onboardingPeriodDay, onDismissSection: onDismissSection })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { getIsXflowTakeoverType: getIsXflowTakeoverType } = (0, $ad82bda774949b47$export$a6c1b621697476fb)();
    const isXflowTakeoverType = getIsXflowTakeoverType();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        testId: "htv2-learning-resources",
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $38041ee5c4c2068e$var$i18n.heading)), onDismissSection && (0, $9wGTI.fg)('cc_onboarding_takeover_dismiss_button') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        testId: "htv2-learning-resources-dismiss-button",
        onClick: onDismissSection,
        label: formatMessage($38041ee5c4c2068e$var$i18n.dismissLearningResources),
        spacing: isXflowTakeoverType ? 'default' : 'compact',
        appearance: isXflowTakeoverType ? 'default' : 'subtle',
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                ...iconProps,
                size: "small"
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8SNb.default), {
        gap: "space.200",
        xcss: $38041ee5c4c2068e$var$gridStyles.root
    }, $38041ee5c4c2068e$var$HTV2NthUserLearningOpportunityCards.map((learningOpportunityCardContent)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $de74dc0c412c0211$export$95f80ed95aeb19f6), {
            key: `${formatMessage(learningOpportunityCardContent.title)}`,
            ...learningOpportunityCardContent,
            onboardingPeriodDay: onboardingPeriodDay
        });
    })));
};









var $9oezN = parcelRequire("9oezN");










var $44dc39e6cf3d3086$exports = {};
$44dc39e6cf3d3086$exports = new URL("addProfilePictureDark.b3507081.svg", import.meta.url).toString();


var $4c07a3af60b95db8$exports = {};
$4c07a3af60b95db8$exports = new URL("addProfilePictureLight.d50a6145.svg", import.meta.url).toString();


var $6c8641ec5ff05102$exports = {};
$6c8641ec5ff05102$exports = new URL("changeSiteThemeDark.d8e951cf.svg", import.meta.url).toString();


var $32c8e98d563726cd$exports = {};
$32c8e98d563726cd$exports = new URL("changeSiteThemeLight.40f63e13.svg", import.meta.url).toString();


var $6879bcaae34f447e$exports = {};
$6879bcaae34f447e$exports = new URL("createPageDark.67a6d96c.svg", import.meta.url).toString();


var $bb50259cfd1106cb$exports = {};
$bb50259cfd1106cb$exports = new URL("createPageLight.65781bf0.svg", import.meta.url).toString();


var $27ac409634453a0e$exports = {};
$27ac409634453a0e$exports = new URL("createSpaceDark.8179e65e.svg", import.meta.url).toString();


var $452857bfe1e3f6dc$exports = {};
$452857bfe1e3f6dc$exports = new URL("createSpaceLight.3798bf79.svg", import.meta.url).toString();


var $44eb6ac7355f8c01$exports = {};
$44eb6ac7355f8c01$exports = new URL("createWhiteboardDark.5cebd92e.svg", import.meta.url).toString();


var $5917cc1b06b53127$exports = {};
$5917cc1b06b53127$exports = new URL("createWhiteboardLight.29b7b77d.svg", import.meta.url).toString();


var $9f16daca8d25497e$exports = {};
$9f16daca8d25497e$exports = new URL("downloadMobileAppDark.acae3e72.svg", import.meta.url).toString();


var $412b86e610013bba$exports = {};
$412b86e610013bba$exports = new URL("downloadMobileAppLight.cfce9d68.svg", import.meta.url).toString();


var $8df7e2f8c0debbc8$exports = {};
$8df7e2f8c0debbc8$exports = new URL("explorePremiumDark.681b018f.svg", import.meta.url).toString();


var $a82f6b72530899c6$exports = {};
$a82f6b72530899c6$exports = new URL("explorePremiumLight.8f219783.svg", import.meta.url).toString();


var $0cd9e8a864145b47$exports = {};
$0cd9e8a864145b47$exports = new URL("marketplaceLight.244efc33.svg", import.meta.url).toString();


var $8c750aa2261f0b31$exports = {};
$8c750aa2261f0b31$exports = new URL("marketplaceDark.2db71a9a.svg", import.meta.url).toString();


var $fc7b92f08d45c5d3$exports = {};
$fc7b92f08d45c5d3$exports = new URL("viewPopularContentLight.8a22cd39.svg", import.meta.url).toString();


var $f2050394552ece41$exports = {};
$f2050394552ece41$exports = new URL("viewPopularContentDark.9bd259ee.svg", import.meta.url).toString();


var $48e746da7f9be319$exports = {};
$48e746da7f9be319$exports = new URL("aiLight.946c95dd.svg", import.meta.url).toString();


var $1821d029004c9d5d$exports = {};
$1821d029004c9d5d$exports = new URL("aiDark.0a919ea0.svg", import.meta.url).toString();


const $605aec3e62fc613c$export$f9417f756858637d = {
    createPage: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($bb50259cfd1106cb$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($6879bcaae34f447e$exports)))
    },
    createSpace: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($452857bfe1e3f6dc$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($27ac409634453a0e$exports)))
    },
    createWhiteboard: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($5917cc1b06b53127$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($44eb6ac7355f8c01$exports)))
    },
    addProfilePicture: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($4c07a3af60b95db8$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($44dc39e6cf3d3086$exports)))
    },
    changeSiteTheme: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($32c8e98d563726cd$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($6c8641ec5ff05102$exports)))
    },
    explorePremium: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($a82f6b72530899c6$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($8df7e2f8c0debbc8$exports)))
    },
    downloadMobileApp: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($412b86e610013bba$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($9f16daca8d25497e$exports)))
    },
    exploreMarketplace: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($0cd9e8a864145b47$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($8c750aa2261f0b31$exports)))
    },
    exploreAI: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($48e746da7f9be319$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($1821d029004c9d5d$exports)))
    },
    viewPopularContent: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($fc7b92f08d45c5d3$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($f2050394552ece41$exports)))
    }
};









var $4wwVl = parcelRequire("4wwVl");








var $dD7ks = parcelRequire("dD7ks");

const $cb50a626fa424824$var$HTV2ActionCardLinkCTA = ({ onClick: onClick, href: href, children: children, icon: icon })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        iconBefore: icon,
        onClick: onClick,
        href: href,
        target: "_blank"
    }, children);
};
const $cb50a626fa424824$export$cfda3af46d74ac3 = ({ children: children, onClick: onClick })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { href: href } = (0, $dD7ks.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId ?? ''
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cb50a626fa424824$var$HTV2ActionCardLinkCTA, {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4wwVl))),
        onClick: onClick,
        href: (0, $9wGTI.fg)('confluence-adopt-teams-nav-config') ? href : `/wiki/people/${userId}`
    }, children);
};









var $ZDq1z = parcelRequire("ZDq1z");


var $dkIiA = parcelRequire("dkIiA");


var $bZSO8 = parcelRequire("bZSO8");


const $aa9c686096fb5b3d$var$HTV2CreateContentCTA = ({ appearance: appearance, children: children, contentType: contentType, onClick: onClick, source: source, icon: icon, openTemplatesGallery: openTemplatesGallery })=>{
    const { personalSpaceKey: personalSpaceKey } = (0, $ad82bda774949b47$export$40b715800492930d)();
    const getButtonHref = ()=>{
        return (0, $bZSO8.buildCreationLink)({
            contentType: contentType,
            source: source,
            spaceKey: personalSpaceKey,
            subType: (0, $dkIiA.ConfluencePageSubType).LIVE,
            openTemplatesGallery: openTemplatesGallery || undefined
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        onClick: onClick,
        isDisabled: !Boolean(personalSpaceKey),
        href: getButtonHref(),
        appearance: appearance,
        iconBefore: icon
    }, children);
};
const $aa9c686096fb5b3d$export$7044ebf8ab34fd95 = ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($aa9c686096fb5b3d$var$HTV2CreateContentCTA, {
        source: "homeOnboardingTakeoverV2CreateWhiteboard",
        contentType: "whiteboard",
        onClick: onClick,
        appearance: "default",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z)))
    }, children);
};
const $aa9c686096fb5b3d$export$3ce14525978eb5aa = ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($aa9c686096fb5b3d$var$HTV2CreateContentCTA, {
        source: "homeOnboardingTakeoverV2CreateIntro",
        contentType: "page",
        onClick: onClick,
        appearance: "default",
        openTemplatesGallery: true
    }, children);
};









var $4yg2A = parcelRequire("4yg2A");

var $fJ5kL = parcelRequire("fJ5kL");

const $3b605859dbf463d0$export$62446e0882debc0e = ({ children: children, onClick: onClick })=>{
    const { feedType: feedType, updateFeedType: updateFeedType } = (0, $fJ5kL.useFeedTypeSelector)();
    const handleFeedSelectorChange = (0, $42omo.useCallback)((updatedFeedType)=>{
        updateFeedType(updatedFeedType);
    }, [
        updateFeedType
    ]);
    const handleClick = (0, $42omo.useCallback)(()=>{
        // Update feed type if it is popular feed is not selected
        if (feedType !== (0, $4yg2A.FeedType).POPULAR) handleFeedSelectorChange((0, $4yg2A.FeedType).POPULAR);
        // Mark the onboarding action card as completed
        onClick();
        // Scroll to the feed section
        const feedSection = document.querySelector('[data-testid="activity-feed"]');
        feedSection?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }, [
        feedType,
        handleFeedSelectorChange,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: handleClick,
        appearance: "default"
    }, children);
};





const $8a1fa21a7f518231$export$be7e46fee04363c = (0, $aXWIB.defineMessages)({
    createWhiteboardTitle: {
        id: "experiment-home-onboarding-takeover-v2.create-whiteboard.title",
        defaultMessage: "Brainstorm on a whiteboard"
    },
    createWhiteboardDescription: {
        id: "experiment-home-onboarding-takeover-v2.create-whiteboard.description",
        defaultMessage: "Dream up new ideas and visualize your work."
    },
    createWhiteboardCTA: {
        id: "experiment-home-onboarding-takeover-v2.create-whiteboard.cta",
        defaultMessage: "Create whiteboard"
    },
    addProfilePictureTitle: {
        id: "experiment-home-onboarding-takeover-v2.add-profile-picture.title",
        defaultMessage: "Add your profile photo"
    },
    addProfilePictureCTA: {
        id: "experiment-home-onboarding-takeover-v2.add-profile-picture.cta",
        defaultMessage: "Add photo"
    }
});


const $c1c2e6c8520ca16f$var$i18n = (0, $aXWIB.defineMessages)({
    addProfilePictureDescription: {
        id: "experiment-home-onboarding-takeover-v2.add-profile-picture-nth-user.description",
        defaultMessage: "Help teammates recognize you by adding a profile photo."
    },
    createIntroBlogTitle: {
        id: "experiment-home-onboarding-takeover-v2.create-intro-blog.title",
        defaultMessage: "Introduce yourself to your new peers"
    },
    createIntroBlogDescription: {
        id: "experiment-home-onboarding-takeover-v2.create-intro-blog.description",
        defaultMessage: "Easily share your stories and interests with teammates by personalizing the intro template."
    },
    createIntroBlogCTA: {
        id: "experiment-home-onboarding-takeover-v2.create-intro-blog.cta",
        defaultMessage: "See templates"
    },
    createWhiteboardDescription: {
        id: "experiment-home-onboarding-takeover-v2.create-whiteboard-nth-user.description",
        defaultMessage: "Dream up new ideas by collaborating and visualizing in a freefrom way using whiteboards."
    },
    viewPopularContentTitle: {
        id: "experiment-home-onboarding-takeover-v2.view-popular-content.title",
        defaultMessage: "Discover & react to trending content"
    },
    viewPopularContentDescription: {
        id: "experiment-home-onboarding-takeover-v2.view-popular-content.description",
        defaultMessage: "Dive into popular content and share your thoughts with a fun reaction or comment."
    },
    viewPopularContentCTA: {
        id: "experiment-home-onboarding-takeover-v2.view-popular-content.cta",
        defaultMessage: "View popular content"
    }
});
const $c1c2e6c8520ca16f$export$43cedd252f50b9ab = [
    {
        id: 'viewPopularContent',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c1c2e6c8520ca16f$var$i18n.viewPopularContentTitle),
        description: $c1c2e6c8520ca16f$var$i18n.viewPopularContentDescription,
        image: (0, $605aec3e62fc613c$export$f9417f756858637d).viewPopularContent,
        cta: ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3b605859dbf463d0$export$62446e0882debc0e), {
                onClick: onClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c1c2e6c8520ca16f$var$i18n.viewPopularContentCTA)),
        fadeCardOnComplete: true,
        keepCtaOnCompleted: true
    },
    {
        id: 'createIntroBlog',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c1c2e6c8520ca16f$var$i18n.createIntroBlogTitle),
        description: $c1c2e6c8520ca16f$var$i18n.createIntroBlogDescription,
        image: (0, $605aec3e62fc613c$export$f9417f756858637d).createPage,
        cta: ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aa9c686096fb5b3d$export$3ce14525978eb5aa), {
                onClick: onClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c1c2e6c8520ca16f$var$i18n.createIntroBlogCTA)),
        fadeCardOnComplete: true,
        keepCtaOnCompleted: true
    },
    {
        id: 'createWhiteboard',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $8a1fa21a7f518231$export$be7e46fee04363c).createWhiteboardTitle),
        description: $c1c2e6c8520ca16f$var$i18n.createWhiteboardDescription,
        image: (0, $605aec3e62fc613c$export$f9417f756858637d).createWhiteboard,
        cta: ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aa9c686096fb5b3d$export$7044ebf8ab34fd95), {
                onClick: onClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $8a1fa21a7f518231$export$be7e46fee04363c).createWhiteboardCTA)),
        fadeCardOnComplete: true,
        keepCtaOnCompleted: true
    },
    {
        id: 'addProfilePicture',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $8a1fa21a7f518231$export$be7e46fee04363c).addProfilePictureTitle),
        description: $c1c2e6c8520ca16f$var$i18n.addProfilePictureDescription,
        image: (0, $605aec3e62fc613c$export$f9417f756858637d).addProfilePicture,
        cta: ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cb50a626fa424824$export$cfda3af46d74ac3), {
                onClick: onClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $8a1fa21a7f518231$export$be7e46fee04363c).addProfilePictureCTA)),
        fadeCardOnComplete: true,
        keepCtaOnCompleted: true
    }
];
const $c1c2e6c8520ca16f$export$69b5d0ca55ec4c6e = ({ onboardingActionStates: onboardingActionStates })=>{
    return $c1c2e6c8520ca16f$export$43cedd252f50b9ab.map((action)=>({
            ...action,
            state: onboardingActionStates[action.id] || 'pending'
        }));
};


const $e208299f3fd02b06$var$DUPLICATED_ONBOARDING_ACTION_IDS = [
    ...(0, $c1c2e6c8520ca16f$export$43cedd252f50b9ab)
].map((action)=>action.id);
const $e208299f3fd02b06$export$c4d8be815289b698 = [
    ...new Set($e208299f3fd02b06$var$DUPLICATED_ONBOARDING_ACTION_IDS)
];
const $e208299f3fd02b06$export$82740826f5d31d6 = [
    'pending',
    'dismissed',
    'completed'
];



function $f5be8383e833e00b$var$deserializeOnboardingActionStates(serializedValues) {
    try {
        const values = JSON.parse(serializedValues || '{}');
        if (typeof values !== 'object') return {};
        // There's no control over the shape of the object that's deserialized,
        // so we need to filter out any keys and values that aren't valid.
        const isValidState = (value)=>(0, $e208299f3fd02b06$export$82740826f5d31d6).includes(value);
        return (0, $e208299f3fd02b06$export$c4d8be815289b698).reduce((states, id)=>isValidState(values[id]) ? {
                ...states,
                [id]: values[id]
            } : states, {});
    } catch (e) {
        return {};
    }
}
function $f5be8383e833e00b$var$serializeOnboardingActionStates(onboardingActionStates) {
    return JSON.stringify(onboardingActionStates);
}
function $f5be8383e833e00b$export$5d769c20b5d59814() {
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        ...Object.values((0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS))
    ]);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { onboardingActionStates: serializedOnboardingActionStates, hasSeenConfetti: hasSeenConfetti } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const onboardingActionStates = (0, $42omo.useMemo)(()=>{
        return $f5be8383e833e00b$var$deserializeOnboardingActionStates(serializedOnboardingActionStates);
    }, [
        serializedOnboardingActionStates
    ]);
    const complete = (0, $42omo.useMemo)(()=>(id)=>{
            setOnboardingState({
                key: (0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).onboardingActionStates,
                value: $f5be8383e833e00b$var$serializeOnboardingActionStates({
                    ...onboardingActionStates,
                    [id]: 'completed'
                })
            });
        }, [
        onboardingActionStates,
        setOnboardingState
    ]);
    const errors = [
        onboardingStateError
    ].filter(Boolean);
    const actions = (0, $42omo.useMemo)(()=>{
        return (0, $c1c2e6c8520ca16f$export$69b5d0ca55ec4c6e)({
            onboardingActionStates: onboardingActionStates
        });
    }, [
        onboardingActionStates
    ]);
    const isFinished = actions.every((action)=>action.state !== 'pending');
    const hasPoppedConfetti = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (onboardingStateLoading || !isFinished) return;
        const popConfettiIfVisible = ()=>{
            if (hasSeenConfetti || hasPoppedConfetti.current || document.visibilityState !== 'visible') return;
            hasPoppedConfetti.current = true;
            (0, $9oezN.popOnboardingConfetti)();
            setOnboardingState([
                {
                    key: (0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).hasSeenConfetti,
                    value: 'true'
                },
                {
                    key: (0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).isCollapsed,
                    value: 'true'
                }
            ]);
        };
        // Check to see if the user is still viewing the page. The timeout is used
        // to ensure that the confetti doesn't pop if the user is navigating away.
        const timeout = setTimeout(popConfettiIfVisible, 50);
        document.addEventListener('visibilitychange', popConfettiIfVisible);
        return ()=>{
            // Cleanup timeout and event listener
            clearTimeout(timeout);
            document.removeEventListener('visibilitychange', popConfettiIfVisible);
        };
    }, [
        onboardingStateLoading,
        hasSeenConfetti,
        isFinished,
        setOnboardingState
    ]);
    return {
        actions: actions,
        complete: complete,
        errors: errors,
        loading: onboardingStateLoading,
        isFinished: isFinished
    };
}









var $c4jUA = parcelRequire("c4jUA");


var $3FxV8 = parcelRequire("3FxV8");


var $6R5uz = parcelRequire("6R5uz");


var $laHi9 = parcelRequire("laHi9");








var $6f0Oj = parcelRequire("6f0Oj");



var $cwkWT = parcelRequire("cwkWT");

var $dcJ7R = parcelRequire("dcJ7R");







var $cOrQJ = parcelRequire("cOrQJ");





var $g9Srd = parcelRequire("g9Srd");

var $h3cbw = parcelRequire("h3cbw");




/* HTV2ActionCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $gj7hi = parcelRequire("gj7hi");








var $3sFtD = parcelRequire("3sFtD");


















const $ec39d532218c9094$var$dismissIconStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    cursor: 'pointer'
});
const $ec39d532218c9094$export$b93d522d630e54a4 = ({ onDismiss: onDismiss, label: label })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ec39d532218c9094$var$dismissIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        isTooltipDisabled: false,
        onClick: onDismiss,
        label: formatMessage(label),
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), iconProps)
    }));
};



const $eba8001c579a2419$var$contentContainerStyles = (0, $ecnYn.xcss)({
    paddingBlock: 'space.200',
    paddingInline: 'space.200',
    height: '100%'
});
const $eba8001c579a2419$var$cardStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: 'radius.large',
    background: "var(--ds-surface, #FFFFFF)"
});
const $eba8001c579a2419$var$fadeStyles = (0, $ecnYn.xcss)({
    opacity: '0.3'
});
const $eba8001c579a2419$var$imageContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $eba8001c579a2419$var$imageStyles = null;
const $eba8001c579a2419$var$descriptionContainerStyles = (0, $ecnYn.xcss)({
    // Ensure the description text is always 3 lines tall
    height: '4.28em' // (20px line height * 3 lines) / 14px font size
});
const $eba8001c579a2419$var$i18n = (0, $aXWIB.defineMessages)({
    dismissButtonLabel: {
        id: "experiment-home-onboarding-takeover-v2.dismiss-card-button-label",
        defaultMessage: "Dismiss this action"
    },
    completedCardText: {
        id: "experiment-home-onboarding-takeover-v2.completed-card-text",
        defaultMessage: "You completed this step."
    }
});
const $eba8001c579a2419$export$2fef0751517155f4 = ({ action: action, dismiss: dismiss, complete: complete, onboardingPeriodDay: onboardingPeriodDay, fadeCardOnComplete: fadeCardOnComplete = false, keepCtaOnComplete: keepCtaOnComplete = false })=>{
    const Cta = action.cta;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { getIsXflowTakeoverType: getIsXflowTakeoverType } = (0, $ad82bda774949b47$export$a6c1b621697476fb)();
    const isXflow = getIsXflowTakeoverType();
    const handleClick = (0, $42omo.useCallback)(()=>{
        complete?.(action.id);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'homeOnboardingTakeoverV2ActionCta',
                attributes: {
                    onboardingAction: action.id,
                    onboardingPeriodDay: onboardingPeriodDay,
                    isXflow: isXflow
                },
                source: 'onboarding'
            }
        }).fire();
    }, [
        complete,
        createAnalyticsEvent,
        action.id,
        onboardingPeriodDay,
        isXflow
    ]);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        if (dismiss) dismiss(action.id);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'homeOnboardingTakeoverV2ActionDismiss',
                attributes: {
                    onboardingAction: action.id,
                    onboardingPeriodDay: onboardingPeriodDay,
                    isXflow: isXflow
                },
                source: 'onboarding'
            }
        }).fire();
    }, [
        dismiss,
        createAnalyticsEvent,
        action.id,
        onboardingPeriodDay,
        isXflow
    ]);
    const isCompleted = action.state === 'completed';
    return /*#__PURE__*/ $42omo.createElement((0, $bUlM5.default), {
        testId: isCompleted ? 'htv2-onboarding-action-completed' : 'htv2-onboarding-action-pending',
        direction: "column",
        xcss: $eba8001c579a2419$var$cardStyles
    }, /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: [
            $eba8001c579a2419$var$imageContainerStyles,
            fadeCardOnComplete && isCompleted && $eba8001c579a2419$var$fadeStyles
        ]
    }, /*#__PURE__*/ $42omo.createElement((0, $gj7hi.default), {
        src: action.image.light,
        srcDark: action.image.dark,
        alt: "",
        className: (0, $gMc0m.default)([
            "_1e0c1ule _1bsb1osq"
        ])
    }), dismiss && /*#__PURE__*/ $42omo.createElement((0, $ec39d532218c9094$export$b93d522d630e54a4), {
        label: {
            ...$eba8001c579a2419$var$i18n.dismissButtonLabel
        },
        onDismiss: handleDismiss
    })), /*#__PURE__*/ $42omo.createElement((0, $bUlM5.default), {
        xcss: $eba8001c579a2419$var$contentContainerStyles,
        justifyContent: "space-between",
        direction: "column",
        gap: "space.100"
    }, /*#__PURE__*/ $42omo.createElement((0, $bUlM5.default), {
        direction: "column",
        gap: "space.100"
    }, /*#__PURE__*/ $42omo.createElement((0, $bUlM5.default), {
        direction: "row",
        gap: "space.100"
    }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
        size: "xsmall"
    }, action.title), isCompleted && /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        color: "var(--ds-icon-success)",
        label: "completed"
    })), /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $eba8001c579a2419$var$descriptionContainerStyles
    }, /*#__PURE__*/ $42omo.createElement((0, $5dK2X.default), {
        color: isCompleted ? 'color.text.subtlest' : undefined,
        maxLines: 3
    }, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), isCompleted ? $eba8001c579a2419$var$i18n.completedCardText : action.description)))), (!isCompleted || keepCtaOnComplete) && /*#__PURE__*/ $42omo.createElement((0, $bUlM5.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ $42omo.createElement(Cta, {
        onClick: handleClick
    }))));
};




function $f30dd92ebe48cdb9$export$2df8346413809f96(items, pageSize) {
    const [idx, setIdx] = (0, $42omo.useState)(0);
    const pages = (0, (/*@__PURE__*/$parcel$interopDefault($c4jUA)))([
        ...items.keys()
    ], pageSize);
    const effectiveIdx = (0, (/*@__PURE__*/$parcel$interopDefault($3FxV8)))(idx, 0, items.length - 1);
    const currentPage = pages.findIndex((page)=>page.includes(effectiveIdx));
    const hasNext = currentPage < pages.length - 1;
    const hasPrevious = currentPage > 0;
    const nextIdx = pages[currentPage + 1]?.[0];
    const previousIdx = pages[currentPage - 1]?.[0];
    return {
        next: hasNext ? ()=>setIdx(nextIdx) : undefined,
        previous: hasPrevious ? ()=>setIdx(previousIdx) : undefined,
        visible: (pages[currentPage] || []).map((i)=>items[i]),
        pageKey: effectiveIdx
    };
}
/**
 * Custom hook that preloads all card images based on the current color mode.
 *
 * This hook uses the `useThemeObserver` to get the current color mode (light or dark)
 * and preloads the appropriate images for each card. It returns an array of `Image` objects
 * with their `src` set to the preloaded image URLs.
 *
 * Images are memo'd to make sure the image objects aren't GC'd by the browser.
 *
 */ function $f30dd92ebe48cdb9$var$usePreloadCardImages() {
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    (0, $42omo.useMemo)(()=>{
        const imageSrcs = Object.values((0, $605aec3e62fc613c$export$f9417f756858637d)).map(({ light: light, dark: dark })=>colorMode === 'dark' ? dark : light);
        return imageSrcs.map((src)=>{
            const img = new Image();
            img.src = src;
            return img;
        });
    }, [
        colorMode
    ]);
}
/**
 * Custom hook that checks the homeIsSingleColumn CSS variable.
 *
 * @returns {Object} An object containing:
 * - `ref`: A ref that must be attached to an element that has the
 *   `--homeIsSingleColumn` CSS variable. It should be an element that spans
 *   the width of the home content area, since we will watch its width to
 *   decide when to update.
 * - `isSingleColumn`: A boolean indicating the value of the
 *   `--homeIsSingleColumn` CSS variable (true if '1', false otherwise).
 */ function $f30dd92ebe48cdb9$var$useHomeIsSingleColumn() {
    const ref = (0, $42omo.useRef)(null);
    const [isSingleColumn, setIsSingleColumn] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!ref.current) return;
        // We watch the carousel for size changes (via the ref), as it's possible that --homeIsSingleColumn
        // can change without a re-render (e.g. if the user resizes the window or the sidebar).
        const resizeObserver = new ResizeObserver(()=>{
            setIsSingleColumn(Boolean(ref.current && window.getComputedStyle(ref.current).getPropertyValue('--homeIsSingleColumn') === '1'));
        });
        resizeObserver.observe(ref.current);
        return ()=>resizeObserver.disconnect();
    }, []);
    return {
        ref: ref,
        isSingleColumn: isSingleColumn
    };
}
/**
 * Sorts an array of onboarding actions into buckets based on their state.
 *
 * @param actions - The array of onboarding actions to be sorted.
 * @returns An object where the keys are the states ('pending', 'completed', 'dismissed')
 * and the values are arrays of actions that correspond to each state.
 */ function $f30dd92ebe48cdb9$var$sortActions(actions) {
    return actions.reduce((buckets, action)=>({
            ...buckets,
            [action.state]: [
                ...buckets[action.state] || [],
                action
            ]
        }), {
        pending: [],
        completed: [],
        dismissed: []
    });
}
const $f30dd92ebe48cdb9$var$gridStyles = (0, $ecnYn.xcss)({
    minHeight: '320px'
});
const $f30dd92ebe48cdb9$var$headingWrapper = (0, $ecnYn.xcss)({
    minHeight: '24px'
});
const $f30dd92ebe48cdb9$var$carouselItemsWrapper = (0, $ecnYn.xcss)({
    overflow: 'hidden'
});
const $f30dd92ebe48cdb9$var$i18n = (0, $aXWIB.defineMessages)({
    heading: {
        id: "experiment-home-onboarding-takeover-v2.carousel.heading",
        defaultMessage: "Get to know Confluence (Completed {completed} of {total} cards)"
    },
    previousItem: {
        id: "experiment-home-onboarding-takeover-v2.carousel.previous-item",
        defaultMessage: "Show previous item"
    },
    nextItem: {
        id: "experiment-home-onboarding-takeover-v2.carousel.next-item",
        defaultMessage: "Show next item"
    },
    dismissCarousel: {
        id: "experiment-home-onboarding-takeover-v2.carousel.dismiss-carousel",
        defaultMessage: "Dismiss carousel"
    }
});
function $f30dd92ebe48cdb9$export$cee2d9eac04047dd({ actions: actions, dismiss: dismiss, complete: complete, onboardingPeriodDay: onboardingPeriodDay, suppressSorting: suppressSorting, onDismissSection: onDismissSection }) {
    $f30dd92ebe48cdb9$var$usePreloadCardImages();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { ref: ref, isSingleColumn: isSingleColumn } = $f30dd92ebe48cdb9$var$useHomeIsSingleColumn();
    const numVisible = isSingleColumn ? 2 : 3;
    const { pending: pending, completed: completed } = (0, $42omo.useMemo)(()=>$f30dd92ebe48cdb9$var$sortActions(actions), [
        actions
    ]);
    const cardsToDisplay = suppressSorting ? actions : [
        ...pending,
        ...completed
    ];
    const { next: next, previous: previous, visible: visible, pageKey: pageKey } = $f30dd92ebe48cdb9$export$2df8346413809f96(cardsToDisplay, numVisible);
    const { getIsXflowTakeoverType: getIsXflowTakeoverType } = (0, $ad82bda774949b47$export$a6c1b621697476fb)();
    const isXflowTakeoverType = getIsXflowTakeoverType();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // Hide the carousel controls if all cards can be shown at once.
    const showControls = pending.length + completed.length > numVisible;
    const [enterFrom, setEnterFrom] = (0, $42omo.useState)('left');
    const createClickHandler = (callback, direction)=>{
        if (!callback) return;
        return ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'homeOnboardingTakeoverV2ActionCarouselScroll',
                    source: 'onboarding',
                    attributes: {
                        direction: direction,
                        isXflow: isXflowTakeoverType
                    }
                }
            }).fire();
            setEnterFrom(direction);
            setTimeout(callback, 10);
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        testId: "htv2-carousel",
        ref: ref,
        direction: "column",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        gap: "space.100",
        justifyContent: "space-between",
        xcss: $f30dd92ebe48cdb9$var$headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$f30dd92ebe48cdb9$var$i18n.heading,
        values: {
            completed: completed.length,
            total: completed.length + pending.length
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100"
    }, showControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        label: formatMessage($f30dd92ebe48cdb9$var$i18n.previousItem),
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                ...iconProps,
                size: "small"
            }),
        onClick: createClickHandler(previous, 'left'),
        isDisabled: !previous,
        spacing: isXflowTakeoverType ? 'default' : 'compact',
        appearance: isXflowTakeoverType ? 'default' : 'subtle'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        label: formatMessage($f30dd92ebe48cdb9$var$i18n.nextItem),
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                ...iconProps,
                size: "small"
            }),
        onClick: createClickHandler(next, 'right'),
        isDisabled: !next,
        spacing: isXflowTakeoverType ? 'default' : 'compact',
        appearance: isXflowTakeoverType ? 'default' : 'subtle'
    })), onDismissSection && (0, $9wGTI.fg)('cc_onboarding_takeover_dismiss_button') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        testId: "htv2-carousel-dismiss-button",
        onClick: onDismissSection,
        label: formatMessage($f30dd92ebe48cdb9$var$i18n.dismissCarousel),
        spacing: isXflowTakeoverType ? 'default' : 'compact',
        appearance: isXflowTakeoverType ? 'default' : 'subtle',
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                ...iconProps,
                size: "small"
            })
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $f30dd92ebe48cdb9$var$carouselItemsWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
        exitThenEnter: true,
        appear: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h3cbw.default), {
        key: pageKey,
        enterFrom: enterFrom,
        exitTo: enterFrom === 'right' ? 'left' : 'right'
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ...props,
            "data-vc": "8i9fQYQP"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cwkWT.default), {
            xcss: $f30dd92ebe48cdb9$var$gridStyles,
            gap: "space.200",
            templateColumns: "repeat(calc(3 - var(--homeIsSingleColumn, 0)), 1fr)"
        }, visible.map((action)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eba8001c579a2419$export$2fef0751517155f4), {
                key: action.id,
                action: action,
                dismiss: dismiss,
                complete: complete,
                onboardingPeriodDay: onboardingPeriodDay,
                fadeCardOnComplete: action.fadeCardOnComplete,
                keepCtaOnComplete: action.keepCtaOnCompleted
            }))))))));
}



const $0e79497324363eb1$var$i18n = (0, $aXWIB.defineMessages)({
    collapse: {
        id: "experiment-home-onboarding-takeover-v2.nth-user.collapse-expand-button.collapse",
        defaultMessage: "Collapse onboarding"
    },
    expand: {
        id: "experiment-home-onboarding-takeover-v2.nth-user.collapse-expand-button.expand",
        defaultMessage: "Expand onboarding"
    }
});
const $0e79497324363eb1$var$GetPersonalSpaceKeyQuery = (0, $a2d98364ec0cb107$export$2e2bcd8739ae039);
const $0e79497324363eb1$var$CollapseExpandButton = ({ isCollapsed: isCollapsed, toggleIsCollapsed: toggleIsCollapsed })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        testId: "nth-user-home-onboarding-takeover-collapse-expand-button",
        iconBefore: (iconProps)=>isCollapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                ...iconProps,
                size: "small"
            }),
        appearance: "subtle",
        onClick: toggleIsCollapsed
    }, formatMessage(isCollapsed ? $0e79497324363eb1$var$i18n.expand : $0e79497324363eb1$var$i18n.collapse));
};
const $0e79497324363eb1$export$729f5f3a19e7fe8b = ()=>{
    const { actions: actions, complete: complete, loading: loading, errors: errors, isFinished: isFinished } = (0, $f5be8383e833e00b$export$5d769c20b5d59814)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS)));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isCollapsed: isCollapsed, takeoverSeenAt: takeoverSeenAt, hasDismissedCarousel: hasDismissedCarousel, hasDismissedLearningResources: hasDismissedLearningResources } = (0, $ivb8S.deserializeState)(onboardingStateData);
    (0, $42omo.useEffect)(()=>{
        if (!onboardingStateLoading && !takeoverSeenAt) setOnboardingState({
            key: (0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).takeoverSeenAt,
            value: new Date().toISOString()
        });
    }, [
        onboardingStateLoading,
        takeoverSeenAt,
        setOnboardingState
    ]);
    const onboardingPeriodDay = takeoverSeenAt ? (0, $917iu.default)(new Date(), new Date(takeoverSeenAt)) : 0;
    (0, $42omo.useEffect)(()=>{
        if (!onboardingStateLoading && !errors.length) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'NthUserHomeOnboardingTakeover',
                attributes: {
                    onboardingPeriodDay: onboardingPeriodDay,
                    isFinished: isFinished
                }
            }
        }).fire();
    }, [
        errors,
        isFinished,
        onboardingStateLoading,
        onboardingPeriodDay,
        createAnalyticsEvent
    ]);
    const resizingHeight = (0, $6iqYo.useResizingHeight)();
    const toggleIsCollapsed = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: (0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).isCollapsed,
            value: isCollapsed ? 'false' : 'true'
        });
    }, [
        isCollapsed,
        setOnboardingState
    ]);
    const dismissCarousel = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: (0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).hasDismissedCarousel,
            value: 'true'
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'homeOnboardingTakeoverV2CarouselDismiss',
                source: 'homeOnboardingTakeover'
            }
        }).fire();
    }, [
        setOnboardingState,
        createAnalyticsEvent
    ]);
    const dismissLearningResources = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: (0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).hasDismissedLearningResources,
            value: 'true'
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'homeOnboardingTakeoverV2LearningResourcesDismiss',
                source: 'homeOnboardingTakeover'
            }
        }).fire();
    }, [
        setOnboardingState,
        createAnalyticsEvent
    ]);
    if (loading || onboardingStateLoading) return null;
    // This error is blocking because if onboarding state fails, then a lot of the functionality will be broken
    if (errors.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e79497324363eb1$var$HTV2Errors, {
        errors: [
            ...errors
        ]
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...resizingHeight,
        "data-vc": "daGARcWm"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e79497324363eb1$var$HTV2Errors, {
        errors: [
            ...errors
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        testId: "nth-user-home-onboarding-takeover",
        direction: "column",
        gap: "space.200"
    }, !isCollapsed && !hasDismissedCarousel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f30dd92ebe48cdb9$export$cee2d9eac04047dd), {
        actions: actions,
        complete: complete,
        onboardingPeriodDay: onboardingPeriodDay,
        suppressSorting: true,
        onDismissSection: dismissCarousel
    }), isFinished && !hasDismissedCarousel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e79497324363eb1$var$CollapseExpandButton, {
        isCollapsed: isCollapsed,
        toggleIsCollapsed: toggleIsCollapsed
    })), !hasDismissedLearningResources && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $38041ee5c4c2068e$export$a7dd6259deee6f55), {
        onboardingPeriodDay: onboardingPeriodDay,
        onDismissSection: dismissLearningResources
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_TAKEOVER)
    }));
};
const $0e79497324363eb1$var$HTV2Errors = ({ errors: errors })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, errors.map((error, index)=>{
        (0, $7Sm4c.markErrorAsHandled)(error);
        return error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            key: `${error.message}-${index}`,
            error: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
            name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_TAKEOVER),
            error: error
        })) : null;
    }));
};
const $0e79497324363eb1$export$a4d10729329192ad = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CE_MAU,
        onError: (error)=>{
            experienceTracker.stopOnError({
                name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_TAKEOVER),
                error: error
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e79497324363eb1$var$HomeOnboardingTakeoverV2Store, null));
};
const $0e79497324363eb1$var$HomeOnboardingTakeoverV2Store = ()=>{
    const { data: personalSpaceKeyData, loading: personalSpaceKeyLoading, error: personalSpaceKeyError } = (0, $jMyy4.useQueryInterop)($0e79497324363eb1$var$GetPersonalSpaceKeyQuery, {
        __callerPackage__: "@confluence/experiment-home-onboarding-takeover-v2"
    });
    if (personalSpaceKeyLoading) return null;
    const personalSpaceKey = personalSpaceKeyData?.user?.confluence?.hasPersonalSpace && personalSpaceKeyData?.user?.confluence?.space?.key || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ad82bda774949b47$export$23a4a1a2301bbb22), {
        takeoverType: "nth-user",
        personalSpaceKey: personalSpaceKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e79497324363eb1$var$HTV2Errors, {
        errors: [
            personalSpaceKeyError
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e79497324363eb1$export$729f5f3a19e7fe8b, null));
};






const $a8561b2cf16e3af7$export$a761578900d36b98 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "m1RfB",
    name: "PersonalizedTemplatesV2Loadable",
    loader: async ()=>(await (parcelRequire("3QRgh"))).PersonalizedTemplatesV2ErrorBoundary
});


/**
 * @generated SignedSource<<7e4478f2544db633c06a165542c77b17>>
 * @relayHash 4e5e32f92903b0ddb3e0d216186ab7d9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID db8b39ea6d26e658656d63752a19397755fa6f89a774cfd8721920766e16cd63
const $a5ce719234afd4e6$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "kind": "ScalarField",
                    "name": "team"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPersonalSpace"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "NthUserHomeOnboardingRevampGetUserDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "NthUserHomeOnboardingRevampGetUserDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4e5e32f92903b0ddb3e0d216186ab7d9",
            "id": "db8b39ea6d26e658656d63752a19397755fa6f89a774cfd8721920766e16cd63",
            "metadata": {},
            "name": "NthUserHomeOnboardingRevampGetUserDataQuery",
            "operationKind": "query",
            "text": "query NthUserHomeOnboardingRevampGetUserDataQuery{user:confluence_atlassianUser(current:true){id,displayName,team,confluence{hasPersonalSpace,space{id,key}}}}"
        }
    };
}();
$a5ce719234afd4e6$var$node.hash = "851093c14fc8eb32514cb97641783e65";
var $a5ce719234afd4e6$export$2e2bcd8739ae039 = $a5ce719234afd4e6$var$node;


















































/* UseCasesHomeWelcomeBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 


























var $u9agA = parcelRequire("u9agA");



var $iXCQx = parcelRequire("iXCQx");








var $hxdG1 = parcelRequire("hxdG1");

var $480f5cb179a93a39$exports = {};
$480f5cb179a93a39$exports = new URL("WelcomeBannerIllustrationLight.7011b7ae.svg", import.meta.url).toString();


var $6c5297b23056545a$exports = {};
$6c5297b23056545a$exports = new URL("WelcomeBannerIllustrationDark.f7a5edcb.svg", import.meta.url).toString();


const $3b19b5a183dfb573$var$i18n = (0, $aXWIB.defineMessages)({
    useCasesHomeWelcomeBannerTitle: {
        id: "experiment-personalized-templates-v2.use-cases-in-nth-user-onboarding.welcome-banner.title",
        defaultMessage: "Welcome to Confluence, {name}"
    },
    useCasesHomeWelcomeBannerAction: {
        id: "experiment-personalized-templates-v2.use-cases-in-nth-user-onboarding.welcome-banner.action",
        defaultMessage: "Get started with a template below, or click <b>Create</b> to start from scratch."
    },
    useCasesHomeWelcomeBannerDismiss: {
        id: "experiment-personalized-templates-v2.use-cases-in-nth-user-onboarding.welcome-banner.dismiss",
        defaultMessage: "Dismiss"
    }
});
const $3b19b5a183dfb573$var$styles = {
    container: "_2rko1mok _kqswh2mm _1tke1j4a",
    textSection: "_zulpu2gc _ca0qxy5q _n3tdxy5q _19bvxy5q _u5f31jfw",
    dismiss: "_154ipxbi _1xi2pxbi _kqswstnw _80omtlke"
};
const $3b19b5a183dfb573$export$2d42ab2f37bfa9f6 = ({ name: name })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isTemplateListDismissed: isTemplateListDismissed } = (0, $hxdG1.usePTV2State)(); //TODO: Fix this
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)((0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).VIEWED_HEADER);
    const { headerViewedAt: headerViewedAt } = (0, $ivb8S.deserializeState)(data);
    const onboardingPeriodDay = headerViewedAt ? (0, $917iu.default)(new Date(), new Date(headerViewedAt)) : 0;
    (0, $42omo.useEffect)(()=>{
        if (!Boolean(headerViewedAt)) {
            setOnboardingState({
                key: (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).VIEWED_HEADER,
                value: new Date().toISOString()
            });
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'useCasesHomeWelcomeBanner',
                    attributes: {
                        onboardingPeriodDay: onboardingPeriodDay
                    }
                }
            }).fire();
        }
    }, [
        createAnalyticsEvent,
        setOnboardingState,
        headerViewedAt,
        onboardingPeriodDay
    ]);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).DISMISSED_HEADER,
            value: 'true'
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'useCasesHomeWelcomeBannerDismiss',
                source: 'cc-experiment-use-cases-in-nth-user-onboarding',
                attributes: {
                    onboardingPeriodDay: onboardingPeriodDay
                }
            }
        }).fire();
    }, [
        setOnboardingState,
        createAnalyticsEvent,
        onboardingPeriodDay
    ]); // Do not show the banner under the following criteria:
    // 1. If the banner has already been dismissed (this is handled in useOnboardingTakeoverType)
    // 2. We are outside of the 14 day onboarding period (this is handled in useOnboardingTakeoverType)
    // 3. The templates list is already dismissed
    if (isTemplateListDismissed || loading || error) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        backgroundColor: "color.background.accent.blue.subtlest",
        xcss: $3b19b5a183dfb573$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        xcss: $3b19b5a183dfb573$var$styles.textSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$3b19b5a183dfb573$var$i18n.useCasesHomeWelcomeBannerTitle,
        values: {
            name: name
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$3b19b5a183dfb573$var$i18n.useCasesHomeWelcomeBannerAction,
        values: {
            b: (words)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", {
                    "data-vc": "B11joKCp"
                }, words)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($480f5cb179a93a39$exports))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($6c5297b23056545a$exports))),
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $3b19b5a183dfb573$var$styles.dismiss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: handleDismiss,
        spacing: "default",
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: formatMessage($3b19b5a183dfb573$var$i18n.useCasesHomeWelcomeBannerDismiss),
        isTooltipDisabled: false
    })));
};





/* NthUserHomeOnboardingActionCards.tsx generated by @compiled/babel-plugin v0.36.1 */ 
















var $6xdDU = parcelRequire("6xdDU");





var $eHz1Q = parcelRequire("eHz1Q");


var $dG9Mj = parcelRequire("dG9Mj");





var $9uxfR = parcelRequire("9uxfR");



















/* NthUserCards.tsx generated by @compiled/babel-plugin v0.36.1 */ 














const $0d6c8c89db8717c2$var$styles = {
    imageStyles: "_1bsb1osq _5ral1dfr _1h1tszvo _1e0c1ule _njlposdt",
    imageContainer: "_1reo15vq _18m915vq _1bsb1osq _1h1tszvo _njlp1edp"
};
// Memoized Image component to prevent unnecessary re-renders during transitions
const $0d6c8c89db8717c2$var$MemoizedCardImage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ src: src, srcDark: srcDark })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $0d6c8c89db8717c2$var$styles.imageContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: src,
        srcDark: srcDark,
        alt: "",
        className: (0, $gMc0m.default)([
            $0d6c8c89db8717c2$var$styles.imageStyles
        ])
    })));
$0d6c8c89db8717c2$var$MemoizedCardImage.displayName = 'CardImage';
const $0d6c8c89db8717c2$var$createImageComponent = (src, srcDark)=>{
    return {
        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0d6c8c89db8717c2$var$MemoizedCardImage, {
            src: src,
            srcDark: srcDark
        })
    };
}; /**
    * CDN URLs for all images
    * Provides reliable SSR rendering with browser caching benefits
    */ 
const $0d6c8c89db8717c2$export$33dcd44cdbd7c6b = {
    pageImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/d0x4rv1mqv3pvoma7b0r3w66hutj4s4f.svg',
    pageImageDark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/60a3avoj78460elv2g254c15h356spe4.svg',
    brainstormWhiteboard: 'https://dam-cdn.atl.orangelogic.com/AssetLink/gsy48bdsie2x0jl4bwwqa251ow5vc65s.svg',
    brainstormWhiteboardDark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5j4oiocdk42kkk6567oh3j21u1ar2et3.svg',
    aiTeammate: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1608esypf8aw3u06t0i235yp27p45utr.svg',
    aiTeammateDark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0l17d633654t1u8c8171o0xh48cbs375.svg',
    addProfilePicture: 'https://dam-cdn.atl.orangelogic.com/AssetLink/385i88hx73177r8l53036061ca7wquy4.svg',
    addProfilePictureDark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/20pg03c85k301om1xm75652h821e55gx.svg',
    followPeopleAndSpaces: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5iljf6lua6c42o33qf34l0nt23r7078o.svg',
    followPeopleAndSpacesDark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vn1217d2v8yw2lq888gp0b84e7u5g3tu.svg'
}; // Use CDN URLs for all images - SSR friendly and cacheable
const $0d6c8c89db8717c2$var$IMAGES = {
    pageImage: $0d6c8c89db8717c2$var$createImageComponent($0d6c8c89db8717c2$export$33dcd44cdbd7c6b.pageImage, $0d6c8c89db8717c2$export$33dcd44cdbd7c6b.pageImageDark),
    brainstormWhiteboard: $0d6c8c89db8717c2$var$createImageComponent($0d6c8c89db8717c2$export$33dcd44cdbd7c6b.brainstormWhiteboard, $0d6c8c89db8717c2$export$33dcd44cdbd7c6b.brainstormWhiteboardDark),
    aiTeammate: $0d6c8c89db8717c2$var$createImageComponent($0d6c8c89db8717c2$export$33dcd44cdbd7c6b.aiTeammate, $0d6c8c89db8717c2$export$33dcd44cdbd7c6b.aiTeammateDark),
    addProfilePicture: $0d6c8c89db8717c2$var$createImageComponent($0d6c8c89db8717c2$export$33dcd44cdbd7c6b.addProfilePicture, $0d6c8c89db8717c2$export$33dcd44cdbd7c6b.addProfilePictureDark),
    followPeopleAndSpaces: $0d6c8c89db8717c2$var$createImageComponent($0d6c8c89db8717c2$export$33dcd44cdbd7c6b.followPeopleAndSpaces, $0d6c8c89db8717c2$export$33dcd44cdbd7c6b.followPeopleAndSpacesDark)
};
const $0d6c8c89db8717c2$var$i18n = (0, $aXWIB.defineMessages)({
    createPage: {
        id: "experiment-personalized-templates-v2.nth-user.create.page",
        defaultMessage: "Create a page"
    },
    createPageDescription: {
        id: "experiment-personalized-templates-v2.nth-user.create.page.description",
        defaultMessage: "Plan projects, take notes, and track tasks."
    },
    createPageCTA: {
        id: "experiment-personalized-templates-v2.nth-user.create.page.cta",
        defaultMessage: "Create page"
    },
    brainstormOnWhiteboard: {
        id: "experiment-personalized-templates-v2.nth-user.brainstorm.on.whiteboard",
        defaultMessage: "Brainstorm on a whiteboard"
    },
    brainstormOnWhiteboardDescription: {
        id: "experiment-personalized-templates-v2.nth-user.brainstorm.on.whiteboard.description",
        defaultMessage: "Dream up new ideas and visualize your work."
    },
    brainstormOnWhiteboardCTA: {
        id: "experiment-personalized-templates-v2.nth-user.brainstorm.on.whiteboard.cta",
        defaultMessage: "Create whiteboard"
    },
    followPeopleAndSpaces: {
        id: "experiment-personalized-templates-v2.nth-user.follow.people.and.spaces",
        defaultMessage: "Follow people and spaces"
    },
    followPeopleAndSpacesDescription: {
        id: "experiment-personalized-templates-v2.nth-user.follow.people.and.spaces.description",
        defaultMessage: "Customize your following feed to stay up to date with what matters to you."
    },
    followPeopleAndSpacesCTA: {
        id: "experiment-personalized-templates-v2.nth-user.follow.people.and.spaces.cta",
        defaultMessage: "Customize feed"
    },
    meetAITeammate: {
        id: "experiment-personalized-templates-v2.nth-user.meet.your.ai.teammate",
        defaultMessage: "Meet your AI teammate"
    },
    meetAITeammateDescription: {
        id: "experiment-personalized-templates-v2.nth-user.meet.your.ai.teammate.description",
        defaultMessage: "Rovo connects your knowledge and streamlines work, so you can focus on what matters."
    },
    meetAITeammateCTA: {
        id: "experiment-personalized-templates-v2.nth-user.meet.your.ai.teammate.cta",
        defaultMessage: "Chat with Rovo"
    },
    addProfilePicture: {
        id: "experiment-personalized-templates-v2.nth-user.add.profile.picture",
        defaultMessage: "Add your profile photo"
    },
    addProfilePictureDescription: {
        id: "experiment-personalized-templates-v2.nth-user.add.profile.picture.description",
        defaultMessage: "Welcome your teammates to Confluence with a familiar face."
    },
    addProfilePictureCTA: {
        id: "experiment-personalized-templates-v2.nth-user.add.profile.picture.cta",
        defaultMessage: "Add photo"
    },
    completedCTAText: {
        id: "experiment-personalized-templates-v2.nth-user.completed.cta",
        defaultMessage: "Completed"
    },
    dismissLabel: {
        id: "experiment-personalized-templates-v2.nth-user.dismiss.label",
        defaultMessage: "Dismiss"
    }
});
const $0d6c8c89db8717c2$export$43cedd252f50b9ab = [
    {
        id: 'createPage',
        image: $0d6c8c89db8717c2$var$IMAGES.pageImage,
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.createPage),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.createPageDescription),
        ctaText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.createPageCTA),
        ctaCompletedText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.completedCTAText),
        dismissTooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.dismissLabel),
        onDismiss: ()=>{} // This will be handled by the card's onDismiss prop
    },
    {
        id: 'brainstormOnWhiteboard',
        image: $0d6c8c89db8717c2$var$IMAGES.brainstormWhiteboard,
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.brainstormOnWhiteboard),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.brainstormOnWhiteboardDescription),
        ctaText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.brainstormOnWhiteboardCTA),
        ctaCompletedText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.completedCTAText),
        dismissTooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.dismissLabel),
        onDismiss: ()=>{}
    },
    {
        id: 'followPeopleAndSpaces',
        image: $0d6c8c89db8717c2$var$IMAGES.followPeopleAndSpaces,
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.followPeopleAndSpaces),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.followPeopleAndSpacesDescription),
        ctaText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.followPeopleAndSpacesCTA),
        ctaCompletedText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.completedCTAText),
        dismissTooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.dismissLabel),
        onDismiss: ()=>{}
    },
    {
        id: 'meetAITeammate',
        image: $0d6c8c89db8717c2$var$IMAGES.aiTeammate,
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.meetAITeammate),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.meetAITeammateDescription),
        ctaText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.meetAITeammateCTA),
        ctaCompletedText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.completedCTAText),
        dismissTooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.dismissLabel),
        onDismiss: ()=>{}
    },
    {
        id: 'addProfilePicture',
        image: $0d6c8c89db8717c2$var$IMAGES.addProfilePicture,
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.addProfilePicture),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.addProfilePictureDescription),
        ctaText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.addProfilePictureCTA),
        ctaCompletedText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.completedCTAText),
        dismissTooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d6c8c89db8717c2$var$i18n.dismissLabel),
        onDismiss: ()=>{}
    }
];


const $c1ddb20c20a4b62a$export$33a6b2d2157bcee2 = (dismissedCardIds)=>{
    const { isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const shouldShowRovo = (0, $9wGTI.fg)('rovo_use_rovo_llm_enabled_check') ? isRovoLLMEnabled : isRovoEnabled;
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const actionCardsToDisplay = (0, $42omo.useMemo)(()=>{
        const isCardDismissed = (cardId)=>dismissedCardIds.has(cardId);
        const shouldShowCard = (cardId)=>{
            if (isCardDismissed(cardId)) return false;
            if (cardId === 'meetAITeammate') return shouldShowRovo;
            if (cardId === 'followPeopleAndSpaces') return !shouldShowRovo;
            return true;
        };
        return (0, $0d6c8c89db8717c2$export$43cedd252f50b9ab).filter((card)=>shouldShowCard(card.id));
    }, [
        dismissedCardIds,
        shouldShowRovo
    ]);
    (0, $42omo.useEffect)(()=>{
        if (actionCardsToDisplay.length === 0) setOnboardingState({
            key: (0, $eyUJP.NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS).areAllActionsDismissed,
            value: 'true'
        });
    }, [
        actionCardsToDisplay,
        setOnboardingState
    ]);
    return {
        areAllActionsDismissed: actionCardsToDisplay.length === 0,
        actionCardsToDisplay: actionCardsToDisplay
    };
};
















var $8cmRU = parcelRequire("8cmRU");


var $lEClu = parcelRequire("lEClu");



















var $i25hX = parcelRequire("i25hX");

const $c3fa5e5d9d23f949$var$SOURCE = 'nth-user-home-onboarding-revamp';
function $c3fa5e5d9d23f949$export$78b73ffb475465cf(openActivityFilterModal) {
    const { personalSpaceKey: personalSpaceKey, onboardingPeriodDay: onboardingPeriodDay } = (0, $hxdG1.usePTV2State)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { href: profilePictureHref } = (0, $dD7ks.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId ?? ''
        }
    });
    const pageCreationLink = (0, $bZSO8.buildCreationLink)({
        contentType: 'page',
        source: '`${SOURCE}--create-page`',
        spaceKey: personalSpaceKey,
        subType: (0, $dkIiA.ConfluencePageSubType).LIVE,
        openTemplatesGallery: true
    });
    const whiteboardCreationLink = (0, $bZSO8.buildCreationLink)({
        contentType: 'whiteboard',
        source: `${$c3fa5e5d9d23f949$var$SOURCE}--create-whiteboard`,
        spaceKey: personalSpaceKey
    });
    const hrefMap = (0, $42omo.useMemo)(()=>({
            createPage: pageCreationLink,
            brainstormOnWhiteboard: whiteboardCreationLink,
            addProfilePicture: (0, $9wGTI.fg)('confluence-adopt-teams-nav-config') ? profilePictureHref : `/wiki/people/${userId}`
        }), [
        pageCreationLink,
        whiteboardCreationLink,
        profilePictureHref,
        userId
    ]);
    const handleActionClick = (0, $42omo.useCallback)((id, complete)=>{
        complete(id);
        if (id === 'meetAITeammate') publish({
            type: 'chat-new',
            data: {
                name: 'Ask Rovo',
                dialogues: [],
                prompt: '',
                sourceId: `${$c3fa5e5d9d23f949$var$SOURCE}--meet-ai-teammate`
            },
            source: 'confluence',
            interactionSource: $c3fa5e5d9d23f949$var$SOURCE,
            openChat: true
        });
        else if (id === 'followPeopleAndSpaces') openActivityFilterModal();
        else {
            // Handle href navigation for other actions
            const href = hrefMap[id];
            if (href) {
                const isExternalLink = href && !href.includes('wiki');
                if (isExternalLink) window.open(href, '_blank');
                else window.location.href = href;
            }
        }
        // Track analytics
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'gettingStartedCardNthUserHomeRevamp',
                source: $c3fa5e5d9d23f949$var$SOURCE,
                attributes: {
                    onboardingAction: id,
                    onboardingPeriodDay: onboardingPeriodDay
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        onboardingPeriodDay,
        openActivityFilterModal,
        hrefMap,
        publish
    ]);
    return {
        handleActionClick: handleActionClick
    };
}
function $c3fa5e5d9d23f949$export$471002be235b55c9() {
    const { activityFilterModalOpen: activityFilterModalOpen, closeActivityFilterModal: closeActivityFilterModal, openActivityFilterModal: openActivityFilterModal } = (0, $8cmRU.useActivityFilterModalState)();
    const { updateFeedType: updateFeedType } = (0, $fJ5kL.useFeedTypeSelector)();
    const { followingFeedSortBy: followingFeedSortBy, followingFeedQuery: feedContentQuery } = (0, $lEClu.useFollowingFeedWithSortByStorage)();
    const handleFeedSelectorChange = (0, $42omo.useCallback)((updatedFeedType)=>{
        updateFeedType(updatedFeedType);
    }, [
        updateFeedType
    ]);
    const handleActivityFilterModalSave = (0, $42omo.useCallback)(()=>{
        feedContentQuery.refetch?.({
            sortBy: followingFeedSortBy
        });
        handleFeedSelectorChange((0, $4yg2A.FeedType).FOLLOWING);
    }, [
        feedContentQuery,
        followingFeedSortBy,
        handleFeedSelectorChange
    ]);
    return {
        activityFilterModalOpen: activityFilterModalOpen,
        closeActivityFilterModal: closeActivityFilterModal,
        openActivityFilterModal: openActivityFilterModal,
        handleActivityFilterModalSave: handleActivityFilterModalSave
    };
}


const $7eaa5db0ad110548$var$SOURCE = 'nth-user-home-onboarding-revamp';
const $7eaa5db0ad110548$var$i18n = (0, $aXWIB.defineMessages)({
    heading: {
        id: "experiment-personalized-templates-v2.nth-user.action.cards.heading",
        defaultMessage: "Getting started"
    }
});
const $7eaa5db0ad110548$var$styles = {
    containerStyles: "_n3td1ejb",
    headerStyles: "_4cvr1h6o _n3tdutpp",
    gridStyles: "_yv0ewxkt _1rqt1ajj"
};
const $7eaa5db0ad110548$export$1712ed5fe64b4d6e = ({ onboardingStateData: onboardingStateData })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { onboardingPeriodDay: onboardingPeriodDay } = (0, $hxdG1.usePTV2State)();
    const { actions: actions, dismiss: dismiss, complete: complete } = (0, $9uxfR.usePersonalizedTemplateOnboardingActions)((0, $0d6c8c89db8717c2$export$43cedd252f50b9ab), onboardingStateData, (0, $eyUJP.NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS).onboardingActionStates);
    const { activityFilterModalOpen: activityFilterModalOpen, closeActivityFilterModal: closeActivityFilterModal, handleActivityFilterModalSave: handleActivityFilterModalSave, openActivityFilterModal: openActivityFilterModal } = (0, $c3fa5e5d9d23f949$export$471002be235b55c9)();
    const { handleActionClick: handleActionClick } = (0, $c3fa5e5d9d23f949$export$78b73ffb475465cf)(openActivityFilterModal);
    const handleClick = (0, $42omo.useCallback)((id, _event)=>{
        handleActionClick(id, complete);
    }, [
        handleActionClick,
        complete
    ]);
    const handleDismiss = (0, $42omo.useCallback)((id)=>{
        dismiss?.(id);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissGettingStartedCardNthUserHomeRevamp',
                source: $7eaa5db0ad110548$var$SOURCE,
                attributes: {
                    onboardingAction: id,
                    onboardingPeriodDay: onboardingPeriodDay
                }
            }
        }).fire();
    }, [
        dismiss,
        createAnalyticsEvent,
        onboardingPeriodDay
    ]); // Filter and sort actions
    const actionsMap = (0, $42omo.useMemo)(()=>Object.fromEntries(actions.map((action)=>[
                action.id,
                action
            ])), [
        actions
    ]);
    const dismissedCardIds = (0, $42omo.useMemo)(()=>new Set(Object.values(actionsMap).filter((action)=>action.state === 'dismissed').map((action)=>action.id)), [
        actionsMap
    ]);
    const { actionCardsToDisplay: filteredOnboardingActionCards } = (0, $c1ddb20c20a4b62a$export$33a6b2d2157bcee2)(dismissedCardIds);
    (0, $42omo.useEffect)(()=>{
        if (filteredOnboardingActionCards.length > 0) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'homeRevampActionCards',
                source: $7eaa5db0ad110548$var$SOURCE,
                attributes: {
                    numberOfCards: filteredOnboardingActionCards.length,
                    onboardingPeriodDay: onboardingPeriodDay
                }
            }
        }).fire();
    }, [
        filteredOnboardingActionCards.length,
        createAnalyticsEvent,
        onboardingPeriodDay
    ]);
    if (filteredOnboardingActionCards.length === 0) return null;
    const nonCompletedCards = filteredOnboardingActionCards.filter((card)=>actionsMap[card.id]?.state !== 'completed');
    const completedCards = filteredOnboardingActionCards.filter((card)=>actionsMap[card.id]?.state === 'completed');
    const sortedOnboardingActionCards = [
        ...nonCompletedCards,
        ...completedCards
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $7eaa5db0ad110548$var$styles.containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $7eaa5db0ad110548$var$styles.headerStyles,
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $7eaa5db0ad110548$var$i18n.heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8SNb.default), {
        xcss: $7eaa5db0ad110548$var$styles.gridStyles,
        gap: "space.200"
    }, sortedOnboardingActionCards.map((card)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eHz1Q.default), {
            key: card.id,
            image: card.image,
            heading: card.heading,
            description: card.description,
            ctaText: card.ctaText,
            ctaCompletedText: card.ctaCompletedText,
            dismissTooltip: card.dismissTooltip,
            onClick: (event)=>handleClick(card.id, event),
            onDismiss: ()=>handleDismiss(card.id),
            cardCompleted: actionsMap[card.id]?.state === 'completed',
            hasBorder: true,
            headingSize: "xsmall"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, activityFilterModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dG9Mj.ActivityFilterDialog), {
        onChanged: handleActivityFilterModalSave,
        onClose: closeActivityFilterModal
    })));
};


/**
 * @generated SignedSource<<4e9d6aa18e6fddab23ff474d2b493ef6>>
 * @relayHash a318c6cf4c9eb18c3a3da37ca363ccc1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ad70d54f9d11fe1f125e5eb474fba169e08e62a8d9e0d7d7b53b29042f9ea48
const $4e7f171d842d0a92$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "usePersonalSpace"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "usePersonalSpace",
                    "variableName": "usePersonalSpace"
                }
            ],
            "concreteType": "PaginatedTemplateInfoList",
            "kind": "LinkedField",
            "name": "allTemplates",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TemplateInfo",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "templateId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentBlueprintId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blueprintModuleCompleteKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "itemModuleCompleteKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "NthUserTemplatesAllTemplatesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "NthUserTemplatesAllTemplatesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a318c6cf4c9eb18c3a3da37ca363ccc1",
            "id": "3ad70d54f9d11fe1f125e5eb474fba169e08e62a8d9e0d7d7b53b29042f9ea48",
            "metadata": {},
            "name": "NthUserTemplatesAllTemplatesQuery",
            "operationKind": "query",
            "text": "query NthUserTemplatesAllTemplatesQuery($usePersonalSpace:Boolean!){allTemplates(usePersonalSpace:$usePersonalSpace){nodes{templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,name}}}"
        }
    };
}();
$4e7f171d842d0a92$var$node.hash = "832d03e1fc006e98443bb93d481b50bc";
var $4e7f171d842d0a92$export$2e2bcd8739ae039 = $4e7f171d842d0a92$var$node;









var $tB1mP = parcelRequire("tB1mP");



















var $8E5P5 = parcelRequire("8E5P5");


var $lNMA9 = parcelRequire("lNMA9");


var $aZID8 = parcelRequire("aZID8");


var $k70KU = parcelRequire("k70KU");


var $7eJWX = parcelRequire("7eJWX");


var $25bKr = parcelRequire("25bKr");


var $bTccH = parcelRequire("bTccH");

/* NthUserTemplateList.tsx generated by @compiled/babel-plugin v0.36.1 */ 













var $1Whri = parcelRequire("1Whri");

































const $e07ad381e43da202$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    heading: {
        id: "experiment-personalized-templates-v2.nth-user.template.heading",
        defaultMessage: "Templates trusted by {teamType} teams like yours"
    },
    subheading: {
        id: "experiment-personalized-templates-v2.nth-user.template.subheading",
        defaultMessage: "Chosen to help you move fast and make an impact from day one"
    },
    label: {
        id: "experiment-personalized-templates-v2.nth-user.template.dismiss.label",
        defaultMessage: "Dismiss recommendations"
    },
    expand: {
        id: "experiment-personalized-templates-v2.nth-user.template.see.more.templates.button",
        defaultMessage: "Show {numberTemplateSuggestions} more"
    },
    collapse: {
        id: "experiment-personalized-templates-v2.nth-user.template.show.fewer.button",
        defaultMessage: "Show fewer"
    }
});
const $e07ad381e43da202$var$styles = {
    gridStyles: "_yv0ekwa3",
    textContainerStyles: "_n3tdutpp",
    listResetStyles: "_qtt8glyw _1pfhze3t _6rthze3t _ahbqze3t _12l2ze3t _bozgze3t"
};
const $e07ad381e43da202$var$SOURCE = 'nth-user-home-onboarding-revamp';
const $e07ad381e43da202$export$3381bde4f3f682c5 = ({ cards: cards, teamType: teamType, shouldShowUseCasesHomeWelcomeBanner: shouldShowUseCasesHomeWelcomeBanner })=>{
    const [{ onboardingPeriodDay: onboardingPeriodDay }, { setIsTemplateListDismissed: setIsTemplateListDismissed }] = (0, $hxdG1.usePTV2Store)();
    const [isTemplateListExpanded, setIsTemplateExpanded] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const resizingHeight = (0, $6iqYo.useResizingHeight)();
    const remainingTemplates = (cards?.length || 0) - 4;
    const expandButtonMessage = isTemplateListExpanded ? formatMessage($e07ad381e43da202$export$a7357cdd1f0b0168.collapse) : formatMessage($e07ad381e43da202$export$a7357cdd1f0b0168.expand, {
        numberTemplateSuggestions: remainingTemplates
    });
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const personalizationHeuristic = shouldShowUseCasesHomeWelcomeBanner ? 'useCases' : (0, $lNMA9.teamToTemplatesMapping)[teamType.toLocaleUpperCase()] ? 'teamType' : 'popular';
    const handleToggleButtonClick = (0, $42omo.useCallback)(()=>{
        setIsTemplateExpanded(!isTemplateListExpanded);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'openCloseHomeRevampTemplates',
                source: $e07ad381e43da202$var$SOURCE,
                attributes: {
                    isExpanding: !isTemplateListExpanded,
                    personalizationHeuristic: personalizationHeuristic,
                    onboardingPeriodDay: onboardingPeriodDay
                }
            }
        }).fire();
    }, [
        isTemplateListExpanded,
        setIsTemplateExpanded,
        createAnalyticsEvent,
        personalizationHeuristic,
        onboardingPeriodDay
    ]);
    const handleDismissTemplateListClick = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: (0, $eyUJP.NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS).isTemplateListDismissed,
            value: 'true'
        });
        setIsTemplateListDismissed(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissHomeRevampTemplates',
                source: $e07ad381e43da202$var$SOURCE,
                attributes: {
                    personalizationHeuristic: personalizationHeuristic,
                    onboardingPeriodDay: onboardingPeriodDay
                }
            }
        }).fire();
    }, [
        setOnboardingState,
        setIsTemplateListDismissed,
        createAnalyticsEvent,
        personalizationHeuristic,
        onboardingPeriodDay
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...resizingHeight,
        "data-vc": "NAVBlYtx"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $e07ad381e43da202$var$styles.textContainerStyles,
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        direction: "column",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall",
        as: (0, $6mKj3.expValEquals)('cc_activation_a11y_fixes', 'isEnabled', true) ? 'h3' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$e07ad381e43da202$export$a7357cdd1f0b0168.heading,
        values: {
            teamType: teamType.toLocaleLowerCase()
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "medium",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e07ad381e43da202$export$a7357cdd1f0b0168.subheading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), null, remainingTemplates > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: handleToggleButtonClick
    }, expandButtonMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        isTooltipDisabled: false,
        appearance: "subtle",
        onClick: handleDismissTemplateListClick,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: formatMessage($e07ad381e43da202$export$a7357cdd1f0b0168.label)
    }))), (0, $6mKj3.expValEquals)('cc_activation_a11y_fixes', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8SNb.default), {
        as: "ul",
        xcss: (0, $1Whri.cx)($e07ad381e43da202$var$styles.gridStyles, $e07ad381e43da202$var$styles.listResetStyles),
        gap: "space.200"
    }, cards.filter((card)=>card).splice(0, isTemplateListExpanded ? cards.length : 4).map((card, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
            key: card.key ?? i
        }, card))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8SNb.default), {
        xcss: $e07ad381e43da202$var$styles.gridStyles,
        gap: "space.200"
    }, cards.filter((card)=>card).splice(0, isTemplateListExpanded ? cards.length : 4)));
};


const $bb2b741b44f9896d$var$AllTemplatesQuery = (0, $4e7f171d842d0a92$export$2e2bcd8739ae039);
const $bb2b741b44f9896d$var$SOURCE = 'nth-user-home-onboarding-revamp';
const $bb2b741b44f9896d$export$a0d0c2ff6dc2cf52 = ({ templateUsageValues: templateUsageValues, shouldShowUseCasesHomeWelcomeBanner: shouldShowUseCasesHomeWelcomeBanner })=>{
    const { teamType: teamType, personalSpaceKey: personalSpaceKey, onboardingPeriodDay: onboardingPeriodDay, isTemplateListDismissed: isTemplateListDismissed } = (0, $hxdG1.usePTV2State)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: allTemplatesData } = (0, $jMyy4.useQueryInterop)($bb2b741b44f9896d$var$AllTemplatesQuery, {
        variables: {
            usePersonalSpace: true
        },
        skip: !personalSpaceKey || isTemplateListDismissed,
        __callerPackage__: "@confluence/experiment-personalized-templates-v2"
    });
    const personalizationHeuristic = shouldShowUseCasesHomeWelcomeBanner ? 'useCases' : (0, $lNMA9.teamToTemplatesMapping)[teamType.toLocaleUpperCase()] ? 'teamType' : 'popular';
    const blueprintModuleKeyToTemplate = (0, $8E5P5.mapBlueprintModuleKeyToTemplate)(allTemplatesData);
    // Read use case selected templates from onboarding state
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).SELECTED_TEMPLATES
    ], !(0, $9wGTI.fg)('use-cases-onboarding-state-retrieval-kill-switch'));
    // Determine needed templates
    const neededTemplates = (0, $42omo.useMemo)(()=>{
        let templates = [];
        if (!loading && !error && (0, $9wGTI.fg)('use-cases-onboarding-state-retrieval-kill-switch')) {
            const { selectedTemplates: selectedTemplates } = (0, $ivb8S.deserializeState)(data);
            // Try to use use case selected templates if available
            if (shouldShowUseCasesHomeWelcomeBanner && selectedTemplates) try {
                // Parse the stored use case template selection data
                const { teamType: selectedTeamType, useCases: useCases } = JSON.parse(selectedTemplates);
                // Fetch templates based on team type and use cases
                const useCaseTemplates = (0, $tB1mP.fetchUseCaseTemplatesByTempTypeAndUseCaseId)(selectedTeamType, useCases);
                if (useCaseTemplates && useCaseTemplates.length > 0) for(let uctIndex = 0; uctIndex < useCaseTemplates.length; uctIndex++){
                    if (useCaseTemplates[uctIndex].templateType === 'page') {
                        for (const blueprintName of Object.keys((0, $8E5P5.BLUEPRINT_NAME_TO_IDS_MAPPING)))if ((0, $8E5P5.BLUEPRINT_NAME_TO_IDS_MAPPING)[blueprintName]?.blueprintModuleCompleteKey == useCaseTemplates[uctIndex].templateId) {
                            templates.push(blueprintName);
                            break;
                        }
                    } else if (Object.values((0, $aZID8.WHITEBOARD_TEMPLATE_IDS)).includes(useCaseTemplates[uctIndex].templateId)) templates.push(useCaseTemplates[uctIndex].templateId);
                }
            } catch (error) {
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'failed',
                        actionSubject: 'useCaseTemplate',
                        source: 'cc-experiment-use-cases-in-nth-user-onboarding',
                        attributes: {
                            errorMessage: error.message
                        }
                    }
                }).fire();
            }
        }
        // Fallback to team-based templates if no templates were set
        if (templates.length === 0) templates = (0, $lNMA9.teamToTemplatesMapping)[teamType.toLocaleUpperCase()] || (0, $k70KU.DEFAULT_POPULAR_TEMPLATES);
        return templates;
    }, [
        shouldShowUseCasesHomeWelcomeBanner,
        data,
        teamType,
        loading,
        error,
        createAnalyticsEvent
    ]);
    const { deserializedTemplateUsage: deserializedTemplateUsage, incrementTemplateUsage: incrementTemplateUsage } = (0, $7eJWX.usePTV2TemplateUsage)(templateUsageValues, neededTemplates, (0, $eyUJP.NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS).templateUsageValues);
    (0, $42omo.useEffect)(()=>{
        if (!isTemplateListDismissed) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'homeRevampTemplates',
                source: $bb2b741b44f9896d$var$SOURCE,
                attributes: {
                    personalizationHeuristic: personalizationHeuristic,
                    onboardingPeriodDay: onboardingPeriodDay
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        personalizationHeuristic,
        onboardingPeriodDay,
        isTemplateListDismissed
    ]);
    if (isTemplateListDismissed) return null;
    const cards = neededTemplates.reduce((current, templateName)=>{
        if ((0, $8E5P5.BLUEPRINT_NAMES_SET).has(templateName)) return [
            ...current,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bTccH.PTV2BlueprintTemplateCard), {
                key: templateName,
                usage: deserializedTemplateUsage[templateName] || 0,
                onClick: ()=>{
                    incrementTemplateUsage(templateName);
                },
                templateName: templateName,
                blueprintModuleKeyToTemplate: blueprintModuleKeyToTemplate
            })
        ];
        else return [
            ...current,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $25bKr.PTV2WhiteboardTemplateCard), {
                key: templateName,
                usage: deserializedTemplateUsage[templateName] || 0,
                onClick: ()=>{
                    incrementTemplateUsage(templateName);
                },
                templateName: templateName
            })
        ];
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e07ad381e43da202$export$3381bde4f3f682c5), {
        cards: cards,
        teamType: teamType,
        shouldShowUseCasesHomeWelcomeBanner: shouldShowUseCasesHomeWelcomeBanner
    });
};


const $5fb3c229f2bf9813$var$GetUserDataQuery = (0, $a5ce719234afd4e6$export$2e2bcd8739ae039);
const $5fb3c229f2bf9813$var$SOURCE = 'nth-user-home-onboarding-revamp';
const $5fb3c229f2bf9813$export$734fda6f2c76c665 = ({ shouldShowUseCasesHomeWelcomeBanner: shouldShowUseCasesHomeWelcomeBanner })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)(Object.values({
        IS_FOUNDING_ADMIN: (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
        ...(0, $eyUJP.NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS)
    }));
    const { data: userData, loading: userDataLoading, error: userDataError } = (0, $jMyy4.useQueryInterop)($5fb3c229f2bf9813$var$GetUserDataQuery, {
        __callerPackage__: "@confluence/experiment-personalized-templates-v2"
    });
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { isTemplateListDismissed: isTemplateListDismissed, takeoverSeenAt: takeoverSeenAt, templateUsageValues: templateUsageValues } = (0, $ivb8S.deserializeState)(onboardingStateData) || {};
    (0, $42omo.useEffect)(()=>{
        if (!onboardingStateLoading && !userDataLoading && !Boolean(takeoverSeenAt)) setOnboardingState({
            key: (0, $eyUJP.NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS).takeoverSeenAt,
            value: new Date().toISOString()
        });
    }, [
        onboardingStateLoading,
        userDataLoading,
        takeoverSeenAt,
        setOnboardingState
    ]);
    const personalSpaceKey = userData?.user?.confluence?.hasPersonalSpace && userData?.user?.confluence?.space?.key || '';
    const teamType = userData?.user?.team || '';
    const displayName = userData?.user?.displayName;
    const onboardingPeriodDay = takeoverSeenAt ? (0, $917iu.default)(new Date(), new Date(takeoverSeenAt)) : 0;
    const isReadyToRender = !onboardingStateLoading && !userDataLoading && Boolean(personalSpaceKey);
    const personalizationHeuristic = shouldShowUseCasesHomeWelcomeBanner ? 'useCases' : undefined;
    (0, $42omo.useEffect)(()=>{
        if (isReadyToRender) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'nthUserHomeOnboardingRevamp',
                source: $5fb3c229f2bf9813$var$SOURCE,
                attributes: {
                    teamType: teamType,
                    onboardingPeriodDay: onboardingPeriodDay,
                    isTemplateListDismissed: Boolean(isTemplateListDismissed),
                    personalizationHeuristic: personalizationHeuristic
                }
            }
        }).fire();
    }, [
        isReadyToRender,
        teamType,
        onboardingPeriodDay,
        isTemplateListDismissed,
        createAnalyticsEvent,
        personalizationHeuristic
    ]);
    if (userDataError) {
        if ((0, $1uFM6.isUnauthorizedError)(userDataError) || (0, $95rLf.isExpectedApolloError)(userDataError)) {
            (0, $7Sm4c.markErrorAsHandled)(userDataError);
            experienceTracker.abort({
                name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_REVAMP),
                reason: 'User is not permitted'
            });
        }
        experienceTracker.stopOnError({
            name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_REVAMP),
            error: userDataError
        });
        return null;
    }
    if (!isReadyToRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hxdG1.PTV2StoreContainer), {
        teamType: teamType,
        personalSpaceKey: personalSpaceKey,
        isTemplateListDismissed: isTemplateListDismissed,
        onboardingPeriodDay: onboardingPeriodDay,
        personalizationHeuristic: personalizationHeuristic,
        source: $5fb3c229f2bf9813$var$SOURCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        direction: "column",
        gap: "space.200",
        "data-vc": "nth-user-home-onboarding-revamp"
    }, shouldShowUseCasesHomeWelcomeBanner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3b19b5a183dfb573$export$2d42ab2f37bfa9f6), {
        name: displayName ?? ''
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7eaa5db0ad110548$export$1712ed5fe64b4d6e), {
        onboardingStateData: onboardingStateData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bb2b741b44f9896d$export$a0d0c2ff6dc2cf52), {
        templateUsageValues: templateUsageValues,
        shouldShowUseCasesHomeWelcomeBanner: shouldShowUseCasesHomeWelcomeBanner
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_REVAMP)
    }));
};
const $5fb3c229f2bf9813$export$b2aea928da4324ae = ({ shouldShowUseCasesHomeWelcomeBanner: shouldShowUseCasesHomeWelcomeBanner })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT,
        onError: (error)=>{
            experienceTracker.stopOnError({
                name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_REVAMP),
                error: error
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_REVAMP)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5fb3c229f2bf9813$export$734fda6f2c76c665, {
        shouldShowUseCasesHomeWelcomeBanner: shouldShowUseCasesHomeWelcomeBanner
    }));
};






const $1bab1e21869236aa$export$ff08963ad63f51b1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Tlv72",
    name: "TemplateCollectionsLoader",
    loader: async ()=>(await (parcelRequire("irtDS"))).TemplateCollections
});


const $5b23f4939f96a023$var$onboardingExperienceContainerStyles = null;
const $5b23f4939f96a023$var$templatesContainerStyles = null;
const $5b23f4939f96a023$export$20dcb875488cce60 = ({ onboardingTakeoverType: onboardingTakeoverType, isTemplatesCollectionEligible: isTemplatesCollectionEligible })=>{
    if (onboardingTakeoverType === 'nth-user') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_yyhy6s8z _1ii71sq4 _kqswh2mm _otyr3mo9"
        ]),
        "data-vc": "Bwocd9a8"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0e79497324363eb1$export$a4d10729329192ad), null));
    if (onboardingTakeoverType === 'personalized-templates-v2' || onboardingTakeoverType === 'personalized-templates-v2-xflow') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_yyhy6s8z _1ii71sq4 _kqswh2mm _otyr3mo9"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a8561b2cf16e3af7$export$a761578900d36b98), {
        isXflow: onboardingTakeoverType === 'personalized-templates-v2-xflow'
    }));
    if (onboardingTakeoverType === 'use-cases-in-nth-user-onboarding') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_yyhy6s8z _1ii71sq4 _kqswh2mm _otyr3mo9"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5fb3c229f2bf9813$export$b2aea928da4324ae), {
        shouldShowUseCasesHomeWelcomeBanner: true
    }));
    if (onboardingTakeoverType === 'nth-user-home-onboarding-revamp') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_yyhy6s8z _1ii71sq4 _kqswh2mm _otyr3mo9"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5fb3c229f2bf9813$export$b2aea928da4324ae), null));
    if (isTemplatesCollectionEligible && onboardingTakeoverType !== 'personalized-templates-v2-xflow' && onboardingTakeoverType !== 'personalized-templates-v2') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_yyhy6s8z _1ii71sq4 _kqswh2mm _19pkidpf _otyr1ejb"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1bab1e21869236aa$export$ff08963ad63f51b1), null));
    return null;
};


const $64913c7d2c985501$var$homeBannerContainerStyles = null;
const $64913c7d2c985501$export$addeb901e1836ce1 = ({ onboardingTakeoverType: onboardingTakeoverType, isTemplatesCollectionEligible: isTemplatesCollectionEligible })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_yyhy6s8z _1ii76s8z _1e0c1bgi"
        ]),
        "data-vc": "yQuIIk8T"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5b23f4939f96a023$export$20dcb875488cce60), {
        onboardingTakeoverType: onboardingTakeoverType,
        isTemplatesCollectionEligible: isTemplatesCollectionEligible
    }));
};


/* RecentList.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $6a9Hv = parcelRequire("6a9Hv");








var $hjygH = parcelRequire("hjygH");





var $56QzY = parcelRequire("56QzY");


var $1C3B1 = parcelRequire("1C3B1");


var $lXYVJ = parcelRequire("lXYVJ");





var $kDja4 = parcelRequire("kDja4");


var $yuLaV = parcelRequire("yuLaV");








var $ctLrB = parcelRequire("ctLrB");








var $1Zr9M = parcelRequire("1Zr9M");


var $9FnLD = parcelRequire("9FnLD");


var $1yB28 = parcelRequire("1yB28");


var $kevJM = parcelRequire("kevJM");




/* NarrowPageCardView.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $3gadb = parcelRequire("3gadb");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");


var $8lYIw = parcelRequire("8lYIw");


var $1YXTQ = parcelRequire("1YXTQ");





var $dYA5q = parcelRequire("dYA5q");


var $hXDOc = parcelRequire("hXDOc");


var $2HmqS = parcelRequire("2HmqS");

/* NarrowPageCardLayout.tsx generated by @compiled/babel-plugin v0.36.1 */ 








// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9e180d36b0a6d313$var$Card = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itia51 _2rko1mok _1yt4pxbi _kqswh2mm _80omtlke _bfhkvuon _1dbzt7xp",
            __cmplp.className
        ])
    });
});
const $9e180d36b0a6d313$var$ContentWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $9e180d36b0a6d313$var$InvisibleLink = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $8lYIw.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19it145i _2rko1mok _kqswstnw _1bsb1osq _4t3i1osq _154i1n1a _1ltv1n1a",
            __cmplp.className
        ])
    });
});
const $9e180d36b0a6d313$var$Header = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _otyrdlk8",
            __cmplp.className
        ])
    });
});
const $9e180d36b0a6d313$var$CardIcon = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2hwx12x7",
            __cmplp.className
        ])
    });
});
const $9e180d36b0a6d313$var$CardPrimarySecondary = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _1o9zkb7n _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $9e180d36b0a6d313$var$CardPrimary = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _11c81qyo _syazi7uo _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $9e180d36b0a6d313$var$CardSecondary = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _syazazsu _43dsazsu _1cayazsu _oxk4azsu",
            __cmplp.className
        ])
    });
});
const $9e180d36b0a6d313$var$CardActions = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u01b66 _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $9e180d36b0a6d313$export$4e84ecf8cf7987d = ({ icon: icon, primary: primary, secondary: secondary, lastModified: lastModified, actions: actions, className: className, testId: testId, url: url, onClick: onClick, ariaLabel: ariaLabel })=>{
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9e180d36b0a6d313$var$Card, {
        className: className,
        "data-testid": testId,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9e180d36b0a6d313$var$InvisibleLink, {
        href: url,
        onClick: onClick,
        "aria-label": ariaLabel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9e180d36b0a6d313$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9e180d36b0a6d313$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9e180d36b0a6d313$var$CardIcon, {
        "data-testid": "list-item-icon"
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9e180d36b0a6d313$var$CardPrimarySecondary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9e180d36b0a6d313$var$CardPrimary, null, primary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9e180d36b0a6d313$var$CardSecondary, null, secondary)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9e180d36b0a6d313$var$CardActions, null, actions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9e180d36b0a6d313$var$CardSecondary, null, lastModified))));
};


/* StatusLozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 














var $5nBzc = parcelRequire("5nBzc");





var $aqBZ0 = parcelRequire("aqBZ0");


var $bvJMy = parcelRequire("bvJMy");




const $f9db21cd493ae1c7$export$1e65fa6807627361 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1o9zidpf _16jlkb7n _y3gn1e5h _18u01b66 _19pk1n1a _4t3i7vkz _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $f9db21cd493ae1c7$var$LozengeContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkt94y _2hwx14y2 _otyridpf _18u014y2",
            __cmplp.className
        ])
    });
});
const $f9db21cd493ae1c7$var$inlineStarContainerStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.025'
});
const $f9db21cd493ae1c7$export$f72db4ad1e9b3e6d = ({ status: status, unpublished: unpublished = false, scheduled: scheduled = false, showStar: showStar = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (scheduled) createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'feature',
            action: 'exposed',
            source: 'StatusLozenge'
        }
    }).fire();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f9db21cd493ae1c7$export$1e65fa6807627361, null, status === 'draft' || status === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f9db21cd493ae1c7$var$LozengeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), status === 'draft' ? (0, $2HmqS.i18n).contentDraft : (0, $2HmqS.i18n).contentArchived))) : null, scheduled && unpublished || scheduled && !unpublished ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f9db21cd493ae1c7$var$LozengeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: "default",
        isBold: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $2HmqS.i18n).contentScheduled))) : unpublished && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f9db21cd493ae1c7$var$LozengeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $2HmqS.i18n).contentUnpublished))), showStar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $f9db21cd493ae1c7$var$inlineStarContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bvJMy.StarSelectedIcon), {
        size: "small",
        label: "Favorite"
    })) : null);
};











var $bCECL = parcelRequire("bCECL");


var $8rneB = parcelRequire("8rneB");


var $brn6e = parcelRequire("brn6e");

const $7019f18d0f63dcba$var$iconBorderStyles = (0, $ecnYn.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    height: '32px',
    width: '32px'
});
const $7019f18d0f63dcba$export$529be498da43e377 = ({ contentType: contentType, emoji: emoji, subType: subType })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $7019f18d0f63dcba$var$iconBorderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
        type: contentType,
        subType: subType,
        emoji: emoji
    }));
};
const $7019f18d0f63dcba$export$c6f6399581f183bf = (content)=>{
    const emojiPropertyDraft = (0, $8rneB.getEmojiDraftFromProperties)(content);
    const emojiPropertyPublished = (0, $8rneB.getEmojiPublishedFromProperties)(content);
    const emojiProperty = content.status === 'draft' ? emojiPropertyDraft : emojiPropertyPublished;
    const emoji = emojiProperty || (0, $brn6e.getEmojiFromTitle)(content.title);
    return {
        hasEmojiProperty: Boolean(emojiProperty),
        emoji: emoji
    };
};
const $7019f18d0f63dcba$export$70d1bf7729efff40 = (originalTitle, hasEmojiProperty)=>hasEmojiProperty ? originalTitle : (0, $brn6e.removeEmojiFromTitle)(originalTitle);


const $3b08a451faa582d7$var$SpaceLinkWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1pbykb7n _1e0c1txw _o5721q9c",
            __cmplp.className
        ])
    });
});
const $3b08a451faa582d7$var$SpaceLink = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $8lYIw.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _kqswh2mm _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $3b08a451faa582d7$var$LastModifiedWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _s7n41q9y",
            __cmplp.className
        ])
    });
});
const $3b08a451faa582d7$var$titleSelector = 'home.recents.Title';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3b08a451faa582d7$var$TitleAndStatus = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _174i1r31 _zk6iglyw _malanqa1 _vncqazsu _1oz9i7uo _992b1n1a _1l5x1n1a",
            __cmplp.className
        ])
    });
});
const $3b08a451faa582d7$var$Title = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bto1l2s _kqswh2mm _o5721q9c _syazi7uo",
            __cmplp.className
        ])
    });
});
$3b08a451faa582d7$var$Title.defaultProps = {
    'data-styled-selector': $3b08a451faa582d7$var$titleSelector
};
const $3b08a451faa582d7$export$5c759a6f26335296 = ({ content: content, onClick: onClick, onSpaceClick: onSpaceClick, action: action, lastActionI18n: lastActionI18n })=>{
    const isLivePage = content?.type === 'page' && content?.subType === 'live' && content?.status !== 'archived';
    const EMOJI_CONTENT_TYPES = (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles') ? [
        'page',
        'blogpost',
        'embed',
        'whiteboard',
        'slide'
    ] : [
        'page',
        'blogpost',
        'embed'
    ];
    const url = `${(0, $jlIaF.CONTEXT_PATH)}${content?.links?.webui}`;
    const isEmojiContentType = content?.type && EMOJI_CONTENT_TYPES.includes(content.type);
    const emoji = content?.title?.emoji;
    const title = isEmojiContentType ? (0, $7019f18d0f63dcba$export$70d1bf7729efff40)(content?.title?.text, Boolean(emoji)) : content?.title?.text;
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7019f18d0f63dcba$export$529be498da43e377), {
        emoji: emoji,
        contentType: content?.type || '',
        subType: content?.subType || ''
    });
    const primary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3b08a451faa582d7$var$TitleAndStatus, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: title || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $2HmqS.i18n).contentUntitled),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3b08a451faa582d7$var$Title, {
            href: url,
            ...(0, $9wGTI.fg)('a11y-fix-narrow-card-title-tab-index') ? {
                tabIndex: -1,
                'aria-hidden': true
            } : {},
            ...tooltipProps
        }, title || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $2HmqS.i18n).contentUntitled))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f9db21cd493ae1c7$export$f72db4ad1e9b3e6d), {
        status: content?.status || ''
    }));
    const space = content?.space;
    const spaceKey = space?.spaceKey;
    const spaceName = space?.name || '';
    const secondary = spaceName && (spaceKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3b08a451faa582d7$var$SpaceLinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3b08a451faa582d7$var$SpaceLink, {
        href: (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        }),
        onClick: onSpaceClick
    }, spaceName)) : spaceName);
    const lastModifiedComponent = content?.lastAction?.when && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3b08a451faa582d7$var$LastModifiedWrapper, null, lastActionI18n && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), lastActionI18n), ' '), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
        date: content.lastAction.when
    }));
    const preloadOptions = Boolean((0, $1NBp8.SPACE_OVERVIEW).match(url)) ? (0, $hXDOc.PreloadingPresets).onlyJSAndCriticalData : (0, $hXDOc.PreloadingPresets).onlyJS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dYA5q.LivePagePreloader), {
        isLivePage: isLivePage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXDOc.HoverPreloader), {
        name: "narrow-page-card",
        preloadUrl: url,
        preloadOptions: preloadOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9e180d36b0a6d313$export$4e84ecf8cf7987d), {
        icon: icon,
        primary: primary,
        secondary: secondary,
        lastModified: lastModifiedComponent,
        actions: action,
        url: url,
        onClick: onClick,
        ariaLabel: title || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $2HmqS.i18n).contentUntitled),
        testId: "narrow-page-card"
    })));
};



var $2mfTa = parcelRequire("2mfTa");




const $05a91a1e1489ca6c$var$i18n = (0, $aXWIB.defineMessages)({
    edited: {
        id: "home.views.overview.recent-work.action.edited",
        defaultMessage: "You edited {timeAgo}"
    },
    visited: {
        id: "home.views.overview.recent-work.action.visited",
        defaultMessage: "You visited {timeAgo}"
    },
    created: {
        id: "home.views.overview.recent-work.action.created",
        defaultMessage: "You created {timeAgo}"
    },
    liked: {
        id: "home.views.overview.recent-work.action.liked",
        defaultMessage: "You liked {timeAgo}"
    },
    commented: {
        id: "home.views.overview.recent-work.action.commented",
        defaultMessage: "You commented {timeAgo}"
    },
    unpublished: {
        id: "home.views.overview.recent-work.lozenge.unpublished",
        defaultMessage: "unpublished changes"
    },
    editedShort: {
        id: "home.views.overview.recent-work.action.edited.short",
        defaultMessage: "Edited"
    },
    visitedShort: {
        id: "home.views.overview.recent-work.action.visited.short",
        defaultMessage: "Visited"
    },
    createdShort: {
        id: "home.views.overview.recent-work.action.created.short",
        defaultMessage: "Created"
    },
    likedShort: {
        id: "home.views.overview.recent-work.action.liked.short",
        defaultMessage: "Liked"
    },
    commentedShort: {
        id: "home.views.overview.recent-work.action.commented.short",
        defaultMessage: "Commented"
    }
});
const $05a91a1e1489ca6c$var$ActionIconStrings = {
    VIEWED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($kevJM))),
        $05a91a1e1489ca6c$var$i18n.visited,
        $05a91a1e1489ca6c$var$i18n.visitedShort
    ],
    EDITED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
        $05a91a1e1489ca6c$var$i18n.edited,
        $05a91a1e1489ca6c$var$i18n.editedShort
    ],
    UPDATED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
        $05a91a1e1489ca6c$var$i18n.edited,
        $05a91a1e1489ca6c$var$i18n.editedShort
    ],
    CREATED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
        $05a91a1e1489ca6c$var$i18n.created,
        $05a91a1e1489ca6c$var$i18n.createdShort
    ],
    PUBLISHED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
        $05a91a1e1489ca6c$var$i18n.edited,
        $05a91a1e1489ca6c$var$i18n.editedShort
    ],
    LIKED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))),
        $05a91a1e1489ca6c$var$i18n.liked,
        $05a91a1e1489ca6c$var$i18n.likedShort
    ],
    COMMENTED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
        $05a91a1e1489ca6c$var$i18n.commented,
        $05a91a1e1489ca6c$var$i18n.commentedShort
    ],
    SNAPSHOTTED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
        $05a91a1e1489ca6c$var$i18n.edited,
        $05a91a1e1489ca6c$var$i18n.editedShort
    ],
    STARTED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
        $05a91a1e1489ca6c$var$i18n.created,
        $05a91a1e1489ca6c$var$i18n.createdShort
    ],
    // these shouldn't be possible for Confluence but are listed for completion
    ASSIGNED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($kevJM))),
        $05a91a1e1489ca6c$var$i18n.visited,
        $05a91a1e1489ca6c$var$i18n.visitedShort
    ],
    UNASSIGNED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($kevJM))),
        $05a91a1e1489ca6c$var$i18n.visited,
        $05a91a1e1489ca6c$var$i18n.visitedShort
    ],
    TRANSITIONED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($kevJM))),
        $05a91a1e1489ca6c$var$i18n.visited,
        $05a91a1e1489ca6c$var$i18n.visitedShort
    ]
};
const $05a91a1e1489ca6c$export$2ce63fa6fe9fb735 = ({ recent: recent, index: index, onItemClick: onItemClick, onItemSpaceClick: onItemSpaceClick, shouldAutofocus: shouldAutofocus })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const transformedRecent = (0, $42omo.useMemo)(()=>(0, $ctLrB.transformActivityData)(recent, true), [
        recent
    ]);
    const content = (0, $42omo.useMemo)(()=>(0, $2mfTa.transformRecentToPageCard)(transformedRecent, '', false, true), [
        transformedRecent
    ]);
    const action = transformedRecent.event?.eventType || (0, $ctLrB.ActivityEventType).VIEWED;
    const { status: status, id: contentId, type: type } = content;
    const spaceKey = content.space.spaceKey;
    const linkRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (shouldAutofocus && linkRef.current) linkRef.current.focus();
    }, [
        shouldAutofocus,
        linkRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3b08a451faa582d7$export$5c759a6f26335296), {
        key: index,
        content: content,
        lastActionI18n: $05a91a1e1489ca6c$var$ActionIconStrings[action]?.[2] ?? $05a91a1e1489ca6c$var$i18n.visitedShort,
        onClick: ()=>onItemClick(index, action, status, contentId, spaceKey, cloudId, type),
        onSpaceClick: ()=>onItemSpaceClick(index)
    });
};


/* RecentWorkEmptyState.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $jhwJP = parcelRequire("jhwJP");


var $288YL = parcelRequire("288YL");


var $a9SJx = parcelRequire("a9SJx");


var $8Phdh = parcelRequire("8Phdh");

const $d6d562fa774e9838$var$emptyStateStyles = null;
const $d6d562fa774e9838$var$headerStyles = null;
const $d6d562fa774e9838$var$contentStyles = null;
const $d6d562fa774e9838$var$imageStyles = null;
const $d6d562fa774e9838$var$i18nBase = (0, $aXWIB.defineMessages)({
    header: {
        id: "home.views.overview.recent-empty-state.header",
        defaultMessage: "Get out there and explore"
    },
    body: {
        id: "home.views.overview.recent-empty-state.body",
        defaultMessage: "Once you visit, edit, or create pages, you\u2019ll find the most recent ones here."
    }
});
const $d6d562fa774e9838$var$i18nLiveDocs = (0, $aXWIB.defineMessages)({
    body: {
        id: "home.views.overview.recent-empty-state.body.livedocs",
        defaultMessage: "Once you visit, edit, or create pages or live docs, you\u2019ll find the most recent ones here."
    }
});
const $d6d562fa774e9838$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($d6d562fa774e9838$var$i18nBase, $d6d562fa774e9838$var$i18nLiveDocs);
const $d6d562fa774e9838$export$723865f954913f68 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1yt41ejb _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1yb4 _kqswh2mm _4t3i1qr7"
        ]),
        "data-vc": "0LiiY0Uy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_p12f1kdj"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_11c81qyo _otyru2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $d6d562fa774e9838$var$i18n.header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $d6d562fa774e9838$var$i18n.body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $288YL.CreatePageButton), {
        appearance: "default",
        creationLinkSource: "home-overview-recentList",
        showCreateLivePageButton: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8Phdh))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($a9SJx))),
        alt: "",
        className: (0, $gMc0m.default)([
            "_kqswstnw _1xi21ejb _154i1ejb"
        ])
    }));
};



var $y9T5W = parcelRequire("y9T5W");








var $2fgSf = parcelRequire("2fgSf");


var $2Ujef = parcelRequire("2Ujef");


var $a67vB = parcelRequire("a67vB");

const $77f51db044e9798b$export$4b7c4c3babb9aee3 = ({ isWhiteboardViewedEnabled: isWhiteboardViewedEnabled, isDatabaseEnabled: isDatabaseEnabled, isSlidesEnabled: isSlidesEnabled, first: first })=>{
    const { cloudId: cloudId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $2Ujef.default), {
        ...(0, $a67vB.getRecentWorkQueryOptions)({
            cloudId: cloudId,
            isLoggedIn: isLoggedIn,
            isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
            isDatabaseEnabled: isDatabaseEnabled,
            isSlidesEnabled: isSlidesEnabled,
            first: first
        }),
        ...(0, $2fgSf.shouldUseAGGActivityV3)() && {
            interopApolloAggClient: true
        },
        __callerPackage__: "@confluence/home"
    });
    return {
        data: data,
        loading: loading,
        error: error
    };
};


const $4a2a6fb115c84f19$var$listContainerStyles = null;
const $4a2a6fb115c84f19$var$gridContainerStyles = {
    default: "_zulppxbi _1e0c11p5 _2z051e96 _yv0e13pt",
    shouldShowRightPanel: "_yv0e9sye"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4a2a6fb115c84f19$export$293c6df601f14bb7 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _1o9zkb7n _1bah1yb4 _1ul9uuw1 _2hwxutpp",
            __cmplp.className
        ])
    });
});
const $4a2a6fb115c84f19$var$titleAndCreatorAndSpaceStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4a2a6fb115c84f19$export$b8681802889370f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4g97w _1e0c1txw _4t3i1ady",
            __cmplp.className
        ])
    });
});
const $4a2a6fb115c84f19$var$itemPlaceholderStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4a2a6fb115c84f19$export$7c901fb2027bd1cd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1bsb1tcg _4t3i1tcg _19pkv77o _2hwxdlk8 _bfhkizff",
            __cmplp.className
        ])
    });
});
const $4a2a6fb115c84f19$var$iconPlaceholderStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4a2a6fb115c84f19$export$3a57d38764f05898 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _4t3if6fq _1bsb1nrf _bfhkizff",
            __cmplp.className
        ])
    });
});
const $4a2a6fb115c84f19$var$titlePlaceholderStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4a2a6fb115c84f19$export$bcafb2f622d94fc5 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _4t3i7vkz _1bsb19wn _bfhkizff",
            __cmplp.className
        ])
    });
});
const $4a2a6fb115c84f19$var$creatorAndSpacePlaceholderStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4a2a6fb115c84f19$export$1ad04d0e2f5bb038 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _4t3i1crf _1bsb1x1l _bfhkizff _19pkv77o",
            __cmplp.className
        ])
    });
});
const $4a2a6fb115c84f19$var$lastActionPlaceholderStyles = null;
const $4a2a6fb115c84f19$export$66fe4c20f5d2846f = (data, isShowingMore, firstPageSize = (0, $y9T5W.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH))=>{
    const recents = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))((data?.activity?.myActivity?.all?.edges || []).map((edge)=>edge?.node).map((node)=>(0, $ctLrB.transformActivityData)(node, true)).filter((0, $ctLrB.notEmpty)).filter((node)=>(0, $ctLrB.notEmpty)(node.object?.data)).filter((node)=>(0, $ctLrB.notArchived)(node.object?.data)).filter((node)=>(0, $ctLrB.notDeleted)(node.object?.data)), (node)=>node.object?.data?.id);
    if (isShowingMore) return recents;
    return recents.slice(0, firstPageSize);
};
const $4a2a6fb115c84f19$export$6caf97677f3b2063 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { shouldShowRightPanel: shouldShowRightPanel } = (0, $jYZYm.useRightPanelVisible)();
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isWhiteboardViewedEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');
    const isDatabaseEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const isSlidesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('slide');
    const { data: data, loading: loading, error: error } = (0, $77f51db044e9798b$export$4b7c4c3babb9aee3)({
        isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
        isDatabaseEnabled: isDatabaseEnabled,
        isSlidesEnabled: isSlidesEnabled,
        first: (0, $y9T5W.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH)
    });
    const recents = $4a2a6fb115c84f19$export$66fe4c20f5d2846f(data, false, (0, $y9T5W.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH));
    const onItemClick = (index, action, status, contentId, spaceKey, tenantId, objectType)=>{
        if (objectType === 'page') (0, $lXYVJ.setViewTransitionSource)((0, $1C3B1.RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK));
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'link',
                actionSubjectId: 'recentWorkItem',
                action: 'clicked',
                source: 'overviewScreen',
                attributes: {
                    platformCtx: 'recentWork',
                    destinationProduct: 'confluence',
                    destinationTenantId: tenantId,
                    destinationContainerType: 'space',
                    destinationContainerId: spaceKey,
                    destinationObjectType: objectType,
                    destinationObjectId: contentId,
                    pageLocation: 'home',
                    ranking: index,
                    navdexPointType: (0, $56QzY.START_TOUCH),
                    lastAction: action,
                    contentStatus: status
                }
            }
        }).fire();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'homeRecentWorkItem',
                action: 'clicked',
                source: 'overviewScreen',
                containerType: 'spaceKey',
                containerId: spaceKey,
                objectType: objectType,
                objectId: contentId,
                attributes: {
                    ranking: index,
                    navdexPointType: (0, $56QzY.START_TOUCH),
                    lastAction: action,
                    contentStatus: status
                }
            }
        }).fire();
    };
    const onItemSpaceClick = (index)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'homeRecentWorkItemSpace',
                action: 'clicked',
                source: 'overviewScreen',
                attributes: {
                    ranking: index,
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            }
        }).fire();
    };
    if (!loading && !recents.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rko1mok _19itia51 _ca0qutpp _bfhkhp5a"
        ]),
        "data-vc": "MZkrXsUb"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d6d562fa774e9838$export$723865f954913f68), null), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjygH.ExperienceStop), {
        name: (0, $irVI7.HOME_OVERVIEW_RECENT_EXPERIENCE),
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $gkVDU.HOME_OVERVIEW_RECENT_PAGE_SEGMENT)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...!loading && recents.length > 0 && {
            role: 'list'
        },
        className: (0, $gMc0m.default)([
            $4a2a6fb115c84f19$var$gridContainerStyles['default'],
            shouldShowRightPanel && $4a2a6fb115c84f19$var$gridContainerStyles['shouldShowRightPanel']
        ])
    }, loading && !recents.length ? new Array((0, $y9T5W.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH)).fill(0).map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            key: i,
            "data-testid": "item-placeholder",
            className: (0, $gMc0m.default)([
                "_1yt4g97w _1e0c1txw _4t3i1ady"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_2rkofajl _1bsb1tcg _4t3i1tcg _19pkv77o _2hwxdlk8 _bfhkizff"
            ])
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1e0c1txw _2lx21bp4 _16jlkb7n _1o9zkb7n _1bah1yb4 _1ul9uuw1 _2hwxutpp"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_2rkofajl _4t3if6fq _1bsb1nrf _bfhkizff"
            ])
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_2rkofajl _4t3i7vkz _1bsb19wn _bfhkizff"
            ])
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_2rkofajl _4t3i1crf _1bsb1x1l _bfhkizff _19pkv77o"
            ])
        }))) : recents.map((recent, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $05a91a1e1489ca6c$export$2ce63fa6fe9fb735), {
            key: recent.id,
            recent: recent,
            index: index,
            onItemClick: onItemClick,
            onItemSpaceClick: onItemSpaceClick,
            shouldAutofocus: index === (0, $y9T5W.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH)
        })), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjygH.ExperienceStop), {
        name: (0, $irVI7.HOME_OVERVIEW_RECENT_EXPERIENCE),
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $gkVDU.HOME_OVERVIEW_RECENT_PAGE_SEGMENT)
    })));
};


/* RecentListError.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $aQbeC = parcelRequire("aQbeC");


var $edxGF = parcelRequire("edxGF");


var $eZsGI = parcelRequire("eZsGI");

const $4bcc8da6462294cb$var$errorContainerStyles = null;
const $4bcc8da6462294cb$var$errorImageStyles = null;
const $4bcc8da6462294cb$export$3a789051d4f2a5b2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_ca0qzwfg _u5f3gktf _n3tdzwfg _19bvgktf _1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1osq"
        ]),
        "data-vc": "wEuliW2R"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eZsGI))),
        alt: "",
        className: (0, $gMc0m.default)([
            "_1bsb53f4 _4t3i1wug"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $edxGF.i18n).errorHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $edxGF.i18n).errorAction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aQbeC.ErrorDetail), null)));



















const $d5ea26583237ee93$export$24088281b62f310b = ()=>{
    const { isNewUser: isNewUser } = (0, $JCGnt.useIsNewUser)({
        activeDaysThreshold: 28
    }, !(0, $6mKj3.expValEquals)('cc-hide-pickup-where-you-left-off-exp', 'cohort', 'experiment'));
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isWhiteboardViewedEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');
    const isDatabaseEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const isSlidesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('slide');
    const { data: data, loading: loading } = (0, $77f51db044e9798b$export$4b7c4c3babb9aee3)({
        isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
        isDatabaseEnabled: isDatabaseEnabled,
        isSlidesEnabled: isSlidesEnabled,
        first: (0, $y9T5W.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH)
    });
    const recents = (0, $4a2a6fb115c84f19$export$66fe4c20f5d2846f)(data, false, (0, $y9T5W.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH));
    return !loading && !recents.length && isNewUser && (0, $6mKj3.expValEquals)('cc-hide-pickup-where-you-left-off-exp', 'cohort', 'experiment');
};


const $ebb5220839af7526$var$i18n = (0, $aXWIB.defineMessages)({
    homeTitle: {
        id: "home.title",
        defaultMessage: "Home"
    },
    forYouTitle: {
        id: "home.for-you.title",
        defaultMessage: "For you"
    },
    recentWork: {
        id: "home.views.overview.recent-work",
        defaultMessage: "Pick up where you left off"
    },
    calendarTitle: {
        id: "home.feed.calendar.title",
        defaultMessage: "Calendars"
    },
    announcementsTitle: {
        id: "home.feed.announcements.title",
        defaultMessage: "Announcements"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $ebb5220839af7526$var$OverviewContainer2 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isPostOfficeHomeBannerEligible: isPostOfficeHomeBannerEligible, shouldShowRightPanel: shouldShowRightPanel, isOnboardingExperienceEligible: isOnboardingExperienceEligible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _1e0c11p5 _rerrxy5q",
            __cmplp.isPostOfficeHomeBannerEligible ? "_2z0516ya" : "_2z05103a",
            __cmplp.shouldShowRightPanel ? "_yv0efkbj" : "_yv0e1o02",
            __cmplp.shouldShowRightPanel ? "_v5641ttt" : "_v564glyw",
            __cmplp.isOnboardingExperienceEligible ? "_t4mrkb7n" : "_t4mridpf",
            __cmplp.isPostOfficeHomeBannerEligible ? "_hm6pkb7n" : "_hm6pidpf",
            __cmplp.className
        ])
    });
});
const $ebb5220839af7526$var$recentContainerStyles = null;
const $ebb5220839af7526$var$bannerContainerStyles = null;
const $ebb5220839af7526$var$feedContainerStyles = null;
const $ebb5220839af7526$var$rightPanelContainerStyles = null;
const $ebb5220839af7526$var$recentHeaderStyles = null;
const $ebb5220839af7526$var$limitContainerStyles = null;
const $ebb5220839af7526$var$collectOverview = (events, experience)=>{
    const collection = [
        (0, $irVI7.FEED_EXPERIENCE),
        (0, $irVI7.HOME_OVERVIEW_RECENT_EXPERIENCE),
        (0, $irVI7.HOME_RIGHT_PANEL_APPS_EXPERIENCE)
    ];
    (0, $1A7bE.collectAll)(collection)(events, experience);
};
const $ebb5220839af7526$var$RecentHeader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _otyrpxbi"
        ]),
        "data-vc": "fzd2vnPs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $ebb5220839af7526$var$i18n.recentWork))); //previously called Overview or homeOverview
const $ebb5220839af7526$export$d6cf4bb669b36f29 = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const { onboardingTakeoverType: onboardingTakeoverType } = (0, $f869c0d94495260f$export$fa48385168985af8)();
    const { isTemplatesCollectionEligible: isTemplatesCollectionEligible } = (0, $i1Y90.useTemplatesCollectionEligible)();
    const { isEligible: isPostOfficeHomeBannerEligible } = (0, $5mBfb.usePostOfficeHomeBannerEligible)();
    const { shouldShowRightPanel: shouldShowRightPanel } = (0, $jYZYm.useRightPanelVisible)();
    const isEligibleForHideRecents = (0, $d5ea26583237ee93$export$24088281b62f310b)();
    const { panels: panels, loading: appsLoading, error: appsError } = (0, $dS3n9.useWebPanelLocation)({
        //no way to conditionally load this? Because hooks can't be conditional
        location: (0, $eSLr0.DASHBOARD_SECONDARY),
        fetchPolicy: 'cache-first'
    });
    const feedCustomWebSections = panels && panels.sort(({ weight: i }, { weight: j })=>i > j ? 1 : -1).map(({ html: html, completeKey: completeKey, label: label })=>completeKey.includes('team-calendars') ? {
            title: intl.formatMessage($ebb5220839af7526$var$i18n.calendarTitle),
            key: completeKey,
            icon: (0, $65ae8040b45ec07e$export$480e92afeb9f3ea1),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $33df235db03da5e3$export$39d78c94fb91ad03), {
                completeKey: completeKey,
                key: completeKey,
                noCollapse: true
            })
        } : {
            title: label,
            icon: undefined,
            key: completeKey,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqPSe.WebPanel), {
                html: html
            })
        }) || [];
    const feedCustomPanels = [
        {
            title: intl.formatMessage($ebb5220839af7526$var$i18n.announcementsTitle),
            key: 'confluence.home.announcements',
            // @ts-ignore TODO: fix the CustomPanel type to accept LoadableType icons
            icon: (0, $65ae8040b45ec07e$export$eaac0a9bd05d5448),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caf885298d603c5d$export$cae2a62921ed768b), {
                noCollapse: true
            })
        },
        // @ts-ignore TODO: fix the CustomPanel type to accept LoadableType icons
        ...feedCustomWebSections
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ebb5220839af7526$var$OverviewContainer2, {
        isOnboardingExperienceEligible: Boolean(onboardingTakeoverType || isTemplatesCollectionEligible // Only one of the two can show up at once, so we only need one styling variable
        ),
        isPostOfficeHomeBannerEligible: isPostOfficeHomeBannerEligible && (0, $9wGTI.fg)('post-office_enable-confluence-home-banner'),
        shouldShowRightPanel: shouldShowRightPanel,
        "data-testid": "home_overview"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lt6Lx.DocumentContentTitle), {
        titlePrefix: intl.formatMessage($ebb5220839af7526$var$i18n.forYouTitle),
        isHomePage: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.HOME_OVERVIEW_EXPERIENCE),
        collect: $ebb5220839af7526$var$collectOverview
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.HOME_OVERVIEW_RECENT_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).HOME
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "banners"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $64913c7d2c985501$export$addeb901e1836ce1), {
        onboardingTakeoverType: onboardingTakeoverType,
        isTemplatesCollectionEligible: isTemplatesCollectionEligible
    }), !(isEligibleForHideRecents && (0, $6mKj3.expValEquals)('cc-hide-pickup-where-you-left-off-exp', 'cohort', 'experiment')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_yyhy6s8z _1ii7udd8 _kqswh2mm _19pkidpf _otyr1ejb"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metric: (0, $gkVDU.HOME_OVERVIEW_RECENT_PAGE_SEGMENT)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ebb5220839af7526$var$RecentHeader, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO,
        renderOnError: (0, $4bcc8da6462294cb$export$3a789051d4f2a5b2)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4a2a6fb115c84f19$export$6caf97677f3b2063), null)))), isPostOfficeHomeBannerEligible && (0, $9wGTI.fg)('post-office_enable-confluence-home-banner') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_yyhy6s8z _1ii7ceoy"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4Cx0V.PostOfficeHomeBanner), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "feed-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_yyhy6s8z _1ii712he"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metric: (0, $bxcP5.HOME_OVERVIEW_FEED_PAGE_SEGMENT)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.FEED_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.HOME_RIGHT_PANEL_APPS_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kLaAt.Feed), {
        renderPopularFeed: true,
        customPanels: feedCustomPanels
    }), !appsLoading && !appsError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.HOME_RIGHT_PANEL_APPS_EXPERIENCE)
    }) : null)), shouldShowRightPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_v564cwog _yyhycs5v _19pk11k5 _p3z3kb7n _1891egat _1ul91mjv"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metric: (0, $gkVDU.HOME_OVERVIEW_RIGHT_PANEL_PAGE_SEGMENT)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6a570c156dcdbd2e$export$364a989a35814102), {
        widthMode: "fullwidth"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "automation-limit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rko12b0 _kqsw1n9t _1ltv1epz _1pbytyoy _94n51epz _16qs130s"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f8c0187a09ac9108$export$76c223fce296f63d), null))));
};
module.exports["ForYou"] = $ebb5220839af7526$export$d6cf4bb669b36f29;

});

parcelRegister("ivb8S", function(module, exports) {

var $209pV = parcelRequire("209pV");


var $42omo = parcelRequire("42omo");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $cbOce = parcelRequire("cbOce");


var $1cHqV = parcelRequire("1cHqV");


var $8Z78B = parcelRequire("8Z78B");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");

const $6fc4b7bb962289cc$var$isOnboardingStateEqual = (a, b)=>{
    if (a === b) return true;
    if (!a || !b) return !a && !b;
    if (a.length !== b.length) return false;
    return a.every((item, i)=>item.key === b[i].key && item.value === b[i].value);
};
// Hook to check if we're on a view page route
const $6fc4b7bb962289cc$var$useIsViewPageRoute = ()=>(0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.VIEW_PAGE).name || routeName === (0, $1NBp8.VIEW_BLOG).name || routeName === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name
    });
// Get the combined onboarding state from cache, returns null if not cached
const $6fc4b7bb962289cc$var$getCombinedQueryFromCache = ()=>{
    try {
        return (0, $l1uFv.readQueryInterop)({
            query: (0, $8Z78B.default),
            variables: {
                key: []
            },
            __callerPackage__: "@confluence/onboarding-helpers"
        });
    } catch  {
        return null;
    }
};
// Updates the combined query cache with new onboarding state values.
// This ensures components using the centralized cache see updates on next mount/navigation.
const $6fc4b7bb962289cc$var$updateCombinedQueryCache = (updatedStates)=>{
    if (!(0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false)) return;
    const currentData = $6fc4b7bb962289cc$var$getCombinedQueryFromCache();
    if (!currentData?.onboardingState) return;
    const updatedMap = new Map(updatedStates.map((s)=>[
            s.key,
            s.value
        ]));
    const newOnboardingState = currentData.onboardingState.map((item)=>updatedMap.has(item.key) ? {
            ...item,
            value: updatedMap.get(item.key) ?? item.value
        } : item);
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $8Z78B.default),
        variables: {
            key: []
        },
        data: {
            onboardingState: newOnboardingState
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) for (const { key: key, value: value } of onboardingState){
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) continue;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    }
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $308Wd.useMutationInterop)((0, $209pV.default), {
        update (_cache, { data: data }) {
            const states = data.setOnboardingState;
            (states ?? []).forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                (0, $ij4CE.writeFragmentInterop)({
                    fragmentId: `OnboardingState:${key}`,
                    data: {
                        key: key,
                        value: value ?? null,
                        __typename: 'OnboardingState'
                    }
                });
            });
            // Update the combined query cache for centralized onboarding state
            $6fc4b7bb962289cc$var$updateCombinedQueryCache(states ?? []);
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
    const setOnboardingState = (0, $42omo.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false, reactive = true)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const isViewPageRoute = $6fc4b7bb962289cc$var$useIsViewPageRoute();
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    // Check if centralized cache should be used (experiment enabled + on view page route)
    const useCentralizedCache = isViewPageRoute && (0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false);
    // For non-reactive mode: read from cache once (no subscription)
    // This is a one-time synchronous read that doesn't trigger re-renders on cache changes
    const cachedCombinedData = !reactive && useCentralizedCache ? $6fc4b7bb962289cc$var$getCombinedQueryFromCache() : null;
    const hasCachedCombinedData = cachedCombinedData !== null;
    // For reactive mode: use useQueryInterop with cache-only to subscribe to cache changes
    // This subscribes to the centralized cache and re-renders when it changes (no network requests)
    const { data: reactiveCacheData, error: reactiveCacheError, loading: reactiveCacheLoading } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: []
        },
        skip: skipQuery || !reactive || !useCentralizedCache,
        fetchPolicy: 'cache-only',
        __callerPackage__: "@confluence/onboarding-helpers"
    });
    // Memoize the filtered reactive cache result so filterOnboardingState is only called
    // when reactiveCacheData or key actually changes — not on every render.
    //
    // We must not skip the fallback just because reactiveCacheData is truthy — the centralized
    // cache may not contain the specific keys this consumer requested (e.g. the preload fetched
    // a different set of keys). We only skip the fallback when the filtered reactive cache data
    // actually has entries for the requested keys.
    const { reactiveFilteredData: reactiveFilteredData, reactiveFilteredHasData: reactiveFilteredHasData } = (0, $42omo.useMemo)(()=>{
        if (!(reactive && useCentralizedCache && reactiveCacheData)) return {
            reactiveFilteredData: null,
            reactiveFilteredHasData: false
        };
        const filtered = (0, $1cHqV.filterOnboardingState)(reactiveCacheData, key);
        return {
            reactiveFilteredData: filtered,
            reactiveFilteredHasData: (filtered?.onboardingState?.length ?? 0) > 0
        };
    }, [
        reactive,
        useCentralizedCache,
        reactiveCacheData,
        key
    ]);
    const { data: fallbackQueryData, error: fallbackError, loading: fallbackLoading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: key
        },
        skip: skipQuery || hasCachedCombinedData || reactiveFilteredHasData,
        __callerPackage__: "@confluence/onboarding-helpers"
    });
    // Determine which data source to use:
    // 1. Non-reactive with cached data: use cachedCombinedData (filtered)
    // 2. Reactive with centralized cache and keys found: use reactiveFilteredData
    // 3. Fallback: use fallbackQueryData
    // For reactive path: skip re-render if filtered data for our keys hasn't changed
    const prevFilteredDataRef = (0, $42omo.useRef)(undefined);
    const data = (0, $42omo.useMemo)(()=>{
        if (hasCachedCombinedData) return (0, $1cHqV.filterOnboardingState)(cachedCombinedData, key);
        if (reactiveFilteredHasData && reactiveFilteredData) {
            if (prevFilteredDataRef.current && $6fc4b7bb962289cc$var$isOnboardingStateEqual(prevFilteredDataRef.current.onboardingState, reactiveFilteredData.onboardingState)) return prevFilteredDataRef.current;
            prevFilteredDataRef.current = reactiveFilteredData;
            return reactiveFilteredData;
        }
        return fallbackQueryData;
    }, [
        hasCachedCombinedData,
        cachedCombinedData,
        reactiveFilteredHasData,
        reactiveFilteredData,
        fallbackQueryData,
        key
    ]);
    // Combine error and loading states from both queries
    const error = reactiveCacheError || fallbackError;
    // When centralized cache is enabled in reactive mode but the preload hasn't populated
    // the cache yet, cache-only returns loading: false with data: undefined. Without this
    // guard, consumers interpret undefined data as "user never saw this onboarding" and
    // incorrectly show spotlights/changeboarding that was already dismissed.
    // We report loading: true until either the reactive cache or fallback has actual data.
    //
    // Also guard the case where the reactive cache is populated but doesn't contain the
    // specific keys this consumer requested (reactiveFilteredHasData is false). In that
    // scenario the fallback query has been allowed to run — keep loading: true until it
    // either returns data or an error, so consumers don't prematurely see empty state.
    const isCentralizedCacheWaitingForPreload = reactive && useCentralizedCache && (!reactiveCacheData || !reactiveFilteredHasData) && !fallbackQueryData && !skipQuery && !reactiveCacheError && !fallbackError;
    const loading = isCentralizedCacheWaitingForPreload || (reactive && useCentralizedCache ? reactiveCacheLoading : false) || fallbackLoading;
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("209pV", function(module, exports) {
/**
 * @generated SignedSource<<c53781d55d04bcd0c7414229d1ce8a1a>>
 * @relayHash 3faa5f50f8c511a1bae008881ee58062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed
const $4f605ad876f6c5d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "states"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "states",
                    "variableName": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3faa5f50f8c511a1bae008881ee58062",
            "id": "1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed",
            "metadata": {},
            "name": "onboardingStateSetOnboardingStateMutation",
            "operationKind": "mutation",
            "text": "mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
        }
    };
}();
$4f605ad876f6c5d9$var$node.hash = "90b0af82da00eefb44f28228419e7c9e";
var $4f605ad876f6c5d9$export$2e2bcd8739ae039 = $4f605ad876f6c5d9$var$node;
module.exports["default"] = $4f605ad876f6c5d9$export$2e2bcd8739ae039;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("l1uFv", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $bFdYQ = parcelRequire("bFdYQ");

function $65c7b8940c778902$export$627cb922211284f(params) {
    const source = (0, $iffSy.isRelayEnabled)(params.__callerPackage__) ? 'relay' : 'apollo';
    return (0, $bFdYQ.readQueryWithCacheBridgeFallback)({
        source: source,
        query: params.query,
        variables: params.variables,
        readOriginal: ()=>$65c7b8940c778902$var$readQueryInteropOriginal(params, source)
    });
}
function $65c7b8940c778902$var$readQueryInteropOriginal(params, source) {
    return source === 'relay' ? $65c7b8940c778902$var$readQueryInteropRelay(params) : $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropRelay(params) {
    // Guard window for SSR; this only runs client-side.
    const relayEnv = typeof window !== 'undefined' ? window.GLOBAL_RELAY_ENV : undefined;
    if (!relayEnv) return null;
    const source = relayEnv.getStore().getSource();
    const rootRecord = source.get((0, $3e6Uc.ROOT_ID));
    if (!rootRecord) return null;
    const queryNode = params.query;
    const queryFields = queryNode?.operation?.selections;
    if (!queryFields) return null;
    const variables = params.variables ?? {};
    return $65c7b8940c778902$var$readFields(source, (0, $3e6Uc.ROOT_ID), queryFields, variables);
}
function $65c7b8940c778902$var$resolveArgValue(arg, variables) {
    if (arg.kind === 'Literal') return arg.value;
    if (arg.kind === 'Variable') return variables[arg.variableName];
    // Fallback for other argument types
    return arg.value;
}
function $65c7b8940c778902$var$getFieldKey(field, variables) {
    // Relay pre-computes `storageKey` for literal-only args; prefer it when present.
    if (field.storageKey) return field.storageKey;
    if (!field.args || field.args.length === 0) return field.name;
    // Mirror Relay's `formatStorageKey` (relay-runtime/store/RelayStoreUtils): sort args
    // alphabetically and omit any with a null/undefined value. Skipping the omission would
    // reconstruct a key Relay never wrote (e.g. `teamType:null`), so the lookup misses and
    // the field reads back as `null`.
    const sortedArgs = field.args.slice().sort((a, b)=>a.name.localeCompare(b.name));
    const formattedArgs = [];
    for (const arg of sortedArgs){
        const value = $65c7b8940c778902$var$resolveArgValue(arg, variables);
        if (value != null) formattedArgs.push(`${arg.name}:${JSON.stringify(value)}`);
    }
    return formattedArgs.length === 0 ? field.name : `${field.name}(${formattedArgs.join(',')})`;
}
/* eslint-disable @atlassian/perf-linting/no-quadratic-complexity */ function $65c7b8940c778902$var$readFields(source, recordId, fields, variables) {
    const record = source.get(recordId);
    if (!record) return null;
    const data = {};
    for (const field of fields){
        if (field.kind === 'Condition') {
            // Handle @include/@skip directives with variables
            const conditionValue = variables[field.condition];
            const shouldInclude = field.passingValue ? conditionValue : !conditionValue;
            if (shouldInclude) {
                const conditionalData = $65c7b8940c778902$var$readFields(source, recordId, field.selections, variables);
                if (conditionalData) Object.assign(data, conditionalData);
            }
        } else if (field.kind === 'LinkedField') {
            const linkedField = field;
            const fieldKey = $65c7b8940c778902$var$getFieldKey(linkedField, variables);
            const linkedRef = record[fieldKey];
            if (linkedField.plural) {
                // Relay stores plural refs in two shapes:
                //  - canonical: { __refs: ['id1', 'id2', ...] }
                //  - tolerated: [{ __ref: 'id1' }, { __ref: 'id2' }]
                if (linkedRef && typeof linkedRef === 'object' && !Array.isArray(linkedRef) && Array.isArray(linkedRef.__refs)) {
                    const refs = linkedRef.__refs;
                    data[linkedField.name] = refs.map((id)=>id ? $65c7b8940c778902$var$readFields(source, id, linkedField.selections, variables) : null);
                } else if (Array.isArray(linkedRef)) data[linkedField.name] = linkedRef.map((ref)=>{
                    if (ref && typeof ref === 'object' && '__ref' in ref) return $65c7b8940c778902$var$readFields(source, ref.__ref, linkedField.selections, variables);
                    return null;
                });
                else data[linkedField.name] = null;
            } else if (linkedRef && typeof linkedRef === 'object' && '__ref' in linkedRef) data[linkedField.name] = $65c7b8940c778902$var$readFields(source, linkedRef.__ref, linkedField.selections, variables);
            else data[linkedField.name] = null;
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            const fieldKey = $65c7b8940c778902$var$getFieldKey(scalarField, variables);
            data[scalarField.name] = record[fieldKey];
        } else if (field.kind === 'InlineFragment') {
            // Process all inline fragment selections
            const inlineData = $65c7b8940c778902$var$readFields(source, recordId, field.selections, variables);
            if (inlineData) Object.assign(data, inlineData);
        }
    // Other selection kinds (e.g., FragmentSpread, ClientExtension) are ignored —
    // readQuery only needs to traverse what the query operation directly selects.
    }
    return data;
}
/* eslint-enable @atlassian/perf-linting/no-quadratic-complexity */ function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("cbOce", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("1cHqV", function(module, exports) {
// Cache for filtered onboarding state results.
// Uses WeakMap keyed by data object (auto-clears when data is garbage collected),
// with nested Map keyed by keys string for O(1) lookup.
const $e7b7b792910c4288$var$filteredStateCache = new WeakMap();
/**
 * Creates a cache key from the requested keys.
 */ const $e7b7b792910c4288$var$createCacheKey = (keys)=>{
    return Array.isArray(keys) ? keys.join(',') : keys;
};
/**
 * Performs the actual filtering of onboarding state data.
 */ const $e7b7b792910c4288$var$filterData = (data, requestedKeys)=>{
    const keysArray = Array.isArray(requestedKeys) ? requestedKeys : [
        requestedKeys
    ];
    const keySet = new Set(keysArray);
    return {
        ...data,
        onboardingState: data.onboardingState?.filter(({ key: key })=>{
            // Check both the full key and the parsed key (without prefix)
            // Keys come back as "{prefix}:{property}" format
            const parsedKey = key.split(':')[1] || key;
            return keySet.has(key) || keySet.has(parsedKey);
        })
    };
};
const $e7b7b792910c4288$export$c1dd389f39afa62f = (data, requestedKeys)=>{
    if (!data?.onboardingState) // Convert null to undefined to maintain backward compatibility with consumers
    // that expect `T | undefined` rather than `T | null | undefined`
    return data ?? undefined;
    const cacheKey = $e7b7b792910c4288$var$createCacheKey(requestedKeys);
    let dataCache = $e7b7b792910c4288$var$filteredStateCache.get(data);
    if (!dataCache) {
        dataCache = new Map();
        $e7b7b792910c4288$var$filteredStateCache.set(data, dataCache);
    }
    if (dataCache.has(cacheKey)) return dataCache.get(cacheKey);
    const filteredResult = $e7b7b792910c4288$var$filterData(data, requestedKeys);
    dataCache.set(cacheKey, filteredResult);
    return filteredResult;
};
module.exports["filterOnboardingState"] = $e7b7b792910c4288$export$c1dd389f39afa62f;

});

parcelRegister("8Z78B", function(module, exports) {
/**
 * @generated SignedSource<<abe1bfe242e74d4385961078bad185f8>>
 * @relayHash 56e1784a86c45537dbf4ab9c8bb1ffba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7
const $38160060fa19c5ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "56e1784a86c45537dbf4ab9c8bb1ffba",
            "id": "3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7",
            "metadata": {},
            "name": "onboardingStateGetOnboardingStateQuery",
            "operationKind": "query",
            "text": "query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key,value}}"
        }
    };
}();
$38160060fa19c5ea$var$node.hash = "201bff99b2bdca3d23c658876502ced3";
var $38160060fa19c5ea$export$2e2bcd8739ae039 = $38160060fa19c5ea$var$node;
module.exports["default"] = $38160060fa19c5ea$export$2e2bcd8739ae039;

});

parcelRegister("dBcar", function(module, exports) {
const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$c4e14780cf349e73 = 'xflowSpaceCreated';
const $3c94963df51c0e13$export$275d3dda87d2fa7a = 'nthUserOnboardingCompletedTimestamp';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$f6c79e39ab4496db = 'templateOnboardingViewedTime';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$4d93dfc1d8538d55 = 'nav4:isNav4CollapseReminderSpotlightDismissed';
const $3c94963df51c0e13$export$94a4264abda026cc = 'creation-focused-nav:shouldShowSpotlight';
const $3c94963df51c0e13$export$f0597adb063e4c38 = 'creation-focused-nav:startTime';
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$6c014427ebb0cbae = {
    HAS_SEEN_SPLASH_MODAL: 'create-with-rovo-announcement-splash:hasSeenSplashModal'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$5b471e2344a37be7 = {
    DISMISSED: 'prompt-database-competitor-link:isPromptDatabaseDismissed'
};
const $3c94963df51c0e13$export$c81223a0ce3b63df = {
    HAS_AUTO_FOLLOWED_SPACES: 'nth-user-auto-follow-spaces:hasAutoFollowedSpaces'
};
const $3c94963df51c0e13$export$f1328b04dc902e1f = {
    REVAMPED_BPQA_SHOWN_AT: 'land-users-in-editor-with-revamped-bpqa:revampedBpqaShownAt'
};
const $3c94963df51c0e13$export$e986b94fd54d134 = {
    SELECTED_TEMPLATES: 'use-cases-nth-user-onboarding:selectedTemplates',
    VIEWED_AT: 'use-cases-nth-user-onboarding:viewedAt',
    DISMISSED_HEADER: 'use-cases-nth-user-onboarding:headerDismissed',
    VIEWED_HEADER: 'use-cases-nth-user-onboarding:headerViewedAt'
};
const $3c94963df51c0e13$export$bbdc3607431bd9d3 = {
    EMOJI_TITLE_DISCOVERED: 'auto-page-emoji:emojiTitleDiscovered'
};
const $3c94963df51c0e13$export$31a43870c77aad50 = {
    NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE: 'simplify-nav-new-user:nthUserD0SimplifiedNavEligible',
    NTH_USER_D0_SIMPLIFIED_NAV_START_AT: 'simplify-nav-new-user:nthUserD0SimplifiedNavStartAt'
};
const $3c94963df51c0e13$export$400b215814bf3fc0 = {
    CHECKED_ELIGIBLE: 'creation-focused-nav-xflow:creationFocusedNavXflowCheckedEligible',
    START_AT: 'creation-focused-nav-xflow:creationFocusedNavXflowStartAt'
};
const $3c94963df51c0e13$export$94df39cf9e5d9804 = {
    TRENDING_PAGES: 'cross-join-nth-user-onboarding:trendingPages',
    DISMISSED: 'cross-join-nth-user-onboarding:dismissed'
};
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    XFLOW_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$c4e14780cf349e73}`,
    TEMPLATE_ONBOARDING_VIEWED_TIME: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$f6c79e39ab4496db}`,
    NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$275d3dda87d2fa7a}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const { LEGACY_ONBOARDING_STATE: $3c94963df51c0e13$export$66aa87593037fd4a } = $3c94963df51c0e13$export$bfeb2da96277b623;
const $3c94963df51c0e13$export$d4f5dd2b883b8982 = [
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    $3c94963df51c0e13$export$31a43870c77aad50.NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE,
    $3c94963df51c0e13$export$31a43870c77aad50.NTH_USER_D0_SIMPLIFIED_NAV_START_AT
];
const $3c94963df51c0e13$export$7a13c575f2c75084 = [
    ...Object.values($3c94963df51c0e13$export$49ac0bbeb4be0a06),
    ...Object.values($3c94963df51c0e13$export$6167e5b70dfd11d9),
    ...Object.values($3c94963df51c0e13$export$49c044e5e3ccc2af),
    ...Object.values($3c94963df51c0e13$export$dcbccfe8799c3c7b),
    ...Object.values($3c94963df51c0e13$export$305c55ea55928edf),
    $3c94963df51c0e13$export$b99b309b286adebc,
    $3c94963df51c0e13$export$20b0548cf5859d6,
    $3c94963df51c0e13$export$4d93dfc1d8538d55,
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    ...Object.values($3c94963df51c0e13$export$7ed75560092630f6),
    ...Object.values($3c94963df51c0e13$export$6c014427ebb0cbae),
    ...Object.values($3c94963df51c0e13$export$d1ec748fb682ca97),
    ...Object.values($3c94963df51c0e13$export$1a3a43cef0acd011),
    ...Object.values($3c94963df51c0e13$export$5b471e2344a37be7),
    ...Object.values($3c94963df51c0e13$export$bfeb2da96277b623),
    ...Object.values($3c94963df51c0e13$export$c81223a0ce3b63df),
    ...Object.values($3c94963df51c0e13$export$f1328b04dc902e1f),
    ...Object.values($3c94963df51c0e13$export$e986b94fd54d134),
    ...Object.values($3c94963df51c0e13$export$bbdc3607431bd9d3),
    ...Object.values($3c94963df51c0e13$export$31a43870c77aad50),
    ...Object.values($3c94963df51c0e13$export$400b215814bf3fc0),
    ...Object.values($3c94963df51c0e13$export$94df39cf9e5d9804)
];
module.exports["ONBOARDING_INTENT_EXPERIENCES"] = $3c94963df51c0e13$export$49ac0bbeb4be0a06;
module.exports["TEMPLATES_COLLECTION"] = $3c94963df51c0e13$export$49c044e5e3ccc2af;
module.exports["IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED"] = $3c94963df51c0e13$export$4d93dfc1d8538d55;
module.exports["CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT"] = $3c94963df51c0e13$export$94a4264abda026cc;
module.exports["CREATION_FOCUSED_NAV_START_TIME"] = $3c94963df51c0e13$export$f0597adb063e4c38;
module.exports["CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH"] = $3c94963df51c0e13$export$6c014427ebb0cbae;
module.exports["NTH_USER_SETUP_CONTENT_TYPE"] = $3c94963df51c0e13$export$d1ec748fb682ca97;
module.exports["PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED"] = $3c94963df51c0e13$export$1a3a43cef0acd011;
module.exports["PROMPT_DATABASE_COMPETITOR_LINK"] = $3c94963df51c0e13$export$5b471e2344a37be7;
module.exports["NTH_USER_AUTO_FOLLOW_SPACES"] = $3c94963df51c0e13$export$c81223a0ce3b63df;
module.exports["LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA"] = $3c94963df51c0e13$export$f1328b04dc902e1f;
module.exports["USE_CASES_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$e986b94fd54d134;
module.exports["NTH_USER_EMOJI_TITLE_DISCOVERED"] = $3c94963df51c0e13$export$bbdc3607431bd9d3;
module.exports["SIMPLIFY_NAV_NEW_USER"] = $3c94963df51c0e13$export$31a43870c77aad50;
module.exports["CFIND_5565_CREATION_FOCUSED_NAV_XFLOW"] = $3c94963df51c0e13$export$400b215814bf3fc0;
module.exports["CROSS_JOIN_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$94df39cf9e5d9804;
module.exports["ONBOARDING_EXPERIENCES"] = $3c94963df51c0e13$export$bfeb2da96277b623;
module.exports["COMPLETE"] = $3c94963df51c0e13$export$1660a2d7c2fff354;
module.exports["NAV_EXPERIMENT_ONBOARDING_KEYS"] = $3c94963df51c0e13$export$d4f5dd2b883b8982;
module.exports["OnboardingKeys"] = $3c94963df51c0e13$export$7a13c575f2c75084;

});

parcelRegister("1gy7x", function(module, exports) {
const $071869849092e495$export$d8593f7ef284bfd8 = {
    onboardingActionStates: 'personalized-templates-v2:onboardingActionStates',
    hasDismissedOnboardingActions: 'personalized-templates-v2:hasDismissedOnboardingActions',
    takeoverSeenAt: 'personalized-templates-v2:takeoverSeenAt',
    isTemplateListDismissed: 'personalized-templates-v2:isTemplateListDismissed',
    templateUsageValues: 'personalized-templates-v2:templateUsageValues'
};
const $071869849092e495$export$67c979693bf8551b = [
    ...Object.values($071869849092e495$export$d8593f7ef284bfd8)
];
module.exports["PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS"] = $071869849092e495$export$d8593f7ef284bfd8;
module.exports["PersonalizedTemplatesOnboardingKeys"] = $071869849092e495$export$67c979693bf8551b;

});

parcelRegister("2FNNv", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");

// Production trait: https://data-portal.internal.atlassian.com/targeting/traits/f0c5d949-91be-46e0-b440-7d7a953c9159
const $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME = 'confluence_is_established_user';
// Staging trait: https://data-portal-stg.internal.atlassian.com/targeting/traits/4015e85e-221b-4d95-a945-c68548e21a8b
// NOTE: DO NOT USE Staging trait named as `confluence_is_established_user` - this is a legacy trait created with wrong evaluation type and won't work for staging
const $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME_STAGING = 'confluence_is_established_user_stg';
const $f30477d177bb95bd$export$a284916a4d5ed017 = ()=>{
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    if (environment !== 'PRODUCTION') return $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME_STAGING;
    return $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME;
};
module.exports["useIsEstablishedUserTraitName"] = $f30477d177bb95bd$export$a284916a4d5ed017;

});

parcelRegister("7c4rV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $5a7a73b748300e1f$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $5a7a73b748300e1f$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $5a7a73b748300e1f$export$9bcfef244f363dbe = (0, $1P1Tu.createStore)({
    initialState: $5a7a73b748300e1f$var$initialState,
    actions: $5a7a73b748300e1f$var$actions,
    name: 'atlassianAccountTraitsStore'
});
const $5a7a73b748300e1f$export$c35c4239c4894215 = (0, $9zUhf.createHook)($5a7a73b748300e1f$export$9bcfef244f363dbe);
const $5a7a73b748300e1f$export$aa4cdf7390fbf455 = (0, $9zUhf.createActionsHook)($5a7a73b748300e1f$export$9bcfef244f363dbe);
async function $5a7a73b748300e1f$var$fetchAtlassianAccountTraitsData(userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $5a7a73b748300e1f$var$hasFetched = false;
function $5a7a73b748300e1f$export$f1fbc6ad89f91b89() {
    $5a7a73b748300e1f$var$hasFetched = false;
}
function $5a7a73b748300e1f$var$getAtlassianAccountTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.user);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.user);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $5a7a73b748300e1f$export$88411c3a679154ab({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $42omo.useMemo)(()=>$5a7a73b748300e1f$var$getAtlassianAccountTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $5a7a73b748300e1f$export$c35c4239c4894215();
    const { accessStatus: accessStatus, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $42omo.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($5a7a73b748300e1f$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !userId) return;
        $5a7a73b748300e1f$var$hasFetched = true;
        storeActions.start();
        $5a7a73b748300e1f$var$fetchAtlassianAccountTraitsData(userId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        userId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useAtlassianAccountTraits"] = $5a7a73b748300e1f$export$88411c3a679154ab;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("95rLf", function(module, exports) {
const $4470315d103298df$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4470315d103298df$var$isExpectedGraphqlError);
    return false;
};
const $4470315d103298df$var$isExpectedGraphqlError = (error)=>{
    return $4470315d103298df$export$6ce1d41e4cf63857(error) || $4470315d103298df$export$33c833057c8824dc(error) || $4470315d103298df$export$76a44867d527fcf4(error) || $4470315d103298df$export$fd9ba55aefe8e8a5(error);
};
const $4470315d103298df$export$6ce1d41e4cf63857 = (error)=>{
    return error.message?.includes('Space not found');
};
const $4470315d103298df$export$fd9ba55aefe8e8a5 = (error)=>{
    return error.message?.includes('Cannot find space with id:');
};
const $4470315d103298df$export$33c833057c8824dc = (error)=>{
    return error.message?.includes('Not permitted to view space with id:');
};
const $4470315d103298df$export$76a44867d527fcf4 = (error)=>{
    return error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4470315d103298df$export$288e4801a340fb3c;

});

parcelRegister("eyUJP", function(module, exports) {
const $37b72543ace58c19$export$a266d7c13575e674 = {
    onboardingActionStates: 'nth-user-home-onboarding-revamp:onboardingActionStates',
    areAllActionsDismissed: 'nth-user-home-onboarding-revamp:areAllActionsDismissed',
    takeoverSeenAt: 'nth-user-home-onboarding-revamp:takeoverSeenAt',
    isTemplateListDismissed: 'nth-user-home-onboarding-revamp:isTemplateListDismissed',
    templateUsageValues: 'nth-user-home-onboarding-revamp:templateUsageValues'
};
const $37b72543ace58c19$export$f9348e90ce13bd50 = [
    ...Object.values($37b72543ace58c19$export$a266d7c13575e674)
];
module.exports["NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS"] = $37b72543ace58c19$export$a266d7c13575e674;
module.exports["NthUserHomeOnboardingRevampKeys"] = $37b72543ace58c19$export$f9348e90ce13bd50;

});

parcelRegister("JCGnt", function(module, exports) {

var $6vgLy = parcelRequire("6vgLy");


var $f7MuR = parcelRequire("f7MuR");

const $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $affa2edf03b5b535$export$750d18e9348a361a = ({ activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate }, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const confluenceFirstActive = data?.attributes?.find(({ name: name })=>name === $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { isNewlyCreatedUser: isNewlyCreatedUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return {
        isNewUser: null,
        loading: true
    };
    if (error) return {
        isNewUser: null,
        error: error
    };
    return {
        isNewUser: isNewlyCreatedUser,
        loading: false,
        error: null
    };
};
module.exports["useIsNewUser"] = $affa2edf03b5b535$export$750d18e9348a361a;

});

parcelRegister("6vgLy", function(module, exports) {

var $922yL = parcelRequire("922yL");

var $e0SBo = parcelRequire("e0SBo");

var $cFEpk = parcelRequire("cFEpk");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, we cannot determine if user is new
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: null,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $e0SBo.default)((0, $922yL.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $cFEpk.default)(cutoffDate) ? (0, $e0SBo.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("922yL", function(module, exports) {
$parcel$export(module.exports, "default", () => $6936494635ea8bcb$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $6936494635ea8bcb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("e0SBo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a33b6ba3d9a58f3b$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $a33b6ba3d9a58f3b$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("f7MuR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $1P1Tu.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $9zUhf.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $9zUhf.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skip: skip, skipBootstrap: skipBootstrap, fetchPolicy: fetchPolicy = 'cache-first' } = {}) {
    // skip=true -> full idle, no preload/store/fetch
    const preloadedData = (0, $42omo.useMemo)(()=>skip ? null : $26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), [
        skip
    ]);
    const [storeState, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    // Track whether cache-and-network fetch dispatched this mount
    const fetchDispatchedRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        if (!cloudId || !userId) return;
        if (skipBootstrap) return;
        if (!hasLicensedAccess) return;
        if (fetchPolicy === 'cache-first') {
            // Old behavior: don't fetch if we have data from any source
            if (preloadedData || storeState.data || storeState.loading || storeState.error) return;
            if ($26d702ce000cc6e9$var$hasFetched) return;
            $26d702ce000cc6e9$var$hasFetched = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        } else {
            // cache-and-network: fetch once per mount
            if (storeState.loading) {
                fetchDispatchedRef.current = true;
                return;
            }
            if (fetchDispatchedRef.current) return;
            fetchDispatchedRef.current = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        }
    }, [
        skip,
        skipBootstrap,
        fetchPolicy,
        cloudId,
        userId,
        hasLicensedAccess,
        preloadedData,
        storeState,
        storeActions
    ]);
    if (skip) return {
        data: null,
        loading: false,
        error: null
    };
    // Fetched store result wins over preloaded data
    if (storeState.data) return {
        data: storeState.data,
        loading: storeState.loading,
        error: storeState.error
    };
    if (preloadedData) return {
        data: preloadedData,
        loading: storeState.loading,
        error: null
    };
    return {
        data: null,
        loading: storeState.loading,
        error: storeState.error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("c8Y4F", function(module, exports) {
/**
 * @generated SignedSource<<72780697d815ba0b47ba06abfcdb06a9>>
 * @relayHash 54a5106deb8051638f67e17262ef90b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ae8f1aadd164d1b501e16f6020a287594e642feab79c3afc381daad3acbf576
const $a939e7843212ec9f$var$node = function() {
    var v0 = [
        {
            "concreteType": "License",
            "kind": "LinkedField",
            "name": "license",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "licenseConsumingUserCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "54a5106deb8051638f67e17262ef90b5",
            "id": "1ae8f1aadd164d1b501e16f6020a287594e642feab79c3afc381daad3acbf576",
            "metadata": {},
            "name": "useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
            "operationKind": "query",
            "text": "query useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery{license{licenseConsumingUserCount}}"
        }
    };
}();
$a939e7843212ec9f$var$node.hash = "eaf07b0d0888b09c16c5bc48d9bf826d";
var $a939e7843212ec9f$export$2e2bcd8739ae039 = $a939e7843212ec9f$var$node;
module.exports["default"] = $a939e7843212ec9f$export$2e2bcd8739ae039;

});

parcelRegister("lvvx5", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa84f3f15ff2b5dc$export$2e2bcd8739ae039);

var $917iu = parcelRequire("917iu");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $fa84f3f15ff2b5dc$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $917iu.default)(dateLeft, dateRight) / 7;
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("fls5L", function(module, exports) {
var $b2be9bac2e487919$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $b2be9bac2e487919$var$defaultRoundingMethod = 'trunc';
function $b2be9bac2e487919$export$b6474a47258c1211(method) {
    return method ? $b2be9bac2e487919$var$roundingMap[method] : $b2be9bac2e487919$var$roundingMap[$b2be9bac2e487919$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $b2be9bac2e487919$export$b6474a47258c1211;

});

parcelRegister("cTaz1", function(module, exports) {
$parcel$export(module.exports, "default", () => $9622d0df3fc5e743$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $9622d0df3fc5e743$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    return (0, $egXhZ.default)(dirtyDate).getTime() > Date.now();
}

});

parcelRegister("aDe4X", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $922yL = parcelRequire("922yL");

var $e0SBo = parcelRequire("e0SBo");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $ivb8S = parcelRequire("ivb8S");


var $b4VFP = parcelRequire("b4VFP");

var $dBcar = parcelRequire("dBcar");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $2FNNv = parcelRequire("2FNNv");


var $30D0J = parcelRequire("30D0J");

const $d12c0291e106b88f$var$HOME_ONBOARDING_TAKEOVER_NTH_USER_DAYS = 14;
const $d12c0291e106b88f$export$de7bc1ba49cd35c5 = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { accessStatus: accessStatus, userId: userId } = (0, $bQm3c.useSessionData)();
    const isEstablishedUserTraitName = (0, $2FNNv.useIsEstablishedUserTraitName)();
    // User is licensed (site admin or nth user)
    const hasAdminOrUseAccess = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    (0, $42omo.useEffect)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_TAKEOVER)
        });
    }, [
        experienceTracker
    ]);
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
        ...Object.values((0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS))
    ], !hasAdminOrUseAccess);
    const { isFoundingAdmin: isFoundingAdmin, takeoverSeenAt: takeoverSeenAt } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const takeoverExpired = Boolean(takeoverSeenAt) && (0, $e0SBo.default)(Date.now(), (0, $922yL.default)(new Date(takeoverSeenAt), $d12c0291e106b88f$var$HOME_ONBOARDING_TAKEOVER_NTH_USER_DAYS));
    const { data: userPersonalizationQueryData, loading: userPersonalizationQueryLoading, error: userPersonalizationQueryError } = (0, $30D0J.useExperimentalUserPersonalizationQuery)({
        skip: !hasAdminOrUseAccess || takeoverExpired,
        variables: {
            userId: userId
        }
    });
    const attributes = userPersonalizationQueryData?.experimentalUserPersonalization?.attributes ?? [];
    const isEstablishedUser = attributes.find((attr)=>attr?.name === isEstablishedUserTraitName)?.value === 'true';
    const isEstablishedUserReady = !userPersonalizationQueryLoading && !userPersonalizationQueryError;
    const isNotEstablishedUser = isEstablishedUserReady && !isEstablishedUser;
    const isEligible = Boolean(hasAdminOrUseAccess && (takeoverSeenAt ?? isNotEstablishedUser) && !isFoundingAdmin);
    if (onboardingStateError || userPersonalizationQueryError) experienceTracker.stopOnError({
        name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_TAKEOVER),
        error: onboardingStateError || userPersonalizationQueryError
    });
    return {
        isEligible: isEligible,
        isVisible: isEligible && !takeoverExpired,
        loading: onboardingStateLoading || userPersonalizationQueryLoading
    };
};
module.exports["useNthUserHomeOnboardingTakeoverV2Eligibility"] = $d12c0291e106b88f$export$de7bc1ba49cd35c5;

});

parcelRegister("b4VFP", function(module, exports) {
const $390e454b1ae488b2$export$1d1c13df264a094 = {
    hasSeenHomeNudge: 'home-onboarding-takeover-v2:hasSeenHomeNudge',
    isHomeNudgeScheduledAt: 'home-onboarding-takeover-v2:isHomeNudgeScheduledAt',
    takeoverSeenAt: 'home-onboarding-takeover-v2:takeoverSeenAt',
    onboardingActionStates: 'home-onboarding-takeover-v2:onboardingActionStates',
    isCollapsed: 'home-onboarding-takeover-v2:isCollapsed',
    hasSeenConfetti: 'home-onboarding-takeover-v2:hasSeenConfetti',
    hasDismissedCarousel: 'home-onboarding-takeover-v2:hasDismissedCarousel',
    hasDismissedLearningResources: 'home-onboarding-takeover-v2:hasDismissedLearningResources',
    hasDismissedTakeover: 'home-onboarding-takeover-v2:hasDismissedTakeover'
};
const $390e454b1ae488b2$export$3392b5b28b589b00 = Object.values($390e454b1ae488b2$export$1d1c13df264a094);
module.exports["HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS"] = $390e454b1ae488b2$export$1d1c13df264a094;
module.exports["HomeTakeoverOnboardingKeys"] = $390e454b1ae488b2$export$3392b5b28b589b00;

});

parcelRegister("30D0J", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");


var $7c4rV = parcelRequire("7c4rV");

const $0f856dd8e4045e89$var$mapPersonalizationResponse = (response)=>({
        experimentalUserPersonalization: {
            attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(response.attributes)
        }
    });
const $0f856dd8e4045e89$export$241fc4ad38d78de1 = ({ skip: skip, onError: onError, variables: variables })=>{
    const lastHandledTraitErrorRef = (0, $42omo.useRef)(null);
    const legacyResult = (0, $dK51B.useExperimentalQuery)({
        // eslint-disable-next-line confluence-targeting-usage/no-legacy-tap-personalization-api -- To be migrated to useAtlassianAccountTraits. See ACTIVATION-2527
        url: ({ userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`,
        method: 'GET',
        parseResult: $0f856dd8e4045e89$var$mapPersonalizationResponse,
        skip: skip || (0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false),
        onError: onError,
        variables: variables
    });
    const atlassianAccountTraitsResult = (0, $7c4rV.useAtlassianAccountTraits)({
        skipBootstrap: skip || !variables.userId || !(0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false)
    });
    (0, $42omo.useEffect)(()=>{
        const traitError = atlassianAccountTraitsResult.error;
        if (skip || !variables.userId || !traitError || lastHandledTraitErrorRef.current === traitError || !(0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false)) return;
        lastHandledTraitErrorRef.current = traitError;
        onError?.(traitError);
    }, [
        atlassianAccountTraitsResult.error,
        onError,
        skip,
        variables.userId
    ]);
    if (!(0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false)) return legacyResult;
    if (skip || !variables.userId) return legacyResult;
    return {
        ...legacyResult,
        data: atlassianAccountTraitsResult.data ? $0f856dd8e4045e89$var$mapPersonalizationResponse(atlassianAccountTraitsResult.data) : undefined,
        loading: atlassianAccountTraitsResult.loading,
        error: atlassianAccountTraitsResult.error ?? undefined
    };
};
module.exports["useExperimentalUserPersonalizationQuery"] = $0f856dd8e4045e89$export$241fc4ad38d78de1;

});

parcelRegister("dK51B", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $7ac155b86059b716$export$9a41df5b9f27a628({ url: url, method: method, headers: headers, body: body, variables: variables, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $7ac155b86059b716$export$defacdf98710c90a({
        key: key,
        fetchData: fetchData,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        skip: skip,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $7ac155b86059b716$export$defacdf98710c90a({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { queryState: queryState, execute: execute, refetch: refetch, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        isLazyQuery: false,
        pollInterval: pollInterval,
        isSSR: isSSR
    });
    (0, $42omo.useEffect)(()=>{
        // Edit Page uses JSDOM, so effects run in SSR. Experimental queries should not execute during SSR
        if (!skip && !isSSR) execute();
    }, [
        execute,
        key,
        skip,
        fetchPolicy,
        isSSR
    ]);
    // If skip is true, return idle state with refetch
    if (skip) return {
        ...(0, $7ji4X.INITIAL_IDLE_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
    // Use store state if available, otherwise return initial loading state with refetch
    // (stable reference prevents extra renders before query executes)
    return queryState ? {
        ...queryState,
        refetch: refetch,
        stopPolling: stopPolling
    } : {
        ...(0, $7ji4X.INITIAL_LOADING_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQuery"] = $7ac155b86059b716$export$9a41df5b9f27a628;
module.exports["useExperimentalQueryBase"] = $7ac155b86059b716$export$defacdf98710c90a;

});

parcelRegister("1GTIR", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $GLgaM = parcelRequire("GLgaM");

// Allows using variables from either the mutate call or initial hook call
// Follows Apollo Client behavior: only falls back when variables is undefined, not empty object
const $e94116a19c839dfc$var$resolveVariables = (localVariables, fallbackVariables)=>{
    return localVariables !== undefined ? localVariables : fallbackVariables ?? {};
};
const $e94116a19c839dfc$export$80ee20aa64f130f = ({ url: url, method: method, variables: variables = {}, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const response = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, resolvedVariables);
        return parseResult(response, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
const $e94116a19c839dfc$export$54f10667ecd8890d = ({ requestConfigs: requestConfigs, variables: variables = {}, parseResult: parseResult })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const responses = await Promise.all(requestConfigs.map((fetchOptions)=>(0, $GLgaM.fetchResponse)(fetchOptions, resolvedVariables)));
        return parseResult(responses, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
module.exports["useFetchData"] = $e94116a19c839dfc$export$80ee20aa64f130f;
module.exports["useFetchDataWithMultipleFetches"] = $e94116a19c839dfc$export$54f10667ecd8890d;

});

parcelRegister("GLgaM", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $lMdlY = parcelRequire("lMdlY");


var $3FAG5 = parcelRequire("3FAG5");

async function $2229ddfbe95e9ad1$export$4b00e7449e7c9147(fetchOptions, variables) {
    const { url: url, method: method, body: body, headers: headers, credentials: credentials, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError } = fetchOptions;
    try {
        const resolvedMethod = typeof method === 'function' ? method(variables) : method;
        const defaultBody = resolvedMethod === 'GET' ? undefined : JSON.stringify(variables);
        // Tesseract instruments the outgoing http requests automatically, no need to pass tracing headers when running in SSR.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const tracingHeaders = (0, $lMdlY.getActiveTraceHttpRequestHeaders)('' /* url, not used */ );
        const enhancedHeaders = {
            ...headers,
            ...tracingHeaders
        };
        const response = await (0, $f7B1p.cfetch)(typeof url === 'function' ? url(variables) : url, {
            method: resolvedMethod,
            body: typeof body === 'function' ? body(variables) : body || defaultBody,
            headers: enhancedHeaders,
            credentials: credentials
        });
        if (parseResponseOnSuccess) return parseResponseOnSuccess(response);
        return await $2229ddfbe95e9ad1$var$parseResponse(response);
    } catch (error) {
        if (parseResponseOnError) return parseResponseOnError(error, variables);
        throw error;
    }
}
async function $2229ddfbe95e9ad1$var$parseResponse(response) {
    if (response.status === 204) return {};
    // In case a service happens to return a 200 instead of 204 with no content
    if (response.headers?.get('content-length') === '0') return {};
    try {
        return await response.json();
    } catch (error) {
        throw (0, $3FAG5.throwErrorWithResponse)(error, response);
    }
}
module.exports["fetchResponse"] = $2229ddfbe95e9ad1$export$4b00e7449e7c9147;

});

parcelRegister("3FAG5", function(module, exports) {
// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
function $6c7ad22961ce35d0$export$8a24908f7aac7ac7(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    throw error;
}
module.exports["throwErrorWithResponse"] = $6c7ad22961ce35d0$export$8a24908f7aac7ac7;

});

parcelRegister("fqCbQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $hR9WV = parcelRequire("hR9WV");


var $7ji4X = parcelRequire("7ji4X");


var $iXGsw = parcelRequire("iXGsw");

const $2b5be438041a56b3$export$96d43f36deadf5d1 = new Map();
function $2b5be438041a56b3$export$ca796a141438ab25({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy, isLazyQuery: isLazyQuery = false, pollInterval: pollInterval, isSSR: isSSR = false }) {
    // For no-cache: use local state per hook instance instead of shared state
    const [localState, setLocalState] = (0, $42omo.useState)();
    const sharedState = (0, $7ji4X.useExperimentalQueryState)({
        key: key
    });
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    // Store the last used variables for polling
    // This ensures lazy queries remember their variables for subsequent poll requests
    const lastVariablesRef = (0, $42omo.useRef)(undefined);
    // Choose which state to expose based on fetchPolicy
    const queryState = fetchPolicy === 'no-cache' ? localState : sharedState;
    const execute = (0, $26Yfd.useStableCallback)(async (variables, options)=>{
        // Store variables for future polling requests
        // This matches Apollo's behavior where lazy queries remember their variables
        if (variables !== undefined) lastVariablesRef.current = variables;
        // Use provided variables, or fall back to stored variables (e.g., during polling)
        const effectiveVariables = variables ?? lastVariablesRef.current;
        // If cache-first and we have data, return immediately (unless bypassCache is true, e.g., for polling)
        if (fetchPolicy === 'cache-first' && queryState?.data !== undefined && !options?.bypassCache) {
            onCompleted?.(queryState.data);
            return;
        }
        // Check if this exact query is already in flight (deduplication)
        const existingPromise = $2b5be438041a56b3$export$96d43f36deadf5d1.get(key);
        if (existingPromise) {
            // Wait for the shared promise
            const outcome = await existingPromise;
            // Set local state if no-cache policy. Other fetch policies use shared state
            if (fetchPolicy === 'no-cache') {
                if (outcome.error) setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: outcome.error,
                        called: true
                    }));
                else if (outcome.data !== undefined) setLocalState({
                    data: outcome.data,
                    loading: false,
                    error: undefined,
                    called: true
                });
            }
            // Call this component's callbacks
            if (outcome.error) onError?.(outcome.error);
            else if (outcome.data !== undefined) onCompleted?.(outcome.data);
            return;
        }
        // Create a Promise for the fetch operation that resolves to the outcome
        const fetchPromise = (async ()=>{
            try {
                // Set loading state if not initial fetch
                const shouldSetLoadingState = !options?.skipLoadingState && (isLazyQuery || queryState?.loading === false || queryState?.data !== undefined || queryState?.error);
                if (shouldSetLoadingState) {
                    // Update the appropriate state based on fetchPolicy
                    if (fetchPolicy === 'no-cache') setLocalState({
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                    else setQueryState(key, {
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                }
                const data = await fetchData(effectiveVariables);
                if (fetchPolicy === 'no-cache') setLocalState({
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                else setQueryState(key, {
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                onCompleted?.(data);
                return {
                    data: data
                };
            } catch (error) {
                const finalError = await (0, $hR9WV.handleError)({
                    error: error,
                    transformError: transformError,
                    onError: onError
                });
                if (fetchPolicy === 'no-cache') setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                else setQueryState(key, (prev)=>({
                        data: prev.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                return {
                    error: finalError
                };
            } finally{
                // Remove from in-flight map so future calls create a new request
                $2b5be438041a56b3$export$96d43f36deadf5d1.delete(key);
            }
        })();
        // Store the Promise in the Map before starting the fetch
        $2b5be438041a56b3$export$96d43f36deadf5d1.set(key, fetchPromise);
        await fetchPromise;
    });
    // Note: This only updates the shared state, so any fetch policies (e.g. "no-cache") will be ignored.
    // Please implement local state usage if it's needed in the future.
    const refetch = (0, $26Yfd.useStableCallback)(async (variables)=>{
        try {
            setQueryState(key, {
                data: queryState?.data,
                loading: true,
                error: undefined,
                called: true
            });
            const data = await fetchData(variables);
            setQueryState(key, {
                data: data,
                loading: false,
                error: undefined,
                called: true
            });
            onCompleted?.(data);
            return {
                data: data
            };
        } catch (error) {
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            setQueryState(key, (prev)=>({
                    data: prev.data,
                    loading: false,
                    error: finalError,
                    called: true
                }));
            throw finalError;
        }
    });
    const { stopPolling: stopPolling } = (0, $iXGsw.usePollInterval)(pollInterval, execute, fetchPolicy, isLazyQuery, queryState?.called, isSSR);
    return {
        queryState: queryState,
        execute: execute,
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQueryExecution"] = $2b5be438041a56b3$export$ca796a141438ab25;

});

parcelRegister("hR9WV", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $bjeS8 = parcelRequire("bjeS8");

const $b1a7f6ba28f294ca$export$d3da1ecaf1206c58 = async ({ error: error, transformError: transformError, onError: onError })=>{
    // The `transformError` callback can optionally return a new error to replace the original,
    // allowing for custom errors (e.g. based on the error's status code)
    const finalError = (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    // Process error for monitoring/analytics
    if (finalError.graphQLErrors?.length) finalError.graphQLErrors.forEach((e)=>{
        (0, $7Sm4c.processError)(e);
    });
    onError?.(finalError);
    return finalError;
};
module.exports["handleError"] = $b1a7f6ba28f294ca$export$d3da1ecaf1206c58;

});

parcelRegister("bjeS8", function(module, exports) {

var $aAxiE = parcelRequire("aAxiE");


var $422HI = parcelRequire("422HI");

const $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a = (error)=>{
    const message = error.message || 'Unknown error';
    const status = 'response' in error ? error.response?.status : undefined;
    return new (0, $422HI.ApolloErrorInterop)({
        graphQLErrors: [
            $79bfccd7ee2a0d89$var$createGraphQLError({
                message: message,
                status: status,
                originalError: error
            })
        ]
    });
};
const $79bfccd7ee2a0d89$var$createGraphQLError = ({ message: message, status: status, originalError: originalError })=>{
    const extensions = status ? {
        statusCode: status,
        http: {
            status: status
        }
    } : undefined;
    return new (0, $aAxiE.GraphQLError)(message, null, // nodes - no GraphQL query AST
    null, // source - no GraphQL query text
    null, // positions - no GraphQL query positions
    null, // path - not executing GraphQL schema fields
    originalError, extensions);
};
module.exports["convertToApolloError"] = $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a;

});

parcelRegister("7ji4X", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $67e5a1fc9f6e62d4$export$c6060eb21313da7c = {
    data: undefined,
    loading: false,
    error: undefined,
    called: false
};
const $67e5a1fc9f6e62d4$export$baa1629d06692c30 = {
    data: undefined,
    loading: true,
    error: undefined,
    called: true
};
const $67e5a1fc9f6e62d4$var$Store = (0, $1P1Tu.createStore)({
    initialState: {},
    actions: {
        setQueryState: (key, state)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const prevState = currentState[key] || $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
                const newState = typeof state === 'function' ? state(prevState) : state;
                setState({
                    ...currentState,
                    [key]: newState
                });
            }
    },
    name: 'useExperimentalQueryState'
});
const $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a = (0, $9zUhf.createActionsHook)($67e5a1fc9f6e62d4$var$Store);
const $67e5a1fc9f6e62d4$export$39156bd8f00c1e38 = (0, $9zUhf.createStateHook)($67e5a1fc9f6e62d4$var$Store, {
    selector: (state, params)=>state[params.key]
});
const $67e5a1fc9f6e62d4$export$14d57088f5885a49 = $67e5a1fc9f6e62d4$var$Store;
module.exports["INITIAL_IDLE_STATE"] = $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
module.exports["INITIAL_LOADING_STATE"] = $67e5a1fc9f6e62d4$export$baa1629d06692c30;
module.exports["useExperimentalQueryStateActions"] = $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a;
module.exports["useExperimentalQueryState"] = $67e5a1fc9f6e62d4$export$39156bd8f00c1e38;
module.exports["queryStateStore"] = $67e5a1fc9f6e62d4$export$14d57088f5885a49;

});

parcelRegister("iXGsw", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d90d6eaddcfc40bd$export$55982a4d88e0db29(pollInterval, execute, fetchPolicy, isLazyQuery, called, isSSR) {
    if (pollInterval && fetchPolicy === 'cache-first') throw new Error('Queries that specify the cache-first fetchPolicy cannot also be polling queries.');
    const pollIntervalRef = (0, $42omo.useRef)(null);
    const stopPolling = (0, $42omo.useCallback)(()=>{
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    }, []);
    const handlePoll = (0, $42omo.useCallback)(()=>{
        execute(undefined, {
            bypassCache: true,
            skipLoadingState: true
        });
    }, [
        execute
    ]);
    // For non-lazy queries: poll immediately when pollInterval > 0
    // For lazy queries: only poll after query has been called at least once
    const shouldStartPolling = (0, $42omo.useMemo)(()=>{
        if (isSSR || !pollInterval || pollInterval <= 0) return false;
        return !isLazyQuery || called;
    }, [
        isSSR,
        pollInterval,
        isLazyQuery,
        called
    ]);
    (0, $42omo.useEffect)(()=>{
        // Clear any existing poll interval when conditions change
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        if (shouldStartPolling) pollIntervalRef.current = setInterval(()=>{
            handlePoll();
        }, pollInterval);
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [
        pollInterval,
        handlePoll,
        shouldStartPolling
    ]);
    return {
        stopPolling: stopPolling
    };
}
module.exports["usePollInterval"] = $d90d6eaddcfc40bd$export$55982a4d88e0db29;

});

parcelRegister("6l6jb", function(module, exports) {
function $459f9fedb053e25e$export$a4f9b7f788f9e71f(params) {
    const { url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables } = params;
    return $459f9fedb053e25e$var$canonicalStringify({
        url: typeof url === 'function' ? url.toString() : url,
        method: typeof method === 'function' ? method.toString() : method,
        headers: headers,
        body: typeof body === 'function' ? body.toString() : body,
        credentials: credentials,
        variables: variables
    });
}
function $459f9fedb053e25e$export$ebaa599ca92b9c11(requestConfigs, variables) {
    const keys = requestConfigs.map((config)=>$459f9fedb053e25e$export$a4f9b7f788f9e71f({
            ...config,
            variables: variables
        })).sort();
    return $459f9fedb053e25e$var$canonicalStringify(keys);
}
// Serializes with sorted object keys for deterministic output
function $459f9fedb053e25e$var$canonicalStringify(value) {
    return JSON.stringify(value, $459f9fedb053e25e$var$canonicalStringifyReplacer);
}
function $459f9fedb053e25e$var$canonicalStringifyReplacer(_key, value) {
    // Ensures we only process plain objects (not arrays, dates, etc.)
    if (value && typeof value === 'object') {
        const proto = Object.getPrototypeOf(value);
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys are already sorted, return the original value unchanged to avoid unnecessary object creation
            if (keys.every($459f9fedb053e25e$var$everyKeyInOrder)) return value;
            keys.sort();
            const sortedObject = Object.create(proto);
            keys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
function $459f9fedb053e25e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
module.exports["generateCacheKey"] = $459f9fedb053e25e$export$a4f9b7f788f9e71f;
module.exports["generateCacheKeyForMultipleFetches"] = $459f9fedb053e25e$export$ebaa599ca92b9c11;

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("dS3n9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");

const $9fffd50bbcc7c343$export$c8daa7260f75e213 = ({ spaceKey: spaceKey, contentId: contentId, location: location, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', onCompleted: onCompleted })=>{
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    const baseOptions = {
        variables: variables,
        ...onCompleted && {
            onCompleted: onCompleted
        }
    };
    const useNoFurtherUpdate = location !== (0, $eSLr0.DASHBOARD_SECONDARY) && // Keep watching query for home route to avoid VC90 regression
    (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true);
    const { loading: loading, data: data, error: error } = useNoFurtherUpdate ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), baseOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: fetchPolicy,
        __callerPackage__: "@confluence/web-panel-location"
    });
    const panels = (data?.webPanels || []).filter((panel)=>panel);
    return {
        panels: panels,
        loading: loading,
        error: error
    };
};
module.exports["useWebPanelLocation"] = $9fffd50bbcc7c343$export$c8daa7260f75e213;

});

parcelRegister("ln0hx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $42omo.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("1eaCJ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $frIzR.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_PAGE_COMMENT"] = 30000] = "VIEW_PAGE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("7boqA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kGwvc = parcelRequire("kGwvc");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $18R9N = parcelRequire("18R9N");

const $e6e452b898a1ec38$var$noop = ()=>{};
const $e6e452b898a1ec38$var$EMBEDDED_PREFIX = 'embedded-';
const $e6e452b898a1ec38$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const { onComplete: onComplete = $e6e452b898a1ec38$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of PageSegmentLoadStartProps guarantees that exactly one of
    // `metricKey` or `metric` is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$e6e452b898a1ec38$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const handleSegmentLoadStart = (0, $42omo.useCallback)(()=>{
        (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${prefixedKey}`);
        onComplete();
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadStart, timing);
    return null;
});
const $e6e452b898a1ec38$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($e6e452b898a1ec38$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $e6e452b898a1ec38$export$f11db193fdaffcc9;

});

parcelRegister("aJv6Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("N1nBh", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
   * This will perform the given action at a scheduled time after the
   * component has painted.
   *
   * This is the default behavior.
   */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
   * This will perform the given action at the next animation frame (after the
   * component has been painted).
   */ ActionTiming["PAINT"] = "PAINT";
    /**
   * This will perform the given action at the moment its render function
   * fires.
   *
   * NOTE: This is called _within_ the render body, making it unpure. The
   * component is memoized, so it will fire this only once for a given set
   * of props. Be careful when using this, since it is unsafe.
   */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $42omo.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $42omo.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("18R9N", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6b4f0c0629e8427f$export$fda153f959d0066f = /*#__PURE__*/ (0, $42omo.createContext)(false);
const $6b4f0c0629e8427f$export$b6c7102a78eb7f7f = ()=>(0, $42omo.useContext)($6b4f0c0629e8427f$export$fda153f959d0066f);
module.exports["EmbeddedConfluenceTrackingContext"] = $6b4f0c0629e8427f$export$fda153f959d0066f;
module.exports["useIsEmbeddedTracking"] = $6b4f0c0629e8427f$export$b6c7102a78eb7f7f;

});

parcelRegister("bxcP5", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $57ed722ec78a151a$export$bdce15adff7bb212 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.HOME_OVERVIEW_FEED_SEGMENT_KEY),
    // Set FMP = FCP if SSR (normally FMP = TTI)
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["HOME_OVERVIEW_FEED_PAGE_SEGMENT"] = $57ed722ec78a151a$export$bdce15adff7bb212;

});

parcelRegister("fQ3iN", function(module, exports) {
/**
 * BM3 Deprecation Phase 2 — gated wrapper around the raw BM3 page-segment-load factory.
 *
 * This file is the canonical implementation behind the public name
 * `createPageSegmentLoadMetric` (re-exported from
 * `@confluence/browser-metrics/entry-points/metricConfigs.ts`). All Confluence consumers
 * call the gated variant by virtue of importing the public name; there is no separate
 * "raw" public entry point.
 *
 * When the `cc_bm3_deprecation_phase_2` gate is OFF (default), every method call delegates
 * verbatim to the underlying BM3 PageSegmentLoadMetric so existing behaviour and the BM3
 * `PAGE_SEGMENT_LOAD` analytics events are preserved.
 *
 * When the gate is ON, the BM3 calls are skipped and equivalent UFO custom marks / custom
 * data are emitted instead. This lets us roll out the removal of the BM3 page-segment-load
 * events incrementally — controlled by Statsig — without touching any of the ~25
 * perf.config files or ~20 imperative call sites. Consumers continue to use
 * `METRIC.start()`, `.stop()`, `.cancel()`, `.mark()`, `.markFMP()`,
 * `.startFromPageLoad()` exactly as before; the gate decision is centralised here.
 *
 * The gate `fg(...)` is evaluated **inline at the callsite of each method**, never aliased
 * or wrapped, in line with the feature-gate-and-experiment-usage AGENTS guidance. Per-method
 * (rather than per-construction) evaluation is required because perf.config modules are
 * imported very early in app boot — earlier than Statsig data is loaded — so a one-shot
 * `fg()` call at construction time would always read the default (false) value.
 *
 * Implementation note: rather than returning a *new* wrapper object, this helper mutates
 * the real BM3 metric instance by overriding selected methods with bound functions that
 * consult the gate. This preserves the metric's class identity, prototype chain, and
 * private internal state so it remains a fully drop-in substitute everywhere a BM3
 * PageSegmentLoadMetric is used (including in `pageLoadMetric.include[]` / `until[]`
 * arrays where BM3 walks the internal experience graph).
 *
 * Once the gate has fully ramped, this file's body will be replaced with a UFO-only
 * implementation and the BM3 dependency removed entirely.
 */ 
var $cbc8g = parcelRequire("cbc8g");


var $kGwvc = parcelRequire("kGwvc");


var $9wGTI = parcelRequire("9wGTI");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            const opts = args[0];
            if (opts?.customData) (0, $cbc8g.addUFOCustomData)(opts.customData);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            // Note - there's no equivalent for cancel in UFO, so we use the end mark instead.
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [name, timestamp] = args;
            (0, $kGwvc.addUFOCustomMark)(name, timestamp);
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [timestamp] = args;
            (0, $kGwvc.addUFOCustomMark)(`fmp:${key}`, timestamp);
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("kw6I9", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $kyiqo = parcelRequire("kyiqo");

const $864083edfead32eb$export$2a2fe1e11b4e0413 = (0, $kyiqo.metrics).pageSegmentLoad;
module.exports["createBM3PageSegmentLoadMetricRaw"] = $864083edfead32eb$export$2a2fe1e11b4e0413;

});

parcelRegister("kyiqo", function(module, exports) {

var $bCz2F = parcelRequire("bCz2F");


var $bs5rD = parcelRequire("bs5rD");

const $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54 = {
    pageLoad: $bs5rD.pageLoad,
    pageSegmentLoad: $bs5rD.pageSegmentLoad,
    interaction: $bs5rD.interaction,
    custom: $bs5rD.custom,
    concurrent: $bCz2F.concurrent
};
module.exports["metrics"] = $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54;

});

parcelRegister("bCz2F", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $bs5rD = parcelRequire("bs5rD");

const $bbc3e125622b0c90$var$concurrentMetrics = {};
const $bbc3e125622b0c90$var$getKey = (config, type)=>`${type}--${config.key}`;
const $bbc3e125622b0c90$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $bbc3e125622b0c90$var$ensurePath = (config, type)=>{
    const key = $bbc3e125622b0c90$var$getKey(config, type);
    if (!(key in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[key] = {};
};
const $bbc3e125622b0c90$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $bbc3e125622b0c90$var$getKey(config, type);
    if (concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics && $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $bbc3e125622b0c90$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $bbc3e125622b0c90$var$validateConfig(config);
    $bbc3e125622b0c90$var$ensurePath(config, type);
    const metricFromCache = $bbc3e125622b0c90$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $j4jXg.BMEventsType).INLINE_RESULT ? (0, $bs5rD.interaction) : (0, $bs5rD.custom);
    const metric = metricFactory(config);
    $bbc3e125622b0c90$var$concurrentMetrics[$bbc3e125622b0c90$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $bbc3e125622b0c90$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $bbc3e125622b0c90$export$370df09ecc3de059;

});

parcelRegister("bs5rD", function(module, exports) {

var $iuio5 = parcelRequire("iuio5");


var $boXf9 = parcelRequire("boXf9");


var $giQku = parcelRequire("giQku");


var $j4jXg = parcelRequire("j4jXg");

const $d0aae4122f29b5ae$export$791d520f7e8058a5 = (config)=>{
    return new (0, $boXf9.PageLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_LOAD
    });
};
const $d0aae4122f29b5ae$export$94114666844d5f66 = (config)=>{
    return new (0, $giQku.PageSegmentLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $d0aae4122f29b5ae$export$92473e6020ad89b4 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).INLINE_RESULT
    });
};
const $d0aae4122f29b5ae$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).CUSTOM
    });
};
module.exports["pageLoad"] = $d0aae4122f29b5ae$export$791d520f7e8058a5;
module.exports["pageSegmentLoad"] = $d0aae4122f29b5ae$export$94114666844d5f66;
module.exports["interaction"] = $d0aae4122f29b5ae$export$92473e6020ad89b4;
module.exports["custom"] = $d0aae4122f29b5ae$export$4c00f665f0d4b443;

});

parcelRegister("iuio5", function(module, exports) {

var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $4k3LC = parcelRequire("4k3LC");

class $6456fd2c244bded5$export$efdd3e096bc27746 extends (0, $4k3LC.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $lH7GJ.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $11Zqj.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $6456fd2c244bded5$export$efdd3e096bc27746;

});

parcelRegister("boXf9", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $7RgFv = parcelRequire("7RgFv");


var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $j4jXg = parcelRequire("j4jXg");


var $3znwT = parcelRequire("3znwT");


var $69Zr8 = parcelRequire("69Zr8");


var $e9ZCR = parcelRequire("e9ZCR");

class $b4ce8d24635e776a$export$3c51073271a9eac3 extends (0, $3znwT.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $69Zr8.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $69Zr8.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $3znwT.BasePageLoadMetric).FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $69Zr8.pageLoadMetaMetric).markFMP(mark);
            } else (0, $69Zr8.pageLoadMetaMetric).markFMP(this.marks[(0, $3znwT.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $lH7GJ.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $11Zqj.submitter).queue(data);
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $69Zr8.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $69Zr8.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $11Zqj.submitter).config.configChunk;
        if (!configChunk?.[(0, $j4jXg.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $e9ZCR.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $11Zqj.submitter).queue(webVitalMetric.getData());
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $b4ce8d24635e776a$export$3c51073271a9eac3;

});

parcelRegister("e9ZCR", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");

class $fd3d2d441d340510$export$dc0d85d4d6503cd7 extends (0, $4k3LC.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $j4jXg.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $4k3LC.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $fd3d2d441d340510$export$dc0d85d4d6503cd7;

});

parcelRegister("giQku", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");


var $iuio5 = parcelRequire("iuio5");


var $69Zr8 = parcelRequire("69Zr8");

class $4f83d9bff0211700$export$24c8bfcd77494cc1 extends (0, $iuio5.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $4f83d9bff0211700$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($4f83d9bff0211700$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $j4jXg.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $4k3LC.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $4k3LC.MetricState).STARTED) (0, $69Zr8.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $4f83d9bff0211700$export$24c8bfcd77494cc1;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
const $fa0ea3428ec5aa62$export$b3aade49b91bdeba = 'comments-panel-mentions-me-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["MEDIA_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7416ef7ed24ec47f;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;
module.exports["COMMENTS_PANEL_MENTIONS_ME_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b3aade49b91bdeba;

});

parcelRegister("dpPtd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aD1SW = parcelRequire("aD1SW");


var $eCEXz = parcelRequire("eCEXz");


var $6uGcC = parcelRequire("6uGcC");

const $c997cd3fd9f4ee84$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
function $c997cd3fd9f4ee84$export$2879604e6aec4ab() {
    const api = (0, $42omo.useContext)($c997cd3fd9f4ee84$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $c997cd3fd9f4ee84$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $c997cd3fd9f4ee84$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $42omo.useState)([]);
    const removeFlag = (0, $42omo.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $42omo.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $c997cd3fd9f4ee84$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c997cd3fd9f4ee84$var$FlagContext.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uGcC.default), {
        onDismissed: removeFlag,
        shouldRenderToParent: shouldRenderToParent
    }, flags.map((flag)=>{
        const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
        const FlagType = isAutoDismiss ? (0, $aD1SW.default) : (0, $eCEXz.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FlagType, {
            ...restProps,
            key: flag.id
        });
    })));
}
const $c997cd3fd9f4ee84$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c997cd3fd9f4ee84$export$a4270ab432ac8a58, null, fn());
module.exports["useFlags"] = $c997cd3fd9f4ee84$export$2879604e6aec4ab;
module.exports["FlagsProvider"] = $c997cd3fd9f4ee84$export$a4270ab432ac8a58;

});

parcelRegister("7Hi9s", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a4720dcc648d07e799e98d5c507a4ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $59aaa10ecf407b59$var$_react = $59aaa10ecf407b59$var$_interopRequireDefault((parcelRequire("42omo")));

var $59aaa10ecf407b59$var$_baseNew = $59aaa10ecf407b59$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $59aaa10ecf407b59$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WelcomeFeed".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: Intro blog feed picker on Hello
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $59aaa10ecf407b59$var$WelcomeFeedIcon = (props)=>/*#__PURE__*/ $59aaa10ecf407b59$var$_react.default.createElement($59aaa10ecf407b59$var$_baseNew.default, Object.assign({
        name: "WelcomeFeedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM4.5 5A1.25 1.25 0 1 1 7 5a1.25 1.25 0 0 1-2.5 0M9 5a1.25 1.25 0 1 1 2.5 0A1.25 1.25 0 0 1 9 5M6.085 8.783C6.571 9.16 7.225 9.5 8 9.5s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69C10.196 10.464 9.226 11 8 11s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$59aaa10ecf407b59$var$WelcomeFeedIcon.displayName = 'WelcomeFeedIcon';
var $59aaa10ecf407b59$var$_default = module.exports.default = $59aaa10ecf407b59$var$WelcomeFeedIcon;

});

parcelRegister("g5jMy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d6ff2113712652381db2eeef0f24380>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb5c754bd5a605c4$var$_react = $bb5c754bd5a605c4$var$_interopRequireDefault((parcelRequire("42omo")));

var $bb5c754bd5a605c4$var$_baseNew = $bb5c754bd5a605c4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $bb5c754bd5a605c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sunset".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Farewell feed in hello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb5c754bd5a605c4$var$SunsetIcon = (props)=>/*#__PURE__*/ $bb5c754bd5a605c4$var$_react.default.createElement($bb5c754bd5a605c4$var$_baseNew.default, Object.assign({
        name: "SunsetIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v2h-1.5V1zm3 2.845 1.414-1.415 1.06 1.061-1.413 1.414zm-8.586 1.07L1.75 3.5l1.06-1.06 1.415 1.414zM8 6a3 3 0 0 0-3 3H3.5a4.5 4.5 0 0 1 9 0H11a3 3 0 0 0-3-3M2 9H0V7.5h2zm14 0h-2V7.5h2zm-1 3H1v-1.5h14zm-4.5 1.5V15h-5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$bb5c754bd5a605c4$var$SunsetIcon.displayName = 'SunsetIcon';
var $bb5c754bd5a605c4$var$_default = module.exports.default = $bb5c754bd5a605c4$var$SunsetIcon;

});

parcelRegister("2Rith", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $j4EkW = parcelRequire("j4EkW");

const $0f73dde994861ed0$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $0f73dde994861ed0$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $j4EkW.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $42omo.useMemo)(()=>{
        $0f73dde994861ed0$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ifW2H.AIEventsInstrumentationContext).Provider, {
        value: contextValue
    }, children);
};
module.exports["AIEventsInstrumentationProvider"] = $0f73dde994861ed0$export$b5d4bc85dfbaa4f8;

});

parcelRegister("2HrIG", function(module, exports) {

let $1f75197c42d844ba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1f75197c42d844ba$var$load("c831e"),
    $1f75197c42d844ba$var$load("7EorR"),
    $1f75197c42d844ba$var$load("gRvAH")
]).then(()=>parcelRequire('5t5Ni'));

});

parcelRegister("kvJHJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $cbc8g = parcelRequire("cbc8g");


var $kGwvc = parcelRequire("kGwvc");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $42omo.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
        (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
        (0, $cbc8g.addUFOCustomData)({
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("2O7Qv", function(module, exports) {

var $4u5NT = parcelRequire("4u5NT");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $4u5NT.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("9oxdN", function(module, exports) {

var $h1PDd = parcelRequire("h1PDd");


var $iaK3p = parcelRequire("iaK3p");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $fEmGS = parcelRequire("fEmGS");


var $l1uFv = parcelRequire("l1uFv");


var $7W8i8 = parcelRequire("7W8i8");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery = (0, $iaK3p.default);
const $112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation = (0, $h1PDd.default);
const $112f5732a615f62f$var$logger = (0, $7W8i8.getLogger)('useFeatureDiscovery');
const $112f5732a615f62f$export$2dd355223baa0569 = 'com.atlassian.confluence.plugins.confluence-frontend-support';
const $112f5732a615f62f$var$updateCache = (_, { data: data })=>{
    const newMarkedFeature = data?.markFeatureDiscovered;
    if (!newMarkedFeature) return;
    const cachedFeatureData = (0, $l1uFv.readQueryInterop)({
        query: $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery,
        __callerPackage__: "@confluence/feature-discovery"
    });
    if (!cachedFeatureData?.featureDiscovery) return;
    (0, $fEmGS.writeQueryInterop)({
        query: $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery,
        data: {
            featureDiscovery: cachedFeatureData.featureDiscovery.concat(newMarkedFeature)
        },
        __callerPackage__: "@confluence/feature-discovery"
    });
};
const $112f5732a615f62f$var$getLocalOverrideValue = (featureKey)=>{
    try {
        if ((0, $17wUi.confluenceSessionStorageInstance).getItem((0, $9wGTI.fg)('confluence_browser_storage_prepended_keys') ? `${featureKey}-featureDiscoveryOverride` : `${(0, $1UApO.keys).FEATURE_DISCOVERY_OVERRIDE_PREFIX}-${featureKey}`)) return true;
    } catch (e) {
        $112f5732a615f62f$var$logger.error(e);
    }
    return false;
};
const $112f5732a615f62f$var$noop = ()=>{};
const $112f5732a615f62f$export$6de1a7573792d1a9 = (featureKey, skip)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const skipFeatureDiscoveryQuery = !isLoggedIn || skip;
    const { data: data, loading: queryLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery, {
        skip: skipFeatureDiscoveryQuery,
        __callerPackage__: "@confluence/feature-discovery"
    });
    const [markFeatureDiscovered, { loading: mutationLoading, error: mutationError }] = (0, $308Wd.useMutationInterop)($112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation, {
        variables: {
            featureKey: featureKey,
            pluginKey: $112f5732a615f62f$export$2dd355223baa0569
        },
        update: $112f5732a615f62f$var$updateCache,
        __callerPackage__: "@confluence/feature-discovery"
    });
    const loading = queryLoading || mutationLoading;
    const error = queryError || mutationError;
    const showFeature = !loading && !error && !data?.featureDiscovery?.some((feature)=>feature?.pluginKey === $112f5732a615f62f$export$2dd355223baa0569 && feature?.featureKey === featureKey);
    const handleStop = (0, $42omo.useCallback)(()=>{
        if (showFeature) // error is handled in the useMutation result
        markFeatureDiscovered().catch(()=>{});
    }, [
        showFeature,
        markFeatureDiscovered
    ]);
    if (skipFeatureDiscoveryQuery) return [
        false,
        $112f5732a615f62f$var$noop,
        undefined
    ];
    // this is for dev/testing, since we cant easily remove data from the featureDiscovery array
    const forceShowFeature = showFeature || $112f5732a615f62f$var$getLocalOverrideValue(featureKey);
    return [
        forceShowFeature,
        handleStop,
        error
    ];
};
module.exports["useFeatureDiscovery"] = $112f5732a615f62f$export$6de1a7573792d1a9;

});

parcelRegister("h1PDd", function(module, exports) {
/**
 * @generated SignedSource<<1333db28a4b11ca5e337731bdc8887fb>>
 * @relayHash 7e3a97b41907f84e881bf7535b1379ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081
const $fca31db58911eb73$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "featureKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pluginKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "featureKey",
                    "variableName": "featureKey"
                },
                {
                    "kind": "Variable",
                    "name": "pluginKey",
                    "variableName": "pluginKey"
                }
            ],
            "concreteType": "FeatureDiscoveryPayload",
            "kind": "LinkedField",
            "name": "markFeatureDiscovered",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7e3a97b41907f84e881bf7535b1379ce",
            "id": "aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081",
            "metadata": {},
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "operationKind": "mutation",
            "text": "mutation useFeatureDiscoveryMarkFeatureDiscoveredMutation($featureKey:String!,$pluginKey:String!){markFeatureDiscovered(featureKey:$featureKey,pluginKey:$pluginKey){pluginKey,featureKey}}"
        }
    };
}();
$fca31db58911eb73$var$node.hash = "55ae5a7186fb2a98e37da374a9b9784e";
var $fca31db58911eb73$export$2e2bcd8739ae039 = $fca31db58911eb73$var$node;
module.exports["default"] = $fca31db58911eb73$export$2e2bcd8739ae039;

});

parcelRegister("iaK3p", function(module, exports) {
/**
 * @generated SignedSource<<232155696f82fbae3aa6e3e0b041a429>>
 * @relayHash 5f15c23509e6cb7f2874b0f92de8a11b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f
const $8d30006ecab20121$var$node = function() {
    var v0 = [
        {
            "concreteType": "DiscoveredFeature",
            "kind": "LinkedField",
            "name": "featureDiscovery",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "5f15c23509e6cb7f2874b0f92de8a11b",
            "id": "8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f",
            "metadata": {},
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "operationKind": "query",
            "text": "query useFeatureDiscoveryFeatureDiscoveryQuery{featureDiscovery{pluginKey,featureKey}}"
        }
    };
}();
$8d30006ecab20121$var$node.hash = "8577be880df828fbee71c90a7701eddf";
var $8d30006ecab20121$export$2e2bcd8739ae039 = $8d30006ecab20121$var$node;
module.exports["default"] = $8d30006ecab20121$export$2e2bcd8739ae039;

});

parcelRegister("fgRQY", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $40c43516853cc93d$export$951d3821f04440e9 = (elementRef, onSeen, t0)=>{
    const $ = (0, $frIzR.c)(5);
    const threshold = t0 === undefined ? 1 : t0;
    const observerRef = (0, $42omo.useRef)();
    const hasIntersected = (0, $42omo.useRef)(false);
    let t1;
    let t2;
    if ($[0] !== elementRef || $[1] !== onSeen || $[2] !== threshold) {
        t1 = ()=>{
            const disconnectObserver = ()=>{
                if (observerRef.current) {
                    observerRef.current.disconnect();
                    observerRef.current = undefined;
                }
            };
            const handleIntersect = (entries)=>{
                if (!hasIntersected.current && entries[0].isIntersecting) {
                    onSeen();
                    hasIntersected.current = true;
                    disconnectObserver();
                }
            };
            observerRef.current = new IntersectionObserver(handleIntersect, {
                threshold: threshold
            });
            if (elementRef.current) observerRef.current.observe(elementRef.current);
            return disconnectObserver;
        };
        t2 = [
            onSeen,
            elementRef,
            threshold
        ];
        $[0] = elementRef;
        $[1] = onSeen;
        $[2] = threshold;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
};
module.exports["useElementSeenCallback"] = $40c43516853cc93d$export$951d3821f04440e9;

});

parcelRegister("j0RU5", function(module, exports) {
const $4417c16353652d2d$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4417c16353652d2d$var$isExpectedGraphqlError);
    return false;
};
const $4417c16353652d2d$var$isExpectedGraphqlError = (error)=>{
    return $4417c16353652d2d$export$96764ac307b61f82(error) || $4417c16353652d2d$export$76be013bd4365c41(error) || $4417c16353652d2d$export$d03792e4e1b785d4(error);
};
const $4417c16353652d2d$var$feedConfigSpacesPath = [
    'getFeedUserConfig',
    'spaces'
];
const $4417c16353652d2d$export$d03792e4e1b785d4 = (error)=>{
    return $4417c16353652d2d$var$feedConfigSpacesPath.every((path)=>error.path?.includes(path)) && error.message?.includes('Cannot find space with id:');
};
const $4417c16353652d2d$export$96764ac307b61f82 = (error)=>{
    return $4417c16353652d2d$var$feedConfigSpacesPath.every((path)=>error.path?.includes(path)) && error.message?.includes('Not permitted to view space with id:');
};
const $4417c16353652d2d$var$feedConfigUsersPath = [
    'getFeedUserConfig',
    'users'
];
const $4417c16353652d2d$export$76be013bd4365c41 = (error)=>{
    return $4417c16353652d2d$var$feedConfigUsersPath.every((path)=>error.path?.includes(path)) && error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4417c16353652d2d$export$288e4801a340fb3c;
module.exports["isFeedConfigSpacePermissionError"] = $4417c16353652d2d$export$96764ac307b61f82;
module.exports["isFeedConfigUserPermissionError"] = $4417c16353652d2d$export$76be013bd4365c41;
module.exports["isFeedConfigDeletedSpaceError"] = $4417c16353652d2d$export$d03792e4e1b785d4;

});

parcelRegister("iKskQ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $buthI = parcelRequire("buthI");


var $4wwVl = parcelRequire("4wwVl");

const $b378bfc9d198c46c$var$spaceImgStyles = {
    default: "_19itidpf _1o9zidpf _bfhkizff",
    loaded: "_bfhk1j28"
};
const $b378bfc9d198c46c$var$AvatarStyles = {
    xsmall: "_2rko12b0 _1bsbgktf _4t3igktf",
    small: "_2rkolb4i _1bsb1tcg _4t3i1tcg",
    medium: "_2rkofajl _1bsbzwfg _4t3izwfg",
    large: "_2rkofajl _1bsb1ylp _4t3i1ylp",
    xlarge: "_2rko1qi0 _1bsb16xz _4t3i16xz"
};
const $b378bfc9d198c46c$export$b14ad400b1d09e0f = {
    global: (0, (/*@__PURE__*/$parcel$interopDefault($buthI))),
    personal: (0, (/*@__PURE__*/$parcel$interopDefault($4wwVl)))
};
const $b378bfc9d198c46c$export$38ffce4a7986ba20 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { type: type, label: t1, size: t2, src: src, testId: testId } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const [imgLoaded, setImgLoaded] = (0, $42omo.useState)(!src);
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setImgLoaded(true);
        };
        $[0] = t3;
    } else t3 = $[0];
    const setLoaded = t3;
    if (src) {
        const t4 = src?.includes("/wiki") || src?.startsWith("http") ? src : `/wiki${src}`;
        const t5 = imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles.loaded;
        const t6 = $b378bfc9d198c46c$var$AvatarStyles[size];
        let t7;
        if ($[1] !== t5 || $[2] !== t6) {
            t7 = (0, $gMc0m.default)([
                $b378bfc9d198c46c$var$spaceImgStyles["default"],
                t5,
                t6
            ]);
            $[1] = t5;
            $[2] = t6;
            $[3] = t7;
        } else t7 = $[3];
        let t8;
        if ($[4] !== label || $[5] !== t4 || $[6] !== t7 || $[7] !== testId) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
                src: t4,
                alt: label,
                onLoad: setLoaded,
                onError: setLoaded,
                "data-testid": testId,
                className: t7
            });
            $[4] = label;
            $[5] = t4;
            $[6] = t7;
            $[7] = testId;
            $[8] = t8;
        } else t8 = $[8];
        return t8;
    }
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($buthI)));
    let t4;
    if ($[9] !== Icon || $[10] !== label || $[11] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: label,
            testId: testId
        });
        $[9] = Icon;
        $[10] = label;
        $[11] = testId;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ type: type, label: label = '', size: size = 'medium', src: src, testId: testId })=>{
    const [imgLoaded, setImgLoaded] = (0, $42omo.useState)(!src);
    const setLoaded = (0, $42omo.useCallback)(()=>{
        setImgLoaded(true);
    }, [
        setImgLoaded
    ]);
    if (src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: src?.includes('/wiki') || src?.startsWith('http') ? src : `/wiki${src}`,
        alt: label,
        onLoad: setLoaded,
        onError: setLoaded,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $b378bfc9d198c46c$var$spaceImgStyles['default'],
            imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles['loaded'],
            $b378bfc9d198c46c$var$AvatarStyles[size]
        ])
    });
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($buthI)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: label,
        testId: testId
    });
});
module.exports["SpaceIcon"] = $b378bfc9d198c46c$export$38ffce4a7986ba20;

});

parcelRegister("fs6LW", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $esRft = parcelRequire("esRft");


var $jyPfN = parcelRequire("jyPfN");


var $9wGTI = parcelRequire("9wGTI");


var $a6t12 = parcelRequire("a6t12");

const $98dff64af54e38f8$var$avatarWrapperStyles = {
    base: (0, $ecnYn.xcss)({
        display: 'inline-flex',
        backgroundColor: 'color.background.neutral.subtle',
        borderWidth: '0',
        padding: 'space.0',
        borderRadius: 'radius.full',
        outlineOffset: 'space.0',
        ':focus-within': {
            outlineStyle: 'solid',
            outlineWidth: 'border.width.focused',
            outlineColor: 'color.border.focused'
        }
    }),
    blockBase: (0, $ecnYn.xcss)({
        display: 'flex'
    }),
    cursor: (0, $ecnYn.xcss)({
        cursor: 'pointer'
    })
};
const $98dff64af54e38f8$var$i18n = (0, $aXWIB.defineMessages)({
    label: {
        id: "profile.avatar.image",
        defaultMessage: "profile image of a user"
    },
    ariaLabel: {
        id: "profile.avatar.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
const $98dff64af54e38f8$export$3778be82376b06d7 = (t0)=>{
    const $ = (0, $frIzR.c)(44);
    const { userId: userId, canViewProfile: t1, isAnonymous: t2, size: t3, src: src, onClick: onClick, trigger: trigger, name: name, stackIndex: stackIndex, testId: testId, position: position, borderColor: borderColor, offset: offset, isBlockLevel: t4 } = t0;
    const canViewProfile = t1 === undefined ? true : t1;
    const isAnonymous = t2 === undefined ? false : t2;
    const size = t3 === undefined ? "medium" : t3;
    const isBlockLevel = t4 === undefined ? false : t4;
    const intl = (0, $aXWIB.useIntl)();
    const avatarSrc = isAnonymous || !canViewProfile || !src ? undefined : src;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const willRenderProfileCardTrigger = !isAnonymous && canViewProfile && !!userId && hasViewUserProfilePermission;
    const avatarRef = (0, $42omo.useRef)(null);
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [shouldReturnFocus, setShouldReturnFocus] = (0, $42omo.useState)(false);
    const [wasKeyboardAction, setWasKeyboardAction] = (0, $42omo.useState)(false);
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (isVisible_0)=>{
            setIsVisible(isVisible_0);
        };
        $[0] = t5;
    } else t5 = $[0];
    const handleVisibilityChange = t5;
    let t6;
    let t7;
    if ($[1] !== isVisible || $[2] !== shouldReturnFocus) {
        t6 = ()=>{
            if (shouldReturnFocus && !isVisible && avatarRef.current) {
                avatarRef.current.focus();
                setShouldReturnFocus(false);
            }
        };
        t7 = [
            isVisible,
            shouldReturnFocus
        ];
        $[1] = isVisible;
        $[2] = shouldReturnFocus;
        $[3] = t6;
        $[4] = t7;
    } else {
        t6 = $[3];
        t7 = $[4];
    }
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    if ($[5] !== isVisible || $[6] !== wasKeyboardAction) {
        t8 = (e)=>{
            e.stopPropagation();
            if (e.key === "Enter") {
                setWasKeyboardAction(true);
                setIsVisible($98dff64af54e38f8$var$_temp);
                setShouldReturnFocus(true);
            } else if (e.key === "Escape" && isVisible && wasKeyboardAction) {
                setIsVisible(false);
                setWasKeyboardAction(false);
                setShouldReturnFocus(true);
            }
        };
        $[5] = isVisible;
        $[6] = wasKeyboardAction;
        $[7] = t8;
    } else t8 = $[7];
    const handleKeyDown = t8;
    const t9 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? "" : name || "";
    let t10;
    if ($[8] !== intl) {
        t10 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? {} : {
            label: intl.formatMessage($98dff64af54e38f8$var$i18n.label)
        };
        $[8] = intl;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== avatarSrc || $[11] !== borderColor || $[12] !== onClick || $[13] !== size || $[14] !== stackIndex || $[15] !== t10 || $[16] !== t9 || $[17] !== testId) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            src: avatarSrc,
            size: size,
            target: "_blank",
            name: t9,
            ...t10,
            stackIndex: stackIndex,
            testId: testId,
            borderColor: borderColor,
            onClick: onClick
        });
        $[10] = avatarSrc;
        $[11] = borderColor;
        $[12] = onClick;
        $[13] = size;
        $[14] = stackIndex;
        $[15] = t10;
        $[16] = t9;
        $[17] = testId;
        $[18] = t11;
    } else t11 = $[18];
    const Icon = t11;
    let t12;
    if ($[19] !== intl || $[20] !== isVisible || $[21] !== name || $[22] !== willRenderProfileCardTrigger) {
        t12 = ()=>{
            if ((0, $9wGTI.fg)("a11y_whiteboards_changes")) return {};
            if (willRenderProfileCardTrigger) return {
                tabIndex: -1
            };
            return {
                "aria-haspopup": "true",
                "aria-expanded": isVisible,
                "aria-label": intl.formatMessage($98dff64af54e38f8$var$i18n.ariaLabel, {
                    name: name || ""
                }),
                role: "button",
                tabIndex: 0
            };
        };
        $[19] = intl;
        $[20] = isVisible;
        $[21] = name;
        $[22] = willRenderProfileCardTrigger;
        $[23] = t12;
    } else t12 = $[23];
    const getAriaProps = t12;
    const t13 = name || "";
    let t14;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $9wGTI.fg)("a11y_whiteboards_changes");
        $[24] = t14;
    } else t14 = $[24];
    const t15 = isBlockLevel && $98dff64af54e38f8$var$avatarWrapperStyles.blockBase;
    const t16 = canViewProfile && hasViewUserProfilePermission && $98dff64af54e38f8$var$avatarWrapperStyles.cursor;
    let t17;
    if ($[25] !== t15 || $[26] !== t16) {
        t17 = [
            $98dff64af54e38f8$var$avatarWrapperStyles.base,
            t15,
            t16
        ];
        $[25] = t15;
        $[26] = t16;
        $[27] = t17;
    } else t17 = $[27];
    let t18;
    if ($[28] !== getAriaProps) {
        t18 = getAriaProps();
        $[28] = getAriaProps;
        $[29] = t18;
    } else t18 = $[29];
    let t19;
    if ($[30] !== Icon || $[31] !== handleKeyDown || $[32] !== t17 || $[33] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t17,
            testId: "avatarWrapperTestId",
            ref: avatarRef,
            onKeyDown: handleKeyDown,
            ...t18
        }, Icon);
        $[30] = Icon;
        $[31] = handleKeyDown;
        $[32] = t17;
        $[33] = t18;
        $[34] = t19;
    } else t19 = $[34];
    let t20;
    if ($[35] !== canViewProfile || $[36] !== isAnonymous || $[37] !== offset || $[38] !== position || $[39] !== t13 || $[40] !== t19 || $[41] !== trigger || $[42] !== userId) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: userId,
            canViewProfile: canViewProfile,
            isAnonymous: isAnonymous,
            trigger: trigger,
            fullName: t13,
            disabledAriaAttributes: t14,
            onVisibilityChange: handleVisibilityChange,
            position: position,
            offset: offset
        }, t19);
        $[35] = canViewProfile;
        $[36] = isAnonymous;
        $[37] = offset;
        $[38] = position;
        $[39] = t13;
        $[40] = t19;
        $[41] = trigger;
        $[42] = userId;
        $[43] = t20;
    } else t20 = $[43];
    return t20;
};
function $98dff64af54e38f8$var$_temp(prev) {
    return !prev;
}
module.exports["ProfileAvatar"] = $98dff64af54e38f8$export$3778be82376b06d7;

});

parcelRegister("8rneB", function(module, exports) {

var $ibzAc = parcelRequire("ibzAc");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["DefaultTitleEmojiValues"] = $61659933fe71a4ee$export$66d7571a7d7aad65;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("32x2E", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");


var $5B7Fh = parcelRequire("5B7Fh");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    return `${cloudId}_${userId}_${allowAnonymousAccess}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $5B7Fh.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("5B7Fh", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $fhsiz = parcelRequire("fhsiz");


var $fJJ4V = parcelRequire("fJJ4V");


var $i0VEL = parcelRequire("i0VEL");


var $dh538 = parcelRequire("dh538");

class $57ed069fa0b7e304$export$67106c51beb59865 extends (0, $i0VEL.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $eTj7Y.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $eTj7Y.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            if ((0, $dh538.fg)('platform_twemoji_removal_unicode_emojis')) {
                // Skip SSR for nodes without an Id
                if (!node.attrs.id) return undefined;
                const unicodeEmoji = (0, $fJJ4V.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    id: node.attrs.id,
                    shortName: node.attrs.shortName,
                    fallback: node.attrs.text,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    },
                    searchable: true,
                    type: '',
                    category: ''
                };
            }
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $fhsiz.defaultEmojiHeight),
                    width: (0, $fhsiz.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // For STANDARD emojis, return a UnicodeRepresentation so they are rendered
            // as native text characters rather than images (twemoji removal).
            if (node.attrs.id && result && (0, $dh538.fg)('platform_twemoji_removal_unicode_emojis')) {
                const unicodeEmoji = (0, $fJJ4V.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    ...result,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    }
                };
            }
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $57ed069fa0b7e304$export$67106c51beb59865;

});

parcelRegister("i0VEL", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $iu6m9 = parcelRequire("iu6m9");

class $1946187bbb294084$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) {
            this.updateCache(ssrData, {
                strategy: 'replace',
                source: 'ssr'
            });
            return;
        }
        this.cacheVersion++;
        this.cache = Object.fromEntries(Object.entries(ssrData).map(([key, data])=>[
                key,
                {
                    data: data,
                    source: 'ssr'
                }
            ]));
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $eTj7Y.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) {
                    // Replace promise with the resolved data in the cache
                    if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) this.updateCache({
                        [dataKey]: data
                    }, {
                        strategy: 'merge',
                        source: 'network'
                    });
                    else this.cache[dataKey] = {
                        data: data,
                        source: 'network'
                    };
                }
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $1946187bbb294084$export$1185db7a00c13eed;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("dYA5q", function(module, exports) {
/* LivePagePreloader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $9wGTI = parcelRequire("9wGTI");


var $7W8i8 = parcelRequire("7W8i8");


var $39rFu = parcelRequire("39rFu");

const $15ad27b3337f3f82$var$logger = (0, $7W8i8.getLogger)('LivePagePreloader');
const $15ad27b3337f3f82$export$6eca3633b04cd128 = ({ isLivePage: isLivePage, children: children })=>{
    const { livePageComponentsPreloader: livePageComponentsPreloader } = (0, $39rFu.useEditPageLoadingActions)();
    const [isPreloading, setIsPreloading] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!isPreloading || !isLivePage) return;
        const preloadComponents = ()=>{
            livePageComponentsPreloader?.().catch((error)=>{
                $15ad27b3337f3f82$var$logger.error`Preloading live page components failed ${error}`;
            }).finally(()=>{
                setIsPreloading(false);
            });
        };
        preloadComponents();
    }, [
        isPreloading,
        isLivePage,
        livePageComponentsPreloader
    ]);
    const triggerPreload = (0, $42omo.useCallback)(()=>{
        if (isLivePage && !isPreloading) setIsPreloading(true);
    }, [
        isLivePage,
        isPreloading
    ]);
    if (!isLivePage || !(0, $9wGTI.fg)('confluence_perf_preload_livepage_assets')) return children;
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default // presentation role here to tell screen readers that this is not interactive
    ), {
        role: "presentation",
        onMouseEnter: triggerPreload,
        onFocus: triggerPreload,
        xcss: (0, $1Whri.cx)($15ad27b3337f3f82$var$styles.box)
    }, children);
};
const $15ad27b3337f3f82$var$styles = {
    box: "_4t3i1osq _1bsb1osq"
};
module.exports["LivePagePreloader"] = $15ad27b3337f3f82$export$6eca3633b04cd128;

});

parcelRegister("hXDOc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $42omo.useRef)(null);
    const preloadRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $42omo.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $42omo.isValidElement)(children) ? /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("l8oxh", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $cb0d4ce40dbff1b4$export$c5295390d6167a3e = ({ onScrollTo: onScrollTo, cursor: cursor, observerOptions: observerOptions, children: children })=>{
    const loaderTarget = (0, $42omo.useRef)(null);
    const previousCursor = (0, $42omo.useRef)(null);
    // This function is called by the IntersectionObserver API when "loaderTarget" UI element
    // changes visibility.  If it has become visible (typically by user scrolling), call our
    // scroll handler and the parent will attempt to load more data
    const handleIntersect = (0, $42omo.useCallback)((entries)=>{
        // Sometimes based on an unknown render race condition, the previous IntersectionObserver is not
        // properly cleared before the next one is observed, which causes the 0th indexed IntersectionObserver
        // to never be intersecting, which causes the onScrollTo callback to not be called when it should be.
        // To fix this just get rid of the old observer if it is not properly cleaned up.
        if (entries.length > 1) entries.shift();
        // On the first scroll the previousCursor = null and cursor is a string or undefined
        // Intersection can occur multiple times but we only call onScrollTo again if we have a new cursor.
        if (entries?.[0]?.isIntersecting && cursor !== previousCursor.current) {
            previousCursor.current = cursor;
            onScrollTo();
        }
    }, [
        onScrollTo,
        cursor
    ]);
    // IntersectionObserver detects when our target element becomes visible
    (0, $42omo.useEffect)(()=>{
        // Adding a positive 'rootMargin' and setting 'root' to the scroll container *should* trigger
        // a positive 'intersection' result (thus loading results) before this element even comes into view
        // (when it is Xpx away from the viewport). 'rootMargin' follows CSS 'margin' syntax.
        // However, this doesn't seem to be working, intersection only triggers when element is in viewport.
        // Have also attempted to pass in a ref from the table tree container instead of querying the document,
        // but that also does not work.
        // @TODO figure out what is wrong here.
        // eslint-disable-next-line
        const observer = new IntersectionObserver(handleIntersect, observerOptions);
        const target = loaderTarget?.current;
        if (target) observer.observe(target);
        return ()=>{
            if (target) observer.unobserve(target);
            observer.disconnect();
        };
    }, [
        loaderTarget,
        handleIntersect,
        observerOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cb0d4ce40dbff1b4$var$LoaderTarget, {
        ref: loaderTarget
    }, children);
};
const $cb0d4ce40dbff1b4$var$LoaderTarget = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        "data-vc": "0a-2iLy2"
    }, children));
module.exports["InfiniteScroll"] = $cb0d4ce40dbff1b4$export$c5295390d6167a3e;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $42omo.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $42omo.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("i3jcY", function(module, exports) {

const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return (window.location.search ?? '').includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("8SCD6", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $l5y3Y = parcelRequire("l5y3Y");

const $6881c6359fe8b822$export$4da9db299e81cd38 = /*#__PURE__*/ (0, $42omo.createContext)({
    isReactionsEnabled: false
});
$6881c6359fe8b822$export$4da9db299e81cd38.displayName = 'ReactionsContext';
const $6881c6359fe8b822$export$2157a4212fd7f5b1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { contentId: contentId, children: children } = t0;
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    let t1;
    if ($[0] !== isReactionsEnabled) {
        t1 = {
            isReactionsEnabled: isReactionsEnabled
        };
        $[0] = isReactionsEnabled;
        $[1] = t1;
    } else t1 = $[1];
    const reactionsContextValue = t1;
    let t2;
    if ($[2] !== children || $[3] !== reactionsContextValue) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
            value: reactionsContextValue
        }, children);
        $[2] = children;
        $[3] = reactionsContextValue;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ contentId: contentId, children: children })=>{
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    const reactionsContextValue = (0, $42omo.useMemo)(()=>({
            isReactionsEnabled: isReactionsEnabled
        }), [
        isReactionsEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
        value: reactionsContextValue
    }, children);
};
module.exports["ReactionsContext"] = $6881c6359fe8b822$export$4da9db299e81cd38;
module.exports["ReactionsProvider"] = $6881c6359fe8b822$export$2157a4212fd7f5b1;

});

parcelRegister("l5y3Y", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");


var $dPJCf = parcelRequire("dPJCf");

const $13602a0094cde4d6$export$da23010c6e2ddd94 = (contentId)=>{
    const isPDFExport = (0, $dPJCf.usePathnameMatcher)({
        selector: (pathname)=>pathname?.indexOf('/wiki/pdf/') !== -1
    });
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        },
        skip: isPDFExport
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), baseOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: 'cache-first',
        __callerPackage__: "@confluence/comments-hooks"
    });
    return !isPDFExport && Boolean(data?.webPanels?.length);
};
module.exports["useIsReactionsEnabled"] = $13602a0094cde4d6$export$da23010c6e2ddd94;

});

parcelRegister("3FlVr", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable check-file/filename-blocklist */ var $3196fb7749a17aaf$export$3b10d30805d4d939 = /*#__PURE__*/ function(ReactionLocation) {
    ReactionLocation["PAGE"] = "page";
    ReactionLocation["BLOGPOST"] = "blogpost";
    ReactionLocation["PAGE_COMMENT"] = "page-comment";
    ReactionLocation["INLINE_COMMENT"] = "inline-comment";
    ReactionLocation["EDITOR_INLINE_COMMENT"] = "editor-inline-comment";
    ReactionLocation["FEED_PAGE"] = "feed-page";
    ReactionLocation["FEED_BLOGPOST"] = "feed-blogpost";
    ReactionLocation["FEED_COMMENT"] = "feed-comment";
    ReactionLocation["OBJECT_COMMENT_FOOTER_PAGE"] = "object-comment-footer-page";
    ReactionLocation["OBJECT_COMMENT_FOOTER_BLOGPOST"] = "object-comment-footer-blogpost";
    return ReactionLocation;
}({});
var $3196fb7749a17aaf$export$d86afc9493bb8e1 = /*#__PURE__*/ function(ReactionContainerType) {
    ReactionContainerType["PAGE"] = "page";
    ReactionContainerType["BLOGPOST"] = "blogpost";
    ReactionContainerType["SPACE"] = "space";
    return ReactionContainerType;
}({});
module.exports["ReactionLocation"] = $3196fb7749a17aaf$export$3b10d30805d4d939;
module.exports["ReactionContainerType"] = $3196fb7749a17aaf$export$d86afc9493bb8e1;

});

parcelRegister("1NF8X", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $bFPHx = parcelRequire("bFPHx");


var $5Kc7f = parcelRequire("5Kc7f");


const $032b81a28ff18608$export$96ee387620e23ced = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "XLglR",
    name: "ReactionsLoader",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), {
            useAccuratePills: true,
            ...props
        });
    },
    loader: async ()=>(await (parcelRequire("fPaXE"))).Reactions
});

const $032b81a28ff18608$export$ddfc48793728637f = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "4wRdk",
    name: "ReactionsLoaderBackground",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), null);
    },
    loader: async ()=>(await (parcelRequire("fPaXE"))).Reactions
});
module.exports["ReactionsLoader"] = $032b81a28ff18608$export$96ee387620e23ced;
module.exports["ReactionsLoaderBackground"] = $032b81a28ff18608$export$ddfc48793728637f;

});

parcelRegister("bFPHx", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $b3Wpp = parcelRequire("b3Wpp");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $4FHTF = parcelRequire("4FHTF");


var $1s5hv = parcelRequire("1s5hv");


var $1qfLF = parcelRequire("1qfLF");


var $jMyy4 = parcelRequire("jMyy4");


var $ep3mz = parcelRequire("ep3mz");

const $3ae84312c23de134$var$ReactionsPlaceholderQuery = (0, $b3Wpp.default);
const $3ae84312c23de134$var$placeholderContainerStyles = null;
const $3ae84312c23de134$var$reactionPillStyles = null;
const $3ae84312c23de134$var$reactionIconStyles = null;
const $3ae84312c23de134$var$DEFAULT_NUM_PILLS = 2;
const $3ae84312c23de134$export$47a91e92112986d6 = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { useAccuratePills: useAccuratePills, onlyRenderPicker: onlyRenderPicker, customAnalyticsAttributes: customAnalyticsAttributes } = t0;
    const isSSR = window.__SSR_RENDERED__ || undefined;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = !isSSR || !useAccuratePills || !contentId || onlyRenderPicker;
    let t3;
    if ($[2] !== t1 || $[3] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($3ae84312c23de134$var$ReactionsPlaceholderQuery, {
        ...t3,
        __callerPackage__: "@confluence/reactions"
    });
    if (loading) return null;
    let t4;
    if ($[5] !== customAnalyticsAttributes || $[6] !== onlyRenderPicker) {
        t4 = (numPills)=>onlyRenderPicker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                justifyContent: "center",
                alignItems: "center",
                testId: "reactions-picker-placeholder"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4FHTF))),
                label: "",
                analyticsContext: {
                    name: "reactionsPicker",
                    ...customAnalyticsAttributes
                }
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "reactions-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _2lx2vrvc _4cvr1h6o _80om1x0y _19pkv77o _otyrv77o _18u0idpf"
                ])
            }, Array(numPills).fill("").map($3ae84312c23de134$var$_temp), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                "data-testid": "reaction-icon",
                className: (0, $gMc0m.default)([
                    "_11q7vkf5 _2rko1rr0 _1bsb1crf _4t3i1crf _18u012x7"
                ])
            }));
        $[5] = customAnalyticsAttributes;
        $[6] = onlyRenderPicker;
        $[7] = t4;
    } else t4 = $[7];
    const renderPlaceholder = t4;
    if (isSSR) {
        const numDistinctReactions = data?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji.length;
        const numReactionPills = numDistinctReactions !== undefined ? numDistinctReactions : $3ae84312c23de134$var$DEFAULT_NUM_PILLS;
        let t5;
        if ($[8] !== numReactionPills || $[9] !== renderPlaceholder) {
            t5 = renderPlaceholder(numReactionPills);
            $[8] = numReactionPills;
            $[9] = renderPlaceholder;
            $[10] = t5;
        } else t5 = $[10];
        return t5;
    } else {
        let t5;
        if ($[11] !== renderPlaceholder) {
            t5 = renderPlaceholder($3ae84312c23de134$var$DEFAULT_NUM_PILLS);
            $[11] = renderPlaceholder;
            $[12] = t5;
        } else t5 = $[12];
        return t5;
    }
};
function $3ae84312c23de134$var$_temp(_, i) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        key: i,
        "data-testid": "reactions-pill",
        className: (0, $gMc0m.default)([
            "_11q7vkf5 _2rko1rr0 _1bsbor1b _4t3i1tcg _2hwx1b66"
        ])
    });
}
module.exports["ReactionsPlaceholder"] = $3ae84312c23de134$export$47a91e92112986d6;

});

parcelRegister("b3Wpp", function(module, exports) {
/**
 * @generated SignedSource<<e034cf0adfd46c9f4d0f6acd07f7d817>>
 * @relayHash 82e58e09cb6c0ae8731a0483a5357faf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d94877ce2b304668842025392ca6cfa2689c4ad6aec2d397cee17e057f1968a6
const $41658e2724bc842d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "contentReactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ReactionsPlaceholderQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ReactionsPlaceholderQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "82e58e09cb6c0ae8731a0483a5357faf",
            "id": "d94877ce2b304668842025392ca6cfa2689c4ad6aec2d397cee17e057f1968a6",
            "metadata": {},
            "name": "ReactionsPlaceholderQuery",
            "operationKind": "query",
            "text": "query ReactionsPlaceholderQuery($contentId:ID!){content(id:$contentId){nodes{id,contentReactionsSummary{reactionsSummaryForEmoji{id}}}}}"
        }
    };
}();
$41658e2724bc842d$var$node.hash = "22ecbec40a97883abeadc26399cf4367";
var $41658e2724bc842d$export$2e2bcd8739ae039 = $41658e2724bc842d$var$node;
module.exports["default"] = $41658e2724bc842d$export$2e2bcd8739ae039;

});

parcelRegister("5Kc7f", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");


var $eTjjM = parcelRequire("eTjjM");

const $aba7293523a7a5b0$var$styles = {
    emojiPlaceholderBackground: "_bfhkizff",
    wrapperStyles: "_19bvu2gc _u5f3utpp _19pk1i6y",
    countSkeletonStyles: "_2rko1rr0 _1bsb19bv _4t3i19bv _bfhkizff"
};
const $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS = {
    shortName: 'loading-placeholder',
    size: 16,
    xcss: $aba7293523a7a5b0$var$styles.emojiPlaceholderBackground
};
const $aba7293523a7a5b0$export$d85d0301f09f2005 = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.050",
            alignBlock: "center",
            className: (0, $gMc0m.default)([
                $aba7293523a7a5b0$var$styles.wrapperStyles
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $aba7293523a7a5b0$var$styles.countSkeletonStyles
            ]),
            "data-vc": "h--GjALP"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["ReactionsSummaryViewPlaceholder"] = $aba7293523a7a5b0$export$d85d0301f09f2005;

});

parcelRegister("fPaXE", function(module, exports) {

let $b8541f13f35210d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b8541f13f35210d9$var$load("lVrrs"),
    $b8541f13f35210d9$var$load("3NkiL"),
    $b8541f13f35210d9$var$load("hsLOm"),
    $b8541f13f35210d9$var$load("jgDEy"),
    $b8541f13f35210d9$var$load("6wr18"),
    $b8541f13f35210d9$var$load("3EXzu"),
    $b8541f13f35210d9$var$load("ffEVr"),
    $b8541f13f35210d9$var$load("7EorR"),
    $b8541f13f35210d9$var$load("Wowvf"),
    $b8541f13f35210d9$var$load("hxlWB"),
    $b8541f13f35210d9$var$load("1C6qR")
]).then(()=>parcelRequire('kTkGJ'));

});

parcelRegister("di8q4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("9E31d"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fT2ta = parcelRequire("fT2ta");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $frIzR.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $gMc0m.default)([
                    "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
                ]),
                "data-vc": "fkPkwcAA"
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("9E31d", function(module, exports) {

let $705a30e3f259727c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $705a30e3f259727c$var$load("5JkDi"),
    $705a30e3f259727c$var$load("lVrrs"),
    $705a30e3f259727c$var$load("3NkiL"),
    $705a30e3f259727c$var$load("hCiBy"),
    $705a30e3f259727c$var$load("6wr18"),
    $705a30e3f259727c$var$load("ffEVr"),
    $705a30e3f259727c$var$load("ajMch"),
    $705a30e3f259727c$var$load("hxlWB"),
    $705a30e3f259727c$var$load("kFiBp"),
    $705a30e3f259727c$var$load("4qVsX"),
    $705a30e3f259727c$var$load("jPZn6"),
    $705a30e3f259727c$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $e0ycV = parcelRequire("e0ycV");


var $j7K0C = parcelRequire("j7K0C");


var $jRsqV = parcelRequire("jRsqV");


var $8jHAi = parcelRequire("8jHAi");


var $9RVmI = parcelRequire("9RVmI");


var $ZDq1z = parcelRequire("ZDq1z");


var $6B0jU = parcelRequire("6B0jU");


var $g5QRf = parcelRequire("g5QRf");


var $5tmwS = parcelRequire("5tmwS");


var $cHaKZ = parcelRequire("cHaKZ");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1, isMarkdownMode: t2 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const isMarkdownMode = t2 === undefined ? false : t2;
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t3 = emoji || "";
        let t4;
        if ($[0] !== height || $[1] !== t3 || $[2] !== type) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t3,
                contentType: type,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = height;
            $[1] = t3;
            $[2] = type;
            $[3] = t4;
        } else t4 = $[3];
        return t4;
    }
    const actualType = isLivePage && isMarkdownMode ? "markdown" : isLivePage ? "liveDoc" : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    let t3;
    if ($[4] !== Icon || $[5] !== color || $[6] !== label.id) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[4] = Icon;
        $[5] = color;
        $[6] = label.id;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16, isMarkdownMode: isMarkdownMode = false })=>{
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: type,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    const actualType = isLivePage && isMarkdownMode ? 'markdown' : isLivePage ? 'liveDoc' : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $aXWIB.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    slide: {
        id: "icons.content-icon.label.slide",
        defaultMessage: "Slide"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    },
    markdown: {
        id: "icons.content-icon.label.markdown",
        defaultMessage: "Markdown"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    slide: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5QRf))),
        label: $b2e0c504f331f5cc$var$i18n.slide
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHaKZ))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jRsqV))),
        label: $b2e0c504f331f5cc$var$i18n.note
    },
    markdown: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($j7K0C))),
        label: $b2e0c504f331f5cc$var$i18n.markdown
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("e0ycV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a32b99a806197ff2$var$_react = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("42omo")));

var $a32b99a806197ff2$var$_baseNew = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a32b99a806197ff2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a32b99a806197ff2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a32b99a806197ff2$var$_react.default.createElement($a32b99a806197ff2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a32b99a806197ff2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a32b99a806197ff2$var$_default = module.exports.default = $a32b99a806197ff2$var$PageLiveDocIcon;

});

parcelRegister("j7K0C", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ac59572d5177720dc1f7db0f6832687d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dec25c3798de43c2$var$_react = $dec25c3798de43c2$var$_interopRequireDefault((parcelRequire("42omo")));

var $dec25c3798de43c2$var$_baseNew = $dec25c3798de43c2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $dec25c3798de43c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FileMarkdown".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing a Markdown document filetype.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dec25c3798de43c2$var$FileMarkdownIcon = (props)=>/*#__PURE__*/ $dec25c3798de43c2$var$_react.default.createElement($dec25c3798de43c2$var$_baseNew.default, Object.assign({
        name: "FileMarkdownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12 8.5V5.25c0-.519-.206-1.017-.573-1.384L8.134.573A1.96 1.96 0 0 0 6.75 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h.5v-1.5H2a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v2.5zM7.5 2.06 9.94 4.5H7.5z"/><path fill="currentcolor" d="M5.125 10a.75.75 0 0 1 .661.396L7 12.66l1.214-2.265A.75.75 0 0 1 8.875 10h.375a.75.75 0 0 1 .75.75V16H8.5v-2.962l-.839 1.566a.75.75 0 0 1-1.322 0L5.5 13.039V16H4v-5.25a.75.75 0 0 1 .75-.75zm9.125 0v3.042l.565-.402a.75.75 0 0 1 1 1.104l-1.75 2a.75.75 0 0 1-1.13 0l-1.75-2a.75.75 0 0 1 1-1.104l.565.402V10z"/>`
    }, props));
$dec25c3798de43c2$var$FileMarkdownIcon.displayName = 'FileMarkdownIcon';
var $dec25c3798de43c2$var$_default = module.exports.default = $dec25c3798de43c2$var$FileMarkdownIcon;

});

parcelRegister("jRsqV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e75905caaf7b6b39$var$_react = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("42omo")));

var $e75905caaf7b6b39$var$_baseNew = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e75905caaf7b6b39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e75905caaf7b6b39$var$NotepadIcon = (props)=>/*#__PURE__*/ $e75905caaf7b6b39$var$_react.default.createElement($e75905caaf7b6b39$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$e75905caaf7b6b39$var$NotepadIcon.displayName = 'NotepadIcon';
var $e75905caaf7b6b39$var$_default = module.exports.default = $e75905caaf7b6b39$var$NotepadIcon;

});

parcelRegister("g5QRf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8306b821ef694f38a906a83337269c35>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb761d6fd7d44f19$var$_react = $bb761d6fd7d44f19$var$_interopRequireDefault((parcelRequire("42omo")));

var $bb761d6fd7d44f19$var$_baseNew = $bb761d6fd7d44f19$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $bb761d6fd7d44f19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb761d6fd7d44f19$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $bb761d6fd7d44f19$var$_react.default.createElement($bb761d6fd7d44f19$var$_baseNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$bb761d6fd7d44f19$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $bb761d6fd7d44f19$var$_default = module.exports.default = $bb761d6fd7d44f19$var$AiGenerativeSlidesIcon;

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("lpPVE", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $71GjD = parcelRequire("71GjD");

const $d9de10c6417158bd$export$d347e131abf45bea = (href, featureCodes)=>{
    if (!featureCodes.length) return href;
    const [path, queryString] = href.split('?');
    const searchParams = new URLSearchParams(queryString);
    // If the query param already exists, append the new feature codes to the existing ones
    if (searchParams.has((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
        const existingFeatureCodes = searchParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM)) || '';
        const newFeatureCodes = [
            ...new Set([
                ...existingFeatureCodes.split(','),
                ...featureCodes
            ])
        ];
        searchParams.set((0, $71GjD.FEATURE_CODES_QUERY_PARAM), newFeatureCodes.join(','));
    } else searchParams.append((0, $71GjD.FEATURE_CODES_QUERY_PARAM), featureCodes.join(','));
    const newQueryString = searchParams.toString();
    return newQueryString ? `${path}?${newQueryString}` : path;
};
const $d9de10c6417158bd$export$3c2127388df02347 = (queryParams)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_insights_feature_attribution')) return {
        from: undefined
    };
    const featureCodes = queryParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM))?.split(',');
    const fromCode = featureCodes?.find((code)=>Object.values((0, $71GjD.FeatureCode)).includes(code));
    return {
        from: fromCode
    };
};
const $d9de10c6417158bd$export$241f453208292937 = (history, location)=>{
    if (!location?.search?.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) return;
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete((0, $71GjD.FEATURE_CODES_QUERY_PARAM));
    const search = searchParams.toString();
    history?.replace?.({
        ...location,
        search: search ? `?${search}` : ''
    });
};
const $d9de10c6417158bd$export$866aaa0a921ee13d = (existingFeatureCodes, featureCodeToCheck)=>{
    return existingFeatureCodes.includes(featureCodeToCheck);
};
const $d9de10c6417158bd$export$84f5742c2ddda28f = (existingFeatureCodes, featureCodeToAdd)=>{
    if ($d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToAdd)) return existingFeatureCodes;
    return [
        ...existingFeatureCodes,
        featureCodeToAdd
    ];
};
const $d9de10c6417158bd$export$f2b1b8a892016485 = (existingFeatureCodes, featureCodeToRemove)=>{
    if (!$d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToRemove)) return existingFeatureCodes;
    return existingFeatureCodes.filter((code)=>code !== featureCodeToRemove);
};
module.exports["generatePathWithFeatureCodesQueryParam"] = $d9de10c6417158bd$export$d347e131abf45bea;
module.exports["getFeatureCodes"] = $d9de10c6417158bd$export$3c2127388df02347;
module.exports["hideFeatureCodesQueryParam"] = $d9de10c6417158bd$export$241f453208292937;

});

parcelRegister("71GjD", function(module, exports) {
/**
 * Feature attribution enum for tracking feature usage/attribution
 *
 * @note All feature codes are intended to be 8 characters or less in length
 *
 * @see https://hello.atlassian.net/wiki/x/lQxt9Q
 */ var $9d2fac30cbee1d6f$export$661babcb078ff919 = /*#__PURE__*/ function(FeatureCode) {
    /** Confluence Home Feeds (Following and Popular) **/ FeatureCode["HOME_FEED"] = "HOMEFEED";
    /** Confluence End of Page Recommendations (Related Pages) **/ FeatureCode["EOP_REC"] = "EOPREC";
    /** Confluence End of Page Recommendations (Related Pages) Hover Card **/ FeatureCode["EOP_REC_CARD"] = "EOPCARD";
    /** Confluence Page Tree **/ FeatureCode["PAGE_TREE"] = "PAGETREE";
    /** Confluence Page Tree Card **/ FeatureCode["PAGE_TREE_CARD"] = "TREECARD";
    /** Following Feed email **/ FeatureCode["FOLLOWING_FEED_EMAIL"] = "FLLWEML";
    /** Popular Feed email **/ FeatureCode["POPULAR_FEED_EMAIL"] = "PPLREML";
    FeatureCode["ADMIN_KEY_EMAIL"] = "ADMINEML";
    FeatureCode["ATTACHMENT_EMAILS"] = "ATTCHEML";
    FeatureCode["BATCH_EMAIL"] = "BATCHEML";
    FeatureCode["BLOG_CREATED_EMAIL"] = "BLOGEML";
    FeatureCode["BULK_ARCHIVE_EMAIL"] = "BLKAREML";
    FeatureCode["BULK_OWNER_CHANGE_EMAIL"] = "BLKOWEML";
    FeatureCode["CONFLUENCE_WRAPPED_EMAIL"] = "WRAPEML";
    FeatureCode["CONTACT_ADMINISTRATORS_EMAIL"] = "CTADMEML";
    FeatureCode["CONTENT_OWNER_CHANGE_EMAIL"] = "OWNREML";
    FeatureCode["CONTENT_REDACTION_EMAIL"] = "RDCTDEML";
    FeatureCode["EXCO_ADDED_TO_SPACE_EMAIL"] = "EXCASEML";
    FeatureCode["EXCO_REQUEST_ACCESS_EMAIL"] = "EXCRAEML";
    FeatureCode["EXCO_SPACE_READY_EMAIL"] = "EXCSREML";
    FeatureCode["IMPORTER_NOTIFICATIONS"] = "IMPRTNTF";
    FeatureCode["LIVE_PAGE_PUBLISHED_EMAIL"] = "LPPEML";
    FeatureCode["MENTIONS_EMAIL"] = "MNTNEML";
    FeatureCode["PAGE_CREATED_EMAIL"] = "PAGEEML";
    FeatureCode["REMINDER_EMAIL"] = "RMNDREML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_EMAILS"] = "REQACEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_SLACK"] = "REQACSLK";
    FeatureCode["TASKS_EMAIL"] = "TASKEML";
    FeatureCode["TEAM_CALENDAR_EMAIL"] = "CLNDREML";
    FeatureCode["WHITEBOARD_CREATED_EMAIL"] = "WTBRDEML";
    FeatureCode["CONTENT_REDACTION_IN_APP"] = "RDCTDAPP";
    FeatureCode["DAILY_DIGEST_EMAIL"] = "DIGSTEML";
    FeatureCode["MENTIONS_REMINDER_EMAIL"] = "MNTNREML";
    FeatureCode["PUBLIC_LINK_EMAIL"] = "PBLNKEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_IN_APP"] = "REQACAPP";
    FeatureCode["SHARE_AND_RESTRICT_DIALOG"] = "SRDIALOG";
    FeatureCode["ROVO_CHAT_LINK"] = "ROVOCHAT";
    FeatureCode["ROVO_EXTENSION_LINK"] = "ROVOEXT";
    FeatureCode["SEND_TO_DESKTOP_EMAIL"] = "SNDDSKEML";
    return FeatureCode;
}({});
const $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd = 'atl_f';
const $9d2fac30cbee1d6f$export$384cf7f2010cb469 = 'confluence_frontend_insights_feature_attribution';
module.exports["FeatureCode"] = $9d2fac30cbee1d6f$export$661babcb078ff919;
module.exports["FEATURE_CODES_QUERY_PARAM"] = $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd;

});

parcelRegister("7uUnJ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $1f248bc2c3d9f18f$export$ef69bde44521bba7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Q9h_Y",
    name: "LiveDocsIconTile",
    loader: async ()=>(await (parcelRequire("3bLAJ"))).LiveDocsIconTile
});
module.exports["LiveDocsIconTile"] = $1f248bc2c3d9f18f$export$ef69bde44521bba7;

});

parcelRegister("3bLAJ", function(module, exports) {

let $252750d8ae3d7e32$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $252750d8ae3d7e32$var$load("dYtBN"),
    $252750d8ae3d7e32$var$load("dek7I"),
    $252750d8ae3d7e32$var$load("e19Zv")
]).then(()=>parcelRequire('nSMSQ'));

});

parcelRegister("bvJMy", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gI8uy = parcelRequire("gI8uy");


var $cOrQJ = parcelRequire("cOrQJ");

const $82c992371ed08bb5$export$fd017b91d8968d63 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { label: label, size: size, testId: testId, spacing: spacing } = t0;
    const theme = (0, $cOrQJ.default)();
    const primaryColor = theme.colorMode === "dark" ? "var(--ds-icon-accent-yellow, #B38600)" : "var(--ds-icon-accent-orange, #E06C00)";
    let t1;
    if ($[0] !== size) {
        t1 = size && {
            size: size
        };
        $[0] = size;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== testId) {
        t2 = testId && {
            testId: testId
        };
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== label || $[5] !== primaryColor || $[6] !== spacing || $[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gI8uy))), {
            label: label,
            color: primaryColor,
            ...t1,
            ...t2,
            spacing: spacing
        });
        $[4] = label;
        $[5] = primaryColor;
        $[6] = spacing;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ label: label, size: size, testId: testId, spacing: spacing })=>{
    const theme = (0, $cOrQJ.default)();
    const primaryColor = (0, $42omo.useMemo)(()=>{
        return theme.colorMode === 'dark' ? "var(--ds-icon-accent-yellow, #B38600)" : "var(--ds-icon-accent-orange, #E06C00)";
    }, [
        theme.colorMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gI8uy))), {
        label: label,
        color: primaryColor,
        ...size && {
            size: size
        },
        ...testId && {
            testId: testId
        },
        spacing: spacing
    });
};
module.exports["StarSelectedIcon"] = $82c992371ed08bb5$export$fd017b91d8968d63;

});

parcelRegister("gfIPU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("dkIiA", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["LIVE"] = "LIVE";
    return ConfluencePageSubType;
}({});
var $ee5b1a976329bd8a$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
module.exports["ConfluencePageSubType"] = $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8;
module.exports["GraphQLContentStatus"] = $ee5b1a976329bd8a$export$b634e5de755b7d35;

});

parcelRegister("bZSO8", function(module, exports) {

var $c3Qwv = parcelRequire("c3Qwv");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $hQnHK = parcelRequire("hQnHK");


var $98wxI = parcelRequire("98wxI");

const $e7afa99020494478$var$queryParamKeys = {
    subType: 'subType',
    parentPageId: 'parentPageId',
    title: 'title',
    draftId: 'draftId',
    linkCreation: 'linkCreation',
    fromPageId: 'fromPageId',
    // used by createpage.action endpoint.
    spaceKey: 'spaceKey',
    source: 'source',
    withFallback: 'withFallback',
    openTemplatesGallery: 'openTemplatesGallery',
    paywallStatus: 'paywallStatus',
    deactivationIdentifier: 'deactivationIdentifier',
    openJiraImportTool: (0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM),
    cloudId: (0, $hQnHK.CLOUD_ID),
    projectUuid: (0, $hQnHK.PROJECT_UUID),
    autoImportJiraIssues: (0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM),
    jiraImportJql: (0, $hQnHK.JIRA_IMPORT_JQL),
    insertTemplateWithKey: (0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM),
    smartLinkCreateSource: 'smartLinkCreateSource',
    smartLinkEmbedUrl: 'smartLinkEmbedUrl',
    restoreVersionContentId: 'restoreVersionContentId',
    openTemplatePicker: 'openTemplatePicker',
    journeyId: 'journeyId',
    templateKey: 'templateKey',
    onboardingEntryPoint: 'onboardingEntryPoint'
};
const $e7afa99020494478$var$SUPPORTED_CONTENT_TYPES = [
    'page',
    'blog',
    'whiteboard',
    'database',
    'smartLinkEmbed',
    'folder'
];
const $e7afa99020494478$export$b3086acbf0304043 = (options)=>{
    const queryParams = {};
    if ('subType' in options && options.subType) queryParams[$e7afa99020494478$var$queryParamKeys.subType] = options.subType;
    if ('spaceKey' in options && options.spaceKey) queryParams[$e7afa99020494478$var$queryParamKeys.spaceKey] = options.spaceKey;
    if ('parentPageId' in options && options.parentPageId) queryParams[$e7afa99020494478$var$queryParamKeys.parentPageId] = options.parentPageId;
    if ('openTemplatePicker' in options && options.openTemplatePicker !== undefined) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatePicker] = options.openTemplatePicker;
    if ('title' in options && options.title) queryParams[$e7afa99020494478$var$queryParamKeys.title] = options.title;
    if ('draftId' in options && options.draftId) queryParams[$e7afa99020494478$var$queryParamKeys.draftId] = options.draftId;
    if ('linkCreation' in options && options.linkCreation) queryParams[$e7afa99020494478$var$queryParamKeys.linkCreation] = options.linkCreation;
    if ('withFallback' in options && options.withFallback) queryParams[$e7afa99020494478$var$queryParamKeys.withFallback] = options.withFallback;
    if ('openTemplatesGallery' in options && options.openTemplatesGallery) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatesGallery] = options.openTemplatesGallery;
    if ('source' in options && options.source) queryParams[$e7afa99020494478$var$queryParamKeys.source] = options.source;
    if ('paywallStatus' in options && options.paywallStatus) queryParams[$e7afa99020494478$var$queryParamKeys.paywallStatus] = options.paywallStatus;
    if ('deactivationIdentifier' in options && options.deactivationIdentifier) queryParams[$e7afa99020494478$var$queryParamKeys.deactivationIdentifier] = options.deactivationIdentifier;
    if ((0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM) in options && options.openJiraImportTool) queryParams[$e7afa99020494478$var$queryParamKeys.openJiraImportTool] = options.openJiraImportTool;
    if ((0, $hQnHK.CLOUD_ID) in options && options.cloudId) queryParams[$e7afa99020494478$var$queryParamKeys.cloudId] = options.cloudId;
    if ((0, $hQnHK.PROJECT_UUID) in options && options.projectUuid) queryParams[$e7afa99020494478$var$queryParamKeys.projectUuid] = options.projectUuid;
    if ((0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM) in options && options.autoImportJiraIssues) queryParams[$e7afa99020494478$var$queryParamKeys.autoImportJiraIssues] = options.autoImportJiraIssues;
    if ((0, $hQnHK.JIRA_IMPORT_JQL) in options && options.jiraImportJql) queryParams[$e7afa99020494478$var$queryParamKeys.jiraImportJql] = options.jiraImportJql;
    if ((0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM) in options && options.insertTemplateWithKey) queryParams[$e7afa99020494478$var$queryParamKeys.insertTemplateWithKey] = options.insertTemplateWithKey;
    if ('smartLinkCreateSource' in options && options.smartLinkCreateSource) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkCreateSource] = options.smartLinkCreateSource;
    if ('smartLinkEmbedUrl' in options && options.smartLinkEmbedUrl) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl] = options.smartLinkEmbedUrl;
    if ('restoreVersionContentId' in options && options.restoreVersionContentId) queryParams[$e7afa99020494478$var$queryParamKeys.restoreVersionContentId] = options.restoreVersionContentId;
    if ('journeyId' in options && options.journeyId) queryParams[$e7afa99020494478$var$queryParamKeys.journeyId] = options.journeyId;
    if ('templateKey' in options && options.templateKey) queryParams[$e7afa99020494478$var$queryParamKeys.templateKey] = options.templateKey;
    return (0, $1NBp8.CREATE_CONTENT).toUrl({
        contentType: options.contentType
    }, {
        query: queryParams
    });
};
const $e7afa99020494478$var$useContentType = (0, $dPJCf.createRouteParamHook)('contentType');
const $e7afa99020494478$export$963d972ae7433a64 = ()=>{
    const contentType = $e7afa99020494478$var$useContentType();
    if ($e7afa99020494478$var$SUPPORTED_CONTENT_TYPES.includes(contentType)) {
        if (contentType === "folder") return;
        return contentType;
    }
};
const $e7afa99020494478$export$67c4cee80a3410cd = (queryParams)=>{
    const subType = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.subType);
    const spaceKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.spaceKey);
    const parentPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.parentPageId);
    const title = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.title);
    const draftId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.draftId);
    const linkCreation = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.linkCreation);
    const fromPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.fromPageId);
    const withFallback = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.withFallback) ? true : undefined;
    const openTemplatesGallery = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatesGallery) ? true : undefined;
    const source = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.source);
    const deactivationIdentifier = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.deactivationIdentifier);
    const paywallStatus = (0, $98wxI.PaywallStatus)[(0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.paywallStatus) || ''];
    const openJiraImportTool = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openJiraImportTool) ? true : undefined;
    const cloudId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.cloudId);
    const projectUuid = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.projectUuid);
    const autoImportJiraIssues = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.autoImportJiraIssues) ? true : undefined;
    const jiraImportJql = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.jiraImportJql);
    const insertTemplateWithKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.insertTemplateWithKey) ?? undefined;
    const smartLinkCreateSource = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkCreateSource);
    const smartLinkEmbedUrl = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl);
    const restoreVersionContentId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.restoreVersionContentId);
    const journeyId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.journeyId);
    const onboardingEntryPoint = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.onboardingEntryPoint);
    const openTemplatePickerParam = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatePicker);
    const openTemplatePicker = openTemplatePickerParam ? openTemplatePickerParam === 'true' : undefined;
    const templateKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.templateKey);
    return {
        subType: subType,
        spaceKey: spaceKey,
        parentPageId: parentPageId || fromPageId,
        title: // prefer new parameter over old parameter
        title,
        draftId: draftId,
        linkCreation: linkCreation,
        withFallback: withFallback,
        source: source,
        paywallStatus: paywallStatus,
        deactivationIdentifier: deactivationIdentifier,
        openJiraImportTool: openJiraImportTool,
        cloudId: cloudId,
        projectUuid: projectUuid,
        autoImportJiraIssues: autoImportJiraIssues,
        jiraImportJql: jiraImportJql,
        insertTemplateWithKey: insertTemplateWithKey,
        smartLinkCreateSource: smartLinkCreateSource,
        smartLinkEmbedUrl: smartLinkEmbedUrl,
        restoreVersionContentId: restoreVersionContentId,
        openTemplatesGallery: openTemplatesGallery,
        openTemplatePicker: openTemplatePicker,
        journeyId: journeyId,
        onboardingEntryPoint: onboardingEntryPoint,
        templateKey: templateKey
    };
};
var $e7afa99020494478$export$f9ad0711e89cafb5 = /*#__PURE__*/ function(ExperienceResolution) {
    ExperienceResolution[ExperienceResolution["ABORT"] = 0] = "ABORT";
    ExperienceResolution[ExperienceResolution["SUCCEED"] = 1] = "SUCCEED";
    return ExperienceResolution;
}({});
module.exports["buildCreationLink"] = $e7afa99020494478$export$b3086acbf0304043;
module.exports["useCreateRouteSupportedContentType"] = $e7afa99020494478$export$963d972ae7433a64;
module.exports["parseQueryParams"] = $e7afa99020494478$export$67c4cee80a3410cd;
module.exports["ExperienceResolution"] = $e7afa99020494478$export$f9ad0711e89cafb5;

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
const $0037b6bfd6daf741$export$148d5c0fade1be8d = 'slides';
const $0037b6bfd6daf741$export$8896acdfcdaf8f6d = 'hideBorder';
const $0037b6bfd6daf741$export$39abeb28b3f870c6 = 'embed';
const $0037b6bfd6daf741$export$f0568a870cb93dbd = 'nativeEmbedView';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;
module.exports["SLIDES_QUERY_PARAM"] = $0037b6bfd6daf741$export$148d5c0fade1be8d;
module.exports["HIDE_BORDER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8896acdfcdaf8f6d;
module.exports["EMBED_QUERY_PARAM"] = $0037b6bfd6daf741$export$39abeb28b3f870c6;
module.exports["NATIVE_EMBED_VIEW_QUERY_PARAM"] = $0037b6bfd6daf741$export$f0568a870cb93dbd;

});

parcelRegister("98wxI", function(module, exports) {
var $5046ea0ba58442ff$export$d9669dcdbd1161d9 = /*#__PURE__*/ function(PaywallStatus) {
    PaywallStatus["ACTIVE"] = "ACTIVE";
    PaywallStatus["DEACTIVATED"] = "DEACTIVATED";
    PaywallStatus["UNSET"] = "UNSET";
    return PaywallStatus;
}({});
module.exports["PaywallStatus"] = $5046ea0ba58442ff$export$d9669dcdbd1161d9;

});

parcelRegister("g4evd", function(module, exports) {
/**
 * @generated SignedSource<<1e2e0d87fd3938dd426e067e8d68827d>>
 * @relayHash 40ddeb0ef9f72faff15ea2ef539798b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c36b3d08c0171b7af6e2e8fb696bc2e9936c087ca8d85dcb9bd02a1f8349a81
const $8f22a426de8950e5$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "ScalarField",
                    "name": "feedTab"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeedTypeSelectorRefreshQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeedTypeSelectorRefreshQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "40ddeb0ef9f72faff15ea2ef539798b5",
            "id": "1c36b3d08c0171b7af6e2e8fb696bc2e9936c087ca8d85dcb9bd02a1f8349a81",
            "metadata": {},
            "name": "useFeedTypeSelectorRefreshQuery",
            "operationKind": "query",
            "text": "query useFeedTypeSelectorRefreshQuery{userPreferences{__typename,feedTab}}"
        }
    };
}();
$8f22a426de8950e5$var$node.hash = "6ca55df8184dd78031693e2b650f878d";
var $8f22a426de8950e5$export$2e2bcd8739ae039 = $8f22a426de8950e5$var$node;
module.exports["default"] = $8f22a426de8950e5$export$2e2bcd8739ae039;

});

parcelRegister("3cztU", function(module, exports) {
/**
 * @generated SignedSource<<efb1ad4638625583ec721b79a8cce4bb>>
 * @relayHash 027916460fcdde8e42909a043df68ff0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7d8d63b63a6f37feaf8f7e4d03bdb99ff0c74bf97fba9f1d1eb98bc12f44fcf1
const $a845950f81d03c88$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": "relevant",
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "recentActionsCount"
    }, v5 = {
        "kind": "ScalarField",
        "name": "datetime"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "groupSize"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v11 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "KnownUser"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "UnknownUser"
    }, v13 = [
        v6 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ], v14 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v13 /*: any*/ 
    }, v15 = {
        "kind": "ScalarField",
        "name": "version"
    }, v16 = [
        v15 /*: any*/ ,
        v14 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = [
        {
            "kind": "ScalarField",
            "name": "webui"
        }
    ], v19 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v18 /*: any*/ 
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineText"
            }
        ],
        "type": "InlineComment"
    }, v21 = {
        "kind": "ScalarField",
        "name": "value"
    }, v22 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            v21 /*: any*/ 
        ],
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v23 = {
        "kind": "ScalarField",
        "name": "source"
    }, v24 = {
        "kind": "ScalarField",
        "name": "title"
    }, v25 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v26 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v17 /*: any*/ ,
                    v21 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v27 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    }, v28 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 350
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:350)"
    }, v29 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v18 /*: any*/ 
    }, v30 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v31 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v17 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v32 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v33 = {
        "concreteType": "FeedPageInformation",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v34 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "spaces",
        "plural": true,
        "selections": [
            v17 /*: any*/ 
        ]
    }, v35 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "ABSOLUTE"
                    }
                ],
                "kind": "ScalarField",
                "name": "path",
                "storageKey": "path(type:\"ABSOLUTE\")"
            }
        ]
    }, v36 = {
        "kind": "ScalarField",
        "name": "servingRecommendations"
    }, v37 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v38 = [
        v37 /*: any*/ ,
        v6 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ], v39 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v38 /*: any*/ 
    }, v40 = [
        v15 /*: any*/ ,
        v39 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useFollowingFeedWithSortByStorageFeedContentQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedFeed",
                    "kind": "LinkedField",
                    "name": "feed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "FeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summaryLineUpdate",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v14 /*: any*/ 
                                            ],
                                            "type": "FeedEventCreate"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v16 /*: any*/ ,
                                            "type": "FeedEventEdit"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v16 /*: any*/ ,
                                            "type": "FeedEventEditLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v16 /*: any*/ ,
                                            "type": "FeedEventPublishLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "comment",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "location",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "FeedEventComment"
                                        }
                                    ]
                                },
                                v23 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v13 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                v30 /*: any*/ 
                                            ]
                                        },
                                        v31 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v33 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "FollowingFeedGetUserConfig",
                    "kind": "LinkedField",
                    "name": "getFeedUserConfig",
                    "plural": false,
                    "selections": [
                        v34 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "users",
                            "plural": true,
                            "selections": [
                                v8 /*: any*/ ,
                                v35 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        },
                        v36 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useFollowingFeedWithSortByStorageFeedContentQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedFeed",
                    "kind": "LinkedField",
                    "name": "feed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "FeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summaryLineUpdate",
                                    "plural": false,
                                    "selections": [
                                        v37 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v39 /*: any*/ 
                                            ],
                                            "type": "FeedEventCreate"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v40 /*: any*/ ,
                                            "type": "FeedEventEdit"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v40 /*: any*/ ,
                                            "type": "FeedEventEditLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v40 /*: any*/ ,
                                            "type": "FeedEventPublishLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v39 /*: any*/ ,
                                                {
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "comment",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "location",
                                                            "plural": false,
                                                            "selections": [
                                                                v37 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "FeedEventComment"
                                        }
                                    ]
                                },
                                v23 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v38 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v37 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                v30 /*: any*/ 
                                            ]
                                        },
                                        v31 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v33 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "FollowingFeedGetUserConfig",
                    "kind": "LinkedField",
                    "name": "getFeedUserConfig",
                    "plural": false,
                    "selections": [
                        v34 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "users",
                            "plural": true,
                            "selections": [
                                v37 /*: any*/ ,
                                v8 /*: any*/ ,
                                v35 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        },
                        v36 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "027916460fcdde8e42909a043df68ff0",
            "id": "7d8d63b63a6f37feaf8f7e4d03bdb99ff0c74bf97fba9f1d1eb98bc12f44fcf1",
            "metadata": {},
            "name": "useFollowingFeedWithSortByStorageFeedContentQuery",
            "operationKind": "query",
            "text": "query useFollowingFeedWithSortByStorageFeedContentQuery($first:Int,$after:String,$sortBy:String=\"relevant\"){feed(first:$first,after:$after,sortBy:$sortBy){nodes{recentActionsCount,summaryLineUpdate{__typename,datetime,type,groupSize,...on FeedEventCreate{user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventEdit{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventEditLive{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventPublishLive{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventComment{user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},comment{id,links{webui},location{__typename,type,...on InlineComment{inlineText}},body(representation:ATLAS_DOC_FORMAT){value}}}},source,content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},contentProperties{latest{generatedBy}},excerpt(length:350),links{webui},history{createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}},createdDate},space{alias,id,key,name},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}}}},pageInfo{hasNextPage,endCursor}},getFeedUserConfig{spaces{id},users{__typename,displayName,profilePicture{path(type:ABSOLUTE)},...on KnownUser{accountId},...on UnknownUser{accountId}},servingRecommendations}}"
        }
    };
}();
$a845950f81d03c88$var$node.hash = "5d3db85b333af4987211e782a3dccf15";
var $a845950f81d03c88$export$2e2bcd8739ae039 = $a845950f81d03c88$var$node;
module.exports["default"] = $a845950f81d03c88$export$2e2bcd8739ae039;

});

parcelRegister("Yc1IN", function(module, exports) {
/**
 * @generated SignedSource<<7ed0864740dd6ae8885e1ca420a28f05>>
 * @relayHash 5fa23ad64581bf268c729651d6bf4ddb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e98aed0963d75eecbe46cb82c413f1c7dab51ea1ec1170145ad8a9a88b6c3de0
const $ffca0a52a06c83ff$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": "relevant",
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "recentActionsCount"
    }, v5 = {
        "kind": "ScalarField",
        "name": "datetime"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "groupSize"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v11 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "KnownUser"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "UnknownUser"
    }, v13 = [
        v6 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ], v14 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v13 /*: any*/ 
    }, v15 = {
        "kind": "ScalarField",
        "name": "version"
    }, v16 = [
        v15 /*: any*/ ,
        v14 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = [
        {
            "kind": "ScalarField",
            "name": "webui"
        }
    ], v19 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v18 /*: any*/ 
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineText"
            }
        ],
        "type": "InlineComment"
    }, v21 = {
        "kind": "ScalarField",
        "name": "value"
    }, v22 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            v21 /*: any*/ 
        ],
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v23 = {
        "kind": "ScalarField",
        "name": "source"
    }, v24 = {
        "kind": "ScalarField",
        "name": "title"
    }, v25 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v26 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v17 /*: any*/ ,
                    v21 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v27 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    }, v28 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 350
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:350)"
    }, v29 = {
        "concreteType": "ConfluenceContentAISummaryResponse",
        "kind": "LinkedField",
        "name": "aiProperty",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "objectData"
            },
            {
                "kind": "ScalarField",
                "name": "createdAt"
            },
            {
                "kind": "ScalarField",
                "name": "errorMessage"
            }
        ]
    }, v30 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v18 /*: any*/ 
    }, v31 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v32 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v17 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v33 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v34 = {
        "concreteType": "FeedPageInformation",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v35 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "spaces",
        "plural": true,
        "selections": [
            v17 /*: any*/ 
        ]
    }, v36 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "ABSOLUTE"
                    }
                ],
                "kind": "ScalarField",
                "name": "path",
                "storageKey": "path(type:\"ABSOLUTE\")"
            }
        ]
    }, v37 = {
        "kind": "ScalarField",
        "name": "servingRecommendations"
    }, v38 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v39 = [
        v38 /*: any*/ ,
        v6 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ], v40 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v39 /*: any*/ 
    }, v41 = [
        v15 /*: any*/ ,
        v40 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "FollowingFeedWithSortByStorageSnippetsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedFeed",
                    "kind": "LinkedField",
                    "name": "feed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "FeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summaryLineUpdate",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v14 /*: any*/ 
                                            ],
                                            "type": "FeedEventCreate"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v16 /*: any*/ ,
                                            "type": "FeedEventEdit"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v16 /*: any*/ ,
                                            "type": "FeedEventEditLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v16 /*: any*/ ,
                                            "type": "FeedEventPublishLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "comment",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "location",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "FeedEventComment"
                                        }
                                    ]
                                },
                                v23 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v13 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                v31 /*: any*/ 
                                            ]
                                        },
                                        v32 /*: any*/ ,
                                        v33 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v34 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "FollowingFeedGetUserConfig",
                    "kind": "LinkedField",
                    "name": "getFeedUserConfig",
                    "plural": false,
                    "selections": [
                        v35 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "users",
                            "plural": true,
                            "selections": [
                                v8 /*: any*/ ,
                                v36 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        },
                        v37 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "FollowingFeedWithSortByStorageSnippetsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedFeed",
                    "kind": "LinkedField",
                    "name": "feed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "FeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summaryLineUpdate",
                                    "plural": false,
                                    "selections": [
                                        v38 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v40 /*: any*/ 
                                            ],
                                            "type": "FeedEventCreate"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v41 /*: any*/ ,
                                            "type": "FeedEventEdit"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v41 /*: any*/ ,
                                            "type": "FeedEventEditLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v41 /*: any*/ ,
                                            "type": "FeedEventPublishLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v40 /*: any*/ ,
                                                {
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "comment",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "location",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "FeedEventComment"
                                        }
                                    ]
                                },
                                v23 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v39 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v38 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                v31 /*: any*/ 
                                            ]
                                        },
                                        v32 /*: any*/ ,
                                        v33 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v34 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "FollowingFeedGetUserConfig",
                    "kind": "LinkedField",
                    "name": "getFeedUserConfig",
                    "plural": false,
                    "selections": [
                        v35 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "users",
                            "plural": true,
                            "selections": [
                                v38 /*: any*/ ,
                                v8 /*: any*/ ,
                                v36 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        },
                        v37 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "5fa23ad64581bf268c729651d6bf4ddb",
            "id": "e98aed0963d75eecbe46cb82c413f1c7dab51ea1ec1170145ad8a9a88b6c3de0",
            "metadata": {},
            "name": "FollowingFeedWithSortByStorageSnippetsQuery",
            "operationKind": "query",
            "text": "query FollowingFeedWithSortByStorageSnippetsQuery($first:Int,$after:String,$sortBy:String=\"relevant\"){feed(first:$first,after:$after,sortBy:$sortBy){nodes{recentActionsCount,summaryLineUpdate{__typename,datetime,type,groupSize,...on FeedEventCreate{user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventEdit{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventEditLive{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventPublishLive{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventComment{user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},comment{id,links{webui},location{__typename,type,...on InlineComment{inlineText}},body(representation:ATLAS_DOC_FORMAT){value}}}},source,content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},contentProperties{latest{generatedBy}},excerpt(length:350),aiProperty{objectData,createdAt,errorMessage},links{webui},history{createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}},createdDate},space{alias,id,key,name},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}}}},pageInfo{hasNextPage,endCursor}},getFeedUserConfig{spaces{id},users{__typename,displayName,profilePicture{path(type:ABSOLUTE)},...on KnownUser{accountId},...on UnknownUser{accountId}},servingRecommendations}}"
        }
    };
}();
$ffca0a52a06c83ff$var$node.hash = "3d5373dca56a1cdfcca16a1aaa83ff13";
var $ffca0a52a06c83ff$export$2e2bcd8739ae039 = $ffca0a52a06c83ff$var$node;
module.exports["default"] = $ffca0a52a06c83ff$export$2e2bcd8739ae039;

});

parcelRegister("lNpDX", function(module, exports) {
/**
 * @generated SignedSource<<c687c4526492229693e69bf51bc51ed2>>
 * @relayHash 39acb1147d229935866fe5c76d20c1bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ac244f8eb2900313dbd1f99458efd3a3edf69c82efb71c7fff3c8c7aa156021e
const $afadcf197f0b9a77$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": "default",
        "kind": "LocalArgument",
        "name": "timeGranularity"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "timeGranularity",
            "variableName": "timeGranularity"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "title"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v8 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v9 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    }, v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 350
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:350)"
    }, v11 = {
        "kind": "ScalarField",
        "name": "name"
    }, v12 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v13 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v11 /*: any*/ 
        ]
    }, v14 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v15 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v16 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v17 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v18 = {
        "kind": "InlineFragment",
        "selections": v17 /*: any*/ ,
        "type": "KnownUser"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": v17 /*: any*/ ,
        "type": "UnknownUser"
    }, v20 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v21 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "friendlyWhen"
            }
        ]
    }, v22 = {
        "concreteType": "FeedPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePopularFeedWithTimeGranularityStorageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedPopularFeed",
                    "kind": "LinkedField",
                    "name": "popularFeed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PopularFeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v11 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v22 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePopularFeedWithTimeGranularityStorageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedPopularFeed",
                    "kind": "LinkedField",
                    "name": "popularFeed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PopularFeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v23 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v23 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        },
                        v22 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "39acb1147d229935866fe5c76d20c1bc",
            "id": "ac244f8eb2900313dbd1f99458efd3a3edf69c82efb71c7fff3c8c7aa156021e",
            "metadata": {},
            "name": "usePopularFeedWithTimeGranularityStorageQuery",
            "operationKind": "query",
            "text": "query usePopularFeedWithTimeGranularityStorageQuery($first:Int,$after:String,$timeGranularity:String=\"default\"){popularFeed(first:$first,after:$after,timeGranularity:$timeGranularity){nodes{content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},contentProperties{latest{generatedBy}},excerpt(length:350),labels{nodes{name,id}},links{webui},space{alias,id,key,name},history{createdDate,createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}}},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}},version{friendlyWhen}},id},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$afadcf197f0b9a77$var$node.hash = "458c889823784393227130726e48009d";
var $afadcf197f0b9a77$export$2e2bcd8739ae039 = $afadcf197f0b9a77$var$node;
module.exports["default"] = $afadcf197f0b9a77$export$2e2bcd8739ae039;

});

parcelRegister("gFJ3I", function(module, exports) {
/**
 * @generated SignedSource<<a473c2adf3f1dc0bbd28661f42e7e586>>
 * @relayHash 701c47ab92ba720656167a68651cabf8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 945e7480c8024c5838976cd3c3e16f1bc80c56650f328afd46dd6931baf9bf0f
const $281954080cb05dad$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isRovoLLMEnabled"
    }, v3 = {
        "defaultValue": "default",
        "kind": "LocalArgument",
        "name": "timeGranularity"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "timeGranularity",
            "variableName": "timeGranularity"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "title"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v9 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v6 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v10 = {
        "condition": "isRovoLLMEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "entryPoint",
                        "value": "CONFLUENCE_HOME_POPULAR_FEED"
                    }
                ],
                "concreteType": "ConfluenceContentAISummaryResponse",
                "kind": "LinkedField",
                "name": "aiProperty",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "errorMessage"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "createdAt"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "objectData"
                    }
                ],
                "storageKey": "aiProperty(entryPoint:\"CONFLUENCE_HOME_POPULAR_FEED\")"
            }
        ]
    }, v11 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    }, v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 350
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:350)"
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v15 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v13 /*: any*/ 
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v17 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v18 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v19 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v20 = {
        "kind": "InlineFragment",
        "selections": v19 /*: any*/ ,
        "type": "KnownUser"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": v19 /*: any*/ ,
        "type": "UnknownUser"
    }, v22 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v23 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "friendlyWhen"
            }
        ]
    }, v24 = {
        "concreteType": "FeedPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PopularFeedWithTimeGranularityStorageSnippetsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedPopularFeed",
                    "kind": "LinkedField",
                    "name": "popularFeed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PopularFeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v24 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PopularFeedWithTimeGranularityStorageSnippetsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedPopularFeed",
                    "kind": "LinkedField",
                    "name": "popularFeed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PopularFeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ 
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        },
                        v24 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "701c47ab92ba720656167a68651cabf8",
            "id": "945e7480c8024c5838976cd3c3e16f1bc80c56650f328afd46dd6931baf9bf0f",
            "metadata": {},
            "name": "PopularFeedWithTimeGranularityStorageSnippetsQuery",
            "operationKind": "query",
            "text": "query PopularFeedWithTimeGranularityStorageSnippetsQuery($first:Int,$after:String,$timeGranularity:String=\"default\",$isRovoLLMEnabled:Boolean=false){popularFeed(first:$first,after:$after,timeGranularity:$timeGranularity){nodes{content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},aiProperty(entryPoint:\"CONFLUENCE_HOME_POPULAR_FEED\")@include(if:$isRovoLLMEnabled){errorMessage,createdAt,objectData},contentProperties{latest{generatedBy}},excerpt(length:350),labels{nodes{name,id}},links{webui},space{alias,id,key,name},history{createdDate,createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}}},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}},version{friendlyWhen}},id},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$281954080cb05dad$var$node.hash = "01929ccf73034c49133b68b9a80dd611";
var $281954080cb05dad$export$2e2bcd8739ae039 = $281954080cb05dad$var$node;
module.exports["default"] = $281954080cb05dad$export$2e2bcd8739ae039;

});

parcelRegister("d7td2", function(module, exports) {
/**
 * @generated SignedSource<<57476ab721bfd7a2cad088f6d459ce89>>
 * @relayHash 6e6daec1ee51db3b3653a64a4144cb12
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cdbbbcf4cd5fbe5d40081d9bc1efc3b0378b8b6ef5afaf25636b2cd7158e02ee
const $25444c17515b1490$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isRovoLLMEnabled"
    }, v3 = {
        "defaultValue": "default",
        "kind": "LocalArgument",
        "name": "timeGranularity"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "timeGranularity",
            "variableName": "timeGranularity"
        }
    ], v5 = {
        "condition": "isRovoLLMEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "entryPoint",
                        "value": "CONFLUENCE_HOME_POPULAR_FEED"
                    },
                    {
                        "kind": "Literal",
                        "name": "objectType",
                        "value": "snippet_v2"
                    }
                ],
                "concreteType": "ConfluenceContentAISummaryResponse",
                "kind": "LinkedField",
                "name": "aiProperty",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "errorMessage"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "createdAt"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "objectData"
                    }
                ],
                "storageKey": "aiProperty(entryPoint:\"CONFLUENCE_HOME_POPULAR_FEED\",objectType:\"snippet_v2\")"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v10 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v7 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v11 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    }, v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 350
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:350)"
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v15 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v13 /*: any*/ 
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v17 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v18 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v19 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v20 = {
        "kind": "InlineFragment",
        "selections": v19 /*: any*/ ,
        "type": "KnownUser"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": v19 /*: any*/ ,
        "type": "UnknownUser"
    }, v22 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v23 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "friendlyWhen"
            }
        ]
    }, v24 = {
        "concreteType": "FeedPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PopularFeedWithTimeGranularityStorageSnippetsV2Query",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedPopularFeed",
                    "kind": "LinkedField",
                    "name": "popularFeed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PopularFeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v24 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PopularFeedWithTimeGranularityStorageSnippetsV2Query",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedPopularFeed",
                    "kind": "LinkedField",
                    "name": "popularFeed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PopularFeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ 
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        },
                        v24 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "6e6daec1ee51db3b3653a64a4144cb12",
            "id": "cdbbbcf4cd5fbe5d40081d9bc1efc3b0378b8b6ef5afaf25636b2cd7158e02ee",
            "metadata": {},
            "name": "PopularFeedWithTimeGranularityStorageSnippetsV2Query",
            "operationKind": "query",
            "text": "query PopularFeedWithTimeGranularityStorageSnippetsV2Query($first:Int,$after:String,$timeGranularity:String=\"default\",$isRovoLLMEnabled:Boolean=false){popularFeed(first:$first,after:$after,timeGranularity:$timeGranularity){nodes{aiProperty(entryPoint:\"CONFLUENCE_HOME_POPULAR_FEED\",objectType:snippet_v2)@include(if:$isRovoLLMEnabled){errorMessage,createdAt,objectData},content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},contentProperties{latest{generatedBy}},excerpt(length:350),labels{nodes{name,id}},links{webui},space{alias,id,key,name},history{createdDate,createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}}},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}},version{friendlyWhen}},id},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$25444c17515b1490$var$node.hash = "aff44ffc8d4a5147fced8a7e10d8221b";
var $25444c17515b1490$export$2e2bcd8739ae039 = $25444c17515b1490$var$node;
module.exports["default"] = $25444c17515b1490$export$2e2bcd8739ae039;

});

parcelRegister("i1Y90", function(module, exports) {
/**
 * @generated SignedSource<<4a7923339b2cbd295e10fba4f6eedc61>>
 * @relayHash ea99db2d334a94ff820ac76b168b5dab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fc11949bfb68d24a654ecbae157be43e2f2bd5f7436c25df55f43e630df3526f
const $c9b2249f57db9450$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "team"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPersonalSpace"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useTemplatesCollectionEligibleQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useTemplatesCollectionEligibleQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ea99db2d334a94ff820ac76b168b5dab",
            "id": "fc11949bfb68d24a654ecbae157be43e2f2bd5f7436c25df55f43e630df3526f",
            "metadata": {},
            "name": "useTemplatesCollectionEligibleQuery",
            "operationKind": "query",
            "text": "query useTemplatesCollectionEligibleQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}},user:confluence_atlassianUser{id,team,confluence{hasPersonalSpace,space{id,key}}}}"
        }
    };
}();
$c9b2249f57db9450$var$node.hash = "4c6390ae7a1c60c33ec38b4eadda65e8";
var $c9b2249f57db9450$export$2e2bcd8739ae039 = $c9b2249f57db9450$var$node;



var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");


var $2FNNv = parcelRequire("2FNNv");


var $30D0J = parcelRequire("30D0J");

const $aaa38d1e755eea36$var$useTemplatesCollectionEligibleQuery = (0, $c9b2249f57db9450$export$2e2bcd8739ae039);
const $aaa38d1e755eea36$export$a812daf120cf5caa = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isUserEligibleForTemplatesCollection, setisUserEligibleForTemplatesCollection] = (0, $42omo.useState)(false);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const isEstablishedUserTraitName = (0, $2FNNv.useIsEstablishedUserTraitName)();
    const skipConditionsForQueries = !isLicensed || !(0, $9wGTI.fg)('cc_onboarding_experience');
    const { data: userPersonalizationQueryData, loading: userPersonalizationQueryLoading, error: userPersonalizationQueryError } = (0, $30D0J.useExperimentalUserPersonalizationQuery)({
        variables: {
            userId: userId ?? ''
        },
        skip: skipConditionsForQueries
    });
    const attributes = userPersonalizationQueryData?.experimentalUserPersonalization?.attributes ?? [];
    const isEstablishedUser = attributes.find((attr)=>attr?.name === isEstablishedUserTraitName)?.value === 'true';
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)(Object.values({
        ...(0, $dBcar.TEMPLATES_COLLECTION),
        ...(0, $dBcar.ONBOARDING_EXPERIENCES)
    }), skipConditionsForQueries);
    // check if user is a founding admin or/and if the user is tagged already
    const { isFoundingAdmin: isFoundingAdmin, isTaggedForTemplatesCollectionExperiment: isTaggedForTemplatesCollectionExperiment, isTemplatesSectionDismissed: isTemplatesSectionDismissed } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const { data: productsTeamAndSpaceQueryData, loading: productsTeamAndSpaceQueryLoading, error: productsTeamAndSpaceQueryError } = (0, $jMyy4.useQueryInterop)($aaa38d1e755eea36$var$useTemplatesCollectionEligibleQuery, {
        skip: skipConditionsForQueries || isTemplatesSectionDismissed,
        __callerPackage__: "@confluence/onboarding-helpers"
    });
    const hasPersonalSpace = productsTeamAndSpaceQueryData?.user?.confluence?.hasPersonalSpace;
    const isXFlowUser = productsTeamAndSpaceQueryData?.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey.toLowerCase().includes('jira') && product.licenseStatus === 'ACTIVE');
    const isUserEligible = isLicensed && (0, $9wGTI.fg)('cc_onboarding_experience');
    const isUserEligibleForTemplatesCollectionTagging = isUserEligible && isFoundingAdmin && isXFlowUser;
    (0, $42omo.useEffect)(()=>{
        if (// queries have finished loading
        !userPersonalizationQueryError && !userPersonalizationQueryLoading && !onboardingStateLoading && !onboardingStateError && !productsTeamAndSpaceQueryError && !productsTeamAndSpaceQueryLoading && // conditions to meet to be eligible
        !isEstablishedUser && isUserEligibleForTemplatesCollectionTagging && !isTaggedForTemplatesCollectionExperiment) {
            // newly tagged user for the experiment
            setisUserEligibleForTemplatesCollection(true);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'exposed',
                    actionSubject: 'feature',
                    attributes: {
                        name: 'templatesCollection',
                        hasPersonalSpace: hasPersonalSpace
                    }
                }
            }).fire();
            setOnboardingState({
                key: (0, $dBcar.TEMPLATES_COLLECTION).EXPERIMENT_ELIGIBLE,
                value: String(true)
            });
        }
    }, [
        userPersonalizationQueryError,
        userPersonalizationQueryLoading,
        onboardingStateError,
        onboardingStateLoading,
        productsTeamAndSpaceQueryError,
        productsTeamAndSpaceQueryLoading,
        isEstablishedUser,
        isUserEligibleForTemplatesCollectionTagging,
        isTaggedForTemplatesCollectionExperiment,
        setisUserEligibleForTemplatesCollection,
        setOnboardingState,
        createAnalyticsEvent,
        hasPersonalSpace
    ]);
    const isUserPreviouslyTaggedAndEnrolled = Boolean(isTaggedForTemplatesCollectionExperiment);
    const isTemplatesCollectionEligible = !isTemplatesSectionDismissed && Boolean(hasPersonalSpace) && (isUserEligibleForTemplatesCollection || isUserPreviouslyTaggedAndEnrolled);
    return {
        isTemplatesCollectionEligible: isTemplatesCollectionEligible,
        shouldShowGuidingArrow: isTemplatesCollectionEligible && !isEstablishedUser,
        teamType: productsTeamAndSpaceQueryData?.user?.team,
        teamTypeLoading: productsTeamAndSpaceQueryLoading,
        teamTypeError: productsTeamAndSpaceQueryError,
        personalSpaceKey: productsTeamAndSpaceQueryData?.user?.confluence?.space?.key
    };
};
module.exports["useTemplatesCollectionEligible"] = $aaa38d1e755eea36$export$a812daf120cf5caa;

});

parcelRegister("lt6Lx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $d5RCH = parcelRequire("d5RCH");


var $1ytiN = parcelRequire("1ytiN");


var $gSgn8 = parcelRequire("gSgn8");


var $8vxJi = parcelRequire("8vxJi");

const $5a5ab99dc3af9e56$var$i18n = (0, $aXWIB.defineMessages)({
    notFound: {
        id: "document-title.not.found",
        defaultMessage: "Page Not Found"
    }
});
const $5a5ab99dc3af9e56$export$8f4c40b84dd15d46 = ({ titlePrefix: titlePrefix = '', contentTitle: contentTitle = '', contentSpace: contentSpace = '', siteTitleOnly: siteTitleOnly = false, notFound: notFound = false, isHomePage: isHomePage = false })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { siteTitle: siteTitle } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            window['__DOCUMENT_TITLE_TAG__'] = '';
        };
    }, []);
    // In the case when page is rendered by SSR, the __DOCUMENT_TITLE_TAG__ will be
    // populated and we can skip document title — but only when this render has no
    // meaningful content to contribute. If contentTitle, titlePrefix, notFound,
    // isHomePage, or siteTitleOnly are set, we must still update the title
    // (e.g. relay race: new page renders before old cleanup effect runs).
    if (window['__DOCUMENT_TITLE_TAG__'] && window['__SSR_RENDERED__'] && document.title && !contentTitle && !titlePrefix && !notFound && !isHomePage && !siteTitleOnly) return null;
    const title = [
        titlePrefix || (notFound ? intl.formatMessage($5a5ab99dc3af9e56$var$i18n.notFound) : ''),
        siteTitleOnly ? undefined : contentTitle,
        siteTitleOnly ? undefined : contentSpace,
        siteTitle
    ].filter((part)=>part).join(' - ');
    // Don't override an existing title with a less specific one (e.g., don't set "Confluence"
    // when there's already a title with content like "Page Title - Space - Confluence").
    // This prevents components with empty contentTitle from overriding titles set by components
    // with actual content during navigation/rendering transitions.
    // Note: This check happens during render, so it may not catch titles set in the same render cycle,
    // but useLayoutEffect in PageTitle ensures the last component to render wins.
    // A title is considered "specific" if it provides either a contentTitle or a titlePrefix.
    // Pages like the advanced search page pass a titlePrefix (e.g. "Search") without a
    // contentTitle, and we must still allow that title to replace the previous page's title
    // during client-side navigation. notFound, isHomePage, and siteTitleOnly are also
    // meaningful signals that must always be allowed to update the title.
    if (typeof document !== 'undefined' && document.title && !contentTitle && !titlePrefix && !notFound && !isHomePage && !siteTitleOnly) {
        // If contentTitle, titlePrefix, notFound, isHomePage, and siteTitleOnly are all empty/false,
        // we're likely setting a generic title (just siteTitle or siteTitle with space).
        // If there's already a more specific title (3+ parts, or 2 parts where first isn't siteTitle), skip.
        const existingTitleParts = document.title.split(' - ');
        const hasMoreSpecificContent = existingTitleParts.length > 2 || existingTitleParts.length === 2 && existingTitleParts[0] !== siteTitle;
        // Skip if we're trying to set a less specific title when a more specific one exists and it is not the home page
        if (hasMoreSpecificContent && title !== document.title) return null;
    }
    // Set for SSR document title
    window['__DOCUMENT_TITLE_TAG__'] = title;
    if (window.__SSR_REACT_STREAMING__) {
        const inject = (0, $gSgn8.getStreamInject)();
        inject(()=>`document.title=${(0, $8vxJi.stringifyForSSR)(title)}`);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5RCH.PageTitle), {
        title: title
    });
};
module.exports["DocumentContentTitle"] = $5a5ab99dc3af9e56$export$8f4c40b84dd15d46;

});

parcelRegister("d5RCH", function(module, exports) {
function $69aebb91e74cbedb$export$155581e8dc02007a({ title: title }) {
    // document.title is safe to set during render:
    // - It's idempotent (setting the same value multiple times is safe)
    // - It doesn't trigger React re-renders
    // - Many React libraries do this (react-helmet, react-document-title, etc.)
    // - It's a browser API, not React state, so it doesn't violate React's rules
    // - The last component to render will have its title set, avoiding race conditions
    if (typeof document !== 'undefined' && title) document.title = title;
    return null;
}
module.exports["PageTitle"] = $69aebb91e74cbedb$export$155581e8dc02007a;

});

parcelRegister("2mPpz", function(module, exports) {

var $byfJM = parcelRequire("byfJM");

const $479bf4f98cf9c8c7$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>(0, $byfJM.createPlacementComponent)(placementId, Component, placementConfigurationOptions);
module.exports["createPlacementComponent"] = $479bf4f98cf9c8c7$export$8a57effc6307f916;

});

parcelRegister("byfJM", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $T9xHm = parcelRequire("T9xHm");


var $1eSke = parcelRequire("1eSke");

var $4H1Ql = parcelRequire("4H1Ql");


var $kO3gu = parcelRequire("kO3gu");


var $a8wvv = parcelRequire("a8wvv");


var $9dOtv = parcelRequire("9dOtv");


var $eXPKf = parcelRequire("eXPKf");

var $MnX4h = parcelRequire("MnX4h");


var $2HRxT = parcelRequire("2HRxT");

const $573f4005c25c6dbc$export$eaeb39efb2b24b52 = (placementId, Component, placementConfigurationOptions)=>(0, $2HRxT.withErrorBoundary)((props)=>{
        // Hide placement in Isolated Cloud environments if configured
        // The typeof document check ensures we don't call isIsolatedCloud() during SSR
        if (placementConfigurationOptions?.hideInIsolatedCloud && typeof document !== 'undefined' && (0, $T9xHm.isIsolatedCloud)()) return null;
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, fetch: fetch, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        if ((0, $1eSke.isPostOfficePlacementsGloballyDisabled)(context)) return null;
        const stableContext = (0, $4H1Ql.useStableObject)(context);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $eXPKf.PerformanceTracking), {
            initialData: initialData,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kO3gu.MaybePlacementFetchingProvider), {
                fetch: fetch?.fetch,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $MnX4h.StableProviders), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    choreographer: placementConfigurationOptions?.choreographer,
                    subscription: placementConfigurationOptions?.subscription,
                    children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                        context: stableContext,
                        initialData: initialData,
                        ...componentProps
                    })
                })
            })
        });
    });
const $573f4005c25c6dbc$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>{
    const placement = $573f4005c25c6dbc$export$eaeb39efb2b24b52(placementId, Component, placementConfigurationOptions);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = (0, $9dOtv.useComponentErrorHandling)(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $a8wvv.ERROR_BOUNDARY_LOCATION),
            placementId: placementId,
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};
module.exports["createPlacementComponent"] = $573f4005c25c6dbc$export$8a57effc6307f916;

});

parcelRegister("1eSke", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $3a5f78a0c0b53634$export$be54ac815726b4bd = (context)=>{
    const isGlobalDisablePlacementCheckEnabled = (0, $dh538.fg)('post-office-enable-disable-placement-check');
    if (isGlobalDisablePlacementCheckEnabled) return context.disableAllPlacements === true;
    return false;
};
module.exports["isPostOfficePlacementsGloballyDisabled"] = $3a5f78a0c0b53634$export$be54ac815726b4bd;

});

parcelRegister("4H1Ql", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $6932c2b531d219ac$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $6932c2b531d219ac$export$ed02d4adf2068b08(obj) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $42omo.useMemo)(()=>obj, $6932c2b531d219ac$export$cdf98ded28406f69(obj));
}
module.exports["useStableObject"] = $6932c2b531d219ac$export$ed02d4adf2068b08;

});

parcelRegister("9dOtv", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $94fea169e2cb8de7$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    const internalOnError = (0, $42omo.useCallback)((error, info)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
        onError?.(error, info);
    }, [
        onEvent,
        onError
    ]);
    // This is here to facade for a extra prop that overwrote the original error boundary api, consituting a breaking change.
    // This makes sure that the original api is still valid.
    const internalFallbackRender = fallbackRender ?? errorFallback;
    return {
        onError: internalOnError,
        fallbackRender: internalFallbackRender
    };
};
module.exports["useComponentErrorHandling"] = $94fea169e2cb8de7$export$3d127465d22fe4e5;

});

parcelRegister("cyz5M", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $3NyPa = parcelRequire("3NyPa");

var $h6POP = parcelRequire("h6POP");


var $hOVIX = parcelRequire("hOVIX");


var $4oTqF = parcelRequire("4oTqF");


var $eNels = parcelRequire("eNels");


var $aEUWC = parcelRequire("aEUWC");


var $2amyA = parcelRequire("2amyA");


var $Sjnjb = parcelRequire("Sjnjb");


var $cTbOk = parcelRequire("cTbOk");


var $cqOSB = parcelRequire("cqOSB");


var $4S89c = parcelRequire("4S89c");


var $9iUWG = parcelRequire("9iUWG");


var $fUB5z = parcelRequire("fUB5z");


var $2HRxT = parcelRequire("2HRxT");


var $5pgAV = parcelRequire("5pgAV");


var $42omo = parcelRequire("42omo");


var $lVEBn = parcelRequire("lVEBn");


var $2GePd = parcelRequire("2GePd");

const $765afc5340447923$var$STABLE_EMPTY_OBJECT = {};
const $765afc5340447923$export$9750eb54d7c7e789 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        ...props,
        children: children
    });
};
const $765afc5340447923$export$7b7e5a348ef9a7c1 = (messageComponents, placementId, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return /*#__PURE__*/ (0, $42omo.memo)(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, SuspenseBoundary: SuspenseBoundary = (0, $42omo.Suspense), ...data })=>{
            const isUFOEnabled = (0, $c6GJD.default).checkGate('enable_ufo_tracking_in_post_office');
            const isTriggerChoreographingEnabled = (0, $c6GJD.default).checkGate('post-office_enable_trigger-choreographing');
            /// https://switcheroo.atlassian.com/ui/gates/e8049c84-32d5-4452-a52f-5b92940a1b55/key/post-office_enable-i18n-migration-pull
            const isI18nMigrationInAppEnabled = (0, $c6GJD.default).checkGate('post-office_enable-i18n-migration-pull');
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $42omo.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $3NyPa.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const isChunkLoadError = (error)=>{
                    return error?.name === 'ChunkLoadError';
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        if (!isChunkLoadError(error)) messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $fUB5z.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $42omo.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $hOVIX.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $hOVIX.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $42omo.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOLoadHold, {
                        name: (0, $h6POP.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                        children: loadingFallback ?? null
                    }), // oxlint-disable-next-line react-hooks/exhaustive-deps
                [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                // Client-triggered messages: hydrate must return triggerType at top level
                // (e.g. triggerType: messageContext.triggerType). Single source of truth.
                const triggerType = componentProps.triggerType;
                const hasTrigger = isTriggerChoreographingEnabled && (0, $9iUWG.isClientTriggeredMessage)(triggerType);
                // Create waitForTrigger for triggered messages
                const { waitForTrigger: waitForTrigger } = (0, $cqOSB.useWaitForTrigger)({
                    hasTrigger: hasTrigger,
                    messageSuccessComponent: messageSuccessComponent,
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory
                });
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                const messageContextValue = (0, $42omo.useMemo)(()=>({
                        messageInstanceId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        triggerId: triggerId,
                        messageCreationType: messageCreationType,
                        transactionAccountId: componentProps.transactionAccountId,
                        analyticsDetails: postOffice?.analyticsDetails,
                        journeyId: journeyId,
                        journeyTriggerId: journeyTriggerId,
                        configSetId: configSetId
                    }), [
                    componentProps.transactionAccountId
                ]);
                // TODO: clean up the fallback branching logic and remove this gate once
                // 'post-office_enable-triggered-validator-fix' rolls out to 100%.
                // Switcheroo: https://switcheroo.atlassian.com/ui/gates/key/post-office_enable-triggered-validator-fix
                if ((0, $c6GJD.default).checkGate('post-office_enable-triggered-validator-fix')) // NEW TREE (gate ON).
                // - MaybeChoreographerWrapper sits at the top so it can claim its slot even
                //   while the lazy chunk is still loading; it no-ops for client-triggered
                //   messages, which handle their own choreography via
                //   MaybeTriggeredMessageValidator below.
                // - MaybeTriggeredMessageValidator must sit BELOW SuspenseBoundary so it only
                //   mounts after the lazy template chunk has resolved. Otherwise the validator
                //   commits with the Suspense fallback as its children (template hasn't
                //   executed yet, ref is false); when the chunk later resolves only the
                //   Suspense subtree re-renders, so the validator above never sees the ref
                //   flip to true and stays stuck in 'pending' with `display:none`.
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GePd.MaybeChoreographerWrapper), {
                    ChoreographerWrapper: (0, $lVEBn.ChoreographerWrapper),
                    enabled: !waitForTrigger,
                    messageId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2amyA.FeatureFlaggedUfoWrapper), {
                        messageTemplateId: messageTemplateId,
                        isEnabled: isUFOEnabled,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4oTqF.MessageContextProvider), {
                            value: messageContextValue,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5pgAV.RecommendationProvider), {
                                value: recommendationSession ?? $765afc5340447923$var$STABLE_EMPTY_OBJECT,
                                children: /*#__PURE__*/ (0, $l998X.jsx)(SuspenseBoundary, {
                                    fallback: loadingComponent,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cTbOk.MaybeTriggeredMessageValidator), {
                                        waitForTrigger: waitForTrigger,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aEUWC.MessageAnalyticsContextProvider), {
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eNels.MaybeI18nProvider), {
                                                messageTemplateId: messageTemplateId,
                                                placementId: placementId,
                                                isI18nMigrationInAppEnabled: isI18nMigrationInAppEnabled,
                                                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $4S89c.MaybeManualMessageViewedEvent), {
                                                    isManual: !!waitForTrigger,
                                                    children: [
                                                        !waitForTrigger && messageSuccessComponent,
                                                        /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                                                            onError: onError,
                                                            messageInstanceId: messageInstanceId,
                                                            ...componentProps,
                                                            waitForTrigger: waitForTrigger
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                });
                // FALLBACK TREE (gate OFF — pre-fix behaviour). Kept verbatim from before the
                // triggered-validator-fix PR so a kill-switch flip restores the exact previous
                // runtime structure. Known issue: when the template is lazy-loaded under
                // SuspenseBoundary, TriggeredMessageValidator mounts ABOVE Suspense, commits
                // before the template has run, and never re-runs its useLayoutEffect when the
                // chunk resolves — leaving client-triggered messages stuck behind
                // `display:none`. This is what the new tree above fixes.
                const messageContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $2amyA.FeatureFlaggedUfoWrapper), {
                    messageTemplateId: messageTemplateId,
                    isEnabled: isUFOEnabled,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4oTqF.MessageContextProvider), {
                        value: messageContextValue,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5pgAV.RecommendationProvider), {
                            value: recommendationSession ?? $765afc5340447923$var$STABLE_EMPTY_OBJECT,
                            children: /*#__PURE__*/ (0, $l998X.jsx)(SuspenseBoundary, {
                                fallback: loadingComponent,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aEUWC.MessageAnalyticsContextProvider), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eNels.MaybeI18nProvider), {
                                        messageTemplateId: messageTemplateId,
                                        placementId: placementId,
                                        isI18nMigrationInAppEnabled: isI18nMigrationInAppEnabled,
                                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $4S89c.MaybeManualMessageViewedEvent), {
                                            isManual: !!waitForTrigger,
                                            children: [
                                                !waitForTrigger && messageSuccessComponent,
                                                /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                                                    onError: onError,
                                                    messageInstanceId: messageInstanceId,
                                                    ...componentProps,
                                                    waitForTrigger: waitForTrigger
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    })
                });
                if (waitForTrigger) return /*#__PURE__*/ (0, $l998X.jsx)((0, $Sjnjb.TriggeredMessageValidator), {
                    waitForTrigger: waitForTrigger,
                    children: messageContent
                });
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $lVEBn.ChoreographerWrapper), {
                    messageId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    children: messageContent
                });
            };
            return (0, $2HRxT.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                messageTemplateId: messageTemplateId,
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        });
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};
module.exports["MaybeSuspenseBoundary"] = $765afc5340447923$export$9750eb54d7c7e789;
module.exports["asMessageRenderer"] = $765afc5340447923$export$7b7e5a348ef9a7c1;

});

parcelRegister("3NyPa", function(module, exports) {

var $jTlSd = parcelRequire("jTlSd");


var $koKWt = parcelRequire("koKWt");

const $959aa8656bf0972c$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $jTlSd.MessagePerformanceTracker,
    PlacementPerformanceTracker: $koKWt.PlacementPerformanceTracker
};
module.exports["UFOv1"] = $959aa8656bf0972c$export$96236906ebaa7f87;

});

parcelRegister("jTlSd", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");


var $haNjI = parcelRequire("haNjI");

class $71d7f78b2ff13923$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.aggregatedExperience = void 0;
        this.messageSpecificExperience = void 0;
        this.experiences = void 0;
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $5aVN7.UFOExperience)((0, $haNjI.UFOExperienceNames).MESSAGE, {
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $9NDUe.ExperienceTypes).Load,
            platform: {
                component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.messageSpecificExperience = new (0, $5aVN7.UFOExperience)(`${(0, $haNjI.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $9NDUe.ExperienceTypes).Load,
            platform: {
                component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}
module.exports["MessagePerformanceTracker"] = $71d7f78b2ff13923$export$ae5c73c7c4f454e6;

});

parcelRegister("haNjI", function(module, exports) {
const $ac68ec5e99dfa5a8$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $ac68ec5e99dfa5a8$export$6d482cfa20c9d220 = 'post-office';
module.exports["UFOExperienceNames"] = $ac68ec5e99dfa5a8$export$cc7ddf8ca628f6f1;
module.exports["POST_OFFICE_PLATFORM_NAME"] = $ac68ec5e99dfa5a8$export$6d482cfa20c9d220;

});

parcelRegister("koKWt", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");


var $haNjI = parcelRequire("haNjI");

const $f3e04d171a04c0ba$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $9NDUe.ExperienceTypes).Load,
    platform: {
        component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
    },
    timings: [
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $f3e04d171a04c0ba$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        /** UFO experience for tracking the performance of all placements in aggregate.
     * This supports setting up a single platform-level SLO for all placements.
     */ this.aggregatedExperience = void 0;
        /** UFO experience for tracking the performance of a specific placement.
     * This supports setting up a placement-specific SLOs.
     */ this.placementSpecificExperience = void 0;
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $5aVN7.UFOExperience)((0, $haNjI.UFOExperienceNames).PLACEMENT, $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $5aVN7.UFOExperience)(`${(0, $haNjI.UFOExperienceNames).PLACEMENT}.${placementId}`, $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}
module.exports["PlacementPerformanceTracker"] = $f3e04d171a04c0ba$export$8b48c2105ba0b35a;

});

parcelRegister("lVEBn", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $7XIdu = parcelRequire("7XIdu");


var $iX6G3 = parcelRequire("iX6G3");


var $42omo = parcelRequire("42omo");

const $5d2b57d7f45b3b6a$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return null;
};
const $5d2b57d7f45b3b6a$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $iX6G3.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_choreographed_post_office_messages');
    const useMessageTemplateIdAsChoreographerMessageId = (0, $c6GJD.default).checkGate('post-office_use_template_id_for_choreo');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            // Use messageTemplateId as choreographer messageId when feature flag is enabled,
            // otherwise use the original messageId (messageInstanceId) for backward compatibility
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, $l998X.jsx)($5d2b57d7f45b3b6a$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: choreographerMessageId,
                children: children
            });
        }
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["ChoreographerWrapper"] = $5d2b57d7f45b3b6a$export$8db7ba034addcd65;

});

parcelRegister("6Ht9d", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gAOec = parcelRequire("gAOec");

const $876859b1b10b173e$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $42omo.useMemo)(()=>{
        if (typeof initialData === 'undefined') return undefined;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return (0, $gAOec.useData)(initialDataCallback, {
        analytics: {
            name: 'initialData'
        }
    });
};
module.exports["useInitialData"] = $876859b1b10b173e$export$5523c5f3222291d0;

});

parcelRegister("j9AoC", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $crDNP = parcelRequire("crDNP");

const $a918fd7966d948a2$export$7693b71d48f1bf7e = ()=>(render)=>(renderProps)=>{
            const rendered = render(renderProps);
            if (rendered === null) return null;
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $crDNP.MessageViewed), {}),
                    rendered
                ]
            });
        };
const $a918fd7966d948a2$export$b4a84c754a962eee = ()=>(transformMetadata)=>(params)=>transformMetadata(params);
const $a918fd7966d948a2$export$62864968b8b09cdf = ()=>(hydrate)=>(requestContext, placementContext, messageContext)=>hydrate(requestContext, placementContext, messageContext);
const $a918fd7966d948a2$var$exampleHydrator = (hydrateExample, config)=>(_requestContext, placementContext, messageContext)=>{
        const _config = config;
        return {
            ...hydrateExample({
                ..._config?.requestContext ?? {}
            }, placementContext, messageContext),
            ..._config?.additionalRenderProps ?? {}
        };
    };
const $a918fd7966d948a2$export$803c53721d530406 = ()=>(hydrateExample, config)=>$a918fd7966d948a2$var$exampleHydrator(hydrateExample, config);
const $a918fd7966d948a2$var$initializeValidate = ()=>(validate)=>(apiResponse)=>{
            try {
                validate(apiResponse);
            } catch (error) {
                throw error instanceof Error ? error : new Error(typeof error === 'string' ? error : 'Unknown validation error');
            }
            return apiResponse;
        };
const $a918fd7966d948a2$export$b8fedcd4634de5cd = ()=>({
        createHydrate: $a918fd7966d948a2$export$62864968b8b09cdf(),
        createHydrateExample: $a918fd7966d948a2$export$803c53721d530406(),
        createTransformMetadata: $a918fd7966d948a2$export$b4a84c754a962eee()
    });
const $a918fd7966d948a2$export$7d57dbe7f7617174 = ()=>({
        createValidate: $a918fd7966d948a2$var$initializeValidate(),
        createRender: $a918fd7966d948a2$export$7693b71d48f1bf7e()
    });
module.exports["createServerPipeline"] = $a918fd7966d948a2$export$b8fedcd4634de5cd;
module.exports["createClientPipeline"] = $a918fd7966d948a2$export$7d57dbe7f7617174;

});

parcelRegister("jZuqn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $cXFG6 = parcelRequire("cXFG6");


var $5rgbD = parcelRequire("5rgbD");

const $62e9909ce239e1d8$var$packageName = "platform-pkg";
const $62e9909ce239e1d8$var$packageVersion = "0.0.0-use.local";
const $62e9909ce239e1d8$var$progressIndicatorGapMap = {
    comfortable: {
        default: 'space.100',
        large: 'space.150'
    },
    cozy: {
        default: 'space.075',
        large: 'space.100'
    },
    compact: {
        default: 'space.050',
        large: 'space.075'
    }
};
const $62e9909ce239e1d8$var$sizes = {
    default: 8,
    large: 12
};
const $62e9909ce239e1d8$var$varDotsSize = '--ds-dots-size';
const $62e9909ce239e1d8$var$varDotsMargin = '--ds-dots-margin';
/**
 * __ProgressDots__
 *
 * A progress indicator shows the user where they are along the steps of a journey.
 */ const $62e9909ce239e1d8$var$ProgressDots = ({ appearance: appearance = 'default', ariaControls: ariaControls = 'panel', ariaLabel: ariaLabel = 'tab', size: size = 'default', // NOTE: `spacing` is a reserved HTML attribute and will be added to the
// element, replaced with `gutter`.
spacing: gutter = 'comfortable', selectedIndex: selectedIndex, testId: testId, values: values, onSelect: onSelect })=>{
    const tablistRef = (0, $42omo.useRef)(null);
    const onSelectWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onSelect || (0, $ee7An.default),
        action: 'selected',
        componentName: 'progressIndicator',
        packageName: $62e9909ce239e1d8$var$packageName,
        packageVersion: $62e9909ce239e1d8$var$packageVersion
    });
    const gap = $62e9909ce239e1d8$var$progressIndicatorGapMap[gutter][size];
    const handleKeyDown = (0, $42omo.useCallback)((event)=>{
        const indicators = Array.from(tablistRef.current.children);
        // bail if the target isn't an indicator
        if (!indicators.includes(event.target)) return;
        // bail if not valid arrow key
        const isLeft = event.key === 'ArrowLeft';
        const isRight = event.key === 'ArrowRight';
        if (!isLeft && !isRight) return;
        // bail if at either end of the values
        const isAlpha = isLeft && selectedIndex === 0;
        const isOmega = isRight && selectedIndex === values.length - 1;
        if (isAlpha || isOmega) return;
        const index = isLeft ? selectedIndex - 1 : selectedIndex + 1;
        // call the consumer's select method and focus the applicable indicator
        if (onSelect) onSelectWithAnalytics({
            event: event,
            index: index
        });
        if (typeof indicators[index].focus === 'function') indicators[index].focus();
    }, [
        onSelectWithAnalytics,
        selectedIndex,
        values,
        onSelect
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!onSelect) return 0, $ee7An.default;
        return (0, $fFa3V.bind)(document, {
            type: 'keydown',
            listener: handleKeyDown,
            options: {
                capture: false
            }
        });
    }, [
        onSelect,
        handleKeyDown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        style: {
            [$62e9909ce239e1d8$var$varDotsSize]: `${$62e9909ce239e1d8$var$sizes[size]}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            [$62e9909ce239e1d8$var$varDotsMargin]: gap
        },
        role: onSelect && 'tablist'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        testId: testId,
        ref: (r)=>{
            tablistRef.current = r;
        },
        alignInline: "center",
        space: gap
    }, values.map((_, index)=>{
        const isSelected = selectedIndex === index;
        const tabId = `${ariaLabel}${index}`;
        const panelId = `${ariaControls}${index}`;
        const indicatorTestId = testId && `${testId}-ind-${index}`;
        return onSelect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cXFG6.ButtonIndicator), {
            key: index,
            testId: indicatorTestId,
            appearance: appearance,
            isSelected: isSelected,
            tabId: tabId,
            panelId: panelId,
            onClick: (event)=>onSelectWithAnalytics({
                    event: event,
                    index: index
                })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5rgbD.PresentationalIndicator), {
            key: index,
            testId: indicatorTestId,
            appearance: appearance,
            isSelected: isSelected
        });
    })));
};
var $62e9909ce239e1d8$export$2e2bcd8739ae039 = $62e9909ce239e1d8$var$ProgressDots;
module.exports["default"] = $62e9909ce239e1d8$export$2e2bcd8739ae039;

});

parcelRegister("cXFG6", function(module, exports) {
/* button-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $fVUfS = parcelRequire("fVUfS");


var $6F6hl = parcelRequire("6F6hl");

const $0d0624cdabdf0cfe$var$commonStyles = {
    common: "_2rko1rr0 _1bsbg7kr _4t3ig7kr _kqswh2mm _cfu11ule _1mp41th6 _kfgt1th6 _1cs8stnw _1kt9b3bt _iajm1yh4 _z5wt1yh4"
};
const $0d0624cdabdf0cfe$var$colorBorderMap = {
    default: "_19it1axi",
    help: "_19it1axi",
    inverted: "_19it1ps9",
    primary: "_19it1axi"
};
const $0d0624cdabdf0cfe$var$buttonStyle = {
    root: "_12ji1r31 _1qu2glyw _12y3idpf _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _80omtlke"
};
const $0d0624cdabdf0cfe$var$backgroundColor = (isSelected)=>{
    if (!isSelected) return {
        default: "var(--ds-surface, #FFFFFF)",
        help: "var(--ds-surface, #FFFFFF)",
        inverted: "var(--ds-background-neutral-subtle, #00000000)",
        primary: "var(--ds-surface, #FFFFFF)"
    };
    return {
        default: "var(--ds-icon, #292A2E)",
        help: "var(--ds-icon-discovery, #AF59E1)",
        inverted: "var(--ds-icon-inverse, #FFFFFF)",
        primary: "var(--ds-icon-brand, #1868DB)"
    };
};
const $0d0624cdabdf0cfe$export$3716cb524d6018c1 = ({ appearance: appearance, panelId: panelId, tabId: tabId, isSelected: isSelected, onClick: onClick, testId: testId })=>{
    return /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        role: "tab",
        style: {
            backgroundColor: $0d0624cdabdf0cfe$var$backgroundColor(isSelected)[appearance]
        },
        xcss: (0, $1bHXt.cx)($0d0624cdabdf0cfe$var$commonStyles.common, $0d0624cdabdf0cfe$var$buttonStyle.root, $0d0624cdabdf0cfe$var$colorBorderMap[appearance]),
        "aria-controls": panelId,
        "aria-selected": isSelected,
        id: tabId,
        onClick: onClick,
        tabIndex: isSelected ? -1 : undefined,
        testId: testId
    }, /*#__PURE__*/ $42omo.createElement((0, $6F6hl.default), null, tabId));
};
module.exports["ButtonIndicator"] = $0d0624cdabdf0cfe$export$3716cb524d6018c1;

});

parcelRegister("5rgbD", function(module, exports) {
/* presentational-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $gdv5Z = parcelRequire("gdv5Z");

const $98b935bddcd1094d$var$commonStyles = {
    common: "_2rko1rr0 _1bsbg7kr _4t3ig7kr _kqswh2mm _cfu11ule _1mp41th6 _kfgt1th6 _1cs8stnw _1kt9b3bt _iajm1yh4 _z5wt1yh4"
};
const $98b935bddcd1094d$var$colorBorderMap = {
    default: "_19it1axi",
    help: "_19it1axi",
    inverted: "_19it1ps9",
    primary: "_19it1axi"
};
const $98b935bddcd1094d$var$backgroundColor = (isSelected)=>{
    if (!isSelected) return {
        default: "var(--ds-surface, #FFFFFF)",
        help: "var(--ds-surface, #FFFFFF)",
        inverted: "var(--ds-background-neutral-subtle, #00000000)",
        primary: "var(--ds-surface, #FFFFFF)"
    };
    return {
        default: "var(--ds-icon, #292A2E)",
        help: "var(--ds-icon-discovery, #AF59E1)",
        inverted: "var(--ds-icon-inverse, #FFFFFF)",
        primary: "var(--ds-icon-brand, #1868DB)"
    };
};
const $98b935bddcd1094d$export$ec3c81af58a0c4e7 = ({ appearance: appearance, isSelected: isSelected, testId: testId })=>{
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        testId: testId,
        style: {
            backgroundColor: $98b935bddcd1094d$var$backgroundColor(isSelected)[appearance]
        },
        xcss: (0, $1bHXt.cx)($98b935bddcd1094d$var$commonStyles.common, $98b935bddcd1094d$var$colorBorderMap[appearance])
    });
};
module.exports["PresentationalIndicator"] = $98b935bddcd1094d$export$ec3c81af58a0c4e7;

});

parcelRegister("2YerA", function(module, exports) {
$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("jCM2u")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("jCM2u")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("jCM2u")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("fqrVl")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("fqrVl")).Reasons);

var $jCM2u = parcelRequire("jCM2u");


var $fqrVl = parcelRequire("fqrVl");


});

parcelRegister("jCM2u", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5xIym = parcelRequire("5xIym");


var $5B9n6 = parcelRequire("5B9n6");


var $fqrVl = parcelRequire("fqrVl");

const $32c19fce160b377b$var$LATEST_VERSION = (0, $5B9n6.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $32c19fce160b377b$var$CrossFlowContext = /*#__PURE__*/ (0, $42omo.createContext)(()=>({
        isEnabled: false,
        reason: (0, $fqrVl.Reasons).NO_PROVIDER
    }));
const $32c19fce160b377b$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $5B9n6.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $5xIym.createAPIv0)(onOpen),
                    apiV1: (0, $5B9n6.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $fqrVl.Reasons).NO_API_SUPPORT
                };
        }
    };
const $32c19fce160b377b$export$c0ddec072762f62a = ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $42omo.useMemo)(()=>$32c19fce160b377b$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($32c19fce160b377b$var$CrossFlowContext.Provider, {
        value: negotiateApi
    }, children);
};
const $32c19fce160b377b$export$6e7a10fe635a0dfc = ()=>{
    const negotiateApi = (0, $42omo.useContext)($32c19fce160b377b$var$CrossFlowContext);
    return (0, $42omo.useMemo)(()=>negotiateApi($32c19fce160b377b$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $32c19fce160b377b$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (props)=>{
        const crossFlow = $32c19fce160b377b$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}
module.exports["BaseCrossFlowApiProvider"] = $32c19fce160b377b$export$c0ddec072762f62a;
module.exports["useCrossFlow"] = $32c19fce160b377b$export$6e7a10fe635a0dfc;
module.exports["withCrossFlow"] = $32c19fce160b377b$export$655b6c19a0daddb8;

});

parcelRegister("5xIym", function(module, exports) {
const $1eb0c594c750199f$export$a4ad2735b021c132 = 0;
const $1eb0c594c750199f$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["createAPIv0"] = $1eb0c594c750199f$export$9ff7368ac93fcf2d;

});

parcelRegister("5B9n6", function(module, exports) {
const $12de2f6721823415$export$a4ad2735b021c132 = 1;
const $12de2f6721823415$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["VERSION"] = $12de2f6721823415$export$a4ad2735b021c132;
module.exports["createAPIv1"] = $12de2f6721823415$export$8fd5792fc468459f;

});

parcelRegister("fqrVl", function(module, exports) {
const $4db9b154d66dd01a$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $4db9b154d66dd01a$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};
module.exports["Journeys"] = $4db9b154d66dd01a$export$3411873bfd520bb6;
module.exports["Reasons"] = $4db9b154d66dd01a$export$da2d4f2f250d6f84;

});

parcelRegister("9oJIg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kO3gu = parcelRequire("kO3gu");


var $MyxIQ = parcelRequire("MyxIQ");

const $5176b2e7fefe99e5$export$9be10e5cc29463c9 = ({ children: children })=>{
    const fetch = (0, $MyxIQ.usePlacementSSRFetch)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kO3gu.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};
module.exports["PlacementFetchProvider"] = $5176b2e7fefe99e5$export$9be10e5cc29463c9;

});

parcelRegister("MyxIQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bnKhH = parcelRequire("bnKhH");


var $5dPMD = parcelRequire("5dPMD");


var $301rJ = parcelRequire("301rJ");


var $xwvlW = parcelRequire("xwvlW");


var $wPrRK = parcelRequire("wPrRK");


var $1xpoY = parcelRequire("1xpoY");


var $60cDW = parcelRequire("60cDW");


var $d6NtA = parcelRequire("d6NtA");



var $d5fg6 = parcelRequire("d5fg6");


var $0VKZa = parcelRequire("0VKZa");

/**
 * Post Office class for managing in memory cache of Placement queries.
 * We store the cache reference on the global object to persist across SSR requests.
 */ const $cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE = globalThis?.__POST_OFFICE_QUERY_CACHE__ || {};
const $cdd1e9f9feeb24fd$var$postOfficeClient = new (0, $d5fg6.PostOfficeCacheClient)($cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE);
const $cdd1e9f9feeb24fd$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $cdd1e9f9feeb24fd$export$b3732c8ff6f9c463 = (res)=>{
    if (typeof res === 'undefined') throw new Error('No response from server');
    if (res.ok) return res;
    throw new Error($cdd1e9f9feeb24fd$export$18a0019e5439b209(res));
};
const $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse = (data)=>{
    const init = {
        status: 200,
        statusText: 'ok!'
    };
    return new Response(JSON.stringify(data), init);
};
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $cdd1e9f9feeb24fd$var$getIsSSR = ()=>Boolean(undefined);
const $cdd1e9f9feeb24fd$var$confluenceFetcher = async (url, headers, requestInit)=>{
    // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Transition preloaders
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
        const cachedFetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
        if (cachedFetcher) return cachedFetcher;
    }
    let fetcher;
    fetcher = (0, $5dPMD.defaultFetcher)(url, headers, requestInit);
    fetcher = fetcher.then($cdd1e9f9feeb24fd$export$b3732c8ff6f9c463).then((res)=>res.json()).then((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithUrl(url, data);
        return $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data);
    });
    // When we're in SPA mode, we want to cache the fetcher so that it can be reused
    // if the network request takes too long and the data doesn't come back in time
    // before another request is requested by <Placement>
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) $cdd1e9f9feeb24fd$var$postOfficeClient.setFetcherWithUrl(url, fetcher);
    return fetcher;
};
const $cdd1e9f9feeb24fd$var$cookieMap = new Map([
    [
        'consentToken',
        (0, $301rJ.ATLASSIAN_CONSENT_COOKIE_KEY)
    ],
    [
        'fallbackConsentToken',
        (0, $301rJ.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)
    ]
]);
const $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders = (cookies)=>{
    if (typeof cookies !== 'object' || cookies === null) return undefined;
    return Array.from($cdd1e9f9feeb24fd$var$cookieMap.entries()).map(([key, value])=>{
        if (cookies[key]) return `${value}=${cookies[key]}`;
        return '';
    }).filter(Boolean).join(';');
};
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $cdd1e9f9feeb24fd$var$preloadPostOfficePlacement = async (placementId, contextOptions, extraFetchOptions)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    // Mirror client-side guard in Placement.tsx (useInitialDataIfEnabled → isPostOfficePlacementsGloballyDisabled)
    // to prevent SSR/client mismatch when placements are globally disabled (e.g. stableUI=1).
    if (postOfficeContext.disableAllPlacements) return;
    const confluenceFetcherWithS2SHeaders = async (url)=>{
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = Boolean(undefined);
        if (isSSR) {
            let hostEnv = 'prod';
            if (environment.currentEnv !== 'production') hostEnv = 'staging';
            const { cookiesConsentToken: cookiesConsentToken, cookiesFallbackToken: cookiesFallbackToken } = (0, $60cDW.getSSRRenderInputs)();
            const cookies = $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders({
                consentToken: cookiesConsentToken,
                fallbackConsentToken: cookiesFallbackToken
            });
            const fetchHeaders = !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'post-office',
                // Tells Tesseract to S2S with `post-office`
                'x-ssr-service-env': hostEnv // Defaults to current Env, however Post Office is not in dev
            } : {};
            if (cookies) fetchHeaders.Cookie = cookies;
            const finalUrl = (0, $d6NtA.isLocal)() ? url : url.replace('gateway/api/post-office/', '');
            return $cdd1e9f9feeb24fd$var$confluenceFetcher(finalUrl, fetchHeaders, extraFetchOptions?.requestInit);
        }
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, undefined, extraFetchOptions?.requestInit);
    };
    const basePath = (0, $bnKhH.buildBasePath)(environment.currentEnv, environment.envConfigs);
    return (0, $5dPMD.requestInitialData)(placementId, postOfficeContext, confluenceFetcherWithS2SHeaders, {
        ...basePath,
        resource: extraFetchOptions?.resource
    });
};
const $cdd1e9f9feeb24fd$export$420f2f91a928b3b6 = ()=>{
    return (0, $42omo.useCallback)((url, requestOptions)=>{
        // Use data in cache if it exists
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithUrl(url);
        if (data) /**
       * Preloaded data must be serialized, however our initialData is expected to be in the form of a Response promise.
       * TODO: Remove this workaround once the Post Office placement API is updated to handle flat data.
       */ return Promise.resolve($cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data));
        // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Placement component
        if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
            const fetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
            if (fetcher) return fetcher;
        }
        // Convert headers to Record<string, string> if present
        let headers = {};
        if (requestOptions?.headers) {
            if (requestOptions.headers instanceof Headers) requestOptions.headers.forEach((value, name)=>{
                headers[name] = value;
            });
            else if (Array.isArray(requestOptions.headers)) requestOptions.headers.forEach(([name, value])=>{
                headers[name] = value;
            });
            else headers = requestOptions.headers;
        }
        // Use a new fetcher if neither data nor fetcher is in cache
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, headers, requestOptions);
    }, []);
};
const $cdd1e9f9feeb24fd$export$17b92961ead3f211 = (placementId)=>{
    const [preloadedData, setPreloadedData] = (0, $42omo.useState)(()=>{
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithPlacementId(placementId);
        if (data) return data;
        return undefined;
    });
    const setter = (0, $42omo.useCallback)((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithPlacementId(placementId, data);
        setPreloadedData(data);
    }, [
        placementId
    ]);
    return [
        preloadedData,
        setter
    ];
};
const $cdd1e9f9feeb24fd$export$1d2f4123d64ba093 = async (placementId, extraFetchOptions)=>{
    const sessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const postOfficeTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_preload_postoffice_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return (0, $wPrRK.slowQueryGuard)(`preloadPostOfficePlacement:${placementId}`, ()=>$cdd1e9f9feeb24fd$var$preloadPostOfficePlacement(placementId, {
            postOfficeContext: (0, $0VKZa.sessionToPostOfficeContext)(sessionContext),
            environment: {
                currentEnv: (0, $0VKZa.transformConfluenceEnvToPostOfficeEnvironment)(sessionContext.environment)
            }
        }, extraFetchOptions), postOfficeTimeout);
};
module.exports["usePlacementSSRFetch"] = $cdd1e9f9feeb24fd$export$420f2f91a928b3b6;
module.exports["usePlacementPreloadedData"] = $cdd1e9f9feeb24fd$export$17b92961ead3f211;
module.exports["preloadPostOfficePlacementWithSessionContext"] = $cdd1e9f9feeb24fd$export$1d2f4123d64ba093;

});

parcelRegister("wPrRK", function(module, exports) {


var $9WAeG = parcelRequire("9WAeG");


var $1xpoY = parcelRequire("1xpoY");



const $0a25e88d230f5014$export$df0dc85e162077fe = 500;
const $0a25e88d230f5014$export$e4579551e9b7b973 = async (name, task, timeout, skipSignal)=>{
    let timer = null;
    const slowQueryGuardTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_slow_query_guard_timeout', $0a25e88d230f5014$export$df0dc85e162077fe);
    const finalTimeout = Math.max(timeout, slowQueryGuardTimeout);
    const timeoutPromise = new Promise((resolve)=>{
        timer = setTimeout(()=>{
            resolve(false);
        }, finalTimeout);
    });
    const runTask = async ()=>{
        const run = async ()=>{
            await (0, $9WAeG.SSRMeasures).run(`ssr-app/prepare/preloadQuery/slowQueryGuard:${name}`, task);
            if (timer) clearTimeout(timer);
            return true;
        };
        return run();
    };
    return Promise.race(skipSignal ? [
        timeoutPromise,
        skipSignal.then(()=>true),
        runTask()
    ] : [
        timeoutPromise,
        runTask()
    ]);
};
module.exports["SLOW_QUERY_DEFAULT_TIMEOUT"] = $0a25e88d230f5014$export$df0dc85e162077fe;
module.exports["slowQueryGuard"] = $0a25e88d230f5014$export$e4579551e9b7b973;

});

parcelRegister("d5fg6", function(module, exports) {
class $2eb32372f08d498d$export$11e1da55bed53d18 {
    getKey(url) {
        const urlMatches = url.match(/placements\/([\w\-\/]+)(?:.*updateKey=)?(\w+)?/);
        if (urlMatches?.length && urlMatches.length > 1) return urlMatches.slice(1).filter(Boolean).join('/');
        return url;
    }
    get(key) {
        return this.cache[key];
    }
    set(key, value) {
        this.cache[key] = value;
    }
    getDataWithPlacementId(placementId) {
        return this.get(`placements/${placementId}`)?.data;
    }
    setDataWithPlacementId(placementId, data) {
        this.set(`placements/${placementId}`, {
            data: data,
            fetcher: undefined
        });
    }
    getDataWithUrl(url) {
        return this.get('placements/' + this.getKey(url))?.data;
    }
    setDataWithUrl(url, data) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            fetcher: cache?.fetcher,
            data: data
        });
    }
    getFetcherWithUrl(url) {
        return this.get(`placements/${this.getKey(url)}`)?.fetcher;
    }
    setFetcherWithUrl(url, fetcher) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            data: cache?.data,
            fetcher: fetcher
        });
    }
    constructor(cache){
        this.cache = cache;
        globalThis.__POST_OFFICE_QUERY_CACHE__ = cache;
    }
}
module.exports["PostOfficeCacheClient"] = $2eb32372f08d498d$export$11e1da55bed53d18;

});

parcelRegister("0VKZa", function(module, exports) {

var $i3jcY = parcelRequire("i3jcY");


var $d9tcB = parcelRequire("d9tcB");

const $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT = 'confluence';
const $e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT,
    locale: 'en'
};
const $e888fb1bd5b30926$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $e888fb1bd5b30926$export$40fdfb947dabfc30 = (sessionData)=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId, locale: locale, orgId: orgId, edition: edition } = sessionData;
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const workspaceAri = $e888fb1bd5b30926$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        orgId: orgId,
        isSiteAdmin: isAdmin,
        tenantId: cloudId === '' ? undefined : cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        subproduct: undefined,
        productEdition: edition || undefined,
        disableAllPlacements: (0, $i3jcY.isStableUIEnabledForTests)() ? true : undefined
    };
};
const $e888fb1bd5b30926$export$76d03739bfe0286a = (environment)=>{
    switch(environment){
        case 'STAGING':
            return 'staging';
        case 'PRODUCTION':
            return 'production';
        case 'DEVELOPMENT':
            return 'local';
        default:
            return 'local';
    }
};
module.exports["sessionToPostOfficeContext"] = $e888fb1bd5b30926$export$40fdfb947dabfc30;
module.exports["transformConfluenceEnvToPostOfficeEnvironment"] = $e888fb1bd5b30926$export$76d03739bfe0286a;

});

parcelRegister("9QvUi", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $4H1Ql = parcelRequire("4H1Ql");


var $NT2w1 = parcelRequire("NT2w1");


var $2mPpz = parcelRequire("2mPpz");


var $eXPKf = parcelRequire("eXPKf");


var $42omo = parcelRequire("42omo");


var $2xYsH = parcelRequire("2xYsH");


var $hnA4H = parcelRequire("hnA4H");

const $13bb23ac78effffb$var$STABLE_OBJECT = {};
const $13bb23ac78effffb$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $42omo.useMemo)(()=>(0, $2mPpz.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $4H1Ql.useStableObject)(placementProps ?? $13bb23ac78effffb$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eXPKf.PerformanceTrackingSegment), {
        placementId: placementId,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $NT2w1.default), {
            placementId: placementId,
            consumptionType: "local",
            onEvent: onEvent,
            disableInitialData: disableInitialData,
            children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2xYsH.default), {
                    analyticsChannel: (0, $hnA4H.ANALYTICS_CHANNEL),
                    placementId: placementId,
                    onError: sharedOnEvent,
                    fallback: ErrorFallback,
                    children: /*#__PURE__*/ (0, $l998X.jsx)(MemoizedPlacement, {
                        initialData: initialData,
                        context: context,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore - Confluence Local Consumption
                        errorFallback: ErrorFallback,
                        onEvent: sharedOnEvent,
                        ...stableLocalPlacementProps,
                        children: children
                    })
                })
        })
    });
};
const $13bb23ac78effffb$var$PlacementMemoized = /*#__PURE__*/ (0, $42omo.memo)($13bb23ac78effffb$var$Placement);
var $13bb23ac78effffb$export$2e2bcd8739ae039 = $13bb23ac78effffb$var$PlacementMemoized;
module.exports["default"] = $13bb23ac78effffb$export$2e2bcd8739ae039;

});

parcelRegister("NT2w1", function(module, exports) {

var $ffCOo = parcelRequire("ffCOo");


var $1eSke = parcelRequire("1eSke");

var $PAiZW = parcelRequire("PAiZW");

var $6yHRM = parcelRequire("6yHRM");

var $4H1Ql = parcelRequire("4H1Ql");


var $3NyPa = parcelRequire("3NyPa");


var $kO3gu = parcelRequire("kO3gu");


var $42omo = parcelRequire("42omo");


var $4u5NT = parcelRequire("4u5NT");


var $dE7qQ = parcelRequire("dE7qQ");


var $5dPMD = parcelRequire("5dPMD");


var $dug7n = parcelRequire("dug7n");


var $feexy = parcelRequire("feexy");


var $9x4nt = parcelRequire("9x4nt");


var $dh538 = parcelRequire("dh538");

const $80ab3a0c2f45d583$var$useInitialDataIfEnabled = (placementId, context, baseUrl, path, disableInitialData)=>{
    const fetcher = (0, $kO3gu.usePlacementFetchingContext)();
    const arePlacementsGloballyDisabled = (0, $1eSke.isPostOfficePlacementsGloballyDisabled)(context);
    return (0, $42omo.useMemo)(()=>arePlacementsGloballyDisabled || disableInitialData ? undefined : (0, $5dPMD.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        arePlacementsGloballyDisabled,
        disableInitialData,
        baseUrl,
        path,
        placementId,
        context,
        fetcher.fetch
    ]);
};
/**
 * Validates error is a standard Error instance. If not, wraps in new Error instance.
 */ const $80ab3a0c2f45d583$var$validateErrorFromEventType = (err, eventType)=>{
    if (err instanceof Error) return err;
    if (typeof err === 'string') return new Error(err);
    return new Error(`Unknown error during ${eventType}`);
};
/**
 * Reports an error to UFO v2 for a given placement, on the current UFO v2 active interaction.
 * @param ufoV2Interaction Context of the current active UFO v2 interaction
 * @param placementId Post Office placement identifier
 * @param error
 * @param errorEventType Event type that triggered the error
 * @returns void
 */ const $80ab3a0c2f45d583$var$handleUfoV2Error = ({ ufoV2Interaction: ufoV2Interaction, placementId: placementId, error: error, errorEventType: errorEventType })=>{
    const validatedError = $80ab3a0c2f45d583$var$validateErrorFromEventType(error, errorEventType);
    const { interactionId: interactionId, labelStack: labelStack } = ufoV2Interaction;
    if (interactionId) (0, $4u5NT.addError)(interactionId, `${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
    else (0, $4u5NT.addErrorToAll)(`${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
};
const $80ab3a0c2f45d583$var$Placement = ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $6yHRM.usePostOfficeRoute)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $dug7n.useBuildBasePath)();
    const stableContextWithRoute = (0, $4H1Ql.useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $42omo.useMemo)(()=>isUFOEnabled ? new (0, $3NyPa.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    const ufoV2InteractionId = (0, $42omo.useContext)((0, $feexy.default));
    const ufoV2InteractionContext = (0, $42omo.useContext)((0, $9x4nt.default));
    const stableUfoV2Interaction = (0, $4H1Ql.useStableObject)({
        interactionId: ufoV2InteractionId.current,
        labelStack: ufoV2InteractionContext?.labelStack
    });
    // Callback function to listen to the different stages of the component and track its performance
    const componentOnEvent = (0, $42omo.useCallback)(({ type: type, error: error })=>{
        // Used for local placement components, UFO v2 events
        if (consumptionType === 'local') {
            switch(type){
                case 'fetch-error':
                case 'component-error':
                case 'render-error':
                    if ((0, $dh538.fg)('post-office_enable_ufo-v2-add-error')) $80ab3a0c2f45d583$var$handleUfoV2Error({
                        ufoV2Interaction: stableUfoV2Interaction,
                        placementId: placementId,
                        error: error,
                        errorEventType: type
                    });
            }
            return;
        }
        // Used for remote placement components, UFO v1 events
        if (consumptionType === 'remote') {
            placementOnEvent?.({
                type: type,
                error: error
            });
            switch(type){
                case 'fetch-complete':
                    ufoV1PlacementTracker?.markFetchComplete();
                    break;
                case 'fetch-error':
                    ufoV1PlacementTracker?.markFetchFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                    break;
                case 'render-complete':
                    ufoV1PlacementTracker?.markRenderComplete();
                    break;
                case 'render-error':
                    ufoV1PlacementTracker?.markRenderFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                    break;
                case 'initial-data-complete':
                    ufoV1PlacementTracker?.markInitialDataComplete();
                    break;
                case 'initial-data-error':
                    ufoV1PlacementTracker?.markInitialDataFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-error':
                    ufoV1PlacementTracker?.markComponentFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-ready':
                    ufoV1PlacementTracker?.markComponentReady();
                    break;
                case 'unmount':
                    ufoV1PlacementTracker?.markComponentAborted();
                    break;
            }
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker,
        consumptionType,
        placementId,
        stableUfoV2Interaction
    ]);
    const initialData = $80ab3a0c2f45d583$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    const placementAnalyticsContext = (0, $42omo.useMemo)(()=>({
            source: (0, $dE7qQ.ANALYTICS_SOURCE),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app'
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ffCOo.PostOfficeAnalyticsContext), {
        data: placementAnalyticsContext
    }, children({
        initialData: initialData,
        context: stableContextWithRoute,
        onEvent: componentOnEvent
    }));
};
var $80ab3a0c2f45d583$export$2e2bcd8739ae039 = $80ab3a0c2f45d583$var$Placement;
module.exports["default"] = $80ab3a0c2f45d583$export$2e2bcd8739ae039;

});

parcelRegister("6yHRM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxT4C = parcelRequire("hxT4C");


var $4H1Ql = parcelRequire("4H1Ql");

const $d8346e8a2779e8cd$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $d8346e8a2779e8cd$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        const next = routeChange.next?.toString();
        if (next === state.current && state.searchParams === routeChange.next?.searchParams) return;
        state = {
            previous: state.current,
            current: next,
            searchParams: routeChange.next?.searchParams
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $d8346e8a2779e8cd$var$usePostOfficeRouteStore = ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $hxT4C.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $4H1Ql.useStableObject)(route);
};
const $d8346e8a2779e8cd$var$initialState = {
    previous: undefined,
    current: undefined,
    searchParams: undefined
};
const $d8346e8a2779e8cd$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$d8346e8a2779e8cd$var$initialState,
        current: initialUrl ? initialUrl?.toString() : undefined,
        searchParams: initialUrl?.searchParams
    });
const $d8346e8a2779e8cd$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $42omo.createContext)($d8346e8a2779e8cd$var$initialState);
const $d8346e8a2779e8cd$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $42omo.useRef)();
    if (!ref.current) ref.current = $d8346e8a2779e8cd$export$98c77e1bd702ed15(props);
    const route = $d8346e8a2779e8cd$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d8346e8a2779e8cd$export$f7f47a74e8b47b1f.Provider, {
        value: route
    }, children);
};
const $d8346e8a2779e8cd$export$79301b66f7808cd8 = ()=>(0, $42omo.useContext)($d8346e8a2779e8cd$export$f7f47a74e8b47b1f); //Route listener
module.exports["PostOfficeRouteContext"] = $d8346e8a2779e8cd$export$f7f47a74e8b47b1f;
module.exports["PostOfficeRouteProvider"] = $d8346e8a2779e8cd$export$89eadc6b3e5f4e9e;
module.exports["usePostOfficeRoute"] = $d8346e8a2779e8cd$export$79301b66f7808cd8;

});

parcelRegister("dE7qQ", function(module, exports) {
const $2d2adb07a8ea6d4a$export$85183a312807388d = 'postOffice';
const $2d2adb07a8ea6d4a$export$f7109619a5e9e0d6 = 'post-office-frontend';
module.exports["ANALYTICS_SOURCE"] = $2d2adb07a8ea6d4a$export$f7109619a5e9e0d6;

});

parcelRegister("dug7n", function(module, exports) {

var $bnKhH = parcelRequire("bnKhH");

var $c3xd8 = parcelRequire("c3xd8");


var $42omo = parcelRequire("42omo");

const $f2f503b4228c54ff$export$83d6c58b7ab7ae67 = ()=>{
    const postOfficeEnvironment = (0, $c3xd8.usePostOfficeEnvironment)();
    return (0, $42omo.useMemo)(()=>(0, $bnKhH.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
        postOfficeEnvironment.currentEnv,
        postOfficeEnvironment.envConfigs
    ]);
};
module.exports["useBuildBasePath"] = $f2f503b4228c54ff$export$83d6c58b7ab7ae67;

});

parcelRegister("2xYsH", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $1DWH0 = parcelRequire("1DWH0");


var $42omo = parcelRequire("42omo");

class $1916333c8b5a116e$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
const $1916333c8b5a116e$var$ErrorBoundaryWithAnalytics = (0, $1DWH0.default)()($1916333c8b5a116e$var$ErrorBoundary);
var $1916333c8b5a116e$export$2e2bcd8739ae039 = $1916333c8b5a116e$var$ErrorBoundaryWithAnalytics;
module.exports["default"] = $1916333c8b5a116e$export$2e2bcd8739ae039;

});

parcelRegister("hnA4H", function(module, exports) {
const $f3b0e253e752d4df$export$85183a312807388d = 'postOffice';
module.exports["ANALYTICS_CHANNEL"] = $f3b0e253e752d4df$export$85183a312807388d;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $frIzR.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("aaVos", function(module, exports) {

let $76875baed79c70d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $76875baed79c70d0$var$load("6Ci2O").then(()=>parcelRequire('jpPFR'));

});

parcelRegister("gkVDU", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");

var $i3c1S = parcelRequire("i3c1S");


var $1UCmC = parcelRequire("1UCmC");

var $jX1qB = parcelRequire("jX1qB");


var $bxcP5 = parcelRequire("bxcP5");

const $b122e413b2e9a2d7$export$6e008bd122a517f = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.HOME_OVERVIEW_RECENT_SEGMENT_KEY),
    // Set FMP = FCP if SSR (normally FMP = TTI)
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $b122e413b2e9a2d7$export$b80080833943f333 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY),
    // Set FMP = FCP if SSR (normally FMP = TTI)
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $b122e413b2e9a2d7$export$818919f7ea82fa05 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY),
    // Set FMP = FCP if SSR (normally FMP = TTI)
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $b122e413b2e9a2d7$var$expectedPageSegments = [
    $b122e413b2e9a2d7$export$6e008bd122a517f,
    (0, $bxcP5.HOME_OVERVIEW_FEED_PAGE_SEGMENT),
    $b122e413b2e9a2d7$export$818919f7ea82fa05,
    $b122e413b2e9a2d7$export$b80080833943f333
];
const $b122e413b2e9a2d7$export$238b3665fb2c4c64 = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.CONFLUENCE_HOME_LOAD_KEY),
    timings: (0, $i3c1S.getWaterfallTimings)($b122e413b2e9a2d7$var$expectedPageSegments),
    include: $b122e413b2e9a2d7$var$expectedPageSegments,
    // Set FMP = FCP if SSR (normally FMP = TTI)
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["HOME_OVERVIEW_RECENT_PAGE_SEGMENT"] = $b122e413b2e9a2d7$export$6e008bd122a517f;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_PAGE_SEGMENT"] = $b122e413b2e9a2d7$export$818919f7ea82fa05;
module.exports["CONFLUENCE_HOME_PAGE_LOAD"] = $b122e413b2e9a2d7$export$238b3665fb2c4c64;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $3kTfj = parcelRequire("3kTfj");

var $kyiqo = parcelRequire("kyiqo");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $kyiqo.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $kyiqo.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $kyiqo.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $kyiqo.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("1UCmC", function(module, exports) {
const $00aca2e58bbddd9e$export$9ee3c9e81070f140 = 'admin-announcement-banner-setting-page';
const $00aca2e58bbddd9e$export$162462d8f302c50a = 'advanced-search';
const $00aca2e58bbddd9e$export$17e011598d6a739d = 'unified-search';
const $00aca2e58bbddd9e$export$a88513891a2ab6b7 = 'confluence-home';
const $00aca2e58bbddd9e$export$5614199f62986e3b = 'all-drafts';
const $00aca2e58bbddd9e$export$3bbaa81ece500746 = 'recent-pages';
const $00aca2e58bbddd9e$export$b634edee624f5dc2 = 'starred-pages';
const $00aca2e58bbddd9e$export$5946c48030569b81 = 'content-history';
const $00aca2e58bbddd9e$export$1eefb862c6c6ce00 = 'edit-page';
const $00aca2e58bbddd9e$export$e164999ba8681ff6 = 'edit-template';
const $00aca2e58bbddd9e$export$6cdf3f4614ddd679 = 'edit-template-old';
const $00aca2e58bbddd9e$export$8faa34d8ba45e128 = 'embedded-view-page';
const $00aca2e58bbddd9e$export$3fb3338cf2b36704 = 'embedded-edit-page';
const $00aca2e58bbddd9e$export$779fbc1a16a8cb5d = 'global-permissions';
const $00aca2e58bbddd9e$export$9d8c586f3355f180 = 'inaccessible-page';
const $00aca2e58bbddd9e$export$a0c73183bde575ec = 'not-found';
const $00aca2e58bbddd9e$export$6d480c75094dbd7f = 'space-directory';
const $00aca2e58bbddd9e$export$8d0f9920174f22b4 = 'space-overview';
const $00aca2e58bbddd9e$export$228f2841a225e5ad = 'space-pages';
const $00aca2e58bbddd9e$export$fe4f0edc4d6532a8 = 'tasks-home';
const $00aca2e58bbddd9e$export$cc53520b570e0a46 = 'content-manager';
const $00aca2e58bbddd9e$export$bdc26b2b517231a = 'space-manager';
const $00aca2e58bbddd9e$export$b6d237d1e8f12e5d = 'template-gallery';
const $00aca2e58bbddd9e$export$a715ad00b824ec3f = 'view-page';
const $00aca2e58bbddd9e$export$132f38e0c19c02b6 = 'embedded-marketplace';
const $00aca2e58bbddd9e$export$d2dddf4422ad7ae8 = 'create-content';
const $00aca2e58bbddd9e$export$9c7a9f4f853f6fba = 'public-link-shared-page';
const $00aca2e58bbddd9e$export$643b9c181748da38 = 'public-link-site-setting-page';
const $00aca2e58bbddd9e$export$4716363caa82a23b = 'public-links-space-settings-page';
const $00aca2e58bbddd9e$export$75726af5c0ee9402 = 'whiteboard-view-page';
const $00aca2e58bbddd9e$export$afe76b61b3f9aaa8 = 'database-view-page';
const $00aca2e58bbddd9e$export$dd63a13fc6c1ba34 = 'embed-view-page';
const $00aca2e58bbddd9e$export$16aeb03ec0c24b89 = 'live-page';
const $00aca2e58bbddd9e$export$ce4e0f6f3d614d45 = 'live-edit';
const $00aca2e58bbddd9e$export$ecea02b4eaa314f3 = 'team-calendars';
const $00aca2e58bbddd9e$export$726cbfa087a55101 = 'admin-team-calendars';
const $00aca2e58bbddd9e$export$2f245ed7ebaea89 = 'admin-general-configuration';
const $00aca2e58bbddd9e$export$2af60fefae96902b = 'admin-configure-code-macro';
const $00aca2e58bbddd9e$export$fbea00ed02ef2502 = 'admin-default-space-logo-config';
const $00aca2e58bbddd9e$export$6e9c07174668ae36 = 'admin-header-and-footer';
const $00aca2e58bbddd9e$export$51fdddeccf175d74 = 'admin-security-configuration';
const $00aca2e58bbddd9e$export$2d0370cc7d14b72e = 'admin-templates-and-blueprints';
const $00aca2e58bbddd9e$export$a8d02dbd84c83dd = 'admin-import-spaces';
const $00aca2e58bbddd9e$export$1d91ea2ef976728a = 'admin-trashed-spaces';
const $00aca2e58bbddd9e$export$a13bfc71dc6b7924 = 'admin-application-navigator';
const $00aca2e58bbddd9e$export$3ba6335cd90d2e59 = 'admin-themes';
const $00aca2e58bbddd9e$export$cb4b6b707a32ee92 = 'admin-jira-macro-repair';
const $00aca2e58bbddd9e$export$5cb6689cb672a5c0 = 'admin-pdf-export';
const $00aca2e58bbddd9e$export$fff7d33fb1514c44 = 'admin-macro-usage';
const $00aca2e58bbddd9e$export$d4aa60a3ffc18652 = 'admin-user-access';
const $00aca2e58bbddd9e$export$52c0c13179848b50 = 'CONTENT_ANALYTICS';
const $00aca2e58bbddd9e$export$40dab65f060e1231 = 'SPACE_ANALYTICS';
const $00aca2e58bbddd9e$export$b682ed6d6fa429fb = 'INSTANCE_ANALYTICS';
const $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1 = 'space-details';
const $00aca2e58bbddd9e$export$2633c6986b98b723 = 'pdf-export-route';
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9ee3c9e81070f140;
module.exports["ADVANCED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$162462d8f302c50a;
module.exports["UNIFIED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$17e011598d6a739d;
module.exports["CONFLUENCE_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$a88513891a2ab6b7;
module.exports["CONFLUENCE_DRAFTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$5614199f62986e3b;
module.exports["CONFLUENCE_RECENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$3bbaa81ece500746;
module.exports["CONFLUENCE_STARRED_LOAD_KEY"] = $00aca2e58bbddd9e$export$b634edee624f5dc2;
module.exports["CONTENT_HISTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$5946c48030569b81;
module.exports["EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$1eefb862c6c6ce00;
module.exports["EDIT_TEMPLATE_LOAD_KEY"] = $00aca2e58bbddd9e$export$e164999ba8681ff6;
module.exports["EDIT_TEMPLATE_OLD_LOAD_KEY"] = $00aca2e58bbddd9e$export$6cdf3f4614ddd679;
module.exports["EMBEDDED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$8faa34d8ba45e128;
module.exports["EMBEDDED_EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$3fb3338cf2b36704;
module.exports["GLOBAL_PERMISSIONS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$779fbc1a16a8cb5d;
module.exports["INACCESSIBLE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9d8c586f3355f180;
module.exports["NOT_FOUND_LOAD_KEY"] = $00aca2e58bbddd9e$export$a0c73183bde575ec;
module.exports["SPACE_DIRECTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$6d480c75094dbd7f;
module.exports["SPACE_OVERVIEW_LOAD_KEY"] = $00aca2e58bbddd9e$export$8d0f9920174f22b4;
module.exports["SPACE_PAGES_LOAD_KEY"] = $00aca2e58bbddd9e$export$228f2841a225e5ad;
module.exports["TASKS_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$fe4f0edc4d6532a8;
module.exports["CONTENT_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$cc53520b570e0a46;
module.exports["SPACE_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$bdc26b2b517231a;
module.exports["TEMPLATE_GALLERY_LOAD_KEY"] = $00aca2e58bbddd9e$export$b6d237d1e8f12e5d;
module.exports["VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$a715ad00b824ec3f;
module.exports["EMBEDDED_MARKETPLACE_LOAD_KEY"] = $00aca2e58bbddd9e$export$132f38e0c19c02b6;
module.exports["CREATE_CONTENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$d2dddf4422ad7ae8;
module.exports["PUBLIC_LINK_SHARED_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9c7a9f4f853f6fba;
module.exports["PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$643b9c181748da38;
module.exports["WHITEBOARD_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$75726af5c0ee9402;
module.exports["DATABASE_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$afe76b61b3f9aaa8;
module.exports["EMBED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$dd63a13fc6c1ba34;
module.exports["LIVE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$16aeb03ec0c24b89;
module.exports["LIVE_PAGE_REACT_UFO_LOAD_KEY"] = $00aca2e58bbddd9e$export$ce4e0f6f3d614d45;
module.exports["TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$ecea02b4eaa314f3;
module.exports["ADMIN_TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$726cbfa087a55101;
module.exports["ADMIN_GENERAL_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$2f245ed7ebaea89;
module.exports["ADMIN_CONFIGURE_CODE_MACRO_LOAD_KEY"] = $00aca2e58bbddd9e$export$2af60fefae96902b;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_KEY"] = $00aca2e58bbddd9e$export$fbea00ed02ef2502;
module.exports["ADMIN_HEADER_AND_FOOTER_LOAD_KEY"] = $00aca2e58bbddd9e$export$6e9c07174668ae36;
module.exports["ADMIN_SECURITY_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$51fdddeccf175d74;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$2d0370cc7d14b72e;
module.exports["ADMIN_IMPORT_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$a8d02dbd84c83dd;
module.exports["ADMIN_TRASHED_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$1d91ea2ef976728a;
module.exports["ADMIN_APPLICATION_NAVIGATOR_KEY"] = $00aca2e58bbddd9e$export$a13bfc71dc6b7924;
module.exports["ADMIN_THEMES_LOAD_KEY"] = $00aca2e58bbddd9e$export$3ba6335cd90d2e59;
module.exports["ADMIN_JIRA_MACRO_REPAIR_LOAD_KEY"] = $00aca2e58bbddd9e$export$cb4b6b707a32ee92;
module.exports["ADMIN_PDF_EXPORT_LOAD_KEY"] = $00aca2e58bbddd9e$export$5cb6689cb672a5c0;
module.exports["ADMIN_MACRO_USAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$fff7d33fb1514c44;
module.exports["ADMIN_USER_ACCESS_KEY"] = $00aca2e58bbddd9e$export$d4aa60a3ffc18652;
module.exports["PAGE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$52c0c13179848b50;
module.exports["SPACE_ANALYTICS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$40dab65f060e1231;
module.exports["SITE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$b682ed6d6fa429fb;
module.exports["SPACE_DETAILS_LOAD_KEY"] = $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1;
module.exports["PDF_EXPORT_ROUTE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2633c6986b98b723;

});

parcelRegister("lkQRq", function(module, exports) {
/**
 * @generated SignedSource<<5e6dc5fedc0d7b393180fe43b9febef9>>
 * @relayHash f1f5bc833b3adcfaa8f23a0262a11c35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a3dfcdba660c43ea3c005773a8867b277288a1f1828accb84953d86fd5503884
const $8e3067533735c561$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "HomeWidget",
                    "kind": "LinkedField",
                    "name": "homeWidgets",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "state"
                        },
                        v0 /*: any*/ 
                    ]
                },
                v0 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useHomeWidgetStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useHomeWidgetStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f1f5bc833b3adcfaa8f23a0262a11c35",
            "id": "a3dfcdba660c43ea3c005773a8867b277288a1f1828accb84953d86fd5503884",
            "metadata": {},
            "name": "useHomeWidgetStateQuery",
            "operationKind": "query",
            "text": "query useHomeWidgetStateQuery{userPreferences{homeWidgets{id,state,__typename},__typename}}"
        }
    };
}();
$8e3067533735c561$var$node.hash = "2b3d6cba775f89e74fb24fec1d37c65d";
var $8e3067533735c561$export$2e2bcd8739ae039 = $8e3067533735c561$var$node;
module.exports["default"] = $8e3067533735c561$export$2e2bcd8739ae039;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("4vC63", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $bflGB = parcelRequire("bflGB");


var $1k6sE = parcelRequire("1k6sE");

const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { module: module, tooltip: t1, children: children } = t0;
    const tooltip = t1 === undefined ? "" : t1;
    let accelerator;
    let t2;
    if ($[0] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t2 = accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = module;
        $[1] = accelerator;
        $[2] = t2;
    } else {
        accelerator = $[1];
        t2 = $[2];
    }
    if (t2) {
        const t3 = `forge-keyboard-shortcut-visualizer-${accelerator}`;
        let t4;
        if ($[3] !== accelerator || $[4] !== tooltip) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: accelerator,
                contentBefore: tooltip,
                isTooltip: true
            });
            $[3] = accelerator;
            $[4] = tooltip;
            $[5] = t4;
        } else t4 = $[5];
        let t5;
        if ($[6] !== children || $[7] !== t3 || $[8] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                tag: "span",
                testId: t3,
                content: t4
            }, children);
            $[6] = children;
            $[7] = t3;
            $[8] = t4;
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    }
    let t3;
    if ($[10] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[10] = children;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip,
            isTooltip: true
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { module: module, action: action } = t0;
    let accelerator;
    let t1;
    if ($[0] !== action || $[1] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t1 = accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = action;
        $[1] = module;
        $[2] = accelerator;
        $[3] = t1;
    } else {
        accelerator = $[2];
        t1 = $[3];
    }
    if (t1) {
        const t2 = `forge-keyboard-shortcut-${accelerator}`;
        let t3;
        if ($[4] !== accelerator || $[5] !== action) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
                accelerator: accelerator,
                listener: action,
                shortcutType: (0, $bflGB.ShortcutType).Forge
            });
            $[4] = accelerator;
            $[5] = action;
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== t2 || $[8] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                "data-testid": t2
            }, t3);
            $[7] = t2;
            $[8] = t3;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    return null;
} : ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $bflGB.ShortcutType).Forge
    }));
    return null;
};
module.exports["ForgeKeyboardShortcutVisualizer"] = $c1fece3650e281b8$export$b804abdac3f5f117;
module.exports["ForgeKeyboardShortcut"] = $c1fece3650e281b8$export$4e51bfd8ba3e71ef;

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("hFuXC"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("hFuXC", function(module, exports) {

let $cdce481da9c47d1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cdce481da9c47d1c$var$load("e1RjR"),
    $cdce481da9c47d1c$var$load("hhss7"),
    $cdce481da9c47d1c$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("lLEEZ"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("4eE7x"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("beXfC"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("71pm5"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("kfOJN"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("49RFm"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("2D0DU"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("6FCaq"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("hrWWA"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("2rCgd"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("8ynWU"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("6Bffc"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("lLEEZ", function(module, exports) {

let $fd8d87048f406a5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fd8d87048f406a5d$var$load("2YffH"),
    $fd8d87048f406a5d$var$load("eNXrl"),
    $fd8d87048f406a5d$var$load("iUYwr"),
    $fd8d87048f406a5d$var$load("7o5Pu"),
    $fd8d87048f406a5d$var$load("jjZO0"),
    $fd8d87048f406a5d$var$load("AGwzU"),
    $fd8d87048f406a5d$var$load("lo4Uk"),
    $fd8d87048f406a5d$var$load("jEvZI"),
    $fd8d87048f406a5d$var$load("eBRUf"),
    $fd8d87048f406a5d$var$load("fjVVr"),
    $fd8d87048f406a5d$var$load("rFdxz"),
    $fd8d87048f406a5d$var$load("2tIxk"),
    $fd8d87048f406a5d$var$load("dLq4a"),
    $fd8d87048f406a5d$var$load("h9S8v"),
    $fd8d87048f406a5d$var$load("27glK"),
    $fd8d87048f406a5d$var$load("bvY53"),
    $fd8d87048f406a5d$var$load("lTK3c"),
    $fd8d87048f406a5d$var$load("1WXdc"),
    $fd8d87048f406a5d$var$load("3GuOt"),
    $fd8d87048f406a5d$var$load("hUmZG"),
    $fd8d87048f406a5d$var$load("h4Nf7"),
    $fd8d87048f406a5d$var$load("5o4Kn"),
    $fd8d87048f406a5d$var$load("6rS39"),
    $fd8d87048f406a5d$var$load("3MYQs"),
    $fd8d87048f406a5d$var$load("6SWFK"),
    $fd8d87048f406a5d$var$load("5zapo"),
    $fd8d87048f406a5d$var$load("6wr18"),
    $fd8d87048f406a5d$var$load("9atVd"),
    $fd8d87048f406a5d$var$load("ffEVr"),
    $fd8d87048f406a5d$var$load("5JkDi"),
    $fd8d87048f406a5d$var$load("jbM5v"),
    $fd8d87048f406a5d$var$load("219St"),
    $fd8d87048f406a5d$var$load("b1DMS"),
    $fd8d87048f406a5d$var$load("lVrrs"),
    $fd8d87048f406a5d$var$load("3NkiL"),
    $fd8d87048f406a5d$var$load("1bbSu"),
    $fd8d87048f406a5d$var$load("kbwlB"),
    $fd8d87048f406a5d$var$load("hhss7"),
    $fd8d87048f406a5d$var$load("Wowvf"),
    $fd8d87048f406a5d$var$load("cRtGo"),
    $fd8d87048f406a5d$var$load("4qVsX"),
    $fd8d87048f406a5d$var$load("jPZn6"),
    $fd8d87048f406a5d$var$load("hCiBy"),
    $fd8d87048f406a5d$var$load("2OkLl"),
    $fd8d87048f406a5d$var$load("lnKog"),
    $fd8d87048f406a5d$var$load("h3ABO"),
    $fd8d87048f406a5d$var$load("kC80R"),
    $fd8d87048f406a5d$var$load("7EorR"),
    $fd8d87048f406a5d$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("4eE7x", function(module, exports) {

let $31579751564dfb89$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $31579751564dfb89$var$load("2YffH"),
    $31579751564dfb89$var$load("eNXrl"),
    $31579751564dfb89$var$load("iUYwr"),
    $31579751564dfb89$var$load("7o5Pu"),
    $31579751564dfb89$var$load("jjZO0"),
    $31579751564dfb89$var$load("AGwzU"),
    $31579751564dfb89$var$load("lo4Uk"),
    $31579751564dfb89$var$load("jEvZI"),
    $31579751564dfb89$var$load("eBRUf"),
    $31579751564dfb89$var$load("fjVVr"),
    $31579751564dfb89$var$load("rFdxz"),
    $31579751564dfb89$var$load("2tIxk"),
    $31579751564dfb89$var$load("dLq4a"),
    $31579751564dfb89$var$load("h9S8v"),
    $31579751564dfb89$var$load("27glK"),
    $31579751564dfb89$var$load("bvY53"),
    $31579751564dfb89$var$load("lTK3c"),
    $31579751564dfb89$var$load("1WXdc"),
    $31579751564dfb89$var$load("3GuOt"),
    $31579751564dfb89$var$load("hUmZG"),
    $31579751564dfb89$var$load("h4Nf7"),
    $31579751564dfb89$var$load("5o4Kn"),
    $31579751564dfb89$var$load("6rS39"),
    $31579751564dfb89$var$load("3MYQs"),
    $31579751564dfb89$var$load("6SWFK"),
    $31579751564dfb89$var$load("5zapo"),
    $31579751564dfb89$var$load("6wr18"),
    $31579751564dfb89$var$load("9atVd"),
    $31579751564dfb89$var$load("ffEVr"),
    $31579751564dfb89$var$load("5JkDi"),
    $31579751564dfb89$var$load("jbM5v"),
    $31579751564dfb89$var$load("219St"),
    $31579751564dfb89$var$load("b1DMS"),
    $31579751564dfb89$var$load("lVrrs"),
    $31579751564dfb89$var$load("3NkiL"),
    $31579751564dfb89$var$load("1bbSu"),
    $31579751564dfb89$var$load("kbwlB"),
    $31579751564dfb89$var$load("hhss7"),
    $31579751564dfb89$var$load("Wowvf"),
    $31579751564dfb89$var$load("cRtGo"),
    $31579751564dfb89$var$load("4qVsX"),
    $31579751564dfb89$var$load("jPZn6"),
    $31579751564dfb89$var$load("hCiBy"),
    $31579751564dfb89$var$load("2OkLl"),
    $31579751564dfb89$var$load("lnKog"),
    $31579751564dfb89$var$load("h3ABO"),
    $31579751564dfb89$var$load("kC80R"),
    $31579751564dfb89$var$load("7EorR"),
    $31579751564dfb89$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("beXfC", function(module, exports) {

let $82eef6831c2c6a3b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $82eef6831c2c6a3b$var$load("2YffH"),
    $82eef6831c2c6a3b$var$load("eNXrl"),
    $82eef6831c2c6a3b$var$load("iUYwr"),
    $82eef6831c2c6a3b$var$load("7o5Pu"),
    $82eef6831c2c6a3b$var$load("jjZO0"),
    $82eef6831c2c6a3b$var$load("AGwzU"),
    $82eef6831c2c6a3b$var$load("lo4Uk"),
    $82eef6831c2c6a3b$var$load("jEvZI"),
    $82eef6831c2c6a3b$var$load("eBRUf"),
    $82eef6831c2c6a3b$var$load("fjVVr"),
    $82eef6831c2c6a3b$var$load("rFdxz"),
    $82eef6831c2c6a3b$var$load("2tIxk"),
    $82eef6831c2c6a3b$var$load("dLq4a"),
    $82eef6831c2c6a3b$var$load("h9S8v"),
    $82eef6831c2c6a3b$var$load("27glK"),
    $82eef6831c2c6a3b$var$load("bvY53"),
    $82eef6831c2c6a3b$var$load("lTK3c"),
    $82eef6831c2c6a3b$var$load("1WXdc"),
    $82eef6831c2c6a3b$var$load("3GuOt"),
    $82eef6831c2c6a3b$var$load("hUmZG"),
    $82eef6831c2c6a3b$var$load("h4Nf7"),
    $82eef6831c2c6a3b$var$load("5o4Kn"),
    $82eef6831c2c6a3b$var$load("6rS39"),
    $82eef6831c2c6a3b$var$load("3MYQs"),
    $82eef6831c2c6a3b$var$load("6SWFK"),
    $82eef6831c2c6a3b$var$load("5zapo"),
    $82eef6831c2c6a3b$var$load("6wr18"),
    $82eef6831c2c6a3b$var$load("9atVd"),
    $82eef6831c2c6a3b$var$load("ffEVr"),
    $82eef6831c2c6a3b$var$load("5JkDi"),
    $82eef6831c2c6a3b$var$load("jbM5v"),
    $82eef6831c2c6a3b$var$load("219St"),
    $82eef6831c2c6a3b$var$load("b1DMS"),
    $82eef6831c2c6a3b$var$load("lVrrs"),
    $82eef6831c2c6a3b$var$load("3NkiL"),
    $82eef6831c2c6a3b$var$load("1bbSu"),
    $82eef6831c2c6a3b$var$load("kbwlB"),
    $82eef6831c2c6a3b$var$load("hhss7"),
    $82eef6831c2c6a3b$var$load("Wowvf"),
    $82eef6831c2c6a3b$var$load("cRtGo"),
    $82eef6831c2c6a3b$var$load("4qVsX"),
    $82eef6831c2c6a3b$var$load("jPZn6"),
    $82eef6831c2c6a3b$var$load("hCiBy"),
    $82eef6831c2c6a3b$var$load("2OkLl"),
    $82eef6831c2c6a3b$var$load("lnKog"),
    $82eef6831c2c6a3b$var$load("h3ABO"),
    $82eef6831c2c6a3b$var$load("kC80R"),
    $82eef6831c2c6a3b$var$load("7EorR"),
    $82eef6831c2c6a3b$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("71pm5", function(module, exports) {

let $51cc4b6892a7f5b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $51cc4b6892a7f5b3$var$load("2YffH"),
    $51cc4b6892a7f5b3$var$load("iUYwr"),
    $51cc4b6892a7f5b3$var$load("jjZO0"),
    $51cc4b6892a7f5b3$var$load("AGwzU"),
    $51cc4b6892a7f5b3$var$load("jEvZI"),
    $51cc4b6892a7f5b3$var$load("eBRUf"),
    $51cc4b6892a7f5b3$var$load("fjVVr"),
    $51cc4b6892a7f5b3$var$load("rFdxz"),
    $51cc4b6892a7f5b3$var$load("2tIxk"),
    $51cc4b6892a7f5b3$var$load("dLq4a"),
    $51cc4b6892a7f5b3$var$load("27glK"),
    $51cc4b6892a7f5b3$var$load("bvY53"),
    $51cc4b6892a7f5b3$var$load("lTK3c"),
    $51cc4b6892a7f5b3$var$load("1WXdc"),
    $51cc4b6892a7f5b3$var$load("3GuOt"),
    $51cc4b6892a7f5b3$var$load("hUmZG"),
    $51cc4b6892a7f5b3$var$load("h4Nf7"),
    $51cc4b6892a7f5b3$var$load("5o4Kn"),
    $51cc4b6892a7f5b3$var$load("6rS39"),
    $51cc4b6892a7f5b3$var$load("3MYQs"),
    $51cc4b6892a7f5b3$var$load("6SWFK"),
    $51cc4b6892a7f5b3$var$load("5zapo"),
    $51cc4b6892a7f5b3$var$load("6wr18"),
    $51cc4b6892a7f5b3$var$load("9atVd"),
    $51cc4b6892a7f5b3$var$load("ffEVr"),
    $51cc4b6892a7f5b3$var$load("5JkDi"),
    $51cc4b6892a7f5b3$var$load("jbM5v"),
    $51cc4b6892a7f5b3$var$load("219St"),
    $51cc4b6892a7f5b3$var$load("b1DMS"),
    $51cc4b6892a7f5b3$var$load("lVrrs"),
    $51cc4b6892a7f5b3$var$load("3NkiL"),
    $51cc4b6892a7f5b3$var$load("1bbSu"),
    $51cc4b6892a7f5b3$var$load("kbwlB"),
    $51cc4b6892a7f5b3$var$load("hhss7"),
    $51cc4b6892a7f5b3$var$load("Wowvf"),
    $51cc4b6892a7f5b3$var$load("cRtGo"),
    $51cc4b6892a7f5b3$var$load("4qVsX"),
    $51cc4b6892a7f5b3$var$load("jPZn6"),
    $51cc4b6892a7f5b3$var$load("hCiBy"),
    $51cc4b6892a7f5b3$var$load("2OkLl"),
    $51cc4b6892a7f5b3$var$load("h3ABO"),
    $51cc4b6892a7f5b3$var$load("kC80R"),
    $51cc4b6892a7f5b3$var$load("7EorR"),
    $51cc4b6892a7f5b3$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("kfOJN", function(module, exports) {

let $03ce235e1ba67fa9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $03ce235e1ba67fa9$var$load("2YffH"),
    $03ce235e1ba67fa9$var$load("iUYwr"),
    $03ce235e1ba67fa9$var$load("jjZO0"),
    $03ce235e1ba67fa9$var$load("AGwzU"),
    $03ce235e1ba67fa9$var$load("jEvZI"),
    $03ce235e1ba67fa9$var$load("eBRUf"),
    $03ce235e1ba67fa9$var$load("fjVVr"),
    $03ce235e1ba67fa9$var$load("rFdxz"),
    $03ce235e1ba67fa9$var$load("2tIxk"),
    $03ce235e1ba67fa9$var$load("dLq4a"),
    $03ce235e1ba67fa9$var$load("27glK"),
    $03ce235e1ba67fa9$var$load("bvY53"),
    $03ce235e1ba67fa9$var$load("lTK3c"),
    $03ce235e1ba67fa9$var$load("1WXdc"),
    $03ce235e1ba67fa9$var$load("3GuOt"),
    $03ce235e1ba67fa9$var$load("hUmZG"),
    $03ce235e1ba67fa9$var$load("h4Nf7"),
    $03ce235e1ba67fa9$var$load("5o4Kn"),
    $03ce235e1ba67fa9$var$load("6rS39"),
    $03ce235e1ba67fa9$var$load("3MYQs"),
    $03ce235e1ba67fa9$var$load("6SWFK"),
    $03ce235e1ba67fa9$var$load("5zapo"),
    $03ce235e1ba67fa9$var$load("6wr18"),
    $03ce235e1ba67fa9$var$load("9atVd"),
    $03ce235e1ba67fa9$var$load("ffEVr"),
    $03ce235e1ba67fa9$var$load("5JkDi"),
    $03ce235e1ba67fa9$var$load("jbM5v"),
    $03ce235e1ba67fa9$var$load("219St"),
    $03ce235e1ba67fa9$var$load("b1DMS"),
    $03ce235e1ba67fa9$var$load("lVrrs"),
    $03ce235e1ba67fa9$var$load("3NkiL"),
    $03ce235e1ba67fa9$var$load("1bbSu"),
    $03ce235e1ba67fa9$var$load("kbwlB"),
    $03ce235e1ba67fa9$var$load("hhss7"),
    $03ce235e1ba67fa9$var$load("Wowvf"),
    $03ce235e1ba67fa9$var$load("cRtGo"),
    $03ce235e1ba67fa9$var$load("4qVsX"),
    $03ce235e1ba67fa9$var$load("jPZn6"),
    $03ce235e1ba67fa9$var$load("hCiBy"),
    $03ce235e1ba67fa9$var$load("2OkLl"),
    $03ce235e1ba67fa9$var$load("h3ABO"),
    $03ce235e1ba67fa9$var$load("kC80R"),
    $03ce235e1ba67fa9$var$load("7EorR"),
    $03ce235e1ba67fa9$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("49RFm", function(module, exports) {

let $3071a1a95db51d23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3071a1a95db51d23$var$load("2YffH"),
    $3071a1a95db51d23$var$load("iUYwr"),
    $3071a1a95db51d23$var$load("jjZO0"),
    $3071a1a95db51d23$var$load("AGwzU"),
    $3071a1a95db51d23$var$load("jEvZI"),
    $3071a1a95db51d23$var$load("eBRUf"),
    $3071a1a95db51d23$var$load("fjVVr"),
    $3071a1a95db51d23$var$load("rFdxz"),
    $3071a1a95db51d23$var$load("2tIxk"),
    $3071a1a95db51d23$var$load("dLq4a"),
    $3071a1a95db51d23$var$load("27glK"),
    $3071a1a95db51d23$var$load("bvY53"),
    $3071a1a95db51d23$var$load("lTK3c"),
    $3071a1a95db51d23$var$load("1WXdc"),
    $3071a1a95db51d23$var$load("3GuOt"),
    $3071a1a95db51d23$var$load("hUmZG"),
    $3071a1a95db51d23$var$load("h4Nf7"),
    $3071a1a95db51d23$var$load("5o4Kn"),
    $3071a1a95db51d23$var$load("6rS39"),
    $3071a1a95db51d23$var$load("3MYQs"),
    $3071a1a95db51d23$var$load("6SWFK"),
    $3071a1a95db51d23$var$load("5zapo"),
    $3071a1a95db51d23$var$load("6wr18"),
    $3071a1a95db51d23$var$load("9atVd"),
    $3071a1a95db51d23$var$load("ffEVr"),
    $3071a1a95db51d23$var$load("5JkDi"),
    $3071a1a95db51d23$var$load("jbM5v"),
    $3071a1a95db51d23$var$load("219St"),
    $3071a1a95db51d23$var$load("b1DMS"),
    $3071a1a95db51d23$var$load("lVrrs"),
    $3071a1a95db51d23$var$load("3NkiL"),
    $3071a1a95db51d23$var$load("1bbSu"),
    $3071a1a95db51d23$var$load("kbwlB"),
    $3071a1a95db51d23$var$load("hhss7"),
    $3071a1a95db51d23$var$load("Wowvf"),
    $3071a1a95db51d23$var$load("cRtGo"),
    $3071a1a95db51d23$var$load("4qVsX"),
    $3071a1a95db51d23$var$load("jPZn6"),
    $3071a1a95db51d23$var$load("hCiBy"),
    $3071a1a95db51d23$var$load("2OkLl"),
    $3071a1a95db51d23$var$load("h3ABO"),
    $3071a1a95db51d23$var$load("kC80R"),
    $3071a1a95db51d23$var$load("7EorR"),
    $3071a1a95db51d23$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("2D0DU", function(module, exports) {

let $1e9fb8ebd57c87be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1e9fb8ebd57c87be$var$load("2YffH"),
    $1e9fb8ebd57c87be$var$load("iUYwr"),
    $1e9fb8ebd57c87be$var$load("jjZO0"),
    $1e9fb8ebd57c87be$var$load("AGwzU"),
    $1e9fb8ebd57c87be$var$load("jEvZI"),
    $1e9fb8ebd57c87be$var$load("eBRUf"),
    $1e9fb8ebd57c87be$var$load("fjVVr"),
    $1e9fb8ebd57c87be$var$load("rFdxz"),
    $1e9fb8ebd57c87be$var$load("2tIxk"),
    $1e9fb8ebd57c87be$var$load("dLq4a"),
    $1e9fb8ebd57c87be$var$load("27glK"),
    $1e9fb8ebd57c87be$var$load("bvY53"),
    $1e9fb8ebd57c87be$var$load("lTK3c"),
    $1e9fb8ebd57c87be$var$load("1WXdc"),
    $1e9fb8ebd57c87be$var$load("3GuOt"),
    $1e9fb8ebd57c87be$var$load("hUmZG"),
    $1e9fb8ebd57c87be$var$load("h4Nf7"),
    $1e9fb8ebd57c87be$var$load("5o4Kn"),
    $1e9fb8ebd57c87be$var$load("6rS39"),
    $1e9fb8ebd57c87be$var$load("3MYQs"),
    $1e9fb8ebd57c87be$var$load("6SWFK"),
    $1e9fb8ebd57c87be$var$load("5zapo"),
    $1e9fb8ebd57c87be$var$load("6wr18"),
    $1e9fb8ebd57c87be$var$load("9atVd"),
    $1e9fb8ebd57c87be$var$load("ffEVr"),
    $1e9fb8ebd57c87be$var$load("5JkDi"),
    $1e9fb8ebd57c87be$var$load("jbM5v"),
    $1e9fb8ebd57c87be$var$load("219St"),
    $1e9fb8ebd57c87be$var$load("b1DMS"),
    $1e9fb8ebd57c87be$var$load("lVrrs"),
    $1e9fb8ebd57c87be$var$load("3NkiL"),
    $1e9fb8ebd57c87be$var$load("1bbSu"),
    $1e9fb8ebd57c87be$var$load("kbwlB"),
    $1e9fb8ebd57c87be$var$load("hhss7"),
    $1e9fb8ebd57c87be$var$load("Wowvf"),
    $1e9fb8ebd57c87be$var$load("cRtGo"),
    $1e9fb8ebd57c87be$var$load("4qVsX"),
    $1e9fb8ebd57c87be$var$load("jPZn6"),
    $1e9fb8ebd57c87be$var$load("hCiBy"),
    $1e9fb8ebd57c87be$var$load("2OkLl"),
    $1e9fb8ebd57c87be$var$load("lnKog"),
    $1e9fb8ebd57c87be$var$load("h3ABO"),
    $1e9fb8ebd57c87be$var$load("kC80R"),
    $1e9fb8ebd57c87be$var$load("7EorR"),
    $1e9fb8ebd57c87be$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("6FCaq", function(module, exports) {

let $4db42d9e94193e25$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4db42d9e94193e25$var$load("2YffH"),
    $4db42d9e94193e25$var$load("iUYwr"),
    $4db42d9e94193e25$var$load("jjZO0"),
    $4db42d9e94193e25$var$load("AGwzU"),
    $4db42d9e94193e25$var$load("lo4Uk"),
    $4db42d9e94193e25$var$load("jEvZI"),
    $4db42d9e94193e25$var$load("eBRUf"),
    $4db42d9e94193e25$var$load("fjVVr"),
    $4db42d9e94193e25$var$load("rFdxz"),
    $4db42d9e94193e25$var$load("2tIxk"),
    $4db42d9e94193e25$var$load("dLq4a"),
    $4db42d9e94193e25$var$load("h9S8v"),
    $4db42d9e94193e25$var$load("27glK"),
    $4db42d9e94193e25$var$load("bvY53"),
    $4db42d9e94193e25$var$load("lTK3c"),
    $4db42d9e94193e25$var$load("1WXdc"),
    $4db42d9e94193e25$var$load("3GuOt"),
    $4db42d9e94193e25$var$load("hUmZG"),
    $4db42d9e94193e25$var$load("h4Nf7"),
    $4db42d9e94193e25$var$load("5o4Kn"),
    $4db42d9e94193e25$var$load("6rS39"),
    $4db42d9e94193e25$var$load("3MYQs"),
    $4db42d9e94193e25$var$load("6SWFK"),
    $4db42d9e94193e25$var$load("5zapo"),
    $4db42d9e94193e25$var$load("6wr18"),
    $4db42d9e94193e25$var$load("9atVd"),
    $4db42d9e94193e25$var$load("ffEVr"),
    $4db42d9e94193e25$var$load("5JkDi"),
    $4db42d9e94193e25$var$load("jbM5v"),
    $4db42d9e94193e25$var$load("219St"),
    $4db42d9e94193e25$var$load("b1DMS"),
    $4db42d9e94193e25$var$load("lVrrs"),
    $4db42d9e94193e25$var$load("3NkiL"),
    $4db42d9e94193e25$var$load("1bbSu"),
    $4db42d9e94193e25$var$load("kbwlB"),
    $4db42d9e94193e25$var$load("hhss7"),
    $4db42d9e94193e25$var$load("Wowvf"),
    $4db42d9e94193e25$var$load("cRtGo"),
    $4db42d9e94193e25$var$load("4qVsX"),
    $4db42d9e94193e25$var$load("jPZn6"),
    $4db42d9e94193e25$var$load("hCiBy"),
    $4db42d9e94193e25$var$load("2OkLl"),
    $4db42d9e94193e25$var$load("lnKog"),
    $4db42d9e94193e25$var$load("h3ABO"),
    $4db42d9e94193e25$var$load("kC80R"),
    $4db42d9e94193e25$var$load("7EorR"),
    $4db42d9e94193e25$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("hrWWA", function(module, exports) {

let $cb42ae516f3ae8f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cb42ae516f3ae8f1$var$load("2YffH"),
    $cb42ae516f3ae8f1$var$load("iUYwr"),
    $cb42ae516f3ae8f1$var$load("jjZO0"),
    $cb42ae516f3ae8f1$var$load("AGwzU"),
    $cb42ae516f3ae8f1$var$load("lo4Uk"),
    $cb42ae516f3ae8f1$var$load("jEvZI"),
    $cb42ae516f3ae8f1$var$load("eBRUf"),
    $cb42ae516f3ae8f1$var$load("fjVVr"),
    $cb42ae516f3ae8f1$var$load("rFdxz"),
    $cb42ae516f3ae8f1$var$load("2tIxk"),
    $cb42ae516f3ae8f1$var$load("dLq4a"),
    $cb42ae516f3ae8f1$var$load("h9S8v"),
    $cb42ae516f3ae8f1$var$load("27glK"),
    $cb42ae516f3ae8f1$var$load("bvY53"),
    $cb42ae516f3ae8f1$var$load("lTK3c"),
    $cb42ae516f3ae8f1$var$load("1WXdc"),
    $cb42ae516f3ae8f1$var$load("3GuOt"),
    $cb42ae516f3ae8f1$var$load("hUmZG"),
    $cb42ae516f3ae8f1$var$load("h4Nf7"),
    $cb42ae516f3ae8f1$var$load("5o4Kn"),
    $cb42ae516f3ae8f1$var$load("6rS39"),
    $cb42ae516f3ae8f1$var$load("3MYQs"),
    $cb42ae516f3ae8f1$var$load("6SWFK"),
    $cb42ae516f3ae8f1$var$load("5zapo"),
    $cb42ae516f3ae8f1$var$load("6wr18"),
    $cb42ae516f3ae8f1$var$load("9atVd"),
    $cb42ae516f3ae8f1$var$load("ffEVr"),
    $cb42ae516f3ae8f1$var$load("5JkDi"),
    $cb42ae516f3ae8f1$var$load("jbM5v"),
    $cb42ae516f3ae8f1$var$load("219St"),
    $cb42ae516f3ae8f1$var$load("b1DMS"),
    $cb42ae516f3ae8f1$var$load("lVrrs"),
    $cb42ae516f3ae8f1$var$load("3NkiL"),
    $cb42ae516f3ae8f1$var$load("1bbSu"),
    $cb42ae516f3ae8f1$var$load("kbwlB"),
    $cb42ae516f3ae8f1$var$load("hhss7"),
    $cb42ae516f3ae8f1$var$load("Wowvf"),
    $cb42ae516f3ae8f1$var$load("cRtGo"),
    $cb42ae516f3ae8f1$var$load("4qVsX"),
    $cb42ae516f3ae8f1$var$load("jPZn6"),
    $cb42ae516f3ae8f1$var$load("hCiBy"),
    $cb42ae516f3ae8f1$var$load("2OkLl"),
    $cb42ae516f3ae8f1$var$load("lnKog"),
    $cb42ae516f3ae8f1$var$load("h3ABO"),
    $cb42ae516f3ae8f1$var$load("kC80R"),
    $cb42ae516f3ae8f1$var$load("7EorR"),
    $cb42ae516f3ae8f1$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("2rCgd", function(module, exports) {

let $1c7bc82329c8f9c7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1c7bc82329c8f9c7$var$load("2YffH"),
    $1c7bc82329c8f9c7$var$load("iUYwr"),
    $1c7bc82329c8f9c7$var$load("jjZO0"),
    $1c7bc82329c8f9c7$var$load("AGwzU"),
    $1c7bc82329c8f9c7$var$load("jEvZI"),
    $1c7bc82329c8f9c7$var$load("eBRUf"),
    $1c7bc82329c8f9c7$var$load("fjVVr"),
    $1c7bc82329c8f9c7$var$load("rFdxz"),
    $1c7bc82329c8f9c7$var$load("2tIxk"),
    $1c7bc82329c8f9c7$var$load("dLq4a"),
    $1c7bc82329c8f9c7$var$load("27glK"),
    $1c7bc82329c8f9c7$var$load("bvY53"),
    $1c7bc82329c8f9c7$var$load("lTK3c"),
    $1c7bc82329c8f9c7$var$load("1WXdc"),
    $1c7bc82329c8f9c7$var$load("3GuOt"),
    $1c7bc82329c8f9c7$var$load("hUmZG"),
    $1c7bc82329c8f9c7$var$load("h4Nf7"),
    $1c7bc82329c8f9c7$var$load("5o4Kn"),
    $1c7bc82329c8f9c7$var$load("6rS39"),
    $1c7bc82329c8f9c7$var$load("3MYQs"),
    $1c7bc82329c8f9c7$var$load("6SWFK"),
    $1c7bc82329c8f9c7$var$load("5zapo"),
    $1c7bc82329c8f9c7$var$load("6wr18"),
    $1c7bc82329c8f9c7$var$load("9atVd"),
    $1c7bc82329c8f9c7$var$load("ffEVr"),
    $1c7bc82329c8f9c7$var$load("5JkDi"),
    $1c7bc82329c8f9c7$var$load("jbM5v"),
    $1c7bc82329c8f9c7$var$load("219St"),
    $1c7bc82329c8f9c7$var$load("b1DMS"),
    $1c7bc82329c8f9c7$var$load("lVrrs"),
    $1c7bc82329c8f9c7$var$load("3NkiL"),
    $1c7bc82329c8f9c7$var$load("1bbSu"),
    $1c7bc82329c8f9c7$var$load("kbwlB"),
    $1c7bc82329c8f9c7$var$load("hhss7"),
    $1c7bc82329c8f9c7$var$load("Wowvf"),
    $1c7bc82329c8f9c7$var$load("cRtGo"),
    $1c7bc82329c8f9c7$var$load("4qVsX"),
    $1c7bc82329c8f9c7$var$load("jPZn6"),
    $1c7bc82329c8f9c7$var$load("hCiBy"),
    $1c7bc82329c8f9c7$var$load("2OkLl"),
    $1c7bc82329c8f9c7$var$load("h3ABO"),
    $1c7bc82329c8f9c7$var$load("kC80R"),
    $1c7bc82329c8f9c7$var$load("7EorR"),
    $1c7bc82329c8f9c7$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("8ynWU", function(module, exports) {

let $63a413804290f7ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $63a413804290f7ac$var$load("2YffH"),
    $63a413804290f7ac$var$load("iUYwr"),
    $63a413804290f7ac$var$load("jjZO0"),
    $63a413804290f7ac$var$load("AGwzU"),
    $63a413804290f7ac$var$load("jEvZI"),
    $63a413804290f7ac$var$load("eBRUf"),
    $63a413804290f7ac$var$load("fjVVr"),
    $63a413804290f7ac$var$load("rFdxz"),
    $63a413804290f7ac$var$load("2tIxk"),
    $63a413804290f7ac$var$load("dLq4a"),
    $63a413804290f7ac$var$load("27glK"),
    $63a413804290f7ac$var$load("bvY53"),
    $63a413804290f7ac$var$load("lTK3c"),
    $63a413804290f7ac$var$load("1WXdc"),
    $63a413804290f7ac$var$load("3GuOt"),
    $63a413804290f7ac$var$load("hUmZG"),
    $63a413804290f7ac$var$load("h4Nf7"),
    $63a413804290f7ac$var$load("5o4Kn"),
    $63a413804290f7ac$var$load("6rS39"),
    $63a413804290f7ac$var$load("3MYQs"),
    $63a413804290f7ac$var$load("6SWFK"),
    $63a413804290f7ac$var$load("5zapo"),
    $63a413804290f7ac$var$load("6wr18"),
    $63a413804290f7ac$var$load("9atVd"),
    $63a413804290f7ac$var$load("ffEVr"),
    $63a413804290f7ac$var$load("5JkDi"),
    $63a413804290f7ac$var$load("jbM5v"),
    $63a413804290f7ac$var$load("219St"),
    $63a413804290f7ac$var$load("b1DMS"),
    $63a413804290f7ac$var$load("lVrrs"),
    $63a413804290f7ac$var$load("3NkiL"),
    $63a413804290f7ac$var$load("1bbSu"),
    $63a413804290f7ac$var$load("kbwlB"),
    $63a413804290f7ac$var$load("hhss7"),
    $63a413804290f7ac$var$load("Wowvf"),
    $63a413804290f7ac$var$load("cRtGo"),
    $63a413804290f7ac$var$load("4qVsX"),
    $63a413804290f7ac$var$load("jPZn6"),
    $63a413804290f7ac$var$load("hCiBy"),
    $63a413804290f7ac$var$load("2OkLl"),
    $63a413804290f7ac$var$load("lnKog"),
    $63a413804290f7ac$var$load("h3ABO"),
    $63a413804290f7ac$var$load("kC80R"),
    $63a413804290f7ac$var$load("7EorR"),
    $63a413804290f7ac$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("6Bffc", function(module, exports) {

let $4ce205f78c951c67$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4ce205f78c951c67$var$load("2YffH"),
    $4ce205f78c951c67$var$load("iUYwr"),
    $4ce205f78c951c67$var$load("jjZO0"),
    $4ce205f78c951c67$var$load("AGwzU"),
    $4ce205f78c951c67$var$load("jEvZI"),
    $4ce205f78c951c67$var$load("eBRUf"),
    $4ce205f78c951c67$var$load("fjVVr"),
    $4ce205f78c951c67$var$load("rFdxz"),
    $4ce205f78c951c67$var$load("2tIxk"),
    $4ce205f78c951c67$var$load("dLq4a"),
    $4ce205f78c951c67$var$load("27glK"),
    $4ce205f78c951c67$var$load("bvY53"),
    $4ce205f78c951c67$var$load("lTK3c"),
    $4ce205f78c951c67$var$load("1WXdc"),
    $4ce205f78c951c67$var$load("3GuOt"),
    $4ce205f78c951c67$var$load("hUmZG"),
    $4ce205f78c951c67$var$load("h4Nf7"),
    $4ce205f78c951c67$var$load("5o4Kn"),
    $4ce205f78c951c67$var$load("6rS39"),
    $4ce205f78c951c67$var$load("3MYQs"),
    $4ce205f78c951c67$var$load("6SWFK"),
    $4ce205f78c951c67$var$load("5zapo"),
    $4ce205f78c951c67$var$load("6wr18"),
    $4ce205f78c951c67$var$load("9atVd"),
    $4ce205f78c951c67$var$load("ffEVr"),
    $4ce205f78c951c67$var$load("5JkDi"),
    $4ce205f78c951c67$var$load("jbM5v"),
    $4ce205f78c951c67$var$load("219St"),
    $4ce205f78c951c67$var$load("b1DMS"),
    $4ce205f78c951c67$var$load("lVrrs"),
    $4ce205f78c951c67$var$load("3NkiL"),
    $4ce205f78c951c67$var$load("1bbSu"),
    $4ce205f78c951c67$var$load("kbwlB"),
    $4ce205f78c951c67$var$load("hhss7"),
    $4ce205f78c951c67$var$load("Wowvf"),
    $4ce205f78c951c67$var$load("cRtGo"),
    $4ce205f78c951c67$var$load("4qVsX"),
    $4ce205f78c951c67$var$load("jPZn6"),
    $4ce205f78c951c67$var$load("hCiBy"),
    $4ce205f78c951c67$var$load("2OkLl"),
    $4ce205f78c951c67$var$load("lnKog"),
    $4ce205f78c951c67$var$load("h3ABO"),
    $4ce205f78c951c67$var$load("kC80R"),
    $4ce205f78c951c67$var$load("7EorR"),
    $4ce205f78c951c67$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "BitbucketExtension", () => (parcelRequire("2JC3k")).BitbucketExtension);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    FULL_PAGE: 'confluence:fullPage',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    FULL_PAGE: 'jira:fullPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
const $d977f97374f9d2c9$export$586232a3e4271798 = {
    CUSTOM_MERGE_CHECK: 'bitbucket:mergeCheck',
    DYNAMIC_PIPELINES_PROVIDER: 'bitbucket:dynamicPipelinesProvider',
    REPOSITORY_CODE_FILE_VIEWER: 'bitbucket:repoCodeFileViewer',
    REPOSITORY_CODE_OVERVIEW_CARD: 'bitbucket:repoCodeOverviewCard',
    REPOSITORY_CODE_OVERVIEW_ACTION: 'bitbucket:repoCodeOverviewAction',
    REPOSITORY_CODE_OVERVIEW_PANEL: 'bitbucket:repoCodeOverviewPanel',
    REPOSITORY_PULL_REQUEST_CARD: 'bitbucket:repoPullRequestCard',
    REPOSITORY_PULL_REQUEST_ACTION: 'bitbucket:repoPullRequestAction',
    REPOSITORY_PULL_REQUEST_OVERVIEW_PANEL: 'bitbucket:repoPullRequestOverviewPanel',
    REPOSITORY_MAIN_MENU_PAGE: 'bitbucket:repoMainMenuPage',
    REPOSITORY_SETTINGS_MENU_PAGE: 'bitbucket:repoSettingsMenuPage',
    PROJECT_SETTINGS_MENU_PAGE: 'bitbucket:projectSettingsMenuPage',
    WORKSPACE_GLOBAL_PAGE: 'bitbucket:workspaceGlobalPage',
    WORKSPACE_PERSONAL_SETTINGS_PAGE: 'bitbucket:workspacePersonalSettingsPage',
    WORKSPACE_SETTINGS_MENU_PAGE: 'bitbucket:workspaceSettingsMenuPage'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;
module.exports["BitbucketExtension"] = $d977f97374f9d2c9$export$586232a3e4271798;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("8WjFq"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("8WjFq", function(module, exports) {

let $6822ff017737725d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6822ff017737725d$var$load("2OkLl"),
    $6822ff017737725d$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("4lbme", function(module, exports) {
/* CollapsibleSection.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $inPa6 = parcelRequire("inPa6");


var $b3j2Y = parcelRequire("b3j2Y");


var $h1Vf7 = parcelRequire("h1Vf7");

const $b317972e35a48dec$var$collapsibleStyles = null;
const $b317972e35a48dec$var$collapsibleCollapsedStyles = null;
const $b317972e35a48dec$var$headerExpandCollapseButtonStyles = {
    default: "_11c8fhey _1yt4u2gc _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itze3t _1e0c1txw _1bah1yb4 _4cvr1h6o _1bsb1osq _bfhkhp5a _kqsw1if8 _154ixmi2 _1pbykb7n _13li1mok _qrwq1mok _d0altlke",
    collapsed: "_2rko1mok",
    expanded: "_n7zlze3t"
};
const $b317972e35a48dec$var$headerActionsWrapperStyles = null;
const $b317972e35a48dec$var$collasibleContentStyles = null; /**
                                       * CollapsibleSection should be used within the right rail on the home screen. All sections of the right rail should
                                       * be placed inside of a CollapsibleSection. Local storage and collapsed state will be handled within this component.
                                       *
                                       * By default the header will be displayed when the section is expanded, to hide the header use the prop
                                       * hideHeaderWhenExpanded. If hideHeaderWhenExpanded is false, the content of the section will occupy the full width
                                       * with 24px of left and right padding. If hidHeaderWhenExpanded is true the content will only occupy the space left
                                       * of the expand/collapse button with 24px of left padding and 40px of right padding.
                                       *
                                       * @param sectionId: Unique identifier for the section, used for local storage
                                       * @param header: React node to appear in the header. By default the header will be rendered in the expanded state
                                       * @param hideHeaderWhenExpanded: Boolean value that, when true, will hide the header when the section is expanded
                                       * @param children: React node to be rendered in the expanded state. Children must be styled appropriately.
                                       */ 
const $b317972e35a48dec$export$55b973e094275b13 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ sectionId: sectionId, header: header, headerActions: headerActions, children: children, defaultState: defaultState, initialStateOverride: initialStateOverride, onInitialCollapse: onInitialCollapse, ariaLabel: ariaLabel }, ref)=>{
    const { widgetState: widgetState, setWidgetState: setWidgetState, loading: loading, error: error } = (0, $h1Vf7.useHomeWidgetState)(sectionId, defaultState, initialStateOverride);
    const isCollapsed = widgetState === 'COLLAPSED';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const checkedInitialState = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (loading || checkedInitialState.current) return;
        checkedInitialState.current = true;
        if (widgetState === 'COLLAPSED') onInitialCollapse?.();
    }, [
        loading,
        widgetState,
        onInitialCollapse
    ]);
    const fireAnalyticsEvent = (0, $42omo.useCallback)((action)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: action,
                actionSubject: 'collapsibleSection',
                actionSubjectId: sectionId,
                source: 'rightPanel',
                attributes: {
                    homeVersion: '1.5'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        sectionId
    ]);
    const onClick = (0, $42omo.useCallback)(()=>{
        const onCollapse = ()=>{
            setWidgetState('COLLAPSED');
            fireAnalyticsEvent('collapsed');
        };
        const onExpand = ()=>{
            setWidgetState('EXPANDED');
            fireAnalyticsEvent('expanded');
        };
        isCollapsed ? onExpand() : onCollapse();
    }, [
        isCollapsed,
        setWidgetState,
        fireAnalyticsEvent
    ]);
    if (loading) return null;
    const Icon = isCollapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))) : (0, (/*@__PURE__*/$parcel$interopDefault($ghftu)));
    const headerId = `home-right-panel-header-${sectionId}`;
    const sectionHeaderCompiled = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
        id: headerId,
        onClick: onClick,
        "aria-expanded": !isCollapsed,
        "aria-controls": "collapsible-content",
        "aria-label": ariaLabel,
        className: (0, $gMc0m.default)([
            $b317972e35a48dec$var$headerExpandCollapseButtonStyles['default'],
            isCollapsed && $b317972e35a48dec$var$headerExpandCollapseButtonStyles['collapsed'],
            !isCollapsed && $b317972e35a48dec$var$headerExpandCollapseButtonStyles['expanded']
        ]),
        "data-vc": "yHeMWnwA"
    }, header, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: "",
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _1xi2xy5q _154iu2gc _1pbykb7n"
        ])
    }, headerActions));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        "data-testid": sectionId,
        className: (0, $gMc0m.default)([
            "_19itia51 _2rko1mok _bfhkhp5a _kqswh2mm _otyrutpp",
            isCollapsed && "_1dbzt7xp"
        ])
    }, sectionHeaderCompiled, isCollapsed ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        id: "collapsible-content",
        role: "region",
        "aria-labelledby": headerId,
        className: (0, $gMc0m.default)([
            "_1yt4u2gc"
        ])
    }, children), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }));
});
module.exports["CollapsibleSection"] = $b317972e35a48dec$export$55b973e094275b13;

});

parcelRegister("jYZYm", function(module, exports) {

var $3b6WO = parcelRequire("3b6WO");


var $7Ndnw = parcelRequire("7Ndnw");

const $092337d0b1510a67$var$useForgeAppsVisible = ()=>{
    const { extensions: extensions } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_HOMEPAGE_FEED)
    });
    return Array.isArray(extensions) && extensions.length > 0;
};
const $092337d0b1510a67$export$4da380cd3efc4347 = ()=>{
    const shouldShowForgeApps = $092337d0b1510a67$var$useForgeAppsVisible();
    const shouldShowRightPanel = shouldShowForgeApps;
    return {
        shouldShowRightPanel: shouldShowRightPanel,
        shouldShowForgeApps: shouldShowForgeApps
    };
};
module.exports["useRightPanelVisible"] = $092337d0b1510a67$export$4da380cd3efc4347;

});

parcelRegister("3b6WO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $aXWIB = parcelRequire("aXWIB");


var $42omo = parcelRequire("42omo");


var $dTb09 = parcelRequire("dTb09");


var $7zIsq = parcelRequire("7zIsq");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $6qkXi = parcelRequire("6qkXi");

const $8eb9026be26e0c85$export$cab421e039d23b2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: t1, skipQuery: t2, spaceContextOnly: spaceContextOnly } = t0;
    const returnBlockedExtensions = t1 === undefined ? false : t1;
    const skipQuery = t2 === undefined ? false : t2;
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    let t3;
    if ($[0] !== cloudId || $[1] !== contentId || $[2] !== locale || $[3] !== moduleType || $[4] !== queryOptions || $[5] !== returnBlockedExtensions || $[6] !== skipQuery || $[7] !== spaceContextOnly || $[8] !== spaceKey) {
        t3 = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            spaceContextOnly: spaceContextOnly
        });
        $[0] = cloudId;
        $[1] = contentId;
        $[2] = locale;
        $[3] = moduleType;
        $[4] = queryOptions;
        $[5] = returnBlockedExtensions;
        $[6] = skipQuery;
        $[7] = spaceContextOnly;
        $[8] = spaceKey;
        $[9] = t3;
    } else t3 = $[9];
    const options = t3;
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    let t4;
    let t5;
    if ($[10] !== extsError || $[11] !== spaceError) {
        t4 = ()=>{
            if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
        };
        t5 = [
            extsError,
            spaceError
        ];
        $[10] = extsError;
        $[11] = spaceError;
        $[12] = t4;
        $[13] = t5;
    } else {
        t4 = $[12];
        t5 = $[13];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[14] !== extsData || $[15] !== extsError || $[16] !== extsLoading) {
        t6 = {
            extensions: extsData,
            loading: extsLoading,
            error: extsError
        };
        $[14] = extsData;
        $[15] = extsError;
        $[16] = extsLoading;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
} : ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly })=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const options = (0, $42omo.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        skipQuery,
        spaceKey,
        contentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    (0, $42omo.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
const $8eb9026be26e0c85$var$usePrefilteredExtensionList = (0, $dTb09.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('forge-ui-migrate-extension-list-query-to-relay'), (0, $7zIsq.usePrefilteredExtensionListRelay), (0, $7zIsq.usePrefilteredExtensionList));
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("kqIWy", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $4ZxLt = parcelRequire("4ZxLt");


var $jtuBN = parcelRequire("jtuBN");

const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey, t0)=>{
    const $ = (0, $frIzR.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { includeSpaceTypeSettings: t2 } = t1;
    const includeSpaceTypeSettings = t2 === undefined ? false : t2;
    let t3;
    if ($[2] !== includeSpaceTypeSettings || $[3] !== spaceKey) {
        t3 = {
            variables: {
                spaceKey: spaceKey,
                includeSpaceTypeSettings: includeSpaceTypeSettings
            }
        };
        $[2] = includeSpaceTypeSettings;
        $[3] = spaceKey;
        $[4] = t3;
    } else t3 = $[4];
    const options = t3;
    const { loading: loading, data: data, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $4ZxLt.default), options);
    let t4;
    if ($[5] !== data || $[6] !== includeSpaceTypeSettings) {
        t4 = data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path,
            typeSettings: includeSpaceTypeSettings && data.space?.spaceTypeSettings ? {
                enabledContentTypes: {
                    ...data.space.spaceTypeSettings.enabledContentTypes
                }
            } : undefined
        } : undefined;
        $[5] = data;
        $[6] = includeSpaceTypeSettings;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== error || $[9] !== loading || $[10] !== t4) {
        t5 = {
            loading: loading,
            data: t4,
            error: error
        };
        $[8] = error;
        $[9] = loading;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<99243770d7843a9bcd6325c5cf3c6efa>>
 * @relayHash 8503b5ca122c8b61cd10af1b1c2004c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeSpaceTypeSettings"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "condition": "includeSpaceTypeSettings",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SpaceTypeSettings",
                            "kind": "LinkedField",
                            "name": "spaceTypeSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EnabledContentTypes",
                                    "kind": "LinkedField",
                                    "name": "enabledContentTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLivePagesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isWhiteboardsEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDatabasesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isSlidesEnabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8503b5ca122c8b61cd10af1b1c2004c9",
            "id": "3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String,$includeSpaceTypeSettings:Boolean!){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path},spaceTypeSettings@include(if:$includeSpaceTypeSettings){enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled,isSlidesEnabled}}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "591d4790bc30ed0352bb44ad552d45cb";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("6qkXi", function(module, exports) {

var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, spaceContextOnly: spaceContextOnly = false })=>{
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: spaceContextOnly ? {
            spaceKey: spaceKey
        } : {
            spaceKey: spaceKey,
            contentId: contentId
        },
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("hYbgt", function(module, exports) {

let $d150c737c0d61016$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d150c737c0d61016$var$load("aRNbZ").then(()=>parcelRequire('h5BLU'));

});

parcelRegister("bDjCi", function(module, exports) {
$parcel$export(module.exports, "ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE", () => (parcelRequire("e8WZK")).ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE);
$parcel$export(module.exports, "CALENDAR_CONTEXT", () => (parcelRequire("ltKTq")).CALENDAR_CONTEXT);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


var $e8WZK = parcelRequire("e8WZK");


var $ltKTq = parcelRequire("ltKTq");


const $0fe83f4fb6168025$export$666c7163d0ae1b3f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "UHi5n",
    name: "LazyTeamCalendars",
    loader: async ()=>(await (parcelRequire("cLIAY"))).TeamCalendar
});

const $0fe83f4fb6168025$export$9bc5a864d70a9980 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "DHsKy",
    name: "LazyHomepageCard",
    loader: async ()=>(await (parcelRequire("3Gq02"))).HomepageCard
});

const $0fe83f4fb6168025$export$85a8d72151ca049b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sxt9o",
    name: "LazyTeamCalendarSiteSettingsPage",
    loader: async ()=>(await (parcelRequire("eTrnh"))).TeamCalendarSiteSettingsPage
});
module.exports["LazyTeamCalendars"] = $0fe83f4fb6168025$export$666c7163d0ae1b3f;
module.exports["LazyHomepageCard"] = $0fe83f4fb6168025$export$9bc5a864d70a9980;
module.exports["LazyTeamCalendarSiteSettingsPage"] = $0fe83f4fb6168025$export$85a8d72151ca049b;

});

parcelRegister("cLIAY", function(module, exports) {

let $94bc778dc0cc718a$var$load = (parcelRequire("4mJKd"))(5);



module.exports = Promise.all([
    $94bc778dc0cc718a$var$load("lVrrs"),
    $94bc778dc0cc718a$var$load("3NkiL"),
    $94bc778dc0cc718a$var$load("6wr18"),
    $94bc778dc0cc718a$var$load("dwhgo"),
    $94bc778dc0cc718a$var$load("j104l"),
    $94bc778dc0cc718a$var$load("9OQNK"),
    (parcelRequire("alui6"))((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve("46TWH"), 5)),
    $94bc778dc0cc718a$var$load("c831e"),
    $94bc778dc0cc718a$var$load("9pso5"),
    $94bc778dc0cc718a$var$load("9nOeM"),
    $94bc778dc0cc718a$var$load("90USU"),
    $94bc778dc0cc718a$var$load("5oU5X"),
    $94bc778dc0cc718a$var$load("98Au8"),
    $94bc778dc0cc718a$var$load("j2bbk"),
    $94bc778dc0cc718a$var$load("hLjS5"),
    $94bc778dc0cc718a$var$load("6uYZX"),
    $94bc778dc0cc718a$var$load("eEyVs"),
    $94bc778dc0cc718a$var$load("1tzsM"),
    $94bc778dc0cc718a$var$load("4Jbf1"),
    $94bc778dc0cc718a$var$load("f1x0y"),
    $94bc778dc0cc718a$var$load("5t3NJ"),
    $94bc778dc0cc718a$var$load("9a2oY"),
    $94bc778dc0cc718a$var$load("cHQ50"),
    $94bc778dc0cc718a$var$load("cM6bW"),
    $94bc778dc0cc718a$var$load("lkOIY"),
    $94bc778dc0cc718a$var$load("37ldp"),
    $94bc778dc0cc718a$var$load("Wowvf"),
    $94bc778dc0cc718a$var$load("ffEVr"),
    $94bc778dc0cc718a$var$load("alL67")
]).then(()=>parcelRequire('biV8C'));

});

parcelRegister("alui6", function(module, exports) {
"use strict";

var $h4lNe = parcelRequire("h4lNe");

module.exports = $h4lNe(function loadCSSBundle(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        let isCurrentBundle = function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        };
        if ([].concat(existingLinks).some(isCurrentBundle)) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});

parcelRegister("h4lNe", function(module, exports) {
"use strict";
let $c6d3b70899d3a8aa$var$cachedBundles = {};
let $c6d3b70899d3a8aa$var$cachedPreloads = {};
let $c6d3b70899d3a8aa$var$cachedPrefetches = {};
function $c6d3b70899d3a8aa$var$getCache(type) {
    switch(type){
        case 'preload':
            return $c6d3b70899d3a8aa$var$cachedPreloads;
        case 'prefetch':
            return $c6d3b70899d3a8aa$var$cachedPrefetches;
        default:
            return $c6d3b70899d3a8aa$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $c6d3b70899d3a8aa$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});

parcelRegister("3Gq02", function(module, exports) {

let $2ae9765358cefb6c$var$load = (parcelRequire("4mJKd"))(5);



module.exports = Promise.all([
    $2ae9765358cefb6c$var$load("lVrrs"),
    $2ae9765358cefb6c$var$load("3NkiL"),
    $2ae9765358cefb6c$var$load("6wr18"),
    $2ae9765358cefb6c$var$load("j104l"),
    $2ae9765358cefb6c$var$load("9OQNK"),
    (parcelRequire("alui6"))((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve("46TWH"), 5)),
    $2ae9765358cefb6c$var$load("c831e"),
    $2ae9765358cefb6c$var$load("9pso5"),
    $2ae9765358cefb6c$var$load("9nOeM"),
    $2ae9765358cefb6c$var$load("5oU5X"),
    $2ae9765358cefb6c$var$load("98Au8"),
    $2ae9765358cefb6c$var$load("j2bbk"),
    $2ae9765358cefb6c$var$load("hLjS5"),
    $2ae9765358cefb6c$var$load("6uYZX"),
    $2ae9765358cefb6c$var$load("eEyVs"),
    $2ae9765358cefb6c$var$load("1tzsM"),
    $2ae9765358cefb6c$var$load("4Jbf1"),
    $2ae9765358cefb6c$var$load("f1x0y"),
    $2ae9765358cefb6c$var$load("5t3NJ"),
    $2ae9765358cefb6c$var$load("9a2oY"),
    $2ae9765358cefb6c$var$load("cHQ50"),
    $2ae9765358cefb6c$var$load("cM6bW"),
    $2ae9765358cefb6c$var$load("lkOIY"),
    $2ae9765358cefb6c$var$load("ffEVr"),
    $2ae9765358cefb6c$var$load("37ldp"),
    $2ae9765358cefb6c$var$load("Wowvf"),
    $2ae9765358cefb6c$var$load("3orE4")
]).then(()=>parcelRequire('IdTEh'));

});

parcelRegister("eTrnh", function(module, exports) {

let $ad7b6fc50b889c45$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ad7b6fc50b889c45$var$load("5oU5X"),
    $ad7b6fc50b889c45$var$load("hhss7"),
    $ad7b6fc50b889c45$var$load("9g1FS")
]).then(()=>parcelRequire('4GncZ'));

});

parcelRegister("e8WZK", function(module, exports) {
const $5e4945ce4960200f$export$c0e43f82fc27fe04 = 'adminTeamCalendars';
module.exports["ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE"] = $5e4945ce4960200f$export$c0e43f82fc27fe04;

});

parcelRegister("ltKTq", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $c9e0854a72739c18$export$feb9e2d8bc9b9b85 = /*#__PURE__*/ function(CALENDAR_CONTEXT) {
    CALENDAR_CONTEXT["SPACE_CALENDARS"] = "spaceCalendars";
    CALENDAR_CONTEXT["MY_CALENDARS"] = "myCalendars";
    CALENDAR_CONTEXT["SPACE_SUBCALENDAR"] = "spaceSubCalendar";
    CALENDAR_CONTEXT["EMBEDDED_SUBCALENDAR"] = "embeddedSubCalendar";
    CALENDAR_CONTEXT["MULTIPLE_CALENDARS"] = "multipleCalendars";
    CALENDAR_CONTEXT["EMBEDDED_MULTIPLE_CALENDARS"] = "embeddedMultipleCalendars";
    CALENDAR_CONTEXT["MACRO"] = "macro";
    return CALENDAR_CONTEXT;
}({});
const $c9e0854a72739c18$var$TCContext = /*#__PURE__*/ (0, $42omo.createContext)({});
const $c9e0854a72739c18$export$5f8036cb54c4d559 = ()=>{
    const context = (0, $42omo.useContext)($c9e0854a72739c18$var$TCContext);
    if (context === undefined) throw new Error('useTCContextDispatch must be used within TCContextProvider');
    return context;
};
let $c9e0854a72739c18$var$initialState;
const $c9e0854a72739c18$var$getInitialState = ({ calendars: calendars, calendarContext: calendarContext, userTimeZoneId: userTimeZoneId, userTimeFormat: userTimeFormat, isLoadingEvents: isLoadingEvents, firstDay: firstDay })=>{
    return(// @ts-expect-error - TS2454 Typescript 5.9.2 upgrade
    $c9e0854a72739c18$var$initialState || {
        calendars: calendars,
        events: [],
        calendarContext: calendarContext,
        userTimeZoneId: userTimeZoneId,
        userTimeFormat: userTimeFormat,
        viewDate: new Date(),
        dateTimeFormatOptions: {
            hour: 'numeric',
            minute: 'numeric',
            hourCycle: userTimeFormat === 'displayTimeFormat12' ? 'h12' : 'h23',
            timeZone: userTimeZoneId
        },
        calendarErrors: [],
        isLoadingEvents: isLoadingEvents,
        firstDay: firstDay
    });
};
const $c9e0854a72739c18$var$AT = {
    SET_EVENTS: 'SET_EVENTS',
    SET_CALENDAR_EVENTS: 'SET_CALENDAR_EVENTS',
    SET_CALENDARS: 'SET_CALENDARS',
    SET_VIEW_DATE: 'SET_VIEW_DATE',
    SET_CALENDAR_ERRORS: 'SET_CALENDAR_ERRORS',
    SET_IS_LOADING_EVENTS: 'SET_IS_LOADING_EVENTS',
    SET_FIRST_DAY: 'SET_FIRST_DAY'
};
const $c9e0854a72739c18$export$97f0c60a5aa0f317 = ({ calendars: calendars, calendarContext: calendarContext, userTimeZoneId: userTimeZoneId, children: children, userTimeFormat: userTimeFormat, isLoadingEvents: isLoadingEvents = false, firstDay: firstDay = 1 })=>{
    const initialState = $c9e0854a72739c18$var$getInitialState({
        calendars: calendars,
        calendarContext: calendarContext,
        userTimeZoneId: userTimeZoneId,
        userTimeFormat: userTimeFormat,
        isLoadingEvents: isLoadingEvents,
        firstDay: firstDay
    });
    const reducer = (0, $42omo.useCallback)((state, action)=>{
        switch(action.type){
            case $c9e0854a72739c18$var$AT.SET_EVENTS:
                return {
                    ...state,
                    events: action.events
                };
            case $c9e0854a72739c18$var$AT.SET_CALENDAR_EVENTS:
                {
                    const calendarIds = action.calendarIds;
                    const newEvents = action.events;
                    const oldEvents = state.events.filter((event)=>!calendarIds.includes(event.subCalendarId));
                    const updatedEvents = oldEvents.concat(newEvents);
                    return {
                        ...state,
                        events: updatedEvents
                    };
                }
            case $c9e0854a72739c18$var$AT.SET_CALENDARS:
                return {
                    ...state,
                    calendars: action.calendars
                };
            case $c9e0854a72739c18$var$AT.SET_VIEW_DATE:
                return {
                    ...state,
                    viewDate: action.viewDate
                };
            case $c9e0854a72739c18$var$AT.SET_CALENDAR_ERRORS:
                if (state.calendarErrors.length === 0 && action.calendarErrors.length === 0) return state;
                return {
                    ...state,
                    calendarErrors: action.calendarErrors
                };
            case $c9e0854a72739c18$var$AT.SET_IS_LOADING_EVENTS:
                return {
                    ...state,
                    isLoadingEvents: action.isLoadingEvents
                };
            case $c9e0854a72739c18$var$AT.SET_FIRST_DAY:
                return {
                    ...state,
                    firstDay: action.firstDay
                };
            default:
                return initialState;
        }
    }, [
        initialState
    ]);
    const [state, dispatch] = (0, $42omo.useReducer)(reducer, initialState);
    const actions = (0, $42omo.useMemo)(()=>({
            setEvents: (events)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_EVENTS,
                    events: events
                });
            },
            setCalendarEvents: (calendarIds, events)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDAR_EVENTS,
                    calendarIds: calendarIds,
                    events: events
                });
            },
            setCalendars: (calendars)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDARS,
                    calendars: calendars
                });
            },
            setViewDate: (viewDate)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_VIEW_DATE,
                    viewDate: viewDate
                });
            },
            setCalendarErrors: (calendarErrors)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDAR_ERRORS,
                    calendarErrors: calendarErrors
                });
            },
            setIsLoadingEvents: (isLoadingEvents)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_IS_LOADING_EVENTS,
                    isLoadingEvents: isLoadingEvents
                });
            },
            setFirstDay: (firstDay)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_FIRST_DAY,
                    firstDay: firstDay
                });
            }
        }), []);
    const tcContextValue = (0, $42omo.useMemo)(()=>({
            state: state,
            actions: actions
        }), [
        state,
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c9e0854a72739c18$var$TCContext.Provider, {
        value: tcContextValue
    }, children);
};
module.exports["CALENDAR_CONTEXT"] = $c9e0854a72739c18$export$feb9e2d8bc9b9b85;
module.exports["useTCContextDispatch"] = $c9e0854a72739c18$export$5f8036cb54c4d559;
module.exports["TCContextProvider"] = $c9e0854a72739c18$export$97f0c60a5aa0f317;

});

parcelRegister("6iqYo", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required */ 
var $42omo = parcelRequire("42omo");


var $ig6yX = parcelRequire("ig6yX");


var $4c48T = parcelRequire("4c48T");


var $6ttbq = parcelRequire("6ttbq");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $hUAWL = parcelRequire("hUAWL");


var $2K5gO = parcelRequire("2K5gO");


var $4QtAs = parcelRequire("4QtAs");

const $06c041dcdd49b073$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $4c48T.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $ig6yX.easeInOut) } = {})=>{
    const prevDimensions = (0, $42omo.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $2K5gO.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $hUAWL.useRequestAnimationFrame)();
    (0, $4QtAs.useSnapshotBeforeUpdate)(()=>{
        if ((0, $6ttbq.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        if ((0, $6ttbq.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizingHeight"] = $06c041dcdd49b073$export$da99457d6430d83;

});

parcelRegister("83H3T", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $68de0fcb6733268f$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $42omo.useRef)(null);
    const setRef = (0, $42omo.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $68de0fcb6733268f$export$ff879f35a69d56b7;

});

parcelRegister("hUAWL", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $9fe18f2334f78b72$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $9fe18f2334f78b72$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $9fe18f2334f78b72$var$getHookDeps(opts));
    return (0, $42omo.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $9fe18f2334f78b72$export$1775f27e7c8051ca;

});

parcelRegister("4QtAs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dclyF = parcelRequire("dclyF");

const $0136602141ebd577$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $42omo.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $dclyF.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $0136602141ebd577$export$9e95200239cd148b;

});

parcelRegister("9oezN", function(module, exports) {

const $6b7b6fc399a60c96$export$47e445a2288f991 = async ({ resetAfter: resetAfter = 3000 } = {})=>{
    let confetti = null;
    try {
        confetti = (await (parcelRequire("6u9JG"))).default;
    } catch (error) {
        return;
    }
    if (!confetti) return;
    // mirrors the confetti animation in Atlas
    const baseProps = {
        particleCount: 120,
        spread: 55,
        ticks: 225,
        zIndex: 2000,
        scalar: 1.5,
        startVelocity: 100,
        colors: [
            '#6554C0',
            '#0065FF',
            '#00B8D9',
            '#FF5630',
            '#FFAB00',
            '#36B37E'
        ]
    };
    // right corner
    confetti({
        ...baseProps,
        origin: {
            x: 1,
            y: 1
        },
        angle: 120
    });
    // left corner
    confetti({
        ...baseProps,
        origin: {
            x: 0,
            y: 1
        },
        angle: 60
    });
    if (resetAfter) setTimeout(()=>{
        confetti?.reset();
    }, resetAfter);
};
module.exports["popOnboardingConfetti"] = $6b7b6fc399a60c96$export$47e445a2288f991;

});

parcelRegister("6u9JG", function(module, exports) {

let $4b8d18bab8f60514$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4b8d18bab8f60514$var$load("aglhs").then(()=>parcelRequire('g3Ror'));

});

parcelRegister("3QRgh", function(module, exports) {

let $2cdf8b11e35ac527$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2cdf8b11e35ac527$var$load("6wr18"),
    $2cdf8b11e35ac527$var$load("hhss7"),
    $2cdf8b11e35ac527$var$load("8b0Gw"),
    $2cdf8b11e35ac527$var$load("hga3v"),
    $2cdf8b11e35ac527$var$load("hyzoX"),
    $2cdf8b11e35ac527$var$load("9ldRJ"),
    $2cdf8b11e35ac527$var$load("Wowvf"),
    $2cdf8b11e35ac527$var$load("ffEVr"),
    $2cdf8b11e35ac527$var$load("kGjlO")
]).then(()=>parcelRequire('blj77'));

});

parcelRegister("hxdG1", function(module, exports) {

var $FOT9i = parcelRequire("FOT9i");

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $c9db3b2bd4f34a4a$var$PTV2Store = (0, $1P1Tu.createStore)({
    initialState: {
        teamType: '',
        subAnchor: '',
        personalSpaceKey: '',
        isTemplateListDismissed: true,
        personalizationHeuristic: '',
        onboardingPeriodDay: 0,
        isXflow: false,
        source: ''
    },
    actions: {
        setIsTemplateListDismissed: (isTemplateListDismissed)=>({ setState: setState })=>{
                setState({
                    isTemplateListDismissed: isTemplateListDismissed
                });
            }
    },
    name: 'PTV2Store'
});
const $c9db3b2bd4f34a4a$export$2011a7877d539b4d = (0, $9zUhf.createStateHook)($c9db3b2bd4f34a4a$var$PTV2Store);
const $c9db3b2bd4f34a4a$export$e08a7878fceccdd4 = (0, $9zUhf.createHook)($c9db3b2bd4f34a4a$var$PTV2Store);
const $c9db3b2bd4f34a4a$export$94a688c7da2f7e6d = (0, $FOT9i.createContainer)($c9db3b2bd4f34a4a$var$PTV2Store, {
    onInit: ()=>({ setState: setState }, { teamType: teamType, subAnchor: subAnchor, personalSpaceKey: personalSpaceKey, isTemplateListDismissed: isTemplateListDismissed, personalizationHeuristic: personalizationHeuristic, onboardingPeriodDay: onboardingPeriodDay, isXflow: isXflow, source: source })=>{
            setState({
                teamType: teamType,
                subAnchor: subAnchor,
                personalSpaceKey: personalSpaceKey,
                isTemplateListDismissed: isTemplateListDismissed,
                personalizationHeuristic: personalizationHeuristic,
                onboardingPeriodDay: onboardingPeriodDay,
                isXflow: isXflow,
                source: source
            });
        }
});
module.exports["usePTV2State"] = $c9db3b2bd4f34a4a$export$2011a7877d539b4d;
module.exports["usePTV2Store"] = $c9db3b2bd4f34a4a$export$e08a7878fceccdd4;
module.exports["PTV2StoreContainer"] = $c9db3b2bd4f34a4a$export$94a688c7da2f7e6d;

});

parcelRegister("eHz1Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b757bd6f4f887e6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1qfLF = parcelRequire("1qfLF");


var $1Whri = parcelRequire("1Whri");


var $cO1el = parcelRequire("cO1el");


var $cvXh8 = parcelRequire("cvXh8");


var $hmuev = parcelRequire("hmuev");


var $8tdj3 = parcelRequire("8tdj3");


var $gj7hi = parcelRequire("gj7hi");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $kpYGL = parcelRequire("kpYGL");


var $cOrQJ = parcelRequire("cOrQJ");


var $3gadb = parcelRequire("3gadb");

const $1b757bd6f4f887e6$var$cssStyles = {
    borderStyles: "_2rko1mok _1h6d1l7x _189ee4h9 _1dqonqa1",
    cardContainerStyles: "_kqswh2mm _c71l1ogy",
    pressableStyles: "_1bsb1osq _bfhkhfxm _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _irr31dpa",
    imageContainerStyles: "_1reo15vq _18m915vq _c71l1qr7 _qrwq1mok _13li1mok",
    imageHiddenStyles: "_1e0cglyw",
    completedCardStyles: "_tzy42wxo",
    contentContainerStyles: "_zulp1ejb _c71l11ux _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1wpz1fhb",
    textStyles: "_y3gn1e5h",
    ctaStyles: "_zulp1b66 _syazazsu",
    dismissIconStyles: "_kqswstnw _154iu2gc _1xi2u2gc _80omtlke"
};
// This styling is used in case an image that is too small is passed in to fit the card width
const $1b757bd6f4f887e6$var$imageStyles = null;
const $1b757bd6f4f887e6$var$ellipsisTextStyles = null; //  This styling is for setting limits on text for heading and will truncate with ellipses
const $1b757bd6f4f887e6$var$headingTextOverflowStyles = null;
const $1b757bd6f4f887e6$var$descriptionTextOverflowStyles = null;
function $1b757bd6f4f887e6$export$2e2bcd8739ae039({ image: image, heading: heading, description: description, onClick: onClick, hrefLink: hrefLink, showAsExternalLink: showAsExternalLink, onDismiss: onDismiss, ctaText: ctaText, ctaCompletedText: ctaCompletedText, dismissTooltip: dismissTooltip, headingSize: headingSize, hasBorder: hasBorder, cardCompleted: cardCompleted, enableCompletedOnClick: enableCompletedOnClick = true }) {
    const [gif, img, component] = [
        image,
        image,
        image
    ];
    const isComponentImage = Boolean(component.component);
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const [hovered, setHovered] = (0, $42omo.useState)(false);
    const [dismissed, setDismissed] = (0, $42omo.useState)(false);
    const [hasClicked, setHasClicked] = (0, $42omo.useState)(false); // Component image doens't require skeleton loading. Can set this to true straight away.
    const [imageLoaded, setImageLoaded] = (0, $42omo.useState)(isComponentImage);
    const isCardCompleted = hasClicked || cardCompleted === true; // If showAsExternalLink is true, it will always be shown an external link, otherwise it will only be an external link if the hrefLink does not include 'wiki'.
    const isExternalLink = hrefLink && (showAsExternalLink ?? !hrefLink.includes('wiki'));
    const handleCardClick = (event)=>{
        if (onClick) onClick(event);
        if (hrefLink) {
            if (isExternalLink) window.open(hrefLink, '_blank');
            else window.location.href = hrefLink;
        }
        if (enableCompletedOnClick) setHasClicked(true);
    };
    const handleDismiss = ()=>{
        onDismiss();
        setDismissed(true);
    };
    if (dismissed) return null;
    let [imageSrc, darkModeImageSrc] = [
        img.src,
        img.srcDark || img.src
    ]; // Have dark mode default to light mode in case it was not passed in
    if (gif.gif && gif.staticImageGif) {
        if (hovered) [imageSrc, darkModeImageSrc] = [
            gif.gif,
            gif.darkModeGif || gif.gif
        ];
        else [imageSrc, darkModeImageSrc] = [
            gif.staticImageGif,
            gif.staticDarkModeImageGif || gif.staticImageGif
        ];
    }
    let componentSrc;
    if (isComponentImage) componentSrc = colorMode === 'dark' && component.componentDark || component.component;
    const headingComponentSize = headingSize ? headingSize : 'small';
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $1b757bd6f4f887e6$var$cssStyles.cardContainerStyles
    }, /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        onMouseEnter: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false),
        onClick: handleCardClick,
        xcss: (0, $1Whri.cx)($1b757bd6f4f887e6$var$cssStyles.pressableStyles, isCardCompleted && $1b757bd6f4f887e6$var$cssStyles.completedCardStyles, hasBorder && $1b757bd6f4f887e6$var$cssStyles.borderStyles)
    }, /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), null, !imageLoaded && /*#__PURE__*/ $42omo.createElement((0, $kpYGL.default), {
        isShimmering: true,
        height: "128px",
        width: "100%",
        borderRadius: "var(--ds-radius-large, 8px)"
    }), /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
        alignItems: "center",
        xcss: !imageLoaded ? $1b757bd6f4f887e6$var$cssStyles.imageHiddenStyles : $1b757bd6f4f887e6$var$cssStyles.imageContainerStyles
    }, isComponentImage ? componentSrc : /*#__PURE__*/ $42omo.createElement((0, $gj7hi.default), {
        src: imageSrc,
        srcDark: darkModeImageSrc,
        alt: "",
        onLoad: ()=>setImageLoaded(true),
        className: (0, $gMc0m.default)([
            "_1bsb1osq _5ral1dfr"
        ])
    })), /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
        xcss: $1b757bd6f4f887e6$var$cssStyles.contentContainerStyles,
        alignItems: "start",
        direction: "column"
    }, /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
        direction: "column",
        alignItems: "start",
        gap: "space.050",
        xcss: $1b757bd6f4f887e6$var$cssStyles.textStyles
    }, /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
        content: heading,
        isScreenReaderAnnouncementDisabled: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1e0ccj1k _o5724jg8 _1bto1l2s _sudp1e54",
            "_c71lgktf _1yyjkb7n"
        ]),
        "data-vc": "-oDDIw__"
    }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
        size: headingComponentSize
    }, heading))), /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
        content: description,
        isScreenReaderAnnouncementDisabled: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_4t3izwfg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        maxLines: 2,
        size: "small",
        color: "color.text.subtlest"
    }, description)))), /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
        alignItems: "center",
        xcss: $1b757bd6f4f887e6$var$cssStyles.ctaStyles
    }, isCardCompleted ? /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        label: ""
    }), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        color: "color.text.subtle"
    }, ctaCompletedText)) : /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        color: "color.text.subtle"
    }, ctaText), isExternalLink && /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
        label: "",
        testId: "shortcut-icon"
    })))))), hovered && /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $1b757bd6f4f887e6$var$cssStyles.dismissIconStyles,
        onMouseEnter: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false)
    }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
        testId: "button-dismiss",
        isTooltipDisabled: false,
        onClick: handleDismiss,
        label: dismissTooltip,
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), iconProps)
    })));
}

});

parcelRegister("9uxfR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ivb8S = parcelRequire("ivb8S");


var $1gy7x = parcelRequire("1gy7x");

function $bbea2b83a9125021$var$deserializeOnboardingActionStates(serializedValues, OnboardingActionCards) {
    try {
        const values = JSON.parse(serializedValues || '{}');
        if (typeof values !== 'object') return {};
        const ONBOARDING_ACTION_IDS = OnboardingActionCards.map((action)=>action.id);
        // Return a mapping of all onboarding action IDs to their states.
        const states = ONBOARDING_ACTION_IDS.reduce((states, id)=>({
                ...states,
                [id]: values[id]
            }), {});
        return states;
    // eslint-disable-next-line no-unused-vars
    } catch (e) {
        return {};
    }
}
function $bbea2b83a9125021$var$serializeOnboardingActionStates(onboardingActionStates) {
    return JSON.stringify(onboardingActionStates);
}
function $bbea2b83a9125021$export$8eb8c3792bd3aae4(HomeOnboardingTakeoverCardsList, onboardingStateData, onboardingActionStatesKey = (0, $1gy7x.PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS).onboardingActionStates) {
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { onboardingActionStates: serializedOnboardingActionStates, hasUserPublished: hasUserPublished, hasDismissedOnboardingActions: hasDismissedOnboardingActions } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const onboardingActionStates = (0, $42omo.useMemo)(()=>{
        return $bbea2b83a9125021$var$deserializeOnboardingActionStates(serializedOnboardingActionStates, HomeOnboardingTakeoverCardsList);
    }, [
        serializedOnboardingActionStates,
        HomeOnboardingTakeoverCardsList
    ]);
    const actions = (0, $42omo.useMemo)(()=>{
        const mappedActions = HomeOnboardingTakeoverCardsList.map((action)=>({
                id: action.id,
                state: onboardingActionStates[action.id] || 'pending'
            }));
        return mappedActions;
    }, [
        HomeOnboardingTakeoverCardsList,
        onboardingActionStates
    ]);
    const dismiss = (0, $42omo.useMemo)(()=>(id)=>{
            const newState = {
                ...onboardingActionStates,
                [id]: 'dismissed'
            };
            setOnboardingState({
                key: onboardingActionStatesKey,
                value: $bbea2b83a9125021$var$serializeOnboardingActionStates(newState)
            });
        }, [
        onboardingActionStates,
        setOnboardingState,
        onboardingActionStatesKey
    ]);
    const complete = (0, $42omo.useMemo)(()=>(id)=>{
            const newState = {
                ...onboardingActionStates,
                [id]: 'completed'
            };
            setOnboardingState({
                key: onboardingActionStatesKey,
                value: $bbea2b83a9125021$var$serializeOnboardingActionStates(newState)
            });
        }, [
        onboardingActionStates,
        setOnboardingState,
        onboardingActionStatesKey
    ]);
    (0, $42omo.useEffect)(()=>{
        const hasntCreatedPage = actions.some((action)=>action.id === 'createPage' && action.state === 'pending');
        if (hasUserPublished && hasntCreatedPage) complete('createPage');
    }, [
        hasUserPublished,
        complete,
        actions
    ]);
    return {
        actions: actions,
        dismiss: dismiss,
        complete: complete,
        hasDismissedOnboardingActions: hasDismissedOnboardingActions
    };
}
module.exports["usePersonalizedTemplateOnboardingActions"] = $bbea2b83a9125021$export$8eb8c3792bd3aae4;

});

parcelRegister("8E5P5", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ var $522761dd0b51db26$export$82e276cacb9013c9 = /*#__PURE__*/ function(BLUEPRINT_NAMES) {
    BLUEPRINT_NAMES["NINETY_DAY_PLAN"] = "90-day plan";
    BLUEPRINT_NAMES["ALL_HANDS_MEETING"] = "All hands meeting";
    BLUEPRINT_NAMES["ANNUAL_PLAN_ONE_PAGER"] = "Annual plan one-pager";
    BLUEPRINT_NAMES["EXECUTIVE_BUSINESS_REVIEW"] = "Executive business review";
    BLUEPRINT_NAMES["BUSINESS_STATUS_UPDATE"] = "Business status update";
    BLUEPRINT_NAMES["BUSINESS_PLAN_ONE_PAGER"] = "Business plan one-pager";
    BLUEPRINT_NAMES["CAREER_DEVELOPMENT_PLAN"] = "Career development plan";
    BLUEPRINT_NAMES["COMPETITIVE_ANALYSIS"] = "Competitive analysis";
    BLUEPRINT_NAMES["CONTENT_DESIGN_GLOSSARY"] = "Content design glossary";
    BLUEPRINT_NAMES["CONTENT_STRATEGY"] = "Content strategy";
    BLUEPRINT_NAMES["CUSTOMER_IMPACT_ASSESSMENT"] = "Customer Impact Assessment";
    BLUEPRINT_NAMES["CUSTOMER_INTERVIEW_REPORT"] = "Customer Interview Report";
    BLUEPRINT_NAMES["DACI_DECISION_DOCUMENTATION"] = "DACI: Decision documentation";
    BLUEPRINT_NAMES["DESIGN_DECISION"] = "Design decision";
    BLUEPRINT_NAMES["DESIGN_REVIEW"] = "Design review";
    BLUEPRINT_NAMES["DESIGN_SPRINT"] = "Design sprint";
    BLUEPRINT_NAMES["DESIGN_SYSTEMS"] = "Design systems";
    BLUEPRINT_NAMES["DEVOPS_RUNBOOK"] = "DevOps runbook";
    BLUEPRINT_NAMES["EMPLOYEE_HANDBOOK"] = "Employee handbook";
    BLUEPRINT_NAMES["HR_KNOWLEDGE_BASE_MANAGEMENT"] = "HR Knowledge Base Management";
    BLUEPRINT_NAMES["HOW_TO_ARTICLE"] = "How-to article";
    BLUEPRINT_NAMES["ITSM_KNOWN_ERRORS"] = "ITSM Known Errors";
    BLUEPRINT_NAMES["ITSM_CHANGE_MANAGEMENT"] = "ITSM change management";
    BLUEPRINT_NAMES["ITSM_POST_INCIDENT_REVIEWS"] = "ITSM post incident reviews";
    BLUEPRINT_NAMES["ITSM_RUNBOOK"] = "ITSM runbook";
    BLUEPRINT_NAMES["INCIDENT_COMMUNICATION"] = "Incident communication";
    BLUEPRINT_NAMES["INCIDENT_POSTMORTEM"] = "Incident postmortem";
    BLUEPRINT_NAMES["JOB_DESCRIPTION"] = "Job description";
    BLUEPRINT_NAMES["LENNYS_PERFORMANCE_REVIEW"] = "Lenny's Performance Review";
    BLUEPRINT_NAMES["LENNYS_PRODUCT_REQUIREMENTS"] = "Lenny's product requirements";
    BLUEPRINT_NAMES["MARKETING_PLAN"] = "Marketing plan";
    BLUEPRINT_NAMES["MEETING_NOTES"] = "Meeting notes";
    BLUEPRINT_NAMES["MESSAGE_HOUSE"] = "Message house";
    BLUEPRINT_NAMES["OKRS"] = "OKRs";
    BLUEPRINT_NAMES["PERSONA"] = "Persona";
    BLUEPRINT_NAMES["PRESENTER_MODE"] = "Presenter mode";
    BLUEPRINT_NAMES["PRODUCT_REQUIREMENTS"] = "Product Requirements";
    BLUEPRINT_NAMES["PRODUCT_ROADMAP"] = "Product roadmap";
    BLUEPRINT_NAMES["PROJECT_KICKOFF"] = "Project Kickoff";
    BLUEPRINT_NAMES["PROJECT_PLAN"] = "Project plan";
    BLUEPRINT_NAMES["PROJECT_STATUS"] = "Project status";
    BLUEPRINT_NAMES["PROJECT_TIMELINE_TEMPLATE"] = "Project Timeline Template";
    BLUEPRINT_NAMES["QTC_ACQUISITION"] = "QTC Acquisition";
    BLUEPRINT_NAMES["QUARTERLY_CHECK_IN"] = "Quarterly check in";
    BLUEPRINT_NAMES["REMOTE_TEAM_MEETING"] = "Remote team meeting";
    BLUEPRINT_NAMES["RISK_ASSESSMENT_MATRIX"] = "Risk assessment matrix";
    BLUEPRINT_NAMES["ROLES_AND_RESPONSIBILITIES"] = "Roles and responsibilities play";
    BLUEPRINT_NAMES["SMART_GOALS"] = "SMART Goals";
    BLUEPRINT_NAMES["SWOT_ANALYSIS"] = "SWOT analysis";
    BLUEPRINT_NAMES["SALES_PORTAL"] = "Sales Portal";
    BLUEPRINT_NAMES["SALES_ACCOUNT_PLANNING"] = "Sales account planning";
    BLUEPRINT_NAMES["SERVICE_TEAM_HEALTH_MONITOR"] = "Service team health monitor";
    BLUEPRINT_NAMES["SOFTWARE_ARCHITECTURE_REVIEW"] = "Software Architecture Review";
    BLUEPRINT_NAMES["SPRINT_PLANNING_MEETING"] = "Sprint planning meeting";
    BLUEPRINT_NAMES["STAKEHOLDER_COMMUNICATIONS"] = "Stakeholder communications";
    BLUEPRINT_NAMES["STANDARD_OPERATING_PROCEDURE_TEMPLATE"] = "Standard Operating Procedure (SOP) Template";
    BLUEPRINT_NAMES["STRATEGIC_PLAN"] = "Strategic plan";
    BLUEPRINT_NAMES["TEAM_HOMEPAGE"] = "Team homepage";
    BLUEPRINT_NAMES["TEAM_POSTER"] = "Team poster";
    BLUEPRINT_NAMES["TO_DO_LIST"] = "To-do list";
    BLUEPRINT_NAMES["TROUBLESHOOTING_ARTICLE"] = "Troubleshooting article";
    BLUEPRINT_NAMES["VENDOR_AGREEMENT"] = "Vendor agreement";
    BLUEPRINT_NAMES["VIRTUAL_EVENT"] = "Virtual event";
    BLUEPRINT_NAMES["VISION_TO_VALUES"] = "Vision to values";
    BLUEPRINT_NAMES["END_OF_WEEK_STATUS_REPORT"] = "End of week status report";
    BLUEPRINT_NAMES["WEEKLY_MEETING_NOTES"] = "Weekly meeting notes";
    BLUEPRINT_NAMES["WORK_TRIP_PLANNER"] = "Work trip planner";
    BLUEPRINT_NAMES["WORKSHOP_PLANNER"] = "Workshop planner";
    BLUEPRINT_NAMES["WRITING_GUIDELINES"] = "Writing guidelines";
    BLUEPRINT_NAMES["AWS_ARCHITECTURE_DIAGRAM"] = "AWS architecture diagram";
    BLUEPRINT_NAMES["MARKETING_BLOG_POST"] = "Marketing blog post";
    BLUEPRINT_NAMES["MARKETING_CAMPAIGN"] = "Marketing campaign";
    BLUEPRINT_NAMES["HIRING_PROCESS"] = "Hiring process";
    BLUEPRINT_NAMES["MUTUAL_ACTION_PLAN"] = "Mutual action plan";
    BLUEPRINT_NAMES["ITSM_WEEKLY_MAJOR_INCIDENT_REPORT"] = "ITSM weekly major incident report";
    BLUEPRINT_NAMES["DISRUPTIVE_BRAINSTORMING"] = "Disruptive brainstorming";
    return BLUEPRINT_NAMES;
}({});
const $522761dd0b51db26$export$c42db12dd3d44bb8 = new Set(Object.values($522761dd0b51db26$export$82e276cacb9013c9));
const $522761dd0b51db26$export$d7a793aff6267afc = {
    ["90-day plan"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:90-day-plan-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:90-day-plan-item',
        contentBlueprintId: 'b18bd4b0-cb12-4c8a-be83-bb5769b25481'
    },
    ["All hands meeting"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:all-hands-meeting-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:all-hands-meeting-item',
        contentBlueprintId: '67dddaa6-f038-45bf-b21f-8259dcf441db'
    },
    ["Annual plan one-pager"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:annual-plan-one-pager-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:annual-plan-one-pager-item',
        contentBlueprintId: '2823fda6-dfb4-4b81-8394-2e19e96b99fb'
    },
    ["Executive business review"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:executive-business-review-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:executive-business-review-item',
        contentBlueprintId: '9433bfd2-c7b2-41cf-b493-d4a1feb39210'
    },
    ["Business status update"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-item',
        contentBlueprintId: 'f877653e-87e1-4654-a915-3591b3dd0db3'
    },
    ["Business plan one-pager"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-plan-one-pager-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-plan-one-pager-item',
        contentBlueprintId: '6db15ae0-081f-4a9b-9936-15dec72492ee'
    },
    ["Career development plan"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:career-development-plan-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:career-development-plan-item',
        contentBlueprintId: '2b75697e-04cd-4e68-8eec-c3828a0d8c36'
    },
    ["Competitive analysis"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:competitive-analysis-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:competitive-analysis-item',
        contentBlueprintId: '1f0e6e6e-766b-4e98-9022-90ab4ef6194f'
    },
    ["Content design glossary"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:content-design-glossary-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:content-design-glossary-item',
        contentBlueprintId: 'bc251e1b-c784-4593-a360-d5a5bbccd56b'
    },
    ["Content strategy"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:content-strategy-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:content-strategy-item',
        contentBlueprintId: '30735803-4a23-40df-9848-1ab97067e66c'
    },
    ["Customer Impact Assessment"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-impact-assessment-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-impact-assessment-item',
        contentBlueprintId: '71a66b1f-49c9-4f9e-87fa-895850e1d2db'
    },
    ["Customer Interview Report"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-interview-report-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-interview-report-item',
        contentBlueprintId: '5322e0f4-2f85-45f3-8ffe-94fba1d571d8'
    },
    ["DACI: Decision documentation"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint-item',
        contentBlueprintId: '7edaef4a-329f-47c9-abfe-7e241c9e17ba'
    },
    ["Design decision"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-item',
        contentBlueprintId: 'fb9933f8-841d-43ea-a872-ef06abd7f725'
    },
    ["Design review"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-review-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-review-item',
        contentBlueprintId: '22f59064-c993-4fa9-bfd7-6a9e1be0ba4c'
    },
    ["Design sprint"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-sprint-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-sprint-item',
        contentBlueprintId: '3acf77bc-919c-4bd5-a8ee-cf1f045d01d5'
    },
    ["Design systems"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-systems-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-systems-item',
        contentBlueprintId: '337e0487-2a9c-4ce9-95b0-4212c228379a'
    },
    ["DevOps runbook"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:devops-runbook-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:devops-runbook-item',
        contentBlueprintId: 'eb916d7d-a90d-4d18-955b-445e28ce08a5'
    },
    ["Employee handbook"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-item',
        contentBlueprintId: '705c6810-8621-4c26-8d4e-ec51c92fd395'
    },
    ["HR Knowledge Base Management"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hr-knowledge-base-management-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hr-knowledge-base-management-item',
        contentBlueprintId: '62eb020a-ab61-4a64-8f96-788745e1761c'
    },
    ["How-to article"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-article-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-item',
        contentBlueprintId: '74323bcf-829b-4d71-a765-facc886accdd'
    },
    ["ITSM Known Errors"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-known-errors-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-known-errors-item',
        contentBlueprintId: '55c00b7d-e8e9-4644-ae6c-08bc4a480b70'
    },
    ["ITSM change management"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-change-management-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-change-management-item',
        contentBlueprintId: '0ad3bc27-3852-4166-af6b-d5ffe48060e9'
    },
    ["ITSM post incident reviews"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-pir-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-pir-item',
        contentBlueprintId: '0d50396d-ca50-4c57-90aa-91dea817d4db'
    },
    ["ITSM runbook"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-item',
        contentBlueprintId: '9866346f-4709-4ae3-ba43-05bd2c30f689'
    },
    ["Incident communication"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-communication-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-communication-item',
        contentBlueprintId: '45175536-78b0-4f59-a44c-47b0994037d0'
    },
    ["Incident postmortem"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-management-post-mortem-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-management-post-mortem-item',
        contentBlueprintId: '08117408-2841-483d-a2f6-7fe1c8985b8d'
    },
    ["Job description"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:job-description-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:job-description-item',
        contentBlueprintId: '2571ed8f-b86b-4f30-aadd-997bbb259906'
    },
    ["Lenny's Performance Review"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:lennys-performance-review-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:lennys-performance-review-item',
        contentBlueprintId: '8c187053-1bc6-4fef-a9f1-3d22e02b94b4'
    },
    ["Lenny's product requirements"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:lennys-product-requirements-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:lennys-product-requirements-item',
        contentBlueprintId: '245dd102-5d0f-41a2-b26c-048d43b60005'
    },
    ["Marketing plan"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-item',
        contentBlueprintId: '857e112e-50f1-4a24-b4f5-d6a717e4e279'
    },
    ["Meeting notes"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-item',
        contentBlueprintId: 'ec8ecc7e-7e4b-4f8a-aa3f-a6a7f2df4ac9'
    },
    ["Message house"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:message-house-template-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:message-house-template-item',
        contentBlueprintId: '43864f05-5531-44c1-b54b-66b97993fc9f'
    },
    ["OKRs"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:okr-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:okr-item',
        contentBlueprintId: '1e2fb2f7-e6d6-4825-8f1e-47033a15bd52'
    },
    ["Persona"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:persona-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:persona-item',
        contentBlueprintId: '181f2ea7-5fd6-4cbc-aa8f-d314f62c2483'
    },
    ["Presenter mode"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:presenter-mode-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:presenter-mode-item',
        contentBlueprintId: 'b414482f-1bd4-460e-bf14-8607879a93cb'
    },
    ["Product Requirements"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-item',
        contentBlueprintId: '4443a61a-9a9a-4712-b81e-a84e3ae51554'
    },
    ["Product roadmap"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-item',
        contentBlueprintId: '72f7004a-2f37-4ea4-a95f-2daade784d58'
    },
    ["Project Kickoff"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-kickoff-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-kickoff-item',
        contentBlueprintId: '4342057b-f7b0-4385-9317-2b8de25ee952'
    },
    ["Project plan"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-item',
        contentBlueprintId: 'f7a9afa1-19c0-4558-abd4-f8060829f9fc'
    },
    ["Project status"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-status-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-status-item',
        contentBlueprintId: 'a2484be7-df58-4f17-a347-2fecb7b22bb9'
    },
    ["Project Timeline Template"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-timeline-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-timeline-item',
        contentBlueprintId: 'ecd39da6-2163-4ea4-b6c7-280b7662681b'
    },
    ["QTC Acquisition"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:qtc-acquisition-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:qtc-acquisition-item',
        contentBlueprintId: 'feafa3b9-bf33-46af-9452-1fbcbe36e0a2'
    },
    ["Remote team meeting"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:remote-team-meeting-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:remote-team-meeting-item',
        contentBlueprintId: '5a273376-0251-49ca-9ee8-197e643bdfd3'
    },
    ["Risk assessment matrix"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:risk-assessment-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:risk-assessment-item',
        contentBlueprintId: '7f67b5e5-fd5e-4517-9006-0775f3f2f8ec'
    },
    ["Roles and responsibilities play"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:roles-responsibilities-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:roles-responsibilities-item',
        contentBlueprintId: 'be29e5eb-fbe7-4213-b16f-5fb25b13f2d8'
    },
    ["SMART Goals"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:smart-goals-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:smart-goals-item',
        contentBlueprintId: 'e97d646a-8b86-4561-9daf-ae7ee2de4a19'
    },
    ["SWOT analysis"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:swot-analysis-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:swot-analysis-item',
        contentBlueprintId: '2f7a20e6-4b0d-478f-96cf-1f093470f571'
    },
    ["Sales Portal"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sales-portal-template-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sales-portal-template-item',
        contentBlueprintId: '985c2d47-6f30-4a58-915a-3103786a9f8f'
    },
    ["Sales account planning"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:account-planning-for-sales-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:account-planning-for-sales-item',
        contentBlueprintId: 'cd9f6877-6926-4f48-b178-0d897b70b99c'
    },
    ["Software Architecture Review"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-item',
        contentBlueprintId: 'd1e47ac0-cc06-4699-a939-b012a4ead2f8'
    },
    ["Sprint planning meeting"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sprint-planning-meeting-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sprint-planning-meeting-item',
        contentBlueprintId: '611f84bb-1b6e-4a35-ba13-b67fdbeebfb6'
    },
    ["Stakeholder communications"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:stakeholder-communications-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:stakeholder-communications-item',
        contentBlueprintId: 'b6c3445f-bbc5-4de3-8b06-919619d9a82f'
    },
    ["Standard Operating Procedure (SOP) Template"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:standard-operating-procedure-sop-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:standard-operating-procedure-sop-item',
        contentBlueprintId: '14d6eb8f-cac0-494c-a22d-0e41bd76e9f9'
    },
    ["Strategic plan"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-strategy-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-strategy-item',
        contentBlueprintId: '43da1e9b-652d-4a0c-9570-cfdcbfc38c10'
    },
    ["Team homepage"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:team-homepage-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:team-homepage-item',
        contentBlueprintId: 'c9160e85-fb5c-4502-a6b9-c39c3f8f9d2a'
    },
    ["Team poster"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:team-poster-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:team-poster-item',
        contentBlueprintId: '2e0ddf37-d490-4bc8-9476-0597d928fe06'
    },
    ["To-do list"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-item',
        contentBlueprintId: 'c5ad620d-c78d-4d72-84aa-adf07798dc81'
    },
    ["Troubleshooting article"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-troubleshooting-article-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-troubleshooting-item',
        contentBlueprintId: 'e864ea83-270e-47de-b573-b21d1cc537cd'
    },
    ["Vendor agreement"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vendor-agreement-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vendor-agreement-item',
        contentBlueprintId: '9f11fe97-3ee7-43d7-8ad0-05253c80c12e'
    },
    ["Virtual event"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:virtual-event-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:virtual-event-item',
        contentBlueprintId: '65012d82-c253-41de-8875-552cb92baa1d'
    },
    ["Vision to values"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vision-to-values-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vision-to-values-item',
        contentBlueprintId: '00361a2d-c2c9-4670-9cfc-49d8c4126122'
    },
    ["End of week status report"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-item',
        contentBlueprintId: '6873d89c-765f-4677-b370-048005c7470b'
    },
    ["Weekly meeting notes"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:recurring-meeting-minutes-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:recurring-meeting-minutes-item',
        contentBlueprintId: '7c19a101-d13e-4d67-870b-279e6342c6bc'
    },
    ["Work trip planner"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:work-trip-planner-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:work-trip-planner-item',
        contentBlueprintId: 'b3c70113-a13a-4419-b906-7cac93bcd092'
    },
    ["Workshop planner"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:workshop-planner-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:workshop-planner-item',
        contentBlueprintId: 'e9889133-019b-4283-a4d2-9f916081cc76'
    },
    ["Writing guidelines"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:writing-guideline-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:writing-guideline-item',
        contentBlueprintId: '0193f684-d07b-4af1-af11-7dc20d7d7bc4'
    },
    ["Quarterly check in"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:quarterly-check-in-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:quarterly-check-in-item',
        contentBlueprintId: 'e2a1cea6-c5e7-4de1-b397-862efddc17d8'
    },
    ["AWS architecture diagram"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:aws-architecture-diagram-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:aws-architecture-diagram-item',
        contentBlueprintId: '777e5e10-8151-411b-9d3a-e18c32e1ccf9'
    },
    ["Marketing blog post"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blog-post-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blog-post-item',
        contentBlueprintId: '77b5e06c-c8a6-4fa5-b104-69b4b2c3006d'
    },
    ["Marketing campaign"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-item',
        contentBlueprintId: '4254b414-5ba3-4178-85fd-03c93166d92b'
    },
    ["Hiring process"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hiring-process-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hiring-process-item',
        contentBlueprintId: '29e1a62b-919d-4a1d-9325-ab26e1539bba'
    },
    ["Mutual action plan"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:mutual-action-plan-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:mutual-action-plan-item',
        contentBlueprintId: 'cd7d12fc-79c5-45fc-97e0-275b5fe09063'
    },
    ["ITSM weekly major incident report"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-weekly-major-incident-report-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-weekly-major-incident-report-item',
        contentBlueprintId: '00917469-8d47-4375-8148-8f6e42db13a6'
    },
    ["Disruptive brainstorming"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:disrupt-brainstorming-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:disrupt-brainstorming-item',
        contentBlueprintId: '01e2cb00-2daf-41d8-aec2-e409c985bcbb'
    }
};
const $522761dd0b51db26$export$749d5881ec6896ca = (templates)=>{
    const blueprintModuleKeyToTemplate = {};
    templates?.allTemplates?.nodes?.forEach((template)=>{
        if (template?.blueprintModuleCompleteKey) blueprintModuleKeyToTemplate[template.blueprintModuleCompleteKey] = template;
    });
    return blueprintModuleKeyToTemplate;
};
module.exports["BLUEPRINT_NAMES"] = $522761dd0b51db26$export$82e276cacb9013c9;
module.exports["BLUEPRINT_NAMES_SET"] = $522761dd0b51db26$export$c42db12dd3d44bb8;
module.exports["BLUEPRINT_NAME_TO_IDS_MAPPING"] = $522761dd0b51db26$export$d7a793aff6267afc;
module.exports["mapBlueprintModuleKeyToTemplate"] = $522761dd0b51db26$export$749d5881ec6896ca;

});

parcelRegister("lNMA9", function(module, exports) {

var $8E5P5 = parcelRequire("8E5P5");


var $aZID8 = parcelRequire("aZID8");

const $238db7033b629672$export$eaa4084616ac3256 = {
    'SOFTWARE DEVELOPMENT': [
        (0, $8E5P5.BLUEPRINT_NAMES).PRODUCT_REQUIREMENTS,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SIMPLE_RETROSPECTIVE,
        (0, $8E5P5.BLUEPRINT_NAMES).SOFTWARE_ARCHITECTURE_REVIEW,
        (0, $8E5P5.BLUEPRINT_NAMES).DEVOPS_RUNBOOK,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).FLOWCHART,
        (0, $8E5P5.BLUEPRINT_NAMES).SPRINT_PLANNING_MEETING,
        (0, $8E5P5.BLUEPRINT_NAMES).INCIDENT_POSTMORTEM
    ],
    'CUSTOMER SERVICE': [
        (0, $8E5P5.BLUEPRINT_NAMES).CUSTOMER_IMPACT_ASSESSMENT,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SERVICE_BLUEPRINT,
        (0, $8E5P5.BLUEPRINT_NAMES).INCIDENT_COMMUNICATION,
        (0, $8E5P5.BLUEPRINT_NAMES).TROUBLESHOOTING_ARTICLE,
        (0, $8E5P5.BLUEPRINT_NAMES).SMART_GOALS
    ],
    'IT SUPPORT': [
        (0, $8E5P5.BLUEPRINT_NAMES).HOW_TO_ARTICLE,
        (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_PLAN,
        (0, $8E5P5.BLUEPRINT_NAMES).ITSM_KNOWN_ERRORS,
        (0, $8E5P5.BLUEPRINT_NAMES).TROUBLESHOOTING_ARTICLE,
        (0, $8E5P5.BLUEPRINT_NAMES).ITSM_POST_INCIDENT_REVIEWS,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SIMPLE_RETROSPECTIVE,
        (0, $8E5P5.BLUEPRINT_NAMES).ITSM_RUNBOOK,
        (0, $8E5P5.BLUEPRINT_NAMES).ITSM_CHANGE_MANAGEMENT
    ],
    'PRODUCT MANAGEMENT': [
        (0, $8E5P5.BLUEPRINT_NAMES).LENNYS_PRODUCT_REQUIREMENTS,
        (0, $8E5P5.BLUEPRINT_NAMES).PRODUCT_ROADMAP,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).PRIORITIZATION_MATRIX,
        (0, $8E5P5.BLUEPRINT_NAMES).DACI_DECISION_DOCUMENTATION,
        (0, $8E5P5.BLUEPRINT_NAMES).STRATEGIC_PLAN,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING,
        (0, $8E5P5.BLUEPRINT_NAMES).BUSINESS_STATUS_UPDATE,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).USER_STORY_MAP
    ],
    'PROJECT MANAGEMENT': [
        (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_PLAN,
        (0, $8E5P5.BLUEPRINT_NAMES).STRATEGIC_PLAN,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SIMPLE_RETROSPECTIVE,
        (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_STATUS,
        (0, $8E5P5.BLUEPRINT_NAMES).DACI_DECISION_DOCUMENTATION,
        (0, $8E5P5.BLUEPRINT_NAMES).OKRS,
        (0, $8E5P5.BLUEPRINT_NAMES).ROLES_AND_RESPONSIBILITIES,
        (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_KICKOFF
    ],
    DESIGN: [
        (0, $8E5P5.BLUEPRINT_NAMES).DESIGN_SYSTEMS,
        (0, $8E5P5.BLUEPRINT_NAMES).DESIGN_SPRINT,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).DISRUPTIVE_BRAINSTORM,
        (0, $8E5P5.BLUEPRINT_NAMES).CONTENT_STRATEGY,
        (0, $8E5P5.BLUEPRINT_NAMES).DESIGN_DECISION,
        (0, $8E5P5.BLUEPRINT_NAMES).PERSONA,
        (0, $8E5P5.BLUEPRINT_NAMES).DESIGN_REVIEW,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).CRAZY_8S_BRAINSTORMING,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).USER_STORY_MAP
    ],
    MARKETING: [
        (0, $8E5P5.BLUEPRINT_NAMES).MARKETING_PLAN,
        (0, $8E5P5.BLUEPRINT_NAMES).COMPETITIVE_ANALYSIS,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).USER_STORY_MAP,
        (0, $8E5P5.BLUEPRINT_NAMES).SWOT_ANALYSIS,
        (0, $8E5P5.BLUEPRINT_NAMES).PERSONA,
        (0, $8E5P5.BLUEPRINT_NAMES).MESSAGE_HOUSE,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).TIMELINE_WORKFLOW
    ],
    SALES: [
        (0, $8E5P5.BLUEPRINT_NAMES).SALES_PORTAL,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING,
        (0, $8E5P5.BLUEPRINT_NAMES).COMPETITIVE_ANALYSIS,
        (0, $8E5P5.BLUEPRINT_NAMES).SWOT_ANALYSIS,
        (0, $8E5P5.BLUEPRINT_NAMES).BUSINESS_PLAN_ONE_PAGER,
        (0, $8E5P5.BLUEPRINT_NAMES).MESSAGE_HOUSE,
        (0, $8E5P5.BLUEPRINT_NAMES).SALES_ACCOUNT_PLANNING,
        (0, $8E5P5.BLUEPRINT_NAMES).EXECUTIVE_BUSINESS_REVIEW
    ],
    OPERATIONS: [
        (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_PLAN,
        (0, $8E5P5.BLUEPRINT_NAMES).BUSINESS_STATUS_UPDATE,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).GAP_ANALYSIS,
        (0, $8E5P5.BLUEPRINT_NAMES).TEAM_POSTER,
        (0, $8E5P5.BLUEPRINT_NAMES).ANNUAL_PLAN_ONE_PAGER,
        (0, $8E5P5.BLUEPRINT_NAMES).BUSINESS_PLAN_ONE_PAGER,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ANNUAL_CALENDAR,
        (0, $8E5P5.BLUEPRINT_NAMES).SWOT_ANALYSIS,
        (0, $8E5P5.BLUEPRINT_NAMES).ALL_HANDS_MEETING,
        (0, $8E5P5.BLUEPRINT_NAMES).STRATEGIC_PLAN
    ],
    RESEARCH: [
        (0, $8E5P5.BLUEPRINT_NAMES).CUSTOMER_INTERVIEW_REPORT,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).USER_STORY_MAP,
        (0, $8E5P5.BLUEPRINT_NAMES).PERSONA,
        (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_PLAN,
        (0, $8E5P5.BLUEPRINT_NAMES).MEETING_NOTES,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING,
        (0, $8E5P5.BLUEPRINT_NAMES).PRESENTER_MODE
    ],
    FINANCE: [
        (0, $8E5P5.BLUEPRINT_NAMES).BUSINESS_STATUS_UPDATE,
        (0, $8E5P5.BLUEPRINT_NAMES).BUSINESS_PLAN_ONE_PAGER,
        (0, $8E5P5.BLUEPRINT_NAMES).TEAM_POSTER,
        (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_STATUS,
        (0, $8E5P5.BLUEPRINT_NAMES).VENDOR_AGREEMENT,
        (0, $8E5P5.BLUEPRINT_NAMES).QTC_ACQUISITION,
        (0, $8E5P5.BLUEPRINT_NAMES).DACI_DECISION_DOCUMENTATION,
        (0, $8E5P5.BLUEPRINT_NAMES).RISK_ASSESSMENT_MATRIX
    ],
    'HUMAN RESOURCES': [
        (0, $8E5P5.BLUEPRINT_NAMES).HR_KNOWLEDGE_BASE_MANAGEMENT,
        (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_PLAN,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ORG_CHART,
        (0, $8E5P5.BLUEPRINT_NAMES).EMPLOYEE_HANDBOOK,
        (0, $8E5P5.BLUEPRINT_NAMES).CAREER_DEVELOPMENT_PLAN,
        (0, $8E5P5.BLUEPRINT_NAMES).JOB_DESCRIPTION,
        (0, $8E5P5.BLUEPRINT_NAMES).TEAM_POSTER,
        (0, $8E5P5.BLUEPRINT_NAMES).NINETY_DAY_PLAN,
        (0, $8E5P5.BLUEPRINT_NAMES).LENNYS_PERFORMANCE_REVIEW,
        (0, $8E5P5.BLUEPRINT_NAMES).VISION_TO_VALUES
    ],
    LEGAL: [
        (0, $8E5P5.BLUEPRINT_NAMES).DACI_DECISION_DOCUMENTATION,
        (0, $8E5P5.BLUEPRINT_NAMES).RISK_ASSESSMENT_MATRIX,
        (0, $8E5P5.BLUEPRINT_NAMES).TO_DO_LIST,
        (0, $8E5P5.BLUEPRINT_NAMES).MEETING_NOTES
    ],
    OTHER: [
        (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_PLAN,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING,
        (0, $8E5P5.BLUEPRINT_NAMES).MEETING_NOTES,
        (0, $8E5P5.BLUEPRINT_NAMES).TO_DO_LIST,
        (0, $8E5P5.BLUEPRINT_NAMES).END_OF_WEEK_STATUS_REPORT,
        (0, $8E5P5.BLUEPRINT_NAMES).PRESENTER_MODE
    ]
};
module.exports["teamToTemplatesMapping"] = $238db7033b629672$export$eaa4084616ac3256;

});

parcelRegister("aZID8", function(module, exports) {
/* Eventually these strings should get moved to the components they're used in but creating generic file for now to kickoff translations */ 
var $aXWIB = parcelRequire("aXWIB");

const $1b4f1e6e0b571adc$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    databaseTemplateType: {
        id: "experiment-personalized-templates-v2.database.template",
        defaultMessage: "Database template"
    },
    getStartedHeader: {
        id: "experiment-personalized-templates-v2.getting.started.header",
        defaultMessage: "Get started"
    },
    simpleRetrospectiveTemplate: {
        id: "experiment-personalized-templates-v2.simple.retrospective.template",
        defaultMessage: "Simple retrospective"
    },
    flowchartTemplate: {
        id: "experiment-personalized-templates-v2.flowchart.template",
        defaultMessage: "Flowchart"
    },
    prioritizationMatrixTemplate: {
        id: "experiment-personalized-templates-v2.prioritization.matrix.template",
        defaultMessage: "Prioritization matrix"
    },
    brainwritingTemplate: {
        id: "experiment-personalized-templates-v2.brainwriting.template",
        defaultMessage: "Brainwriting"
    },
    incidentPostmortemTemplate: {
        id: "experiment-personalized-templates-v2.incident.postmortem.template",
        defaultMessage: "Incident postmortem"
    },
    fourLsTemplate: {
        id: "experiment-personalized-templates-v2.four.ls.template",
        defaultMessage: "4 Ls Retro"
    },
    networkOfTeamsTemplate: {
        id: "experiment-personalized-templates-v2.network.of.teams.template",
        defaultMessage: "Network of teams"
    },
    disruptiveBrainstormTemplate: {
        id: "experiment-personalized-templates-v2.disruptive.brainstorm.template",
        defaultMessage: "Disruptive brainstorm"
    },
    conceptMapTemplate: {
        id: "experiment-personalized-templates-v2.concept.map.template",
        defaultMessage: "Concept map"
    },
    swimlanesProcessMapTemplate: {
        id: "experiment-personalized-templates-v2.swimlanes.process.map.template",
        defaultMessage: "Swimlanes process map"
    },
    swotAnalysisTemplate: {
        id: "experiment-personalized-templates-v2.swot.analysis.template",
        defaultMessage: "SWOT Analysis"
    },
    focusAreaDiagramTemplate: {
        id: "experiment-personalized-templates-v2.focus.area.diagram.template",
        defaultMessage: "Focus area diagram"
    },
    userStoryMapTemplate: {
        id: "experiment-personalized-templates-v2.user.story.map.template",
        defaultMessage: "User story map"
    },
    fishboneDiagramTemplate: {
        id: "experiment-personalized-templates-v2.fishbone.diagram.template",
        defaultMessage: "Fishbone diagram"
    },
    orgChartTemplate: {
        id: "experiment-personalized-templates-v2.org.chart.template",
        defaultMessage: "Org chart"
    },
    icebreakersTemplate: {
        id: "experiment-personalized-templates-v2.icebreakers.template",
        defaultMessage: "Icebreakers"
    },
    serviceBlueprintTemplate: {
        id: "experiment-personalized-templates-v2.service.blueprint.template",
        defaultMessage: "Service blueprint"
    },
    productVisionTemplate: {
        id: "experiment-personalized-templates-v2.product.vision.board.template",
        defaultMessage: "Product vision board"
    },
    workflowTemplate: {
        id: "experiment-personalized-templates-v2.workflow.template",
        defaultMessage: "Workflow"
    },
    timelineWorkflowTemplate: {
        id: "experiment-personalized-templates-v2.timeline.workflow.template",
        defaultMessage: "Timeline workflow"
    },
    teamHealthMonitorTemplate: {
        id: "experiment-personalized-templates-v2.team.health.monitor.template",
        defaultMessage: "Team health monitor"
    },
    teamCharterTemplate: {
        id: "experiment-personalized-templates-v2.team.charter.template",
        defaultMessage: "Team charter template"
    },
    actionPlanTemplate: {
        id: "experiment-personalized-templates-v2.action.plan.template",
        defaultMessage: "Action plan"
    },
    gapAnalysisTemplate: {
        id: "experiment-personalized-templates-v2.gap.analysis.template",
        defaultMessage: "Gap analysis"
    },
    productRoadmapTemplate: {
        id: "experiment-personalized-templates-v2.product.roadmap.template",
        defaultMessage: "Product roadmap"
    },
    crazy8sBrainstormingTemplate: {
        id: "experiment-personalized-templates-v2.product.crazy-8s-brainstorming.template",
        defaultMessage: "Crazy 8s brainstorming"
    },
    annualCalendarTemplate: {
        id: "experiment-personalized-templates-v2.product.annual-calendar.template",
        defaultMessage: "Annual Calendar"
    },
    stakeholderMappingTemplate: {
        id: "experiment-personalized-templates-v2.product.stakeholder-mapping.template",
        defaultMessage: "Stakeholder mapping"
    },
    rootCauseTemplate: {
        id: "experiment-personalized-templates-v2.product.root-cause.template",
        defaultMessage: "Root cause analysis"
    },
    executiveSummaryTemplate: {
        id: "experiment-personalized-templates-v2.product.executive-summary.template",
        defaultMessage: "Executive summary"
    },
    elevatorPitchTemplate: {
        id: "experiment-personalized-templates-v2.product.elevator-pitch.template",
        defaultMessage: "Elevator pitch"
    }
});


var $1c49274cbb1cbf62$export$2f1a3cf395e54495 = /*#__PURE__*/ function(WHITEBOARD_TEMPLATE_IDS) {
    WHITEBOARD_TEMPLATE_IDS["ACTION_PLAN"] = "action-plan";
    WHITEBOARD_TEMPLATE_IDS["ANNUAL_CALENDAR"] = "annual-calendar-2025-2026";
    WHITEBOARD_TEMPLATE_IDS["BRAINWRITING"] = "brainwriting";
    WHITEBOARD_TEMPLATE_IDS["CONCEPT_MAP"] = "concept-map";
    WHITEBOARD_TEMPLATE_IDS["CRAZY_8S_BRAINSTORMING"] = "crazy-8s";
    WHITEBOARD_TEMPLATE_IDS["DISRUPTIVE_BRAINSTORM"] = "disruptive-brainstorm";
    WHITEBOARD_TEMPLATE_IDS["EXECUTIVE_SUMMARY"] = "executive-summary";
    WHITEBOARD_TEMPLATE_IDS["FISHBONE_DIAGRAM"] = "fishbone-diagram";
    WHITEBOARD_TEMPLATE_IDS["FLOWCHART"] = "flow-chart";
    WHITEBOARD_TEMPLATE_IDS["FOCUS_AREA_DIAGRAM"] = "focus-area-diagram";
    WHITEBOARD_TEMPLATE_IDS["FOURLS_RETRO"] = "4ls-retro";
    WHITEBOARD_TEMPLATE_IDS["GAP_ANALYSIS"] = "gap-analysis";
    WHITEBOARD_TEMPLATE_IDS["ICEBREAKERS"] = "ice-breakers";
    WHITEBOARD_TEMPLATE_IDS["INCIDENT_POSTMORTEM"] = "incident-postmortem";
    WHITEBOARD_TEMPLATE_IDS["NETWORK_OF_TEAMS"] = "network-of-teams";
    WHITEBOARD_TEMPLATE_IDS["ORG_CHART"] = "org-chart";
    WHITEBOARD_TEMPLATE_IDS["PRIORITIZATION_MATRIX"] = "prioritization";
    WHITEBOARD_TEMPLATE_IDS["PRODUCT_ROADMAP"] = "product-roadmap";
    WHITEBOARD_TEMPLATE_IDS["PRODUCT_VISION_BOARD"] = "product-vision-board";
    WHITEBOARD_TEMPLATE_IDS["ROOT_CAUSE_TEMPLATE"] = "root-cause-analysis";
    WHITEBOARD_TEMPLATE_IDS["SERVICE_BLUEPRINT"] = "service-blueprint";
    WHITEBOARD_TEMPLATE_IDS["SIMPLE_RETROSPECTIVE"] = "simple-retrospective";
    WHITEBOARD_TEMPLATE_IDS["STAKEHOLDER_MAPPING"] = "stakeholder-mapping";
    WHITEBOARD_TEMPLATE_IDS["SWIMLANES_PROCESS_MAP"] = "swimlanes";
    WHITEBOARD_TEMPLATE_IDS["SWOT_ANALYSIS"] = "swot-analysis";
    WHITEBOARD_TEMPLATE_IDS["TEAM_CHARTER_TEMPLATE"] = "team-formation-guide";
    WHITEBOARD_TEMPLATE_IDS["TEAM_HEALTH_MONITOR"] = "health-monitor";
    WHITEBOARD_TEMPLATE_IDS["TIMELINE_WORKFLOW"] = "timeline-workflow";
    WHITEBOARD_TEMPLATE_IDS["USER_STORY_MAP"] = "user-story-map";
    WHITEBOARD_TEMPLATE_IDS["WORKFLOW_TEMPLATE"] = "workflow";
    WHITEBOARD_TEMPLATE_IDS["ELEVATOR_PITCH"] = "elevator-pitch";
    return WHITEBOARD_TEMPLATE_IDS;
}({});
const $1c49274cbb1cbf62$export$e6f6ad6a6a9f5ec0 = {
    ["simple-retrospective"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).simpleRetrospectiveTemplate,
    ["prioritization"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).prioritizationMatrixTemplate,
    ["brainwriting"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).brainwritingTemplate,
    ["incident-postmortem"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).incidentPostmortemTemplate,
    ["4ls-retro"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).fourLsTemplate,
    ["network-of-teams"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).networkOfTeamsTemplate,
    ["disruptive-brainstorm"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).disruptiveBrainstormTemplate,
    ["concept-map"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).conceptMapTemplate,
    ["swimlanes"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).swimlanesProcessMapTemplate,
    ["swot-analysis"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).swotAnalysisTemplate,
    ["focus-area-diagram"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).focusAreaDiagramTemplate,
    ["user-story-map"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).userStoryMapTemplate,
    ["timeline-workflow"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).timelineWorkflowTemplate,
    ["fishbone-diagram"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).fishboneDiagramTemplate,
    ["org-chart"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).orgChartTemplate,
    ["ice-breakers"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).icebreakersTemplate,
    ["service-blueprint"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).serviceBlueprintTemplate,
    ["product-vision-board"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).productVisionTemplate,
    ["workflow"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).workflowTemplate,
    ["health-monitor"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).teamHealthMonitorTemplate,
    ["flow-chart"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).flowchartTemplate,
    ["team-formation-guide"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).teamCharterTemplate,
    ["action-plan"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).actionPlanTemplate,
    ["executive-summary"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).executiveSummaryTemplate,
    ["root-cause-analysis"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).rootCauseTemplate,
    ["stakeholder-mapping"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).stakeholderMappingTemplate,
    ["gap-analysis"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).gapAnalysisTemplate,
    ["annual-calendar-2025-2026"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).annualCalendarTemplate,
    ["crazy-8s"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).crazy8sBrainstormingTemplate,
    ["product-roadmap"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).productRoadmapTemplate,
    ["elevator-pitch"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).elevatorPitchTemplate
};
const $1c49274cbb1cbf62$export$e29ba58b8013030 = new Set(Object.values($1c49274cbb1cbf62$export$2f1a3cf395e54495));
module.exports["WHITEBOARD_TEMPLATE_IDS"] = $1c49274cbb1cbf62$export$2f1a3cf395e54495;
module.exports["WHITEBOARD_TEMPLATE_TITLE_MAPPING"] = $1c49274cbb1cbf62$export$e6f6ad6a6a9f5ec0;

});

parcelRegister("k70KU", function(module, exports) {

var $8E5P5 = parcelRequire("8E5P5");


var $aZID8 = parcelRequire("aZID8");

const $f3ad0d73036ec58e$export$2c95017061b2237f = [
    (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_PLAN,
    (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING,
    (0, $8E5P5.BLUEPRINT_NAMES).MEETING_NOTES,
    (0, $8E5P5.BLUEPRINT_NAMES).TEAM_POSTER,
    (0, $8E5P5.BLUEPRINT_NAMES).END_OF_WEEK_STATUS_REPORT,
    (0, $8E5P5.BLUEPRINT_NAMES).PRESENTER_MODE,
    (0, $8E5P5.BLUEPRINT_NAMES).HOW_TO_ARTICLE,
    (0, $8E5P5.BLUEPRINT_NAMES).TO_DO_LIST
];
module.exports["DEFAULT_POPULAR_TEMPLATES"] = $f3ad0d73036ec58e$export$2c95017061b2237f;

});

parcelRegister("7eJWX", function(module, exports) {

var $ivb8S = parcelRequire("ivb8S");


var $1gy7x = parcelRequire("1gy7x");

const $ee10c3f51286dbb8$var$deserializeTemplateUsage = (serializedTemplateUsage, templateList)=>{
    try {
        const parsedTemplateUsage = JSON.parse(serializedTemplateUsage || '{}');
        if (typeof parsedTemplateUsage !== 'object') return {};
        // There's no control over the shape of the object that's deserialized,
        // so we need to filter out any keys and values that aren't valid.
        const templateListSet = new Set(templateList);
        return Object.keys(parsedTemplateUsage).reduce((acc, key)=>templateListSet.has(key) ? {
                ...acc,
                [key]: parsedTemplateUsage[key]
            } : acc, {});
    } catch (e) {
        return {};
    }
};
const $ee10c3f51286dbb8$var$serializeTemplateUsage = (deserializedTemplateUsage)=>{
    return JSON.stringify(deserializedTemplateUsage);
};
const $ee10c3f51286dbb8$export$eade43de7a369096 = (serializedTemplateUsage, templateList, templateUsageKey = (0, $1gy7x.PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS).templateUsageValues)=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const deserializedTemplateUsage = $ee10c3f51286dbb8$var$deserializeTemplateUsage(serializedTemplateUsage, templateList);
    const incrementTemplateUsage = (templateId)=>{
        const updatedTemplateUsage = {
            ...deserializedTemplateUsage,
            [templateId]: (deserializedTemplateUsage[templateId] || 0) + 1
        };
        setOnboardingState({
            key: templateUsageKey,
            value: $ee10c3f51286dbb8$var$serializeTemplateUsage(updatedTemplateUsage)
        });
    };
    return {
        deserializedTemplateUsage: deserializedTemplateUsage,
        incrementTemplateUsage: incrementTemplateUsage
    };
};
module.exports["usePTV2TemplateUsage"] = $ee10c3f51286dbb8$export$eade43de7a369096;

});

parcelRegister("25bKr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ZDq1z = parcelRequire("ZDq1z");


var $inPa6 = parcelRequire("inPa6");


var $gj7hi = parcelRequire("gj7hi");


var $bZSO8 = parcelRequire("bZSO8");


var $dPJCf = parcelRequire("dPJCf");


var $dR5is = parcelRequire("dR5is");


var $aZID8 = parcelRequire("aZID8");


var $34yV7 = parcelRequire("34yV7");


var $hxdG1 = parcelRequire("hxdG1");

const $e8e43144b9c01ae5$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    whiteboardTemplateType: {
        id: "experiment-personalized-templates-v2.whiteboard.template",
        defaultMessage: "Whiteboard template"
    }
});
const $e8e43144b9c01ae5$export$8e3c134254b621fa = ({ usage: usage, templateName: templateName, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { personalSpaceKey: personalSpaceKey, personalizationHeuristic: personalizationHeuristic, onboardingPeriodDay: onboardingPeriodDay, isXflow: isXflow, source: source } = (0, $hxdG1.usePTV2State)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'templateCardPTV2',
                source: source ?? 'cc-onboarding-personalized-templates-v2',
                attributes: {
                    templateType: 'whiteboard',
                    templateId: templateName,
                    personalizationHeuristic: // whiteboard template names are already the IDs
                    personalizationHeuristic,
                    onboardingPeriodDay: onboardingPeriodDay,
                    isXflow: isXflow
                }
            }
        }).fire();
        onClick();
        push((0, $bZSO8.buildCreationLink)({
            contentType: 'whiteboard',
            source: 'cc-onboarding-personalized-templates-v2',
            spaceKey: personalSpaceKey,
            insertTemplateWithKey: templateName,
            openTemplatePicker: false
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dR5is.PTV2TemplateCard), {
        usage: usage,
        subTitle: formatMessage($e8e43144b9c01ae5$export$a7357cdd1f0b0168.whiteboardTemplateType),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))), {
            label: ""
        }),
        onClick: handleClick,
        title: formatMessage((0, $aZID8.WHITEBOARD_TEMPLATE_TITLE_MAPPING)[templateName]),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: (0, $34yV7.WHITEBOARD_TEMPLATE_TO_IMG_MAPPING)[templateName] || (0, $34yV7.defaultImgSrc),
            srcDark: (0, $34yV7.WHITEBOARD_TEMPLATE_TO_DARK_IMG_MAPPING)[templateName] || (0, $34yV7.defaultDarkImgSrc),
            alt: ""
        })
    });
};
module.exports["PTV2WhiteboardTemplateCard"] = $e8e43144b9c01ae5$export$8e3c134254b621fa;

});

parcelRegister("bTccH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $gj7hi = parcelRequire("gj7hi");


var $e0ycV = parcelRequire("e0ycV");


var $2YJkl = parcelRequire("2YJkl");


var $dR5is = parcelRequire("dR5is");


var $34yV7 = parcelRequire("34yV7");


var $hxdG1 = parcelRequire("hxdG1");


var $8E5P5 = parcelRequire("8E5P5");

const $db0a355b403329ac$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    pageTemplateType: {
        id: "experiment-personalized-templates-v2.page.template",
        defaultMessage: "Page template"
    },
    documentTemplateType: {
        id: "experiment-personalized-templates-v2.document.template",
        defaultMessage: "Document template"
    }
});
const $db0a355b403329ac$export$2744e97e4feefb02 = ({ usage: usage, templateName: templateName, onClick: onClick, blueprintModuleKeyToTemplate: blueprintModuleKeyToTemplate })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { personalSpaceKey: personalSpaceKey, personalizationHeuristic: personalizationHeuristic, onboardingPeriodDay: onboardingPeriodDay, isXflow: isXflow, source: source } = (0, $hxdG1.usePTV2State)();
    const createFromTemplate = (0, $2YJkl.useCreateContentFromTemplate)();
    const blueprintIds = (0, $8E5P5.BLUEPRINT_NAME_TO_IDS_MAPPING)[templateName];
    if (!blueprintIds) return null;
    const { blueprintModuleCompleteKey: blueprintModuleCompleteKey } = blueprintIds;
    const template = blueprintModuleKeyToTemplate[blueprintModuleCompleteKey];
    if (!template || !template?.name) return null;
    const handleClick = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'templateCardPTV2',
                source: source ?? 'cc-onboarding-personalized-templates-v2',
                attributes: {
                    templateType: 'blueprint',
                    templateId: blueprintModuleCompleteKey.substring(blueprintModuleCompleteKey.lastIndexOf(':') + 1),
                    personalizationHeuristic: personalizationHeuristic,
                    onboardingPeriodDay: onboardingPeriodDay,
                    isXflow: isXflow
                }
            }
        }).fire();
        onClick();
        try {
            await createFromTemplate(template, personalSpaceKey, {
                subType: 'live'
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'created',
                    actionSubject: 'template',
                    actionSubjectId: template?.name,
                    source: 'cc-onboarding-personalized-templates-v2',
                    attributes: {
                        isXflow: isXflow
                    }
                }
            }).fire();
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'template',
                    actionSubjectId: template?.name,
                    source: 'cc-onboarding-personalized-templates-v2',
                    attributes: {
                        errorMessage: error.message,
                        isXflow: isXflow
                    }
                }
            }).fire();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dR5is.PTV2TemplateCard), {
        usage: usage,
        title: template?.name,
        subTitle: formatMessage($db0a355b403329ac$export$a7357cdd1f0b0168.documentTemplateType),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))), {
            label: ""
        }),
        onClick: handleClick,
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: (0, $34yV7.BLUEPRINT_NAME_TO_IMG_MAPPING)[templateName] || (0, $34yV7.defaultImgSrc),
            srcDark: (0, $34yV7.BLUEPRINT_IMG_MAP_DARK)[templateName] || (0, $34yV7.defaultDarkImgSrc),
            alt: ""
        })
    });
};
module.exports["PTV2BlueprintTemplateCard"] = $db0a355b403329ac$export$2744e97e4feefb02;

});

parcelRegister("irtDS", function(module, exports) {

let $d6d1bde8fce379f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d6d1bde8fce379f6$var$load("5R843").then(()=>parcelRequire('fB9FN'));

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("hjygH", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $1aeb691895c5954d$export$85823f26dca064c3(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>{
            if (error) experienceTracker.stopOnError({
                name: name,
                error: error,
                attributes: attributes
            });
            else experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        };
        t2 = [
            experienceTracker,
            name,
            attributes,
            error
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceStop"] = $1aeb691895c5954d$export$85823f26dca064c3;

});

parcelRegister("kDja4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $42omo.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        // Use static feature gate calls to satisfy confluence-feature-gating/static-feature-gates
        switch(featureName){
            case 'whiteboardSolidHeader':
                return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
            case 'whiteboardOptOut':
                return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
            case 'digitalTeammate':
                return (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
            case 'aiFirstCreation':
                return (0, $9wGTI.fg)('aifc_create_enabled');
            default:
                return false;
        }
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dh538.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("yuLaV", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $lzcvT = parcelRequire("lzcvT");


var $5spQU = parcelRequire("5spQU");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            const isEnvEnabled = (0, $5spQU.isFeatureEnabled)('confluence', featureKeyMap[contentType], {
                'fedramp-moderate': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_fedramp'),
                'isolated-cloud-commercial': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_ic')
            });
            if (contentType === 'slide') return isEnvEnabled && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
            return isEnvEnabled;
        }
        if (contentType === 'slide') return !(0, $lzcvT.isFedRamp)() && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
        return !(0, $lzcvT.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("ctLrB", function(module, exports) {

var $5T18X = parcelRequire("5T18X");


var $aXWIB = parcelRequire("aXWIB");

var $61e4e33a86012bad$export$62aa48085237e36f = /*#__PURE__*/ function(LoadingState) {
    LoadingState[LoadingState["done"] = 0] = "done";
    LoadingState[LoadingState["initial"] = 1] = "initial";
    LoadingState[LoadingState["pagination"] = 2] = "pagination";
    return LoadingState;
}({});
var $61e4e33a86012bad$export$f5dd0176116f8854 = /*#__PURE__*/ function(HomeViewFilters) {
    HomeViewFilters["ALL"] = "ALL";
    HomeViewFilters["WORKED_ON"] = "WORKED_ON";
    HomeViewFilters["CREATED"] = "CREATED";
    HomeViewFilters["STARRED"] = "STARRED";
    HomeViewFilters["TASKS"] = "TASKS";
    HomeViewFilters["DRAFTS"] = "DRAFTS";
    return HomeViewFilters;
}({});
var $61e4e33a86012bad$export$132f858337fea016 = /*#__PURE__*/ function(ActivityEventType) {
    ActivityEventType["ASSIGNED"] = "ASSIGNED";
    ActivityEventType["COMMENTED"] = "COMMENTED";
    ActivityEventType["CREATED"] = "CREATED";
    ActivityEventType["EDITED"] = "EDITED";
    ActivityEventType["LIKED"] = "LIKED";
    ActivityEventType["PUBLISHED"] = "PUBLISHED";
    ActivityEventType["SNAPSHOTTED"] = "SNAPSHOTTED";
    ActivityEventType["STARTED"] = "STARTED";
    ActivityEventType["TRANSITIONED"] = "TRANSITIONED";
    ActivityEventType["UNASSIGNED"] = "UNASSIGNED";
    ActivityEventType["UPDATED"] = "UPDATED";
    ActivityEventType["VIEWED"] = "VIEWED";
    return ActivityEventType;
}({});
var $61e4e33a86012bad$export$4edf00fad4b97379 = /*#__PURE__*/ function(ActivitiesObjectType) {
    ActivitiesObjectType["BLOGPOST"] = "BLOGPOST";
    ActivitiesObjectType["DATABASE"] = "DATABASE";
    ActivitiesObjectType["EMBED"] = "EMBED";
    ActivitiesObjectType["ISSUE"] = "ISSUE";
    ActivitiesObjectType["PAGE"] = "PAGE";
    ActivitiesObjectType["SLIDE"] = "SLIDE";
    ActivitiesObjectType["WHITEBOARD"] = "WHITEBOARD";
    ActivitiesObjectType["CONTENT"] = "CONTENT";
    ActivitiesObjectType["COMMENT"] = "COMMENT";
    return ActivitiesObjectType;
}({});
const $61e4e33a86012bad$var$i18n = (0, $aXWIB.defineMessages)({
    untitled: {
        id: "home.views.untitled",
        defaultMessage: "Untitled"
    }
});
const $61e4e33a86012bad$export$232e7dd3cd551a33 = $61e4e33a86012bad$var$i18n.untitled;
const $61e4e33a86012bad$export$2786ecc2e2951fe3 = (networkStatus)=>{
    if (networkStatus === (0, $5T18X.NetworkStatus).loading || networkStatus === (0, $5T18X.NetworkStatus).setVariables) return 1;
    if (networkStatus === (0, $5T18X.NetworkStatus).fetchMore) return 2;
    return 0;
};
function $61e4e33a86012bad$export$b29ea735dcfba3c1(value) {
    return value !== null && value !== undefined;
}
const $61e4e33a86012bad$export$4b0a6c95b9c45006 = (textFilter, title)=>{
    const trimmedTextFilter = textFilter.trim();
    if (trimmedTextFilter === '') return true;
    return (title || '').toUpperCase().indexOf(textFilter.toUpperCase()) > -1;
};
const $61e4e33a86012bad$export$c29c1699278467fe = (recent, isActivityV3HomeRecent)=>{
    if (recent?.object?.data?.commentId) {
        recent.event.eventType = 'commented';
        recent.object.data = recent?.object?.data?.container;
    }
    const content = recent?.object?.data;
    if (isActivityV3HomeRecent) {
        if (content) {
            content.type = content.type?.toLowerCase();
            if (content.type === 'blog_post') content.type = 'blogpost';
            content.subtype = content.subtype?.toLowerCase();
            // The "status" field is ConfluencePage/ConfluenceBlogPost type for pages/blogs but is
            // ConfluenceContentStatus type for all other content types. To prevent the GraphQL
            // "returns different types" error, we are using the aliases "pageStatus" and "blogStatus"
            content.status = [
                content.status,
                content.pageStatus,
                content.blogStatus
            ].find((status)=>status)?.toLowerCase();
            // FE workaround for activity query returning "status: DRAFT" for published content with unpublished changes
            if (content.status === 'draft' && content.createdAt) content.status = 'current';
        }
        recent.event.eventType = recent.event?.eventType.toUpperCase();
    }
    return recent;
};
const $61e4e33a86012bad$export$7105b33a95adadcf = (content)=>{
    return content?.status !== 'archived';
};
const $61e4e33a86012bad$export$d54a312242c6a930 = (content)=>{
    return content?.status !== 'trashed';
};
const $61e4e33a86012bad$export$78ba6bbd8fcbc43f = (userId, content)=>{
    const createdBy = content?.status === 'draft' ? content?.version?.by : content?.history?.createdBy;
    return userId === createdBy?.accountId;
};
module.exports["LoadingState"] = $61e4e33a86012bad$export$62aa48085237e36f;
module.exports["HomeViewFilters"] = $61e4e33a86012bad$export$f5dd0176116f8854;
module.exports["ActivityEventType"] = $61e4e33a86012bad$export$132f858337fea016;
module.exports["ActivitiesObjectType"] = $61e4e33a86012bad$export$4edf00fad4b97379;
module.exports["untitled"] = $61e4e33a86012bad$export$232e7dd3cd551a33;
module.exports["getLoadingState"] = $61e4e33a86012bad$export$2786ecc2e2951fe3;
module.exports["notEmpty"] = $61e4e33a86012bad$export$b29ea735dcfba3c1;
module.exports["byTitle"] = $61e4e33a86012bad$export$4b0a6c95b9c45006;
module.exports["transformActivityData"] = $61e4e33a86012bad$export$c29c1699278467fe;
module.exports["notArchived"] = $61e4e33a86012bad$export$7105b33a95adadcf;
module.exports["notDeleted"] = $61e4e33a86012bad$export$d54a312242c6a930;
module.exports["isCreatorCurrentUser"] = $61e4e33a86012bad$export$78ba6bbd8fcbc43f;

});

parcelRegister("2HmqS", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $1f70ff8c8e4a6ab6$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    resultLastModifiedContent: {
        id: "entity-view.content.lastmodified",
        defaultMessage: "Updated"
    },
    resultLastModifiedAttachment: {
        id: "entity-view.attachment.lastmodified",
        defaultMessage: "Uploaded"
    },
    contentDraft: {
        id: "entity-view.content.draft",
        defaultMessage: "Draft"
    },
    contentArchived: {
        id: "entity-view.content.archived",
        defaultMessage: "Archived"
    },
    contentUnpublished: {
        id: "entity-view.content.unpublishes",
        defaultMessage: "Unpublished changes"
    },
    contentUntitled: {
        id: "entity-view.content.untitled",
        defaultMessage: "Untitled"
    },
    spaceArchived: {
        id: "entity-view.content.spaceArchived",
        defaultMessage: "archived"
    },
    spaceStarred: {
        id: "entity-view.content.spaceStarred",
        defaultMessage: "starred"
    },
    contentScheduled: {
        id: "entity-view.content.scheduled",
        defaultMessage: "Publish scheduled"
    }
});
module.exports["i18n"] = $1f70ff8c8e4a6ab6$export$a7357cdd1f0b0168;

});

parcelRegister("aqBZ0", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $1f65bcd6ebccf55c$export$41b2e06f27dfe96e = 'archived';
const $1f65bcd6ebccf55c$export$e2153f1ee0381860 = 'ARCHIVE_';
const $1f65bcd6ebccf55c$export$c8e98879124fb1f0 = 'UNARCHIVE_';
const $1f65bcd6ebccf55c$export$781b73bccf46ba2c = 255;
const $1f65bcd6ebccf55c$export$ab874a69c0b17d25 = 500;
var $1f65bcd6ebccf55c$export$ca079fdb822b790f = /*#__PURE__*/ function(ArchiveStatus) {
    ArchiveStatus["LOADING"] = "loading";
    ArchiveStatus["ERROR"] = "error";
    ArchiveStatus["SUCCESS"] = "success";
    return ArchiveStatus;
}({});
const $1f65bcd6ebccf55c$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $1f65bcd6ebccf55c$export$a2742df05b19b873 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
const $1f65bcd6ebccf55c$export$9de02bef22980fc = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
const $1f65bcd6ebccf55c$export$45c8fb669461b6d5 = 'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';
const $1f65bcd6ebccf55c$export$f71e45bebd610efa = 'archivedPageBanner';
const $1f65bcd6ebccf55c$export$7d669dd29a0917b2 = 'archive-page-banner-restore-link';
const $1f65bcd6ebccf55c$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    restoreLinkMessage: {
        id: "archive-pages.page-banner.link.unarchive",
        defaultMessage: "Restore"
    },
    learnMoreLinkMessage: {
        id: "archive-pages.page-banner.link.learn-more",
        defaultMessage: "Learn more"
    },
    hasRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-restorable",
        defaultMessage: "This content is archived. Restore to make changes."
    },
    noRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-unrestorable",
        defaultMessage: "This content is archived."
    }
});
module.exports["CONTENT_STATUS_ARCHIVED"] = $1f65bcd6ebccf55c$export$41b2e06f27dfe96e;
module.exports["ARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$e2153f1ee0381860;
module.exports["UNARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$c8e98879124fb1f0;
module.exports["ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT"] = $1f65bcd6ebccf55c$export$781b73bccf46ba2c;
module.exports["BULK_ARCHIVE_PAGE_SELECTION_LIMIT"] = $1f65bcd6ebccf55c$export$ab874a69c0b17d25;
module.exports["ArchiveStatus"] = $1f65bcd6ebccf55c$export$ca079fdb822b790f;
module.exports["PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$a2742df05b19b873;
module.exports["ARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$9de02bef22980fc;
module.exports["UNARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$45c8fb669461b6d5;
module.exports["ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE"] = $1f65bcd6ebccf55c$export$f71e45bebd610efa;
module.exports["ARCHIVED_PAGE_BANNER_RESTORE_LINK_TESTID"] = $1f65bcd6ebccf55c$export$7d669dd29a0917b2;
module.exports["i18n"] = $1f65bcd6ebccf55c$export$a7357cdd1f0b0168;

});

parcelRegister("brn6e", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $7PLO8 = parcelRequire("7PLO8");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $3shHM = parcelRequire("3shHM");


var $8rneB = parcelRequire("8rneB");


var $5DJsZ = parcelRequire("5DJsZ");


var $5amrO = parcelRequire("5amrO");

const $a7a7184e7345058e$export$8807f1cb55bf77de = async ({ userId: userId, cloudId: cloudId, emojiId: emojiId })=>{
    const provider = await (0, $8rneB.getEmojiProvider)(cloudId, userId);
    if (provider) {
        const emoji = await provider.findById(emojiId);
        if (emoji) return provider.loadMediaEmoji(emoji);
    }
    return Promise.resolve(null);
};
const $a7a7184e7345058e$export$66e71aac8865f81a = /([a-z\d_-]+):/;
let $a7a7184e7345058e$var$hasSetFavicon = false;
let $a7a7184e7345058e$var$previousFavicon = null;
const $a7a7184e7345058e$var$updateFaviconHref = (href)=>{
    const favIcons = document.querySelectorAll("link[rel~='icon']");
    favIcons.forEach((linkEl)=>{
        // remember default favicon on first change in case we need to revert
        if (!$a7a7184e7345058e$var$hasSetFavicon) {
            $a7a7184e7345058e$var$previousFavicon = linkEl.href;
            $a7a7184e7345058e$var$hasSetFavicon = true;
        }
        linkEl.href = href;
    });
};
const $a7a7184e7345058e$export$4bb2c221b7e4cc0 = (emoji)=>{
    if (!(0, $dh538.fg)('confluence_emoji_title_favicon')) return;
    if (!emoji) {
        if ($a7a7184e7345058e$var$hasSetFavicon && $a7a7184e7345058e$var$previousFavicon) $a7a7184e7345058e$var$updateFaviconHref($a7a7184e7345058e$var$previousFavicon);
        return;
    }
    $a7a7184e7345058e$var$updateFaviconHref(emoji);
};
const $a7a7184e7345058e$export$ea48fb6f63107646 = async ({ selectedEmoji: selectedEmoji, emojiProvider: emojiProvider, onUpdateStartEmoji: onUpdateStartEmoji, createAnalyticsEvent: createAnalyticsEvent, emojiTitleState: emojiTitleState, onEmojiUpdated: onEmojiUpdated, onUpdateEndEmoji: onUpdateEndEmoji, updateContentProperty: updateContentProperty, contentId: contentId, componentName: componentName, isLivePage: isLivePage, emojiStatusFieldName: emojiStatusFieldName, aiSuggestedEmojiId: aiSuggestedEmojiId, isSmartCreate: isSmartCreate, hasReplacedAIFCEmoji: hasReplacedAIFCEmoji, setHasReplacedAIFCEmoji: setHasReplacedAIFCEmoji }, _event)=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    // Snapshot before overwrite to detect if the AIFC-suggested emoji was replaced.
    const previouslySelectedEmoji = emojiTitleState.state.selectedEmoji;
    const previouslySelectedEmojiId = typeof previouslySelectedEmoji === 'string' ? previouslySelectedEmoji : previouslySelectedEmoji?.id;
    const replacedAIFCSuggestedEmoji = !hasReplacedAIFCEmoji && !!isSmartCreate && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedAIFCSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    (0, $3shHM.sendAnalyticsEvent)(createAnalyticsEvent, {
        eventType: 'sendUIEvent',
        element: 'button',
        action: 'clicked',
        actionSubject: 'emojiPicker',
        actionSubjectId: 'emoji',
        attributes: {
            emojiId: selectedEmoji?.id,
            inputMethod: 'title',
            isLivePage: isLivePage,
            replacedAIFCSuggestedEmoji: replacedAIFCSuggestedEmoji
        }
    });
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    const loadedEmoji = await emojiProvider.loadMediaEmoji(selectedEmoji, true);
    emojiTitleState.setOpenSecondEmojiPicker(false);
    emojiTitleState.setSelectedEmoji(loadedEmoji);
    return onEmojiUpdated().then(({ data: data })=>{
        const versionNumber = (0, $8rneB.getVersionNumber)(data, emojiStatusFieldName);
        const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
        const emojiValue = selectedEmoji?.id?.replace(/['"]+/g, '') ?? '';
        return updateContentProperty({
            propertyKey: propertyKey,
            propertyValue: emojiValue,
            hasExistingProperty: versionNumber > 0,
            options: {
                update: ()=>{
                    try {
                        const cacheData = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            __callerPackage__: "@confluence/emoji-title"
                        });
                        if (cacheData.content.nodes[0][emojiStatusFieldName]) cacheData.content.nodes[0][emojiStatusFieldName].nodes[0] = {
                            ...cacheData.content.nodes[0][emojiStatusFieldName].nodes[0],
                            id: contentId,
                            key: propertyKey,
                            value: emojiValue,
                            version: {
                                number: newVersionNumber,
                                __typename: 'Version'
                            }
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data,
                            __callerPackage__: "@confluence/emoji-title"
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating ${propertyKey} content property after user selecting emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).then(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
            emojiTitleState.setSelectedEmoji(loadedEmoji);
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user selecting emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$fbfb144f0da80edc = (_event, { onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, onEmojiUpdated: onEmojiUpdated, contentId: contentId, updateContentProperty: updateContentProperty, componentName: componentName = '', emojiStatusFieldName: emojiStatusFieldName })=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    return onEmojiUpdated().then(()=>{
        return updateContentProperty({
            propertyKey: propertyKey,
            isDelete: true,
            options: {
                update: ()=>{
                    try {
                        const data = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            __callerPackage__: "@confluence/emoji-title"
                        });
                        data.content.nodes[0][emojiStatusFieldName] = {
                            nodes: [],
                            __typename: 'PaginatedJsonContentPropertyList'
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data,
                            __callerPackage__: "@confluence/emoji-title"
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating content property after user removing emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).finally(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user removing emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$8c0236acf4c550c0 = RegExp("^(\\p{RI}\\p{RI}|\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?(\\u{200D}\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?)*)", "u");
const $a7a7184e7345058e$export$cb9bb843138d9261 = (title)=>title && title.replace($a7a7184e7345058e$export$8c0236acf4c550c0, '').trimLeft() || '';
const $a7a7184e7345058e$export$9d1875ac2476f6b6 = (title)=>title && $a7a7184e7345058e$export$8c0236acf4c550c0.exec(title)?.[0] || '';
const $a7a7184e7345058e$export$388f90f8e727e4d5 = (rawTitle = '', rawPublishedEmoji = '', rawDraftEmoji = '', status = '', untitledDraftText = '', getEmoji = true)=>{
    const nativeEmoji = getEmoji ? $a7a7184e7345058e$export$9d1875ac2476f6b6(rawTitle) : '';
    let selectedEmoji = '';
    if (getEmoji) selectedEmoji = status?.toLowerCase() === 'draft' ? rawDraftEmoji : rawPublishedEmoji;
    const hasNativeEmoji = nativeEmoji.length > 0;
    const hasSelectedEmoji = selectedEmoji.length > 0;
    const emoji = hasSelectedEmoji ? selectedEmoji : nativeEmoji;
    let text = hasNativeEmoji && !hasSelectedEmoji ? $a7a7184e7345058e$export$cb9bb843138d9261(rawTitle) : rawTitle;
    if (status === 'draft' && !text) text = untitledDraftText;
    return {
        text: text,
        emoji: emoji,
        selectedEmoji: selectedEmoji
    };
};
module.exports["getEmojiFromEmojiId"] = $a7a7184e7345058e$export$8807f1cb55bf77de;
module.exports["maybeOverrideFaviconWithEmoji"] = $a7a7184e7345058e$export$4bb2c221b7e4cc0;
module.exports["onSelectEmoji"] = $a7a7184e7345058e$export$ea48fb6f63107646;
module.exports["onRemoveEmoji"] = $a7a7184e7345058e$export$fbfb144f0da80edc;
module.exports["emojiExp"] = $a7a7184e7345058e$export$8c0236acf4c550c0;
module.exports["removeEmojiFromTitle"] = $a7a7184e7345058e$export$cb9bb843138d9261;
module.exports["getEmojiFromTitle"] = $a7a7184e7345058e$export$9d1875ac2476f6b6;
module.exports["getTitleAndEmoji"] = $a7a7184e7345058e$export$388f90f8e727e4d5;

});

parcelRegister("7PLO8", function(module, exports) {
const $3009aa09d1bfedbe$export$93a0fdadbf6c055a = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};
module.exports["getDraftShareIdFromQueryParam"] = $3009aa09d1bfedbe$export$93a0fdadbf6c055a;

});

parcelRegister("3shHM", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $8rneB = parcelRequire("8rneB");


var $5amrO = parcelRequire("5amrO");


var $5DJsZ = parcelRequire("5DJsZ");

const $d6c558249b167bda$export$5e53520e517ec9ab = (createAnalyticsEvent, { eventType: eventType, element: element, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
    createAnalyticsEvent({
        type: eventType,
        data: {
            action: action,
            source: 'EmojiTitleSection',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                element: element,
                ...attributes
            }
        }
    }).fire();
};
const $d6c558249b167bda$export$1fa99c5c7c4cc530 = async ({ createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isLivePage: isLivePage })=>{
    const { data: data } = await (0, $c0rhi.queryInterop)({
        query: (0, $5DJsZ.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false
        },
        __callerPackage__: "@confluence/emoji-title"
    });
    const emojiId = (0, $8rneB.getEmojiId)(data, (0, $5amrO.EMOJI_TITLE_DRAFT_FIELD));
    const hasDraftEmoji = emojiId.length >= 0 && emojiId !== '';
    // only track draft with emoji
    if (hasDraftEmoji) $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: '',
        action: 'created',
        actionSubject: 'draftWithEmoji',
        actionSubjectId: '',
        attributes: {
            emojiId: emojiId,
            isLivePage: isLivePage
        }
    });
};
const $d6c558249b167bda$export$5a8401d422e6e576 = ({ createAnalyticsEvent: createAnalyticsEvent, emoji: emoji, context: context, error: error = {
    message: ''
}, isLivePage: isLivePage })=>{
    $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: 'emoji',
        action: 'error',
        actionSubject: 'renderEmoji',
        actionSubjectId: 'renderEmojiError',
        attributes: {
            emojiShortName: emoji && emoji.shortName,
            emojiId: emoji && emoji.id,
            context: context,
            errorMessage: error.message,
            isLivePage: isLivePage
        }
    });
};
module.exports["sendAnalyticsEvent"] = $d6c558249b167bda$export$5e53520e517ec9ab;
module.exports["trackDraftCreatedWithEmoji"] = $d6c558249b167bda$export$1fa99c5c7c4cc530;
module.exports["onFailedToLoadEmoji"] = $d6c558249b167bda$export$5a8401d422e6e576;

});

parcelRegister("5DJsZ", function(module, exports) {
/**
 * @generated SignedSource<<26dbb45846c41499d3735f0e079c26cb>>
 * @relayHash 736318216100158fedfd1efdb0277723
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6
const $4dc353069380bea7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipPublishedFragment"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v4 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "condition": "skipPublishedFragment",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "emojiTitlePublished",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "emoji-title-published"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "properties(key:\"emoji-title-published\")"
                                }
                            ]
                        },
                        {
                            "alias": "emojiTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-title-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v5 /*: any*/ ,
                            "storageKey": "properties(key:\"emoji-title-draft\")"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PublishedContentProperties",
                                    "kind": "LinkedField",
                                    "name": "latest",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "defaultTitleEmoji"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "736318216100158fedfd1efdb0277723",
            "id": "ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6",
            "metadata": {},
            "name": "EmojiTitleQuery",
            "operationKind": "query",
            "text": "query EmojiTitleQuery($contentId:ID,$status:[String],$draftShareId:String,$skipPublishedFragment:Boolean!){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,emojiTitlePublished:properties(key:\"emoji-title-published\")@skip(if:$skipPublishedFragment){nodes{id,key,value,version{number}}},emojiTitleDraft:properties(key:\"emoji-title-draft\"){nodes{id,key,value,version{number}}},contentProperties{latest{defaultTitleEmoji}}}}}"
        }
    };
}();
$4dc353069380bea7$var$node.hash = "c3af19fccb4a5096e4bb34c9aa198098";
var $4dc353069380bea7$export$2e2bcd8739ae039 = $4dc353069380bea7$var$node;
module.exports["default"] = $4dc353069380bea7$export$2e2bcd8739ae039;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("a9SJx", function(module, exports) {
module.exports = new URL("RecentEmptyStateDark.f3f34e0a.svg", import.meta.url).toString();

});

parcelRegister("8Phdh", function(module, exports) {
module.exports = new URL("RecentEmptyStateLight.623e8d6d.svg", import.meta.url).toString();

});

parcelRegister("y9T5W", function(module, exports) {
const $c2f13451050bd3c6$export$a1180afea81894e6 = 6;
module.exports["ALL_RECENT_ITEMS_COUNT_HOME_REFRESH"] = $c2f13451050bd3c6$export$a1180afea81894e6;

});

parcelRegister("2fgSf", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $e7508444bbfb347b$export$69ed422375389c7 = ()=>{
    if ((0, $6mKj3.expValEquals)('cc_migrate_activity_v3_recents_queries_to_agg', 'isEnabled', true)) return true;
    // We are migrating Activity V3 queries for custom domain tenants earlier due to a cc-graphql bug
    const isDefaultDomain = window.location.hostname.endsWith('.atlassian.net') || window.location.hostname.endsWith('.jira-dev.com');
    return !isDefaultDomain;
};
module.exports["shouldUseAGGActivityV3"] = $e7508444bbfb347b$export$69ed422375389c7;

});

parcelRegister("2Ujef", function(module, exports) {
/**
 * @generated SignedSource<<4ea7984ee8e2180b4d1f3235e3ffd6da>>
 * @relayHash 29c4cb130b82621c8ae64d700e35e867
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0f8088baf02eccbefe567796b693e824d4a461ef0707b0e60aa6a11c98152551
const $451651b37d1d3ba3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "objectTypes"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "objectTypes",
                            "variableName": "objectTypes"
                        },
                        {
                            "kind": "Literal",
                            "name": "products",
                            "value": [
                                "CONFLUENCE"
                            ]
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "arguments"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "rootContainerIds.0",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "rootContainerIds"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "AND"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "title"
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v10 = {
        "kind": "ScalarField",
        "name": "webUi"
    }, v11 = [
        v10 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "editUi"
        }
    ], v12 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v13 = {
        "concreteType": "ConfluenceContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ConfluenceContentTitleEmoji",
                "kind": "LinkedField",
                "name": "titleEmojiDraft",
                "plural": false,
                "selections": v12 /*: any*/ 
            },
            {
                "concreteType": "ConfluenceContentTitleEmoji",
                "kind": "LinkedField",
                "name": "titleEmojiPublished",
                "plural": false,
                "selections": v12 /*: any*/ 
            }
        ]
    }, v14 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "subtype"
            },
            {
                "alias": "pageStatus",
                "kind": "ScalarField",
                "name": "status"
            },
            v9 /*: any*/ ,
            {
                "concreteType": "ConfluencePageLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v11 /*: any*/ 
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ],
        "type": "ConfluencePage"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            {
                "alias": "blogStatus",
                "kind": "ScalarField",
                "name": "status"
            },
            v9 /*: any*/ ,
            {
                "concreteType": "ConfluenceBlogPostLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v11 /*: any*/ 
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ],
        "type": "ConfluenceBlogPost"
    }, v17 = {
        "kind": "ScalarField",
        "name": "status"
    }, v18 = [
        v10 /*: any*/ 
    ], v19 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v17 /*: any*/ ,
            {
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v18 /*: any*/ 
            },
            v14 /*: any*/ 
        ],
        "type": "ConfluenceWhiteboard"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v17 /*: any*/ ,
            {
                "concreteType": "ConfluenceDatabaseLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v18 /*: any*/ 
            },
            v14 /*: any*/ 
        ],
        "type": "ConfluenceDatabase"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v17 /*: any*/ ,
            {
                "concreteType": "ConfluenceSlideLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v18 /*: any*/ 
            },
            v14 /*: any*/ 
        ],
        "type": "ConfluenceSlide"
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v17 /*: any*/ ,
            {
                "concreteType": "ConfluenceEmbedLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v18 /*: any*/ 
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ],
        "type": "ConfluenceEmbed"
    }, v23 = {
        "concreteType": "ActivityEvent",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "timestamp"
            },
            {
                "kind": "ScalarField",
                "name": "eventType"
            }
        ]
    }, v24 = [
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HomeRecentWorkQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MyActivity",
                            "kind": "LinkedField",
                            "name": "myActivity",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "all",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityObject",
                                                            "kind": "LinkedField",
                                                            "name": "object",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v19 /*: any*/ ,
                                                                        v20 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v23 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "HomeRecentWorkQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MyActivity",
                            "kind": "LinkedField",
                            "name": "myActivity",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "all",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityObject",
                                                            "kind": "LinkedField",
                                                            "name": "object",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "__typename"
                                                                        },
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v19 /*: any*/ ,
                                                                        v20 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v24 /*: any*/ ,
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v24 /*: any*/ ,
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v24 /*: any*/ ,
                                                                            "type": "MercuryPortfolio"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v23 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "29c4cb130b82621c8ae64d700e35e867",
            "id": "0f8088baf02eccbefe567796b693e824d4a461ef0707b0e60aa6a11c98152551",
            "metadata": {},
            "name": "HomeRecentWorkQuery",
            "operationKind": "query",
            "text": "query HomeRecentWorkQuery($cloudId:ID!,$first:Int,$after:String,$objectTypes:[String!]){activity{myActivity{all(filter:{type:AND,rootContainerIds:[$cloudId],arguments:{products:[\"CONFLUENCE\"],objectTypes:$objectTypes}},first:$first,after:$after){edges{cursor,node{id,object{id,data{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},metadata{titleEmojiDraft{value},titleEmojiPublished{value}},space{alias,id,key,name}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,createdAt,links{webUi,editUi},metadata{titleEmojiDraft{value},titleEmojiPublished{value}},space{alias,id,key,name}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},space{alias,id,key,name}},...on ConfluenceDatabase{id,title,type,status,links{webUi},space{alias,id,key,name}},...on ConfluenceSlide{id,title,type,status,links{webUi},space{alias,id,key,name}},...on ConfluenceEmbed{id,title,type,status,links{webUi},metadata{titleEmojiDraft{value},titleEmojiPublished{value}},space{alias,id,key,name}},...on Node{__isNode:__typename,id},...on DevOpsPullRequestDetails{id},...on MercuryPortfolio{id}}},event{id,timestamp,eventType}}}}}}}"
        }
    };
}();
$451651b37d1d3ba3$var$node.hash = "a45e25c98c3a3864ddaee2dc7df8090c";
var $451651b37d1d3ba3$export$2e2bcd8739ae039 = $451651b37d1d3ba3$var$node;
module.exports["default"] = $451651b37d1d3ba3$export$2e2bcd8739ae039;

});

parcelRegister("a67vB", function(module, exports) {

var $d4Pk4 = parcelRequire("d4Pk4");


var $ctLrB = parcelRequire("ctLrB");


var $MTTRf = parcelRequire("MTTRf");

const $4b2ee2ac7b774614$export$154132902c275093 = ({ cloudId: cloudId, isLoggedIn: isLoggedIn, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false, isSlidesEnabled: isSlidesEnabled = false, first: first = 10 })=>({
        query: (0, $MTTRf.HomeRecentWorkQuery),
        variables: {
            cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            first: first,
            after: '',
            objectTypes: [
                (0, $ctLrB.ActivitiesObjectType).PAGE,
                (0, $ctLrB.ActivitiesObjectType).BLOGPOST,
                (0, $ctLrB.ActivitiesObjectType).EMBED,
                (0, $ctLrB.ActivitiesObjectType).CONTENT,
                ...isWhiteboardViewedEnabled ? [
                    (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                ] : [],
                ...isDatabaseEnabled ? [
                    (0, $ctLrB.ActivitiesObjectType).DATABASE
                ] : [],
                ...isSlidesEnabled ? [
                    (0, $ctLrB.ActivitiesObjectType).SLIDE
                ] : []
            ]
        },
        skip: !isLoggedIn
    });
module.exports["getRecentWorkQueryOptions"] = $4b2ee2ac7b774614$export$154132902c275093;

});

parcelRegister("d4Pk4", function(module, exports) {

var $94jtO = parcelRequire("94jtO");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/platform/site/manifest.ts
var $985375b928439e07$var$platformSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $94jtO.PlatformSiteAriResourceOwner),
    resourceType: (0, $94jtO.PlatformSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/platform/site/index.ts
var $985375b928439e07$export$62388e9e87e2e1c9 = class _PlatformSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $985375b928439e07$var$platformSiteAriStaticOpts.qualifier,
            platformQualifier: $985375b928439e07$var$platformSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $985375b928439e07$var$platformSiteAriStaticOpts.resourceOwner,
            resourceType: $985375b928439e07$var$platformSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $985375b928439e07$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $985375b928439e07$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["PlatformSiteAri"] = $985375b928439e07$export$62388e9e87e2e1c9;

});

parcelRegister("94jtO", function(module, exports) {
// src/platform/site/types.ts
var $69a39916eb9c41be$export$2866935ccba4694c = "platform", $69a39916eb9c41be$export$c9ae8b227ea4b550 = "site";
module.exports["PlatformSiteAriResourceOwner"] = $69a39916eb9c41be$export$2866935ccba4694c;
module.exports["PlatformSiteAriResourceType"] = $69a39916eb9c41be$export$c9ae8b227ea4b550;

});

parcelRegister("MTTRf", function(module, exports) {

var $2Ujef = parcelRequire("2Ujef");

const $fed37ec4c6d5a8b4$export$93fc89076fcc0c52 = (0, $2Ujef.default);
module.exports["HomeRecentWorkQuery"] = $fed37ec4c6d5a8b4$export$93fc89076fcc0c52;

});

parcelRegister("eZsGI", function(module, exports) {
module.exports = new URL("SearchErrorImage.5b33bcd4.svg", import.meta.url).toString();

});

parcelRegister("7hGsm", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $54db0de22feedc16$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("2UWw0")));

var $hXuPC = parcelRequire("hXuPC");


var $iIf3l = parcelRequire("iIf3l");


var $a5jIU = parcelRequire("a5jIU");


var $fkDf0 = parcelRequire("fkDf0");


var $6yHbi = parcelRequire("6yHbi");


var $2UWw0 = parcelRequire("2UWw0");

var $54db0de22feedc16$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $54db0de22feedc16$var$_window = (0, $fkDf0.getGlobalObject)();
if ($54db0de22feedc16$var$_window.Sentry && $54db0de22feedc16$var$_window.Sentry.Integrations) $54db0de22feedc16$var$windowIntegrations = $54db0de22feedc16$var$_window.Sentry.Integrations;
var $54db0de22feedc16$export$99d02219d259eb94 = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $54db0de22feedc16$var$windowIntegrations), (0, $a5jIU)), $6yHbi);
$parcel$exportWildcard(module.exports, $iIf3l);

});

parcelRegister("iIf3l", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("cs0rL")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("euURg")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("805AA")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("805AA")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("805AA")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("805AA")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("805AA")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("k3i2h")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("k3i2h")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("k3i2h")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("k3i2h")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("euURg")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("cSJat")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("805AA")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("cTFwF")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("805AA")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("805AA")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("805AA")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("805AA")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("805AA")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("805AA")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("805AA")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("cW7ac")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("1cvC0")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("a7P2i")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("a7P2i")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("ffG6S")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("ffG6S")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("ffG6S")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("ffG6S")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("ffG6S")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("ffG6S")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("ffG6S")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("ffG6S")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("ffG6S")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("brq4Q")).SDK_NAME);

var $cs0rL = parcelRequire("cs0rL");


var $805AA = parcelRequire("805AA");

var $euURg = parcelRequire("euURg");

var $k3i2h = parcelRequire("k3i2h");

var $cTFwF = parcelRequire("cTFwF");

var $cSJat = parcelRequire("cSJat");


var $cW7ac = parcelRequire("cW7ac");


var $1cvC0 = parcelRequire("1cvC0");


var $a7P2i = parcelRequire("a7P2i");


var $ffG6S = parcelRequire("ffG6S");


var $brq4Q = parcelRequire("brq4Q");


});

parcelRegister("brq4Q", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $854671b7fcc6622a$export$ca61d37259221480 = 'sentry.javascript.browser';
module.exports["SDK_NAME"] = $854671b7fcc6622a$export$ca61d37259221480;

});

parcelRegister("6yHbi", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("3BsQh")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("lIIKi")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bISXm")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("63fUW")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("eLUbA")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("fCIwr")).Dedupe);

var $3BsQh = parcelRequire("3BsQh");


var $lIIKi = parcelRequire("lIIKi");


var $bISXm = parcelRequire("bISXm");


var $63fUW = parcelRequire("63fUW");


var $eLUbA = parcelRequire("eLUbA");


var $fCIwr = parcelRequire("fCIwr");


});

parcelRegister("2UWw0", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("1l2dO")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("8LVWj")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("2yXKF")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hB2rb")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("lgAM0")).makeNewXHRTransport);

var $1l2dO = parcelRequire("1l2dO");


var $8LVWj = parcelRequire("8LVWj");


var $2yXKF = parcelRequire("2yXKF");


var $hB2rb = parcelRequire("hB2rb");


var $lgAM0 = parcelRequire("lgAM0");


});

parcelRegister("5qzNs", function(module, exports) {

var $5ukOg = parcelRequire("5ukOg");


var $ipwYn = parcelRequire("ipwYn");


var $5kt6R = parcelRequire("5kt6R");


var $f2rYC = parcelRequire("f2rYC");


var $gR42R = parcelRequire("gR42R");


var $5baaE = parcelRequire("5baaE");


var $5Nw7l = parcelRequire("5Nw7l");


var $jHiyU = parcelRequire("jHiyU");

/** Used to compose bitmasks for cloning. */ var $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG = 1, $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG = 2, $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $3f3b25eb0c07a9d2$var$omit = $5Nw7l(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $5ukOg(paths, function(path) {
        path = $f2rYC(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $gR42R(object, $jHiyU(object), result);
    if (isDeep) result = $ipwYn(result, $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG | $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG | $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG, $5baaE);
    var length = paths.length;
    while(length--)$5kt6R(result, paths[length]);
    return result;
});
module.exports = $3f3b25eb0c07a9d2$var$omit;

});

parcelRegister("ipwYn", function(module, exports) {

var $en5bh = parcelRequire("en5bh");


var $hLryH = parcelRequire("hLryH");


var $jykdj = parcelRequire("jykdj");


var $3g4Fn = parcelRequire("3g4Fn");


var $juOMD = parcelRequire("juOMD");


var $dYI4C = parcelRequire("dYI4C");


var $irmBX = parcelRequire("irmBX");


var $3qHtb = parcelRequire("3qHtb");


var $80RNM = parcelRequire("80RNM");


var $d5B92 = parcelRequire("d5B92");


var $jHiyU = parcelRequire("jHiyU");


var $1WABR = parcelRequire("1WABR");


var $1Z3rm = parcelRequire("1Z3rm");


var $ka5vO = parcelRequire("ka5vO");


var $8LtzT = parcelRequire("8LtzT");


var $fZxmY = parcelRequire("fZxmY");


var $cSA01 = parcelRequire("cSA01");


var $83PD5 = parcelRequire("83PD5");


var $lc9ud = parcelRequire("lc9ud");


var $6b9OI = parcelRequire("6b9OI");


var $d6TaN = parcelRequire("d6TaN");


var $jVTxf = parcelRequire("jVTxf");

/** Used to compose bitmasks for cloning. */ var $d674238523d4f2bb$var$CLONE_DEEP_FLAG = 1, $d674238523d4f2bb$var$CLONE_FLAT_FLAG = 2, $d674238523d4f2bb$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $d674238523d4f2bb$var$argsTag = '[object Arguments]', $d674238523d4f2bb$var$arrayTag = '[object Array]', $d674238523d4f2bb$var$boolTag = '[object Boolean]', $d674238523d4f2bb$var$dateTag = '[object Date]', $d674238523d4f2bb$var$errorTag = '[object Error]', $d674238523d4f2bb$var$funcTag = '[object Function]', $d674238523d4f2bb$var$genTag = '[object GeneratorFunction]', $d674238523d4f2bb$var$mapTag = '[object Map]', $d674238523d4f2bb$var$numberTag = '[object Number]', $d674238523d4f2bb$var$objectTag = '[object Object]', $d674238523d4f2bb$var$regexpTag = '[object RegExp]', $d674238523d4f2bb$var$setTag = '[object Set]', $d674238523d4f2bb$var$stringTag = '[object String]', $d674238523d4f2bb$var$symbolTag = '[object Symbol]', $d674238523d4f2bb$var$weakMapTag = '[object WeakMap]';
var $d674238523d4f2bb$var$arrayBufferTag = '[object ArrayBuffer]', $d674238523d4f2bb$var$dataViewTag = '[object DataView]', $d674238523d4f2bb$var$float32Tag = '[object Float32Array]', $d674238523d4f2bb$var$float64Tag = '[object Float64Array]', $d674238523d4f2bb$var$int8Tag = '[object Int8Array]', $d674238523d4f2bb$var$int16Tag = '[object Int16Array]', $d674238523d4f2bb$var$int32Tag = '[object Int32Array]', $d674238523d4f2bb$var$uint8Tag = '[object Uint8Array]', $d674238523d4f2bb$var$uint8ClampedTag = '[object Uint8ClampedArray]', $d674238523d4f2bb$var$uint16Tag = '[object Uint16Array]', $d674238523d4f2bb$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $d674238523d4f2bb$var$cloneableTags = {};
$d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$argsTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$arrayTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$arrayBufferTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$dataViewTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$boolTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$dateTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$float32Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$float64Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int8Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int16Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int32Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$mapTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$numberTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$objectTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$regexpTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$setTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$stringTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$symbolTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint8Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint8ClampedTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint16Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint32Tag] = true;
$d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$errorTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$funcTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $d674238523d4f2bb$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $d674238523d4f2bb$var$CLONE_DEEP_FLAG, isFlat = bitmask & $d674238523d4f2bb$var$CLONE_FLAT_FLAG, isFull = bitmask & $d674238523d4f2bb$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$lc9ud(value)) return value;
    var isArr = $fZxmY(value);
    if (isArr) {
        result = $1Z3rm(value);
        if (!isDeep) return $irmBX(value, result);
    } else {
        var tag = $1WABR(value), isFunc = tag == $d674238523d4f2bb$var$funcTag || tag == $d674238523d4f2bb$var$genTag;
        if ($cSA01(value)) return $dYI4C(value, isDeep);
        if (tag == $d674238523d4f2bb$var$objectTag || tag == $d674238523d4f2bb$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $8LtzT(value);
            if (!isDeep) return isFlat ? $80RNM(value, $juOMD(result, value)) : $3qHtb(value, $3g4Fn(result, value));
        } else {
            if (!$d674238523d4f2bb$var$cloneableTags[tag]) return object ? value : {};
            result = $ka5vO(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $en5bh);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($6b9OI(value)) value.forEach(function(subValue) {
        result.add($d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($83PD5(value)) value.forEach(function(subValue, key) {
        result.set(key, $d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $jHiyU : $d5B92 : isFlat ? $jVTxf : $d6TaN;
    var props = isArr ? undefined : keysFunc(value);
    $hLryH(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $jykdj(result, key, $d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $d674238523d4f2bb$var$baseClone;

});

parcelRegister("hLryH", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $ceec3402dc147ea9$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $ceec3402dc147ea9$var$arrayEach;

});

parcelRegister("3g4Fn", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $d6TaN = parcelRequire("d6TaN");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $25f67c63e240b594$var$baseAssign(object, source) {
    return object && $gR42R(source, $d6TaN(source), object);
}
module.exports = $25f67c63e240b594$var$baseAssign;

});

parcelRegister("juOMD", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jVTxf = parcelRequire("jVTxf");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $e318362ea5151771$var$baseAssignIn(object, source) {
    return object && $gR42R(source, $jVTxf(source), object);
}
module.exports = $e318362ea5151771$var$baseAssignIn;

});

parcelRegister("3qHtb", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jcne3 = parcelRequire("jcne3");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $27f584f8141687cb$var$copySymbols(source, object) {
    return $gR42R(source, $jcne3(source), object);
}
module.exports = $27f584f8141687cb$var$copySymbols;

});

parcelRegister("80RNM", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $75Obx = parcelRequire("75Obx");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $5d580ec319704467$var$copySymbolsIn(source, object) {
    return $gR42R(source, $75Obx(source), object);
}
module.exports = $5d580ec319704467$var$copySymbolsIn;

});

parcelRegister("1Z3rm", function(module, exports) {
/** Used for built-in method references. */ var $171e28212cd49be3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $171e28212cd49be3$var$hasOwnProperty = $171e28212cd49be3$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $171e28212cd49be3$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $171e28212cd49be3$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $171e28212cd49be3$var$initCloneArray;

});

parcelRegister("ka5vO", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");


var $43GUE = parcelRequire("43GUE");


var $62nGv = parcelRequire("62nGv");


var $eBmVy = parcelRequire("eBmVy");


var $jDkcM = parcelRequire("jDkcM");

/** `Object#toString` result references. */ var $ead9046a77579327$var$boolTag = '[object Boolean]', $ead9046a77579327$var$dateTag = '[object Date]', $ead9046a77579327$var$mapTag = '[object Map]', $ead9046a77579327$var$numberTag = '[object Number]', $ead9046a77579327$var$regexpTag = '[object RegExp]', $ead9046a77579327$var$setTag = '[object Set]', $ead9046a77579327$var$stringTag = '[object String]', $ead9046a77579327$var$symbolTag = '[object Symbol]';
var $ead9046a77579327$var$arrayBufferTag = '[object ArrayBuffer]', $ead9046a77579327$var$dataViewTag = '[object DataView]', $ead9046a77579327$var$float32Tag = '[object Float32Array]', $ead9046a77579327$var$float64Tag = '[object Float64Array]', $ead9046a77579327$var$int8Tag = '[object Int8Array]', $ead9046a77579327$var$int16Tag = '[object Int16Array]', $ead9046a77579327$var$int32Tag = '[object Int32Array]', $ead9046a77579327$var$uint8Tag = '[object Uint8Array]', $ead9046a77579327$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ead9046a77579327$var$uint16Tag = '[object Uint16Array]', $ead9046a77579327$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $ead9046a77579327$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $ead9046a77579327$var$arrayBufferTag:
            return $jZrbP(object);
        case $ead9046a77579327$var$boolTag:
        case $ead9046a77579327$var$dateTag:
            return new Ctor(+object);
        case $ead9046a77579327$var$dataViewTag:
            return $43GUE(object, isDeep);
        case $ead9046a77579327$var$float32Tag:
        case $ead9046a77579327$var$float64Tag:
        case $ead9046a77579327$var$int8Tag:
        case $ead9046a77579327$var$int16Tag:
        case $ead9046a77579327$var$int32Tag:
        case $ead9046a77579327$var$uint8Tag:
        case $ead9046a77579327$var$uint8ClampedTag:
        case $ead9046a77579327$var$uint16Tag:
        case $ead9046a77579327$var$uint32Tag:
            return $jDkcM(object, isDeep);
        case $ead9046a77579327$var$mapTag:
            return new Ctor;
        case $ead9046a77579327$var$numberTag:
        case $ead9046a77579327$var$stringTag:
            return new Ctor(object);
        case $ead9046a77579327$var$regexpTag:
            return $62nGv(object);
        case $ead9046a77579327$var$setTag:
            return new Ctor;
        case $ead9046a77579327$var$symbolTag:
            return $eBmVy(object);
    }
}
module.exports = $ead9046a77579327$var$initCloneByTag;

});

parcelRegister("43GUE", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $2f48bad00268e015$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $jZrbP(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $2f48bad00268e015$var$cloneDataView;

});

parcelRegister("62nGv", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $46554d38b2abfa6c$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $46554d38b2abfa6c$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $46554d38b2abfa6c$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $46554d38b2abfa6c$var$cloneRegExp;

});

parcelRegister("eBmVy", function(module, exports) {

var $agzqu = parcelRequire("agzqu");

/** Used to convert symbols to primitives and strings. */ var $aa164e47d9e5bdc6$var$symbolProto = $agzqu ? $agzqu.prototype : undefined, $aa164e47d9e5bdc6$var$symbolValueOf = $aa164e47d9e5bdc6$var$symbolProto ? $aa164e47d9e5bdc6$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $aa164e47d9e5bdc6$var$cloneSymbol(symbol) {
    return $aa164e47d9e5bdc6$var$symbolValueOf ? Object($aa164e47d9e5bdc6$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $aa164e47d9e5bdc6$var$cloneSymbol;

});

parcelRegister("83PD5", function(module, exports) {

var $3Ap6k = parcelRequire("3Ap6k");


var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $5de6a718766ecdb3$var$nodeIsMap = $cl53l && $cl53l.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $5de6a718766ecdb3$var$isMap = $5de6a718766ecdb3$var$nodeIsMap ? $dFnBO($5de6a718766ecdb3$var$nodeIsMap) : $3Ap6k;
module.exports = $5de6a718766ecdb3$var$isMap;

});

parcelRegister("3Ap6k", function(module, exports) {

var $1WABR = parcelRequire("1WABR");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $29c8346be35e214d$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $29c8346be35e214d$var$baseIsMap(value) {
    return $6eZU2(value) && $1WABR(value) == $29c8346be35e214d$var$mapTag;
}
module.exports = $29c8346be35e214d$var$baseIsMap;

});

parcelRegister("6b9OI", function(module, exports) {

var $sQE8x = parcelRequire("sQE8x");


var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $47fb629c5fa31bac$var$nodeIsSet = $cl53l && $cl53l.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $47fb629c5fa31bac$var$isSet = $47fb629c5fa31bac$var$nodeIsSet ? $dFnBO($47fb629c5fa31bac$var$nodeIsSet) : $sQE8x;
module.exports = $47fb629c5fa31bac$var$isSet;

});

parcelRegister("sQE8x", function(module, exports) {

var $1WABR = parcelRequire("1WABR");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $056b741c66fd28fb$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $056b741c66fd28fb$var$baseIsSet(value) {
    return $6eZU2(value) && $1WABR(value) == $056b741c66fd28fb$var$setTag;
}
module.exports = $056b741c66fd28fb$var$baseIsSet;

});

parcelRegister("5kt6R", function(module, exports) {

var $f2rYC = parcelRequire("f2rYC");


var $apAFY = parcelRequire("apAFY");


var $9rfkh = parcelRequire("9rfkh");


var $w287Y = parcelRequire("w287Y");

/** Used for built-in method references. */ var $3e1566926de40aab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3e1566926de40aab$var$hasOwnProperty = $3e1566926de40aab$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $3e1566926de40aab$var$baseUnset(object, path) {
    path = $f2rYC(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $w287Y(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$3e1566926de40aab$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $9rfkh(object, path);
    return obj == null || delete obj[$w287Y($apAFY(path))];
}
module.exports = $3e1566926de40aab$var$baseUnset;

});

parcelRegister("9rfkh", function(module, exports) {

var $aT80v = parcelRequire("aT80v");


var $3BqCC = parcelRequire("3BqCC");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $6df28623e183fd76$var$parent(object, path) {
    return path.length < 2 ? object : $aT80v(object, $3BqCC(path, 0, -1));
}
module.exports = $6df28623e183fd76$var$parent;

});

parcelRegister("5baaE", function(module, exports) {

var $gTZCn = parcelRequire("gTZCn");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $3c55de8c787dd7a6$var$customOmitClone(value) {
    return $gTZCn(value) ? undefined : value;
}
module.exports = $3c55de8c787dd7a6$var$customOmitClone;

});

parcelRegister("5Nw7l", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $iK2Oc = parcelRequire("iK2Oc");


var $gnVVm = parcelRequire("gnVVm");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $438a713c021efc47$var$flatRest(func) {
    return $gnVVm($iK2Oc(func, undefined, $5qOzM), func + '');
}
module.exports = $438a713c021efc47$var$flatRest;

});

parcelRegister("5qOzM", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $3f469ccb29f16086$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $8jC8i(array, 1) : [];
}
module.exports = $3f469ccb29f16086$var$flatten;

});

parcelRegister("8jC8i", function(module, exports) {

var $hwwIB = parcelRequire("hwwIB");


var $ifqdW = parcelRequire("ifqdW");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $60ddad71e9a2305d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $ifqdW);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $60ddad71e9a2305d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hwwIB(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $60ddad71e9a2305d$var$baseFlatten;

});

parcelRegister("ifqdW", function(module, exports) {

var $agzqu = parcelRequire("agzqu");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");

/** Built-in value references. */ var $d48df83729a0e096$var$spreadableSymbol = $agzqu ? $agzqu.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $d48df83729a0e096$var$isFlattenable(value) {
    return $fZxmY(value) || $dI6Ko(value) || !!($d48df83729a0e096$var$spreadableSymbol && value && value[$d48df83729a0e096$var$spreadableSymbol]);
}
module.exports = $d48df83729a0e096$var$isFlattenable;

});

parcelRegister("dYU3e", function(module, exports) {


var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $86okN = parcelRequire("86okN");


var $fEmGS = parcelRequire("fEmGS");


var $c0rhi = parcelRequire("c0rhi");


var $9wGTI = parcelRequire("9wGTI");


var $iffSy = parcelRequire("iffSy");




var $7Lnfv = parcelRequire("7Lnfv");



var $2GGOW = parcelRequire("2GGOW");


var $5oHEP = parcelRequire("5oHEP");


var $iYld5 = parcelRequire("iYld5");



var $gnyNQ = parcelRequire("gnyNQ");

const $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors = (result)=>{
    // Preloading is "fire and forget" operation on a client as well, so we can mute
    // some known errors, but we can't really do anything about them as they're not
    // make it to the Apollo cache anyway and therefore don't pop at where they can
    // be handled.
    const hasErrors = result?.errors?.length > 0;
    result?.errors?.forEach((error)=>{
        if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error) || (0, $iYld5.isNotFoundSpaceError)(error) || (0, $5oHEP.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    });
    return hasErrors;
};
function $48ba6fb41a85dc7e$export$2fa187e846a241c4({ query: _query, variables: variables, fetchPolicy: /**
   * How to preload with fresh data correctly.
   * In preloader: query with fetchPolicy: "network-only"
   */ fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'all', context: context, client: client = window.GLOBAL_APOLLO_CLIENT, __callerPackage__: __callerPackage__ }) {
    const query = (0, $86okN.toDocumentNode)(_query);
    const name = (0, $7Lnfv.getOperationName)(query);
    // Detect if this is an agg call by checking if the client is the AGG client
    // The AGG client is created with createWrappedFetch({ isForAggOnly: true })
    const isForAggOnly = client === window.GLOBAL_APOLLO_AGG_CLIENT || client?.__isAGGClient === true;
    let single;
    const queryContext = {
        single: single,
        ...context
    };
    // Only add atl-attribution header if AGG migration feature gate is enabled
    if ((0, $9wGTI.fg)('cc-agg-migration-use-agg-endpoint')) queryContext.headers = {
        ...context?.headers || {},
        ...(0, $gnyNQ.getAtlAttributionHeader)()
    };
    if (window.__SSR_REACT_STREAMING__) {
        queryContext.preload = true;
        queryContext.originalQuery = query;
    }
    return (0, $c0rhi.queryInterop)({
        query: _query,
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        context: queryContext,
        interopApolloAggClient: isForAggOnly,
        __callerPackage__: __callerPackage__
    }).then((result)=>{
        const errors = result.error?.graphQLErrors;
        const interopResult = {
            data: result.data,
            errors: errors
        };
        const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(interopResult);
        return {
            data: result.data ?? null,
            errors: errors,
            hasErrors: hasErrors
        };
    });
}
function $48ba6fb41a85dc7e$export$96f737ecfefc9918(options) {
    return $48ba6fb41a85dc7e$export$2fa187e846a241c4({
        ...options,
        query: options.query,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
function $48ba6fb41a85dc7e$export$eb834b3aa63d4199(options) {
    if ((0, $iffSy.isRelayEnabled)(options.__callerPackage__)) (0, $fEmGS.writeQueryInterop)({
        ...options,
        __callerPackage__: options.__callerPackage__
    });
    else {
        const client = options.client || window.GLOBAL_APOLLO_CLIENT;
        if (client) client.writeQuery({
            ...options,
            query: (0, $86okN.toDocumentNode)(options.query)
        });
    }
}
function $48ba6fb41a85dc7e$export$5e270d77b1b480de(options) {
    $48ba6fb41a85dc7e$export$eb834b3aa63d4199({
        ...options,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
module.exports["query"] = $48ba6fb41a85dc7e$export$2fa187e846a241c4;
module.exports["queryAgg"] = $48ba6fb41a85dc7e$export$96f737ecfefc9918;

});

parcelRegister("7Lnfv", function(module, exports) {
const $b5dd42974905c1cd$var$QUERY_NAME_MATCHER = /query\s+(\w+).*?\{/;
const $b5dd42974905c1cd$export$974b1060e58e0a3f = {
    data: null,
    hasErrors: false
};
function $b5dd42974905c1cd$var$isOperationDefinition(definition) {
    return definition.kind === 'OperationDefinition';
}
function $b5dd42974905c1cd$export$41bca9dc6871dd4e(query) {
    if (typeof query === 'string') {
        const match = query.match($b5dd42974905c1cd$var$QUERY_NAME_MATCHER);
        if (match) return match[1];
    } else // graphql-tag tagged AST:
    return (query.definitions || []).filter($b5dd42974905c1cd$var$isOperationDefinition).map((definition)=>definition.name).filter((name)=>name != null)[0]?.value;
    return undefined;
}
module.exports["getOperationName"] = $b5dd42974905c1cd$export$41bca9dc6871dd4e;

});

parcelRegister("2GGOW", function(module, exports) {
const $325950d02840df51$export$55152de1f925fd05 = (error)=>error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
module.exports["isUnauthorizedError"] = $325950d02840df51$export$55152de1f925fd05;

});

parcelRegister("5oHEP", function(module, exports) {
const $e2c1a953aef26c23$export$6ccdb59d3479f4f1 = (error)=>error?.extensions?.statusCode === 404;
module.exports["isNotFoundError"] = $e2c1a953aef26c23$export$6ccdb59d3479f4f1;

});

parcelRegister("iYld5", function(module, exports) {
const $0682584c931be143$export$bb4f02e6ef6f6e17 = (error)=>error?.message?.includes('Cannot find space');
module.exports["isNotFoundSpaceError"] = $0682584c931be143$export$bb4f02e6ef6f6e17;

});

parcelRegister("19w2x", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6ttbq = parcelRequire("6ttbq");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $hUAWL = parcelRequire("hUAWL");


var $2K5gO = parcelRequire("2K5gO");


var $4QtAs = parcelRequire("4QtAs");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $105205360274b3e9$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $105205360274b3e9$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $105205360274b3e9$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $105205360274b3e9$export$a300664a1a230956 = ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $42omo.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    const setTimeout = (0, $2K5gO.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $hUAWL.useRequestAnimationFrame)();
    (0, $4QtAs.useSnapshotBeforeUpdate)(()=>{
        if ((0, $6ttbq.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        if ((0, $6ttbq.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$105205360274b3e9$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $105205360274b3e9$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $105205360274b3e9$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $105205360274b3e9$export$a300664a1a230956;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("62guz", function(module, exports) {
$parcel$export(module.exports, "default", () => $464fb8f83176ac12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $464fb8f83176ac12$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $b5utg.default)(2, arguments);
    return (0, $egXhZ.default)(dateLeft).getTime() - (0, $egXhZ.default)(dateRight).getTime();
}

});

parcelRegister("iTcHJ", function(module, exports) {
/**
 * @generated SignedSource<<ad7f8916cadafdf5756ee8bd1ad40682>>
 * @relayHash 60dcb7a4a06a5eaa2ddb4f4df7437c8c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076
const $cd49b7baa8bd0c54$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "missingContentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "condition": "missingContentId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "atlas_doc_format",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "EmbeddedMediaToken",
                                                    "kind": "LinkedField",
                                                    "name": "mediaToken",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "token"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "60dcb7a4a06a5eaa2ddb4f4df7437c8c",
            "id": "da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076",
            "metadata": {},
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchMediaTokenQuery($contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$cd49b7baa8bd0c54$var$node.hash = "c53e0852d23c6b17549e89592c16b84c";
var $cd49b7baa8bd0c54$export$2e2bcd8739ae039 = $cd49b7baa8bd0c54$var$node;
module.exports["default"] = $cd49b7baa8bd0c54$export$2e2bcd8739ae039;

});

parcelRegister("6IsMq", function(module, exports) {
/**
 * @generated SignedSource<<782a202a95cb3894b03a17351d1d4a69>>
 * @relayHash b0b89409f45955f1d6631ca601f67f8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b
const $684f397ef7ad0ae2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueAri"
        },
        {
            "defaultValue": 65536,
            "kind": "LocalArgument",
            "name": "maxTokenLength"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "issueAri"
        }
    ], v2 = {
        "args": [
            {
                "kind": "Variable",
                "name": "maxTokenLength",
                "variableName": "maxTokenLength"
            }
        ],
        "concreteType": "JiraMediaReadToken",
        "kind": "LinkedField",
        "name": "mediaReadToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "clientId"
            },
            {
                "kind": "ScalarField",
                "name": "endpointUrl"
            },
            {
                "kind": "ScalarField",
                "name": "tokenLifespanInSeconds"
            },
            {
                "concreteType": "JiraMediaTokenWithFilesConnection",
                "kind": "LinkedField",
                "name": "tokensWithFiles",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraMediaTokenWithFilesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraMediaTokenWithFiles",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b0b89409f45955f1d6631ca601f67f8b",
            "id": "916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b",
            "metadata": {},
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchJiraMediaTokenQuery($issueAri:ID!,$maxTokenLength:Int=65536){jira{issueById(id:$issueAri){mediaReadToken(maxTokenLength:$maxTokenLength)@optIn(to:\"JiraMediaReadTokenInIssue\"){clientId,endpointUrl,tokenLifespanInSeconds,tokensWithFiles{edges{node{token}}}},id}}}"
        }
    };
}();
$684f397ef7ad0ae2$var$node.hash = "7036cf95096a08504e6375127746a507";
var $684f397ef7ad0ae2$export$2e2bcd8739ae039 = $684f397ef7ad0ae2$var$node;
module.exports["default"] = $684f397ef7ad0ae2$export$2e2bcd8739ae039;

});

parcelRegister("kt8c2", function(module, exports) {

var $9Bict = parcelRequire("9Bict");

const $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $f62061dbe92ec1bb$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE;
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $9Bict.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["default"] = $f62061dbe92ec1bb$export$2e2bcd8739ae039;

});

parcelRegister("9Bict", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $21987ac45ee5412e$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $21987ac45ee5412e$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$21987ac45ee5412e$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $21987ac45ee5412e$export$efebfe7859cae3c7;

});

parcelRegister("k2in1", function(module, exports) {
const $70107457754d8ab2$var$MAX_RETRY_DELAY = 30000;
const $70107457754d8ab2$var$parseRetryAfter = (retryAfter)=>{
    // retryAfter can either be in seconds or HTTP date
    const parsedRetryAfter = parseInt(retryAfter, 10);
    if (!isNaN(parsedRetryAfter) && parsedRetryAfter > 0) return parsedRetryAfter * 1000;
    const retryDate = new Date(retryAfter);
    if (isNaN(retryDate.getTime())) return undefined;
    const delayFromDate = retryDate.getTime() - Date.now();
    if (delayFromDate > 0) return delayFromDate;
    return undefined;
};
const $70107457754d8ab2$export$cffaac380b94df26 = async (url, options, retriesRemaining = 3, delay = 1000)=>{
    const response = await fetch(url, options);
    const shouldRetry = !response.ok && response.status === 429 && retriesRemaining > 1;
    if (!shouldRetry) return response;
    const retryAfter = response.headers.get('Retry-After');
    const parsedDelay = (retryAfter ? $70107457754d8ab2$var$parseRetryAfter(retryAfter) : undefined) ?? delay;
    const retryDelay = Math.min(parsedDelay, $70107457754d8ab2$var$MAX_RETRY_DELAY);
    await new Promise((resolve)=>setTimeout(resolve, retryDelay));
    return $70107457754d8ab2$export$cffaac380b94df26(url, options, retriesRemaining - 1, delay * 2);
};
module.exports["fetchWithRetry"] = $70107457754d8ab2$export$cffaac380b94df26;

});

parcelRegister("cD1qu", function(module, exports) {
var $7825447594ee3eb0$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}({});
var $7825447594ee3eb0$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "current";
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["ARCHIVED"] = "archived";
    return ContentStatus;
}({});
const $7825447594ee3eb0$export$5d7c5e13dde1e9b8 = [
    "draft"
];
const $7825447594ee3eb0$export$c75005e52070dee = [
    "current"
];
module.exports["PageMode"] = $7825447594ee3eb0$export$6ea4b0c62affbe44;
module.exports["ContentStatus"] = $7825447594ee3eb0$export$b2be22e9d5dd3927;
module.exports["DRAFT_STATUS"] = $7825447594ee3eb0$export$5d7c5e13dde1e9b8;
module.exports["CURRENT_STATUS"] = $7825447594ee3eb0$export$c75005e52070dee;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EDIT_PAGE).name,
    (0, $1NBp8.EDIT_PAGE_V2).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).SLIDE
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    FeedbackSource["SLIDE"] = "Slide";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("5cryL", function(module, exports) {
const $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b = {
    EDITOR_ONBOARDING_ELIGIBLE_NEW: 'editor-state:editorOnboardingEligiblity',
    EDITOR_VISITED: 'editor-state:editorVisited',
    WAS_DRAFT_BANNER_SEEN: 'editor-state:wasDraftBannerSeen',
    IS_DRAFT_BANNER_VISIBLE: 'editor-state:isDraftBannerVisible',
    IS_LAND_IN_EDITOR_BANNER_VISIBLE: 'editor-state:isLandInEditorBannerVisible',
    HAS_USER_PUBLISHED: 'editor-state:hasUserPublished',
    SUCCESS_FLAG_SEEN: 'editor-state:successFlagCompleted',
    RECENT_SPOTLIGHT_OPEN: 'editor-state:recentSpotlightOpen',
    RECENT_SPOTLIGHT_SEEN: 'editor-state:recentSpotlightCompleted',
    EDITOR_TUTORIAL_SUCCESS_FLAG_SEEN: 'editor-state:editorTutorialSuccessFlagCompleted',
    WAS_EDITOR_CONVERSION_DIALOG_SEEN: 'editor-state:wasEditorConversionModalSeen',
    WAS_EDITOR_CONVERSION_DIALOG_V3_SEEN: 'editor-state:wasEditorConversionModalV3Seen'
};
const $d59a11eb5a1dc2b2$export$1a907d3885d0a16c = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-blueprint';
const $d59a11eb5a1dc2b2$export$3cae7707c5db4087 = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-v2-blueprint';
const $d59a11eb5a1dc2b2$export$fa405f661a23ebc5 = 'editor-onboarding';
const $d59a11eb5a1dc2b2$export$caf77613d415fe3 = [
    ...Object.values($d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b),
    $d59a11eb5a1dc2b2$export$1a907d3885d0a16c,
    $d59a11eb5a1dc2b2$export$3cae7707c5db4087
];
module.exports["EDITOR_ONBOARDING_STATE_KEYS"] = $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY"] = $d59a11eb5a1dc2b2$export$1a907d3885d0a16c;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED"] = $d59a11eb5a1dc2b2$export$3cae7707c5db4087;
module.exports["ONBOARDING_TUTORIAL_LABEL"] = $d59a11eb5a1dc2b2$export$fa405f661a23ebc5;
module.exports["EditorOnboardingKeys"] = $d59a11eb5a1dc2b2$export$caf77613d415fe3;

});

parcelRegister("e4o8D", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $60cDW = parcelRequire("60cDW");

const $2679ebd914f0a083$var$emptySubscribe = ()=>()=>{};
const $2679ebd914f0a083$var$getClientSnapshot = ()=>false;
const $2679ebd914f0a083$var$getServerSnapshot = ()=>true;
const $2679ebd914f0a083$var$editRoutes = [
    (0, $1NBp8.EDIT_PAGE_V2),
    (0, $1NBp8.EDIT_BLOG_V2),
    (0, $1NBp8.EDIT_PAGE),
    (0, $1NBp8.EDIT_BLOG),
    (0, $1NBp8.EDIT_PAGE_EMBED)
];
const $2679ebd914f0a083$var$isEditOrLiveRoute = ()=>{
    const { uri: uri, isLivePage: isLivePage } = (0, $60cDW.getSSRRenderInputs)();
    if (isLivePage) return true;
    if (uri) return $2679ebd914f0a083$var$editRoutes.some((route)=>route.match(uri));
    return false;
};
const $2679ebd914f0a083$export$96e8e9e8e57310bb = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isSSRSync = (0, $42omo.useSyncExternalStore)($2679ebd914f0a083$var$emptySubscribe, $2679ebd914f0a083$var$getClientSnapshot, $2679ebd914f0a083$var$getServerSnapshot);
    const optimizedRenderServerPlaceholder = (0, $42omo.useDeferredValue)(isSSRSync);
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            if ($2679ebd914f0a083$var$isEditOrLiveRoute() || !(0, $6mKj3.expVal)("confluence_optimize_render_server_placeholder", "isEnabled", false)) setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[2] !== optimizedRenderServerPlaceholder || $[3] !== renderServerPlaceholder) {
        t3 = !$2679ebd914f0a083$var$isEditOrLiveRoute() && (0, $6mKj3.expVal)("confluence_optimize_render_server_placeholder", "isEnabled", false) ? optimizedRenderServerPlaceholder : renderServerPlaceholder;
        $[2] = optimizedRenderServerPlaceholder;
        $[3] = renderServerPlaceholder;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("hpNab", function(module, exports) {

var $kFwgS = parcelRequire("kFwgS");


var $9tQM5 = parcelRequire("9tQM5");

var $cfa17a27dec34885$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $cfa17a27dec34885$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        // @deprecated: use template-browser-panel instead.
        'template-browser',
        'template-browser-panel',
        'blank-page-quick-actions',
        'inline-comments',
        'disable-publish-close-buttons',
        'disable-close-button',
        'loom-external-open',
        'rovo',
        'enable-share'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$var$pageAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$blogPostAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$whiteboardAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard
};
const $cfa17a27dec34885$var$contentTypeAllowedFeatures = {
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $cfa17a27dec34885$var$pageAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $cfa17a27dec34885$var$blogPostAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $cfa17a27dec34885$var$whiteboardAllowedFeatures
};
const $cfa17a27dec34885$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$cfa17a27dec34885$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $cfa17a27dec34885$export$3207c60940c4a9b0;

});

parcelRegister("kFwgS", function(module, exports) {
var $b38de1a13d5a6bb8$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $b38de1a13d5a6bb8$export$816ef638e478449a;

});

parcelRegister("9tQM5", function(module, exports) {
var $5b5865fbd831eb6d$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $5b5865fbd831eb6d$export$942a5fac9b8c9dc2;

});

parcelRegister("aWwYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $4BDAe = parcelRequire("4BDAe");


var $6mKj3 = parcelRequire("6mKj3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$21f0d255469350e0 = 3840;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    /**
   * Hide the sidebar immediately, bypassing the canClosePanel guard.
   * Use only when the caller has already confirmed with the user that it is
   * safe to discard any draft (e.g. after showing their own warning dialog).
   */ hideObjectSidebarForce: ()=>({ getState: getState, setState: setState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            if (!isObjectSidebarShown || !panel) return;
            panel.closeOptions?.onPanelClose?.();
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
        },
    /**
   * Legacy writer used by `ObjectSidebarPushPlaceholder`'s ResizeObserver
   * loop, which reports the inner content width (without push padding).
   * Prefer `setVisiblePanelWidth` from drag-resize call sites.
   */ setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    /**
   * Drag-resize writer. Takes the *visible* panel width directly (no
   * `−CONTENT_RIGHT_PADDING` at the call site). Same encoding as
   * `setPanelWidth`, so `panelWidth` consistently represents
   * "visible + push padding" regardless of which writer set it.
   */ setVisiblePanelWidth: (visiblePanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(visiblePanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $1P1Tu.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $9zUhf.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $42omo.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = (0, $42omo.useMemo)(()=>(0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) ? showObjectSidebarWrapper : internalActions.showObjectSidebar, [
        showObjectSidebarWrapper,
        internalActions.showObjectSidebar
    ]);
    const memoizedActions = (0, $42omo.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $42omo.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["CONTENT_RIGHT_PADDING"] = $5371993c50b87836$export$c0cd7aea5be0e780;
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("4BDAe", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $bbe4d3361c67916e$var$noop = (props)=>{};
const $bbe4d3361c67916e$export$5f5debba1692bf40 = ()=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    if (!context) return {
        open: $bbe4d3361c67916e$var$noop,
        close: $bbe4d3361c67916e$var$noop,
        setPanelWidth: $bbe4d3361c67916e$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bbe4d3361c67916e$export$5f5debba1692bf40;

});

parcelRegister("fN3iy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $7FN4e = parcelRequire("7FN4e");


var $D92g9 = parcelRequire("D92g9");

const $1ec08acbc7c3653d$var$noop = ()=>{};
const $1ec08acbc7c3653d$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $1ec08acbc7c3653d$var$noop,
    onClose: $1ec08acbc7c3653d$var$noop
};
const $1ec08acbc7c3653d$export$f473d225913e225d = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $1ec08acbc7c3653d$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $1ec08acbc7c3653d$var$noop,
                onClose: $1ec08acbc7c3653d$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
      	When opening a new preview panel, if the current panel is of the same type we don't
      	want to close the panel, but rather swap out the content. If the panel types don't match
      	we close the current panel and open the new one.
      	ex: A Goals panel is already open, and user tries to open a different Goals panel.
      	Parent Products must pass their preview panel close functions to the Preview Panel provider
      	via the `onPreviewPanelClose` prop.
      */ if (state.panel && !(0, $D92g9.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $1ec08acbc7c3653d$var$initialState.onOpen,
                onClose: params.onClose || $1ec08acbc7c3653d$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $1ec08acbc7c3653d$export$65ae37e9c61321f9 = ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $7FN4e.usePanelWidth)((0, $dh538.fg)('nin_glance_panel_initial_width_ssr') ? {
        initialWidth: initialWidth
    } : undefined);
    const [state, dispatch] = (0, $42omo.useReducer)($1ec08acbc7c3653d$var$previewPanelsReducer, {
        ...$1ec08acbc7c3653d$var$initialState,
        ...initialPanel && (0, $dh538.fg)('preview_panel_initial_state') ? {
            panel: initialPanel
        } : {},
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $42omo.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $42omo.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $42omo.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $42omo.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1ec08acbc7c3653d$export$f473d225913e225d.Provider, {
        value: context
    }, children);
};
const $1ec08acbc7c3653d$export$609db4be92d0fad8 = ()=>{
    return (0, $42omo.useContext)($1ec08acbc7c3653d$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $1ec08acbc7c3653d$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $1ec08acbc7c3653d$export$609db4be92d0fad8;

});

parcelRegister("7FN4e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jSnXV = parcelRequire("jSnXV");


var $inPa6 = parcelRequire("inPa6");


var $awbqn = parcelRequire("awbqn");

const $426c7353872dcab1$export$82b270f291af5a5 = ({ initialWidth: initialWidth } = {})=>{
    const [defaultWidth, setDefaultWidth] = (0, $42omo.useState)((0, $awbqn.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $42omo.useState)(initialWidth ?? defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $42omo.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $42omo.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $42omo.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $42omo.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $42omo.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $awbqn.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        const unbind = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $426c7353872dcab1$export$82b270f291af5a5;

});

parcelRegister("awbqn", function(module, exports) {
const $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH = 400;
const $9ee4137247832c84$var$PANEL_MAX_WIDTH = 1000;
const $9ee4137247832c84$var$MINIMUM_WIDTH = 1800;
const $9ee4137247832c84$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $9ee4137247832c84$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $9ee4137247832c84$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $9ee4137247832c84$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $9ee4137247832c84$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $9ee4137247832c84$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $9ee4137247832c84$export$29ceecbfeef33bfc;

});

parcelRegister("D92g9", function(module, exports) {

var $k4HRJ = parcelRequire("k4HRJ");

const $101bde26e7a6d36a$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $k4HRJ.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $k4HRJ.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $101bde26e7a6d36a$export$eb89e687f2b278d7;

});

parcelRegister("jvYFk", function(module, exports) {
var $d9aaea339f75cad2$export$328a8baf694e5d32 = /*#__PURE__*/ function(PanelName) {
    PanelName["CommentsPanel"] = "commentsPanel";
    PanelName["DetailsPanel"] = "detailsPanel";
    PanelName["WorkflowsPanel"] = "workflowsPanel";
    return PanelName;
}({});
const $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS = new Set([
    "commentsPanel",
    "detailsPanel",
    'jiraWorkItemsPanel'
]);
function $d9aaea339f75cad2$export$a9799883e6d611cc(panelId) {
    return !!panelId && $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS.has(panelId);
}
module.exports["PanelName"] = $d9aaea339f75cad2$export$328a8baf694e5d32;
module.exports["isMigratedToPanelSystem"] = $d9aaea339f75cad2$export$a9799883e6d611cc;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("gEtAQ", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3b7cd9ec7876f958 = ()=>Boolean((0, $1NBp8.EDIT_PAGE_EMBED).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$e40fec4aab490836 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.SLIDES_VIEW).name;
    return Boolean((0, $1NBp8.SLIDES_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isSlides"] = $b5832a8b6d0203e7$export$e40fec4aab490836;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("8aF6s", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $9zUhf.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $42omo.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $9zUhf.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $42omo.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("eyfm5", function(module, exports) {
const $6fd46c311db8d44c$export$76c7e83ecc9cdf05 = (content)=>({
        type: 'listItem',
        content: content
    });
module.exports["listItem"] = $6fd46c311db8d44c$export$76c7e83ecc9cdf05;

});

parcelRegister("bqMS3", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $6mYMS = parcelRequire("6mYMS");


var $jaPjp = parcelRequire("jaPjp");


var $3jsXx = parcelRequire("3jsXx");


var $jSnXV = parcelRequire("jSnXV");

const $298721003a2aaba7$var$MAX_QUERY_ITEMS = 100;
const $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS = 20;
const $298721003a2aaba7$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $298721003a2aaba7$export$4529f10aed0950d4 {
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
    constructor(){
        this.changeListeners = void 0;
        this.errListeners = void 0;
        this.infoListeners = void 0;
        this.allResultsListeners = void 0;
        this.analyticsListeners = void 0;
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
}
class $298721003a2aaba7$export$8576ba1ed2760927 extends $298721003a2aaba7$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $jaPjp.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $jaPjp.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $298721003a2aaba7$export$5a4331e3e1c43553 extends $298721003a2aaba7$export$8576ba1ed2760927 {
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    getMentionDisabledState(mention) {
        return this.config.getMentionDisabledState?.(mention);
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $jaPjp.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $6mYMS.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $298721003a2aaba7$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
   * Clear a context object to generate query params by removing empty
   * strings, `undefined` and empty values.
   *
   * @param contextIdentifier the current context identifier
   * @returns a safe context for query encoding
   */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
   * Returns the initial mention display list before a search is performed for the specified
   * container.
   *
   * @param contextIdentifier
   * @returns Promise
   */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const configHeaders = this.config.headers;
        const options = {
            path: 'bootstrap',
            queryParams: queryParams,
            ...configHeaders && {
                requestInit: {
                    headers: configHeaders
                }
            }
        };
        try {
            const result = await (0, $dwp40.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).INITIAL_STATE, (0, $6mYMS.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).INITIAL_STATE, (0, $6mYMS.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const configHeaders = this.config.headers;
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $298721003a2aaba7$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            },
            ...configHeaders && {
                requestInit: {
                    headers: configHeaders
                }
            }
        };
        try {
            const result = await (0, $dwp40.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).SEARCH, (0, $6mYMS.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).SEARCH, (0, $6mYMS.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $6mYMS.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $6mYMS.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
    constructor(config){
        super();
        this.config = void 0;
        this.lastReturnedSearch = void 0;
        this.activeSearches = void 0;
        this.productName = void 0;
        this.shouldEnableInvite = void 0;
        this.userRole = void 0;
        this.onInviteItemClick = void 0;
        this.inviteXProductUser = void 0;
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(this.filter, this.config.debounceTime);
    }
}
class $298721003a2aaba7$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.name = void 0;
        this.message = void 0;
        this.statusCode = void 0;
        this.stack = void 0;
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $298721003a2aaba7$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $298721003a2aaba7$export$2e2bcd8739ae039 = $298721003a2aaba7$export$5a4331e3e1c43553;
module.exports["AbstractResource"] = $298721003a2aaba7$export$4529f10aed0950d4;
module.exports["AbstractMentionResource"] = $298721003a2aaba7$export$8576ba1ed2760927;
module.exports["isResolvingMentionProvider"] = $298721003a2aaba7$export$ae1fce5f69858ef3;
module.exports["default"] = $298721003a2aaba7$export$2e2bcd8739ae039;

});

parcelRegister("6mYMS", function(module, exports) {
var $4e350b6bba0e5c59$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    MentionType[MentionType["DISABLED"] = 3] = "DISABLED";
    return MentionType;
}({});
var $4e350b6bba0e5c59$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $4e350b6bba0e5c59$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $4e350b6bba0e5c59$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $4e350b6bba0e5c59$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $4e350b6bba0e5c59$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $4e350b6bba0e5c59$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $4e350b6bba0e5c59$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $4e350b6bba0e5c59$export$81124e6148ca5db0[0];
}
function $4e350b6bba0e5c59$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[1];
}
function $4e350b6bba0e5c59$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[2];
}
function $4e350b6bba0e5c59$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[3];
}
function $4e350b6bba0e5c59$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $4e350b6bba0e5c59$export$4369c812aac99591 = (p)=>!!(p && p.then);
module.exports["MentionType"] = $4e350b6bba0e5c59$export$2102863a3c660c6b;
module.exports["UserAccessLevel"] = $4e350b6bba0e5c59$export$81124e6148ca5db0;
module.exports["UserType"] = $4e350b6bba0e5c59$export$8436e53e45ffe15b;
module.exports["SliNames"] = $4e350b6bba0e5c59$export$7afb0727c7d7e8af;
module.exports["ComponentNames"] = $4e350b6bba0e5c59$export$5c42d9dea6d035c1;
module.exports["Actions"] = $4e350b6bba0e5c59$export$b52183d5cfb26dc9;
module.exports["MentionNameStatus"] = $4e350b6bba0e5c59$export$b8fa67dc54502853;
module.exports["isRestricted"] = $4e350b6bba0e5c59$export$dbaa15dc1820b89a;
module.exports["isSpecialMention"] = $4e350b6bba0e5c59$export$37b8dcac6198c514;
module.exports["isAppMention"] = $4e350b6bba0e5c59$export$eb590c844d13454c;
module.exports["isTeamMention"] = $4e350b6bba0e5c59$export$803b1379348dbfd5;
module.exports["isSpecialMentionText"] = $4e350b6bba0e5c59$export$d13d4f976b36a397;
module.exports["isPromise"] = $4e350b6bba0e5c59$export$4369c812aac99591;

});

parcelRegister("jaPjp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7f0f11694d4a0f0$export$2e2bcd8739ae039);
let $f7f0f11694d4a0f0$var$debugEnabled = false;
let $f7f0f11694d4a0f0$var$stacktracesEnabled = false;
function $f7f0f11694d4a0f0$export$748ada60eaf985cc(enable) {
    $f7f0f11694d4a0f0$var$debugEnabled = enable;
}
function $f7f0f11694d4a0f0$export$4f7017086af31c25(enable) {
    $f7f0f11694d4a0f0$var$stacktracesEnabled = enable;
}
function $f7f0f11694d4a0f0$export$2a858f450a2f66d() {
    if ($f7f0f11694d4a0f0$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $f7f0f11694d4a0f0$export$2e2bcd8739ae039(msg, ...args) {
    if ($f7f0f11694d4a0f0$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("3jsXx", function(module, exports) {

var $7TH2w = parcelRequire("7TH2w");


var $ElsUb = parcelRequire("ElsUb");


var $6mYMS = parcelRequire("6mYMS");

const $43ca455672da960d$var$packageName = "platform-pkg";
const $43ca455672da960d$var$packageVersion = "0.0.0-use.local";
const $43ca455672da960d$export$245097525aef1262 = 'sli';
const $43ca455672da960d$export$c724588856bbfbcf = 'smart';
const $43ca455672da960d$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $6mYMS.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $43ca455672da960d$var$packageName,
                    packageVersion: $43ca455672da960d$var$packageVersion,
                    componentName: (0, $6mYMS.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
const $43ca455672da960d$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            attributes: {
                packageName: $43ca455672da960d$var$packageName,
                packageVersion: $43ca455672da960d$var$packageVersion,
                componentName: (0, $6mYMS.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $6mYMS.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        return event;
    };
const $43ca455672da960d$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $43ca455672da960d$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
const $43ca455672da960d$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        attributes: {
            packageName: $43ca455672da960d$var$packageName,
            packageVersion: $43ca455672da960d$var$packageVersion,
            componentName: (0, $6mYMS.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $43ca455672da960d$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $6mYMS.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $43ca455672da960d$var$packageName,
                    packageVersion: $43ca455672da960d$var$packageVersion,
                    componentName: (0, $6mYMS.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
// OLD Analytics
const $43ca455672da960d$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $43ca455672da960d$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$43ca455672da960d$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $6mYMS.isSpecialMentionText)(text)
        });
    };
module.exports["SLI_EVENT_TYPE"] = $43ca455672da960d$export$245097525aef1262;
module.exports["SMART_EVENT_TYPE"] = $43ca455672da960d$export$c724588856bbfbcf;
module.exports["fireAnalyticsMentionTypeaheadEvent"] = $43ca455672da960d$export$a823474ae5cb9e9c;
module.exports["fireAnalyticsMentionEvent"] = $43ca455672da960d$export$44902bc7b3f0b09f;
module.exports["fireSliAnalyticsEvent"] = $43ca455672da960d$export$c8b245b690e10169;
module.exports["fireAnalyticsMentionHydrationEvent"] = $43ca455672da960d$export$91b2fa6a0fe06408;

});

parcelRegister("ElsUb", function(module, exports) {
const $cc0765a5d08d319a$export$d821aa4c8afb384e = 'fabric-elements';
module.exports["ELEMENTS_CHANNEL"] = $cc0765a5d08d319a$export$d821aa4c8afb384e;

});

parcelRegister("f8J4a", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $a33388bf0f1afdd4$export$74e304339778e94d = (0, $aXWIB.defineMessages)({
    copyCodeToClipboard: {
        id: "fabric.editor.codeBlockCopyButton.copyToClipboard",
        defaultMessage: "Copy as text"
    },
    copiedCodeToClipboard: {
        id: "fabric.editor.codeBlockCopyButton.copiedToClipboard",
        defaultMessage: "Copied!"
    },
    // Remove wrapCode/unwrapCode and use wrapCodeLabel/unwrapCodeLabel
    // when cleaning up platform_editor_code_block_q4_lovability.
    wrapCode: {
        id: "fabric.editor.codeBlockWrapButton.wrapCodeBlock",
        defaultMessage: "Turn on wrap"
    },
    unwrapCode: {
        id: "fabric.editor.codeBlockWrapButton.unwrapCodeBlock",
        defaultMessage: "Turn off wrap"
    },
    wrapCodeLabel: {
        id: "fabric.editor.codeBlockWrapButton.wrapCode",
        defaultMessage: "Wrap code"
    },
    unwrapCodeLabel: {
        id: "fabric.editor.codeBlockWrapButton.unwrapCode",
        defaultMessage: "Unwrap code"
    },
    showLineNumbersLabel: {
        id: "fabric.editor.codeBlockLineNumbersButton.showLineNumbers",
        defaultMessage: "Show line numbers"
    },
    hideLineNumbersLabel: {
        id: "fabric.editor.codeBlockLineNumbersButton.hideLineNumbers",
        defaultMessage: "Hide line numbers"
    },
    formatCode: {
        id: "fabric.editor.codeBlockFormatButton.formatCode",
        defaultMessage: "Format code"
    },
    formatCodeUnavailable: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeUnavailable",
        defaultMessage: "Formatting not available for this language"
    },
    formatCodeFailed: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailed",
        defaultMessage: "Code formatting failed"
    },
    formatCodeFailedDescription: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailedDescription",
        defaultMessage: "Review the content or change the selected language."
    },
    formatCodeFailedAutoDetectedDescription: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailedAutoDetectedDescription",
        defaultMessage: "Review the content or select a specific language."
    },
    selectLanguage: {
        id: "fabric.editor.selectLanguage",
        defaultMessage: "Select language"
    },
    detectLanguage: {
        id: "fabric.editor.codeBlock.detectLanguage",
        defaultMessage: "Detect language"
    },
    detectedLanguage: {
        id: "fabric.editor.codeBlock.detectedLanguage",
        defaultMessage: "{language} (detected)"
    },
    noneDetected: {
        id: "fabric.editor.codeBlock.noneDetected",
        defaultMessage: "(None detected)"
    },
    recentlyUsed: {
        id: "fabric.editor.codeBlock.recentlyUsed",
        defaultMessage: "Recently used"
    },
    all: {
        id: "fabric.editor.codeBlock.all",
        defaultMessage: "All"
    }
});
module.exports["codeBlockButtonMessages"] = $a33388bf0f1afdd4$export$74e304339778e94d;

});

parcelRegister("4JDbp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i7RGj = parcelRequire("i7RGj");

/**
 * This component will observer the current width,
 * and it will call the `setWidth` callback every time this changes.
 *
 * The only required is the parent HTMLElement should have `position: relative`
 * because this is an absolute element.
 */ const $b400565b9de87bc3$var$WidthObserver = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7RGj.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $b400565b9de87bc3$export$2e2bcd8739ae039 = $b400565b9de87bc3$var$WidthObserver;
module.exports["default"] = $b400565b9de87bc3$export$2e2bcd8739ae039;

});

parcelRegister("i7RGj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5EteX = parcelRequire("5EteX");

const $0e043a05e9b77ebf$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $5EteX.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef,
        "data-vc": "VFGtZ62Q"
    });
});
module.exports["WidthDetectorObserver"] = $0e043a05e9b77ebf$export$ff983d2a2b6112ea;

});

parcelRegister("5EteX", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $63cd7642b16dfa22$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}
module.exports["useInView"] = $63cd7642b16dfa22$export$2f62ee6831462844;

});

parcelRegister("I1nNR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $chRg6 = parcelRequire("chRg6");

const $7834fba73424be0b$export$a54013f0d02a8f82 = ({ children: children, locale: incomingLocale = (0, $chRg6.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $42omo.useState)();
    const locale = (0, $42omo.useMemo)(()=>(0, $chRg6.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $42omo.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $chRg6.DEFAULT_LOCALE)
    }, children);
};
module.exports["I18nProvider"] = $7834fba73424be0b$export$a54013f0d02a8f82;

});

parcelRegister("chRg6", function(module, exports) {
const $22ba11b592de8836$var$DEFAULT_LANGUAGE = 'en';
const $22ba11b592de8836$var$DEFAULT_REGION = 'US';
const $22ba11b592de8836$export$1af4c7e47ad72f44 = `${$22ba11b592de8836$var$DEFAULT_LANGUAGE}-${$22ba11b592de8836$var$DEFAULT_REGION}`;
const $22ba11b592de8836$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $22ba11b592de8836$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $22ba11b592de8836$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $22ba11b592de8836$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $22ba11b592de8836$export$1af4c7e47ad72f44;
};
module.exports["DEFAULT_LOCALE"] = $22ba11b592de8836$export$1af4c7e47ad72f44;
module.exports["normalizeLocale"] = $22ba11b592de8836$export$dca0327c9b9c6498;

});

parcelRegister("kudeD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $khmAd = parcelRequire("khmAd");


var $4icDV = parcelRequire("4icDV");

// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $0a26766864270169$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $0a26766864270169$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $0a26766864270169$var$Provider = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $42omo.useState)(contentType);
    const isInitialized = (0, $42omo.useRef)(true);
    const iframeLoadMetrics = (0, $42omo.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $42omo.useRef)();
    (0, $42omo.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $khmAd.embeddedViewToEditTransitionMetric)();
        // Setup iframe post message handling
        const handler = (e)=>{
            let uniqueKey;
            try {
                uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
            } catch (error) {
                uniqueKey = null;
            }
            // Validate uniqueKey (if it exists) to avoid race condition between multiple embedded confluence instances
            if (!e.data.payload?.customData?.uniqueKey || !uniqueKey || e.data.payload.customData.uniqueKey === uniqueKey) switch(e.data.type){
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_VIEW_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDITOR_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDIT_CLICK):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_IFRAME_CONTENT_INITIALIZED):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $42omo.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $khmAd.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $42omo.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $42omo.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a26766864270169$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        }
    }, children);
};
const $0a26766864270169$export$865423e6f8e2e839 = ()=>{
    return (0, $42omo.useContext)($0a26766864270169$var$PerformanceMetricsContext);
};
const $0a26766864270169$export$c6f19d9afc6c86c8 = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $0a26766864270169$export$865423e6f8e2e839();
    (0, $42omo.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a26766864270169$var$Provider, {
        contentType: contentType,
        sourceComponent: sourceComponent
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
module.exports["usePerformanceMetrics"] = $0a26766864270169$export$865423e6f8e2e839;
module.exports["PerformanceMetricsProvider"] = $0a26766864270169$export$c6f19d9afc6c86c8;

});

parcelRegister("khmAd", function(module, exports) {

var $kyiqo = parcelRequire("kyiqo");


var $j4jXg = parcelRequire("j4jXg");

const $078bd495543d458c$export$4de078c3b9971f9b = ()=>(0, $kyiqo.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $078bd495543d458c$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $078bd495543d458c$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    }
};
const $078bd495543d458c$export$a23245993532c751 = (contentType)=>(0, $kyiqo.metrics).pageSegmentLoad($078bd495543d458c$var$loadingMetricsConfig[contentType]);
module.exports["embeddedViewToEditTransitionMetric"] = $078bd495543d458c$export$4de078c3b9971f9b;
module.exports["embeddedConfluenceIframeLoadMetrics"] = $078bd495543d458c$export$a23245993532c751;

});

parcelRegister("4icDV", function(module, exports) {
const $2c9093170036a8a1$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $2c9093170036a8a1$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $2c9093170036a8a1$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $2c9093170036a8a1$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $2c9093170036a8a1$export$73b982309451f084 = 'embedded-iframe-content-initialized';
module.exports["EMBEDDED_CONFLUENCE_METRICS_PREFIX"] = $2c9093170036a8a1$export$ad3f29048eb3061;
module.exports["EMBEDDED_VIEW_TTI"] = $2c9093170036a8a1$export$e5b04c2a3cc97ddc;
module.exports["EMBEDDED_EDITOR_TTI"] = $2c9093170036a8a1$export$9f8bbf62fac57d48;
module.exports["EMBEDDED_EDIT_CLICK"] = $2c9093170036a8a1$export$e08d2ab8ef653595;
module.exports["EMBEDDED_IFRAME_CONTENT_INITIALIZED"] = $2c9093170036a8a1$export$73b982309451f084;

});

parcelRegister("cGc86", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $diaaX = parcelRequire("diaaX");

const $b9b017651fce2f05$var$UniqueKeyContext = /*#__PURE__*/ (0, $42omo.createContext)({
    uniqueKey: undefined
});
const $b9b017651fce2f05$export$71829d27b87a2006 = ({ children: children })=>{
    const uniqueKey = (0, $42omo.useMemo)(()=>(0, $diaaX.createUniqueKey)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9b017651fce2f05$var$UniqueKeyContext.Provider, {
        value: {
            uniqueKey: uniqueKey
        }
    }, children);
};
const $b9b017651fce2f05$export$cef64a0cfb90e369 = ()=>{
    return (0, $42omo.useContext)($b9b017651fce2f05$var$UniqueKeyContext);
};
module.exports["UniqueKeyProvider"] = $b9b017651fce2f05$export$71829d27b87a2006;
module.exports["useUniqueKey"] = $b9b017651fce2f05$export$cef64a0cfb90e369;

});

parcelRegister("3WsBD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2LONO = parcelRequire("2LONO");


var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");


var $hpNab = parcelRequire("hpNab");


var $aXWIB = parcelRequire("aXWIB");


var $cezNv = parcelRequire("cezNv");


var $cGc86 = parcelRequire("cGc86");

const $5a8d62fce039da42$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $2LONO.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $5a8d62fce039da42$var$serializeQueryParams = (queryParams)=>queryParams ? new URLSearchParams(Object.entries(queryParams).sort(([paramA], [paramB])=>paramA.localeCompare(paramB))).toString() : '';
const $5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY = '/gateway/api/ex/confluence/';
const $5a8d62fce039da42$var$nonAllFeatures = [
    'modern-header',
    'disable-help-button',
    'disable-title-toolbar'
];
const $5a8d62fce039da42$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, previewPanels: previewPanels, protocol: protocol, queryParams: consumerQueryParams, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $42omo.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $42omo.useMemo)(()=>allowedFeatures === 'all' ? (0, $hpNab.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    // 'enable-redirection' should not be included in initial allowed features unless a parent has passed this in as an allowedFeature in the correct format.
    .filter((feature)=>feature !== 'edit' && feature !== 'enable-redirection')// 'modern-header' should not be included in initial allowed features when allowedFeatures is 'all'
    .filter((feature)=>!$5a8d62fce039da42$var$nonAllFeatures.includes(feature)).join('.') : features;
    // check whether re-direction is enabled
    const enableRedirectionFeature = features && features !== 'all' ? features.find((feature)=>(0, $cezNv.isRedirectionEnabled)(feature)) : undefined;
    const crossSiteTenantId = enableRedirectionFeature ? (0, $cezNv.getCrossSiteTenantIdFromAllowedFeature)(enableRedirectionFeature) : undefined;
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const consumerQueryParamsString = $5a8d62fce039da42$var$serializeQueryParams(consumerQueryParams);
    const contentConfigurationQueryParamsString = $5a8d62fce039da42$var$serializeQueryParams(contentConfiguration?.queryParams);
    const queryParams = (0, $42omo.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $5a8d62fce039da42$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (previewPanels) query.previewPanels = previewPanels;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        if (uniqueKey) query.uniqueKey = uniqueKey;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        const searchParams = new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery
        });
        new URLSearchParams(consumerQueryParamsString).forEach((value, key)=>{
            if (!searchParams.has(key)) searchParams.set(key, value);
        });
        new URLSearchParams(contentConfigurationQueryParamsString).forEach((value, key)=>{
            searchParams.set(key, value);
        });
        return `?${searchParams.toString()}`;
    }, [
        consumerQueryParamsString,
        contentConfigurationQueryParamsString,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        previewPanels,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template,
        uniqueKey
    ]);
    return (0, $42omo.useMemo)(()=>({
            ...$5a8d62fce039da42$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams,
                crossSiteTenantId: crossSiteTenantId
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams,
        crossSiteTenantId
    ]);
};
const $5a8d62fce039da42$var$CONTEXT_PATH = '/wiki/spaces';
const $5a8d62fce039da42$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $5a8d62fce039da42$var$constructUrl(mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams, crossSiteTenantId: crossSiteTenantId }) {
    if (contentType !== (0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE && !contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$5a8d62fce039da42$var$CONTEXT_PATH}`;
    const prefixWithStargate = crossSiteTenantId ? `${protocol || window.location.protocol}//${window.location.host //take the parent site because want don't want it to be cross-site EP
    }${$5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY}${crossSiteTenantId}${$5a8d62fce039da42$var$CONTEXT_PATH}` : undefined;
    let base;
    const pageUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: contentId ? `${spaceKey}/pages/${contentId}` : `${spaceKey}/overview`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = contentTypeUrl[contentType]?.[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefixWithStargate ?? prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}
module.exports["themeStateObjectToQueryString"] = $5a8d62fce039da42$export$6e43e60d51b79331;
module.exports["useUrl"] = $5a8d62fce039da42$export$305222dff575c4e3;

});

parcelRegister("cezNv", function(module, exports) {
const $d21a741e0de1277a$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES = [
    'template-browser',
    'template-browser-panel'
];
const $d21a741e0de1277a$var$hasAllowedFeature = (feature, featureName)=>{
    if (typeof feature === 'string') return feature === featureName;
    if (feature && typeof feature === 'object') return Object.prototype.hasOwnProperty.call(feature, featureName);
    return false;
};
const $d21a741e0de1277a$export$b47e8b0fa2aae156 = (allowedFeatures)=>{
    if (allowedFeatures === 'all') return true;
    return allowedFeatures?.some((feature)=>$d21a741e0de1277a$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES.some((featureName)=>$d21a741e0de1277a$var$hasAllowedFeature(feature, featureName))) ?? false;
};
const $d21a741e0de1277a$export$51abd16148027412 = (feature)=>{
    if (typeof feature === 'object') return 'enable-redirection' in feature;
    if (typeof feature === 'string') try {
        const parsedFeature = JSON.parse(feature);
        return parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature;
    } catch  {
        return false;
    }
    return false;
};
const $d21a741e0de1277a$export$243fbba563b8aa8e = (feature)=>{
    if (!feature) return undefined;
    if (typeof feature === 'string') try {
        const parsed = JSON.parse(feature);
        return parsed['enable-redirection']?.['cross-site-tenant-id'];
    } catch  {
        return undefined;
    }
    return feature['enable-redirection']?.['cross-site-tenant-id'];
};
module.exports["isInEditorTemplatesPanelEnabled"] = $d21a741e0de1277a$export$b47e8b0fa2aae156;
module.exports["isRedirectionEnabled"] = $d21a741e0de1277a$export$51abd16148027412;
module.exports["getCrossSiteTenantIdFromAllowedFeature"] = $d21a741e0de1277a$export$243fbba563b8aa8e;

});

parcelRegister("66dpz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $893c7e3925139b9a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c9832fbd4a1ca0bae327cc20e7bdf16>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $kXb3C = parcelRequire("kXb3C");

function $893c7e3925139b9a$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
}

});

parcelRegister("kXb3C", function(module, exports) {
$parcel$export(module.exports, "default", () => $5412502140f64e3a$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $5412502140f64e3a$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});

parcelRegister("kLzei", function(module, exports) {
/* getSmartCardRenderers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $5spQU = parcelRequire("5spQU");


var $i5WUp = parcelRequire("i5WUp");


var $di8q4 = parcelRequire("di8q4");


var $9wGTI = parcelRequire("9wGTI");


var $ge2sX = parcelRequire("ge2sX");


var $f7i8j = parcelRequire("f7i8j");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $1431e51c33a3f61c$var$emojiWrapperStyles = null;
const $1431e51c33a3f61c$var$SmartCardEmojiWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1o8l _1bah1h6o _1ul97vkz"
        ]),
        "data-vc": "rb-ssvla"
    }, children); // Custom render wrapper for AISnippet providing session data
const $1431e51c33a3f61c$var$AISnippetRenderer = (props)=>{
    const { displayName: displayName, userId: userId, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const isAIFeatureEnabled = (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai');
    if (!isAdminHubAIEnabled || !isAIFeatureEnabled || !(0, $6mKj3.expVal)('confluence-ai-linking-ai-snippets', 'should_render_ai_snippet', false)) return props.fallbackComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i5WUp.AISnippetWithRelayEnvironment), {
        ...props,
        userId: userId ?? undefined,
        displayName: displayName ?? undefined
    });
};
const $1431e51c33a3f61c$export$61bc672a900b57f = (0, $2XqLN.default)(()=>({
        renderers: {
            emoji: (emojiId, _parentComponent = 'SmartCard', contentType = 'page')=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ge2sX.SessionData), null, (sessionData)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7i8j.SessionDataContext).Provider, {
                        value: sessionData
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                        emoji: emojiId,
                        height: 16,
                        context: "smartCard",
                        wrapper: $1431e51c33a3f61c$var$SmartCardEmojiWrapper,
                        contentType: contentType
                    }))),
            snippet: (0, $9wGTI.fg)('cc-ai-snippet-renderer-gate') ? $1431e51c33a3f61c$var$AISnippetRenderer : undefined
        }
    }));
module.exports["getSmartCardRenderers"] = $1431e51c33a3f61c$export$61bc672a900b57f;

});

parcelRegister("7gpC4", function(module, exports) {
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $6MlG5 = parcelRequire("6MlG5");


var $9wgn8 = parcelRequire("9wgn8");


var $cVrnQ = parcelRequire("cVrnQ");


var $hcDON = parcelRequire("hcDON");

const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $42omo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $9wgn8.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss
    }, /*#__PURE__*/ $42omo.createElement("input" // It is necessary only for Safari. It allows to render focus styles.
    , {
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        className: (0, $gMc0m.default)([
            $1f9fb6b4b3bc4020$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ $42omo.createElement((0, $6MlG5.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $42omo.createElement((0, $cVrnQ.default), null, label, isRequired && /*#__PURE__*/ $42omo.createElement((0, $hcDON.default), null)));
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;
module.exports["default"] = $1f9fb6b4b3bc4020$export$2e2bcd8739ae039;

});

parcelRegister("6MlG5", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $71feb0a29953fded$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit",
        "data-vc": "7HJJLEkC"
    });
    if (isChecked) return /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $42omo.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $42omo.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $gMc0m.default)([
            $71feb0a29953fded$var$svgStyles.root
        ])
    }, /*#__PURE__*/ $42omo.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $42omo.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        className: (0, $gMc0m.default)([
            $71feb0a29953fded$var$svgStyles.rect
        ])
    }), icon));
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;
module.exports["default"] = $71feb0a29953fded$export$2e2bcd8739ae039;

});

parcelRegister("9wgn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $edf27753e59bf881$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $edf27753e59bf881$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $edf27753e59bf881$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $edf27753e59bf881$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $edf27753e59bf881$var$disabledCheckedStyles = null;
function $edf27753e59bf881$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ $42omo.createElement("label", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("cVrnQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0c2060f65a94bd0$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f0c2060f65a94bd0$var$labelTextStyles = null;
function $f0c2060f65a94bd0$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        "data-vc": "7vKawawo"
    }, children);
}

});

parcelRegister("hcDON", function(module, exports) {
$parcel$export(module.exports, "default", () => $a14852587cdb2524$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a14852587cdb2524$var$requiredIndicatorStyles = null;
function $a14852587cdb2524$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $42omo.createElement("span", {
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            "_syaz1tmw _bozgv77o"
        ]),
        "data-vc": "vEKPo6pO"
    }, "*");
}

});

parcelRegister("6iY4P", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0e9f22edb5bbb2a5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97191d14e335e1cb9997865bd9c31c4d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $kXb3C = parcelRequire("kXb3C");

function $0e9f22edb5bbb2a5$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("9fywD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");

const $43aed8c383cce8da$var$i18n = (0, $aXWIB.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("9ILXP", function(module, exports) {
function $713d6dc98197981e$var$e(e) {
    this.message = e;
}
$713d6dc98197981e$var$e.prototype = new Error, $713d6dc98197981e$var$e.prototype.name = "InvalidCharacterError";
var $713d6dc98197981e$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $713d6dc98197981e$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $713d6dc98197981e$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($713d6dc98197981e$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $713d6dc98197981e$var$r(t);
    }
}
function $713d6dc98197981e$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $713d6dc98197981e$var$o(e, r) {
    if ("string" != typeof e) throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($713d6dc98197981e$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$713d6dc98197981e$export$b9721ef022f71a68.prototype = new Error, $713d6dc98197981e$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $713d6dc98197981e$export$2e2bcd8739ae039 = $713d6dc98197981e$var$o;
module.exports["default"] = $713d6dc98197981e$export$2e2bcd8739ae039;

});

parcelRegister("4GGNn", function(module, exports) {

var $jhbO3 = parcelRequire("jhbO3");


var $GLgaM = parcelRequire("GLgaM");


var $bjeS8 = parcelRequire("bjeS8");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError }) {
    const fetchData = async ()=>{
        const json = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, variables);
        return await parseResult(json, variables);
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $jhbO3.apolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("hSHWm", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d1e7679282bf3961$export$8b4809eaf655f286 = /*#__PURE__*/ (0, $42omo.createContext)({});
module.exports["CoreInvitesContext"] = $d1e7679282bf3961$export$8b4809eaf655f286;

});

parcelRegister("gXrHX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $42omo.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined,
    isAccessLinkRequest: false
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("2SowE", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ function $3c96f0e6009ebcf8$export$dc64ca688fb64c26(payload, newAttributes) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            ...newAttributes
        }
    };
}
const $3c96f0e6009ebcf8$export$a9a68a8b41555f13 = (startTime, duration)=>{
    return Number.isFinite(startTime) && Number.isFinite(duration) ? Math.round(startTime + duration) : undefined;
};
const $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6 = (context)=>{
    return context.filter((obj)=>obj.attributes && typeof obj.attributes === 'object' && !Array.isArray(obj.attributes)).reduce((acc, obj)=>({
            ...acc,
            ...obj.attributes
        }), {});
};
module.exports["extendPayloadAttributes"] = $3c96f0e6009ebcf8$export$dc64ca688fb64c26;
module.exports["getProseMirrorFMPTimestamp"] = $3c96f0e6009ebcf8$export$a9a68a8b41555f13;
module.exports["extractAttributesFromContext"] = $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6;

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'mod+option+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
const $e13bb5c64c0a0eec$export$bc654500edb91b60 = 'mod+shift+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;
module.exports["UNIVERSAL_TOGGLE_MARKDOWN_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$bc654500edb91b60;

});

parcelRegister("a2xFu", function(module, exports) {

var $5KmYv = parcelRequire("5KmYv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/page/manifest.ts
var $74f4351b9cae92fc$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5KmYv.ConfluencePageAriResourceOwner),
    resourceType: (0, $5KmYv.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $74f4351b9cae92fc$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $74f4351b9cae92fc$export$3f931dd15d96caff;

});

parcelRegister("5KmYv", function(module, exports) {
// src/confluence/page/types.ts
var $42f311f8b7b6730c$export$da53e4f7db4c6a71 = "confluence", $42f311f8b7b6730c$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $42f311f8b7b6730c$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $42f311f8b7b6730c$export$636fc622562a2c5b;

});

parcelRegister("4rwCt", function(module, exports) {

var $51c7W = parcelRequire("51c7W");


var $JlyMu = parcelRequire("JlyMu");

function $33c2fc9905303660$export$c9058316764c140e(refs) {
    return (0, $JlyMu.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $51c7W.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $33c2fc9905303660$export$c9058316764c140e;

});

parcelRegister("JlyMu", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $0884ed72a8650e84$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $0884ed72a8650e84$export$35a19128eb4acba4;

});

parcelRegister("744ND", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d51e4a53b773461fcacb3f2ef49e80e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $524ca136d29d3c89$var$_react = $524ca136d29d3c89$var$_interopRequireDefault((parcelRequire("42omo")));

var $524ca136d29d3c89$var$_baseNew = $524ca136d29d3c89$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $524ca136d29d3c89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $524ca136d29d3c89$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $524ca136d29d3c89$var$_react.default.createElement($524ca136d29d3c89$var$_baseNew.default, Object.assign({
        name: "WarningOutlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.383c.996-1.816 3.605-1.817 4.602-.002l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972.002L1.68 11.834c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$524ca136d29d3c89$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $524ca136d29d3c89$var$_default = module.exports.default = $524ca136d29d3c89$var$WarningOutlineIcon;

});

parcelRegister("7642E", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $XOZYy = parcelRequire("XOZYy");


const $52ac3a8ba658d4f5$var$_inlined0 = (()=>{
    const module1 = {
        exports: {}
    };
    const exports = module1.exports;
    (function() {
        /**
 * Shim for the removed @atlaskit/icon default export (legacy Icon base component).
 *
 * This provides a lightweight replacement for the legacy Icon component that
 * was removed in DSP-24550. Instead of wrapping the glyph in a span with
 * complex styling, it simply renders the glyph component directly, passing
 * through relevant props.
 *
 * This is NOT a public API — it exists solely to unblock the removal of
 * deprecated icon APIs from @atlaskit/icon.
 */ const React = (parcelRequire("42omo"));
        function Icon(props) {
            const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor, testId: testId, label: label } = props;
            if (Glyph) return React.createElement(Glyph, {
                role: label ? 'img' : 'presentation',
                'aria-label': label || undefined,
                'aria-hidden': label ? undefined : 'true',
                'data-testid': testId,
                fill: primaryColor || 'currentColor'
            });
            if (dangerouslySetGlyph) return React.createElement('span', {
                dangerouslySetInnerHTML: {
                    __html: dangerouslySetGlyph
                },
                role: label ? 'img' : undefined,
                'aria-label': label || undefined,
                'aria-hidden': label ? undefined : 'true',
                'data-testid': testId,
                style: {
                    display: 'inline-block',
                    lineHeight: 1,
                    color: primaryColor || 'currentColor'
                }
            });
            return null;
        }
        Icon.displayName = 'Icon';
        module1.exports = Icon;
    })();
    return module1.exports;
})();
module.exports = Object.assign({}, $XOZYy, {
    default: $52ac3a8ba658d4f5$var$_inlined0
});
if ($XOZYy.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});

parcelRegister("i7jPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6421b29072e9fbe0$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6421b29072e9fbe0$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf _s7n4nkob",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $6421b29072e9fbe0$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $6421b29072e9fbe0$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $6421b29072e9fbe0$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
function $6421b29072e9fbe0$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $gMc0m.default)([
            $6421b29072e9fbe0$var$styles.root,
            $6421b29072e9fbe0$var$sizeMap[size],
            isInset ? $6421b29072e9fbe0$var$styles.inset : $6421b29072e9fbe0$var$styles.nonInset,
            isInset && $6421b29072e9fbe0$var$insetSizeMap[size],
            $6421b29072e9fbe0$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $6421b29072e9fbe0$var$styles.border
        ])
    }, children);
}

});

parcelRegister("4asqm", function(module, exports) {
const $241c8f59f5ed98aa$export$f182130953438e47 = ({ tags: tags, destinationApp: destinationApp, createAnalyticsEvent: createAnalyticsEvent, analyticsEventFireName: analyticsEventFireName, bridge: bridge, source: source, actionSubjectId: actionSubjectId })=>{
    const analyticsEvent = createAnalyticsEvent({
        action: 'customCrossAppExperience',
        actionSubject: 'viewed',
        actionSubjectId: actionSubjectId,
        eventType: 'ui',
        tags: tags,
        attributes: {
            bridge: bridge,
            source: source,
            destinationApp: destinationApp
        }
    });
    analyticsEvent.fire(analyticsEventFireName);
};
module.exports["fireCustomCrossAppAnalytic"] = $241c8f59f5ed98aa$export$f182130953438e47;

});

parcelRegister("9SMct", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8jHAi = parcelRequire("8jHAi");


var $7CgcZ = parcelRequire("7CgcZ");

const $3c9171fc16956912$var$PageIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), 'blueBold');
$3c9171fc16956912$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $3c9171fc16956912$export$2e2bcd8739ae039 = $3c9171fc16956912$var$PageIconWithColor;
module.exports["default"] = $3c9171fc16956912$export$2e2bcd8739ae039;

});

parcelRegister("7CgcZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7642E = parcelRequire("7642E");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $ivUmx = parcelRequire("ivUmx");

/**
 * Maps IconTile appearance to the icon glyph color token to use when rendering
 * a standalone icon (without a tile background).
 */ const $6846287c8ee6bf50$var$appearanceToStandaloneIconColor = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
const $6846287c8ee6bf50$export$3acc3fb10995f020 = (size)=>{
    if ((0, $dh538.fg)('platform_sl_icons_refactor')) switch(size){
        case (0, $5TXU5.SmartLinkSize).Small:
        case (0, $5TXU5.SmartLinkSize).Medium:
            return undefined;
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return 'small';
        default:
            // SmartLinkSize.Small, SmartLinkSize.Medium, and undefined all
            // previously mapped to size="16" which has been removed. Render
            // the icon directly (no tile) for these sizes.
            return undefined;
    }
};
const $6846287c8ee6bf50$export$28dd5ad82647c000 = (ObjectIcon, ObjectTileIcon)=>{
    return ({ size: size, ...props })=>{
        if ((0, $ivUmx.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ObjectTileIcon, {
            ...props,
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ObjectIcon, props);
    };
};
const $6846287c8ee6bf50$export$87c3646d0e299cfe = (Icon, appearance)=>{
    return ({ size: size, isTiledIcon: isTiledIcon, ...props })=>{
        const tileSize = $6846287c8ee6bf50$export$3acc3fb10995f020(size);
        if (tileSize === undefined) {
            // size="16" has been removed — render the icon directly without a tile,
            // using the appearance-derived color so it still matches the intended style.
            const label = props.label ?? '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                role: label ? 'img' : undefined,
                "aria-label": label || undefined,
                "data-testid": props.testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                color: $6846287c8ee6bf50$var$appearanceToStandaloneIconColor[appearance],
                label: ""
            }));
        }
        const { shape: _shape, UNSAFE_circleReplacementComponent: _unsafe, ...tileProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7642E.IconTile), {
            appearance: appearance,
            icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                    ...iconProps,
                    spacing: "spacious"
                }) : Icon,
            size: tileSize,
            ...tileProps
        });
    };
};
module.exports["transformSmartLinkSizeToIconTileSize"] = $6846287c8ee6bf50$export$3acc3fb10995f020;
module.exports["renderIconPerSize"] = $6846287c8ee6bf50$export$28dd5ad82647c000;
module.exports["renderIconTile"] = $6846287c8ee6bf50$export$87c3646d0e299cfe;

});

parcelRegister("fP78j", function(module, exports) {
$parcel$export(module.exports, "default", () => $fce53c8d1c9f5417$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $i7jPX = parcelRequire("i7jPX");

function $fce53c8d1c9f5417$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: label,
        color: color,
        testId: testId,
        // @ts-expect-error - Internal, undocumented prop
        shouldScale: true
    }));
}

});

parcelRegister("j6GAe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $90028f2cad692a01$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db70e40168178b4ae8431bb0df789052>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $fP78j = parcelRequire("fP78j");

function $90028f2cad692a01$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("fAGae", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0f3b40ffeda05888$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a95f50e5543417b936016ac441fe40a9>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $fP78j = parcelRequire("fP78j");

function $0f3b40ffeda05888$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
}

});

parcelRegister("caRYB", function(module, exports) {
const $d9000e0d99d20134$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });
module.exports["doc"] = $d9000e0d99d20134$export$2a111da947c407d2;

});

parcelRegister("9k33u", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $grxv4 = parcelRequire("grxv4");


var $8IHds = parcelRequire("8IHds");

const $93e9546cb0a1512c$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $93e9546cb0a1512c$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $42omo.useMemo)(()=>(0, $grxv4.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $8IHds.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($93e9546cb0a1512c$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        }
    }, children);
};
module.exports["MediaContext"] = $93e9546cb0a1512c$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $93e9546cb0a1512c$export$57164260bc1f1218;

});

parcelRegister("8IHds", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $82Dle = parcelRequire("82Dle");

const $ad9bb6183b9f6f81$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $42omo.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $82Dle.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $ad9bb6183b9f6f81$export$d54af28440a5efc0;

});

parcelRegister("82Dle", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $3a61632aaf261ebb$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $3a61632aaf261ebb$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($3a61632aaf261ebb$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $3a61632aaf261ebb$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $3a61632aaf261ebb$export$2d23ed2854ac1650 = $3a61632aaf261ebb$export$7e209e67b965bc63($3a61632aaf261ebb$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $3a61632aaf261ebb$export$2d23ed2854ac1650;

});

parcelRegister("jRNsq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3rvSa = parcelRequire("3rvSa");


var $9k33u = parcelRequire("9k33u");

const $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $3rvSa.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $9k33u.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345;

});

parcelRegister("O1c6O", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ffCOo = parcelRequire("ffCOo");

const $a6f5bf930119200a$export$f7434a73419cbe6f = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $a6f5bf930119200a$export$73b91fac7f27799f({ data: data, children: children }) {
    const analyticsContextData = (0, $42omo.useMemo)(()=>{
        if (typeof data === 'object') return {
            ...$a6f5bf930119200a$export$f7434a73419cbe6f,
            ...data
        };
        return $a6f5bf930119200a$export$f7434a73419cbe6f;
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ffCOo.PeopleTeamsAnalyticsContext), {
        data: analyticsContextData
    }, children);
}
module.exports["TeamsAppAnalyticsContext"] = $a6f5bf930119200a$export$73b91fac7f27799f;

});

parcelRegister("j5l6c", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $4rwCt = parcelRequire("4rwCt");


var $lGgRw = parcelRequire("lGgRw");


var $9hlns = parcelRequire("9hlns");


var $48FEk = parcelRequire("48FEk");


var $gWF6I = parcelRequire("gWF6I");


var $cVCEk = parcelRequire("cVCEk");


var $6tqQS = parcelRequire("6tqQS");


var $8bvhr = parcelRequire("8bvhr");

const $b8d392bdf2ca0fbb$var$emptyEntryPointParams = {};
const $b8d392bdf2ca0fbb$var$emptyEntryPointProps = {};
const $b8d392bdf2ca0fbb$var$FallbackComponent = ({ fallback: fallback, onUnmount: onUnmount })=>{
    (0, $42omo.useEffect)(()=>{
        return ()=>onUnmount();
    }, [
        onUnmount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, fallback || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), null));
};
function $b8d392bdf2ca0fbb$export$afca832e0d04586a({ trigger: trigger, triggerMode: triggerMode = 'click', entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, forcedReportErrorUFO: forcedReportErrorUFO, onOpen: onOpen, onClose: onClose, ...popupProps }) {
    const environmentProvider = (0, $gWF6I.useRelayEnvironmentProvider)();
    const id = (0, $42omo.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [content, setContent] = (0, $42omo.useState)(null);
    const updateRef = (0, $42omo.useRef)(null);
    const openedByRef = (0, $42omo.useRef)(null);
    const isOpenRef = (0, $42omo.useRef)(isOpen);
    const triggers = Array.isArray(triggerMode) ? triggerMode : [
        triggerMode
    ];
    (0, $42omo.useLayoutEffect)(()=>{
        isOpenRef.current = isOpen;
    }, [
        isOpen
    ]);
    const handleOpen = (0, $42omo.useCallback)((method)=>{
        setIsOpen(true);
        if (method) onOpen?.(method);
    }, [
        onOpen
    ]);
    const handleClose = (0, $42omo.useCallback)((event, currentLevel)=>{
        setIsOpen(false);
        onClose?.(event ?? null, currentLevel);
    }, [
        onClose
    ]);
    const load = (0, $42omo.useCallback)(()=>(0, $irOoi.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $b8d392bdf2ca0fbb$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $42omo.useCallback)(({ reference: entryPointReference })=>{
        if (isOpenRef.current) return;
        handleOpen(openedByRef.current);
        setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48FEk.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b8d392bdf2ca0fbb$var$FallbackComponent, {
                fallback: fallback,
                onUnmount: ()=>updateRef.current?.()
            }),
            errorFallback: errorFallback,
            runtimeProps: {
                ...entryPointProps ?? $b8d392bdf2ca0fbb$var$emptyEntryPointProps,
                onContentResized: ()=>{
                    updateRef.current?.();
                },
                onClose: handleClose
            },
            onError: onError,
            forcedError: forcedReportErrorUFO
        }));
    }, [
        setContent,
        id,
        entryPointProps,
        fallback,
        forcedReportErrorUFO,
        errorFallback,
        handleOpen,
        onError,
        handleClose
    ]);
    const preloadRef = (0, $6tqQS.usePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const pressableRef = (0, $8bvhr.usePressableTriggerRef)({
        onOpen: preloadRef.loadAndOpen,
        onClose: handleClose,
        isOpen: isOpen,
        isDisabled: !triggers.includes('click'),
        openedByRef: openedByRef
    });
    const { triggerRef: hoverTriggerRef, contentRef: hoverContentRef } = (0, $cVCEk.useHoverTriggerRef)({
        onOpen: preloadRef.loadAndOpen,
        onClose: handleClose,
        isOpen: isOpen,
        isDisabled: !triggers.includes('hover'),
        openedByRef: openedByRef
    });
    (0, $42omo.useEffect)(()=>{
        if (!isOpen) openedByRef.current = null;
    }, [
        isOpen
    ]);
    const popupTrigger = (0, $42omo.useCallback)((triggerProps)=>{
        const mergedRef = (0, $4rwCt.mergeRefs)([
            preloadRef,
            pressableRef,
            hoverTriggerRef,
            triggerProps.ref
        ]);
        return trigger({
            ...triggerProps,
            ref: mergedRef
        });
    }, [
        trigger,
        preloadRef,
        pressableRef,
        hoverTriggerRef
    ]);
    const popupContent = (0, $42omo.useCallback)(({ update: update })=>{
        updateRef.current = update;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: hoverContentRef,
            role: "none",
            "data-vc": "WHHOppMa"
        }, content);
    }, [
        content,
        hoverContentRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.Popup), {
        ...popupProps,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent
    });
}
module.exports["PopupTriggerWithHover"] = $b8d392bdf2ca0fbb$export$afca832e0d04586a;

});

parcelRegister("cVCEk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $dURKH = parcelRequire("dURKH");


var $9atrt = parcelRequire("9atrt");

const $fc5e81d0067479e5$var$HOVER_OPEN_DELAY = 800;
const $fc5e81d0067479e5$var$HOVER_CLOSE_DELAY = 200;
function $fc5e81d0067479e5$export$b8df9ab832b125ac({ onOpen: onOpen, onClose: onClose, isOpen: isOpen = false, isDisabled: isDisabled = false, openedByRef: openedByRef, delays: delays = {} }) {
    const { hoverOpen: hoverOpen = $fc5e81d0067479e5$var$HOVER_OPEN_DELAY, hoverClose: hoverClose = $fc5e81d0067479e5$var$HOVER_CLOSE_DELAY } = delays;
    const triggerNodeRef = (0, $42omo.useRef)(null);
    const triggerListeners = (0, $42omo.useRef)([]);
    const contentNodeRef = (0, $42omo.useRef)(null);
    const contentListeners = (0, $42omo.useRef)(new Map());
    const isOpenRef = (0, $42omo.useRef)(isOpen);
    (0, $42omo.useLayoutEffect)(()=>{
        isOpenRef.current = isOpen;
    }, [
        isOpen
    ]);
    const openDelay = (0, $dURKH.useHoverDelay)(()=>{
        if (isOpenRef.current) return;
        if (openedByRef) openedByRef.current = 'hover';
        onOpen();
    }, hoverOpen);
    const closeDelay = (0, $dURKH.useHoverDelay)(()=>{
        if (!isOpenRef.current) return;
        if (!openedByRef || openedByRef.current === 'hover') onClose?.();
    }, hoverClose);
    const openDelayRef = (0, $42omo.useRef)(openDelay);
    const closeDelayRef = (0, $42omo.useRef)(closeDelay);
    openDelayRef.current = openDelay;
    closeDelayRef.current = closeDelay;
    const handleTriggerEnter = (0, $42omo.useCallback)(()=>{
        closeDelayRef.current.clear();
        openDelayRef.current.schedule();
    }, []);
    const handleTriggerLeave = (0, $42omo.useCallback)(()=>{
        openDelayRef.current.clear();
        closeDelayRef.current.schedule();
    }, []);
    const triggerRef = (0, $42omo.useCallback)((element)=>{
        if (element === triggerNodeRef.current) return;
        triggerListeners.current.forEach((unbind)=>unbind());
        triggerListeners.current = [];
        triggerNodeRef.current = element;
        if (element && !isDisabled) triggerListeners.current.push((0, $fFa3V.bind)(element, {
            type: 'mouseenter',
            listener: handleTriggerEnter
        }), (0, $fFa3V.bind)(element, {
            type: 'mouseleave',
            listener: handleTriggerLeave
        }));
    }, [
        handleTriggerEnter,
        handleTriggerLeave,
        isDisabled
    ]);
    const handleContentEnter = (0, $42omo.useCallback)(()=>{
        closeDelayRef.current.clear();
    }, []);
    const cleanupContentListeners = (0, $42omo.useCallback)(()=>{
        contentListeners.current.forEach((unbind)=>unbind());
        contentListeners.current.clear();
    }, []);
    const attachContentListeners = (0, $42omo.useCallback)((element)=>{
        if (contentListeners.current.has(element)) return;
        const handleMouseLeave = (event)=>{
            if (!(0, $9atrt.hasRelatedTarget)(event)) return;
            const relatedTarget = event.relatedTarget;
            if ((0, $9atrt.isMovingToKudos)(relatedTarget)) return;
            const childPortal = (0, $9atrt.getChildPortalFromParentPopup)(relatedTarget, contentNodeRef.current);
            if (childPortal) {
                attachContentListeners(childPortal);
                return;
            }
            closeDelayRef.current.schedule();
        };
        const unbindEnter = (0, $fFa3V.bind)(element, {
            type: 'mouseenter',
            listener: handleContentEnter
        });
        const unbindLeave = (0, $fFa3V.bind)(element, {
            type: 'mouseleave',
            listener: handleMouseLeave
        });
        contentListeners.current.set(element, ()=>{
            unbindEnter();
            unbindLeave();
        });
    }, [
        handleContentEnter
    ]);
    const contentRef = (0, $42omo.useCallback)((element)=>{
        if (element === contentNodeRef.current) return;
        cleanupContentListeners();
        contentNodeRef.current = element;
        if (element && !isDisabled) attachContentListeners(element);
    }, [
        attachContentListeners,
        cleanupContentListeners,
        isDisabled
    ]);
    (0, $42omo.useEffect)(()=>{
        const listeners = contentListeners.current;
        const triggers = triggerListeners.current;
        return ()=>{
            openDelayRef.current.clear();
            closeDelayRef.current.clear();
            triggers.forEach((unbind)=>unbind());
            listeners.forEach((unbind)=>unbind());
        };
    }, []);
    return {
        triggerRef: triggerRef,
        contentRef: contentRef
    };
}
module.exports["useHoverTriggerRef"] = $fc5e81d0067479e5$export$b8df9ab832b125ac;

});

parcelRegister("dURKH", function(module, exports) {

var $42omo = parcelRequire("42omo");

/**
 * Hook for managing delayed hover actions with timeout management.
 */ function $c31b2fcc25ec339e$export$beb151954e0eb9fa(callback, delay) {
    const timeoutRef = (0, $42omo.useRef)(null);
    const callbackRef = (0, $42omo.useRef)(callback);
    (0, $42omo.useEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    const clear = (0, $42omo.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);
    const schedule = (0, $42omo.useCallback)(()=>{
        clear();
        timeoutRef.current = window.setTimeout(()=>{
            callbackRef.current();
        }, delay);
    }, [
        delay,
        clear
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>clear();
    }, [
        clear
    ]);
    return {
        schedule: schedule,
        clear: clear
    };
}
module.exports["useHoverDelay"] = $c31b2fcc25ec339e$export$beb151954e0eb9fa;

});

parcelRegister("9atrt", function(module, exports) {
/**
 * Type guard to check if an event has a relatedTarget property.
 */ function $304c1579b8ce8624$export$63ce2e5e32c4f6a0(event) {
    return 'relatedTarget' in event;
}
/**
 * Checks if the mouse is moving to an atlaskit portal or kudos modal
 * where we should prevent the popup from closing
 */ function $304c1579b8ce8624$export$386001e6036bddcf(relatedTarget) {
    if (!(relatedTarget instanceof HTMLElement)) return false;
    const iframe = relatedTarget.closest('.atlaskit-portal')?.querySelector('iframe') || relatedTarget.closest('iframe');
    return iframe instanceof HTMLIFrameElement && iframe.src.includes('give-kudos');
}
/**
 * Returns the child portal if mouse is moving to a portal controlled by the parent popup.
 */ function $304c1579b8ce8624$export$a5fb0bbf4bb0e26a(relatedTarget, parentPopupElement) {
    if (!(relatedTarget instanceof HTMLElement) || !parentPopupElement) return null;
    const portal = relatedTarget.closest('.atlaskit-portal');
    if (!portal) return null;
    for (const trigger of Array.from(parentPopupElement.querySelectorAll('[aria-controls]'))){
        const controlsId = trigger.getAttribute('aria-controls');
        if (controlsId && portal.querySelector(`#${controlsId}`)) return portal;
    }
    return null;
}
module.exports["hasRelatedTarget"] = $304c1579b8ce8624$export$63ce2e5e32c4f6a0;
module.exports["isMovingToKudos"] = $304c1579b8ce8624$export$386001e6036bddcf;
module.exports["getChildPortalFromParentPopup"] = $304c1579b8ce8624$export$a5fb0bbf4bb0e26a;

});

parcelRegister("6tqQS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");

const $8aae14190b57ed3c$var$PRELOAD_MAX_AGE = 300000;
const $8aae14190b57ed3c$var$TIME_TO_INTENT = 200;
function $8aae14190b57ed3c$export$e0cecaf2b8cc8d36({ load: load, onLoad: onLoad }) {
    const nodeRef = (0, $42omo.useRef)(null);
    const eventListeners = (0, $42omo.useRef)([]);
    const { loadAndOpen: loadAndOpen, preloadReference: preloadReference, cancelPreload: cancelPreload } = (0, $42omo.useMemo)(()=>{
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (request.preloadIntentTimeout != null) {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (request.preloadMaxAgeTimeout != null) {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const loadAndOpen = ()=>{
            clearPreloadTimeouts();
            onLoad(loadReference());
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $8aae14190b57ed3c$var$PRELOAD_MAX_AGE);
            }, $8aae14190b57ed3c$var$TIME_TO_INTENT);
        };
        return {
            loadAndOpen: loadAndOpen,
            preloadReference: preloadReference,
            cancelPreload: cancelPreload
        };
    }, [
        load,
        onLoad
    ]);
    const cleanUpEventListeners = (0, $42omo.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $42omo.useCallback)((element, type, callback)=>{
        const unbind = (0, $fFa3V.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $42omo.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) {
                cancelPreload();
                cleanUpEventListeners();
            }
            if (element) {
                addEventListener(element, 'mouseenter', preloadReference);
                addEventListener(element, 'mouseleave', cancelPreload);
            }
            nodeRef.current = element;
        }
    }, [
        preloadReference,
        cancelPreload,
        addEventListener,
        cleanUpEventListeners
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return Object.assign(refCallback, {
        loadAndOpen: loadAndOpen
    });
}
module.exports["usePreloadRef"] = $8aae14190b57ed3c$export$e0cecaf2b8cc8d36;

});

parcelRegister("8bvhr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");

function $cbc21cfc4e7583ca$export$186b93979375b734({ onOpen: onOpen, onClose: onClose, isOpen: isOpen = false, isDisabled: isDisabled = false, openedByRef: openedByRef }) {
    const nodeRef = (0, $42omo.useRef)(null);
    const eventListeners = (0, $42omo.useRef)([]);
    const handleOpen = (0, $42omo.useCallback)(()=>{
        if (isOpen) onClose?.();
        else {
            if (openedByRef) openedByRef.current = 'click';
            onOpen();
        }
    }, [
        isOpen,
        onClose,
        openedByRef,
        onOpen
    ]);
    const keydownListener = (0, $42omo.useCallback)((event)=>{
        if (event instanceof KeyboardEvent && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            handleOpen();
        }
    }, [
        handleOpen
    ]);
    const cleanUpEventListeners = (0, $42omo.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $42omo.useCallback)((element, type, callback)=>{
        const unbind = (0, $fFa3V.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $42omo.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) cleanUpEventListeners();
            if (element) {
                if (!isDisabled) addEventListener(element, 'click', handleOpen);
                // Always attach keydown for keyboard accessibility
                addEventListener(element, 'keydown', keydownListener);
            }
            nodeRef.current = element;
        }
    }, [
        handleOpen,
        keydownListener,
        addEventListener,
        cleanUpEventListeners,
        isDisabled
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return refCallback;
}
module.exports["usePressableTriggerRef"] = $cbc21cfc4e7583ca$export$186b93979375b734;

});

parcelRegister("eToX6", function(module, exports) {
/**
 * Utility functions for detecting and working with preview panels
 */ // Types for preview panel detection
// Preview panel indicators
const $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
/**
 * Gets URL search parameters safely
 */ const $cf00e918e2c1556d$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $cf00e918e2c1556d$export$5c3b154013d00c5f = (searchParams)=>{
    return searchParams.has($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $cf00e918e2c1556d$export$cd88bef28d20da33 = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $cf00e918e2c1556d$var$getUrlSearchParams(currentSearch);
            if (currentParams && $cf00e918e2c1556d$export$5c3b154013d00c5f(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $cf00e918e2c1556d$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
module.exports["hasPreviewPanelIndicators"] = $cf00e918e2c1556d$export$5c3b154013d00c5f;
module.exports["isInPreviewPanel"] = $cf00e918e2c1556d$export$cd88bef28d20da33;
module.exports["isInIframe"] = $cf00e918e2c1556d$export$9f140ed41af5108c;

});

parcelRegister("iH7AG", function(module, exports) {

var $hIjpx = parcelRequire("hIjpx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/database/manifest.ts
var $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $hIjpx.ConfluenceDatabaseAriResourceOwner),
    resourceType: (0, $hIjpx.ConfluenceDatabaseAriResourceType),
    resourceIdSlug: "activation/{activationId}/{databaseId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        databaseId: /[0-9]+/
    }
};
// src/confluence/database/index.ts
var $d9c22183dba005c8$export$317cd32472deea7e = class _ConfluenceDatabaseAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.qualifier,
            platformQualifier: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.resourceOwner,
            resourceType: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};
module.exports["ConfluenceDatabaseAri"] = $d9c22183dba005c8$export$317cd32472deea7e;

});

parcelRegister("hIjpx", function(module, exports) {
// src/confluence/database/types.ts
var $ce559a57d4ba003b$export$e83bc7b627335f1d = "confluence", $ce559a57d4ba003b$export$d26db9a1a0b750aa = "database";
module.exports["ConfluenceDatabaseAriResourceOwner"] = $ce559a57d4ba003b$export$e83bc7b627335f1d;
module.exports["ConfluenceDatabaseAriResourceType"] = $ce559a57d4ba003b$export$d26db9a1a0b750aa;

});

parcelRegister("dM0Qh", function(module, exports) {

var $dPsPU = parcelRequire("dPsPU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/embed/manifest.ts
var $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $dPsPU.ConfluenceEmbedAriResourceOwner),
    resourceType: (0, $dPsPU.ConfluenceEmbedAriResourceType),
    resourceIdSlug: "activation/{activationId}/{embedId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        embedId: /[0-9]+/
    }
};
// src/confluence/embed/index.ts
var $a070694ffdc5cb3b$export$47d4b4205d0ac61a = class _ConfluenceEmbedAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get embedId() {
        return this._embedId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.qualifier,
            platformQualifier: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.resourceOwner,
            resourceType: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.embedId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                embedId: opts.embedId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            embedId: this.embedId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
    }
};
module.exports["ConfluenceEmbedAri"] = $a070694ffdc5cb3b$export$47d4b4205d0ac61a;

});

parcelRegister("dPsPU", function(module, exports) {
// src/confluence/embed/types.ts
var $a116681263506e39$export$7a02af293cacddd2 = "confluence", $a116681263506e39$export$f817d48842ea0d4a = "embed";
module.exports["ConfluenceEmbedAriResourceOwner"] = $a116681263506e39$export$7a02af293cacddd2;
module.exports["ConfluenceEmbedAriResourceType"] = $a116681263506e39$export$f817d48842ea0d4a;

});

parcelRegister("lb1Mg", function(module, exports) {

var $bYbE5 = parcelRequire("bYbE5");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/folder/manifest.ts
var $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $bYbE5.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $bYbE5.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $f6ac010730fe9d5d$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};
module.exports["ConfluenceFolderAri"] = $f6ac010730fe9d5d$export$501a782385a3f485;

});

parcelRegister("bYbE5", function(module, exports) {
// src/confluence/folder/types.ts
var $8b6e54dbbb0b2632$export$77cf4e1b17902bfa = "confluence", $8b6e54dbbb0b2632$export$6256ff329bc25a9c = "folder";
module.exports["ConfluenceFolderAriResourceOwner"] = $8b6e54dbbb0b2632$export$77cf4e1b17902bfa;
module.exports["ConfluenceFolderAriResourceType"] = $8b6e54dbbb0b2632$export$6256ff329bc25a9c;

});

parcelRegister("kYvrE", function(module, exports) {

var $3lhEv = parcelRequire("3lhEv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/site/manifest.ts
var $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $3lhEv.ConfluenceSiteAriResourceOwner),
    resourceType: (0, $3lhEv.ConfluenceSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/confluence/site/index.ts
var $f451cd8c9de7a9df$export$82e6693d75ffdd8 = class _ConfluenceSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.qualifier,
            platformQualifier: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.resourceOwner,
            resourceType: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["ConfluenceSiteAri"] = $f451cd8c9de7a9df$export$82e6693d75ffdd8;

});

parcelRegister("3lhEv", function(module, exports) {
// src/confluence/site/types.ts
var $26f1069ffd8f654d$export$9e07499cd8b0bde5 = "confluence", $26f1069ffd8f654d$export$57b7cabbf31f1f68 = "site";
module.exports["ConfluenceSiteAriResourceOwner"] = $26f1069ffd8f654d$export$9e07499cd8b0bde5;
module.exports["ConfluenceSiteAriResourceType"] = $26f1069ffd8f654d$export$57b7cabbf31f1f68;

});

parcelRegister("7CLBv", function(module, exports) {

var $ipwYn = parcelRequire("ipwYn");

/** Used to compose bitmasks for cloning. */ var $58d10224aec51c86$var$CLONE_DEEP_FLAG = 1, $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $58d10224aec51c86$var$cloneDeep(value) {
    return $ipwYn(value, $58d10224aec51c86$var$CLONE_DEEP_FLAG | $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $58d10224aec51c86$var$cloneDeep;

});

parcelRegister("bavCP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jMyy4 = parcelRequire("jMyy4");

const $86f32d96feea2a1f$export$67f105fad14d18d = (0, $3u0dr.isReactCompilerActiveV2)() ? function QueryInterop(t0) {
    const $ = (0, $frIzR.c)(7);
    let children;
    let props;
    let query;
    if ($[0] !== t0) {
        ({ children: children, query: query, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = query;
    } else {
        children = $[1];
        props = $[2];
        query = $[3];
    }
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    let t1;
    if ($[4] !== children || $[5] !== result) {
        t1 = children(result);
        $[4] = children;
        $[5] = result;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : function QueryInterop({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
};
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $ay6Zz = parcelRequire("ay6Zz");


var $bYUc2 = parcelRequire("bYUc2");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    const isNav4Enabled = (0, $bYUc2.getIsNav4EnabledSafe)();
    return (0, $ay6Zz.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: isNav4Enabled,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("eB56w", function(module, exports) {

var $fOAkx = parcelRequire("fOAkx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/blogpost/manifest.ts
var $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $fOAkx.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $fOAkx.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $aa087af90d1c8aca$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $aa087af90d1c8aca$export$8602a2c2f6ac09bc;

});

parcelRegister("fOAkx", function(module, exports) {
// src/confluence/blogpost/types.ts
var $b837b4f269c93ee4$export$9389f06bd1d0765c = "confluence", $b837b4f269c93ee4$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $b837b4f269c93ee4$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $b837b4f269c93ee4$export$fb777a2d645a4129;

});

parcelRegister("a5Dk4", function(module, exports) {

var $aOBEU = parcelRequire("aOBEU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/whiteboard/manifest.ts
var $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $aOBEU.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $aOBEU.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $7588dfadc8876fc5$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $7588dfadc8876fc5$export$ba3d25b6768ddb10;

});

parcelRegister("aOBEU", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $7dfbc92767b8c664$export$6130ea1abbb885ef = "confluence", $7dfbc92767b8c664$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $7dfbc92767b8c664$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $7dfbc92767b8c664$export$d3070d1568a10e2d;

});

parcelRegister("5yfLD", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("5k6WH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $uRQKa = parcelRequire("uRQKa");


var $6ttbq = parcelRequire("6ttbq");

const $479e1e8ac650b5b6$export$c537e63161742ce3 = ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $42omo.useState)((0, $6ttbq.isReducedMotion));
    (0, $42omo.useEffect)(()=>{
        if (!(0, $uRQKa.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $fFa3V.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
module.exports["useIsReducedMotion"] = $479e1e8ac650b5b6$export$c537e63161742ce3;

});

parcelRegister("1a6Dn", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $hrAmX = parcelRequire("hrAmX");

class $d3905c2d386f370c$export$c59406a16f2704a5 extends (0, $T1bCI.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            floatingBanners: []
        };
        this.showFloating = (name, height)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.push({
                    name: name,
                    height: height
                });
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
            else if (this.state.floatingBanners[index].height !== height) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray[index].height = height;
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.hideFloating = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index > -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.splice(index, 1);
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.getFloatingHeightBefore = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) return 0;
            return this.state.floatingBanners.slice(0, index).reduce((height, banner)=>{
                return height + banner.height;
            }, 0);
        };
        this.getFloatingHeight = ()=>this.state.floatingBanners.reduce((height, banner)=>height + banner.height, 0);
    }
}
module.exports["FloatingBannerStateContainer"] = $d3905c2d386f370c$export$c59406a16f2704a5;

});

parcelRegister("hrAmX", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $i3jcY = parcelRequire("i3jcY");


var $6mKj3 = parcelRequire("6mKj3");


var $1dnxO = parcelRequire("1dnxO");

const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.indexOf(inArray.filter((banner)=>banner.name === name)[0]);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $T1bCI.Container) {
    constructor(props = {}){
        super();
        this.topNavHeight = void 0;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index === -1) return {
                    ...state,
                    banners: [
                        ...state.banners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                else if (state.banners[index].height !== height) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray[index].height = height;
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index > -1) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        let navHeight = (0, $1dnxO.getIsNav4Enabled)() ? 48 : 56;
        if (// The increased height change is only applied when FHS is enabled.
        // Ideally we could check `useIsFhsEnabled()` but we can't use hooks here.
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('navx-full-height-sidebar-exp', 'isEnabled', false)) navHeight = 56;
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.state.banners = (0, $i3jcY.isStableUIEnabledForTests)() ? [] : props.initialState?.banners || [];
    }
}
module.exports["findBanner"] = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620;
module.exports["BannerStateContainer"] = $6ee3834dea9f6c5c$export$bbac707b3ebb5681;

});

parcelRegister("8WfxO", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $eSLr0 = parcelRequire("eSLr0");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");


var $dS3n9 = parcelRequire("dS3n9");

const $720c81ac24834d84$export$dc9cc84753faedac = ()=>{
    const $ = (0, $frIzR.c)(10);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const atlGeneralHeightChanges = (0, $42omo.useRef)(t0);
    const [webPanelHeight, setWebPanelHeight] = (0, $42omo.useState)($720c81ac24834d84$var$_temp);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, spaceKey: spaceKey } = t1;
    let t2;
    if ($[1] !== contentId || $[2] !== spaceKey) {
        t2 = {
            location: (0, $eSLr0.ATL_GENERAL),
            fetchPolicy: "cache-first",
            spaceKey: spaceKey,
            contentId: contentId
        };
        $[1] = contentId;
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)(t2);
    const isATLGeneralWebPanelFixed = panels.length > 0;
    let t3;
    let t4;
    if ($[4] !== isATLGeneralWebPanelFixed) {
        t3 = ()=>{
            const listener = (e)=>{
                let newHeight;
                if ((0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
                    setWebPanelHeight(e?.detail?.height ?? 0);
                    newHeight = e?.detail?.height ?? 0;
                } else {
                    setWebPanelHeight($720c81ac24834d84$var$getAtlGeneralWebPanelHeight());
                    newHeight = $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
                }
                if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__)) {
                    const lastHeight = atlGeneralHeightChanges.current.length === 0 ? window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__ || 0 : atlGeneralHeightChanges.current[atlGeneralHeightChanges.current.length - 1];
                    if (lastHeight !== newHeight) atlGeneralHeightChanges.current.push(newHeight);
                    window.__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__ = atlGeneralHeightChanges.current;
                }
            };
            if (isATLGeneralWebPanelFixed) document.addEventListener("atlGeneralWebPanelHeightUpdated", listener);
            return ()=>{
                if (isATLGeneralWebPanelFixed) document.removeEventListener("atlGeneralWebPanelHeightUpdated", listener);
            };
        };
        t4 = [
            isATLGeneralWebPanelFixed
        ];
        $[4] = isATLGeneralWebPanelFixed;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[7] !== isATLGeneralWebPanelFixed || $[8] !== webPanelHeight) {
        t5 = {
            isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
            atlGeneralWebPanelHeight: webPanelHeight
        };
        $[7] = isATLGeneralWebPanelFixed;
        $[8] = webPanelHeight;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};
const $720c81ac24834d84$var$getAtlGeneralWebPanelHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--atl-general-webpanel-height')) || 0;
};
function $720c81ac24834d84$var$_temp() {
    if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
        const initialHeight = window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__;
        return initialHeight ?? 0;
    } else return $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
}
module.exports["useATLGeneralWebPanelListener"] = $720c81ac24834d84$export$dc9cc84753faedac;

});

parcelRegister("4KFTW", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $38a1fdadc870189c$export$ed05b2901e9d7d22({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name, timeout: timeout }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).start({
            attributes: attributes,
            name: name,
            timeout: timeout,
            id: attributes?.macroId || contentId
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name,
        timeout
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStart"] = $38a1fdadc870189c$export$ed05b2901e9d7d22;

});

parcelRegister("cLo2u", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $frIzR.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("83Z6R", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jxs8y = parcelRequire("jxs8y");


var $86okN = parcelRequire("86okN");

const $b847dc1d37d68706$export$dcf9d4e77de27956 = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryPromiseInterop(query, options) {
    const $ = (0, $frIzR.c)(11);
    const resolversRef = (0, $42omo.useRef)();
    let t0;
    if ($[0] !== query) {
        t0 = (0, $86okN.toDocumentNode)(query);
        $[0] = query;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== options || $[3] !== t0) {
        t1 = [
            t0,
            options
        ];
        $[2] = options;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    const [doQuery, t2] = (0, $jxs8y.useLazyQuery)(...t1);
    const { data: data, error: error } = t2;
    let t3;
    let t4;
    if ($[5] !== data || $[6] !== error) {
        t3 = ()=>{
            if (data) resolversRef.current?.resolve?.(data);
            if (error) resolversRef.current?.reject?.(error);
        };
        t4 = [
            data,
            error
        ];
        $[5] = data;
        $[6] = error;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== doQuery) {
        t5 = (vars)=>{
            let resolve;
            let reject;
            const promise = new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
            resolversRef.current = {
                resolve: resolve,
                reject: reject
            };
            doQuery(vars);
            return promise;
        };
        $[9] = doQuery;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : function useLazyQueryPromiseInterop(query, options) {
    const resolversRef = (0, $42omo.useRef)();
    /**
   * NOTE: Using `onCompleted` and `onError` callbacks does not work as expected due to Apollo bug which is present in both v2 and v3 - https://github.com/apollographql/apollo-client/issues/9338
   */ const [doQuery, { data: data, error: error }] = (0, $jxs8y.useLazyQuery)(...[
        (0, $86okN.toDocumentNode)(query),
        options
    ]);
    (0, $42omo.useEffect)(()=>{
        if (data) resolversRef.current?.resolve?.(data);
        if (error) resolversRef.current?.reject?.(error);
    }, [
        data,
        error
    ]);
    return (0, $42omo.useCallback)((vars)=>{
        let resolve;
        let reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        // @ts-expect-error `resolve` and `reject` *will* be assigned via the Promise constructor, but TS can't guarantee that. This should be replaced with `Promise.withResolvers` once out jest setup properly supports that
        resolversRef.current = {
            resolve: resolve,
            reject: reject
        };
        doQuery(vars);
        return promise;
    }, [
        doQuery
    ]);
};
module.exports["useLazyQueryPromiseInterop"] = $b847dc1d37d68706$export$dcf9d4e77de27956;

});

parcelRegister("4cOi8", function(module, exports) {
var $c7f67cb608b5916f$export$bdc3c19374266b98 = /*#__PURE__*/ function(ButtonStyle) {
    ButtonStyle["DEFAULT"] = "default";
    ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
    return ButtonStyle;
}({});
var $c7f67cb608b5916f$export$a6e645fda5339bf8 = /*#__PURE__*/ function(CornerStyle) {
    CornerStyle["ROUNDED"] = "rounded";
    CornerStyle["SQUARED"] = "squared";
    return CornerStyle;
}({});
var $c7f67cb608b5916f$export$8954cfac7c08d16a = /*#__PURE__*/ function(Height) {
    Height["MEDIUM"] = "medium";
    Height["SMALL"] = "small";
    Height["LARGE"] = "large";
    return Height;
}({});
var $c7f67cb608b5916f$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
    Alignment["CENTER"] = "center";
    return Alignment;
}({});
var $c7f67cb608b5916f$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $c7f67cb608b5916f$export$21e76ed09a093e97 = /*#__PURE__*/ function(CardLayout) {
    CardLayout["FOLDERS"] = "folders";
    CardLayout["ACCORDIONS"] = "accordions";
    return CardLayout;
}({});
var $c7f67cb608b5916f$export$42809f9f1496f50d = /*#__PURE__*/ function(CommonLayout) {
    CommonLayout["FRAME_ABOVE_IMAGE"] = "frame-above-image";
    CommonLayout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
    CommonLayout["SPLIT_IMAGE_LEFT"] = "split-image-left";
    CommonLayout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
    CommonLayout["NO_IMAGE_BACKGROUND"] = "no-image-background";
    return CommonLayout;
}({});
var $c7f67cb608b5916f$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    FeedbackType["CUSTOM_SEARCH"] = "Custom search";
    return FeedbackType;
}({});
var $c7f67cb608b5916f$export$533ae1c1b7b7ac6 = /*#__PURE__*/ function(ExtensionMode) {
    ExtensionMode["RENDERER"] = "renderer";
    ExtensionMode["EDITOR"] = "editor";
    return ExtensionMode;
}({});
const $c7f67cb608b5916f$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
var $c7f67cb608b5916f$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $c7f67cb608b5916f$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});
var $c7f67cb608b5916f$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    // group preferences stored via this field when segmentationTarget is EACH
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});
module.exports["ButtonStyle"] = $c7f67cb608b5916f$export$bdc3c19374266b98;
module.exports["CornerStyle"] = $c7f67cb608b5916f$export$a6e645fda5339bf8;
module.exports["Height"] = $c7f67cb608b5916f$export$8954cfac7c08d16a;
module.exports["Alignment"] = $c7f67cb608b5916f$export$9d7927214ed7d2cf;
module.exports["Orientation"] = $c7f67cb608b5916f$export$df54d73aa0ec5e82;
module.exports["CardLayout"] = $c7f67cb608b5916f$export$21e76ed09a093e97;
module.exports["CommonLayout"] = $c7f67cb608b5916f$export$42809f9f1496f50d;
module.exports["FeedbackType"] = $c7f67cb608b5916f$export$d4c0482bf980ef26;
module.exports["ExtensionMode"] = $c7f67cb608b5916f$export$533ae1c1b7b7ac6;
module.exports["RenderVariant"] = $c7f67cb608b5916f$export$1f60141b6ce5efed;
module.exports["SegmentationTargets"] = $c7f67cb608b5916f$export$f6cd408cac7f930c;
module.exports["ITEM_FIELDS"] = $c7f67cb608b5916f$export$bf7ebf7fed6e7189;

});

parcelRegister("lOeVN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8aF6s = parcelRequire("8aF6s");


var $jmjWc = parcelRequire("jmjWc");

function $926167cc1656a619$export$4be696be8a3bff13(props) {
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const propsRef = (0, $42omo.useRef)();
    propsRef.current = props;
    return (0, $42omo.useCallback)(()=>showModal($926167cc1656a619$var$FeedbackCollectorLoader, propsRef.current), [
        showModal
    ]);
}

const $926167cc1656a619$var$FeedbackCollectorLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nSIir",
    name: "FeedbackCollectorLoader",
    loader: async ()=>(await (parcelRequire("1421M"))).FeedbackCollector
});
module.exports["useFeedbackCollector"] = $926167cc1656a619$export$4be696be8a3bff13;

});

parcelRegister("1421M", function(module, exports) {

let $0c67bcd931c05ad3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0c67bcd931c05ad3$var$load("6wr18"),
    $0c67bcd931c05ad3$var$load("ffEVr"),
    $0c67bcd931c05ad3$var$load("bUC6C")
]).then(()=>parcelRequire('cz7bE'));

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("eLV9q", function(module, exports) {
$parcel$export(module.exports, "useGetNavigateToTeamsApp", () => (parcelRequire("eWzPA")).useGetNavigateToTeamsApp);

var $eWzPA = parcelRequire("eWzPA");


});

parcelRegister("eWzPA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ay6Zz = parcelRequire("ay6Zz");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $bYUc2 = parcelRequire("bYUc2");

const $8c3fac113683eb0d$export$bb1230c0e6efa9dc = ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const getNavigateToTeamsApp = (navActionPayload, shouldOpenInSameTab)=>{
        return (0, $ay6Zz.navigateToTeamsApp)({
            hostProduct: 'confluence',
            orgId: orgId,
            cloudId: cloudId,
            userHasNav4Enabled: (0, $bYUc2.getIsNav4EnabledSafe)(),
            shouldOpenInSameTab: shouldOpenInSameTab,
            ...navActionPayload
        });
    };
    const getNavigateToTeamsAppCallback = (0, $42omo.useCallback)(getNavigateToTeamsApp, [
        cloudId,
        orgId
    ]);
    return (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? getNavigateToTeamsAppCallback : getNavigateToTeamsApp;
};
module.exports["useGetNavigateToTeamsApp"] = $8c3fac113683eb0d$export$bb1230c0e6efa9dc;

});

parcelRegister("4o1RV", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $iV5Ic = parcelRequire("iV5Ic");


var $ihkY1 = parcelRequire("ihkY1");


var $kBW0t = parcelRequire("kBW0t");

function $f3bd82ae210529c7$export$57395cb9dce31159() {
    const $ = (0, $frIzR.c)(3);
    const { navigationPolicy: navigationPolicy } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    let t0;
    if ($[0] !== routePolicy || $[1] !== shimUrl) {
        t0 = {
            routePolicy: routePolicy,
            ...shimUrl
        };
        $[0] = routePolicy;
        $[1] = shimUrl;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
}
module.exports["useNavigationPolicy"] = $f3bd82ae210529c7$export$57395cb9dce31159;

});

parcelRegister("ihkY1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1iSzD = parcelRequire("1iSzD");


var $iV5Ic = parcelRequire("iV5Ic");


var $cb6fO = parcelRequire("cb6fO");


var $kBW0t = parcelRequire("kBW0t");

function $477c5af85d2d7fb0$export$53e37724c6846f41(navigationPolicy) {
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { shimUrl: shimUrl } = (0, $kBW0t.useShimUrl)(navigationPolicy);
    const iframePassThroughProps = (0, $iV5Ic.useReactProps_DO_NOT_USE)();
    const enableIframeSpaTransitions = iframePassThroughProps?.enableSpaTransitions;
    const getEmbeddedConfluenceRoutePolicy = (0, $42omo.useCallback)(()=>({
            push ({ match: match, matchSupportedRoute: matchSupportedRoute, open: open, push: defaultPush }, url, forceReload) {
                // When navigate to an url with anchor only e.g. `#test`, the navigation doesn't need to continue as SPA transition,
                // Hence, there is no need to continue the navigation using `push` and potentially execute parent product's navigate method.
                // In this case, we exit `routePolicy.push` earlier and use `open` (window.open) to load the url in the exisitng browsing context
                if ((0, $cb6fO.isHashedOnlyURL)(url)) {
                    open(url, '_self');
                    return;
                }
                const _currRouteName = match?.name;
                const _currRouteContentId = match?.params.contentId;
                const _destinationRoute = matchSupportedRoute(url);
                const _dstRouteName = _destinationRoute?.name;
                const _dstRouteContentId = _destinationRoute?.params.contentId;
                const _dstRouteSpaceKey = _destinationRoute?.params.spaceKey;
                /**
       * Transition within the same window if the target route is navigating to the same content
       * This can ensure link to anchors in the page can still happen within the same window, instead of opening a new tab
       **/ const modifiers = {
                    routeName: $477c5af85d2d7fb0$var$toEPRouteName(_dstRouteName),
                    contentId: _dstRouteContentId,
                    spaceKey: _dstRouteSpaceKey,
                    target: this.willPushInSelf(_currRouteName, _currRouteContentId, _dstRouteName, _dstRouteContentId) ? '_self' : '_blank'
                };
                const defaultNavigate = (url_0, { target: target })=>{
                    // We double check the url here in case parent product modify the `url` in `navigate` function and provided the hashed-only url to `defaultNavigate`
                    if ((0, $cb6fO.isHashedOnlyURL)(url_0)) {
                        open(url_0, '_self');
                        return;
                    }
                    const destRoute = matchSupportedRoute(url_0);
                    const willPushInSelf = this.willPushInSelf(_currRouteName, _currRouteContentId, destRoute?.name, destRoute?.params.contentId);
                    // When navigate to an url with anchor and destination is under the same route for same content,
                    // EP's default navigtation should simply follow browser's navigation instead of going to `defaultPush` and execute `history.push`.
                    // In this case, we use `open` (window.open) to load in the exisitng browsing context
                    if (willPushInSelf && Boolean(destRoute?.hash)) {
                        open(destRoute?.hash, '_self');
                        return;
                    }
                    if (target === '_self') defaultPush(url_0, forceReload);
                    else open(url_0, target);
                };
                /**
       * defaultNavigate can be invoked by the embedding product because it's the 3rd argument to
       * navigationPolicy's navigate. If embedding product tells EP to navigate to a URL in a new
       * tab, EP should not shim (rebase) it since the embedding product has already had a chance
       * and they chose not to. On the other hand, if the embedding product does not tell EP to
       * nagivate, EP can shim the url only when opening a new tab (some links might not have been
       * shimmed, need to shim all links supposed to be shimmed as the last defense).
       **/ return navigationPolicy?.navigate ? navigationPolicy?.navigate(url, modifiers, defaultNavigate) : defaultNavigate(modifiers.target === '_self' ? url : shimUrl(url), modifiers);
            },
            willPushInSelf (currRouteName, currRouteContentId, dstRouteName, dstRouteContentId) {
                const isEPRoute = !!$477c5af85d2d7fb0$var$toEPRouteName(dstRouteName);
                const isSameRoute = currRouteName === dstRouteName && currRouteContentId === dstRouteContentId;
                const shouldTransition = !!enableIframeSpaTransitions && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(currRouteName ?? '') && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(dstRouteName ?? '') && currRouteContentId === dstRouteContentId;
                return isEPRoute && (isSameRoute || shouldTransition);
            }
        }), [
        enableIframeSpaTransitions,
        navigationPolicy,
        shimUrl
    ]);
    return (0, $42omo.useMemo)(()=>isEmbeddedConfluence ? getEmbeddedConfluenceRoutePolicy() : undefined, [
        isEmbeddedConfluence,
        getEmbeddedConfluenceRoutePolicy
    ]);
}
function $477c5af85d2d7fb0$var$toEPRouteName(routeName) {
    switch(routeName){
        case 'VIEW_PAGE':
        case 'EDIT_PAGE_EMBED':
            return routeName;
        default:
            return undefined;
    }
}
module.exports["useRoutePolicy"] = $477c5af85d2d7fb0$export$53e37724c6846f41;

});

parcelRegister("kBW0t", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $2XqLN = parcelRequire("2XqLN");


var $7CLBv = parcelRequire("7CLBv");


var $dDZcC = parcelRequire("dDZcC");


var $cb6fO = parcelRequire("cb6fO");

const $734ea8da77496ad5$var$isAdfContent = (content)=>{
    return content && typeof content === 'object' && content.type === 'doc' && Array.isArray(content.content);
};
function $734ea8da77496ad5$export$8ed0b067e5cd675d(navigationPolicy) {
    const $ = (0, $frIzR.c)(17);
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    let t0;
    if ($[0] !== domainNamesToReplace || $[1] !== shimTemplate || $[2] !== spaceKeyFilter) {
        t0 = (urlToShim)=>$734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        $[0] = domainNamesToReplace;
        $[1] = shimTemplate;
        $[2] = spaceKeyFilter;
        $[3] = t0;
    } else t0 = $[3];
    const shimUrl = t0;
    let t1;
    if ($[4] !== domainNamesToReplace || $[5] !== shimTemplate || $[6] !== spaceKeyFilter) {
        t1 = (adf)=>{
            if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
            const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(adf);
            $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
            return adfClone;
        };
        $[4] = domainNamesToReplace;
        $[5] = shimTemplate;
        $[6] = spaceKeyFilter;
        $[7] = t1;
    } else t1 = $[7];
    const shimAdfUrls = t1;
    let t2;
    if ($[8] !== domainNamesToReplace || $[9] !== shimAdfUrls || $[10] !== shimTemplate || $[11] !== spaceKeyFilter) {
        t2 = (html)=>{
            if (!shimTemplate || !html) return html;
            try {
                const parsedContent = JSON.parse(html);
                if ($734ea8da77496ad5$var$isAdfContent(parsedContent)) {
                    if (html.includes("\"extensionKey\":\"nested-table\"")) {
                        const processedAdf = $734ea8da77496ad5$var$shimAdfWithNestedTables(parsedContent, shimAdfUrls);
                        return JSON.stringify(processedAdf);
                    } else {
                        const shimmedAdf = shimAdfUrls(parsedContent);
                        return JSON.stringify(shimmedAdf);
                    }
                }
            } catch  {}
            try {
                return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, "text/html"), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
            } catch  {
                return html;
            }
        };
        $[8] = domainNamesToReplace;
        $[9] = shimAdfUrls;
        $[10] = shimTemplate;
        $[11] = spaceKeyFilter;
        $[12] = t2;
    } else t2 = $[12];
    const shimHtmlUrls = t2;
    let t3;
    if ($[13] !== shimAdfUrls || $[14] !== shimHtmlUrls || $[15] !== shimUrl) {
        t3 = {
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        };
        $[13] = shimAdfUrls;
        $[14] = shimHtmlUrls;
        $[15] = shimUrl;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
}
function $734ea8da77496ad5$var$shimDomUrls(dom, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    const anchors = dom.getElementsByTagName('a');
    Array.from(anchors).forEach((a)=>{
        a.href = $734ea8da77496ad5$var$shimThisUrl(a.href, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    const imgs = dom.getElementsByTagName('img');
    Array.from(imgs).forEach((img)=>{
        img.src = $734ea8da77496ad5$var$shimThisUrl(img.src, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    return dom;
}
function $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    if (!shimTemplate || !urlToShim || (0, $cb6fO.isHashedOnlyURL)(urlToShim) || !$734ea8da77496ad5$var$isUrlForShimmedSpace(urlToShim, spaceKeyFilter)) return urlToShim;
    try {
        const baseUrl = document.baseURI || window.location.toString();
        const absUrlWithDomainToShim = $734ea8da77496ad5$var$getAbsUrlWithDomain(urlToShim, baseUrl);
        const urlPrefixToShim = $734ea8da77496ad5$var$ccAbsUrlWithDomain(baseUrl);
        const urlShimTemplate = $734ea8da77496ad5$var$shimAbsUrlWithDomain(shimTemplate, baseUrl);
        return $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace);
    } catch  {
        return urlToShim;
    }
}
function $734ea8da77496ad5$var$isUrlForShimmedSpace(url, spaceKeyFilter) {
    // If no filter, shim all URLs (backwards compatibility)
    if (!spaceKeyFilter?.length) return true;
    // Regex to extract spaceKey from /spaces/<spaceKey>/
    const match = url.match(/\/spaces\/([^/]+)/);
    if (match) {
        // If URL contains /spaces/<spaceKey>, only shim if spaceKey is in the filter
        const spaceKey = match[1];
        return spaceKeyFilter.includes(spaceKey);
    }
    // For other /wiki URLs (e.g., share links), retain previous behavior and shim
    return true;
}
const $734ea8da77496ad5$var$ccAbsUrlWithDomain = (0, $2XqLN.default)((base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain((0, $cb6fO.CONTEXT_PATH), base)));
const $734ea8da77496ad5$var$shimAbsUrlWithDomain = (0, $2XqLN.default)((urlShimTemplate, base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain(urlShimTemplate, base)));
function $734ea8da77496ad5$var$getAbsUrlWithDomain(url, base) {
    return new URL(url, base).toString();
}
function $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace) {
    if (absUrlWithDomainToShim.includes((0, $cb6fO.CONTEXT_PATH))) {
        //We can only rebase or shim /wiki URLs
        const absUrlObj = new URL(absUrlWithDomainToShim);
        const baseUrlObj = new URL(baseUrl);
        //Check if the URL should be rebased
        if (domainNamesToReplace?.includes(absUrlObj.hostname)) {
            //Rebase the URL by replacing the origin string of absUrlWithDomainToShim with that of baseUrl
            const rebasedAbsUrlToShim = absUrlWithDomainToShim.replace(absUrlObj.origin, baseUrlObj.origin);
            //Shimming the rebased URL
            return rebasedAbsUrlToShim.replace(urlPrefixToShim, urlShimTemplate);
        }
    }
    return absUrlWithDomainToShim.replace(urlPrefixToShim, urlShimTemplate);
}
function $734ea8da77496ad5$var$appendSlash(url) {
    if (!url.endsWith('/')) return `${url}/`;
    return url;
}
const $734ea8da77496ad5$var$URL_ADF_KEYS = [
    'url',
    'href'
];
function $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfJson, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    Object.entries(adfJson).forEach(([key, value])=>{
        if (!value) return;
        if ($734ea8da77496ad5$var$URL_ADF_KEYS.includes(key) && typeof value === 'string') adfJson[key] = $734ea8da77496ad5$var$shimThisUrl(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        else if (typeof value === 'object') $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
}
/**
 * Shims URLs in ADF content that contains nested tables.
 * This function processes ADF document content with nested tables by:
 * 1. Transforming nested tables (incoming)
 * 2. Applying URL shimming via shimAdfUrls
 * 3. Transforming nested tables (outgoing)
 *
 * @param adfContent - Parsed ADF document content (already validated)
 * @param shimAdfUrls - Function to apply URL shimming to ADF objects
 * @returns Processed ADF object with shimmed URLs and transformed nested tables
 */ function $734ea8da77496ad5$var$shimAdfWithNestedTables(adfContent, shimAdfUrls) {
    // Process ADF document with nested tables - transform and delegate to shimAdfUrls
    const { transformedAdf: transformedAdf } = (0, $dDZcC.transformNestedTablesIncomingDocument)(adfContent);
    const shimmedAdf = shimAdfUrls(transformedAdf);
    return (0, $dDZcC.transformNestedTableNodeOutgoingDocument)(shimmedAdf);
}
module.exports["useShimUrl"] = $734ea8da77496ad5$export$8ed0b067e5cd675d;

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("bMPhU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $7SV4J = parcelRequire("7SV4J");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (spaceKey)=>{
    const $ = (0, $frIzR.c)(5);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    let t0;
    if ($[0] !== spaceKey) {
        t0 = {
            spaceKey: spaceKey
        };
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !spaceKey;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $7SV4J.default), {
        ...t2,
        __callerPackage__: "@confluence/space-utils"
    });
    return data?.space?.homepage?.id || undefined;
};
module.exports["useSpaceHomepageId"] = $337a96ad81fe0f87$export$a1e0cd72fc64ef6;

});

parcelRegister("7SV4J", function(module, exports) {
/**
 * @generated SignedSource<<560475f7b94ff8b73d41c9418925ef8b>>
 * @relayHash be53943df43514309a4d7c908c1c0fa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5
const $6972c51ac50ce9bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                v1 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "be53943df43514309a4d7c908c1c0fa2",
            "id": "7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5",
            "metadata": {},
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "operationKind": "query",
            "text": "query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$6972c51ac50ce9bf$var$node.hash = "008609f21691e19f9c101d43e2e78e81";
var $6972c51ac50ce9bf$export$2e2bcd8739ae039 = $6972c51ac50ce9bf$var$node;
module.exports["default"] = $6972c51ac50ce9bf$export$2e2bcd8739ae039;

});

parcelRegister("jn9ek", function(module, exports) {
const $2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'third party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Edited 1st party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Content created or updated with invalid arguments: Invalid space key specified.' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isExceededRateError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message).includes('rate limit exceeded');
};
const $2f7d9ade7a6b90fb$export$9ae592643c1ef19b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$af33641014b57bba = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$b6b21a057779c53b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError);
};
const $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08 = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isExceededRateError);
};
const $2f7d9ade7a6b90fb$export$69408b85ed2a0e77 = (error)=>{
    if (error && 'graphQLErrors' in error) {
        const originalError = error.graphQLErrors?.[0]?.originalError;
        return originalError?.traceId || '';
    }
    return '';
};
module.exports["isBadThirdPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$9ae592643c1ef19b;
module.exports["isBadEditedFirstPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$af33641014b57bba;
module.exports["isInvalidSpaceKeyError"] = $2f7d9ade7a6b90fb$export$b6b21a057779c53b;
module.exports["isRateExceededError"] = $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08;
module.exports["getTraceIdFromApolloError"] = $2f7d9ade7a6b90fb$export$69408b85ed2a0e77;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("lLRfG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $cbc8g = parcelRequire("cbc8g");


var $78QFu = parcelRequire("78QFu");


var $7sK8i = parcelRequire("7sK8i");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $6VdZc = parcelRequire("6VdZc");


var $4XtQK = parcelRequire("4XtQK");


var $2O7Qv = parcelRequire("2O7Qv");

const $4291167636037428$var$PageLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, customData: customData = {}, stopTime: stopTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hasFiredRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasFiredRef.current) return;
        hasFiredRef.current = true;
        if (metric) (0, $2O7Qv.addCustomTimingForMetric)(metric.key);
        (0, $cbc8g.addUFOCustomData)({
            ...customData,
            ...typeof stopTime === 'number' ? {
                stopTime: stopTime
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
        (0, $7sK8i.resumeLowPriorityEvents)();
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `customData`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        metric
    ]);
    (0, $4XtQK.reportHydrationError)(createAnalyticsEvent, metric?.key);
    return null;
});
const $4291167636037428$export$570dec5b65c6715b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($4291167636037428$var$PageLoadEndComponent);
module.exports["PageLoadEnd"] = $4291167636037428$export$570dec5b65c6715b;

});

parcelRegister("4XtQK", function(module, exports) {

var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");


var $6mKj3 = parcelRequire("6mKj3");

function $433efe87b2d05424$export$e885a680acb7d12e(createAnalyticsEvent, metricKey) {
    if (!(window?.__SSR_RENDERED__ && Boolean(window.__HYDRATION_FAILED__))) return;
    const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
    const attribution = window.__SSR_REACT_STREAMING__ ? 'streaming-hydration' : 'hydration';
    if ((0, $6mKj3.expVal)('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
        source: `PageLoadEnd - ${metricKey}`,
        route: route,
        errorWithRoute: errorWithRoute,
        isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
    })).fire();
    else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
        attribution: attribution
    });
}
module.exports["reportHydrationError"] = $433efe87b2d05424$export$e885a680acb7d12e;

});

parcelRegister("9o40q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5JnOJ = parcelRequire("5JnOJ");


var $6mKj3 = parcelRequire("6mKj3");


var $1GTIR = parcelRequire("1GTIR");


var $bjeS8 = parcelRequire("bjeS8");


var $hNILR = parcelRequire("hNILR");

function $ca37881e75cd694f$export$59b64e912820d0fb({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    if (!(0, $6mKj3.expValEquals)('cc_move_legacy-schema-bridge-code-into-interops', 'isEnabled', true)) // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return (0, $hNILR.useExperimentalMutationLegacy)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        maxRetries: maxRetries,
        variables: defaultVariables,
        update: update,
        optimisticResponse: optimisticResponse
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const fetchDataWithRetry = (0, $42omo.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return $ca37881e75cd694f$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $ca37881e75cd694f$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: update, optimisticResponse: optimisticResponse }) {
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $5JnOJ.useApolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        update: update,
        optimisticResponse: optimisticResponse,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["useExperimentalMutation"] = $ca37881e75cd694f$export$59b64e912820d0fb;
module.exports["useExperimentalMutationBase"] = $ca37881e75cd694f$export$a2949d410ca8baf1;

});

parcelRegister("5JnOJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $7Sm4c = parcelRequire("7Sm4c");

function $0e0c7f21ad093cb8$export$36caaad0aa36f272({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse, convertToApolloError: convertToApolloError }) {
    const [result, setResult] = (0, $42omo.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult_0 = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult_0);
            await onCompleted?.(data);
            return {
                data: newResult_0.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const apolloError = await Promise.resolve(convertToApolloError(error));
            if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
                (0, $7Sm4c.processError)(e);
            });
            onError?.(apolloError);
            const newResult = {
                data: undefined,
                loading: false,
                error: apolloError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw apolloError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useApolloCompatibleMutation"] = $0e0c7f21ad093cb8$export$36caaad0aa36f272;

});

parcelRegister("hNILR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $1GTIR = parcelRequire("1GTIR");


var $hR9WV = parcelRequire("hR9WV");

function $fa6207d2b246a38d$export$9aaca330ad9c982e({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    const fetchDataWithRetry = (0, $42omo.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    return $fa6207d2b246a38d$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $fa6207d2b246a38d$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse }) {
    const [result, setResult] = (0, $42omo.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult);
            await onCompleted?.(data);
            return {
                data: newResult.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            const newResult = {
                data: undefined,
                loading: false,
                error: finalError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw finalError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useExperimentalMutationLegacy"] = $fa6207d2b246a38d$export$9aaca330ad9c982e;

});

parcelRegister("4B2M3", function(module, exports) {
/* ObservableSpinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");


var $l8oxh = parcelRequire("l8oxh");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5ccd6b86c893b680$var$SpinnerWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i1ylp _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $5ccd6b86c893b680$var$SpinnerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41bpf _1reo15vq _18m915vq _1tke1tcg",
            __cmplp.className
        ])
    });
});
const $5ccd6b86c893b680$export$9c05ccc6295d539b = ({ onScrollTo: onScrollTo, testId: testId, cursor: cursor, observerOptions: observerOptions, spinnerSize: spinnerSize = 'medium' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l8oxh.InfiniteScroll), {
        onScrollTo: onScrollTo,
        cursor: cursor,
        observerOptions: observerOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5ccd6b86c893b680$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5ccd6b86c893b680$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: spinnerSize,
        testId: testId
    }))));
};
module.exports["ObservableSpinner"] = $5ccd6b86c893b680$export$9c05ccc6295d539b;

});

parcelRegister("lJDEI", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $4a3de077c1d50444$export$339879d9e7e1b505 = 'inEditorTemplatesPanel';
const $4a3de077c1d50444$export$a957a3414f664a78 = 'open';
const $4a3de077c1d50444$export$5f52a3f66b36af8a = 'keep_open';
const $4a3de077c1d50444$export$3077ff8b594d6ef8 = 'auto_closed';
const $4a3de077c1d50444$export$e03fa63b521a0c2 = 'createdWithTemplate';
const $4a3de077c1d50444$export$79a38b1b3ee7546f = 'contextPanelTabTarget';
const $4a3de077c1d50444$export$d3c15ca89bcfbca6 = 'templates';
const $4a3de077c1d50444$export$9d622978cb62b57d = 'block';
const $4a3de077c1d50444$export$3059f9ac1064e696 = 'import';
const $4a3de077c1d50444$export$ccd8928f1e8269de = 'templates';
const $4a3de077c1d50444$export$2f49124c0813d6f9 = 'import';
const $4a3de077c1d50444$export$5a50171a4c5c3a34 = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$e03fa63b521a0c2] === 'true';
};
const $4a3de077c1d50444$export$944cd488c360bc7a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$339879d9e7e1b505];
};
const $4a3de077c1d50444$export$c1ea49786444cf5a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$79a38b1b3ee7546f];
};
const $4a3de077c1d50444$export$e991edcb7a1d128f = (getQueryParams)=>{
    return $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams) === $4a3de077c1d50444$export$a957a3414f664a78;
};
const $4a3de077c1d50444$export$835e1f3b6fb2ce1a = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    return queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a;
};
const $4a3de077c1d50444$export$242446a58b76be13 = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    const tabTarget = $4a3de077c1d50444$export$c1ea49786444cf5a(getQueryParams);
    return (queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a) && (tabTarget === $4a3de077c1d50444$export$d3c15ca89bcfbca6 || tabTarget === $4a3de077c1d50444$export$9d622978cb62b57d);
};
const $4a3de077c1d50444$export$56073af4e8655248 = (setQueryParams, isRovoLLMEnabled = false)=>{
    const paramsToRemove = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: null
    };
    // Clear contextPanelTabTarget when either platform_editor_blocks_conf or cwr_blank_object_experiment is enabled
    if (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) paramsToRemove[$4a3de077c1d50444$export$79a38b1b3ee7546f] = null;
    setQueryParams(paramsToRemove, true);
};
const $4a3de077c1d50444$export$90fd502a25d2c01 = (setQueryParams, inEditorTemplatesPanel, tabTarget, isRovoLLMEnabled = false)=>{
    const params = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: inEditorTemplatesPanel
    };
    // Set contextPanelTabTarget when either platform_editor_blocks_conf or cwr_blank_object_experiment is enabled
    if (tabTarget && (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false))) params[$4a3de077c1d50444$export$79a38b1b3ee7546f] = tabTarget;
    setQueryParams(params, true);
};
const $4a3de077c1d50444$export$828af32839880b11 = (spaceKey)=>{
    if (spaceKey) return (0, $1NBp8.SPACE_SETTINGS_TEMPLATES).toUrl({
        spaceKey: spaceKey
    });
    return (0, $1NBp8.ADMIN_TEMPLATES_AND_BLUEPRINTS).toUrl();
};
module.exports["IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$339879d9e7e1b505;
module.exports["IN_EDITOR_TEMPLATES_QUERY_OPEN"] = $4a3de077c1d50444$export$a957a3414f664a78;
module.exports["IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN"] = $4a3de077c1d50444$export$5f52a3f66b36af8a;
module.exports["IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED"] = $4a3de077c1d50444$export$3077ff8b594d6ef8;
module.exports["CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$e03fa63b521a0c2;
module.exports["CONTEXT_PANEL_TAB_TARGET"] = $4a3de077c1d50444$export$79a38b1b3ee7546f;
module.exports["CONTEXT_PANEL_TAB_TARGET_TEMPLATES"] = $4a3de077c1d50444$export$d3c15ca89bcfbca6;
module.exports["CONTEXT_PANEL_TAB_TARGET_BLOCK"] = $4a3de077c1d50444$export$9d622978cb62b57d;
module.exports["CONTEXT_PANEL_TAB_TARGET_IMPORT"] = $4a3de077c1d50444$export$3059f9ac1064e696;
module.exports["PANEL_MODE_TEMPLATES"] = $4a3de077c1d50444$export$ccd8928f1e8269de;
module.exports["PANEL_MODE_IMPORT"] = $4a3de077c1d50444$export$2f49124c0813d6f9;
module.exports["getCreatedWithTemplateQueryParamValue"] = $4a3de077c1d50444$export$5a50171a4c5c3a34;
module.exports["getInEditorTemplatesPanelQueryParamValue"] = $4a3de077c1d50444$export$944cd488c360bc7a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpen"] = $4a3de077c1d50444$export$e991edcb7a1d128f;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpen"] = $4a3de077c1d50444$export$835e1f3b6fb2ce1a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpenWithTemplatesPanelMode"] = $4a3de077c1d50444$export$242446a58b76be13;
module.exports["removeInEditorTemplatesQueryParam"] = $4a3de077c1d50444$export$56073af4e8655248;
module.exports["setInEditorTemplatesPanelQueryParam"] = $4a3de077c1d50444$export$90fd502a25d2c01;
module.exports["getTemplateListPage"] = $4a3de077c1d50444$export$828af32839880b11;

});

parcelRegister("bZ9Ng", function(module, exports) {
/* This module exports shared functions used by both blueprint & template endpoints, as these REST APIs share similar
 * request/response patterns.
 */ // eslint-disable-next-line no-restricted-imports

var $hBkCm = parcelRequire("hBkCm");


var $dw6y2 = parcelRequire("dw6y2");

const $2dc0a210c1f3c9f7$export$79d30bcd36f6be4f = (json)=>{
    const title = json?.content?.title;
    return {
        content: {
            id: json?.content?.id || null,
            type: 'page',
            subType: json?.content?.subType || null,
            title: typeof title === 'string' ? title : null,
            space: {
                key: json?.content?.space?.key || null
            },
            _links: {
                editui: json?.content?._links?.editui || null
            },
            metadata: {
                properties: {
                    editor: {
                        value: json?.content?.metadata?.properties?.editor?.value || null
                    }
                },
                simple: {
                    isFabric: json?.content?.metadata?.simple?.isFabric || null
                }
            }
        }
    };
};
const $2dc0a210c1f3c9f7$export$ed7023388c8f5dd4 = async (cfetch, url, method, headers, pageData)=>{
    const MAX_CONTENT_UPDATE_RETRY = 1;
    const updateTemplate = async (count = 0)=>{
        try {
            const res = await cfetch(url, {
                method: method,
                headers: headers,
                body: JSON.stringify(pageData)
            });
            return res.json();
        } catch (err) {
            const errorStatus = err?.response?.status;
            if (errorStatus === 500) {
                const backendError = await err.response.json();
                throw new (0, $hBkCm.BadStatusError)(backendError.errorMessage, err.response);
            }
            if (count < MAX_CONTENT_UPDATE_RETRY && errorStatus === 409) return updateTemplate(++count);
            throw err;
        }
    };
    const json = await updateTemplate();
    return $2dc0a210c1f3c9f7$export$79d30bcd36f6be4f(json);
};
const $2dc0a210c1f3c9f7$export$6a221318e0d372a4 = async (createPageResponseJson, attemptSpaUrl)=>{
    if (attemptSpaUrl) {
        // TODO: remove the old metadata field check once we use the new metadata field for template
        const isFabric = createPageResponseJson?.content?.metadata?.properties?.editor?.value === 'v2' || createPageResponseJson?.content?.metadata?.simple?.isFabric === true;
        const isLivePage = createPageResponseJson?.content?.subType === 'live';
        if (isLivePage) return createPageResponseJson?.content?._links?.editui;
        if (isFabric) return (0, $dw6y2.createEditDraftPageUrl)(createPageResponseJson);
    }
    return createPageResponseJson?.content?._links?.editui;
};
module.exports["getOnContentUpdatedObjFromResponse"] = $2dc0a210c1f3c9f7$export$79d30bcd36f6be4f;
module.exports["getEditDraftPageUrl"] = $2dc0a210c1f3c9f7$export$6a221318e0d372a4;

});

parcelRegister("dw6y2", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jFumb = parcelRequire("jFumb");

const $5df2cb75c6140959$export$2b48bde4878a8630 = (metadata)=>{
    const data = 'content' in metadata ? metadata.content : metadata;
    const spaceKey = data?.space?.key;
    const subType = data?.subType;
    if (!spaceKey) return data._links.editui;
    if (subType === 'live') return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: data?.id
    });
    return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentId: data?.id,
        contentType: 'pages'
    }, {
        query: {
            draftShareId: (0, $jFumb.getDraftShareIdFromCreateContentMetadata)(data)
        }
    });
};
const $5df2cb75c6140959$export$4a4b0cb92802bec5 = (metadata)=>{
    const spaceAlias = metadata?.space?.alias;
    if (!spaceAlias) return metadata._links.editui;
    return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceAlias,
        contentId: metadata?.id,
        contentType: 'blog'
    }, {
        query: {
            draftShareId: (0, $jFumb.getDraftShareIdFromCreateContentMetadata)(metadata)
        }
    });
};
module.exports["createEditDraftPageUrl"] = $5df2cb75c6140959$export$2b48bde4878a8630;
module.exports["createEditDraftBlogUrl"] = $5df2cb75c6140959$export$4a4b0cb92802bec5;

});

parcelRegister("jFumb", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $517b1e1152d7e308$export$251fafe6ead5eb49 = (data)=>{
    const context = data?._links?.context || (0, $jlIaF.CONTEXT_PATH);
    const legacyUrl = data?._links?.editui || '';
    const legacyDraftRouteMatch = (0, $1NBp8.RESUME_DRAFT_LEGACY).match(context + legacyUrl);
    const id = legacyDraftRouteMatch?.query?.draftShareId;
    const draftShareId = Array.isArray(id) ? id[0] : id;
    return draftShareId || '';
};
module.exports["getDraftShareIdFromCreateContentMetadata"] = $517b1e1152d7e308$export$251fafe6ead5eb49;

});

parcelRegister("cxMI6", function(module, exports) {

var $brn6e = parcelRequire("brn6e");


var $8rneB = parcelRequire("8rneB");


var $huWyw = parcelRequire("huWyw");


var $c7GB4 = parcelRequire("c7GB4");

const $c6273926c8df4325$var$ALL_CONTENT_TYPE = [
    'page',
    'blogpost',
    'whiteboard',
    'database',
    'embed',
    'folder',
    'slide'
];
const $c6273926c8df4325$var$resumeDraftWebUiBypass = (urlPath, content)=>{
    const bypassUrl = (0, $huWyw.getURLBypassingResumeDraftAction)({
        url: urlPath || '',
        spaceKey: content?.space?.alias || content?.space?.key || '',
        contentType: content?.type,
        editorVersion: content?.editorVersion?.nodes?.[0]?.value?.replace(/['"]+/g, ''),
        contentId: content?.id || '',
        noContextPath: true
    });
    return bypassUrl;
};
const $c6273926c8df4325$export$a0bd4958aceee288 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent)=>{
    const EMOJI_CONTENT_TYPE = isWhiteboardEmojiFGEnabled ? [
        'page',
        'blogpost',
        'embed',
        'whiteboard',
        'slide'
    ] : [
        'page',
        'blogpost',
        'embed'
    ];
    const contentType = $c6273926c8df4325$var$ALL_CONTENT_TYPE.includes(content?.type) ? content.type : 'page';
    if (isActivityV3HomeRecent) return {
        id: (0, $c7GB4.getIdFromConfluenceContentAri)({
            ari: content?.id,
            resourceType: contentType
        }) || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, content?.metadata?.titleEmojiPublished?.value || '', content?.metadata?.titleEmojiDraft?.value || '', content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subtype,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editUi, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webUi, content)
        },
        isStarred: content?.viewer?.favoritedSummary?.isFavorite || false,
        likesCount: content?.likesSummary?.count || 0,
        commentsCount: content?.commentCountSummary?.total || 0,
        excerpt: content?.body?.excerpt?.trim()
    };
    return {
        id: content?.id || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, (0, $8rneB.getEmojiPublishedFromProperties)(content), (0, $8rneB.getEmojiDraftFromProperties)(content), content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subType,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editui, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webui, content)
        },
        isStarred: content?.metadata?.currentuser?.favourited?.isFavourite || false,
        likesCount: content?.likes?.count || 0,
        commentsCount: content?.metadata?.comments?.commentsCount || 0,
        excerpt: content?.excerpt?.trim(),
        lastAction: {
            when: content?.metadata?.lastModifiedDate || '',
            action: 'updated'
        }
    };
};
const $c6273926c8df4325$export$898674fde3fd0597 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent = false)=>{
    const spaceAlias = content?.space?.alias || content?.space?.key;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent),
        space: {
            spaceKey: spaceAlias || '',
            name: content?.space?.name || ''
        },
        creatorId: content?.creatorId || '',
        history: {
            ownedBy: {
                displayName: content?.history?.ownedBy?.displayName || ''
            }
        }
    };
};
const $c6273926c8df4325$export$1e1d4cb60561af2b = (content, untitledDraftText = '', isWhiteboardEmojiFGEnabled = false)=>{
    const createdBy = content?.status === 'draft' ? content?.version?.by : content?.history?.createdBy;
    const ownedBy = content?.status === 'draft' ? content?.version?.by : content?.history?.ownedBy;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled),
        createdBy: {
            displayName: createdBy?.displayName || '',
            profilePicture: createdBy?.profilePicture?.path || '',
            accountId: createdBy?.accountId || ''
        },
        ownedBy: {
            displayName: ownedBy?.displayName || '',
            profilePicture: ownedBy?.profilePicture?.path || '',
            accountId: ownedBy?.accountId || ''
        }
    };
};
const $c6273926c8df4325$export$ee67d5d6f48183b0 = (card)=>Boolean(card.createdBy);
module.exports["transformGlobalContent"] = $c6273926c8df4325$export$898674fde3fd0597;
module.exports["transformSpaceContent"] = $c6273926c8df4325$export$1e1d4cb60561af2b;
module.exports["isSpacePageCard"] = $c6273926c8df4325$export$ee67d5d6f48183b0;

});

parcelRegister("huWyw", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $61f50eb1c9d5c417$export$35f6369946b1d8c9 = ({ url: url, spaceKey: spaceKey, contentType: contentType, editorVersion: editorVersion, contentId: contentId, fabricEditorSupported: fabricEditorSupported, noContextPath: noContextPath })=>{
    const isPage = contentType === 'page';
    const isBlog = contentType === 'blogpost';
    const isPageOrBlog = isPage || isBlog;
    const isUsingFabricEditor = fabricEditorSupported || editorVersion === 'v2'; // as opposed to the v1 TinyMCE editor
    const providedURLHitsResumeDraftAction = url.includes('resumedraft.action');
    if (isPageOrBlog && isUsingFabricEditor && providedURLHitsResumeDraftAction) {
        const contentTypeForURL = isPage ? 'pages' : 'blog';
        const contentIdForURL = contentId;
        // Extract the query string from the relative URL.
        const queryString = url.includes('?') ? url.slice(url.indexOf('?') + 1) : '';
        // Extract the `draftShareId` from the query string.
        const urlSearchParams = new URLSearchParams(queryString);
        const draftShareId = urlSearchParams.get('draftShareId');
        const draftShareIdParamString = draftShareId ? `draftShareId=${draftShareId}` : '';
        const optionalContextPath = noContextPath ? '' : (0, $jlIaF.CONTEXT_PATH);
        const bypassURL = `${optionalContextPath}/spaces/${spaceKey}/${contentTypeForURL}/edit-v2/${contentIdForURL}?${draftShareIdParamString}`;
        return bypassURL;
    } else return url;
};
module.exports["getURLBypassingResumeDraftAction"] = $61f50eb1c9d5c417$export$35f6369946b1d8c9;

});

parcelRegister("c7GB4", function(module, exports) {

var $eB56w = parcelRequire("eB56w");

var $iH7AG = parcelRequire("iH7AG");

var $dM0Qh = parcelRequire("dM0Qh");

var $lb1Mg = parcelRequire("lb1Mg");

var $a2xFu = parcelRequire("a2xFu");

var $1LZHF = parcelRequire("1LZHF");

var $a5Dk4 = parcelRequire("a5Dk4");


var $1ggpj = parcelRequire("1ggpj");

const $c96e0d62cf176fc6$export$84dfa7fadd8a006b = ({ ari: ari, resourceType: resourceType })=>{
    if (!ari) return null;
    switch(resourceType){
        case (0, $1ggpj.ContentType).PAGE:
            return (0, $a2xFu.ConfluencePageAri).parse(ari).pageId;
        case (0, $1ggpj.ContentType).BLOGPOST:
            return (0, $eB56w.ConfluenceBlogpostAri).parse(ari).blogpostId;
        case (0, $1ggpj.ContentType).WHITEBOARD:
            return (0, $a5Dk4.ConfluenceWhiteboardAri).parse(ari).whiteboardId;
        case (0, $1ggpj.ContentType).DATABASE:
            return (0, $iH7AG.ConfluenceDatabaseAri).parse(ari).databaseId;
        case (0, $1ggpj.ContentType).EMBED:
            return (0, $dM0Qh.ConfluenceEmbedAri).parse(ari).embedId;
        case (0, $1ggpj.ContentType).FOLDER:
            return (0, $lb1Mg.ConfluenceFolderAri).parse(ari).folderId;
        case (0, $1ggpj.ContentType).SLIDE:
            return (0, $1LZHF.ConfluenceSlideAri).parse(ari).slideId;
    }
};
module.exports["getIdFromConfluenceContentAri"] = $c96e0d62cf176fc6$export$84dfa7fadd8a006b;

});

parcelRegister("1LZHF", function(module, exports) {

var $gFQkO = parcelRequire("gFQkO");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/slide/manifest.ts
var $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $gFQkO.ConfluenceSlideAriResourceOwner),
    resourceType: (0, $gFQkO.ConfluenceSlideAriResourceType),
    resourceIdSlug: "activation/{activationId}/{slideId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        slideId: /[0-9]+/
    }
};
// src/confluence/slide/index.ts
var $14aa0b35cfffabf8$export$86048ac46024146a = class _ConfluenceSlideAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get slideId() {
        return this._slideId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts.qualifier,
            platformQualifier: $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts.resourceOwner,
            resourceType: $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.slideId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                slideId: opts.slideId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            slideId: this.slideId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._slideId = opts.resourceIdSegmentValues.slideId;
    }
};
module.exports["ConfluenceSlideAri"] = $14aa0b35cfffabf8$export$86048ac46024146a;

});

parcelRegister("gFQkO", function(module, exports) {
// src/confluence/slide/types.ts
var $c23912470bd9b644$export$204fa7edd529d4b3 = "confluence", $c23912470bd9b644$export$3de52c55a164daa4 = "slide";
module.exports["ConfluenceSlideAriResourceOwner"] = $c23912470bd9b644$export$204fa7edd529d4b3;
module.exports["ConfluenceSlideAriResourceType"] = $c23912470bd9b644$export$3de52c55a164daa4;

});

parcelRegister("gqypm", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");


var $f7MuR = parcelRequire("f7MuR");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ variables: variables, skip: skip, fetchPolicy: fetchPolicy })=>{
    const legacyResult = (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId, userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`,
        method: 'GET',
        variables: variables,
        parseResult: (json)=>({
                experimentalSiteUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip || (0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false)
    });
    const traitsResult = (0, $f7MuR.useSiteUserTraits)({
        skip: skip || !(0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false),
        fetchPolicy: fetchPolicy
    });
    if (!(0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false)) return {
        data: legacyResult.data,
        loading: legacyResult.loading,
        error: legacyResult.error ?? undefined
    };
    // Exp on: adapt traits result into legacy data/loading/error shape
    const adaptedData = traitsResult.data !== null ? {
        experimentalSiteUserPersonalization: {
            attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(traitsResult.data.attributes)
        }
    } : undefined;
    return {
        data: adaptedData,
        loading: traitsResult.loading,
        error: traitsResult.error ?? undefined
    };
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("aSQ2H", function(module, exports) {
/**
 * @generated SignedSource<<43e31ac1518d2be0e85af0936baa5e6a>>
 * @relayHash 475721f730a3548a4f4eefeb978ba00d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d7c04d39708c6a688256a9fd02644f4c9f3257ba8cf834d535b12f160ca61efb
const $20d3ce40728fbf7c$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useUserByLicensedProductsQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useUserByLicensedProductsQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "475721f730a3548a4f4eefeb978ba00d",
            "id": "d7c04d39708c6a688256a9fd02644f4c9f3257ba8cf834d535b12f160ca61efb",
            "metadata": {},
            "name": "useUserByLicensedProductsQuery",
            "operationKind": "query",
            "text": "query useUserByLicensedProductsQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$20d3ce40728fbf7c$var$node.hash = "d128f30f97ec5f59ea08d8e5ff26d122";
var $20d3ce40728fbf7c$export$2e2bcd8739ae039 = $20d3ce40728fbf7c$var$node;
module.exports["default"] = $20d3ce40728fbf7c$export$2e2bcd8739ae039;

});

parcelRegister("tAt1Q", function(module, exports) {
var $cabc5f48a2666489$export$3e5d0af8e738b082 = /*#__PURE__*/ function(Team) {
    Team["SoftwareDevelopment"] = "software-development";
    Team["ProductManagement"] = "product-management";
    Team["Marketing"] = "marketing";
    Team["Design"] = "design";
    Team["ProjectManagement"] = "project-management";
    Team["Operations"] = "operations";
    Team["ITSupport"] = "it-support";
    Team["Finance"] = "finance";
    Team["HumanResources"] = "human-resources";
    Team["Legal"] = "legal";
    Team["Sales"] = "sales";
    Team["DataScience"] = "data-science";
    Team["CustomerService"] = "customer-service";
    Team["Other"] = "other";
    return Team;
}({});
const $cabc5f48a2666489$export$77134aba51f821f8 = {
    ["software-development"]: 'onboarding-helpers.team.software.development.modern.branding',
    ["product-management"]: 'onboarding-helpers.team.productManagement',
    ["marketing"]: 'onboarding-helpers.team.marketing.modern.branding',
    ["design"]: 'onboarding-helpers.team.design',
    ["project-management"]: 'onboarding-helpers.team.projectManagement',
    ["operations"]: 'onboarding-helpers.team.operations.modern.branding',
    ["it-support"]: 'onboarding-helpers.team.it.support.modern.branding',
    ["finance"]: 'onboarding-helpers.team.finance.modern.branding',
    ["human-resources"]: 'onboarding-helpers.team.human.resources.modern.branding',
    ["legal"]: 'onboarding-helpers.team.legal.modern.branding',
    ["sales"]: 'onboarding-helpers.team.sales.modern.branding',
    ["data-science"]: 'onboarding-helpers.team.data.science.modern.branding',
    ["customer-service"]: 'onboarding-helpers.team.customer.service.modern.branding',
    ["other"]: 'onboarding-helpers.team.other'
};
var $cabc5f48a2666489$export$a0b0994d6b76cdaa = /*#__PURE__*/ function(FocusArea) {
    FocusArea["PlanOutProjects"] = "plan-out-projects";
    FocusArea["CreateTechnicalDocumentation"] = "create-technical-documentation";
    FocusArea["CreateMarketingCampaigns"] = "create-marketing-campaigns";
    FocusArea["ShareStatusUpdates"] = "share-status-updates";
    FocusArea["BrainstormAndStrategize"] = "brainstorm-and-strategize";
    FocusArea["PlanAndPrioritize"] = "plan-and-prioritize";
    FocusArea["GetAlignment"] = "get-alignment";
    FocusArea["ImproveTeamProcesses"] = "improve-team-processes";
    FocusArea["ShareUpdatesWithStakeholders"] = "share-updates-with-stakeholders";
    FocusArea["StrategizeOnMarketingContent"] = "strategize-on-marketing-content";
    FocusArea["ShareWeeklyMeetingNotes"] = "share-weekly-meeting-notes";
    return FocusArea;
}({});
const $cabc5f48a2666489$export$8764a1262502aaf9 = {
    itProjectPoster: 'com.atlassian.confluence.plugins.confluence-business-blueprints:it-project-poster-blueprint',
    sprintPlanning: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sprint-planning-meeting-blueprint',
    productRequirements: 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
    softwareArchitectureReview: 'com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-blueprint',
    howToArticle: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-article-blueprint',
    architectureDiagram: 'com.atlassian.confluence.plugins.confluence-business-blueprints:aws-architecture-diagram-blueprint',
    incidentCommunication: 'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-communication-blueprint',
    experimentPlanAndResults: 'com.atlassian.confluence.plugins.confluence-business-blueprints:experiment-planning-and-results-blueprint',
    dailyStandUp: 'com.atlassian.confluence.plugins.confluence-business-blueprints:daily-stand-up-blueprint',
    projectPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
    strategicPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-strategy-blueprint',
    productRoadmap: 'com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-blueprint',
    workingAgreements: 'com.atlassian.confluence.plugins.confluence-business-blueprints:working-agreements-blueprint',
    teamPoster: 'com.atlassian.confluence.plugins.confluence-business-blueprints:team-poster-blueprint',
    rolesAndResponsibilities: 'com.atlassian.confluence.plugins.confluence-business-blueprints:roles-responsibilities-blueprint',
    stakeholderCommunications: 'com.atlassian.confluence.plugins.confluence-business-blueprints:stakeholder-communications-blueprint',
    endOfWeekStatusReport: 'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
    marketingCampaign: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-blueprint',
    marketingPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blueprint',
    brainstorming: 'com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-blueprint',
    swotAnalysis: 'com.atlassian.confluence.plugins.confluence-business-blueprints:swot-analysis-blueprint',
    competitiveAnalysis: 'com.atlassian.confluence.plugins.confluence-business-blueprints:competitive-analysis-blueprint',
    meetingNotes: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
    daci: 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
    customerJourneyMapping: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-journey-mapping-blueprint',
    toDoList: 'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-blueprint',
    retrospective: 'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint',
    devOpsRunbook: 'com.atlassian.confluence.plugins.confluence-business-blueprints:devops-runbook-blueprint',
    itsmKnownErrors: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-known-errors-blueprint',
    businessStatusUpdate: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
    workshopPlanner: 'com.atlassian.confluence.plugins.confluence-business-blueprints:workshop-planner-blueprint',
    designSystems: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-systems-blueprint',
    designReview: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-review-blueprint',
    businessPlanOnePager: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-plan-one-pager-blueprint',
    riskAssessmentMatrix: 'com.atlassian.confluence.plugins.confluence-business-blueprints:risk-assessment-blueprint',
    vendorAgreement: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vendor-agreement-blueprint',
    visionToValues: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vision-to-values-blueprint',
    careerDevelopmentPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:career-development-plan-blueprint',
    hrKnowledgeBaseManagement: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hr-knowledge-base-management-blueprint',
    salesAccountPlanning: 'com.atlassian.confluence.plugins.confluence-business-blueprints:account-planning-for-sales-blueprint',
    salesPortal: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sales-portal-template-blueprint',
    smartGoals: 'com.atlassian.confluence.plugins.confluence-business-blueprints:smart-goals-blueprint',
    projectStatus: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-status-blueprint',
    itsmChangeManagement: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-change-management-blueprint',
    itsmPostIncidentReviews: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-pir-blueprint',
    itsmRunbook: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-blueprint',
    troubleshootingArticle: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-troubleshooting-article-blueprint',
    mvpIdeation: 'com.atlassian.confluence.plugins.confluence-business-blueprints:mvp-ideation-blueprint',
    designSprint: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-sprint-blueprint',
    elevatorPitch: 'com.atlassian.confluence.plugins.confluence-business-blueprints:elevator-pitch-blueprint',
    mutualActionPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:mutual-action-plan-blueprint',
    executiveBusinessReview: 'com.atlassian.confluence.plugins.confluence-business-blueprints:executive-business-review-blueprint',
    fiveWhysAnalysis: 'com.atlassian.confluence.plugins.confluence-business-blueprints:5-whys-analysis-blueprint',
    okrs: 'com.atlassian.confluence.plugins.confluence-business-blueprints:okr-blueprint',
    employeeHandbook: 'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-blueprint',
    hiringProcess: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hiring-process-blueprint',
    contentStrategy: 'com.atlassian.confluence.plugins.confluence-business-blueprints:content-strategy-blueprint',
    blankPage: '',
    customerImpactAssessment: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-impact-assessment-blueprint',
    lennysProductRequirements: 'com.atlassian.confluence.plugins.confluence-business-blueprints:lennys-product-requirements-blueprint',
    designDecision: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-blueprint',
    persona: 'com.atlassian.confluence.plugins.confluence-business-blueprints:persona-blueprint',
    messageHouse: 'com.atlassian.confluence.plugins.confluence-business-blueprints:message-house-template-blueprint',
    annualPlanOnePager: 'com.atlassian.confluence.plugins.confluence-business-blueprints:annual-plan-one-pager-blueprint',
    allHandsMeeting: 'com.atlassian.confluence.plugins.confluence-business-blueprints:all-hands-meeting-blueprint',
    customerInterviewReport: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-interview-report-blueprint',
    presenterMode: 'com.atlassian.confluence.plugins.confluence-business-blueprints:presenter-mode-blueprint',
    qtcAcquisition: 'com.atlassian.confluence.plugins.confluence-business-blueprints:qtc-acquisition-blueprint',
    jobDescription: 'com.atlassian.confluence.plugins.confluence-business-blueprints:job-description-blueprint',
    ninetyDayPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:90-day-plan-blueprint',
    lennysPerformanceReview: 'com.atlassian.confluence.plugins.confluence-business-blueprints:lennys-performance-review-blueprint',
    projectKickoff: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-kickoff-blueprint'
};
var $cabc5f48a2666489$export$14416b8d99d47caa = /*#__PURE__*/ function(Template) {
    Template["ITProjectPoster"] = "it-project-poster";
    Template["SprintPlanning"] = "sprint-planning";
    Template["ProductRequirements"] = "product-requirements";
    Template["SoftwareArchitectureReview"] = "software-architecture-review";
    Template["HowToArticle"] = "how-to-article";
    Template["ArchitectureDiagram"] = "architecture-diagram";
    Template["IncidentCommunication"] = "incident-communication";
    Template["ExperimentPlanAndResults"] = "experiment-plan-and-results";
    Template["DailyStandUp"] = "daily-stand-up";
    Template["ProjectPlan"] = "project-plan";
    Template["StrategicPlan"] = "strategic-plan";
    Template["ProductRoadmap"] = "product-roadmap";
    Template["BlankPage"] = "blank-page";
    Template["WorkingAgreements"] = "working-agreements";
    Template["TeamPoster"] = "team-poster";
    Template["RolesAndResponsibilities"] = "roles-and-responsibilities";
    Template["StakeholderCommunications"] = "stakeholder-communications";
    Template["EndOfWeekStatusReport"] = "end-of-week-status-report";
    Template["MarketingCampaign"] = "marketing-campaign";
    Template["MarketingPlan"] = "marketing-plan";
    Template["Brainstorming"] = "brainstorming";
    Template["SWOTAnalysis"] = "swot-analysis";
    Template["CompetitiveAnalysis"] = "competitive-analysis";
    Template["MeetingNotes"] = "meeting-notes";
    Template["DACI"] = "daci";
    Template["CustomerJourneyMapping"] = "customer-journey-mapping";
    Template["ToDoList"] = "to-do-list";
    Template["Retrospective"] = "retrospective";
    Template["DevOpsRunbook"] = "dev-ops-runbook";
    Template["ITSMKnownErrors"] = "itsm-known-errors";
    Template["BusinessStatusUpdate"] = "business-status-update";
    Template["WorkshopPlanner"] = "workshop-planner";
    Template["DesignSystems"] = "design-systems";
    Template["DesignReview"] = "design-review";
    Template["BusinessPlanOnePager"] = "business-plan-one-pager";
    Template["RiskAssessmentMatrix"] = "risk-assessment-matrix";
    Template["VendorAgreement"] = "vendor-agreement";
    Template["VisionToValues"] = "vision-to-values";
    Template["CareerDevelopmentPlan"] = "career-development-plan";
    Template["HRKnowledgeBaseManagement"] = "hr-knowledge-base-management";
    Template["SalesAccountPlanning"] = "sales-account-planning";
    Template["SalesPortal"] = "sales-portal";
    Template["SMARTGoals"] = "smart-goals";
    Template["ProjectStatus"] = "project-status";
    Template["ITSMChangeManagement"] = "itsm-change-management";
    Template["ITSMPostIncidentReviews"] = "itsm-post-incident-reviews";
    Template["ITSMRunbook"] = "itsm-runbook";
    Template["TroubleshootingArticle"] = "troubleshooting-article";
    Template["MVPIdeation"] = "mvp-ideation";
    Template["DesignSprint"] = "design-sprint";
    Template["ElevatorPitch"] = "elevator-pitch";
    Template["MutualActionPlan"] = "mutual-action-plan";
    Template["ExecutiveBusinessReview"] = "executive-business-review";
    Template["FiveWhysAnalysis"] = "five-whys-analysis";
    Template["OKRs"] = "okrs";
    Template["EmployeeHandbook"] = "employee-handbook";
    Template["HiringProcess"] = "hiring-process";
    Template["CustomerImpactAssessment"] = "customer-impact-assessment";
    Template["LennysProductRequirements"] = "lennys-product-requirements";
    Template["ContentStrategy"] = "content-strategy";
    Template["DesignDecision"] = "design-decision";
    Template["Persona"] = "persona";
    Template["MessageHouse"] = "message-house";
    Template["AnnualPlanOnePager"] = "annual-plan-one-pager";
    Template["AllHandsMeeting"] = "all-hands-meeting";
    Template["CustomerInterviewReport"] = "customer-interview-report";
    Template["PresenterMode"] = "presenter-mode";
    Template["QtcAcquisition"] = "qtc-acquisition";
    Template["JobDescription"] = "job-description";
    Template["NinetyDayPlan"] = "ninety-day-plan";
    Template["LennysPerformanceReview"] = "lennys-performance-review";
    Template["ProjectKickoff"] = "project-kickoff";
    return Template;
}({});
var $cabc5f48a2666489$export$a6ffeca29f180ace = /*#__PURE__*/ function(WhiteboardTemplate) {
    WhiteboardTemplate["Brainwriting"] = "brainwriting";
    // Name: Brainwriting
    WhiteboardTemplate["Flowchart"] = "flow-chart";
    // Name: Flowchart
    WhiteboardTemplate["FourlsRetro"] = "4ls-retro";
    // Name: 4 Ls Retro
    WhiteboardTemplate["PrioritizationMatrix"] = "prioritization";
    // Name: Prioritization matrix
    WhiteboardTemplate["ProductRoadmap"] = "product-roadmap";
    // Name: Product roadmap
    WhiteboardTemplate["SimpleRetrospective"] = "simple-retrospective";
    // Name: Simple retrospective
    WhiteboardTemplate["SwimlanesProcessMap"] = "swimlanes";
    return WhiteboardTemplate;
}({});
var $cabc5f48a2666489$export$8b6f874ad242ca1b = /*#__PURE__*/ function(KnowledgeHubTemplate) {
    KnowledgeHubTemplate["FAQ"] = "faq";
    KnowledgeHubTemplate["Team"] = "team";
    KnowledgeHubTemplate["Project"] = "project";
    return KnowledgeHubTemplate;
}({});
var $cabc5f48a2666489$export$32da9fe1f998b96c = /*#__PURE__*/ function(ContentKeys) {
    ContentKeys["BRAINSTORMING"] = "BRAINSTORMING";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-page'
    ContentKeys["REQUIREMENTS_DOC"] = "REQUIREMENTS_DOC";
    // 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint'
    ContentKeys["TASK_TRACKING"] = "TASK_TRACKING";
    // 'com.atlassian.confluence.plugins.confluence-space-blueprints:task-tracker-template'
    ContentKeys["FLOWCHART_AND_DIAGRAMS"] = "FLOWCHART_AND_DIAGRAMS";
    // 'whiteboard:flow-chart'
    ContentKeys["MEETING_NOTES"] = "MEETING_NOTES";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-page'
    ContentKeys["KNOWLEDGE_HUB"] = "KNOWLEDGE_HUB";
    // 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-blueprint'
    ContentKeys["PROJECT_PLAN"] = "PROJECT_PLAN";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-page'
    ContentKeys["GANTT_CHART"] = "GANTT_CHART";
    // 'whiteboard:product-roadmap'
    ContentKeys["CREATIVE_BREIFS"] = "CREATIVE_BRIEFS";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:creative-brief-blueprint'
    ContentKeys["CUSTOMER_JOURNEYS"] = "CUSTOMER_JOURNEYS";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-journey-mapping-blueprint'
    ContentKeys["CAMPAIGN_PLANNING"] = "CAMPAIGN_PLANNING";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-content'
    ContentKeys["PROCESS_MAPPING"] = "PROCESS_MAPPING";
    // 'whiteboard:swimlanes'
    ContentKeys["TEAM_STATUS_UPDATE"] = "TEAM_STATUS_UPDATE";
    return ContentKeys;
}({});
var $cabc5f48a2666489$export$64e2ed2cf579d2ef = /*#__PURE__*/ function(AccountSetupScreens) {
    AccountSetupScreens["TEAM"] = "onboarding-account-setup-modal.teamScreen";
    AccountSetupScreens["TEAM_NO_SKIP"] = "onboarding-account-setup-modal.teamScreen.branding";
    AccountSetupScreens["JTBD"] = "onboarding-account-setup-modal.jtbdScreen";
    AccountSetupScreens["JTBD_MODERN_BRANDING"] = "onboarding-account-setup-modal.jtbdScreen.branding";
    AccountSetupScreens["LOADING"] = "onboarding-account-setup-modal.loadingScreen";
    AccountSetupScreens["LOADING_MODERN_BRANDING"] = "onboarding-account-setup-modal.loadingScreen.branding";
    AccountSetupScreens["TEMPLATE"] = "onboarding-account-setup-modal.templateScreen";
    AccountSetupScreens["TEMPLATE_MODERN_BRANDING"] = "onboarding-account-setup-modal.templateScreen.branding";
    AccountSetupScreens["INVITE"] = "onboarding-account-setup-modal.inviteScreen";
    AccountSetupScreens["INVITE_MODERN_BRANDING"] = "onboarding-account-setup-modal.inviteScreen.branding";
    AccountSetupScreens["CONTENTTYPE"] = "onboarding-account-setup-modal.contentTypeScreen";
    // founding admin
    AccountSetupScreens["NTH_USER_CONTENT_TYPE"] = "onboarding-account-setup-modal.nthUserContentTypeScreen";
    // nth user
    AccountSetupScreens["SPACESTOFOLLOW"] = "onboarding-account-setup-modal.spacesToFollowScreen";
    AccountSetupScreens["EDITION"] = "onboarding-account-setup-modal.editionCommunicationScreen";
    AccountSetupScreens["AUTOPROVISIONING_EDITION"] = "onboarding-account-setup-modal.autoprovisioningEditionScreen";
    AccountSetupScreens["JTBD_CONTENT"] = "onboarding-account-setup-modal.jtbdContentScreen";
    AccountSetupScreens["USE_CASES"] = "onboarding-account-setup-modal.useCasesScreen";
    AccountSetupScreens["TEAMMATE_CONTENT"] = "onboarding-account-setup-modal.teammateContentScreen";
    AccountSetupScreens["AIFC_CONTENT_TEAM_TYPE"] = "onboarding-account-setup-modal.aifcContentTeamTypeScreen";
    AccountSetupScreens["GFC_CONTENT_TEAM_TYPE"] = "onboarding-account-setup-modal.gfcContentTeamTypeScreen";
    AccountSetupScreens["AIFC_ONBOARDING_INPUT"] = "onboarding-account-setup-modal.aifcOnboardingInputScreen";
    AccountSetupScreens["GFC_TEMPLATE_ROVO_CREATE"] = "onboarding-account-setup-modal.gfcTemplateScreen";
    AccountSetupScreens["RECOMMENDED_SPACES"] = "onboarding-account-setup-modal.recommendedSpacesScreen";
    AccountSetupScreens["MULTI_APP_INLINE_CONNECTION"] = "onboarding-account-setup-modal.multiAppInlineConnectionScreen";
    AccountSetupScreens["SINGLE_APP_INLINE_CONNECTION"] = "onboarding-account-setup-modal.singleAppInlineConnectionScreen";
    AccountSetupScreens["CWR_NTH_USER_ONBOARDING"] = "onboarding-account-setup-modal.cwrNthUserOnboardingScreen";
    return AccountSetupScreens;
}({});
var $cabc5f48a2666489$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["PAGE"] = "page";
    ContentType["LIVE_DOC"] = "live-doc";
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["DATABASE"] = "database";
    ContentType["KNOWLEDGE_HUB"] = "knowledge-hub";
    return ContentType;
}({});
var $cabc5f48a2666489$export$6435071f58aaae6a = /*#__PURE__*/ function(NthUserContentType) {
    NthUserContentType["PAGE"] = "page";
    NthUserContentType["WHITEBOARD"] = "whiteboard";
    NthUserContentType["LIVE_DOC"] = "live-doc";
    NthUserContentType["DATABASE"] = "database";
    return NthUserContentType;
}({});
var $cabc5f48a2666489$export$3a8c8363200890be = /*#__PURE__*/ function(RecommendationType) {
    RecommendationType["POPULAR"] = "popular";
    RecommendationType["TEAM_SPACE"] = "teammates";
    return RecommendationType;
}({});
var $cabc5f48a2666489$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
module.exports["Team"] = $cabc5f48a2666489$export$3e5d0af8e738b082;
module.exports["TEAM_ID_MAP"] = $cabc5f48a2666489$export$77134aba51f821f8;
module.exports["FocusArea"] = $cabc5f48a2666489$export$a0b0994d6b76cdaa;
module.exports["TemplateBlueprintModuleCompleteKey"] = $cabc5f48a2666489$export$8764a1262502aaf9;
module.exports["Template"] = $cabc5f48a2666489$export$14416b8d99d47caa;
module.exports["WhiteboardTemplate"] = $cabc5f48a2666489$export$a6ffeca29f180ace;
module.exports["KnowledgeHubTemplate"] = $cabc5f48a2666489$export$8b6f874ad242ca1b;
module.exports["AccountSetupScreens"] = $cabc5f48a2666489$export$64e2ed2cf579d2ef;
module.exports["ContentType"] = $cabc5f48a2666489$export$e2e108cbe2e4f865;
module.exports["NthUserContentType"] = $cabc5f48a2666489$export$6435071f58aaae6a;
module.exports["RecommendationType"] = $cabc5f48a2666489$export$3a8c8363200890be;
module.exports["ConfluenceEdition"] = $cabc5f48a2666489$export$68577d543b14ae02;

});

parcelRegister("4yg2A", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $c550e533eafdac36$export$a13b342a3f580b52 = /*#__PURE__*/ function(FeedType) {
    FeedType["DIRECT"] = "DIRECT";
    FeedType["FOLLOWING"] = "FOLLOWING";
    FeedType["POPULAR"] = "POPULAR";
    FeedType["WELCOME"] = "WELCOME";
    FeedType["FAREWELL"] = "FAREWELL";
    return FeedType;
}({});
module.exports["FeedType"] = $c550e533eafdac36$export$a13b342a3f580b52;

});

parcelRegister("4Cx0V", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $l998X = parcelRequire("l998X");


var $2mPpz = parcelRequire("2mPpz");


var $cyz5M = parcelRequire("cyz5M");


var $6Ht9d = parcelRequire("6Ht9d");




/* skeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");


var $fwDOR = parcelRequire("fwDOR");


var $kpYGL = parcelRequire("kpYGL");

const $4b37b39623475e79$var$placeholderStyles = null;
const $4b37b39623475e79$export$a762e2300443622e = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
        name: "confluence-home-banner-loading",
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-testid": "confluence-home-banner-loading-skeleton",
            className: (0, $gMc0m.default)([
                "_1yt4xy5q _1reo15vq _18m915vq _19itj0fz _16jlkb7n _1o9zkb7n _i0dl1osq _2rko12b0 _4t3i1jfw _1e0c1txw _1bah1yb4 _4cvr1h6o _otyr1ejb _bqxkpxbi"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                alignInline: "center",
                alignBlock: "center",
                spread: "space-between",
                grow: "fill",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                        width: "145px",
                        height: "44px",
                        borderRadius: "3px",
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                width: "460px",
                                height: "25px",
                                borderRadius: "3px",
                                isShimmering: true
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                width: "460px",
                                height: "25px",
                                borderRadius: "3px",
                                isShimmering: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                        width: "195px",
                        height: "40px",
                        borderRadius: "3px",
                        isShimmering: true
                    })
                ]
            })
        })
    });
};
var $4b37b39623475e79$export$2e2bcd8739ae039 = $4b37b39623475e79$export$a762e2300443622e;


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 






var $j9AoC = parcelRequire("j9AoC");

const $56ab3d507879a053$var$clientPipeline = (0, $j9AoC.createClientPipeline)();
const $56ab3d507879a053$export$78c758434c34d601 = $56ab3d507879a053$var$clientPipeline.createRender;
const $56ab3d507879a053$export$2859a83e4d6da57d = $56ab3d507879a053$var$clientPipeline.createValidate;
const $56ab3d507879a053$var$serverPipeline = (0, $j9AoC.createServerPipeline)();
const $56ab3d507879a053$export$c905bc718befd59b = $56ab3d507879a053$var$serverPipeline.createHydrate;
const $56ab3d507879a053$export$1f41223e5b0a6622 = $56ab3d507879a053$var$serverPipeline.createHydrateExample;
const $56ab3d507879a053$export$88fe13b4d13f8423 = $56ab3d507879a053$var$serverPipeline.createTransformMetadata;


/* RovoAwarenessHomeBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");


var $lAFHW = parcelRequire("lAFHW");


var $7XIdu = parcelRequire("7XIdu");


var $gVWoV = parcelRequire("gVWoV");




const $152bde5913844257$export$ded08279a8be4c83 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "559",
        height: "236",
        viewBox: "0 0 559 236",
        fill: "none",
        "data-vc": "ebobZ87T",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            d: "M486.715 -22.1858C399.169 -23.4656 463.766 115.967 484.311 156.606C471.045 195.777 442.988 233.946 398.078 233.725C365.725 238.299 341.145 207.89 321.729 186.073C282.999 141.94 293.781 141.377 297.127 86.9212C298.623 42.6571 289.341 -120.166 218.936 -104.546C183.866 -85.2976 208.931 -21.7725 216.562 8.24497C229.031 46.0692 245.459 82.5164 264.304 117.012C276.954 137.358 286.835 150.602 276.871 175.343C260.333 247.95 195.641 407.036 98.0428 352.814C32.5853 300.187 20.1514 207.1 0.939751 133.851C-10.6341 67.5089 -46.5223 29.1707 -85.2953 8.74892C-140.761 -27.0993 -168.346 76.8881 -158.546 122.131C-149.976 162.209 -114.859 183.068 -71.9156 200.208C-40.0898 212.775 -10.9346 220.607 20.1294 234.881C41.7226 243.92 61.4652 237.894 81.0551 237.094C106.299 236.099 130.996 233.819 155.098 227.577C191.174 219.14 226.024 201.797 251.923 176.099C280.639 147.534 299.348 111.127 318.057 74.72C335.486 42.0988 355.024 8.62926 387.855 -11.8486C425.638 -35.8068 468.166 -13.3476 486.715 -22.1858Z",
            fill: "#505258"
        })
    });
};





const $cb5e7f9548ad461b$export$ae0370cf11de76d = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "32",
        height: "31",
        viewBox: "0 0 32 31",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-vc": "COPipyQr",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0.600098 0H1.5626V30.8H0.600098V0Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0.600098 0H27.4501C29.5764 0 31.3001 1.7237 31.3001 3.85V11.55C31.3001 13.6763 29.5764 15.4 27.4501 15.4H0.600098V0Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M5.18683 11.2V4.19745H7.80456C8.34033 4.19745 8.7915 4.29144 9.15808 4.47943C9.52466 4.66742 9.80194 4.9306 9.98993 5.26898C10.1779 5.60423 10.2719 5.9943 10.2719 6.43921C10.2719 6.88411 10.1763 7.27106 9.98523 7.60004C9.79724 7.92902 9.51839 8.1828 9.14868 8.36139C8.77897 8.53998 8.32466 8.62927 7.78576 8.62927H5.91528V7.59064H7.62127C7.93772 7.59064 8.19621 7.54677 8.39673 7.45905C8.59725 7.36818 8.74607 7.23659 8.8432 7.06427C8.94033 6.89195 8.98889 6.68359 8.98889 6.43921C8.98889 6.18785 8.94033 5.98406 8.8432 5.82785C8.74607 5.66835 8.59482 5.55054 8.39031 5.47442C8.18892 5.39831 7.92699 5.36024 7.6045 5.36024H6.38394V11.2H5.18683Z",
                fill: "white"
            })
        ]
    });
};


/* CarouselModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $gdv5Z = parcelRequire("gdv5Z");



var $iXCQx = parcelRequire("iXCQx");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $6xdDU = parcelRequire("6xdDU");


var $gj7hi = parcelRequire("gj7hi");





var $5tOl1 = parcelRequire("5tOl1");


var $bPdpL = parcelRequire("bPdpL");


var $jZuqn = parcelRequire("jZuqn");





var $cO1el = parcelRequire("cO1el");


var $5nBzc = parcelRequire("5nBzc");

var $486e28cf377117b6$exports = {};
$486e28cf377117b6$exports = new URL("GenerateBriefing.12cd6d89.gif", import.meta.url).toString();


var $259fd39aca0bcbc0$exports = {};
$259fd39aca0bcbc0$exports = new URL("CreateWithRovo.900b022b.gif", import.meta.url).toString();


var $84bd09aa0d5e3f61$exports = {};
$84bd09aa0d5e3f61$exports = new URL("WhiteboardFlow.1ec4e94d.gif", import.meta.url).toString();


const $c963ed2edd8dc05d$var$i18n = (0, $aXWIB.defineMessages)({
    carouselModalTitle: {
        id: "confluence-home-rovo-awareness.carousel-modal.title",
        defaultMessage: "More ways to Rovo"
    },
    carouselModalDescription: {
        id: "confluence-home-rovo-awareness.carousel-modal.description",
        defaultMessage: "Discover how you can use Rovo to make your life easier."
    },
    carouselModalAudioTitle: {
        id: "confluence-home-rovo-awareness.carousel-modal.audio-title",
        defaultMessage: "Get briefed on the go"
    },
    carouselModalAudioDescription: {
        id: "confluence-home-rovo-awareness.carousel-modal.audio-description",
        defaultMessage: "Rovo\u2032s audio briefings can fill you in on key information from your team.Just hit play and go for a walk."
    },
    carouselModalCreateTitle: {
        id: "confluence-home-rovo-awareness.carousel-modal.create-title",
        defaultMessage: "Bye-bye blank page"
    },
    carouselModalCreateDescription: {
        id: "confluence-home-rovo-awareness.carousel-modal.create-description",
        defaultMessage: "You describe, Rovo creates. Pages, live docs, whiteboards, databases \u2014 Rovo does it all."
    },
    carouselModalDiagramTitle: {
        id: "confluence-home-rovo-awareness.carousel-modal.diagram-title",
        defaultMessage: "Let flow charts flow"
    },
    carouselModalDiagramDescription: {
        id: "confluence-home-rovo-awareness.carousel-modal.diagram-description",
        defaultMessage: "Rovo can draw the diagrams for you that clearly communicate your ideas."
    },
    carouselModalCarouselImageAlt: {
        id: "confluence-home-rovo-awareness.carousel-modal.carousel-image-alt",
        defaultMessage: "New Feature"
    },
    carouselModalPreviousLabel: {
        id: "confluence-home-rovo-awareness.carousel-modal.previous-label",
        defaultMessage: "Previous"
    },
    carouselModalNextLabel: {
        id: "confluence-home-rovo-awareness.carousel-modal.next-label",
        defaultMessage: "Next"
    },
    carouselModalLozengeNew: {
        id: "confluence-home-rovo-awareness.carousel-modal.lozenge-new",
        defaultMessage: "New"
    },
    carouselModalLozengeComingSoon: {
        id: "confluence-home-rovo-awareness.carousel-modal.lozenge-coming-soon",
        defaultMessage: "Coming soon"
    }
});
const $c963ed2edd8dc05d$var$getCarouselSlides = (formatMessage)=>[
        {
            title: formatMessage($c963ed2edd8dc05d$var$i18n.carouselModalAudioTitle),
            description: formatMessage($c963ed2edd8dc05d$var$i18n.carouselModalAudioDescription),
            imageAlt: formatMessage($c963ed2edd8dc05d$var$i18n.carouselModalCarouselImageAlt),
            imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($486e28cf377117b6$exports))),
            lozenge: {
                text: formatMessage($c963ed2edd8dc05d$var$i18n.carouselModalLozengeNew),
                appearance: 'new'
            }
        },
        {
            title: formatMessage($c963ed2edd8dc05d$var$i18n.carouselModalCreateTitle),
            description: formatMessage($c963ed2edd8dc05d$var$i18n.carouselModalCreateDescription),
            imageAlt: formatMessage($c963ed2edd8dc05d$var$i18n.carouselModalCarouselImageAlt),
            imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($259fd39aca0bcbc0$exports))),
            lozenge: {
                text: formatMessage($c963ed2edd8dc05d$var$i18n.carouselModalLozengeComingSoon),
                appearance: 'inprogress'
            }
        },
        {
            title: formatMessage($c963ed2edd8dc05d$var$i18n.carouselModalDiagramTitle),
            description: formatMessage($c963ed2edd8dc05d$var$i18n.carouselModalDiagramDescription),
            imageAlt: formatMessage($c963ed2edd8dc05d$var$i18n.carouselModalCarouselImageAlt),
            imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($84bd09aa0d5e3f61$exports))),
            lozenge: {
                text: formatMessage($c963ed2edd8dc05d$var$i18n.carouselModalLozengeNew),
                appearance: 'new'
            }
        }
    ];
const $c963ed2edd8dc05d$var$styles = {
    carouselContainer: "_1reo15vq _18m915vq _zulputpp _1e0c1txw _2lx2vrvc _1bsb1osq _rjfvx6dd _1dm8q5uf _19pkv47k",
    slideWrapper: "_16jlidpf _1o9zidpf _i0dl1osq _zulpu2gc _1hu1v2br _1ul91osq _1e0c1txw _2lx21bp4 _4cvr1y6m _y3gn1e5h",
    textContainer: "_zulpv77o _1e0c1txw _2lx21bp4 _4cvr1y6m _19pkpxbi",
    imageStyles: "_2rkopb1k _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x _kqswh2mm _bfhk1j28 _1bsb1osq _p12f1c3h _1h1t1ixt _1e0c1txw _4cvr1h6o _1bah1h6o _5ral1dfr",
    lozengeOverlay: "_kqswstnw _154ipxbi _1ltvpxbi _1pbykb7n",
    controlsContainer: "_1e0c1txw _1bah1yb4 _4cvr1h6o _1bsb1osq _19pkpxbi"
};
const $c963ed2edd8dc05d$var$CarouselSlide = ({ title: title, description: description, imageAlt: imageAlt, imageSrc: imageSrc, lozenge: lozenge, index: index, selectedIndex: selectedIndex })=>{
    const cardRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (cardRef.current && selectedIndex === index) cardRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
        });
    }, [
        selectedIndex,
        index
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $c963ed2edd8dc05d$var$styles.slideWrapper,
        ref: cardRef,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $c963ed2edd8dc05d$var$styles.imageStyles,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                        src: imageSrc,
                        alt: imageAlt
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $c963ed2edd8dc05d$var$styles.lozengeOverlay,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                            appearance: lozenge.appearance,
                            isBold: true,
                            maxWidth: "None",
                            children: lozenge.text
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $c963ed2edd8dc05d$var$styles.textContainer,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "large",
                        weight: "semibold",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text.subtlest",
                        children: description
                    })
                ]
            })
        ]
    });
};
const $c963ed2edd8dc05d$var$CarouselModalContent = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [selectedIndex, setSelectedIndex] = (0, $42omo.useState)(0);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const { messageInstanceClicked: messageInstanceClicked, messageInstanceViewed: messageInstanceViewed } = (0, $gVWoV.useMessageInstanceEvent)();
    const carouselSlides = (0, $42omo.useMemo)(()=>$c963ed2edd8dc05d$var$getCarouselSlides(formatMessage), [
        formatMessage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!messageInstanceViewed) return;
        messageInstanceViewed();
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'RovoAwarenessCarouselModal'
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handlePrevious = ()=>{
        const newIndex = selectedIndex === 0 ? carouselSlides.length - 1 : selectedIndex - 1;
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'carouselPrevious',
                clickedElement: 'button',
                buttonType: 'secondary'
            },
            action: {
                actionType: 'open'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoAwarenessCarouselPreviousButton',
            attributes: {
                fromSlideIndex: selectedIndex,
                toSlideIndex: newIndex
            }
        });
        setSelectedIndex(newIndex);
    };
    const handleNext = ()=>{
        const newIndex = selectedIndex === carouselSlides.length - 1 ? 0 : selectedIndex + 1;
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'carouselNext',
                clickedElement: 'button',
                buttonType: 'secondary'
            },
            action: {
                actionType: 'open'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoAwarenessCarouselNextButton',
            attributes: {
                fromSlideIndex: selectedIndex,
                toSlideIndex: newIndex
            }
        });
        setSelectedIndex(newIndex);
    };
    const handleSelectIndex = (index)=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'carouselProgressIndicator',
                clickedElement: 'button',
                buttonType: 'secondary'
            },
            action: {
                actionType: 'open'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoAwarenessCarouselProgressIndicator',
            attributes: {
                fromSlideIndex: selectedIndex,
                toSlideIndex: index
            }
        });
        setSelectedIndex(index);
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
        onClose: onClose,
        width: "850px",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                hasCloseButton: true,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.150",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
                            size: "small",
                            appearance: "brand",
                            shouldUseNewLogoDesign: true
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                            size: "xlarge",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...$c963ed2edd8dc05d$var$i18n.carouselModalTitle
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text.subtlest",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...$c963ed2edd8dc05d$var$i18n.carouselModalDescription
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $c963ed2edd8dc05d$var$styles.carouselContainer,
                        children: carouselSlides.map((slide, index)=>/*#__PURE__*/ (0, $l998X.jsx)($c963ed2edd8dc05d$var$CarouselSlide, {
                                title: slide.title,
                                description: slide.description,
                                imageAlt: slide.imageAlt,
                                imageSrc: slide.imageSrc,
                                lozenge: slide.lozenge,
                                index: index,
                                selectedIndex: selectedIndex
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $8o1lj.default), {
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    xcss: $c963ed2edd8dc05d$var$styles.controlsContainer,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            shape: "circle",
                            icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
                                    ...iconProps,
                                    size: "medium"
                                }),
                            label: formatMessage($c963ed2edd8dc05d$var$i18n.carouselModalPreviousLabel),
                            onClick: handlePrevious
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $jZuqn.default), {
                            onSelect: ({ event: _, index: index })=>handleSelectIndex(index),
                            selectedIndex: selectedIndex,
                            values: carouselSlides.map((_, i)=>i)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            shape: "circle",
                            icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))), {
                                    ...iconProps,
                                    size: "medium"
                                }),
                            label: formatMessage($c963ed2edd8dc05d$var$i18n.carouselModalNextLabel),
                            onClick: handleNext
                        })
                    ]
                })
            })
        ]
    });
};
const $c963ed2edd8dc05d$export$260b9a691de17a4b = ({ isOpen: isOpen, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: isOpen && /*#__PURE__*/ (0, $l998X.jsx)($c963ed2edd8dc05d$var$CarouselModalContent, {
            onClose: onClose
        })
    });
};





const $8e6c9b980493947f$export$fdc3038398c14da = ({ fireAnalyticsEvent: fireAnalyticsEvent, messageInstanceClicked: messageInstanceClicked, onDismissed: onDismissed, setIsModalOpen: setIsModalOpen })=>{
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'dismissBanner',
                clickedElement: 'cross-icon'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoAwarenessHomeBannerDismiss'
        });
        onDismissed();
    }, [
        fireAnalyticsEvent,
        messageInstanceClicked,
        onDismissed
    ]);
    const handleAskRovoClick = (0, $42omo.useCallback)(()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'askRovo',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'open'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoAwarenessHomeBannerAskRovo'
        });
    // Ask Rovo handler - can be expanded as needed
    }, [
        fireAnalyticsEvent,
        messageInstanceClicked
    ]);
    const handleMoreIdeasClick = (0, $42omo.useCallback)(()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'moreIdeas',
                clickedElement: 'button',
                buttonType: 'secondary'
            },
            action: {
                actionType: 'open'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoAwarenessHomeBannerMoreIdeas'
        });
        setIsModalOpen(true);
    }, [
        fireAnalyticsEvent,
        messageInstanceClicked,
        setIsModalOpen
    ]);
    return (0, $42omo.useMemo)(()=>({
            handleDismiss: handleDismiss,
            handleAskRovoClick: handleAskRovoClick,
            handleMoreIdeasClick: handleMoreIdeasClick
        }), [
        handleDismiss,
        handleAskRovoClick,
        handleMoreIdeasClick
    ]);
};


const $aeb4bf895409d33b$var$i18n = (0, $aXWIB.defineMessages)({
    bannerHeader: {
        id: "confluence-home-rovo-awareness.banner.header",
        defaultMessage: "Ask Rovo to get you up to speed, create automations, brainstorm ideas, and more."
    },
    bannerDescription: {
        id: "confluence-home-rovo-awareness.banner.description",
        defaultMessage: "Let your AI teammate do the heavy lifting so you can focus on what matters. Just ask."
    },
    bannerAskAnythingCTA: {
        id: "confluence-home-rovo-awareness.banner.ask-anything-cta",
        defaultMessage: "Ask Rovo"
    },
    bannerMoreIdeasCTA: {
        id: "confluence-home-rovo-awareness.banner.more-ideas-cta",
        defaultMessage: "More ideas"
    },
    searchBarImageText: {
        id: "confluence-home-rovo-awareness.banner.search-bar-image-text",
        defaultMessage: "If you Rovo, you know..."
    },
    dismissBannerCTA: {
        id: "confluence-home-rovo-awareness.banner.dismiss-banner-cta",
        defaultMessage: "Close banner"
    }
});
const $aeb4bf895409d33b$export$29f9650e7f5c44eb = ({ onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const { messageInstanceClicked: messageInstanceClicked, messageInstanceViewed: messageInstanceViewed } = (0, $gVWoV.useMessageInstanceEvent)();
    (0, $42omo.useEffect)(()=>{
        if (!messageInstanceViewed) return;
        messageInstanceViewed();
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'RovoAwarenessHomeBanner'
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { handleDismiss: handleDismiss, handleAskRovoClick: handleAskRovoClick, handleMoreIdeasClick: handleMoreIdeasClick } = (0, $8e6c9b980493947f$export$fdc3038398c14da)({
        fireAnalyticsEvent: fireAnalyticsEvent,
        messageInstanceClicked: messageInstanceClicked,
        onDismissed: onDismissed,
        setIsModalOpen: setIsModalOpen
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rkopb1k _19it1l7x _kqswh2mm _bfhkqlpt _syaz15cr _ca0q1jfw _n3td1jfw _19bv1jfw _u5f31jfw _1e0c11p5 _yv0ehkll _1f38gt2h _7cca15wb _1rqtwxkt"
        ]),
        "data-vc": "Dl-5JfS9",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                xcss: $aeb4bf895409d33b$var$styles.contentStyles,
                space: "space.400",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                                direction: "row",
                                alignItems: "center",
                                gap: "space.100",
                                xcss: $aeb4bf895409d33b$var$styles.relativeStyles,
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
                                        size: "large",
                                        appearance: "brand",
                                        shouldUseNewLogoDesign: true
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)("span", {
                                        className: (0, $gMc0m.default)([
                                            $aeb4bf895409d33b$var$unboundStyles.headerStyles,
                                            $aeb4bf895409d33b$var$unboundStyles.whiteTextColor
                                        ]),
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                            ...$aeb4bf895409d33b$var$i18n.bannerHeader
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                size: "large",
                                children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                                    className: (0, $gMc0m.default)([
                                        $aeb4bf895409d33b$var$unboundStyles.whiteTextColor
                                    ]),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                        ...$aeb4bf895409d33b$var$i18n.bannerDescription
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                        space: "space.050",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("button", {
                                onClick: handleAskRovoClick,
                                "data-testid": "ask-rovo-button",
                                className: (0, $gMc0m.default)([
                                    $aeb4bf895409d33b$var$unboundStyles.buttonStyles,
                                    $aeb4bf895409d33b$var$unboundStyles.primaryButtonStyles,
                                    $aeb4bf895409d33b$var$unboundStyles.whiteTextColor
                                ]),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...$aeb4bf895409d33b$var$i18n.bannerAskAnythingCTA
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("button", {
                                onClick: handleMoreIdeasClick,
                                className: (0, $gMc0m.default)([
                                    $aeb4bf895409d33b$var$unboundStyles.buttonStyles,
                                    $aeb4bf895409d33b$var$unboundStyles.defaultButtonStyles
                                ]),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...$aeb4bf895409d33b$var$i18n.bannerMoreIdeasCTA
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $aeb4bf895409d33b$var$unboundStyles.rightContainerStyles
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                    className: (0, $gMc0m.default)([
                        $aeb4bf895409d33b$var$unboundStyles.searchBarStyles
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("span", {
                            className: (0, $gMc0m.default)([
                                $aeb4bf895409d33b$var$unboundStyles.headerStyles,
                                $aeb4bf895409d33b$var$unboundStyles.rovoTelepointerSpacerStyles,
                                $aeb4bf895409d33b$var$unboundStyles.rovoGradientText
                            ]),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...$aeb4bf895409d33b$var$i18n.searchBarImageText
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cb5e7f9548ad461b$export$ae0370cf11de76d), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $aeb4bf895409d33b$var$unboundStyles.dismissIconStyles
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    isTooltipDisabled: false,
                    label: formatMessage($aeb4bf895409d33b$var$i18n.dismissBannerCTA),
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                    onClick: handleDismiss
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $aeb4bf895409d33b$var$unboundStyles.greySwirlContainerStyles
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        $aeb4bf895409d33b$var$unboundStyles.greySwirlStyles
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $152bde5913844257$export$ded08279a8be4c83), {})
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $c963ed2edd8dc05d$export$260b9a691de17a4b), {
                isOpen: isModalOpen,
                onClose: ()=>setIsModalOpen(false)
            })
        ]
    });
};
const $aeb4bf895409d33b$var$containerStyles = null; /**
                               * Every single eslint disable here is based on the design of the banner being the same between dark and light mode. This means
                               * we can't use any tokens as they automatically update between the two themes as well as most ADS components as they also use tokens internally.
                               * This means we can't use Headings, Texts, and Buttons (all variations of buttons).
                               */ 
const $aeb4bf895409d33b$var$unboundStyles = {
    rightContainerStyles: "_1reo15vq _18m915vq _kqswh2mm _1e0c1txw _4cvr1h6o _2lx21sbv _1pbykb7n _8lr5glyw",
    headerStyles: "_1wyb1tcg",
    whiteTextColor: "_syazu67f",
    searchBarPositioner: "_1e0c1txw _1bah1h6o _2lx21sbv",
    searchBarReverse: "_1bsb1osq _1e0c1txw",
    searchBarStyles: "_1reo15vq _18m915vq _1yt4pxbi _13li12b0 _mrkb12b0 _bfhku67f _p12f1gwv _o5721q9c",
    rovoTelepointerSpacerStyles: "_2hwx1b66",
    greySwirlContainerStyles: "_kqswstnw _1pbyidpf _1xi2idpf _4t3i1osq",
    greySwirlStyles: "_4t3i1osq",
    rovoGradientText: "_1itk1eh1 _1y1m1kdv _syaz1j28",
    buttonStyles: "_ca0qi2wt _u5f31crf _n3tdi2wt _19bv1crf _19itglyw _2rko1qi0 _11c8fhey _syazu67f _k48p1wq8 _4t3izwfg _vchhusvi _80omtlke",
    primaryButtonStyles: "_bfhkjexw _irr3f5h9 _1di61bc7",
    primaryButtonPressedStyles: "_bfhk1bc7",
    defaultButtonStyles: "_19it35bj _syazu67f _bfhkyd6a _30l3u67f _irr317x0",
    dismissIconStyles: "_154iutpp _1xi2utpp _kqswstnw _80omtlke _1pbykb7n _58eju67f _1nlxyd6a _l2uv17x0 _1hn7u67f _2yogu67f"
};
const $aeb4bf895409d33b$var$styles = {
    contentStyles: "_1ul9ix73 _1pbykb7n",
    headerContainerStyles: "_1reo15vq _18m915vq _4t3i1osq",
    inlineBlockStyles: "_1e0c1o8l",
    relativeStyles: "_kqswh2mm"
};


const $c323ab387cd18dfd$export$b3890eb0ae9dca99 = (0, $56ab3d507879a053$export$78c758434c34d601)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aeb4bf895409d33b$export$29f9650e7f5c44eb), {
        onDismissed: onDismissed
    }));
var $c323ab387cd18dfd$export$2e2bcd8739ae039 = $c323ab387cd18dfd$export$b3890eb0ae9dca99;








const $e2ba2a4ae00b978f$var$clientPipeline = (0, $j9AoC.createClientPipeline)();
const $e2ba2a4ae00b978f$export$78c758434c34d601 = $e2ba2a4ae00b978f$var$clientPipeline.createRender;
const $e2ba2a4ae00b978f$export$2859a83e4d6da57d = $e2ba2a4ae00b978f$var$clientPipeline.createValidate;
const $e2ba2a4ae00b978f$var$serverPipeline = (0, $j9AoC.createServerPipeline)();
const $e2ba2a4ae00b978f$export$c905bc718befd59b = $e2ba2a4ae00b978f$var$serverPipeline.createHydrate;
const $e2ba2a4ae00b978f$export$1f41223e5b0a6622 = $e2ba2a4ae00b978f$var$serverPipeline.createHydrateExample;
const $e2ba2a4ae00b978f$export$88fe13b4d13f8423 = $e2ba2a4ae00b978f$var$serverPipeline.createTransformMetadata;


const $cab426d5d6981a6b$export$b3890eb0ae9dca99 = (0, $e2ba2a4ae00b978f$export$78c758434c34d601)(()=>/*#__PURE__*/ (0, $l998X.jsx)("button", {
        "data-vc": "lhuOHIxu",
        children: "This is an example test button"
    }));
var $cab426d5d6981a6b$export$2e2bcd8739ae039 = $cab426d5d6981a6b$export$b3890eb0ae9dca99;






var $cOrQJ = parcelRequire("cOrQJ");

/* recommendation.tsx generated by @compiled/babel-plugin v0.36.1 */ 








/* message.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $c6GJD = parcelRequire("c6GJD");


var $fVUfS = parcelRequire("fVUfS");

parcelRequire("2YerA");
var $jCM2u = parcelRequire("jCM2u");





var $jVJ5P = parcelRequire("jVJ5P");




const $b7aa2c3b8cf3d44a$export$1c3f82bc53516a2a = (crossflowOptions, clickedElement)=>{
    const crossflow = (0, $jCM2u.useCrossFlow)();
    const { messageClicked: messageClicked } = (0, $jVJ5P.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $gVWoV.useMessageInstanceEvent)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        messageClicked().catch(()=>{});
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: clickedElement,
            action: {
                actionType: 'acknowledge'
            },
            additionalMetadataFromFrontend: {}
        }).catch(()=>{});
        if (crossflow.isEnabled) crossflow.api.open(crossflowOptions).catch(()=>{});
    }, [
        crossflow,
        crossflowOptions,
        clickedElement,
        messageClicked,
        messageInstanceClicked
    ]);
    return {
        handleClick: handleClick
    };
};



var $4oTqF = parcelRequire("4oTqF");

parcelRequire("42omo");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");











var $3gadb = parcelRequire("3gadb");


var $j01vW = parcelRequire("j01vW");










const $20907c29dc002f27$var$DismissButton = ({ onDismissed: onDismissed })=>{
    const { messageDismissed: messageDismissed } = (0, $jVJ5P.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $gVWoV.useMessageInstanceEvent)();
    const intl = (0, $aXWIB.useIntl)();
    const tooltip = intl.formatMessage({
        id: "post-office.close-button.tooltip",
        defaultMessage: "Close"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: tooltip,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
            shape: "default",
            appearance: "subtle",
            label: "close",
            icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                    ...iconProps,
                    size: "small"
                }),
            onClick: ()=>{
                onDismissed();
                messageDismissed().catch(()=>{});
                messageInstanceClicked({
                    messageEventType: 'clicked',
                    clickedElement: {
                        clickIdentifier: 'close',
                        clickedElement: 'button',
                        buttonType: 'primary'
                    },
                    action: {
                        actionType: 'dismiss'
                    },
                    additionalMetadataFromFrontend: {}
                }).catch(()=>{});
            }
        })
    });
};
const $20907c29dc002f27$var$actionsStyles = null;
const $20907c29dc002f27$export$b52183d5cfb26dc9 = ({ onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw"
        ]),
        "data-vc": "cMOabhBl",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $j01vW.AdControls), {
                iconSize: "small",
                onDismissed: onDismissed,
                showWhyAmISeeingThis: true,
                whyAmISeeingThisModalContent: whyAmISeeingThisModalContent
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($20907c29dc002f27$var$DismissButton, {
                onDismissed: onDismissed
            })
        ]
    });
};


const $c18480ecfd1dac07$var$confluenceBannerMessageStylesCss = null;
const $c18480ecfd1dac07$var$styles = {
    confluenceBannerMessage: "_2rko1mok _1yt4pxbi _kqswh2mm _1e0c1txw _4cvr1h6o _1bah1h6o _y3gn1e5h _bfhk1s93 _1tkel1r9 _19bv1ejb _otyr1ejb _1ubta3nm _d0altlke _owpuoahv _1s0l1ejb"
};
const $c18480ecfd1dac07$var$RECOMMENDATION_MESSAGE_CLICKED_ELEMENT = {
    clickIdentifier: 'recommendation-message',
    clickedElement: 'link'
};
const $c18480ecfd1dac07$export$8e69ee67bea8fbdd = ({ onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, bodyContent: bodyContent, ctaContent: ctaContent, crossflowOptions: crossflowOptions })=>{
    const { messageInstanceId: messageInstanceId } = (0, $4oTqF.useMessageContext)();
    const { handleClick: handleClick } = (0, $b7aa2c3b8cf3d44a$export$1c3f82bc53516a2a)(crossflowOptions, $c18480ecfd1dac07$var$RECOMMENDATION_MESSAGE_CLICKED_ELEMENT);
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    const handleMessageClick = (e)=>{
        const currentTarget = e.currentTarget;
        let target = e.target;
        while(target.parentNode){
            if (target.tagName.toLowerCase() === 'button' || target.tagName.toLowerCase() === 'a' || target.tagName.toLowerCase() === 'html' // this is for the modal & its transparent background
            ) // Don't open Cross-flow since these child elements should've already handled the click
            return;
             // Open Cross-flow if the click is on the banner message itself
            if (target === currentTarget) {
                handleClick();
                return;
            } // Keep traversing up the DOM tree
            target = target.parentNode;
        }
    };
    return (0, $c6GJD.default).checkGate('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
        testId: "confluence-banner-message",
        xcss: $c18480ecfd1dac07$var$styles.confluenceBannerMessage,
        onClick: handleMessageClick,
        children: [
            bodyContent,
            ctaContent,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $20907c29dc002f27$export$b52183d5cfb26dc9), {
                whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
                onDismissed: ()=>onDismissed?.(messageInstanceId)
            })
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        "data-testid": "confluence-banner-message",
        onClick: handleMessageClick,
        className: (0, $gMc0m.default)([
            "_2rko1mok _18zroahv _1rjc1ejb _kqswh2mm _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk1s93 _1tke1jfw _1pbyidpf _otyr1ejb _1ubta3nm _d0altlke _bqxkpxbi _1lzu1ejb"
        ]),
        children: [
            bodyContent,
            ctaContent,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $20907c29dc002f27$export$b52183d5cfb26dc9), {
                whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
                onDismissed: ()=>onDismissed?.(messageInstanceId)
            })
        ]
    });
};









var $ecnYn = parcelRequire("ecnYn");





var $ccHMk = parcelRequire("ccHMk");


var $2W0qg = parcelRequire("2W0qg");


const $e297e79792765034$var$PRIMARY_LINK_CLICKED_ELEMENT = {
    clickIdentifier: 'cta',
    clickedElement: 'button',
    buttonType: 'primary'
};
const $e297e79792765034$export$55d6f395fee83ac9 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, appearance: appearance, alt: alt })=>{
    const { handleClick: handleClick } = (0, $b7aa2c3b8cf3d44a$export$1c3f82bc53516a2a)(crossflowOptions, $e297e79792765034$var$PRIMARY_LINK_CLICKED_ELEMENT);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
        onClick: handleClick,
        appearance: appearance,
        "aria-label": alt,
        children: ctaText
    });
};
const $e297e79792765034$var$PRIMARY_BUTTON_CLICKED_ELEMENT = {
    clickIdentifier: 'cta',
    clickedElement: 'button',
    buttonType: 'primary'
};
const $e297e79792765034$export$585a4ef79f2a8b77 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, pressableStyle: pressableStyle, alt: alt })=>{
    const { handleClick: handleClick } = (0, $b7aa2c3b8cf3d44a$export$1c3f82bc53516a2a)(crossflowOptions, $e297e79792765034$var$PRIMARY_BUTTON_CLICKED_ELEMENT);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
        onClick: handleClick,
        xcss: pressableStyle,
        "aria-label": alt,
        children: ctaText
    });
};
const $e297e79792765034$var$SECONDARY_BUTTON_CLICKED_ELEMENT = {
    clickIdentifier: 'cta',
    clickedElement: 'button',
    buttonType: 'secondary'
};
const $e297e79792765034$export$ba0dce35a480e0b4 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, pressableStyle: pressableStyle, alt: alt })=>{
    const { handleClick: handleClick } = (0, $b7aa2c3b8cf3d44a$export$1c3f82bc53516a2a)(crossflowOptions, $e297e79792765034$var$SECONDARY_BUTTON_CLICKED_ELEMENT);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
        onClick: handleClick,
        xcss: pressableStyle,
        "aria-label": alt,
        children: ctaText
    });
};





const $1f90a1cd1575b07d$var$JOURNEY = 'get-started';
const $1f90a1cd1575b07d$var$SOURCE_COMPONENT = 'confluence-home-banner';
const $1f90a1cd1575b07d$export$f88093e38da354ae = ({ app: app, sourceContext: sourceContext })=>({
        targetProduct: app.hamsIdentifier,
        journey: $1f90a1cd1575b07d$var$JOURNEY,
        sourceComponent: $1f90a1cd1575b07d$var$SOURCE_COMPONENT,
        sourceContext: sourceContext
    });


const $563f5942e399d301$var$buttonText = /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
    id: "post-office.confluence-banner-first-party-recommendation.try-it-now",
    defaultMessage: "Try it now"
});
const $563f5942e399d301$var$ctaButtonStyles = (0, $ecnYn.xcss)({
    minWidth: '100px',
    color: 'color.link',
    marginRight: 'space.100',
    backgroundColor: 'color.background.accent.blue.subtlest',
    paddingInline: 'space.150',
    paddingBlock: 'space.100',
    fontWeight: 'font.weight.medium',
    borderRadius: 'radius.small',
    fontSize: '14px',
    ':hover': {
        backgroundColor: 'color.background.accent.blue.subtler'
    }
});
const $563f5942e399d301$export$bd36621ef7814117 = ({ app: app })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $e297e79792765034$export$585a4ef79f2a8b77), {
        crossflowOptions: (0, $1f90a1cd1575b07d$export$f88093e38da354ae)({
            app: app,
            sourceContext: 'tryItNow'
        }),
        ctaText: $563f5942e399d301$var$buttonText,
        pressableStyle: $563f5942e399d301$var$ctaButtonStyles
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $3f5141e28bdc61dc$var$dividerStyles = null;
const $3f5141e28bdc61dc$export$2e0a83ec2e27ecbb = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_18s81e2i _1wpz1fhb _1bsb10wa _bfhk1l7x"
        ]),
        "data-vc": "eE9VPVpA"
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $53ac8808205c883d$var$valuePropositionStyles = null;
const $53ac8808205c883d$var$headerStyles = null;
const $53ac8808205c883d$var$bodyStyles = null;
const $53ac8808205c883d$export$41a3c9c96d264ad5 = ({ app: app })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _2hwx1ejb"
        ]),
        "data-vc": "9xcI5r-V",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                role: "presentation",
                className: (0, $gMc0m.default)([
                    "_11c81qyo _syazi7uo"
                ]),
                children: app.header
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("p", {
                className: (0, $gMc0m.default)([
                    "_11c8fhey _19pk1b66 _syazazsu"
                ]),
                children: app.description
            })
        ]
    });
};



const $67b25d6bc13c083d$var$bodyContentContainerStyles = null;
const $67b25d6bc13c083d$var$logoContainerStyles = null;
const $67b25d6bc13c083d$var$BodyContent = ({ app: app })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _4t3i1ns9 _1bsb1osq"
        ]),
        "data-vc": "8h5N-Gih",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _4cvr1h6o _4t3ior1b _2hwx7vkz _1chbaq80 _17jbaq80"
                ]),
                children: app.logo
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3f5141e28bdc61dc$export$2e0a83ec2e27ecbb), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $53ac8808205c883d$export$41a3c9c96d264ad5), {
                app: app
            })
        ]
    });
};
const $67b25d6bc13c083d$var$CtaContent = ({ app: app })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $563f5942e399d301$export$bd36621ef7814117), {
        app: app
    });
const $67b25d6bc13c083d$var$RECOMMENDATION_MESSAGE_SOURCE_CONTEXT = 'recommendation-message';
const $67b25d6bc13c083d$export$486c30dd11c42f3 = ({ app: app, onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent })=>{
    const crossflowOptions = (0, $42omo.useMemo)(()=>(0, $1f90a1cd1575b07d$export$f88093e38da354ae)({
            app: app,
            sourceContext: $67b25d6bc13c083d$var$RECOMMENDATION_MESSAGE_SOURCE_CONTEXT
        }), [
        app
    ]);
    const { messageInstanceId: messageInstanceId } = (0, $4oTqF.useMessageContext)();
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $c18480ecfd1dac07$export$8e69ee67bea8fbdd), {
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
        bodyContent: /*#__PURE__*/ (0, $l998X.jsx)($67b25d6bc13c083d$var$BodyContent, {
            app: app
        }),
        ctaContent: /*#__PURE__*/ (0, $l998X.jsx)($67b25d6bc13c083d$var$CtaContent, {
            app: app
        }),
        crossflowOptions: crossflowOptions
    });
};








const $34f4d9d7bcb5efcb$var$clientPipeline = (0, $j9AoC.createClientPipeline)();
const $34f4d9d7bcb5efcb$export$78c758434c34d601 = $34f4d9d7bcb5efcb$var$clientPipeline.createRender;
const $34f4d9d7bcb5efcb$export$2859a83e4d6da57d = $34f4d9d7bcb5efcb$var$clientPipeline.createValidate;
const $34f4d9d7bcb5efcb$var$serverPipeline = (0, $j9AoC.createServerPipeline)();
const $34f4d9d7bcb5efcb$export$c905bc718befd59b = $34f4d9d7bcb5efcb$var$serverPipeline.createHydrate;
const $34f4d9d7bcb5efcb$export$1f41223e5b0a6622 = $34f4d9d7bcb5efcb$var$serverPipeline.createHydrateExample;
const $34f4d9d7bcb5efcb$export$88fe13b4d13f8423 = $34f4d9d7bcb5efcb$var$serverPipeline.createTransformMetadata;





const $b67237a6b5723d3e$export$193c7b53f1a3a6ab = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "110",
        height: "39",
        viewBox: "0 0 110 39",
        fill: "none",
        "data-vc": "ObpLa5DA",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_1258_173043)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                        id: "mask0_1258_173043",
                        style: {
                            maskType: 'luminance'
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "110",
                        height: "39",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M110 0H0V38.6813H110V0Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                        mask: "url(#mask0_1258_173043)",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                                id: "mask1_1258_173043",
                                style: {
                                    maskType: 'luminance'
                                },
                                maskUnits: "userSpaceOnUse",
                                x: "0",
                                y: "2",
                                width: "14",
                                height: "14",
                                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    d: "M13.1678 2.68506H0V15.8528H13.1678V2.68506Z",
                                    fill: "white"
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                                mask: "url(#mask1_1258_173043)",
                                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    d: "M7.64859 2.69168C9.40568 3.20713 11.18 3.20713 12.9371 2.69168C13.0921 2.65732 13.1955 2.76041 13.161 2.91504C12.6615 4.71909 12.6615 6.38573 13.161 8.18977C13.1955 8.32721 13.0921 8.44749 12.9371 8.39595C11.18 7.91485 9.40568 7.91485 7.64859 8.39595C7.51074 8.44749 7.39019 8.32721 7.44184 8.18977C7.90694 6.38573 7.90694 4.71909 7.44184 2.91504C7.39019 2.76041 7.51074 2.65732 7.64859 2.69168ZM8.35484 9.08323V9.37531C8.35484 10.7326 7.40739 11.7292 6.23599 11.7292C5.06459 11.7292 4.13435 10.7842 4.13435 9.61582C4.13435 8.44749 5.0818 7.5197 6.40825 7.5197H6.75279V3.41331C6.58054 3.39612 6.40825 3.39612 6.23599 3.39612C2.79069 3.39612 0 6.17955 0 9.63303C0 13.0865 2.79069 15.8527 6.23599 15.8527C9.68129 15.8527 12.4892 13.0693 12.4892 9.63303V9.08323H8.35484Z",
                                    fill: "#1868DB"
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M91.2968 32.9161H90.2589L86.9041 24.2418H88.6093L91.5748 32.1747L94.5404 24.2418H96.2456L92.7425 33.2127C91.7046 35.8631 91.1115 37.2347 88.7575 37.2347C87.9605 37.2347 87.5157 37.1606 87.0523 36.9752V35.6037C87.5898 35.7705 88.2015 35.8261 88.6649 35.8261C89.9623 35.8261 90.5369 34.9364 91.2968 32.9161Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M83.2901 28.0415V33.5093H81.7332V24.2419H83.2901V25.8729C83.8276 24.7794 84.7543 24.0009 86.5707 24.1121V25.6691C84.5319 25.4652 83.2901 26.0768 83.2901 28.0415Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M75.7574 25.5022C74.0707 25.5022 73.2181 26.5958 73.0513 28.2083H78.2225C78.1298 26.4846 77.3513 25.5022 75.7574 25.5022ZM79.316 33.1386C78.5561 33.5463 77.3884 33.6946 76.4431 33.6946C72.9771 33.6946 71.4573 31.6929 71.4573 28.857C71.4573 26.0583 73.0142 24.0565 75.8315 24.0565C78.6858 24.0565 79.835 26.0397 79.835 28.857V29.5799H73.0698C73.2922 31.1553 74.3116 32.1748 76.4987 32.1748C77.5738 32.1748 78.482 31.9709 79.316 31.6743V33.1386Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M67.3994 33.5092H65.2679L61.6721 24.2418H63.3403L66.3429 32.1562L69.327 24.2418H70.9951L67.3994 33.5092Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M56.8451 33.6946C54.0649 33.6946 52.4338 31.6373 52.4338 28.857C52.4338 26.0768 54.0649 24.0565 56.8451 24.0565C59.6068 24.0565 61.2193 26.0768 61.2193 28.857C61.2193 31.6373 59.6068 33.6946 56.8451 33.6946ZM56.8451 25.5393C54.8619 25.5393 53.9908 27.0962 53.9908 28.857C53.9908 30.6178 54.8619 32.2118 56.8451 32.2118C58.8098 32.2118 59.6624 30.6178 59.6624 28.857C59.6624 27.0962 58.8098 25.5393 56.8451 25.5393Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M51.1701 31.8411V33.2683C50.6141 33.5649 49.7615 33.6946 48.9089 33.6946C45.6097 33.6946 44.0713 31.6929 44.0713 28.857C44.0713 26.0583 45.6097 24.0565 48.9089 24.0565C49.7429 24.0565 50.3917 24.1677 51.1145 24.5014V25.9841C50.5214 25.7061 49.8912 25.5393 49.0201 25.5393C46.6106 25.5393 45.6282 27.0592 45.6282 28.857C45.6282 30.6549 46.6291 32.1748 49.0572 32.1748C50.0024 32.1748 50.5955 32.045 51.1701 31.8411Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M42.7864 30.9885C42.7864 32.5269 41.7855 33.6946 39.3019 33.6946C37.9118 33.6946 36.7811 33.3795 36.0768 33.0088V31.3222C36.8738 31.7855 38.2083 32.2304 39.376 32.2304C40.5993 32.2304 41.2295 31.7299 41.2295 31.0071C41.2295 30.3027 40.692 29.895 38.9312 29.4687C36.8738 28.9682 36.0027 28.1712 36.0027 26.6514C36.0027 25.0389 37.2445 24.0565 39.3575 24.0565C40.5622 24.0565 41.6558 24.3531 42.3415 24.7238V26.3734C41.2295 25.8173 40.3213 25.5208 39.339 25.5208C38.1713 25.5208 37.5411 25.9285 37.5411 26.6514C37.5411 27.3001 37.9859 27.7079 39.6911 28.1156C41.7484 28.6161 42.7864 29.376 42.7864 30.9885Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M32.0952 21.7954C32.0952 21.0911 32.5586 20.6833 33.2073 20.6833C33.856 20.6833 34.3194 21.0911 34.3194 21.7954C34.3194 22.4998 33.856 22.9075 33.2073 22.9075C32.5586 22.9075 32.0952 22.4998 32.0952 21.7954ZM32.3918 33.5094V24.242H33.9858V33.5094H32.3918Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M24.6881 22.926H21.945V31.9154H24.7808C27.561 31.9154 28.9511 30.4511 28.9511 27.5041C28.9511 24.5385 27.6352 22.926 24.6881 22.926ZM20.2769 33.5094V21.332H24.7623C28.7102 21.332 30.6193 23.7972 30.6193 27.4485C30.6193 31.1369 28.6917 33.5094 24.7623 33.5094H20.2769Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M107.361 12.1015C107.361 12.917 107.843 13.4731 108.825 13.4731C109.196 13.4731 109.548 13.3989 109.826 13.3433V14.8817C109.548 14.9559 109.233 15.03 108.751 15.03C106.768 15.03 105.804 13.8623 105.804 12.1386V7.18978H104.302V5.707H105.804V3.74231H107.361V5.707H109.826V7.18978H107.361V12.1015Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M103.336 13.3063V14.7335C102.78 15.0301 101.927 15.1598 101.074 15.1598C97.7752 15.1598 96.2368 13.1581 96.2368 10.3222C96.2368 7.52349 97.7752 5.52173 101.074 5.52173C101.908 5.52173 102.557 5.63294 103.28 5.96656V7.44935C102.687 7.17133 102.057 7.00451 101.186 7.00451C98.7761 7.00451 97.7937 8.52437 97.7937 10.3222C97.7937 12.1201 98.7946 13.64 101.223 13.64C102.168 13.64 102.761 13.5102 103.336 13.3063Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M86.5076 11.1377V5.70703H88.1016V11.3045C88.1016 12.9727 88.7688 13.7141 90.2887 13.7141C91.7715 13.7141 92.7909 12.7317 92.7909 10.8597V5.70703H94.3849V14.9744H92.7909V13.4546C92.1977 14.5481 91.1042 15.1598 89.8624 15.1598C87.7309 15.1598 86.5076 13.6955 86.5076 11.1377Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M77.4497 10.3408C77.4497 12.565 78.3394 13.6771 79.989 13.6771C81.4162 13.6771 82.6951 12.7689 82.6951 10.7115V9.97014C82.6951 7.91278 81.5274 7.00457 80.1743 7.00457C78.3764 7.00457 77.4497 8.1908 77.4497 10.3408ZM82.6951 14.9745V13.3064C82.1019 14.5297 80.9899 15.1599 79.5627 15.1599C77.0975 15.1599 75.8557 13.0654 75.8557 10.3408C75.8557 7.72743 77.1532 5.52179 79.748 5.52179C81.1011 5.52179 82.139 6.13343 82.6951 7.3382V1.83337H84.289V14.9745H82.6951Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M70.1852 15.1598C67.405 15.1598 65.7739 13.1025 65.7739 10.3222C65.7739 7.54202 67.405 5.52173 70.1852 5.52173C72.9469 5.52173 74.5594 7.54202 74.5594 10.3222C74.5594 13.1025 72.9469 15.1598 70.1852 15.1598ZM70.1852 7.00451C68.202 7.00451 67.3308 8.56144 67.3308 10.3222C67.3308 12.083 68.202 13.677 70.1852 13.677C72.1499 13.677 73.0025 12.083 73.0025 10.3222C73.0025 8.56144 72.1499 7.00451 70.1852 7.00451Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M61.8594 9.50672V14.9745H60.3025V5.70709H61.8594V7.33815C62.3969 6.2446 63.3237 5.46613 65.1401 5.57734V7.13427C63.1012 6.93038 61.8594 7.54203 61.8594 9.50672Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M58.836 6.85635C58.836 9.50683 57.3532 10.9896 54.3135 10.9896H51.8854V14.9746H50.2173V2.79724H54.3135C57.3532 2.79724 58.836 4.35416 58.836 6.85635ZM54.1281 9.39562C56.2782 9.46976 57.1122 8.45035 57.1122 6.89342C57.1122 5.41064 56.2782 4.39123 54.1281 4.39123H51.8854V9.39562H54.1281Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M37.2849 10.3408C37.2849 12.565 38.1746 13.677 39.8242 13.677C41.2515 13.677 42.5304 12.7688 42.5304 10.7115V9.97008C42.5304 7.91272 41.3627 7.00451 40.0095 7.00451C38.2117 7.00451 37.2849 8.19074 37.2849 10.3408ZM42.5304 14.9745V13.3063C41.9373 14.5296 40.8252 15.1598 39.3979 15.1598C36.9328 15.1598 35.6909 13.0654 35.6909 10.3408C35.6909 7.72737 36.9884 5.52173 39.5832 5.52173C40.9364 5.52173 41.9744 6.13338 42.5304 7.33814V5.70708H44.1244V14.9745H42.5304Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M31.7764 9.50672V14.9745H30.2195V5.70709H31.7764V7.33815C32.3139 6.2446 33.2407 5.46613 35.0571 5.57734V7.13427C33.0182 6.93038 31.7764 7.54203 31.7764 9.50672Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M25.9229 3.26065C25.9229 2.55633 26.3862 2.14856 27.0349 2.14856C27.6837 2.14856 28.147 2.55633 28.147 3.26065C28.147 3.96499 27.6837 4.37275 27.0349 4.37275C26.3862 4.37275 25.9229 3.96499 25.9229 3.26065ZM26.2194 14.9747V5.70726H27.8134V14.9747H26.2194Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M22.3345 11.3788V2.79724H24.0026V11.2676C24.0026 13.5103 23.0203 15.0487 20.722 15.0487C19.8508 15.0487 19.1836 14.9005 18.7202 14.7336V13.1211C19.2207 13.325 19.8323 13.4362 20.444 13.4362C21.8526 13.4362 22.3345 12.5836 22.3345 11.3788Z",
                                fill: "#E2E3E4"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_1258_173043",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "110",
                        height: "38.6813",
                        fill: "white"
                    })
                })
            })
        ]
    });





const $9502235fec7239c6$export$2177945c83322624 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "110",
        height: "39",
        viewBox: "0 0 110 39",
        fill: "none",
        "data-vc": "KbB8bIkm",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_1258_173148)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                        id: "mask0_1258_173148",
                        style: {
                            maskType: 'luminance'
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "110",
                        height: "39",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M110 0H0V38.6813H110V0Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                        mask: "url(#mask0_1258_173148)",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                                id: "mask1_1258_173148",
                                style: {
                                    maskType: 'luminance'
                                },
                                maskUnits: "userSpaceOnUse",
                                x: "0",
                                y: "2",
                                width: "14",
                                height: "14",
                                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    d: "M13.1678 2.68506H0V15.8528H13.1678V2.68506Z",
                                    fill: "white"
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                                mask: "url(#mask1_1258_173148)",
                                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    d: "M7.64859 2.69168C9.40568 3.20713 11.18 3.20713 12.9371 2.69168C13.0921 2.65732 13.1955 2.76041 13.161 2.91504C12.6615 4.71909 12.6615 6.38573 13.161 8.18977C13.1955 8.32721 13.0921 8.44749 12.9371 8.39595C11.18 7.91485 9.40568 7.91485 7.64859 8.39595C7.51074 8.44749 7.39019 8.32721 7.44184 8.18977C7.90694 6.38573 7.90694 4.71909 7.44184 2.91504C7.39019 2.76041 7.51074 2.65732 7.64859 2.69168ZM8.35484 9.08323V9.37531C8.35484 10.7326 7.40739 11.7292 6.23599 11.7292C5.06459 11.7292 4.13435 10.7842 4.13435 9.61582C4.13435 8.44749 5.0818 7.5197 6.40825 7.5197H6.75279V3.41331C6.58054 3.39612 6.40825 3.39612 6.23599 3.39612C2.79069 3.39612 0 6.17955 0 9.63303C0 13.0865 2.79069 15.8527 6.23599 15.8527C9.68129 15.8527 12.4892 13.0693 12.4892 9.63303V9.08323H8.35484Z",
                                    fill: "#1868DB"
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M91.2968 32.9161H90.2589L86.9041 24.2418H88.6093L91.5748 32.1747L94.5404 24.2418H96.2456L92.7425 33.2127C91.7046 35.8631 91.1115 37.2347 88.7575 37.2347C87.9605 37.2347 87.5157 37.1606 87.0523 36.9752V35.6037C87.5898 35.7705 88.2015 35.8261 88.6649 35.8261C89.9623 35.8261 90.5369 34.9364 91.2968 32.9161Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M83.2901 28.0415V33.5093H81.7332V24.2419H83.2901V25.8729C83.8276 24.7794 84.7543 24.0009 86.5707 24.1121V25.6691C84.5319 25.4652 83.2901 26.0768 83.2901 28.0415Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M75.7574 25.5022C74.0707 25.5022 73.2181 26.5958 73.0513 28.2083H78.2225C78.1298 26.4846 77.3513 25.5022 75.7574 25.5022ZM79.316 33.1386C78.5561 33.5463 77.3884 33.6946 76.4431 33.6946C72.9771 33.6946 71.4573 31.6929 71.4573 28.857C71.4573 26.0583 73.0142 24.0565 75.8315 24.0565C78.6858 24.0565 79.835 26.0397 79.835 28.857V29.5799H73.0698C73.2922 31.1553 74.3116 32.1748 76.4987 32.1748C77.5738 32.1748 78.482 31.9709 79.316 31.6743V33.1386Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M67.3994 33.5092H65.2679L61.6721 24.2418H63.3403L66.3429 32.1562L69.327 24.2418H70.9951L67.3994 33.5092Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M56.8451 33.6946C54.0649 33.6946 52.4338 31.6373 52.4338 28.857C52.4338 26.0768 54.0649 24.0565 56.8451 24.0565C59.6068 24.0565 61.2193 26.0768 61.2193 28.857C61.2193 31.6373 59.6068 33.6946 56.8451 33.6946ZM56.8451 25.5393C54.8619 25.5393 53.9908 27.0962 53.9908 28.857C53.9908 30.6178 54.8619 32.2118 56.8451 32.2118C58.8098 32.2118 59.6624 30.6178 59.6624 28.857C59.6624 27.0962 58.8098 25.5393 56.8451 25.5393Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M51.1701 31.8411V33.2683C50.6141 33.5649 49.7615 33.6946 48.9089 33.6946C45.6097 33.6946 44.0713 31.6929 44.0713 28.857C44.0713 26.0583 45.6097 24.0565 48.9089 24.0565C49.7429 24.0565 50.3917 24.1677 51.1145 24.5014V25.9841C50.5214 25.7061 49.8912 25.5393 49.0201 25.5393C46.6106 25.5393 45.6282 27.0592 45.6282 28.857C45.6282 30.6549 46.6291 32.1748 49.0572 32.1748C50.0024 32.1748 50.5955 32.045 51.1701 31.8411Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M42.7864 30.9885C42.7864 32.5269 41.7855 33.6946 39.3019 33.6946C37.9118 33.6946 36.7811 33.3795 36.0768 33.0088V31.3222C36.8738 31.7855 38.2083 32.2304 39.376 32.2304C40.5993 32.2304 41.2295 31.7299 41.2295 31.0071C41.2295 30.3027 40.692 29.895 38.9312 29.4687C36.8738 28.9682 36.0027 28.1712 36.0027 26.6514C36.0027 25.0389 37.2445 24.0565 39.3575 24.0565C40.5622 24.0565 41.6558 24.3531 42.3415 24.7238V26.3734C41.2295 25.8173 40.3213 25.5208 39.339 25.5208C38.1713 25.5208 37.5411 25.9285 37.5411 26.6514C37.5411 27.3001 37.9859 27.7079 39.6911 28.1156C41.7484 28.6161 42.7864 29.376 42.7864 30.9885Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M32.0952 21.7954C32.0952 21.0911 32.5586 20.6833 33.2073 20.6833C33.856 20.6833 34.3194 21.0911 34.3194 21.7954C34.3194 22.4998 33.856 22.9075 33.2073 22.9075C32.5586 22.9075 32.0952 22.4998 32.0952 21.7954ZM32.3918 33.5094V24.242H33.9858V33.5094H32.3918Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M24.6881 22.926H21.945V31.9154H24.7808C27.561 31.9154 28.9511 30.4511 28.9511 27.5041C28.9511 24.5385 27.6352 22.926 24.6881 22.926ZM20.2769 33.5094V21.332H24.7623C28.7102 21.332 30.6193 23.7972 30.6193 27.4485C30.6193 31.1369 28.6917 33.5094 24.7623 33.5094H20.2769Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M107.361 12.1015C107.361 12.917 107.843 13.4731 108.825 13.4731C109.196 13.4731 109.548 13.3989 109.826 13.3433V14.8817C109.548 14.9559 109.233 15.03 108.751 15.03C106.768 15.03 105.804 13.8623 105.804 12.1386V7.18978H104.302V5.707H105.804V3.74231H107.361V5.707H109.826V7.18978H107.361V12.1015Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M103.336 13.3063V14.7335C102.78 15.0301 101.927 15.1598 101.074 15.1598C97.7752 15.1598 96.2368 13.1581 96.2368 10.3222C96.2368 7.52349 97.7752 5.52173 101.074 5.52173C101.908 5.52173 102.557 5.63294 103.28 5.96656V7.44935C102.687 7.17133 102.057 7.00451 101.186 7.00451C98.7761 7.00451 97.7937 8.52437 97.7937 10.3222C97.7937 12.1201 98.7946 13.64 101.223 13.64C102.168 13.64 102.761 13.5102 103.336 13.3063Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M86.5076 11.1377V5.70703H88.1016V11.3045C88.1016 12.9727 88.7688 13.7141 90.2887 13.7141C91.7715 13.7141 92.7909 12.7317 92.7909 10.8597V5.70703H94.3849V14.9744H92.7909V13.4546C92.1977 14.5481 91.1042 15.1598 89.8624 15.1598C87.7309 15.1598 86.5076 13.6955 86.5076 11.1377Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M77.4497 10.3408C77.4497 12.565 78.3394 13.6771 79.989 13.6771C81.4162 13.6771 82.6951 12.7689 82.6951 10.7115V9.97014C82.6951 7.91278 81.5274 7.00457 80.1743 7.00457C78.3764 7.00457 77.4497 8.1908 77.4497 10.3408ZM82.6951 14.9745V13.3064C82.1019 14.5297 80.9899 15.1599 79.5627 15.1599C77.0975 15.1599 75.8557 13.0654 75.8557 10.3408C75.8557 7.72743 77.1532 5.52179 79.748 5.52179C81.1011 5.52179 82.139 6.13343 82.6951 7.3382V1.83337H84.289V14.9745H82.6951Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M70.1852 15.1598C67.405 15.1598 65.7739 13.1025 65.7739 10.3222C65.7739 7.54202 67.405 5.52173 70.1852 5.52173C72.9469 5.52173 74.5594 7.54202 74.5594 10.3222C74.5594 13.1025 72.9469 15.1598 70.1852 15.1598ZM70.1852 7.00451C68.202 7.00451 67.3308 8.56144 67.3308 10.3222C67.3308 12.083 68.202 13.677 70.1852 13.677C72.1499 13.677 73.0025 12.083 73.0025 10.3222C73.0025 8.56144 72.1499 7.00451 70.1852 7.00451Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M61.8594 9.50672V14.9745H60.3025V5.70709H61.8594V7.33815C62.3969 6.2446 63.3237 5.46613 65.1401 5.57734V7.13427C63.1012 6.93038 61.8594 7.54203 61.8594 9.50672Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M58.836 6.85635C58.836 9.50683 57.3532 10.9896 54.3135 10.9896H51.8854V14.9746H50.2173V2.79724H54.3135C57.3532 2.79724 58.836 4.35416 58.836 6.85635ZM54.1281 9.39562C56.2782 9.46976 57.1122 8.45035 57.1122 6.89342C57.1122 5.41064 56.2782 4.39123 54.1281 4.39123H51.8854V9.39562H54.1281Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M37.2849 10.3408C37.2849 12.565 38.1746 13.677 39.8242 13.677C41.2515 13.677 42.5304 12.7688 42.5304 10.7115V9.97008C42.5304 7.91272 41.3627 7.00451 40.0095 7.00451C38.2117 7.00451 37.2849 8.19074 37.2849 10.3408ZM42.5304 14.9745V13.3063C41.9373 14.5296 40.8252 15.1598 39.3979 15.1598C36.9328 15.1598 35.6909 13.0654 35.6909 10.3408C35.6909 7.72737 36.9884 5.52173 39.5832 5.52173C40.9364 5.52173 41.9744 6.13338 42.5304 7.33814V5.70708H44.1244V14.9745H42.5304Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M31.7764 9.50672V14.9745H30.2195V5.70709H31.7764V7.33815C32.3139 6.2446 33.2407 5.46613 35.0571 5.57734V7.13427C33.0182 6.93038 31.7764 7.54203 31.7764 9.50672Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M25.9229 3.26065C25.9229 2.55633 26.3862 2.14856 27.0349 2.14856C27.6837 2.14856 28.147 2.55633 28.147 3.26065C28.147 3.96499 27.6837 4.37275 27.0349 4.37275C26.3862 4.37275 25.9229 3.96499 25.9229 3.26065ZM26.2194 14.9747V5.70726H27.8134V14.9747H26.2194Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M22.3345 11.3788V2.79724H24.0026V11.2676C24.0026 13.5103 23.0203 15.0487 20.722 15.0487C19.8508 15.0487 19.1836 14.9005 18.7202 14.7336V13.1211C19.2207 13.325 19.8323 13.4362 20.444 13.4362C21.8526 13.4362 22.3345 12.5836 22.3345 11.3788Z",
                                fill: "#101214"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_1258_173148",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "110",
                        height: "38.6813",
                        fill: "white"
                    })
                })
            })
        ]
    });


const $90616e845ea4ca9f$var$jpdLogoByTheme = (colorMode)=>{
    return colorMode === 'light' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9502235fec7239c6$export$2177945c83322624), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $b67237a6b5723d3e$export$193c7b53f1a3a6ab), {});
};
const $90616e845ea4ca9f$export$b3890eb0ae9dca99 = (0, $34f4d9d7bcb5efcb$export$78c758434c34d601)(({ onDismissed: onDismissed })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $67b25d6bc13c083d$export$486c30dd11c42f3), {
        app: {
            hamsIdentifier: 'jira-product-discovery',
            ccpProductId: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
            logo: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                role: "img",
                "aria-label": intl.formatMessage({
                    id: "post-office.growth.recommendation-jpd.confluence-home-banner.logo-alt-text",
                    defaultMessage: "Jira Product Discovery Product Logo"
                }),
                "data-vc": "QgpBfupD",
                children: $90616e845ea4ca9f$var$jpdLogoByTheme(colorMode || 'light')
            }),
            header: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                id: "post-office.growth.recommendation-jpd.confluence-home-banner.header",
                defaultMessage: "Capture your ideas and customer feedback all in one place"
            }),
            description: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                id: "post-office.growth.recommendation-jpd.confluence-home-banner.description",
                defaultMessage: "Make sure your team is building the right things with Jira Product Discovery."
            })
        },
        onDismissed: onDismissed
    });
});
var $90616e845ea4ca9f$export$2e2bcd8739ae039 = $90616e845ea4ca9f$export$b3890eb0ae9dca99;















const $9fcec3f40535e75a$var$clientPipeline = (0, $j9AoC.createClientPipeline)();
const $9fcec3f40535e75a$export$78c758434c34d601 = $9fcec3f40535e75a$var$clientPipeline.createRender;
const $9fcec3f40535e75a$export$2859a83e4d6da57d = $9fcec3f40535e75a$var$clientPipeline.createValidate;
const $9fcec3f40535e75a$var$serverPipeline = (0, $j9AoC.createServerPipeline)();
const $9fcec3f40535e75a$export$c905bc718befd59b = $9fcec3f40535e75a$var$serverPipeline.createHydrate;
const $9fcec3f40535e75a$export$1f41223e5b0a6622 = $9fcec3f40535e75a$var$serverPipeline.createHydrateExample;
const $9fcec3f40535e75a$export$88fe13b4d13f8423 = $9fcec3f40535e75a$var$serverPipeline.createTransformMetadata;





const $0197079ce91c86fc$export$5a3585ff193409c7 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "130",
        height: "40",
        viewBox: "0 0 130 40",
        fill: "none",
        "data-vc": "kgMO81K_",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_1258_173086)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                        id: "mask0_1258_173086",
                        style: {
                            maskType: 'luminance'
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "130",
                        height: "40",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M130 0H0V39.6947H130V0Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                        mask: "url(#mask0_1258_173086)",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                                id: "mask1_1258_173086",
                                style: {
                                    maskType: 'luminance'
                                },
                                maskUnits: "userSpaceOnUse",
                                x: "0",
                                y: "1",
                                width: "14",
                                height: "18",
                                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    d: "M13.8944 1.65393H0V18.028H13.8944V1.65393Z",
                                    fill: "white"
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                                mask: "url(#mask1_1258_173086)",
                                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    d: "M8.68839 8.09373H13.1939C13.8706 8.09373 14.1016 8.74269 13.689 9.25856L6.64189 18.028C4.36439 16.1976 4.57891 13.3021 6.24582 11.1888L8.68839 8.09373ZM5.20607 11.5882H0.700536C0.0238782 11.5882 -0.207175 10.9392 0.20542 10.4233L7.25257 1.65393C9.53007 3.48436 9.28253 6.3465 7.63215 8.47645L5.20607 11.5882Z",
                                    fill: "#1868DB"
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M127.245 31.7846C127.245 32.6215 127.735 33.1921 128.735 33.1921C129.113 33.1921 129.471 33.116 129.754 33.059V34.6377C129.471 34.7137 129.15 34.7898 128.66 34.7898C126.641 34.7898 125.66 33.5915 125.66 31.8226V26.7442H124.132V25.2226H125.66V23.2064H127.245V25.2226H129.754V26.7442H127.245V31.7846Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M122.738 29.1599V34.7329H121.116V28.9887C121.116 27.2769 120.437 26.5161 118.89 26.5161C117.381 26.5161 116.343 27.5241 116.343 29.4452V34.7329H114.721V25.2227H116.343V26.7823C116.947 25.6601 118.06 25.0325 119.324 25.0325C121.493 25.0325 122.738 26.5351 122.738 29.1599Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M108.638 26.5161C106.922 26.5161 106.054 27.6383 105.884 29.293H111.147C111.053 27.5241 110.261 26.5161 108.638 26.5161ZM112.26 34.3524C111.487 34.7709 110.299 34.9231 109.336 34.9231C105.809 34.9231 104.262 32.8689 104.262 29.9587C104.262 27.0867 105.847 25.0325 108.714 25.0325C111.619 25.0325 112.789 27.0676 112.789 29.9587V30.7005H105.903C106.13 32.3173 107.167 33.3634 109.393 33.3634C110.487 33.3634 111.412 33.1542 112.26 32.8498V34.3524Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M96.1729 29.4452V34.7329H94.5505V28.9887C94.5505 27.2769 93.8714 26.5161 92.3245 26.5161C90.8154 26.5161 89.7778 27.5241 89.7778 29.4452V34.7329H88.1555V25.2227H89.7778V26.7823C90.3815 25.6601 91.4945 25.0325 92.7584 25.0325C94.3619 25.0325 95.456 25.8503 95.9276 27.353C96.4558 25.8884 97.7197 25.0325 99.2855 25.0325C101.398 25.0325 102.568 26.478 102.568 29.1599V34.7329H100.946V29.4452C100.946 27.4861 100.266 26.5161 98.7196 26.5161C97.2104 26.5161 96.1729 27.5241 96.1729 29.4452Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M82.0736 26.5161C80.3569 26.5161 79.4891 27.6383 79.3194 29.293H84.5825C84.4882 27.5241 83.6959 26.5161 82.0736 26.5161ZM85.6955 34.3524C84.9221 34.7709 83.7336 34.9231 82.7715 34.9231C79.2439 34.9231 77.697 32.8689 77.697 29.9587C77.697 27.0867 79.2816 25.0325 82.149 25.0325C85.0541 25.0325 86.2237 27.0676 86.2237 29.9587V30.7005H79.3382C79.5646 32.3173 80.6021 33.3634 82.8281 33.3634C83.9223 33.3634 84.8466 33.1542 85.6955 32.8498V34.3524Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M74.2301 33.972V33.021C73.6264 34.2764 72.4946 34.9231 71.042 34.9231C68.5519 34.9231 67.3069 32.7738 67.3069 29.9778C67.3069 27.2959 68.6085 25.0325 71.2307 25.0325C72.6078 25.0325 73.6642 25.6601 74.2301 26.8965V25.2227H75.8147V33.8769C75.8147 36.6729 74.5131 38.5559 71.1363 38.5559C69.5517 38.5559 68.684 38.3467 67.7785 38.0424V36.4447C68.816 36.7871 69.8913 37.0153 71.0609 37.0153C73.4189 37.0153 74.2301 35.7409 74.2301 33.972ZM68.8915 29.9778C68.8915 32.2602 69.797 33.4014 71.4759 33.4014C72.9285 33.4014 74.2301 32.4694 74.2301 30.3582V29.5974C74.2301 27.4861 73.0417 26.5541 71.6646 26.5541C69.8347 26.5541 68.8915 27.7714 68.8915 29.9778Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M58.4656 29.9778C58.4656 32.2602 59.3711 33.4014 61.05 33.4014C62.5026 33.4014 63.8042 32.4694 63.8042 30.3582V29.5974C63.8042 27.4861 62.6158 26.5541 61.2387 26.5541C59.4088 26.5541 58.4656 27.7714 58.4656 29.9778ZM63.8042 34.7329V33.021C63.2005 34.2764 62.0687 34.9231 60.6161 34.9231C58.1072 34.9231 56.8433 32.7738 56.8433 29.9778C56.8433 27.2959 58.1638 25.0325 60.8048 25.0325C62.1819 25.0325 63.2383 25.6601 63.8042 26.8965V25.2227H65.4265V34.7329H63.8042Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M55.1467 29.1599V34.7329H53.5244V28.9887C53.5244 27.2769 52.8453 26.5161 51.2984 26.5161C49.7893 26.5161 48.7517 27.5241 48.7517 29.4452V34.7329H47.1294V25.2227H48.7517V26.7823C49.3554 25.6601 50.4684 25.0325 51.7323 25.0325C53.9017 25.0325 55.1467 26.5351 55.1467 29.1599Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M37.7219 29.9778C37.7219 32.2602 38.6274 33.4014 40.3064 33.4014C41.759 33.4014 43.0606 32.4694 43.0606 30.3582V29.5974C43.0606 27.4861 41.8722 26.5541 40.495 26.5541C38.6652 26.5541 37.7219 27.7714 37.7219 29.9778ZM43.0606 34.7329V33.021C42.457 34.2764 41.3251 34.9231 39.8725 34.9231C37.3635 34.9231 36.0996 32.7738 36.0996 29.9778C36.0996 27.2959 37.4201 25.0325 40.0611 25.0325C41.4383 25.0325 42.4947 25.6601 43.0606 26.8965V25.2227H44.683V34.7329H43.0606Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M23.7176 27.9044L22.0198 23.2634V34.7327H20.322V22.2363H23.2649L26.0757 29.407L27.2264 32.8497L28.3771 29.407L31.2068 22.2363H33.9421V34.7327H32.2443V23.3966L30.7917 27.9044L28.0564 34.7327H26.4152L23.7176 27.9044Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M102.891 7.49567C101.174 7.49567 100.306 8.61787 100.136 10.2726H105.4C105.305 8.50375 104.513 7.49567 102.891 7.49567ZM106.513 15.3321C105.739 15.7505 104.551 15.9027 103.589 15.9027C100.061 15.9027 98.5142 13.8485 98.5142 10.9384C98.5142 8.06628 100.099 6.01208 102.966 6.01208C105.871 6.01208 107.041 8.04726 107.041 10.9384V11.6802H100.155C100.382 13.2969 101.419 14.343 103.645 14.343C104.739 14.343 105.664 14.1338 106.513 13.8295V15.3321Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M97.2282 14.0006V15.4652C96.6623 15.7695 95.7945 15.9027 94.9268 15.9027C91.5689 15.9027 90.0032 13.8485 90.0032 10.9384C90.0032 8.06628 91.5689 6.01208 94.9268 6.01208C95.7757 6.01208 96.4359 6.12621 97.1716 6.46857V7.9902C96.568 7.7049 95.9266 7.53371 95.04 7.53371C92.5876 7.53371 91.5878 9.09338 91.5878 10.9384C91.5878 12.7833 92.6065 14.343 95.0777 14.343C96.0398 14.343 96.6434 14.2099 97.2282 14.0006Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M86.196 3.69164C86.196 2.96886 86.6677 2.55042 87.3279 2.55042C87.9882 2.55042 88.4598 2.96886 88.4598 3.69164C88.4598 4.41442 87.9882 4.83287 87.3279 4.83287C86.6677 4.83287 86.196 4.41442 86.196 3.69164ZM86.4979 15.7125V6.20234H88.1202V15.7125H86.4979Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M81.4328 15.7124H79.2634L75.6038 6.20227H77.3016L80.3576 14.324L83.3947 6.20227H85.0925L81.4328 15.7124Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M71.9262 10.1015V15.7125H70.3416V6.20234H71.9262V7.87613C72.4732 6.75393 73.4164 5.95507 75.2652 6.0692V7.66691C73.1901 7.45768 71.9262 8.08535 71.9262 10.1015Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M64.2593 7.49567C62.5427 7.49567 61.6749 8.61787 61.5051 10.2726H66.7683C66.674 8.50375 65.8817 7.49567 64.2593 7.49567ZM67.8813 15.3321C67.1079 15.7505 65.9194 15.9027 64.9573 15.9027C61.4297 15.9027 59.8828 13.8485 59.8828 10.9384C59.8828 8.06628 61.4674 6.01208 64.3348 6.01208C67.2399 6.01208 68.4095 8.04726 68.4095 10.9384V11.6802H61.524C61.7504 13.2969 62.7879 14.343 65.0139 14.343C66.108 14.343 67.0324 14.1338 67.8813 13.8295V15.3321Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M58.4533 12.2698C58.4533 14.4381 57.1705 15.9027 54.0956 15.9027C51.6998 15.9027 50.5868 15.4272 49.6248 14.9326V13.1828C50.7755 13.7914 52.5487 14.2289 54.1899 14.2289C56.0575 14.2289 56.7555 13.4871 56.7555 12.3839C56.7555 11.2807 56.0764 10.6911 53.7183 10.1205C50.9264 9.43575 49.6813 8.46571 49.6813 6.41151C49.6813 4.47144 51.1528 3.02588 54.039 3.02588C55.8311 3.02588 56.9819 3.46335 57.8308 3.93886V5.6507C56.5857 4.92793 55.2463 4.69968 53.9636 4.69968C52.3412 4.69968 51.3791 5.27029 51.3791 6.41151C51.3791 7.43861 52.1714 7.95216 54.3597 8.50375C56.9819 9.16947 58.4533 10.0254 58.4533 12.2698Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M37.5379 10.9574C37.5379 13.2398 38.4434 14.381 40.1223 14.381C41.575 14.381 42.8766 13.449 42.8766 11.3378V10.577C42.8766 8.46571 41.6882 7.53371 40.3109 7.53371C38.4811 7.53371 37.5379 8.75102 37.5379 10.9574ZM42.8766 15.7125V14.0006C42.273 15.256 41.1411 15.9027 39.6884 15.9027C37.1794 15.9027 35.9155 13.7534 35.9155 10.9574C35.9155 8.27551 37.236 6.01208 39.877 6.01208C41.2543 6.01208 42.3107 6.63976 42.8766 7.87608V6.20229H44.499V15.7125H42.8766Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M31.9313 10.1015V15.7125H30.3467V6.20234H31.9313V7.87613C32.4784 6.75393 33.4216 5.95507 35.2703 6.0692V7.66691C33.1952 7.45768 31.9313 8.08535 31.9313 10.1015Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M25.9736 3.69164C25.9736 2.96886 26.4452 2.55042 27.1055 2.55042C27.7657 2.55042 28.2374 2.96886 28.2374 3.69164C28.2374 4.41442 27.7657 4.83287 27.1055 4.83287C26.4452 4.83287 25.9736 4.41442 25.9736 3.69164ZM26.2755 15.7125V6.20234H27.8978V15.7125H26.2755Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M22.3214 12.0225V3.21606H24.0192V11.9084C24.0192 14.2098 23.0194 15.7885 20.6802 15.7885C19.7935 15.7885 19.1144 15.6363 18.6428 15.4652V13.8104C19.1522 14.0196 19.7747 14.1337 20.3972 14.1337C21.8309 14.1337 22.3214 13.2588 22.3214 12.0225Z",
                                fill: "#E2E3E4"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_1258_173086",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "130",
                        height: "39.6947",
                        fill: "white"
                    })
                })
            })
        ]
    });





const $9847b6210cf26e92$export$3a6e642edb89de35 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "130",
        height: "40",
        viewBox: "0 0 130 40",
        fill: "none",
        "data-vc": "luJcbtdM",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_906_52755)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                        id: "mask0_906_52755",
                        style: {
                            maskType: 'luminance'
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "130",
                        height: "40",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M130 0H0V39.6947H130V0Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                        mask: "url(#mask0_906_52755)",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                                id: "mask1_906_52755",
                                style: {
                                    maskType: 'luminance'
                                },
                                maskUnits: "userSpaceOnUse",
                                x: "0",
                                y: "1",
                                width: "14",
                                height: "18",
                                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    d: "M13.8944 1.65393H0V18.028H13.8944V1.65393Z",
                                    fill: "white"
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                                mask: "url(#mask1_906_52755)",
                                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    d: "M8.68839 8.09373H13.1939C13.8706 8.09373 14.1016 8.74269 13.689 9.25856L6.64189 18.028C4.36439 16.1976 4.57891 13.3021 6.24582 11.1888L8.68839 8.09373ZM5.20607 11.5882H0.700536C0.0238782 11.5882 -0.207175 10.9392 0.20542 10.4233L7.25257 1.65393C9.53007 3.48436 9.28253 6.3465 7.63215 8.47645L5.20607 11.5882Z",
                                    fill: "#1868DB"
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M127.245 31.7848C127.245 32.6217 127.736 33.1924 128.736 33.1924C129.113 33.1924 129.471 33.1163 129.754 33.0592V34.6379C129.471 34.714 129.151 34.7901 128.66 34.7901C126.642 34.7901 125.661 33.5918 125.661 31.8229V26.7445H124.133V25.2228H125.661V23.2067H127.245V25.2228H129.754V26.7445H127.245V31.7848Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M122.736 29.1598V34.7327H121.114V28.9886C121.114 27.2768 120.435 26.5159 118.888 26.5159C117.379 26.5159 116.341 27.524 116.341 29.4451V34.7327H114.719V25.2226H116.341V26.7822C116.945 25.66 118.058 25.0323 119.322 25.0323C121.491 25.0323 122.736 26.535 122.736 29.1598Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M108.638 26.5159C106.922 26.5159 106.054 27.6381 105.884 29.2929H111.147C111.053 27.524 110.261 26.5159 108.638 26.5159ZM112.26 34.3523C111.487 34.7708 110.298 34.9229 109.336 34.9229C105.809 34.9229 104.262 32.8687 104.262 29.9586C104.262 27.0865 105.846 25.0323 108.714 25.0323C111.619 25.0323 112.788 27.0675 112.788 29.9586V30.7004H105.903C106.129 32.3171 107.167 33.3633 109.393 33.3633C110.487 33.3633 111.411 33.154 112.26 32.8497V34.3523Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M96.1736 29.4451V34.7327H94.5513V28.9886C94.5513 27.2768 93.8721 26.5159 92.3253 26.5159C90.8161 26.5159 89.7786 27.524 89.7786 29.4451V34.7327H88.1562V25.2226H89.7786V26.7822C90.3822 25.66 91.4952 25.0323 92.7592 25.0323C94.3626 25.0323 95.4568 25.8502 95.9284 27.3528C96.4566 25.8883 97.7205 25.0323 99.2862 25.0323C101.399 25.0323 102.569 26.4779 102.569 29.1598V34.7327H100.946V29.4451C100.946 27.486 100.267 26.5159 98.7203 26.5159C97.2111 26.5159 96.1736 27.524 96.1736 29.4451Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M82.0718 26.5159C80.3552 26.5159 79.4874 27.6381 79.3177 29.2929H84.5808C84.4865 27.524 83.6942 26.5159 82.0718 26.5159ZM85.6938 34.3523C84.9204 34.7708 83.7319 34.9229 82.7698 34.9229C79.2422 34.9229 77.6953 32.8687 77.6953 29.9586C77.6953 27.0865 79.2799 25.0323 82.1473 25.0323C85.0524 25.0323 86.222 27.0675 86.222 29.9586V30.7004H79.3365C79.5629 32.3171 80.6004 33.3633 82.8264 33.3633C83.9206 33.3633 84.8449 33.154 85.6938 32.8497V34.3523Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M74.2318 33.9719V33.0209C73.6282 34.2762 72.4963 34.9229 71.0437 34.9229C68.5536 34.9229 67.3086 32.7736 67.3086 29.9776C67.3086 27.2958 68.6102 25.0323 71.2324 25.0323C72.6095 25.0323 73.6659 25.66 74.2318 26.8963V25.2226H75.8164V33.8768C75.8164 36.6728 74.5148 38.5558 71.1381 38.5558C69.5535 38.5558 68.6857 38.3466 67.7802 38.0423V36.4446C68.8177 36.7869 69.893 37.0152 71.0626 37.0152C73.4206 37.0152 74.2318 35.7408 74.2318 33.9719ZM68.8932 29.9776C68.8932 32.2601 69.7987 33.4013 71.4776 33.4013C72.9302 33.4013 74.2318 32.4693 74.2318 30.358V29.5972C74.2318 27.486 73.0434 26.554 71.6663 26.554C69.8364 26.554 68.8932 27.7713 68.8932 29.9776Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M58.4661 29.9776C58.4661 32.2601 59.3716 33.4013 61.0505 33.4013C62.5031 33.4013 63.8047 32.4693 63.8047 30.358V29.5972C63.8047 27.486 62.6162 26.554 61.2391 26.554C59.4093 26.554 58.4661 27.7713 58.4661 29.9776ZM63.8047 34.7327V33.0209C63.201 34.2762 62.0692 34.9229 60.6166 34.9229C58.1077 34.9229 56.8438 32.7736 56.8438 29.9776C56.8438 27.2958 58.1643 25.0323 60.8053 25.0323C62.1824 25.0323 63.2388 25.66 63.8047 26.8963V25.2226H65.427V34.7327H63.8047Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M55.1463 29.1598V34.7327H53.5239V28.9886C53.5239 27.2768 52.8448 26.5159 51.2979 26.5159C49.7888 26.5159 48.7512 27.524 48.7512 29.4451V34.7327H47.1289V25.2226H48.7512V26.7822C49.3549 25.66 50.4679 25.0323 51.7318 25.0323C53.9012 25.0323 55.1463 26.535 55.1463 29.1598Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M37.7239 29.9776C37.7239 32.2601 38.6294 33.4013 40.3083 33.4013C41.7609 33.4013 43.0626 32.4693 43.0626 30.358V29.5972C43.0626 27.486 41.8741 26.554 40.497 26.554C38.6671 26.554 37.7239 27.7713 37.7239 29.9776ZM43.0626 34.7327V33.0209C42.4589 34.2762 41.3271 34.9229 39.8744 34.9229C37.3655 34.9229 36.1016 32.7736 36.1016 29.9776C36.1016 27.2958 37.4221 25.0323 40.0631 25.0323C41.4403 25.0323 42.4967 25.66 43.0626 26.8963V25.2226H44.6849V34.7327H43.0626Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M23.7159 27.9045L22.0181 23.2635V34.7328H20.3203V22.2365H23.2632L26.0739 29.4071L27.2247 32.8498L28.3754 29.4071L31.205 22.2365H33.9404V34.7328H32.2426V23.3967L30.79 27.9045L28.0547 34.7328H26.4135L23.7159 27.9045Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M102.892 7.49543C101.175 7.49543 100.308 8.61763 100.138 10.2724H105.401C105.307 8.50351 104.514 7.49543 102.892 7.49543ZM106.514 15.3318C105.741 15.7503 104.552 15.9024 103.59 15.9024C100.062 15.9024 98.5156 13.8482 98.5156 10.9381C98.5156 8.06604 100.1 6.01184 102.968 6.01184C105.873 6.01184 107.042 8.04702 107.042 10.9381V11.6799H100.157C100.383 13.2966 101.421 14.3428 103.647 14.3428C104.741 14.3428 105.665 14.1335 106.514 13.8292V15.3318Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M97.229 14.0004V15.465C96.663 15.7693 95.7953 15.9024 94.9275 15.9024C91.5697 15.9024 90.0039 13.8482 90.0039 10.9381C90.0039 8.06604 91.5697 6.01184 94.9275 6.01184C95.7764 6.01184 96.4367 6.12596 97.1724 6.46833V7.98996C96.5687 7.70465 95.9273 7.53347 95.0407 7.53347C92.5883 7.53347 91.5885 9.09314 91.5885 10.9381C91.5885 12.7831 92.6072 14.3428 95.0784 14.3428C96.0405 14.3428 96.6442 14.2096 97.229 14.0004Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M86.1953 3.69164C86.1953 2.96886 86.6669 2.55042 87.3272 2.55042C87.9874 2.55042 88.459 2.96886 88.459 3.69164C88.459 4.41442 87.9874 4.83287 87.3272 4.83287C86.6669 4.83287 86.1953 4.41442 86.1953 3.69164ZM86.4971 15.7125V6.20234H88.1195V15.7125H86.4971Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M81.4346 15.7124H79.2652L75.6055 6.20227H77.3033L80.3593 14.324L83.3964 6.20227H85.0942L81.4346 15.7124Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M71.9245 10.1014V15.7124H70.3398V6.20222H71.9245V7.87601C72.4715 6.75381 73.4147 5.95495 75.2634 6.06907V7.66679C73.1884 7.45756 71.9245 8.08523 71.9245 10.1014Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M64.2593 7.49567C62.5427 7.49567 61.6749 8.61787 61.5051 10.2726H66.7683C66.674 8.50375 65.8817 7.49567 64.2593 7.49567ZM67.8813 15.3321C67.1079 15.7505 65.9194 15.9027 64.9573 15.9027C61.4297 15.9027 59.8828 13.8485 59.8828 10.9384C59.8828 8.06628 61.4674 6.01208 64.3348 6.01208C67.2399 6.01208 68.4095 8.04726 68.4095 10.9384V11.6802H61.524C61.7504 13.2969 62.7879 14.343 65.0139 14.343C66.108 14.343 67.0324 14.1338 67.8813 13.8295V15.3321Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M58.4535 12.2699C58.4535 14.4382 57.1707 15.9028 54.0959 15.9028C51.7001 15.9028 50.5871 15.4273 49.625 14.9328V13.1829C50.7757 13.7915 52.549 14.229 54.1902 14.229C56.0577 14.229 56.7557 13.4872 56.7557 12.384C56.7557 11.2808 56.0766 10.6912 53.7186 10.1206C50.9266 9.43587 49.6816 8.46584 49.6816 6.41164C49.6816 4.47156 51.153 3.026 54.0393 3.026C55.8314 3.026 56.9821 3.46347 57.831 3.93898V5.65082C56.5859 4.92805 55.2466 4.6998 53.9638 4.6998C52.3415 4.6998 51.3794 5.27042 51.3794 6.41164C51.3794 7.43874 52.1717 7.95229 54.36 8.50388C56.9821 9.16959 58.4535 10.0255 58.4535 12.2699Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M37.5364 10.9571C37.5364 13.2396 38.4419 14.3808 40.1208 14.3808C41.5735 14.3808 42.8752 13.4488 42.8752 11.3375V10.5767C42.8752 8.46547 41.6867 7.53347 40.3095 7.53347C38.4796 7.53347 37.5364 8.75077 37.5364 10.9571ZM42.8752 15.7122V14.0004C42.2715 15.2557 41.1397 15.9024 39.6869 15.9024C37.178 15.9024 35.9141 13.7531 35.9141 10.9571C35.9141 8.27526 37.2346 6.01184 39.8756 6.01184C41.2528 6.01184 42.3092 6.63951 42.8752 7.87584V6.20204H44.4975V15.7122H42.8752Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M31.9323 10.1014V15.7124H30.3477V6.20222H31.9323V7.87601C32.4793 6.75381 33.4225 5.95495 35.2713 6.06907V7.66679C33.1962 7.45756 31.9323 8.08523 31.9323 10.1014Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M25.9727 3.69164C25.9727 2.96886 26.4443 2.55042 27.1045 2.55042C27.7648 2.55042 28.2364 2.96886 28.2364 3.69164C28.2364 4.41442 27.7648 4.83287 27.1045 4.83287C26.4443 4.83287 25.9727 4.41442 25.9727 3.69164ZM26.2745 15.7125V6.20234H27.8968V15.7125H26.2745Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M22.3231 12.0224V3.21594H24.0209V11.9082C24.0209 14.2097 23.0211 15.7884 20.6819 15.7884C19.7953 15.7884 19.1161 15.6362 18.6445 15.465V13.8103C19.1539 14.0195 19.7764 14.1336 20.3989 14.1336C21.8326 14.1336 22.3231 13.2587 22.3231 12.0224Z",
                                fill: "#101214"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_906_52755",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "130",
                        height: "39.6947",
                        fill: "white"
                    })
                })
            })
        ]
    });


const $931ce325970b5e46$var$jsmLogoByTheme = (colorMode)=>{
    return colorMode === 'light' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9847b6210cf26e92$export$3a6e642edb89de35), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $0197079ce91c86fc$export$5a3585ff193409c7), {});
};
const $931ce325970b5e46$export$b3890eb0ae9dca99 = (0, $9fcec3f40535e75a$export$78c758434c34d601)(({ onDismissed: onDismissed })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $67b25d6bc13c083d$export$486c30dd11c42f3), {
        app: {
            hamsIdentifier: 'jira-servicedesk.ondemand',
            ccpProductId: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
            logo: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                role: "img",
                "aria-label": intl.formatMessage({
                    id: "post-office.growth.recommendation-jsm.confluence-home-banner.logo-alt-text",
                    defaultMessage: "Jira Service Management Product Logo"
                }),
                "data-vc": "HDgx-b23",
                children: $931ce325970b5e46$var$jsmLogoByTheme(colorMode || 'light')
            }),
            header: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                id: "post-office.growth.recommendation-jsm.confluence-home-banner.header",
                defaultMessage: "See the whole picture, from request to resolution"
            }),
            description: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                id: "post-office.growth.recommendation-jsm.confluence-home-banner.description",
                defaultMessage: "Automatically turn Slack, Teams, and email requests into tickets."
            })
        },
        onDismissed: onDismissed
    });
});
var $931ce325970b5e46$export$2e2bcd8739ae039 = $931ce325970b5e46$export$b3890eb0ae9dca99;









parcelRequire("42omo");







const $4dacc319747045d7$var$clientPipeline = (0, $j9AoC.createClientPipeline)();
const $4dacc319747045d7$export$78c758434c34d601 = $4dacc319747045d7$var$clientPipeline.createRender;
const $4dacc319747045d7$export$2859a83e4d6da57d = $4dacc319747045d7$var$clientPipeline.createValidate;
const $4dacc319747045d7$var$serverPipeline = (0, $j9AoC.createServerPipeline)();
const $4dacc319747045d7$export$c905bc718befd59b = $4dacc319747045d7$var$serverPipeline.createHydrate;
const $4dacc319747045d7$export$1f41223e5b0a6622 = $4dacc319747045d7$var$serverPipeline.createHydrateExample;
const $4dacc319747045d7$export$88fe13b4d13f8423 = $4dacc319747045d7$var$serverPipeline.createTransformMetadata;


const $e586897f0ce7385d$export$b3890eb0ae9dca99 = (0, $4dacc319747045d7$export$78c758434c34d601)(({ onDismissed: onDismissed })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $67b25d6bc13c083d$export$486c30dd11c42f3), {
        app: {
            hamsIdentifier: 'jira-software.ondemand',
            ccpProductId: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
            logo: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraLogo), {
                size: "small",
                appearance: "brand",
                label: intl.formatMessage({
                    id: "post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.logo-alt-text",
                    defaultMessage: "Jira Product Logo"
                })
            }),
            header: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                id: "post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.header",
                defaultMessage: "Sync real-time data from Jira to any document in Confluence"
            }),
            description: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                id: "post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.description",
                defaultMessage: "See analytics and insights about what your team is working on at any moment"
            })
        },
        onDismissed: onDismissed
    });
});
var $e586897f0ce7385d$export$2e2bcd8739ae039 = $e586897f0ce7385d$export$b3890eb0ae9dca99;









parcelRequire("42omo");







const $70db4d96d3d164d6$var$clientPipeline = (0, $j9AoC.createClientPipeline)();
const $70db4d96d3d164d6$export$78c758434c34d601 = $70db4d96d3d164d6$var$clientPipeline.createRender;
const $70db4d96d3d164d6$export$2859a83e4d6da57d = $70db4d96d3d164d6$var$clientPipeline.createValidate;
const $70db4d96d3d164d6$var$serverPipeline = (0, $j9AoC.createServerPipeline)();
const $70db4d96d3d164d6$export$c905bc718befd59b = $70db4d96d3d164d6$var$serverPipeline.createHydrate;
const $70db4d96d3d164d6$export$1f41223e5b0a6622 = $70db4d96d3d164d6$var$serverPipeline.createHydrateExample;
const $70db4d96d3d164d6$export$88fe13b4d13f8423 = $70db4d96d3d164d6$var$serverPipeline.createTransformMetadata;


const $808aa7ec7b9c4fca$export$b3890eb0ae9dca99 = (0, $70db4d96d3d164d6$export$78c758434c34d601)(({ onDismissed: onDismissed })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $67b25d6bc13c083d$export$486c30dd11c42f3), {
        app: {
            hamsIdentifier: 'jira-software.ondemand',
            ccpProductId: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
            logo: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraLogo), {
                size: "small",
                appearance: "brand",
                label: intl.formatMessage({
                    id: "post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.logo-alt-text",
                    defaultMessage: "Jira Product Logo"
                })
            }),
            header: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                id: "post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.header",
                defaultMessage: "Build world-class products, fast"
            }),
            description: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                id: "post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.description",
                defaultMessage: "76% customers shipped projects faster after adding Confluence and Jira."
            })
        },
        onDismissed: onDismissed
    });
});
var $808aa7ec7b9c4fca$export$2e2bcd8739ae039 = $808aa7ec7b9c4fca$export$b3890eb0ae9dca99;









parcelRequire("42omo");







const $ee13e5a6f9f23216$var$clientPipeline = (0, $j9AoC.createClientPipeline)();
const $ee13e5a6f9f23216$export$78c758434c34d601 = $ee13e5a6f9f23216$var$clientPipeline.createRender;
const $ee13e5a6f9f23216$export$2859a83e4d6da57d = $ee13e5a6f9f23216$var$clientPipeline.createValidate;
const $ee13e5a6f9f23216$var$serverPipeline = (0, $j9AoC.createServerPipeline)();
const $ee13e5a6f9f23216$export$c905bc718befd59b = $ee13e5a6f9f23216$var$serverPipeline.createHydrate;
const $ee13e5a6f9f23216$export$1f41223e5b0a6622 = $ee13e5a6f9f23216$var$serverPipeline.createHydrateExample;
const $ee13e5a6f9f23216$export$88fe13b4d13f8423 = $ee13e5a6f9f23216$var$serverPipeline.createTransformMetadata;


const $2c44fd0c11b42254$export$3678c6c473f30928 = 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f';
const $2c44fd0c11b42254$export$5fca8a2477be63d = 'jira-software.ondemand';
const $2c44fd0c11b42254$export$a75e537c279a265a = 'Jira';


const $d7f3d7c241f7b2f8$export$b3890eb0ae9dca99 = (0, $ee13e5a6f9f23216$export$78c758434c34d601)(({ onDismissed: onDismissed })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $67b25d6bc13c083d$export$486c30dd11c42f3), {
        app: {
            hamsIdentifier: (0, $2c44fd0c11b42254$export$5fca8a2477be63d),
            ccpProductId: (0, $2c44fd0c11b42254$export$3678c6c473f30928),
            logo: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraLogo), {
                appearance: "brand",
                size: "small",
                label: intl.formatMessage({
                    id: "post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.logo-alt-text",
                    defaultMessage: "Jira Product Logo"
                })
            }),
            header: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                id: "post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.header",
                defaultMessage: "Visualize any project in a list, board, backlog, and more"
            }),
            description: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                id: "post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.description",
                defaultMessage: "Jira lets you view your project and tasks in a way that works for you and your team."
            })
        },
        onDismissed: onDismissed
    });
});
var $d7f3d7c241f7b2f8$export$2e2bcd8739ae039 = $d7f3d7c241f7b2f8$export$b3890eb0ae9dca99;








const $7baad853de7d960a$var$clientPipeline = (0, $j9AoC.createClientPipeline)();
const $7baad853de7d960a$export$78c758434c34d601 = $7baad853de7d960a$var$clientPipeline.createRender;
const $7baad853de7d960a$export$2859a83e4d6da57d = $7baad853de7d960a$var$clientPipeline.createValidate;
const $7baad853de7d960a$var$serverPipeline = (0, $j9AoC.createServerPipeline)();
const $7baad853de7d960a$export$c905bc718befd59b = $7baad853de7d960a$var$serverPipeline.createHydrate;
const $7baad853de7d960a$export$1f41223e5b0a6622 = $7baad853de7d960a$var$serverPipeline.createHydrateExample;
const $7baad853de7d960a$export$88fe13b4d13f8423 = $7baad853de7d960a$var$serverPipeline.createTransformMetadata;


const $b9e22dad6dff95d2$export$b3890eb0ae9dca99 = (0, $7baad853de7d960a$export$78c758434c34d601)(()=>/*#__PURE__*/ (0, $l998X.jsx)("button", {
        "data-vc": "GDUoZvWW",
        children: "This is an example test button"
    }));
var $b9e22dad6dff95d2$export$2e2bcd8739ae039 = $b9e22dad6dff95d2$export$b3890eb0ae9dca99;


const $a399ac84f1f75e8e$export$e30378e28ad3e6ab = {
    'confluence-rovo-awareness-home-banner': (0, $c323ab387cd18dfd$export$2e2bcd8739ae039),
    'message-template-template': (0, $cab426d5d6981a6b$export$2e2bcd8739ae039),
    'recommendation-jpd': (0, $90616e845ea4ca9f$export$2e2bcd8739ae039),
    'recommendation-jsm': (0, $931ce325970b5e46$export$2e2bcd8739ae039),
    'recommendation-jsw-real-time-updates': (0, $e586897f0ce7385d$export$2e2bcd8739ae039),
    'recommendation-jsw-tech-teams': (0, $808aa7ec7b9c4fca$export$2e2bcd8739ae039),
    'recommendation-jsw-visualize-work': (0, $d7f3d7c241f7b2f8$export$2e2bcd8739ae039),
    'test-message-inapp': (0, $b9e22dad6dff95d2$export$2e2bcd8739ae039)
};
const $a399ac84f1f75e8e$var$messageRenderer = (0, $cyz5M.asMessageRenderer)($a399ac84f1f75e8e$export$e30378e28ad3e6ab, 'confluence-home-banner');
const $a399ac84f1f75e8e$export$bce4e5106d86e473 = $a399ac84f1f75e8e$var$messageRenderer.initializeMessageRenderer;
const $a399ac84f1f75e8e$export$2df1250b8f917a59 = $a399ac84f1f75e8e$var$messageRenderer.MessageRenderer;


/* GeneratedContentHash: 31aea97eca3fb427d03f67c1f7441dc55b0c7dddfeed2b93043e44c5ef7e2378 */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $628d825e1018a6dc$export$a5cfae247d8360ef = 'confluence-home-banner';


const $a03f7a6129477f8c$var$excludedMessages = new Set([
    'test-message-inapp',
    'message-template-template'
]);
/**
 * Confluence Home Banner does not have IntlProvider, all it's translations are managed by Confluence
 *
 * @see confluence/next/packages/i18n/src/messages.ts
 */ const $a03f7a6129477f8c$var$ConfluenceHomeBanner = (0, $2mPpz.createPlacementComponent)((0, $628d825e1018a6dc$export$a5cfae247d8360ef), /*#__PURE__*/ (0, $42omo.memo)(({ initialData: initialData, preloadedInitialData: preloadedInitialData })=>{
    const { data: data, isLoading: isLoading } = (0, $6Ht9d.useInitialData)(initialData);
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents, @typescript-eslint/no-unsafe-assignment
    const [{ message: message, status: status }, setMessageState] = (0, $42omo.useState)(()=>{
        if (preloadedInitialData) return preloadedInitialData?.messages?.length > 0 ? {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            message: preloadedInitialData?.messages[0],
            status: 'done'
        } : {
            message: undefined,
            status: 'done'
        };
        return {
            message: undefined,
            status: 'loading'
        };
    });
    const handleOnDismissed = (0, $42omo.useCallback)(()=>{
        setMessageState({
            message: undefined,
            status: 'done'
        });
    }, []);
    const isDone = status === 'done';
    (0, $42omo.useEffect)(()=>{
        if (!isLoading && !isDone) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const newMessage = (data?.messages || []).filter(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
            (dataMessage)=>!$a03f7a6129477f8c$var$excludedMessages.has(dataMessage.messageTemplateId))[0];
            setMessageState({
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                message: newMessage,
                status: 'done'
            });
        }
    }, [
        isLoading,
        isDone,
        data
    ]);
    if (status === 'loading') return /*#__PURE__*/ (0, $l998X.jsx)((0, $4b37b39623475e79$export$a762e2300443622e), {});
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: message && // Adding @ts-ingore to suppress the error in confluence typecheck and below error is not thrown in post-office typecheck
        // This error exists because confluence is using react 16 and post-office is using react 18
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - 'ReactNode | ReactElement<any, any>' is not a valid JSX element.
        /*#__PURE__*/ (0, $l998X.jsx)((0, $a399ac84f1f75e8e$export$2df1250b8f917a59), {
            ...message,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            id: message.messageInstanceId,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            messageInstanceId: message.messageInstanceId,
            onDismissed: handleOnDismissed,
            SuspenseBoundary: (0, $cyz5M.MaybeSuspenseBoundary)
        })
    });
}), {
    choreographer: {
        // Disabling this placement from being choreographed as it is not a pop-up
        isDefaultEnabled: false
    }
});
var $a03f7a6129477f8c$export$2e2bcd8739ae039 = $a03f7a6129477f8c$var$ConfluenceHomeBanner;



var $9oJIg = parcelRequire("9oJIg");

var $MyxIQ = parcelRequire("MyxIQ");


var $9QvUi = parcelRequire("9QvUi");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $luv00 = parcelRequire("luv00");

const $158bb15665e24ab2$export$56a6785e0b5d9ed3 = /*#__PURE__*/ (0, $42omo.memo)(()=>{
    const [preloadedInitialData] = (0, $MyxIQ.usePlacementPreloadedData)('confluence-home-banner');
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const memoizedPlacementProps = (0, $42omo.useMemo)(()=>({
            preloadedInitialData: preloadedInitialData
        }), [
        preloadedInitialData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        role: "banner",
        "data-testid": "confluence-home-banner-placement",
        "data-vc": "confluence-home-banner-placement",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9oJIg.PlacementFetchProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9QvUi.default), {
        placementId: "confluence-home-banner",
        // @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
        PlacementComponent: (0, $a03f7a6129477f8c$export$2e2bcd8739ae039),
        placementProps: memoizedPlacementProps,
        disableInitialData: Boolean(preloadedInitialData)
    })));
});
const $158bb15665e24ab2$export$56f554239fdb8ec2 = /*#__PURE__*/ (0, $42omo.memo)((0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).POST_OFFICE
})($158bb15665e24ab2$export$56a6785e0b5d9ed3));
module.exports["PostOfficeHomeBanner"] = $158bb15665e24ab2$export$56f554239fdb8ec2;

});

parcelRegister("5mBfb", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $4yg2A = parcelRequire("4yg2A");

var $fJ5kL = parcelRequire("fJ5kL");


var $lEClu = parcelRequire("lEClu");


var $a6XTh = parcelRequire("a6XTh");

const $77da95ec918c18a4$export$6f0e577fcefa598a = ()=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { feedTypeOverride: feedTypeOverride } = (0, $fJ5kL.useFeedTypeOverride)();
    const { loading: loadingPreferences, feedType: feedType, hasSelectedFeedTypePreference: hasSelectedFeedTypePreference } = (0, $fJ5kL.useFeedTypeSelector)();
    const filterOrOverride = feedTypeOverride || feedType;
    const { followingFeedQuery: followingFeedQuery } = (0, $lEClu.useFollowingFeedWithSortByStorage)();
    const { popularFeedQuery: popularFeedQuery } = (0, $a6XTh.usePopularFeedWithTimeGranularityStorage)(true);
    // If the user is not logged in, they should not see the feed section. So we don't need to check if the feed is empty.
    if (!isLoggedIn) return {
        hasFeed: false
    };
    if (loadingPreferences) return {
        hasFeed: false
    };
    const hasFollowingFeed = !followingFeedQuery?.loading && Boolean(followingFeedQuery?.data?.feed?.nodes.length);
    const hasPopularFeed = !popularFeedQuery?.loading && Boolean(popularFeedQuery?.data?.popularFeed?.nodes.length);
    // If user has NOT selected a feed type preference, we default to checking if the user has any FOLLOWING feed first, and then POPULAR if there's no FOLLOWING.
    if (!hasSelectedFeedTypePreference) return {
        hasFeed: hasFollowingFeed || hasPopularFeed
    };
    // If user has selected a feed type preference, we first check if the overridden type is POPULAr
    if (filterOrOverride === (0, $4yg2A.FeedType).POPULAR) return {
        hasFeed: hasPopularFeed
    };
    // Otherwise, we default to checking if the user has any FOLLOWING feed
    return {
        hasFeed: hasFollowingFeed
    };
};


const $cb59cf9c5f23b9f9$export$486f604e62b3473b = ()=>{
    const { hasFeed: hasFeed } = (0, $77da95ec918c18a4$export$6f0e577fcefa598a)();
    return {
        isEligible: hasFeed
    };
};
module.exports["usePostOfficeHomeBannerEligible"] = $cb59cf9c5f23b9f9$export$486f604e62b3473b;

});

parcelRegister("h1Vf7", function(module, exports) {

var $5amEx = parcelRequire("5amEx");


var $lU1qY = parcelRequire("lU1qY");


var $lkQRq = parcelRequire("lkQRq");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");


var $bQm3c = parcelRequire("bQm3c");




const $3262dd47c4d650d8$var$useHomeWidgetStateQuery = (0, $lkQRq.default);
const $3262dd47c4d650d8$var$useHomeWidgetStateHomeWidgetsMutation = (0, $lU1qY.default);
const $3262dd47c4d650d8$export$86296873b62c42c0 = (id, defaultState, initialStateOverride)=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: queryError } = (0, $jMyy4.useQueryInterop)($3262dd47c4d650d8$var$useHomeWidgetStateQuery, {
        errorPolicy: 'all',
        // Use cache-first for both licensed and unlicensed users to allow cache reads
        fetchPolicy: 'cache-first',
        __callerPackage__: "@confluence/home"
    });
    const [updateWidgetState, { error: mutationError }] = (0, $308Wd.useMutationInterop)($3262dd47c4d650d8$var$useHomeWidgetStateHomeWidgetsMutation, {
        __callerPackage__: "@confluence/home"
    });
    const [stateOverride, setStateOverride] = (0, $42omo.useState)(initialStateOverride);
    (0, $42omo.useEffect)(()=>{
        setStateOverride(initialStateOverride);
    }, [
        initialStateOverride
    ]);
    // Use the widget state override, falling back to saved prefrence, falling back to defaultState, falling back to collapsed
    const widgetState = stateOverride || data?.userPreferences?.homeWidgets.find((widget)=>widget.id === id)?.state || defaultState || 'COLLAPSED';
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $5amEx.default),
        fragmentSpec: (0, $5amEx.default),
        __callerPackage__: "@confluence/home"
    });
    const setWidgetState = (0, $42omo.useCallback)((newState)=>{
        if (isLicensed) updateWidgetState({
            variables: {
                id: id,
                state: newState
            }
        });
        const homeWidgets = (data?.userPreferences?.homeWidgets || []).filter((widget)=>widget.id !== id);
        homeWidgets.push({
            id: id,
            state: newState,
            __typename: 'HomeWidget'
        });
        /**
     * This write into cache serves two purposes:
     *   1. To initially populate the cache in the case where
     *      a preference hasn't yet been saved or the user is unlicensed.
     *   2. To optimistically update the cache, since we're doing #1 anyway
     */ writeFragmentInterop({
            fragmentId: '$ROOT_QUERY.userPreferences',
            data: {
                homeWidgets: homeWidgets,
                __typename: 'UserPreferences'
            }
        });
        // After the user explicitly changes state, clear the state override
        setStateOverride(undefined);
    }, [
        id,
        data,
        isLicensed,
        updateWidgetState,
        writeFragmentInterop
    ]);
    const error = mutationError || queryError;
    return {
        widgetState: widgetState,
        setWidgetState: setWidgetState,
        loading: loading,
        error: error
    };
};
module.exports["useHomeWidgetState"] = $3262dd47c4d650d8$export$86296873b62c42c0;

});

parcelRegister("dR5is", function(module, exports) {
/* PTV2TemplateCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $1Whri = parcelRequire("1Whri");


var $6mKj3 = parcelRequire("6mKj3");

const $a3d10785a39c94e2$var$i18n = (0, $aXWIB.defineMessages)({
    usedBefore: {
        id: "experiment-personalized-templates-v2.template-list.template-card.used-before",
        defaultMessage: "{count, plural, one {Used {count} time before} other {Used {count} times before}}"
    },
    notUsedYet: {
        id: "experiment-personalized-templates-v2.template-list.template-card.havent-used-before",
        defaultMessage: "Not used yet"
    }
});
const $a3d10785a39c94e2$var$styles = {
    borderStyles: "_1h6d1l7x _1dqonqa1 _189ee4h9",
    containerStyles: "_1reo15vq _18m915vq _4t3i1lit _bfhkhfxm _19bvpxbi _ca0qpxbi _u5f3pxbi _vchhusvi _irr31dpa",
    contentContainerStyles: "_zulppxbi _4t3i1osq _y3gnv2br",
    imageContainerStyles: "_1reo15vq _18m915vq _189eidpf _4t3iucft _1bsb1osq _13li12b0 _qrwq12b0",
    pressableStyles: "_1yt4ze3t _18s8ze3t _2rko1mok _1reo15vq _18m915vq _1bsb1osq _4t3i1osq _bfhk1j28",
    iconContainerStyles: "_1yt4u2gc _2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1",
    headerStyles: "_zulputpp _4cvr1h6o"
};
const $a3d10785a39c94e2$export$bc66431553f37afa = ({ title: title, subTitle: subTitle, onClick: onClick, icon: icon, image: image, usage: usage })=>{
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const rernderedSubTitle = usage && isHovered ? formatMessage($a3d10785a39c94e2$var$i18n.usedBefore, {
        count: usage
    }) : subTitle;
    return /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        testId: "ptv2-template-card-button",
        xcss: (0, $1Whri.cx)($a3d10785a39c94e2$var$styles.pressableStyles, $a3d10785a39c94e2$var$styles.borderStyles),
        onClick: onClick,
        // `eslint-plugin-check-bifrost` rule which requires statically analyzable
        // experiment usages. The cc_activation_a11y_fixes experiment exposes the
        // card to assistive tech as a link (see ACTIVATION-2644 / A11Y-42432).
        // tabIndex is intentionally omitted because the underlying <button>
        // element is already focusable with tabindex=0 by default.
        role: (0, $6mKj3.expValEquals)('cc_activation_a11y_fixes', 'isEnabled', true) ? 'link' : undefined
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $a3d10785a39c94e2$var$styles.containerStyles
        ]),
        "data-vc": "hG5mahu5"
    }, /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
        xcss: $a3d10785a39c94e2$var$styles.contentContainerStyles,
        direction: "column"
    }, /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
        xcss: $a3d10785a39c94e2$var$styles.headerStyles
    }, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $a3d10785a39c94e2$var$styles.iconContainerStyles
    }, icon), /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), null, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        maxLines: 1,
        weight: "bold"
    }, title), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        maxLines: 1,
        color: "color.text.subtlest",
        size: "small"
    }, rernderedSubTitle))), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $a3d10785a39c94e2$var$styles.imageContainerStyles
        ])
    }, image))));
};
module.exports["PTV2TemplateCard"] = $a3d10785a39c94e2$export$bc66431553f37afa;

});

parcelRegister("34yV7", function(module, exports) {

var $aZID8 = parcelRequire("aZID8");


var $8E5P5 = parcelRequire("8E5P5");

const $b9d52551482b648b$export$e272c57b679d644 = `https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/taxonomy/`;
const $b9d52551482b648b$export$343b29b08adb8468 = 'https://dam-cdn.atl.orangelogic.com/AssetLink/24jio0s0f10wt00f100x8ka51g80147d.png';
const $b9d52551482b648b$export$e6bc61fd26441f1d = 'https://dam-cdn.atl.orangelogic.com/AssetLink/ka6xb0k673ogce3fr8663jhc11v815cv.svg';
const $b9d52551482b648b$export$ff18b1f7218e1365 = {
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ACTION_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v775766xlw833sa16cqlc03tuw1tflc2.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ANNUAL_CALENDAR]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/gt8mxd565jnlxpcla58q6fik18u0o5b2.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/286roqo0x24518bmu83f668tu5dvgms2.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).CONCEPT_MAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/em34t20hd3k5d3y5lou7ac3pt8nwh53w.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).CRAZY_8S_BRAINSTORMING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/hhhhhjyr0k0tkwqj64550117ytp50i1e.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).DISRUPTIVE_BRAINSTORM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v4n83g7myc10be1f0uahh76jls455i8u.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).EXECUTIVE_SUMMARY]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/54i677d21ed42r1d7ws1bfd37nwf36s8.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).FISHBONE_DIAGRAM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/16065dh57ba4b022x51r0tkqbd28dl87.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).FLOWCHART]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/26814iat2a7ndfjrs0uq5i2g0x72867y.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).FOCUS_AREA_DIAGRAM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/o7sw2x42srn06s00a0esiq788283341p.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).FOURLS_RETRO]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/hu6yl738y22o50t0pr2vo4o05wan62n1.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).GAP_ANALYSIS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0dn87kk6o66hvf420nfqjg45615k4m73.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).INCIDENT_POSTMORTEM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3d765023oqb4btu13pj7wdw5343wx6vv.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ICEBREAKERS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8i66o10j7qu27884l2c3si1xh0335w14.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).NETWORK_OF_TEAMS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l5343a3n0485ax1nh434373xq8g5l6s7.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ORG_CHART]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0e1c2vi1r8376b5t834kd607uqt0ymyp.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).PRIORITIZATION_MATRIX]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/cm3igo2rky6iip0h1t3wy67pek85mla5.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).PRODUCT_VISION_BOARD]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6a51tvn7g1o3tl3vqvg0nsb14p60w77d.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ROOT_CAUSE_TEMPLATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/76p747np1oon57pu221347ohfjvnm180.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SERVICE_BLUEPRINT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/617mv306vsf7w6sp43b6w6pas8xt4djd.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SIMPLE_RETROSPECTIVE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5ks001pi5jng10bnv131n7nu0k40l3xo.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).STAKEHOLDER_MAPPING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/370bf03j886cokvq31658l4l3w66wv6p.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SWIMLANES_PROCESS_MAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/30u4108cdrbb83082p01f6810dtf1of4.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SWOT_ANALYSIS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/w814j2a58v56xuxoi444u5biqctwlhub.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).TEAM_CHARTER_TEMPLATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/kl7cn5h28ysoc3ti2gwyx6025v2b2nac.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).TEAM_HEALTH_MONITOR]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1e56m4o21348hk5j226181v4elqwi0w1.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).TIMELINE_WORKFLOW]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/t520b6d576imhfl70je80l8x8d77bduo.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).USER_STORY_MAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m3hvi182obpt68vrr0x32k7kpcn7j844.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).WORKFLOW_TEMPLATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/b4gx5wo7fsn6we642b242q7188gsq386.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).PRODUCT_ROADMAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/w2w6e854gvt71756v2q53318t6t3vei3.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ELEVATOR_PITCH]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5u8b4i1104l3d762gb8023m1itq7l34x.svg'
};
const $b9d52551482b648b$export$72f354715b8d4636 = {
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ACTION_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8y8sc20314pf86r8887x1rh3j57t7v0m.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ANNUAL_CALENDAR]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/a6x7e6e50ynr0m1117k686cu15f702xn.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g0o1ks846i88hr5a3b64682r5om4202q.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).CONCEPT_MAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4ywpy0ek1o1o4rwao564k64v15ex4618.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).CRAZY_8S_BRAINSTORMING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/31t5j2o00j2s7t5ew0n6pr4kp4phvt04.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).DISRUPTIVE_BRAINSTORM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/o360h3o63u55epg1ai452ds5mms5i8x5.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).EXECUTIVE_SUMMARY]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ul7j8s4v6o2336il6a781m566t0rr6sc.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).FISHBONE_DIAGRAM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/715fur87612t53h5m4bwg11k5j5w3771.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).FLOWCHART]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/t3mfg1hxryf30du04apjsn3rf6i53ujn.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).FOCUS_AREA_DIAGRAM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/nc8ogfbk5y7nugu56gy14cbk8564k4m1.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).FOURLS_RETRO]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/650c73qh4cx735v8v40530xf4l5gr263.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).GAP_ANALYSIS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7a32ce1yafkbwyroef6b5ty6y7684560.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).INCIDENT_POSTMORTEM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/mg40lr1ans63vk7t0rqwq53hx3mv3x0a.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ICEBREAKERS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8543ywanoenx7v0w2fo57874w081rs50.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).NETWORK_OF_TEAMS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/dp08ln0x64w03f6855vt5k25xttu8y1y.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ORG_CHART]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/kpq78wcv70g231k70x6083uw1oj35x15.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).PRIORITIZATION_MATRIX]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/qi6q25nj7657c511n5t06gu6a6cf7nk4.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).PRODUCT_ROADMAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/dd47fnm3l1ngnqcie3ad4oj747251s37.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).PRODUCT_VISION_BOARD]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/eu16r33866w646j52x351lpsceof0057.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ROOT_CAUSE_TEMPLATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g1um66bc1q5ia7x04gsdl0rgx87j6jvm.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SERVICE_BLUEPRINT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fe1f2sv15s3q667sqp4w2l3271qp431y.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SIMPLE_RETROSPECTIVE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/yxsr7cv8cc4ox20f6am0788u13tx8731.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).STAKEHOLDER_MAPPING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/dptnm3xu130487m1a3eo1y780g274c38.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SWIMLANES_PROCESS_MAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3ao2nw5gfffwms6j4w0fd07126007215.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SWOT_ANALYSIS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i88nc0mpr1j8m2v045a7s6ik0x827ero.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).TEAM_CHARTER_TEMPLATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i622u0u2h5d2o0b23abf1qx57h36p8a8.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).TEAM_HEALTH_MONITOR]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x1687g5ye71fs1qfym3a653nls22g460.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).TIMELINE_WORKFLOW]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/17uws3bph888pu42v71k12nbq27i4k5a.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).USER_STORY_MAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1l6gk820v5e7h17h0y4b27sb4l5whvy3.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).WORKFLOW_TEMPLATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1hquucr1ec0b4l1ht06l68sh80r0rs4q.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ELEVATOR_PITCH]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ltv22274128075mvb5h842f082vd35ik.svg'
};
const $b9d52551482b648b$export$c88a6d0afe4f1305 = {
    [(0, $8E5P5.BLUEPRINT_NAMES).NINETY_DAY_PLAN]: '90-day-plan',
    [(0, $8E5P5.BLUEPRINT_NAMES).ALL_HANDS_MEETING]: 'all-hands-meeting',
    [(0, $8E5P5.BLUEPRINT_NAMES).ANNUAL_PLAN_ONE_PAGER]: 'annual-plan-one-pager',
    [(0, $8E5P5.BLUEPRINT_NAMES).EXECUTIVE_BUSINESS_REVIEW]: 'executive-business-review',
    [(0, $8E5P5.BLUEPRINT_NAMES).BUSINESS_STATUS_UPDATE]: 'business-status-update',
    [(0, $8E5P5.BLUEPRINT_NAMES).BUSINESS_PLAN_ONE_PAGER]: 'business-plan-one-pager',
    [(0, $8E5P5.BLUEPRINT_NAMES).CAREER_DEVELOPMENT_PLAN]: 'career-development-plan',
    [(0, $8E5P5.BLUEPRINT_NAMES).COMPETITIVE_ANALYSIS]: 'competitive-analysis',
    [(0, $8E5P5.BLUEPRINT_NAMES).CONTENT_DESIGN_GLOSSARY]: 'content-design-glossary',
    [(0, $8E5P5.BLUEPRINT_NAMES).CONTENT_STRATEGY]: 'content-strategy',
    [(0, $8E5P5.BLUEPRINT_NAMES).CUSTOMER_IMPACT_ASSESSMENT]: 'customer-impact-assessment',
    [(0, $8E5P5.BLUEPRINT_NAMES).CUSTOMER_INTERVIEW_REPORT]: 'customer-interview-report',
    [(0, $8E5P5.BLUEPRINT_NAMES).DACI_DECISION_DOCUMENTATION]: 'decision',
    [(0, $8E5P5.BLUEPRINT_NAMES).DESIGN_DECISION]: 'design-decision',
    [(0, $8E5P5.BLUEPRINT_NAMES).DESIGN_REVIEW]: 'design-review',
    [(0, $8E5P5.BLUEPRINT_NAMES).DESIGN_SPRINT]: 'design-sprint',
    [(0, $8E5P5.BLUEPRINT_NAMES).DESIGN_SYSTEMS]: 'design-system',
    [(0, $8E5P5.BLUEPRINT_NAMES).DEVOPS_RUNBOOK]: 'devops-runbook',
    [(0, $8E5P5.BLUEPRINT_NAMES).EMPLOYEE_HANDBOOK]: 'employee-handbook',
    [(0, $8E5P5.BLUEPRINT_NAMES).HR_KNOWLEDGE_BASE_MANAGEMENT]: 'hr-knowledge-base',
    [(0, $8E5P5.BLUEPRINT_NAMES).HOW_TO_ARTICLE]: 'how-to-article',
    [(0, $8E5P5.BLUEPRINT_NAMES).ITSM_KNOWN_ERRORS]: 'itsm-known-errors',
    [(0, $8E5P5.BLUEPRINT_NAMES).ITSM_CHANGE_MANAGEMENT]: 'itsm-change-management',
    [(0, $8E5P5.BLUEPRINT_NAMES).ITSM_POST_INCIDENT_REVIEWS]: 'itsm-post-incident-review',
    [(0, $8E5P5.BLUEPRINT_NAMES).ITSM_RUNBOOK]: 'itsm-runbook',
    [(0, $8E5P5.BLUEPRINT_NAMES).INCIDENT_COMMUNICATION]: 'incident-communication',
    [(0, $8E5P5.BLUEPRINT_NAMES).INCIDENT_POSTMORTEM]: 'incident-postmortem',
    [(0, $8E5P5.BLUEPRINT_NAMES).JOB_DESCRIPTION]: 'job-description',
    [(0, $8E5P5.BLUEPRINT_NAMES).LENNYS_PERFORMANCE_REVIEW]: 'lennys-performance-review',
    [(0, $8E5P5.BLUEPRINT_NAMES).LENNYS_PRODUCT_REQUIREMENTS]: 'lennys-product-requirements',
    [(0, $8E5P5.BLUEPRINT_NAMES).MARKETING_PLAN]: 'marketing-plan',
    [(0, $8E5P5.BLUEPRINT_NAMES).MEETING_NOTES]: 'meeting-notes',
    [(0, $8E5P5.BLUEPRINT_NAMES).MESSAGE_HOUSE]: 'message-house',
    [(0, $8E5P5.BLUEPRINT_NAMES).OKRS]: 'okrs',
    [(0, $8E5P5.BLUEPRINT_NAMES).PERSONA]: 'persona',
    [(0, $8E5P5.BLUEPRINT_NAMES).PRESENTER_MODE]: 'presenter-mode',
    [(0, $8E5P5.BLUEPRINT_NAMES).PRODUCT_REQUIREMENTS]: 'product-requirements',
    [(0, $8E5P5.BLUEPRINT_NAMES).PRODUCT_ROADMAP]: 'product-roadmap',
    [(0, $8E5P5.BLUEPRINT_NAMES).PROJECT_KICKOFF]: 'project-kickoff',
    [(0, $8E5P5.BLUEPRINT_NAMES).PROJECT_PLAN]: 'project-plan',
    [(0, $8E5P5.BLUEPRINT_NAMES).PROJECT_STATUS]: 'project-status',
    [(0, $8E5P5.BLUEPRINT_NAMES).PROJECT_TIMELINE_TEMPLATE]: 'project-timeline',
    [(0, $8E5P5.BLUEPRINT_NAMES).QTC_ACQUISITION]: 'qtc-acquisition',
    [(0, $8E5P5.BLUEPRINT_NAMES).REMOTE_TEAM_MEETING]: 'remote-team-meeting',
    [(0, $8E5P5.BLUEPRINT_NAMES).RISK_ASSESSMENT_MATRIX]: 'risk-assessment',
    [(0, $8E5P5.BLUEPRINT_NAMES).ROLES_AND_RESPONSIBILITIES]: 'roles-and-responsibilities',
    [(0, $8E5P5.BLUEPRINT_NAMES).SMART_GOALS]: 'smart-goals',
    [(0, $8E5P5.BLUEPRINT_NAMES).SWOT_ANALYSIS]: 'swot-analysis',
    [(0, $8E5P5.BLUEPRINT_NAMES).SALES_PORTAL]: 'sales-portal',
    [(0, $8E5P5.BLUEPRINT_NAMES).SALES_ACCOUNT_PLANNING]: 'sales-account-planning',
    [(0, $8E5P5.BLUEPRINT_NAMES).SOFTWARE_ARCHITECTURE_REVIEW]: 'software-architecture-review',
    [(0, $8E5P5.BLUEPRINT_NAMES).SPRINT_PLANNING_MEETING]: 'sprint-planning-meeting',
    [(0, $8E5P5.BLUEPRINT_NAMES).STAKEHOLDER_COMMUNICATIONS]: 'stakeholder-communications',
    [(0, $8E5P5.BLUEPRINT_NAMES).STANDARD_OPERATING_PROCEDURE_TEMPLATE]: 'sop',
    [(0, $8E5P5.BLUEPRINT_NAMES).STRATEGIC_PLAN]: 'strategic-plan',
    [(0, $8E5P5.BLUEPRINT_NAMES).TEAM_HOMEPAGE]: 'team-homepage',
    [(0, $8E5P5.BLUEPRINT_NAMES).TEAM_POSTER]: 'team-poster',
    [(0, $8E5P5.BLUEPRINT_NAMES).TO_DO_LIST]: 'to-do-list',
    [(0, $8E5P5.BLUEPRINT_NAMES).TROUBLESHOOTING_ARTICLE]: 'troubleshooting-article',
    [(0, $8E5P5.BLUEPRINT_NAMES).VENDOR_AGREEMENT]: 'vendor-agreement',
    [(0, $8E5P5.BLUEPRINT_NAMES).VIRTUAL_EVENT]: 'virtual-event',
    [(0, $8E5P5.BLUEPRINT_NAMES).VISION_TO_VALUES]: 'vision-to-values',
    [(0, $8E5P5.BLUEPRINT_NAMES).END_OF_WEEK_STATUS_REPORT]: 'end-of-week-status-report',
    [(0, $8E5P5.BLUEPRINT_NAMES).WEEKLY_MEETING_NOTES]: 'weekly-meeting-notes',
    [(0, $8E5P5.BLUEPRINT_NAMES).WORK_TRIP_PLANNER]: 'work-trip-planner',
    [(0, $8E5P5.BLUEPRINT_NAMES).WORKSHOP_PLANNER]: 'workshop-planner',
    [(0, $8E5P5.BLUEPRINT_NAMES).WRITING_GUIDELINES]: 'writing-guidelines',
    [(0, $8E5P5.BLUEPRINT_NAMES).QUARTERLY_CHECK_IN]: 'quarterly-check-in',
    [(0, $8E5P5.BLUEPRINT_NAMES).AWS_ARCHITECTURE_DIAGRAM]: 'aws-architecture-diagram',
    [(0, $8E5P5.BLUEPRINT_NAMES).MARKETING_BLOG_POST]: 'marketing-blog-post',
    [(0, $8E5P5.BLUEPRINT_NAMES).MARKETING_CAMPAIGN]: 'marketing-campaign',
    [(0, $8E5P5.BLUEPRINT_NAMES).HIRING_PROCESS]: 'hiring-process',
    [(0, $8E5P5.BLUEPRINT_NAMES).MUTUAL_ACTION_PLAN]: 'mutual-action-plan',
    [(0, $8E5P5.BLUEPRINT_NAMES).ITSM_WEEKLY_MAJOR_INCIDENT_REPORT]: 'itsm-weekly-major-incident-report',
    [(0, $8E5P5.BLUEPRINT_NAMES).DISRUPTIVE_BRAINSTORMING]: 'disruptive-brainstorming'
};
const $b9d52551482b648b$var$blueprintsWithoutImages = new Set([
    (0, $8E5P5.BLUEPRINT_NAMES).STANDARD_OPERATING_PROCEDURE_TEMPLATE,
    (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_TIMELINE_TEMPLATE,
    (0, $8E5P5.BLUEPRINT_NAMES).SOFTWARE_ARCHITECTURE_REVIEW,
    (0, $8E5P5.BLUEPRINT_NAMES).LENNYS_PERFORMANCE_REVIEW,
    (0, $8E5P5.BLUEPRINT_NAMES).LENNYS_PRODUCT_REQUIREMENTS
]);
const $b9d52551482b648b$export$3e4521316af54a8c = Object.keys($b9d52551482b648b$export$c88a6d0afe4f1305).reduce((mappings, key)=>{
    mappings[key] = $b9d52551482b648b$var$blueprintsWithoutImages.has(key) ? $b9d52551482b648b$export$343b29b08adb8468 : `${$b9d52551482b648b$export$e272c57b679d644}${$b9d52551482b648b$export$c88a6d0afe4f1305[key]}.svg`;
    return mappings;
}, {});
const $b9d52551482b648b$export$5afae992b84a32d5 = {
    [(0, $8E5P5.BLUEPRINT_NAMES).DESIGN_REVIEW]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/h4k3b710fj7203m0hj43j3cc425cuy76.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).DESIGN_SPRINT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/olpn6123xee0naxqm57sf3bpnr3mvglw.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).DESIGN_DECISION]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1x53580r2xjt08816apkqrwq6g7ga107.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).DACI_DECISION_DOCUMENTATION]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/juc54l2t2c16lx8k1g3e3q1076ckmfng.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).CUSTOMER_INTERVIEW_REPORT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0e473ir7jdwlcoyls06uc04iim077741.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).CONTENT_STRATEGY]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m06ipqhy7no6d5ab6qrd7kqfhlggy2ni.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).CONTENT_DESIGN_GLOSSARY]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ayg5h2aq885e62ysr47865rg461uw2we.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).CAREER_DEVELOPMENT_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ms2f3506w5a41lv6jk38ucy8882yky4e.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).COMPETITIVE_ANALYSIS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1s4ovxh8tpsk74g33lmd4ujw0np3o731.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).BUSINESS_STATUS_UPDATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/s8644uajks6cw0fj2o0q1e7tf645pjdq.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).BUSINESS_PLAN_ONE_PAGER]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q7243b5o3jvm6vo3504p7rc8o667pmy6.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).ITSM_RUNBOOK]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g5y6q6oqf15txlpv1q2m53648sh1888w.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).ITSM_KNOWN_ERRORS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/843prjia43re78n53vh4f1nkvm5lbb43.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).HR_KNOWLEDGE_BASE_MANAGEMENT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/waj1m80wt58g346m3bx1l82cq5fn785e.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).EXECUTIVE_BUSINESS_REVIEW]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2sb43g4320785m6k44k8djm3d7487s01.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).HOW_TO_ARTICLE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/871dux30tosjc8ipe18fr346rmqe4juf.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).ANNUAL_PLAN_ONE_PAGER]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2atvs27hd5w232sg773008l3q2fssr4o.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).NINETY_DAY_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/eub8wfax8n446u54req1vvq0i5y4ai51.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).ALL_HANDS_MEETING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l8c1g33u3a37qc73v4v0ple4bt7582u8.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).PROJECT_KICKOFF]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q23316jb58686pa5na5l23hp4tmlym5q.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).PERSONA]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3288qdj186qk418dt7p3fp5m1ngy1204.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).DESIGN_SYSTEMS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3r6x6daq4gj0a8w55gv4l0mi0l2jq676.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).DEVOPS_RUNBOOK]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/55p8fe88y7345bq5o8ld1wo4b3s6x7fk.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).END_OF_WEEK_STATUS_REPORT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/322w834s7iv5cv55sawmnvnj214165l8.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).EMPLOYEE_HANDBOOK]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/d154e06qu2wc6f4rvf24qn5q352ni5y5.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).CUSTOMER_IMPACT_ASSESSMENT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x80i888ygwk623tn3b1i1ol70p7v7sa1.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).ITSM_POST_INCIDENT_REVIEWS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8wx1f2120m7qo2osbgh3m26o0h13b460.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).INCIDENT_POSTMORTEM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3p11p1kfnqf1xtj2i6282pup7500v5v7.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).ITSM_CHANGE_MANAGEMENT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/07h8i0ldabdfh18e0f3406xfw32fk787.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).INCIDENT_COMMUNICATION]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/un7420lmym06873pxv6i7us28442i30e.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).JOB_DESCRIPTION]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3lwqq2rfxv426g7op1js2b8470g26sfu.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).PROJECT_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ed8e6w12k8ar4d1523lr3rpx3ys68dhh.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).PRODUCT_REQUIREMENTS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/626r1r03m1i01w37o72r6y7n57t0plmq.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).PRESENTER_MODE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x763b1j8e1y71f0lh286048tn6q30035.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).MEETING_NOTES]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/36p554e65x6ub45035dacj50l08mjpo0.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).ROLES_AND_RESPONSIBILITIES]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/p204067765c1yfd83im6hpt7cv4mfkc7.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).SALES_ACCOUNT_PLANNING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3sj6n68sjtf332lau0l627qr3ot3qe2v.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).RISK_ASSESSMENT_MATRIX]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x2n21bdg03i16s3t16tprkv6537446s5.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).QUARTERLY_CHECK_IN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/26a3wch8758m13o012m762xxv25ch8vg.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).SMART_GOALS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2bf67v33y7f2ln226xipfru2n7kns60b.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).VIRTUAL_EVENT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/c0i6b28xct78230ggb358m1047081ww5.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).TEAM_POSTER]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/k4r783xvvwvviw60i728w66g3nl8a1sn.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).TROUBLESHOOTING_ARTICLE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ok5ycecnech333n2m582ix021r2jy65k.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).TEAM_HOMEPAGE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0rnr6dq077l1x5wx53q036arpk780f2p.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).SWOT_ANALYSIS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/wmlg4wd6587651183as8031t301d4o85.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).TO_DO_LIST]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1asf3cijux7ga204cbc7qg6ra367nhc7.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).WORK_TRIP_PLANNER]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ogmwu64w8pwoxp2ho80nd87kp2x2pa3g.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).WRITING_GUIDELINES]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/64524bi14mrls3rem07y1p25hkumv16u.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).WORKSHOP_PLANNER]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/u0nub00c433fl778atn5yhgjoh782l13.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).WEEKLY_MEETING_NOTES]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/y0i7w3ks85280ehvpr28lpu5yg3ja0a7.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).VISION_TO_VALUES]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7mx000d02pi8r2ueg3rw7v01lgbj55dp.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).PRODUCT_ROADMAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0wtr2h661307rsnsoolf1k4502semf22.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).OKRS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/363722lk1ks8ut57cxor25f1d0864170.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).MARKETING_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/tt73e3c4016001x617mxxitl5g3u1n65.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).MESSAGE_HOUSE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0b2egux177m04b0dxo628v4m3s103460.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).SALES_PORTAL]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/j233apow7he8t03o2dn0o51g52mnw15j.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).REMOTE_TEAM_MEETING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7cknim011u00041rmw2yw1vr3w65xan1.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).QTC_ACQUISITION]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ek48h0gx82ks3j46480m6c6cu2h1e7wq.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).PROJECT_STATUS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vwpc40ldd857guo662l34831851l8h1x.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).VENDOR_AGREEMENT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vkq707lue205jypgy6kiy30u650u566x.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).STAKEHOLDER_COMMUNICATIONS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/wldn3c51e68086nl43q8wpk1x8yrcg17.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).STRATEGIC_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/d25x120oi2118101kxfmt10aqm2g8cvv.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).SPRINT_PLANNING_MEETING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8j1bvq02m82l623fy575sd7of2djd7my.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).AWS_ARCHITECTURE_DIAGRAM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3575i1013te6m8sp1xr08f54e8053egq.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).MARKETING_BLOG_POST]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/xfw4001fj343b5k7fteg177lb3175blr.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).MARKETING_CAMPAIGN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/70u14cws7507hm18ak4lp7eq5k0a8582.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).HIRING_PROCESS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/dc3418xr3v7522y6dv4gg636nmvf8y41.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).MUTUAL_ACTION_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/gm7gxjca3f0i7eon74md67f57c0r3qq1.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).ITSM_WEEKLY_MAJOR_INCIDENT_REPORT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/57ib28g38e3c0h5tj3ak5fxn3g2ppq7o.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).DISRUPTIVE_BRAINSTORMING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/38dc3au247c7a030ya5c7f3ajp7131lq.svg'
};
module.exports["defaultImgSrc"] = $b9d52551482b648b$export$343b29b08adb8468;
module.exports["defaultDarkImgSrc"] = $b9d52551482b648b$export$e6bc61fd26441f1d;
module.exports["WHITEBOARD_TEMPLATE_TO_IMG_MAPPING"] = $b9d52551482b648b$export$ff18b1f7218e1365;
module.exports["WHITEBOARD_TEMPLATE_TO_DARK_IMG_MAPPING"] = $b9d52551482b648b$export$72f354715b8d4636;
module.exports["BLUEPRINT_NAME_TO_IMG_MAPPING"] = $b9d52551482b648b$export$3e4521316af54a8c;
module.exports["BLUEPRINT_IMG_MAP_DARK"] = $b9d52551482b648b$export$5afae992b84a32d5;

});

parcelRegister("fJ5kL", function(module, exports) {

var $jLqGt = parcelRequire("jLqGt");


var $9BHAW = parcelRequire("9BHAW");


var $g4evd = parcelRequire("g4evd");


var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $ij4CE = parcelRequire("ij4CE");


var $jMyy4 = parcelRequire("jMyy4");





var $308Wd = parcelRequire("308Wd");


var $9bkOo = parcelRequire("9bkOo");


var $4yg2A = parcelRequire("4yg2A");

const $28645bc3a2212d0f$var$useFeedTypeSelectorRefreshQuery = (0, $g4evd.default);
const $28645bc3a2212d0f$var$useFeedTypeSelectorFeedTypeSelectorRefreshMutation = (0, $9BHAW.default);
const $28645bc3a2212d0f$export$f7f2ed889afe71b4 = (defaultPreference = (0, $9bkOo.FeedType).FOLLOWING)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $jLqGt.default),
        fragmentSpec: (0, $jLqGt.default),
        __callerPackage__: "@confluence/feed"
    });
    const { data: data, loading: loading, error: queryError } = (0, $jMyy4.useQueryInterop)($28645bc3a2212d0f$var$useFeedTypeSelectorRefreshQuery, {
        skip: !isLoggedIn,
        __callerPackage__: "@confluence/feed"
    });
    const feedType = data?.userPreferences?.feedTab || defaultPreference;
    const [feedTypeSelectorMutation, { error: mutationError }] = (0, $308Wd.useMutationInterop)($28645bc3a2212d0f$var$useFeedTypeSelectorFeedTypeSelectorRefreshMutation, {
        __callerPackage__: "@confluence/feed"
    });
    const updateFeedType = (updatedFeedType)=>{
        if (isLoggedIn) {
            const variables = {
                feedTab: updatedFeedType
            };
            feedTypeSelectorMutation({
                variables: variables,
                optimisticResponse: {
                    __typename: 'Mutation',
                    updateUserPreferences: {
                        __typename: 'UserPreferences',
                        feedTab: updatedFeedType
                    }
                }
            }).catch(()=>{}); // Ignore the error here since it is handled in useMutation
            // Always write to the cache so the user sees the preference even if there is an error
            writeFragmentInterop({
                fragmentId: '$ROOT_QUERY.userPreferences',
                data: {
                    ...variables,
                    //handles either feedType or feedTab depending on FF
                    __typename: 'UserPreferences'
                }
            });
        }
    };
    return {
        loading: loading,
        queryError: queryError,
        mutationError: mutationError,
        feedType: feedType,
        updateFeedType: updateFeedType,
        hasSelectedFeedTypePreference: Boolean(data?.userPreferences?.feedTab)
    };
};
const $28645bc3a2212d0f$export$bc03ece1cfb914e3 = (defaultPreference = (0, $9bkOo.FeedType).FOLLOWING)=>{
    const [feedType, setFeedType] = (0, $42omo.useState)(defaultPreference);
    const [hasSelectedFeedTypePreference, setHasSelectedFeedTypePreference] = (0, $42omo.useState)(false);
    return {
        loading: false,
        feedType: feedType,
        updateFeedType: (feedType)=>{
            setFeedType(feedType);
            setHasSelectedFeedTypePreference(true);
        },
        hasSelectedFeedTypePreference: hasSelectedFeedTypePreference
    };
};
const $28645bc3a2212d0f$var$getFeedType = (feedQueryParam)=>feedQueryParam && Object.values((0, $9bkOo.FeedType)).includes(feedQueryParam) ? feedQueryParam : undefined;
const $28645bc3a2212d0f$export$58e655f86753a7c1 = ()=>{
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const feedQueryParam = (0, $c3Qwv.getSingleParam)(getQueryParams(), 'feedType');
    const [feedTypeOverride, setFeedTypeOverride] = (0, $42omo.useState)($28645bc3a2212d0f$var$getFeedType(feedQueryParam));
    (0, $42omo.useEffect)(()=>{
        setQueryParams({
            feedType: undefined
        }, true);
    }, [
        setQueryParams
    ]);
    const clearFeedTypeOverride = ()=>{
        setFeedTypeOverride(undefined);
    };
    return {
        feedTypeOverride: feedTypeOverride,
        clearFeedTypeOverride: clearFeedTypeOverride
    };
};
module.exports["useFeedTypeSelector"] = $28645bc3a2212d0f$export$f7f2ed889afe71b4;
module.exports["useAnonymousFeedTypeSelector"] = $28645bc3a2212d0f$export$bc03ece1cfb914e3;
module.exports["useFeedTypeOverride"] = $28645bc3a2212d0f$export$58e655f86753a7c1;

});

parcelRegister("lEClu", function(module, exports) {

var $3cztU = parcelRequire("3cztU");


var $1UApO = parcelRequire("1UApO");


var $6mKj3 = parcelRequire("6mKj3");


var $kGgWH = parcelRequire("kGgWH");


var $kLaAt = parcelRequire("kLaAt");


var $2rlHJ = parcelRequire("2rlHJ");

const $c7452f13f73deba3$export$e7c2074107ea4cc7 = (0, $3cztU.default);
const $c7452f13f73deba3$export$68c012d92086743d = ()=>{
    const { value: value, setValue: setValue, query: query } = (0, $2rlHJ.useFeedDropdownStorage)({
        defaultValue: (0, $kLaAt.FollowingFeedSortByValue).Relevant,
        sessionStorageKey: (0, $1UApO.keys).HOME_FOLLOWING_FEED_SORTING,
        skipQuery: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true)
    }, {
        query: $c7452f13f73deba3$export$e7c2074107ea4cc7,
        variables: (sorting)=>({
                sortBy: sorting
            })
    });
    const { value: valueWithSnippets, setValue: setValueWithSnippets, query: queryWithSnippets } = (0, $2rlHJ.useFeedDropdownStorage)({
        defaultValue: (0, $kLaAt.FollowingFeedSortByValue).Relevant,
        sessionStorageKey: (0, $1UApO.keys).HOME_FOLLOWING_FEED_SORTING,
        skipQuery: !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true),
        interopApolloAggClient: true
    }, {
        query: (0, $kGgWH.FollowingFeedWithSortByStorageSnippetsQuery),
        variables: (sorting)=>({
                sortBy: sorting
            })
    });
    return {
        followingFeedSortBy: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true) ? valueWithSnippets : value,
        setFollowingFeedSortBy: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true) ? setValueWithSnippets : setValue,
        followingFeedQuery: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true) ? queryWithSnippets : query
    };
};
module.exports["useFollowingFeedWithSortByStorage"] = $c7452f13f73deba3$export$68c012d92086743d;

});

parcelRegister("a6XTh", function(module, exports) {

var $lNpDX = parcelRequire("lNpDX");


var $1UApO = parcelRequire("1UApO");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $kLaAt = parcelRequire("kLaAt");


var $2rlHJ = parcelRequire("2rlHJ");


var $hO347 = parcelRequire("hO347");


var $afN8s = parcelRequire("afN8s");

const $0305a9034492a0e3$export$8f658981599c0d01 = (0, $lNpDX.default);
const $0305a9034492a0e3$export$e2ce202e4769830c = (renderPopularFeed)=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { value: value, setValue: setValue, query: query } = (0, $2rlHJ.useFeedDropdownStorage)({
        defaultValue: (0, $kLaAt.PopularFeedTimeGranularityValue).Default,
        sessionStorageKey: (0, $1UApO.keys).HOME_POPULAR_FEED_TIME_GRANULARITY,
        // Skip vanilla V1 when ANOTHER query is going to fire for this user.
        // Otherwise vanilla V1 is the safe fallback that must always run.
        //
        // The V2 experiment in Statsig (`confluence_ai_snippets_popular_feed`)
        // uses an `isEnabled` boolean param. All branch checks use
        // `('isEnabled', true)` to detect the V2-treatment arm.
        //
        // V1-with-snippets fires when: in_following_popular_feeds isEnabled=true
        //                              AND NOT V2-treatment
        // V2 fires when:               popular_feed isEnabled=true AND isRovoLLMEnabled
        //
        // Note: we re-call the gate functions inline (rather than caching
        // into a local) so the `confluence-feature-gating/inline-usage`
        // lint rule (which requires gate calls at every callsite for
        // static analysis) is satisfied. The gate runtime memoises results
        // so the duplicate calls are essentially free.
        //
        // Pre-conditions (`renderPopularFeed`, `isRovoLLMEnabled`) are kept
        // at the START of each sub-expression so the gate call is the LAST
        // term, satisfying `confluence-feature-gating/no-preconditioning`.
        skipQuery: !renderPopularFeed || // V1-with-snippets serves the user when its gate is on AND they
        // are NOT in the V2-treatment arm. We compute that as:
        //   in_following_popular_feeds=true
        //   AND popular_feed isEnabled != true
        // To keep each gate call at the END of its sub-expression, we
        // short-circuit on the V2-treatment check first via a "not".
        !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_popular_feed', 'isEnabled', true) && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true) || // V2 serves the user when they are Rovo-enabled AND in the
        // V2-treatment arm. Rovo pre-condition goes first; gate last.
        isRovoLLMEnabled && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_popular_feed', 'isEnabled', true)
    }, {
        query: $0305a9034492a0e3$export$8f658981599c0d01,
        variables: (timeGranularity)=>({
                timeGranularity: timeGranularity
            })
    });
    const { value: valueWithSnippets, setValue: setValueWithSnippets, query: queryWithSnippets } = (0, $2rlHJ.useFeedDropdownStorage)({
        defaultValue: (0, $kLaAt.PopularFeedTimeGranularityValue).Default,
        sessionStorageKey: (0, $1UApO.keys).HOME_POPULAR_FEED_TIME_GRANULARITY,
        skipQuery: !renderPopularFeed || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true) || // Skip V1-with-snippets when the V2 experiment treatment arm is on,
        // regardless of Rovo. Two cases:
        //   1. Rovo-enabled V2-treatment users → served by V2 (no V1).
        //   2. Non-Rovo V2-treatment users → vanilla V1 takes over (it has
        //      no snippet field selections, so a tighter query).
        // Either way, V1-with-snippets is redundant for V2-treatment users.
        (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_popular_feed', 'isEnabled', true),
        interopApolloAggClient: true
    }, {
        query: (0, $hO347.PopularFeedWithTimeGranularityStorageSnippetsQuery),
        variables: (timeGranularity)=>({
                timeGranularity: timeGranularity,
                isRovoLLMEnabled: (0, $6mKj3.expVal)('confluence_ai_snippets_popular_feed_for_ai_enabled', 'isEnabled', false) ? isRovoLLMEnabled : true
            })
    });
    // V2 path: uses aiProperty directly on PopularFeedItem (parallel with Confluence hop).
    // Active when confluence_ai_snippets_popular_feed experiment gate is ON
    // AND the user has Rovo LLM enabled.
    // Blocked by: S4 (graphql-central-schema) + S5 (cc-graphql) must be deployed first.
    //
    // EXPOSURE TIMING (important):
    // We MUST gate this experiment's exposure by Rovo LLM enablement BEFORE
    // firing exposure. AI snippets only render for Rovo-enabled users — without
    // Rovo, no snippet is shown and the treatment effect cannot manifest.
    // Exposing non-Rovo users would dilute both arms and produce SRM /
    // exposure imbalance (the same failure mode that hit the
    // `confluence_ai_snippets_in_following_popular_feeds` experiment).
    //
    // We also use `expValEquals` (not `UNSAFE_expValEqualsNoExposure`) inside
    // `skipQuery` so the exposure fires at query-fire time — the actual point
    // of decision. Pairing this with a `renderPopularFeed && isRovoLLMEnabled`
    // pre-gate ensures only the intended user subset (Rovo-enabled users) is
    // ever exposed.
    //
    // What runs when Rovo is NOT enabled (regardless of V2-treatment state):
    //   - V1 vanilla query (no AI snippets at all), or
    //   - V1-with-snippets (if its gate is on; but @include strips aiProperty)
    // Either way, non-Rovo users never see a snippet and are never exposed to
    // the V2 experiment.
    const { value: valueWithSnippetsV2, setValue: setValueWithSnippetsV2, query: queryWithSnippetsV2 } = (0, $2rlHJ.useFeedDropdownStorage)({
        defaultValue: (0, $kLaAt.PopularFeedTimeGranularityValue).Default,
        sessionStorageKey: (0, $1UApO.keys).HOME_POPULAR_FEED_TIME_GRANULARITY,
        skipQuery: !renderPopularFeed || !isRovoLLMEnabled || !(0, $6mKj3.expValEquals)('confluence_ai_snippets_popular_feed', 'isEnabled', true),
        // Use the AGG (interop) client like V1-with-snippets — V2 also goes through AGG.
        interopApolloAggClient: true
    }, {
        query: (0, $afN8s.PopularFeedWithTimeGranularityStorageSnippetsV2Query),
        variables: (timeGranularity)=>({
                timeGranularity: timeGranularity,
                // The V2 `skipQuery` above already gates on `!isRovoLLMEnabled`,
                // so this variables function is only ever invoked when Rovo LLM
                // is enabled. Pass `true` unconditionally — avoids dead-code
                // branching and prevents a spurious exposure of
                // `confluence_ai_snippets_popular_feed_for_ai_enabled` from
                // firing on every V2 query. This mirrors how `preloadFeed.ts`
                // already handles this (also passes `true` unconditionally in
                // the V2 branch).
                isRovoLLMEnabled: true
            })
    });
    // V2 (parallel hydration) is only taken when the user is explicitly assigned
    // to the V2-treatment arm. When the experiment is not yet created in
    // Statsig, the user is not enrolled, or the experiment client cannot reach
    // Statsig, expValEquals returns false → V1 (legacy sequential) is the safe
    // fallback. Note: experiment calls are inlined at every callsite to satisfy
    // the `confluence-feature-gating/inline-usage` rule, which requires gates
    // to be statically analyzable.
    // Pre-select V1 vs V1-with-snippets to avoid nested ternaries below.
    // Picks V1-with-snippets only when its gate is on AND we're not in the V2
    // arm (where V1-with-snippets is suppressed in favour of vanilla V1).
    // This mirrors the V1-with-snippets `skipQuery` logic above and ensures
    // non-Rovo V2-treatment users (who fall back to vanilla V1) read from the
    // query that actually fires for them.
    const useV1WithSnippets = (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true) && !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_popular_feed', 'isEnabled', true);
    const v1Granularity = useV1WithSnippets ? valueWithSnippets : value;
    const v1Setter = useV1WithSnippets ? setValueWithSnippets : setValue;
    const v1Query = useV1WithSnippets ? queryWithSnippets : query;
    // Exposure for `confluence_ai_snippets_popular_feed` is fired exactly once,
    // at V2 query-fire time inside the V2 `skipQuery` above (via `expValEquals`).
    // All subsequent checks here use `UNSAFE_expValEqualsNoExposure` so we don't
    // log duplicate exposures on every render. This matches the "single point of
    // decision" requirement to avoid SRM / exposure imbalance.
    const isV2Active = isRovoLLMEnabled && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_popular_feed', 'isEnabled', true);
    return {
        popularFeedTimeGranularity: isV2Active ? valueWithSnippetsV2 : v1Granularity,
        setPopularFeedTimeGranularity: isV2Active ? setValueWithSnippetsV2 : v1Setter,
        // Cast required: V2 query has a structurally compatible shape (the
        // `aiProperty` field is additive on PopularFeedItem) but TS can't infer
        // the union assignability for legacy callers that expect the V1 type.
        // Safe at runtime because PopularFeedCard reads only `content`/`id`.
        popularFeedQuery: isV2Active ? queryWithSnippetsV2 : v1Query
    };
};
module.exports["usePopularFeedWithTimeGranularityStorage"] = $0305a9034492a0e3$export$e2ce202e4769830c;

});

parcelRegister("5amEx", function(module, exports) {
/**
 * @generated SignedSource<<16a71ce035eebac5f7f89da8cfff5eb1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a2f312e63a5e94e2$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useHomeWidgetStateUserPreferencesFragment",
        "selections": [
            {
                "concreteType": "HomeWidget",
                "kind": "LinkedField",
                "name": "homeWidgets",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "state"
                    },
                    v0 /*: any*/ 
                ]
            },
            v0 /*: any*/ 
        ],
        "type": "UserPreferences"
    };
}();
$a2f312e63a5e94e2$var$node.hash = "0c62eafb1ea633f1257ca52f851d7e59";
var $a2f312e63a5e94e2$export$2e2bcd8739ae039 = $a2f312e63a5e94e2$var$node;
module.exports["default"] = $a2f312e63a5e94e2$export$2e2bcd8739ae039;

});

parcelRegister("lU1qY", function(module, exports) {
/**
 * @generated SignedSource<<850584403b269e5643d0fbda1aaf937c>>
 * @relayHash a5ed50647af6fea569a4ab5e15cf4bc1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bbaac5fcdb270257646cf6f81e98aeb8be228c55e4f34c33e0db24a5e84cb98a
const $53defb598c8d71bd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "state"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "id",
                                    "variableName": "id"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "state",
                                    "variableName": "state"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "homeWidget"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "HomeWidget",
                    "kind": "LinkedField",
                    "name": "homeWidgets",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "state"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHomeWidgetStateHomeWidgetsMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHomeWidgetStateHomeWidgetsMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a5ed50647af6fea569a4ab5e15cf4bc1",
            "id": "bbaac5fcdb270257646cf6f81e98aeb8be228c55e4f34c33e0db24a5e84cb98a",
            "metadata": {},
            "name": "useHomeWidgetStateHomeWidgetsMutation",
            "operationKind": "mutation",
            "text": "mutation useHomeWidgetStateHomeWidgetsMutation($id:ID!,$state:HomeWidgetState!){updateUserPreferences(userPreferences:{homeWidget:{id:$id,state:$state}}){homeWidgets{id,state}}}"
        }
    };
}();
$53defb598c8d71bd$var$node.hash = "5471258689abf3a3cbbbc72377571311";
var $53defb598c8d71bd$export$2e2bcd8739ae039 = $53defb598c8d71bd$var$node;
module.exports["default"] = $53defb598c8d71bd$export$2e2bcd8739ae039;

});

parcelRegister("jLqGt", function(module, exports) {
/**
 * @generated SignedSource<<71bd89e5eb46257ba4616989ff624258>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $32aa9732e4ed9d66$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useFeedTypeSelectorWriteFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "feedTab"
        }
    ],
    "type": "UserPreferences"
};
$32aa9732e4ed9d66$var$node.hash = "4d2d2b2e6fd75a844316ed9aca89be96";
var $32aa9732e4ed9d66$export$2e2bcd8739ae039 = $32aa9732e4ed9d66$var$node;
module.exports["default"] = $32aa9732e4ed9d66$export$2e2bcd8739ae039;

});

parcelRegister("9BHAW", function(module, exports) {
/**
 * @generated SignedSource<<a835ca4d7cc2e572ecc917489cd69a6d>>
 * @relayHash 1dea07045fdc805115ac232cb227baba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID deae66b71a25de9fe27a948c315bf1284489f18bdc8b2d162d225e511711fe78
const $545242dd4ac6b8fd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "feedTab"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "feedTab",
                            "variableName": "feedTab"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "feedTab"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeedTypeSelectorFeedTypeSelectorRefreshMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeedTypeSelectorFeedTypeSelectorRefreshMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1dea07045fdc805115ac232cb227baba",
            "id": "deae66b71a25de9fe27a948c315bf1284489f18bdc8b2d162d225e511711fe78",
            "metadata": {},
            "name": "useFeedTypeSelectorFeedTypeSelectorRefreshMutation",
            "operationKind": "mutation",
            "text": "mutation useFeedTypeSelectorFeedTypeSelectorRefreshMutation($feedTab:String!){updateUserPreferences(userPreferences:{feedTab:$feedTab}){feedTab}}"
        }
    };
}();
$545242dd4ac6b8fd$var$node.hash = "6a96de700fa7869ef1acedccaf8591a7";
var $545242dd4ac6b8fd$export$2e2bcd8739ae039 = $545242dd4ac6b8fd$var$node;
module.exports["default"] = $545242dd4ac6b8fd$export$2e2bcd8739ae039;

});

parcelRegister("9bkOo", function(module, exports) {
var $1c116a80351d70cc$export$a13b342a3f580b52 = /*#__PURE__*/ function(FeedType) {
    FeedType["DIRECT"] = "DIRECT";
    FeedType["FOLLOWING"] = "FOLLOWING";
    FeedType["POPULAR"] = "POPULAR";
    return FeedType;
}({});
module.exports["FeedType"] = $1c116a80351d70cc$export$a13b342a3f580b52;

});

parcelRegister("kGgWH", function(module, exports) {

var $Yc1IN = parcelRequire("Yc1IN");

const $2c92c921647a6942$export$b29ff2301d2c3d56 = (0, $Yc1IN.default);
module.exports["FollowingFeedWithSortByStorageSnippetsQuery"] = $2c92c921647a6942$export$b29ff2301d2c3d56;

});

parcelRegister("kLaAt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");


var $6xdDU = parcelRequire("6xdDU");


var $dpPtd = parcelRequire("dpPtd");


var $7Hi9s = parcelRequire("7Hi9s");


var $g5jMy = parcelRequire("g5jMy");


var $2Rith = parcelRequire("2Rith");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");


var $1UApO = parcelRequire("1UApO");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $95rLf = parcelRequire("95rLf");


var $4PPzL = parcelRequire("4PPzL");


var $7Sm4c = parcelRequire("7Sm4c");


var $dG9Mj = parcelRequire("dG9Mj");


var $bQm3c = parcelRequire("bQm3c");


var $kvJHJ = parcelRequire("kvJHJ");


var $kUDSV = parcelRequire("kUDSV");


var $fhzlo = parcelRequire("fhzlo");


var $cUsnC = parcelRequire("cUsnC");

var $1Itw6 = parcelRequire("1Itw6");


var $cjYUn = parcelRequire("cjYUn");


var $8cmRU = parcelRequire("8cmRU");


var $4yg2A = parcelRequire("4yg2A");

var $fJ5kL = parcelRequire("fJ5kL");


var $d442j = parcelRequire("d442j");


var $28g78 = parcelRequire("28g78");


var $bxcP5 = parcelRequire("bxcP5");


var $6GgH7 = parcelRequire("6GgH7");


var $anKV5 = parcelRequire("anKV5");


var $4kEyG = parcelRequire("4kEyG");


var $lEClu = parcelRequire("lEClu");


var $a6XTh = parcelRequire("a6XTh");

const $1a7c1e3f737c78a8$var$i18n = (0, $aXWIB.defineMessages)({
    welcomeFeedLabel: {
        id: "feed.welcome-label",
        defaultMessage: "Welcome"
    },
    farewellFeedLabel: {
        id: "feed.farewell-label",
        defaultMessage: "Farewell"
    },
    whatsNewInConfluenceFeedLabel: {
        id: "feed.whatsNew-label",
        defaultMessage: "What\u2019s new in Confluence"
    }
});
var $1a7c1e3f737c78a8$export$f27524bff21c0156 = /*#__PURE__*/ function(PopularFeedTimeGranularityValue) {
    PopularFeedTimeGranularityValue["Day"] = "day";
    PopularFeedTimeGranularityValue["Default"] = "default";
    // default is 2 weeks. cc-analytics expects "default" as a parameter for 2 weeks
    PopularFeedTimeGranularityValue["Month"] = "month";
    PopularFeedTimeGranularityValue["Week"] = "week";
    PopularFeedTimeGranularityValue["Year"] = "year";
    return PopularFeedTimeGranularityValue;
}({});
var $1a7c1e3f737c78a8$export$eff547a168b0f0ed = /*#__PURE__*/ function(FollowingFeedSortByValue) {
    FollowingFeedSortByValue["Relevant"] = "relevant";
    FollowingFeedSortByValue["Recent"] = "chronological";
    return FollowingFeedSortByValue;
}({});
const $1a7c1e3f737c78a8$var$aiAnalyticsConfig = {
    product: 'confluence',
    subproduct: 'confluence',
    source: 'feed',
    aiFeatureName: 'aiSnippetsInFeeds',
    proactiveGeneratedAI: 0,
    userGeneratedAI: 0
};
const $1a7c1e3f737c78a8$var$FeedComponent = ({ renderPopularFeed: renderPopularFeed, customPanels: customPanels })=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const intl = (0, $aXWIB.useIntl)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { feedTypeOverride: feedTypeOverride, clearFeedTypeOverride: clearFeedTypeOverride } = (0, $fJ5kL.useFeedTypeOverride)();
    const loggedInFeedTypeSelector = (0, $fJ5kL.useFeedTypeSelector)();
    const anonymousFeedTypeSelector = (0, $fJ5kL.useAnonymousFeedTypeSelector)();
    const popularFeedPillRef = (0, $42omo.useRef)(null);
    const followingFeedPillRef = (0, $42omo.useRef)(null);
    const welcomeFeedPillRef = (0, $42omo.useRef)(null);
    const farewellFeedPillRef = (0, $42omo.useRef)(null);
    const handleFocusRef = (feedPillRef)=>{
        const feedPillRefButton = feedPillRef.current;
        if (feedPillRefButton) feedPillRefButton.focus();
    };
    const { loading: loadingPreferences, queryError: queryError, mutationError: mutationError, feedType: feedType, updateFeedType: updateFeedType, hasSelectedFeedTypePreference: hasSelectedFeedTypePreference } = isLoggedIn ? loggedInFeedTypeSelector : anonymousFeedTypeSelector;
    const filterOrOverride = feedTypeOverride || feedType;
    const updateFeedTypeAndClearOverride = (0, $42omo.useCallback)((updatedFeedType)=>{
        clearFeedTypeOverride();
        updateFeedType(updatedFeedType);
    }, [
        updateFeedType,
        clearFeedTypeOverride
    ]);
    const handleFeedSelectorChange = (0, $42omo.useCallback)((updatedFeedType)=>{
        experienceTracker.start({
            name: (0, $irVI7.FEED_EXPERIENCE),
            attributes: {
                feedTypeChange: true
            }
        });
        updateFeedTypeAndClearOverride(updatedFeedType);
    }, [
        experienceTracker,
        updateFeedTypeAndClearOverride
    ]);
    const { followingFeedSortBy: followingFeedSortBy, setFollowingFeedSortBy: setFollowingFeedSortBy, followingFeedQuery: feedContentQuery } = (0, $lEClu.useFollowingFeedWithSortByStorage)();
    const hasFollowedAnyone = (feedContentQuery?.data?.getFeedUserConfig?.users?.length || 0) > 0 || (feedContentQuery?.data?.getFeedUserConfig?.spaces?.length || 0) > 0;
    if (feedContentQuery?.error) {
        if ((0, $95rLf.isExpectedApolloError)(feedContentQuery.error)) (0, $7Sm4c.markErrorAsHandled)(feedContentQuery.error);
    }
    const refetchFeedContentQuery = feedContentQuery.refetch;
    const handleActivityFilterModalSave = (0, $42omo.useCallback)(()=>{
        refetchFeedContentQuery?.({
            sortBy: followingFeedSortBy
        });
        handleFeedSelectorChange((0, $4yg2A.FeedType).FOLLOWING);
    }, [
        refetchFeedContentQuery,
        followingFeedSortBy,
        handleFeedSelectorChange
    ]);
    const handleFollowingFeedSortByDropdownChange = (0, $42omo.useCallback)((sortBy)=>{
        setFollowingFeedSortBy(sortBy);
        refetchFeedContentQuery?.({
            sortBy: sortBy
        });
    }, [
        refetchFeedContentQuery,
        setFollowingFeedSortBy
    ]);
    const { popularFeedTimeGranularity: popularFeedTimeGranularity, setPopularFeedTimeGranularity: setPopularFeedTimeGranularity, popularFeedQuery: popularFeedQuery } = (0, $a6XTh.usePopularFeedWithTimeGranularityStorage)(renderPopularFeed);
    const refetchPopularFeedQuery = popularFeedQuery.refetch;
    const handlePopularFeedTimeGranularityDropdownChange = (0, $42omo.useCallback)((timeGranularity)=>{
        setPopularFeedTimeGranularity(timeGranularity);
        refetchPopularFeedQuery?.({
            timeGranularity: timeGranularity
        });
    }, [
        refetchPopularFeedQuery,
        setPopularFeedTimeGranularity
    ]);
    (0, $cjYUn.useFeedRenderedTrackEvent)(filterOrOverride, feedContentQuery.data, popularFeedQuery.data);
    const followFeedSessionId = (0, $anKV5.useFeedSession)(feedContentQuery, (0, $1UApO.keys).HOME_FOLLOWING_FEED_SESSION_ID);
    const followingFeedContext = (0, $42omo.useMemo)(()=>{
        return {
            feedSessionId: followFeedSessionId
        };
    }, [
        followFeedSessionId
    ]);
    const popularFeedSessionId = (0, $anKV5.useFeedSession)(popularFeedQuery, (0, $1UApO.keys).HOME_POPULAR_FEED_SESSION_ID);
    const popularFeedContext = (0, $42omo.useMemo)(()=>{
        return {
            feedSessionId: popularFeedSessionId
        };
    }, [
        popularFeedSessionId
    ]);
    const { activityFilterModalOpen: activityFilterModalOpen, openActivityFilterModal: openActivityFilterModal, closeActivityFilterModal: closeActivityFilterModal } = (0, $8cmRU.useActivityFilterModalState)();
    const welcomeAndFarewellPanels = [
        {
            title: intl.formatMessage($1a7c1e3f737c78a8$var$i18n.welcomeFeedLabel),
            key: 'confluence.home.welcome',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Hi9s))),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kEyG.FilterByLabelFeed), {
                handleFocusRef: ()=>handleFocusRef(welcomeFeedPillRef),
                filterByLabel: "welcome-blog"
            }),
            ref: welcomeFeedPillRef
        },
        {
            title: intl.formatMessage($1a7c1e3f737c78a8$var$i18n.farewellFeedLabel),
            key: 'confluence.home.farewell',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5jMy))),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kEyG.FilterByLabelFeed), {
                handleFocusRef: ()=>handleFocusRef(farewellFeedPillRef),
                filterByLabel: "farewell-blog"
            }),
            ref: farewellFeedPillRef
        }
    ];
    const updatedPanels = [
        ...(0, $9wGTI.fg)('confluence_welcome_farewell_feed') || (0, $1xpoY.default).getBoolean('confluence-welcome-farewell-feed-internal', false) ? welcomeAndFarewellPanels : [],
        ...customPanels || []
    ];
    const renderPanel = (panel)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            role: "tabpanel",
            id: `tabpanel-${panel.key}`,
            "aria-labelledby": `tab-${panel.key}`,
            tabIndex: 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, panel.content), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess //if we render an external panel we'll consider it a success, as the data is fetched externally
        ), {
            name: (0, $irVI7.FEED_EXPERIENCE),
            key: panel.key,
            attributes: {
                feedType: panel.key
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            metric: (0, $bxcP5.HOME_OVERVIEW_FEED_PAGE_SEGMENT)
        }));
    };
    if (loadingPreferences) return null;
    const shouldRenderWithoutWrapper = (panelKey)=>{
        const panels = [
            'confluence.home.welcome',
            'confluence.home.farewell'
        ];
        return panels.includes(panelKey);
    };
    const renderFeedCards = ()=>{
        if (updatedPanels && !!updatedPanels.length && !Object.values((0, $4yg2A.FeedType)).includes(filterOrOverride) // ensures the custom panel isn't just one of the expected panels
        ) {
            const panel = updatedPanels.find((element)=>element.key === filterOrOverride);
            if (panel?.content) return shouldRenderWithoutWrapper(panel?.key) ? renderPanel(panel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $28g78.SimpleWrapper), {
                role: "none"
            }, renderPanel(panel));
        }
        if (!hasSelectedFeedTypePreference) {
            if (feedContentQuery?.data?.feed?.nodes.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GgH7.FeedContext).Provider, {
                value: followingFeedContext
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cUsnC.ActivityFeedCards), {
                feedContentQuery: feedContentQuery,
                openActivityFilterModal: openActivityFilterModal,
                handleFocusRef: ()=>handleFocusRef(followingFeedPillRef),
                followingFeedSortBy: followingFeedSortBy,
                hasFollowedAnyone: hasFollowedAnyone
            }));
            else if (popularFeedQuery?.data?.popularFeed?.nodes.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GgH7.FeedContext).Provider, {
                value: popularFeedContext
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Itw6.PopularFeedCards), {
                popularFeedQuery: popularFeedQuery,
                handleFocusRef: ()=>handleFocusRef(popularFeedPillRef),
                popularFeedTimeGranularity: popularFeedTimeGranularity
            }));
        }
        if (filterOrOverride === (0, $4yg2A.FeedType).POPULAR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GgH7.FeedContext).Provider, {
            value: popularFeedContext
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Itw6.PopularFeedCards), {
            popularFeedQuery: popularFeedQuery,
            handleFocusRef: ()=>handleFocusRef(popularFeedPillRef),
            popularFeedTimeGranularity: popularFeedTimeGranularity
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GgH7.FeedContext).Provider, {
            value: followingFeedContext
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cUsnC.ActivityFeedCards), {
            feedContentQuery: feedContentQuery,
            openActivityFilterModal: openActivityFilterModal,
            handleFocusRef: ()=>handleFocusRef(followingFeedPillRef),
            followingFeedSortBy: followingFeedSortBy,
            hasFollowedAnyone: hasFollowedAnyone
        }));
    };
    const isFollowingOrPopularFeed = filterOrOverride === (0, $4yg2A.FeedType).FOLLOWING || filterOrOverride === (0, $4yg2A.FeedType).POPULAR;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Rith.AIEventsInstrumentationProvider), {
        config: $1a7c1e3f737c78a8$var$aiAnalyticsConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "activity-feed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kUDSV.FeedHeader), {
        openActivityFilterModal: openActivityFilterModal,
        renderPopularFeed: renderPopularFeed,
        feedType: filterOrOverride,
        setFeedType: handleFeedSelectorChange,
        customPanels: updatedPanels,
        popularFeedPillRef: popularFeedPillRef,
        followingFeedPillRef: followingFeedPillRef,
        popularFeedTimeGranularity: popularFeedTimeGranularity,
        handlePopularFeedTimeGranularityDropdownChange: handlePopularFeedTimeGranularityDropdownChange,
        followingFeedSortBy: followingFeedSortBy,
        handleFollowingFeedSortByDropdownChange: handleFollowingFeedSortByDropdownChange,
        hasFollowedAnyone: hasFollowedAnyone
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, isFollowingOrPopularFeed && (0, $6mKj3.expValEquals)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fhzlo.FeedSnippetsFeedbackComponent), null) : null, renderFeedCards(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, activityFilterModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dG9Mj.ActivityFilterDialog), {
        onChanged: handleActivityFilterModalSave,
        onClose: closeActivityFilterModal
    })), queryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: queryError
    }), mutationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: mutationError
    })))));
};
const $1a7c1e3f737c78a8$export$833919a382305440 = ({ renderPopularFeed: renderPopularFeed = false, customPanels: customPanels })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const failFeedExperience = (0, $42omo.useCallback)((error)=>{
        experienceTracker.fail({
            name: (0, $irVI7.FEED_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS,
        renderOnError: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d442j.GenericFeedError), null),
        onError: failFeedExperience
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1a7c1e3f737c78a8$var$FeedComponent, {
        renderPopularFeed: renderPopularFeed,
        customPanels: customPanels
    })));
};
module.exports["PopularFeedTimeGranularityValue"] = $1a7c1e3f737c78a8$export$f27524bff21c0156;
module.exports["FollowingFeedSortByValue"] = $1a7c1e3f737c78a8$export$eff547a168b0f0ed;
module.exports["Feed"] = $1a7c1e3f737c78a8$export$833919a382305440;

});

parcelRegister("2rlHJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5T18X = parcelRequire("5T18X");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $17wUi = parcelRequire("17wUi");


var $jMyy4 = parcelRequire("jMyy4");

function $0f4198ebf1ecfafa$export$8976bb5184850728(config, queryConfig) {
    const { defaultValue: defaultValue, sessionStorageKey: sessionStorageKey, skipQuery: skipQuery, interopApolloAggClient: interopApolloAggClient } = config;
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = window.__SSR_RENDERED__;
    // Initialize state with session storage or default
    const [value, setValue] = (0, $42omo.useState)(()=>{
        if (!isSSR) {
            const sessionValue = (0, $17wUi.confluenceSessionStorageInstance).getItem(sessionStorageKey);
            if (sessionValue && sessionValue !== defaultValue && (0, $6mKj3.expValEquals)('confluence_feeds_sorting_retention_experiment', 'cohort', 'test')) return sessionValue;
        }
        return defaultValue;
    });
    const isFollowingFeed = defaultValue === 'relevant';
    const popularFeedInitialPageSize = (0, $9wGTI.fg)('confluence_ai_feeds_home_banner') ? 10 : (0, $6mKj3.expVal)('confluence_home_feed_initial_page_size', 'popular_spa', 5);
    const initialPageSize = isFollowingFeed ? (0, $6mKj3.expVal)('confluence_home_feed_initial_page_size', 'following_spa', 5) : popularFeedInitialPageSize;
    const query = (0, $jMyy4.useQueryInterop)(queryConfig.query, {
        variables: {
            first: initialPageSize,
            ...queryConfig.variables(value)
        },
        context: {
            single: true
        },
        errorPolicy: 'all',
        notifyOnNetworkStatusChange: true,
        skip: skipQuery,
        interopApolloAggClient: interopApolloAggClient,
        __callerPackage__: "@confluence/feed"
    });
    (0, $42omo.useEffect)(()=>{
        // If refetching, reset to default and update session storage, else set the value
        const valueToSet = query.networkStatus === (0, $5T18X.NetworkStatus).loading || query.networkStatus === (0, $5T18X.NetworkStatus).refetch ? defaultValue : value;
        setValue(valueToSet);
        (0, $17wUi.confluenceSessionStorageInstance).setItem(sessionStorageKey, valueToSet);
    }, [
        query.networkStatus,
        value,
        defaultValue,
        sessionStorageKey
    ]);
    return {
        value: value,
        setValue: setValue,
        query: query
    };
}
module.exports["useFeedDropdownStorage"] = $0f4198ebf1ecfafa$export$8976bb5184850728;

});

parcelRegister("hO347", function(module, exports) {

var $gFJ3I = parcelRequire("gFJ3I");

const $658263d81c77b3a1$export$18199a7682e8a01b = (0, $gFJ3I.default);
module.exports["PopularFeedWithTimeGranularityStorageSnippetsQuery"] = $658263d81c77b3a1$export$18199a7682e8a01b;

});

parcelRegister("afN8s", function(module, exports) {

var $d7td2 = parcelRequire("d7td2");

const $6db752ccb866e30d$export$f978d54afe83bffb = (0, $d7td2.default);
module.exports["PopularFeedWithTimeGranularityStorageSnippetsV2Query"] = $6db752ccb866e30d$export$f978d54afe83bffb;

});

parcelRegister("dG9Mj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $213605160dd82c06$export$1cba263d7c89b8bd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LLSlx",
    name: "ActivityFilterDialog",
    loader: async ()=>(await (parcelRequire("2HrIG"))).ActivityFilterDialog
});
module.exports["ActivityFilterDialog"] = $213605160dd82c06$export$1cba263d7c89b8bd;

});

parcelRegister("kUDSV", function(module, exports) {
/* FeedHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $4KS7f = parcelRequire("4KS7f");


var $ccHMk = parcelRequire("ccHMk");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $cO1el = parcelRequire("cO1el");


var $5izcQ = parcelRequire("5izcQ");


var $bedQP = parcelRequire("bedQP");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $215Eu = parcelRequire("215Eu");


var $4yg2A = parcelRequire("4yg2A");


var $kLaAt = parcelRequire("kLaAt");

const $3cd87315866bd329$var$RemovedSpotlightTarget = (0, $bedQP.componentWithFG)('remove_unused_spotlight_targets', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children), ({ name: name, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: name
    }, children));
const $3cd87315866bd329$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    feedTitle: {
        id: "feed.title",
        defaultMessage: "Discover what\u2019s happening"
    },
    manageFeed: {
        id: "feed.header.manage.following",
        defaultMessage: "Edit feed"
    },
    sortByRelevant: {
        id: "feed.header.sortBy.following.relevant",
        defaultMessage: "Sort by: Most relevant"
    },
    sortByRecent: {
        id: "feed.header.sortBy.following.recent",
        defaultMessage: "Sort by: Last activity"
    },
    day: {
        id: "feed.popular.day",
        defaultMessage: "Today"
    },
    week: {
        id: "feed.popular.week",
        defaultMessage: "Past 7 days"
    },
    twoWeeks: {
        id: "feed.popular.twoWeeks",
        defaultMessage: "Past 14 days"
    },
    month: {
        id: "feed.popular.month",
        defaultMessage: "Past 30 days"
    },
    year: {
        id: "feed.popular.year",
        defaultMessage: "Past year"
    },
    popularDay: {
        id: "feed.popular.dropdown.prefix.day",
        defaultMessage: "Popular: Today"
    },
    popularWeek: {
        id: "feed.popular.dropdown.prefix.week",
        defaultMessage: "Popular: Past 7 days"
    },
    popularTwoWeeks: {
        id: "feed.popular.dropdown.prefix.twoWeeks",
        defaultMessage: "Popular: Past 14 days"
    },
    popularMonth: {
        id: "feed.popular.dropdown.prefix.month",
        defaultMessage: "Popular: Past 30 days"
    },
    popularYear: {
        id: "feed.popular.dropdown.prefix.year",
        defaultMessage: "Popular: Past year"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cd87315866bd329$var$FeedTitleAndActions = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm _1bah1yb4 _1e0c1txw _1n261g80 _otyrpxbi _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cd87315866bd329$var$SelectorAndActions = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1yb4 _o5721q9c _19pku2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cd87315866bd329$var$FeedTitleHeader = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o _1bah1yb4 _4t3ixy5q",
            __cmplp.className
        ])
    });
});
const $3cd87315866bd329$var$SpotlightContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41b66 _kqswstnw _154iidpf _1ltvr5cr _4t3i1osq _1bsb1osq _lcxvglyw",
            __cmplp.className
        ])
    });
});
const $3cd87315866bd329$var$linkButtonTheme = (currentTheme, themeProps)=>{
    const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            fontWeight: "var(--ds-font-weight-regular, 400)"
        },
        spinnerStyles: spinnerStyles
    };
};
var $3cd87315866bd329$var$FeedHeaderDropdownType = /*#__PURE__*/ function(FeedHeaderDropdownType) {
    FeedHeaderDropdownType["FOLLOWING_FEED_SORT_BY"] = "followingSortBy";
    FeedHeaderDropdownType["POPULAR_FEED_TIME_GRANULARITY"] = "popularTimeGranularity";
    return FeedHeaderDropdownType;
}($3cd87315866bd329$var$FeedHeaderDropdownType || {});
const $3cd87315866bd329$export$691a0baee9d17455 = ({ openActivityFilterModal: openActivityFilterModal, renderPopularFeed: renderPopularFeed, feedType: feedType, setFeedType: setFeedType, customPanels: customPanels, popularFeedPillRef: popularFeedPillRef, followingFeedPillRef: followingFeedPillRef, popularFeedTimeGranularity: popularFeedTimeGranularity, handlePopularFeedTimeGranularityDropdownChange: handlePopularFeedTimeGranularityDropdownChange, followingFeedSortBy: followingFeedSortBy, handleFollowingFeedSortByDropdownChange: handleFollowingFeedSortByDropdownChange, hasFollowedAnyone: hasFollowedAnyone, hasResults: hasResults = true })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const handleManageButtonClick = (0, $42omo.useCallback)(()=>{
        openActivityFilterModal();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'item',
                actionSubjectId: 'editFeed',
                source: 'homeScreen'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        openActivityFilterModal
    ]);
    const getPopularFeedTimeGranularityDropDownText = ()=>{
        switch(popularFeedTimeGranularity){
            case (0, $kLaAt.PopularFeedTimeGranularityValue).Day:
                return formatMessage($3cd87315866bd329$export$a7357cdd1f0b0168.popularDay);
            case (0, $kLaAt.PopularFeedTimeGranularityValue).Week:
                return formatMessage($3cd87315866bd329$export$a7357cdd1f0b0168.popularWeek);
            case (0, $kLaAt.PopularFeedTimeGranularityValue).Month:
                return formatMessage($3cd87315866bd329$export$a7357cdd1f0b0168.popularMonth);
            case (0, $kLaAt.PopularFeedTimeGranularityValue).Year:
                return formatMessage($3cd87315866bd329$export$a7357cdd1f0b0168.popularYear);
            default:
                return formatMessage($3cd87315866bd329$export$a7357cdd1f0b0168.popularTwoWeeks);
        }
    };
    const getFollowingFeedSortByDropDownText = ()=>{
        switch(followingFeedSortBy){
            case (0, $kLaAt.FollowingFeedSortByValue).Recent:
                return formatMessage($3cd87315866bd329$export$a7357cdd1f0b0168.sortByRecent);
            default:
                return formatMessage($3cd87315866bd329$export$a7357cdd1f0b0168.sortByRelevant);
        }
    };
    const handleDropdownChange = (0, $42omo.useCallback)((type, value)=>{
        // if the value is the same as the current value, do nothing
        if (type === "popularTimeGranularity" && value === popularFeedTimeGranularity || type === "followingSortBy" && value === followingFeedSortBy) return;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'item',
                actionSubjectId: type,
                source: 'homeScreen',
                attributes: {
                    [type === "popularTimeGranularity" ? 'timeGranularity' : 'sortBy']: value
                }
            }
        }).fire();
        if (type === "popularTimeGranularity") handlePopularFeedTimeGranularityDropdownChange(value);
        else handleFollowingFeedSortByDropdownChange(value);
    }, [
        handleFollowingFeedSortByDropdownChange,
        handlePopularFeedTimeGranularityDropdownChange,
        createAnalyticsEvent,
        followingFeedSortBy,
        popularFeedTimeGranularity
    ]);
    const handleDropdownOpenChange = (type, isOpen)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'toggled',
                actionSubject: 'dropdown',
                actionSubjectId: type,
                source: 'homeScreen',
                attributes: {
                    isOpen: isOpen
                }
            }
        }).fire();
    };
    const handlePopularFeedTimeGranularityDropdownOpenChange = (isOpen)=>{
        handleDropdownOpenChange("popularTimeGranularity", isOpen);
    };
    const handleFollowingFeedSortByDropdownOpenChange = (isOpen)=>{
        handleDropdownOpenChange("followingSortBy", isOpen);
    };
    const renderPopularFeedTimeGranularityDropdown = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            testId: "popular-feed-dropdown"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
            onOpenChange: (onOpenChangeAttributes)=>handlePopularFeedTimeGranularityDropdownOpenChange(onOpenChangeAttributes.isOpen),
            trigger: getPopularFeedTimeGranularityDropDownText(),
            shouldRenderToParent: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            isSelected: popularFeedTimeGranularity === (0, $kLaAt.PopularFeedTimeGranularityValue).Day,
            onClick: ()=>handleDropdownChange("popularTimeGranularity", (0, $kLaAt.PopularFeedTimeGranularityValue).Day)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3cd87315866bd329$export$a7357cdd1f0b0168.day)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            isSelected: popularFeedTimeGranularity === (0, $kLaAt.PopularFeedTimeGranularityValue).Week,
            onClick: ()=>handleDropdownChange("popularTimeGranularity", (0, $kLaAt.PopularFeedTimeGranularityValue).Week)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3cd87315866bd329$export$a7357cdd1f0b0168.week)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            isSelected: popularFeedTimeGranularity === (0, $kLaAt.PopularFeedTimeGranularityValue).Default,
            onClick: ()=>handleDropdownChange("popularTimeGranularity", (0, $kLaAt.PopularFeedTimeGranularityValue).Default)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3cd87315866bd329$export$a7357cdd1f0b0168.twoWeeks)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            isSelected: popularFeedTimeGranularity === (0, $kLaAt.PopularFeedTimeGranularityValue).Month,
            onClick: ()=>handleDropdownChange("popularTimeGranularity", (0, $kLaAt.PopularFeedTimeGranularityValue).Month)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3cd87315866bd329$export$a7357cdd1f0b0168.month)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            isSelected: popularFeedTimeGranularity === (0, $kLaAt.PopularFeedTimeGranularityValue).Year,
            onClick: ()=>handleDropdownChange("popularTimeGranularity", (0, $kLaAt.PopularFeedTimeGranularityValue).Year)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3cd87315866bd329$export$a7357cdd1f0b0168.year)))));
    };
    const renderActions = ()=>{
        if (feedType === (0, $4yg2A.FeedType).FOLLOWING && hasFollowedAnyone === false && !hasResults) return null;
        if (feedType === (0, $4yg2A.FeedType).POPULAR && !(0, $9wGTI.fg)('confluence_ai_feeds_home_banner')) return renderPopularFeedTimeGranularityDropdown();
        else if (feedType === (0, $4yg2A.FeedType).FOLLOWING && (0, $6mKj3.expValEquals)('cc_smarts_following_feed_dropdown_experiment', 'cohort', 'test')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
            onOpenChange: (onOpenChangeAttributes)=>handleFollowingFeedSortByDropdownOpenChange(onOpenChangeAttributes.isOpen),
            trigger: getFollowingFeedSortByDropDownText(),
            shouldRenderToParent: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            isSelected: followingFeedSortBy === (0, $kLaAt.FollowingFeedSortByValue).Relevant,
            onClick: ()=>handleDropdownChange("followingSortBy", (0, $kLaAt.FollowingFeedSortByValue).Relevant)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3cd87315866bd329$export$a7357cdd1f0b0168.sortByRelevant)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            isSelected: followingFeedSortBy === (0, $kLaAt.FollowingFeedSortByValue).Recent,
            onClick: ()=>handleDropdownChange("followingSortBy", (0, $kLaAt.FollowingFeedSortByValue).Recent)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3cd87315866bd329$export$a7357cdd1f0b0168.sortByRecent)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            onClick: handleManageButtonClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3cd87315866bd329$export$a7357cdd1f0b0168.manageFeed)));
        else if (feedType === (0, $4yg2A.FeedType).FOLLOWING) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
            theme: $3cd87315866bd329$var$linkButtonTheme,
            onClick: handleManageButtonClick,
            testId: "manage-feed-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3cd87315866bd329$export$a7357cdd1f0b0168.manageFeed));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3cd87315866bd329$var$FeedTitleAndActions, {
        "data-testid": "feed-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3cd87315866bd329$var$RemovedSpotlightTarget, {
        name: "home-activity"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3cd87315866bd329$var$SpotlightContainer, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3cd87315866bd329$var$FeedTitleHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall",
        as: "h2",
        id: "tablist-feedtypes"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3cd87315866bd329$export$a7357cdd1f0b0168.feedTitle)), renderActions()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3cd87315866bd329$var$SelectorAndActions, null, renderPopularFeed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $215Eu.FeedTypeSelector), {
        selectedFeedType: feedType,
        setSelectedFeedType: setFeedType,
        customPanels: customPanels,
        popularFeedPillRef: popularFeedPillRef,
        followingFeedPillRef: followingFeedPillRef
    })));
};
module.exports["FeedHeader"] = $3cd87315866bd329$export$691a0baee9d17455;

});

parcelRegister("fhzlo", function(module, exports) {
/* FeedSnippetsFeedbackComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $eXmBZ = parcelRequire("eXmBZ");


var $1Whri = parcelRequire("1Whri");


var $aXh2V = parcelRequire("aXh2V");

var $9Rf00 = parcelRequire("9Rf00");

const $bee7b2081924512d$var$AI_SNIPPETS_POPULAR_FOLLOWING_FEEDS_CONTENT_ID = 'bd3af97d-5e24-463c-a29a-6e23233bbe8a';
const $bee7b2081924512d$var$i18n = (0, $aXWIB.defineMessages)({
    aiDisclaimerText: {
        id: "feed.ai-disclaimer-text",
        defaultMessage: "Summaries use AI. Verify results."
    },
    statusInformationIconLabel: {
        id: "feed.status-information-icon-label",
        defaultMessage: "Summaries use AI. Verify results."
    }
});
const $bee7b2081924512d$var$aiDisclaimerStyles = {
    disclaimer: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _2hwx12x7",
    icon: "_2hwx12x7",
    container: "_ca0qu2gc _n3tdutpp _otyr1b66"
};
const $bee7b2081924512d$export$7114e2b0a1fb113e = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const disclaimerMessage = intl.formatMessage($bee7b2081924512d$var$i18n.aiDisclaimerText);
    const statusInformationIconLabel = intl.formatMessage($bee7b2081924512d$var$i18n.statusInformationIconLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Rf00.AIFeedbackPropertiesProvider), {
        entrypointId: $bee7b2081924512d$var$AI_SNIPPETS_POPULAR_FOLLOWING_FEEDS_CONTENT_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        xcss: (0, $1Whri.cx)($bee7b2081924512d$var$aiDisclaimerStyles.container)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        xcss: (0, $1Whri.cx)($bee7b2081924512d$var$aiDisclaimerStyles.disclaimer),
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($bee7b2081924512d$var$aiDisclaimerStyles.icon)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
        label: statusInformationIconLabel,
        size: "small",
        color: "var(--ds-text-subtlest, #6B6E76)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest"
    }, disclaimerMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXh2V.AIFeedbackComponent), {
        contentId: "ai-snippets-popular-following-feeds"
    })));
};
module.exports["FeedSnippetsFeedbackComponent"] = $bee7b2081924512d$export$7114e2b0a1fb113e;

});

parcelRegister("cUsnC", function(module, exports) {
/* ActivityFeedCards.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5T18X = parcelRequire("5T18X");


var $inPa6 = parcelRequire("inPa6");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $9hlns = parcelRequire("9hlns");


var $4KS7f = parcelRequire("4KS7f");


var $7yOcR = parcelRequire("7yOcR");


var $6mKj3 = parcelRequire("6mKj3");


var $4yg2A = parcelRequire("4yg2A");


var $YAWAX = parcelRequire("YAWAX");


var $8FX3K = parcelRequire("8FX3K");

var $lYst4 = parcelRequire("lYst4");


var $9yPX0 = parcelRequire("9yPX0");


var $gusOH = parcelRequire("gusOH");


var $28g78 = parcelRequire("28g78");


var $8BIV2 = parcelRequire("8BIV2");


var $6zZYs = parcelRequire("6zZYs");

const $6408708fd25031c0$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    allActivity: {
        id: "feed.fallback.message",
        defaultMessage: "To see personalized activity edit your feed by following people and spaces."
    },
    manageFeed: {
        id: "feed.fallback.manage.following",
        defaultMessage: "Edit feed"
    }
});
const $6408708fd25031c0$var$feedRecommendationsContainerStyle = null;
const $6408708fd25031c0$var$fallbackToAllActivityBannerWrapperStyle = null;
const $6408708fd25031c0$var$spinnerWrapperStyle = null;
const $6408708fd25031c0$export$3e88c5c2a61da20e = ({ feedContentQuery: feedContentQuery, openActivityFilterModal: openActivityFilterModal, handleFocusRef: handleFocusRef, followingFeedSortBy: followingFeedSortBy, hasFollowedAnyone: hasFollowedAnyone })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, loading: loading, error: error, networkStatus: networkStatus, fetchMore: fetchMore } = feedContentQuery;
    const [consecutiveOnboardingPulls, setConsecutiveOnboardingPulls] = (0, $42omo.useState)(0);
    const MAX_ONBOARDING_PULLS = 3;
    const shouldIncludeItem = (0, $42omo.useCallback)((item)=>{
        return item?.content?.contentProperties?.latest?.generatedBy !== 'ONBOARDING' || !(0, $6mKj3.expValEquals)('cc-activation-use-generated-by-exp-gate', 'cohort', 'test');
    }, []);
    const hasNextPage = data?.feed?.pageInfo?.hasNextPage && ((0, $6mKj3.expValEquals)('cc-activation-use-generated-by-exp-gate', 'cohort', 'test') ? consecutiveOnboardingPulls < MAX_ONBOARDING_PULLS : true);
    const endCursor = data?.feed?.pageInfo?.endCursor;
    const allResults = data?.feed?.nodes || [];
    const results = allResults.filter(shouldIncludeItem);
    const servingRecommendations = !!data?.getFeedUserConfig?.servingRecommendations;
    const { showFeedRecs: showFeedRecs, setShowFeedRecs: setShowFeedRecs, recsLoading: recsLoading, recs: recs, setRecs: setRecs, feedRecError: feedRecError } = (0, $lYst4.useFeedRecommendations)();
    const shouldHideComments = (0, $gusOH.useFeedShouldHideComments)();
    (0, $42omo.useEffect)(()=>{
        if (data && allResults.length > 0 && results.length === 0 && (0, $6mKj3.expValEquals)('cc-activation-use-generated-by-exp-gate', 'cohort', 'test')) setConsecutiveOnboardingPulls(1);
    }, [
        data,
        allResults.length,
        results.length
    ]);
    const linkButtonTheme = (currentTheme, themeProps)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                fontWeight: "var(--ds-font-weight-regular, 400)"
            },
            spinnerStyles: spinnerStyles
        };
    };
    const injectFeedSortByIntoCursor = (cursor, feedSortBy)=>{
        if (!feedSortBy) return cursor;
        const decodedCursor = atob(cursor);
        const parsedCursor = JSON.parse(decodedCursor);
        if (parsedCursor.feedSortOrder === feedSortBy.toUpperCase()) return cursor;
        return btoa(JSON.stringify({
            ...parsedCursor,
            feedSortOrder: feedSortBy.toUpperCase()
        }));
    };
    const loadNextPage = (0, $42omo.useCallback)(async ()=>{
        try {
            if (!endCursor) return undefined;
            const newResult = await fetchMore({
                variables: {
                    first: (0, $9yPX0.FETCH_MORE_PAGE_SIZE),
                    after: endCursor,
                    sortBy: followingFeedSortBy
                },
                updateQuery: (prevResults, { fetchMoreResult: fetchMoreResult })=>{
                    if (!fetchMoreResult) return prevResults;
                     // Deep clone required — a shallow spread shares node references with Apollo's
                    // InMemoryCache and corrupts the cache write on fetchMore.
                    const fetchMoreResultCopy = JSON.parse(JSON.stringify(fetchMoreResult));
                    const newNodes = fetchMoreResultCopy.feed?.nodes || [];
                    const filteredNewNodes = newNodes.filter(shouldIncludeItem);
                    if ((0, $6mKj3.expValEquals)('cc-activation-use-generated-by-exp-gate', 'cohort', 'test')) {
                        if (filteredNewNodes.length === 0 && newNodes.length > 0) setConsecutiveOnboardingPulls((prev)=>prev + 1);
                        else setConsecutiveOnboardingPulls(0);
                    }
                    if (fetchMoreResultCopy.feed?.nodes && prevResults.feed?.nodes) {
                        fetchMoreResultCopy.feed.nodes = prevResults.feed.nodes.concat(filteredNewNodes);
                        if (fetchMoreResultCopy.feed.pageInfo.endCursor) fetchMoreResultCopy.feed.pageInfo.endCursor = injectFeedSortByIntoCursor(fetchMoreResultCopy.feed.pageInfo.endCursor, followingFeedSortBy);
                        else fetchMoreResultCopy.feed.pageInfo.endCursor = prevResults.feed?.pageInfo?.endCursor ?? '';
                    }
                    return fetchMoreResultCopy;
                }
            });
            if (newResult.data) {
                const previousVisibleCount = (data?.feed.nodes || []).filter(shouldIncludeItem).length;
                const newVisibleCount = (newResult.data.feed?.nodes || []).filter(shouldIncludeItem).length;
                const visibleItemsAdded = newVisibleCount - previousVisibleCount;
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'paginated',
                        actionSubject: 'feed',
                        source: 'homeScreen',
                        attributes: {
                            resultCount: visibleItemsAdded
                        }
                    }
                }).fire();
            }
            if (newResult.errors) throw newResult.errors;
            return newResult;
        } catch (e) {
            throw e;
        }
    }, [
        endCursor,
        fetchMore,
        followingFeedSortBy,
        createAnalyticsEvent,
        data,
        setConsecutiveOnboardingPulls,
        shouldIncludeItem
    ]);
    const disableAnimation = Boolean(window.__SSR_RENDERED__ && networkStatus !== (0, $5T18X.NetworkStatus).fetchMore);
    const handleManageButtonClick = (0, $42omo.useCallback)(()=>{
        openActivityFilterModal();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'item',
                actionSubjectId: 'editFeed',
                source: 'homeScreen'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        openActivityFilterModal
    ]);
    const shouldFallbackBasedOnCursor = (cursor)=>{
        if (!cursor) return false;
        try {
            const decodedCursor = atob(cursor);
            const parsedCursor = JSON.parse(decodedCursor);
            return results.length > 0 ? parsedCursor.fallbackToAllActivity ?? false : false;
        } catch  {
            return false;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $YAWAX.FeedOnboardingMessage), {
        openActivityFilterModal: openActivityFilterModal,
        servingRecommendations: servingRecommendations
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8BIV2.FeedCardsWrapper), {
        loading: loading,
        firstPageError: error,
        networkStatus: networkStatus,
        endCursor: endCursor,
        hasNextPage: hasNextPage,
        loadNextPage: loadNextPage,
        openActivityFilterModal: openActivityFilterModal,
        feedType: (0, $4yg2A.FeedType).FOLLOWING,
        hasFollowedAnyone: hasFollowedAnyone
    }, shouldFallbackBasedOnCursor(endCursor) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "fallback-to-all-activity-banner",
        className: (0, $gMc0m.default)([
            "_11q79yqt _1yt4utpp _2rko1mok _1e0c1txw _4cvr1h6o _y3gn1e5h _otyrpxbi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yOcR))), {
        label: "",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-vc": "lTJE9ruK"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, intl.formatMessage($6408708fd25031c0$export$a7357cdd1f0b0168.allActivity))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        onClick: handleManageButtonClick,
        theme: linkButtonTheme,
        appearance: "link",
        spacing: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, intl.formatMessage($6408708fd25031c0$export$a7357cdd1f0b0168.manageFeed))))), results.map((result, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
            key: result.content?.id
        }, result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $28g78.FeedCard), {
            feedItem: result,
            ranking: index,
            disableAnimation: disableAnimation,
            shouldHideComments: shouldHideComments,
            followingFeedSortBy: followingFeedSortBy
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zZYs.ExitFeedAllyButton), {
            onExit: handleFocusRef,
            source: "following-feed",
            feedCardIndex: index
        }), index === 2 && showFeedRecs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_11q71j9a _1yt41pyq _1reo15vq _18m915vq _19itia51 _2rko1mok _kqswh2mm _n3tdpxbi _otyrpxbi _4t3idyal _1dbzt7xp"
            ])
        }, recsLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "large"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8FX3K.FeedRecommendations), {
            position: index + 1,
            setShowFeedRecs: setShowFeedRecs,
            recs: recs,
            setRecs: setRecs,
            feedRecError: feedRecError
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zZYs.ExitFeedAllyButton), {
            onExit: handleFocusRef,
            source: "following-feed",
            isAfterRecommendations: true
        })));
    })));
};
module.exports["ActivityFeedCards"] = $6408708fd25031c0$export$3e88c5c2a61da20e;

});

parcelRegister("1Itw6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5T18X = parcelRequire("5T18X");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");


var $4yg2A = parcelRequire("4yg2A");


var $9yPX0 = parcelRequire("9yPX0");


var $6wpcc = parcelRequire("6wpcc");


var $3xaH7 = parcelRequire("3xaH7");


var $8BIV2 = parcelRequire("8BIV2");


var $6zZYs = parcelRequire("6zZYs");

function $9a8dddbd019a8775$export$7bdb387412b5d100(results) {
    const deduplicatedResultsMap = new Map();
    const removedResultsMap = new Map();
    results.forEach((item, index)=>{
        const id = item?.content?.id;
        if (!id) return;
        if (deduplicatedResultsMap.has(id)) removedResultsMap.set(id, {
            index: index,
            id: id
        });
        else deduplicatedResultsMap.set(id, item);
    });
    return {
        deduplicatedResults: Array.from(deduplicatedResultsMap.values()),
        removedResults: Array.from(removedResultsMap.values())
    };
}
const $9a8dddbd019a8775$export$6551caf568a95d42 = ({ popularFeedQuery: popularFeedQuery, handleFocusRef: handleFocusRef, popularFeedTimeGranularity: popularFeedTimeGranularity })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, loading: loading, error: error, networkStatus: networkStatus, fetchMore: fetchMore } = popularFeedQuery;
    const hasNextPage = (0, $9wGTI.fg)('confluence_ai_feeds_home_banner') ? false : data?.popularFeed?.pageInfo?.hasNextPage;
    const endCursor = data?.popularFeed?.pageInfo?.endCursor;
    const shouldIncludeItem = (item)=>{
        if (item?.content?.labels?.nodes?.some((value)=>value?.name === 'farewell-blog' || value?.name === 'welcome-blog') && ((0, $9wGTI.fg)('confluence_welcome_farewell_feed') || (0, $1xpoY.default).getBoolean('confluence-welcome-farewell-feed-internal', false))) return false;
        if (item?.content?.contentProperties?.latest?.generatedBy === 'ONBOARDING' && (0, $6mKj3.expValEquals)('cc-activation-use-generated-by-exp-gate', 'cohort', 'test')) return false;
        return true;
    };
    const allResults = data?.popularFeed?.nodes || [];
    const results = allResults.filter(shouldIncludeItem);
    const { deduplicatedResults: deduplicatedResults, removedResults: removedResults } = $9a8dddbd019a8775$export$7bdb387412b5d100(results);
    // Build a stable Set of removed content IDs to use as a useEffect dependency
    // instead of JSON.stringify(removedResults), which serializes on every render.
    const removedResultIds = removedResults.map(({ id: id })=>id).join(',');
    const finalResults = (0, $9wGTI.fg)('confluence_ai_feeds_home_banner') ? deduplicatedResults.slice(0, 3) : deduplicatedResults;
    const loadNextPage = (0, $42omo.useCallback)(async ()=>{
        try {
            if (!endCursor) return undefined;
            const newResult = await fetchMore({
                variables: {
                    first: (0, $9yPX0.FETCH_MORE_PAGE_SIZE),
                    after: endCursor,
                    timeGranularity: popularFeedTimeGranularity
                },
                updateQuery: (prevResults, { fetchMoreResult: fetchMoreResult })=>{
                    if (!fetchMoreResult || !fetchMoreResult.popularFeed) return prevResults;
                    // Deep clone required — a shallow spread shares node references with Apollo's
                    // InMemoryCache and corrupts the cache write on fetchMore.
                    const fetchMoreResultCopy = JSON.parse(JSON.stringify(fetchMoreResult));
                    if (prevResults.popularFeed?.nodes) fetchMoreResultCopy.popularFeed.nodes = prevResults.popularFeed.nodes.concat(fetchMoreResultCopy.popularFeed.nodes);
                    return fetchMoreResultCopy;
                }
            });
            if (newResult.data) {
                const newVisibleCount = newResult.data?.popularFeed?.nodes.filter(shouldIncludeItem).length ?? 0;
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'paginated',
                        actionSubject: 'popularFeed',
                        source: 'homeScreen',
                        attributes: {
                            resultCount: newVisibleCount
                        }
                    }
                }).fire();
            }
            if (newResult.errors) throw newResult.errors;
            return newResult;
        } catch (e) {
            throw e;
        }
    }, [
        fetchMore,
        createAnalyticsEvent,
        endCursor,
        popularFeedTimeGranularity
    ]);
    (0, $42omo.useEffect)(()=>{
        removedResults.forEach(({ index: index, id: id })=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'rendered',
                    actionSubject: 'duplicate',
                    actionSubjectId: 'popularFeedCard',
                    source: 'homeScreen',
                    attributes: {
                        ranking: index,
                        contentId: id
                    }
                }
            }).fire();
        });
    // Only report when removed results change. We use a joined string of IDs
    // (removedResultIds) as a stable dependency instead of JSON.stringify(removedResults),
    // which would serialize the full array on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        removedResultIds
    ]);
    const disableAnimation = Boolean(window.__SSR_RENDERED__ && networkStatus !== (0, $5T18X.NetworkStatus).fetchMore);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8BIV2.FeedCardsWrapper), {
        loading: loading,
        firstPageError: error,
        networkStatus: networkStatus,
        endCursor: endCursor,
        hasNextPage: hasNextPage,
        loadNextPage: loadNextPage,
        feedType: (0, $4yg2A.FeedType).POPULAR,
        hasResults: finalResults.length > 0
    }, (0, $1xpoY.default).getBoolean('cc_mobile_app_promo_popular_feed_config', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wpcc.MobileAppPromo), null), finalResults.map((result, index)=>{
        return result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
            key: result.content.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3xaH7.PopularFeedCard), {
            feedItem: result,
            ranking: index,
            disableAnimation: disableAnimation,
            timeGranularity: popularFeedTimeGranularity
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zZYs.ExitFeedAllyButton), {
            onExit: handleFocusRef,
            source: "popular-feed",
            feedCardIndex: index
        }));
    }));
};
module.exports["PopularFeedCards"] = $9a8dddbd019a8775$export$6551caf568a95d42;

});

parcelRegister("cjYUn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $56QzY = parcelRequire("56QzY");


var $9bkOo = parcelRequire("9bkOo");

const $7958fdcfcd0693ed$export$fee5b5a066c6d977 = (feedType, followingFeedData, popularFeedData)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isFollowing = feedType === (0, $9bkOo.FeedType).FOLLOWING;
    const isPopular = feedType === (0, $9bkOo.FeedType).POPULAR;
    const hasData = isFollowing ? Boolean(followingFeedData) : Boolean(popularFeedData);
    const resultCount = (isFollowing ? followingFeedData?.feed?.nodes?.length : popularFeedData?.popularFeed?.nodes?.length) || 0;
    const spacesFollowing = isFollowing ? followingFeedData?.getFeedUserConfig?.spaces?.length || 0 : undefined;
    const peopleFollowing = isFollowing ? followingFeedData?.getFeedUserConfig?.users?.length || 0 : undefined;
    // should fire the "rendered" analytics event only once,
    // including when switching between feed types
    const renderedEventLastFeedTypeRef = (0, $42omo.useRef)('');
    const firedRenderedEvent = feedType === renderedEventLastFeedTypeRef.current;
    (0, $42omo.useEffect)(()=>{
        if (hasData && !firedRenderedEvent) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'homeScreen',
                    action: 'rendered',
                    actionSubject: 'feed',
                    actionSubjectId: 'feedAlpha',
                    attributes: {
                        feedType: feedType.toLowerCase(),
                        navdexPointType: (0, $56QzY.START_TOUCH),
                        homeVersion: 'visualRefresh',
                        ...isFollowing || isPopular ? {
                            resultCount: resultCount,
                            // TODO: The logic of this entire hook must be reworked so that the workaround below is no longer necessary.
                            // resultCount will only be 2 on SSR load, so there is no risk to this change (CCI-1817).
                            isSSR: resultCount === 2,
                            spacesFollowing: spacesFollowing,
                            peopleFollowing: peopleFollowing
                        } : {}
                    }
                }
            }).fire();
            renderedEventLastFeedTypeRef.current = feedType;
        }
    }, [
        hasData,
        feedType,
        resultCount,
        spacesFollowing,
        peopleFollowing,
        firedRenderedEvent,
        isFollowing,
        isPopular,
        createAnalyticsEvent
    ]);
};
module.exports["useFeedRenderedTrackEvent"] = $7958fdcfcd0693ed$export$fee5b5a066c6d977;

});

parcelRegister("8cmRU", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $7c187e9ac8c8c769$export$6bf07b55b4e954e1 = ()=>{
    const [activityFilterModalOpen, setActivityFilterModalOpen] = (0, $42omo.useState)(false);
    const openActivityFilterModal = (0, $42omo.useCallback)(()=>{
        setActivityFilterModalOpen(true);
    }, [
        setActivityFilterModalOpen
    ]);
    const closeActivityFilterModal = (0, $42omo.useCallback)(()=>{
        setActivityFilterModalOpen(false);
    }, [
        setActivityFilterModalOpen
    ]);
    return {
        activityFilterModalOpen: activityFilterModalOpen,
        openActivityFilterModal: openActivityFilterModal,
        closeActivityFilterModal: closeActivityFilterModal
    };
};
module.exports["useActivityFilterModalState"] = $7c187e9ac8c8c769$export$6bf07b55b4e954e1;

});

parcelRegister("d442j", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $abC4X = parcelRequire("abC4X");


var $eEA8O = parcelRequire("eEA8O");


var $eefUQ = parcelRequire("eefUQ");

const $777d195b4cddad40$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    errorHeader: {
        id: "feed.error.generic.header",
        defaultMessage: "We couldn\u2019t load the feed"
    },
    errorDescription: {
        id: "feed.error.generic.description",
        defaultMessage: "Refresh to try again."
    },
    buttonText: {
        id: "feed.error.generic.button.text",
        defaultMessage: "Refresh"
    }
});
const $777d195b4cddad40$var$GenericFeedErrorComponent = ({ intl: intl })=>{
    const handleRefreshPage = (0, $42omo.useCallback)(()=>{
        window.location.reload();
    }, []);
    const refreshButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        onClick: handleRefreshPage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $777d195b4cddad40$export$a7357cdd1f0b0168.buttonText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $abC4X.default), {
        header: intl.formatMessage($777d195b4cddad40$export$a7357cdd1f0b0168.errorHeader),
        description: intl.formatMessage($777d195b4cddad40$export$a7357cdd1f0b0168.errorDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($eefUQ))),
        imageHeight: 95,
        primaryAction: refreshButton
    });
};
const $777d195b4cddad40$export$cb06f6f9ccf65f65 = (0, $aXWIB.injectIntl)($777d195b4cddad40$var$GenericFeedErrorComponent);
module.exports["GenericFeedError"] = $777d195b4cddad40$export$cb06f6f9ccf65f65;

});

parcelRegister("28g78", function(module, exports) {
/* FeedCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $fs6LW = parcelRequire("fs6LW");


var $8rneB = parcelRequire("8rneB");


var $fgRQY = parcelRequire("fgRQY");


var $dYA5q = parcelRequire("dYA5q");


var $hXDOc = parcelRequire("hXDOc");


var $1RkMx = parcelRequire("1RkMx");


var $fYx4v = parcelRequire("fYx4v");

var $6OiEk = parcelRequire("6OiEk");


var $3WnxN = parcelRequire("3WnxN");


var $9HGVt = parcelRequire("9HGVt");


var $dKup5 = parcelRequire("dKup5");


var $fWjNm = parcelRequire("fWjNm");


var $cYSIK = parcelRequire("cYSIK");


var $gW7vR = parcelRequire("gW7vR");


var $hsR9s = parcelRequire("hsR9s");

const $61d33b405399253c$var$simpleWrapperStyle = null;
const $61d33b405399253c$export$a5a8a7b85f8f9317 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_11q7hp5a _19itia51 _2rko1mok _1yt4pxbi _1e0c1txw _2lx2vrvc _otyrutpp _59381r31 _yha28stv _1nmznqa1 _rfqo1r31 _1bgkglyw _1t0pnqa1 _9m7f1r31 _w7sw8stv _15a9nqa1 _9m3z1osq"
        ]),
        "data-vc": "6F2nLgEm"
    });
const $61d33b405399253c$var$wrapperStyle = null;
const $61d33b405399253c$var$wrapperExperimentPersistentStyles = null;
const $61d33b405399253c$var$actionMenuStyle = null;
const $61d33b405399253c$var$fadeIn = null;
const $61d33b405399253c$var$fadeInAnimation = null; // Note: this component extracts the props that we don't want to send to the DOM
const $61d33b405399253c$export$e6dfd72ab29f8598 = ({ isActionMenuOpen: isActionMenuOpen, disableAnimation: disableAnimation, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...rest,
        className: (0, $gMc0m.default)([
            "_11q7hp5a _19itia51 _2rko1mok _1yt4pxbi _kqswh2mm _1e0c1txw _2lx2vrvc _otyrutpp _14iyidpf _1dbzt7xp _1qamtlke _1pjhtlke _d0altlke _17zqt94y _km9nt94y _1soat94y _1bumglyw _sedtglyw",
            isActionMenuOpen && "_14iyt94y",
            !disableAnimation && "",
            !disableAnimation && "_y44v1r1a",
            (0, $6mKj3.expValEquals)('confluence_feed_card_icons_persistent', 'isEnabled', true) && "_14iyt94y _1qamtlke _1pjhtlke _d0altlke"
        ])
    });
const $61d33b405399253c$var$avatarWrapperStyle = null;
const $61d33b405399253c$var$contentWrapperStyle = null;
const $61d33b405399253c$var$summaryLineStyle = null;
const $61d33b405399253c$var$summaryLineRelevantActionStyle = null;
const $61d33b405399253c$var$summaryLineActionsStyle = null;
const $61d33b405399253c$var$spacerStyle = null;
const $61d33b405399253c$export$f7c7741d7ae5c510 = /*#__PURE__*/ (0, $42omo.memo)(({ feedItem: feedItem, ranking: ranking, disableAnimation: disableAnimation, shouldHideComments: shouldHideComments, followingFeedSortBy: followingFeedSortBy })=>{
    const isMounted = (0, $dKup5.useIsMounted)();
    const [, setHasBeenHovered] = (0, $42omo.useState)(false);
    const [isActionMenuOpen] = (0, $42omo.useState)(false);
    const bottomOfCardRef = (0, $42omo.useRef)(null);
    const mainUpdate = feedItem.summaryLineUpdate;
    const recentActionsCount = feedItem.recentActionsCount;
    const mainUpdateUserId = (0, $1RkMx.getUserAccountId)(mainUpdate.user);
    const updateType = mainUpdate?.type;
    const contentUrl = (0, $1RkMx.getContentLink)(feedItem.content);
    const updateTime = mainUpdate?.datetime;
    const contentId = feedItem?.content?.id || '';
    const updateLink = (0, $1RkMx.getLinkForSummaryLinkUpdate)(mainUpdate, contentUrl, contentId);
    const contentType = feedItem?.content?.type || 'page';
    const contentSubType = feedItem?.content?.subType;
    const contentTitle = feedItem?.content?.title || '';
    const contentExcerpt = feedItem.content?.excerpt;
    const aiSnippet = feedItem?.content?.aiProperty?.objectData;
    const authorName = feedItem?.content?.history?.createdBy?.displayName || '';
    const ownerName = feedItem?.content?.history?.ownedBy?.displayName || '';
    const spaceId = feedItem?.content?.space?.id || '';
    const spaceName = feedItem?.content?.space?.name || '';
    const emoji = (0, $8rneB.getEmojiValueFromContent)(feedItem.content);
    const numComments = feedItem?.content?.metadata?.comments?.commentsCount || 0;
    const spaceUrl = (0, $1RkMx.getSpaceLink)(feedItem.content);
    const authorId = (0, $1RkMx.getUserAccountId)(feedItem.content?.history?.createdBy) || '';
    const ownerId = (0, $1RkMx.getUserAccountId)(feedItem.content?.history?.ownedBy) || '';
    const hasNullComment = updateType === (0, $fWjNm.FeedEventType).COMMENT && mainUpdate.comment === null;
    const supportedEvent = (0, $1RkMx.isSupportedEvent)(feedItem.summaryLineUpdate.type);
    const isLivePage = contentType === 'page' && contentSubType === 'live';
    const hasAiSnippet = aiSnippet && (0, $6mKj3.expValEquals)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true);
    const summaryContent = hasAiSnippet ? aiSnippet : contentExcerpt;
    const sourceIds = feedItem.source.reduce((filtered, source)=>{
        if (source === (0, $fWjNm.FeedItemSourceType).PERSON && mainUpdateUserId) filtered.push(mainUpdateUserId);
        else if (source === (0, $fWjNm.FeedItemSourceType).SPACE && spaceId) filtered.push(spaceId);
        return filtered;
    }, []);
    const handleMouseEnter = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        setHasBeenHovered(true);
    }, [
        setHasBeenHovered
    ]);
    const fireAnalyticsEvent = (0, $9HGVt.useFeedCardAnalyticsEvents)(contentId, spaceId, 'following', {
        ranking: ranking,
        contentType: contentType,
        updateType: updateType,
        sourceIds: sourceIds,
        isFromSource: feedItem.source,
        recentActionsCount: recentActionsCount,
        commentsCount: numComments,
        lastUpdated: new Date(mainUpdate.datetime).getTime()
    });
    const onObserved = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent({
            type: 'sendTrackEvent',
            action: 'observed',
            actionSubject: 'feedCard'
        });
    }, [
        fireAnalyticsEvent
    ]);
    (0, $fgRQY.useElementSeenCallback)(bottomOfCardRef, onObserved);
    (0, $42omo.useEffect)(()=>{
        if (hasNullComment) fireAnalyticsEvent({
            type: 'sendOperationalEvent',
            action: 'hidden',
            actionSubject: 'nullCommentFeedCard'
        });
    }, [
        hasNullComment,
        fireAnalyticsEvent
    ]);
    const feedCardContextValue = (0, $42omo.useMemo)(()=>({
            fireAnalyticsEvent: fireAnalyticsEvent
        }), [
        fireAnalyticsEvent
    ]);
    if (hasNullComment || !supportedEvent) return null;
    const cardHref = shouldHideComments && updateType === (0, $fWjNm.FeedEventType).COMMENT ? updateLink : contentUrl;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cYSIK.FeedCardContext).Provider, {
        value: feedCardContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dYA5q.LivePagePreloader), {
        isLivePage: isLivePage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXDOc.HoverPreloader), {
        name: "feed-card",
        preloadUrl: cardHref,
        preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($61d33b405399253c$export$e6dfd72ab29f8598, {
        "data-testid": "feed-card",
        isActionMenuOpen: isActionMenuOpen,
        disableAnimation: isMounted || disableAnimation,
        onMouseEnter: handleMouseEnter,
        onFocus: handleMouseEnter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hsR9s.FeedCardInvisibleFullSizedLink), {
        href: cardHref,
        contentType: contentType,
        followingFeedSortBy: followingFeedSortBy,
        hasAiSnippet: !!hasAiSnippet
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_u5f3pxbi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: mainUpdateUserId,
        src: mainUpdate.user?.profilePicture?.path || '',
        canViewProfile: true,
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1ul9idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _otyrutpp"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1yt41b66 _18s8r5cr _1e0c1txw _2lx2vrvc _syazazsu _1bto1l2s _o5721q9c _4cvr1h6o _16jlkb7n _2hwx1b66"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fYx4v.ActivityLineUpdateLink), {
        type: updateType,
        userDisplayName: mainUpdate.user?.displayName || null,
        link: updateLink,
        groupSize: mainUpdate.groupSize,
        activityDropdownLineItem: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_18s8otz2"
        ])
    }, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3WnxN.ActionTime), {
        actionTime: updateTime
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_syazazsu _1e0c1txw _4cvr1h6o _1o9zidpf"
        ])
    }, (recentActionsCount > 1 || (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_analytics_use_topn_query_in_feed_experiment', 'cohort', 'test')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6OiEk.AllActivityDropdown), {
        contentUrl: contentUrl,
        contentId: contentId,
        recentActionsCount: recentActionsCount,
        shouldShowRecentActionsCountNumber: (0, $6mKj3.UNSAFE_expValNoExposure)('cc_analytics_use_topn_query_in_feed_experiment', 'cohort', 'control') === 'control'
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gW7vR.FeedCardBody), {
        contentId: contentId,
        emoji: emoji,
        contentTitle: contentTitle,
        contentType: contentType,
        contentSubType: contentSubType,
        contentUrl: contentUrl,
        spaceId: spaceId,
        spaceName: spaceName,
        spaceUrl: spaceUrl,
        authorName: authorName,
        authorId: authorId,
        ownerName: ownerName,
        ownerId: ownerId,
        contentExcerpt: summaryContent,
        numComments: numComments,
        comment: updateType === (0, $fWjNm.FeedEventType).COMMENT ? mainUpdate : undefined,
        source: "following-feed",
        shouldHideComments: shouldHideComments,
        followingFeedSortby: followingFeedSortBy,
        hasAiSnippet: !!hasAiSnippet
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: bottomOfCardRef
    }))))));
});
module.exports["SimpleWrapper"] = $61d33b405399253c$export$a5a8a7b85f8f9317;
module.exports["Wrapper"] = $61d33b405399253c$export$e6dfd72ab29f8598;
module.exports["FeedCard"] = $61d33b405399253c$export$f7c7741d7ae5c510;

});

parcelRegister("6GgH7", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $ef487b545dccb1a5$export$e75d2edbfa99b7d8 = (0, $42omo.createContext)({
    feedSessionId: null
});
module.exports["FeedContext"] = $ef487b545dccb1a5$export$e75d2edbfa99b7d8;

});

parcelRegister("anKV5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5T18X = parcelRequire("5T18X");


var $kyKWe = parcelRequire("kyKWe");


var $17wUi = parcelRequire("17wUi");

const $dd9b0509e0327438$export$f76be7c0556c5409 = (feedContentQuery, sessionStorageKey)=>{
    // Fetch the initial feed id from session storage or generate a new one
    const feedSessionIdInitial = feedContentQuery.data ? (0, $17wUi.confluenceSessionStorageInstance)?.getItem(sessionStorageKey) || (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))() : (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const [feedSessionId, setFeedSessionId] = (0, $42omo.useState)(feedSessionIdInitial);
    // Update the session storage with the new feed id if it changes
    (0, $42omo.useEffect)(()=>{
        (0, $17wUi.confluenceSessionStorageInstance)?.setItem(sessionStorageKey, feedSessionId);
    }, [
        sessionStorageKey,
        feedSessionId
    ]);
    // Regenerate session id when refetching
    (0, $42omo.useEffect)(()=>{
        if (feedContentQuery.networkStatus === (0, $5T18X.NetworkStatus).refetch) setFeedSessionId((0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))());
    }, [
        feedContentQuery.networkStatus
    ]);
    return feedSessionId;
};
module.exports["useFeedSession"] = $dd9b0509e0327438$export$f76be7c0556c5409;

});

parcelRegister("4kEyG", function(module, exports) {

var $kZ8dV = parcelRequire("kZ8dV");


var $42omo = parcelRequire("42omo");


var $5T18X = parcelRequire("5T18X");


var $9wGTI = parcelRequire("9wGTI");


var $8BIV2 = parcelRequire("8BIV2");


var $4yg2A = parcelRequire("4yg2A");


var $3xaH7 = parcelRequire("3xaH7");


var $6zZYs = parcelRequire("6zZYs");


var $jMyy4 = parcelRequire("jMyy4");

const $5c36509cc983df2b$var$FilterByLabelFeedQuery = (0, $kZ8dV.default);
const $5c36509cc983df2b$export$90b19fb7c85a6759 = ({ filterByLabel: filterByLabel, handleFocusRef: handleFocusRef })=>{
    const { data: data, loading: loading, error: error, networkStatus: networkStatus, fetchMore: fetchMore } = (0, $jMyy4.useQueryInterop)($5c36509cc983df2b$var$FilterByLabelFeedQuery, {
        variables: {
            cql: `label = "${filterByLabel}" AND created >= now(\"-2w\") order by created desc`,
            first: (0, $9wGTI.fg)('confluence_ai_feeds_home_banner') ? 10 : 5
        },
        errorPolicy: 'all',
        notifyOnNetworkStatusChange: true,
        __callerPackage__: "@confluence/feed"
    });
    const results = data?.search?.nodes || [];
    const hasNextPage = (0, $9wGTI.fg)('confluence_ai_feeds_home_banner') ? false : data?.search?.pageInfo?.hasNextPage || false;
    // Must convert `endCursor` to `string | undefined`; never null.
    const endCursor = data?.search?.pageInfo?.endCursor ?? undefined;
    const disableAnimation = Boolean(window.__SSR_RENDERED__ && networkStatus !== (0, $5T18X.NetworkStatus).fetchMore);
    const feedType = filterByLabel === 'welcome-blog' ? (0, $4yg2A.FeedType).WELCOME : (0, $4yg2A.FeedType).FAREWELL;
    const loadNextPage = (0, $42omo.useCallback)(async ()=>{
        try {
            if (!endCursor) return undefined;
            const newResult = await fetchMore({
                variables: {
                    first: 5,
                    after: endCursor
                },
                updateQuery: (prevResults, { fetchMoreResult: fetchMoreResult })=>{
                    if (!fetchMoreResult) return prevResults;
                    if (fetchMoreResult?.search?.nodes && prevResults?.search?.nodes) fetchMoreResult.search.nodes = prevResults.search.nodes.concat(fetchMoreResult.search.nodes);
                    return fetchMoreResult;
                }
            });
            if (newResult.errors) throw newResult.errors;
            return newResult;
        } catch (e) {
            throw e;
        }
    }, [
        fetchMore,
        endCursor
    ]);
    const feedItems = (0, $9wGTI.fg)('confluence_ai_feeds_home_banner') ? results.slice(0, 3) : results;
    // The `endCursor` *must* be passed in, otherwise the `InfiniteScroll` component paginates at most *once*.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8BIV2.FeedCardsWrapper), {
        loading: loading,
        firstPageError: error,
        networkStatus: networkStatus,
        endCursor: endCursor,
        hasNextPage: hasNextPage,
        loadNextPage: loadNextPage,
        feedType: feedType
    }, feedItems.map((result, index)=>{
        return result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
            key: result.content?.id ?? index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3xaH7.PopularFeedCard), {
            feedItem: result,
            ranking: index,
            disableAnimation: disableAnimation
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zZYs.ExitFeedAllyButton), {
            onExit: handleFocusRef,
            source: "popular-feed",
            feedCardIndex: index
        }));
    }));
};
module.exports["FilterByLabelFeed"] = $5c36509cc983df2b$export$90b19fb7c85a6759;

});

parcelRegister("215Eu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $cyLm6 = parcelRequire("cyLm6");


var $lebfc = parcelRequire("lebfc");


var $4yg2A = parcelRequire("4yg2A");


var $k11sS = parcelRequire("k11sS");

const $29db5a39384177a9$var$i18n = (0, $aXWIB.defineMessages)({
    following: {
        id: "feed.card.categories.following",
        defaultMessage: "Following"
    },
    popular: {
        id: "feed.card.categories.popular",
        defaultMessage: "Popular"
    }
});
const $29db5a39384177a9$var$containerStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.negative.050'
});
const $29db5a39384177a9$export$55981cdcb801b395 = ({ selectedFeedType: selectedFeedType, setSelectedFeedType: setSelectedFeedType, customPanels: customPanels, popularFeedPillRef: popularFeedPillRef, followingFeedPillRef: followingFeedPillRef })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $29db5a39384177a9$var$containerStyle,
        wrap: "wrap",
        role: "tablist",
        "aria-labelledby": "tablist-feedtypes"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k11sS.FeedTypePill), {
        feedType: (0, $4yg2A.FeedType).FOLLOWING,
        selectedFeedType: selectedFeedType,
        setFeedType: setSelectedFeedType,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lebfc))),
        ref: followingFeedPillRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $29db5a39384177a9$var$i18n.following)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k11sS.FeedTypePill), {
        feedType: (0, $4yg2A.FeedType).POPULAR,
        selectedFeedType: selectedFeedType,
        setFeedType: setSelectedFeedType,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cyLm6))),
        ref: popularFeedPillRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $29db5a39384177a9$var$i18n.popular)), customPanels && customPanels.map((item)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k11sS.FeedTypePill), {
            key: item.key,
            feedType: item.key,
            selectedFeedType: selectedFeedType,
            setFeedType: setSelectedFeedType,
            Icon: item.icon,
            ref: item.ref,
            isPulseActive: item.isPulseActive,
            onPulseClick: item.onPulseClick
        }, item.title);
    }));
};
module.exports["FeedTypeSelector"] = $29db5a39384177a9$export$55981cdcb801b395;

});

parcelRegister("YAWAX", function(module, exports) {
/* FeedOnboardingMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $cO1el = parcelRequire("cO1el");


var $gj7hi = parcelRequire("gj7hi");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $inPa6 = parcelRequire("inPa6");


var $9oxdN = parcelRequire("9oxdN");


var $b3j2Y = parcelRequire("b3j2Y");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $9yPX0 = parcelRequire("9yPX0");


var $4baog = parcelRequire("4baog");


var $rzvmf = parcelRequire("rzvmf");


var $f4ywA = parcelRequire("f4ywA");


var $bCcO6 = parcelRequire("bCcO6");

const $c3b8f8d03a12c5fa$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    headerTitle: {
        id: "feed.header.title",
        defaultMessage: "We\u2019re keeping you in the loop"
    },
    headerDescription: {
        id: "feed.header.description",
        defaultMessage: "Stay in-the-know by following people and spaces. Their activity will show up in your feed, but you won\u2019t receive email notifications about it. Add to, or edit, your feed anytime."
    },
    editFeed: {
        id: "feed.header.editFeed",
        defaultMessage: "Edit feed"
    },
    closeMessageLabel: {
        id: "feed.header.closeLabel",
        defaultMessage: "Close message box"
    },
    headerDescriptionV2: {
        id: "feed.header.description.v2",
        defaultMessage: "We\u2019ve automatically followed top recommended spaces and people for you, so you never miss important updates. You can add or remove spaces and people from your feed at any time to tailor what you see."
    },
    customizeFeed: {
        id: "feed.header.customizeFeed",
        defaultMessage: "Customize feed"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c3b8f8d03a12c5fa$var$BodyContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itia51 _2rko1mok _11q7vuon _1yt4ol3b _vchhusvi _1e0c1txw _otyr1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c3b8f8d03a12c5fa$var$MessageContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _2hwxv47k _otyr1ejb",
            __cmplp.className
        ])
    });
});
const $c3b8f8d03a12c5fa$var$descriptionTextStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c3b8f8d03a12c5fa$var$OnBoardingImage = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $gj7hi.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_p12fuuw1 _c71l1lit _1o9zidpf _1wpzesu3 _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $c3b8f8d03a12c5fa$var$CloseButtonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1o9zidpf",
            __cmplp.className
        ])
    });
});
const $c3b8f8d03a12c5fa$var$defaultContentConfig = {
    lightImage: (0, (/*@__PURE__*/$parcel$interopDefault($rzvmf))),
    darkImage: (0, (/*@__PURE__*/$parcel$interopDefault($4baog))),
    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "large",
        weight: "regular"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c3b8f8d03a12c5fa$export$a7357cdd1f0b0168.headerDescription)),
    button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c3b8f8d03a12c5fa$export$a7357cdd1f0b0168.editFeed),
    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "small",
        as: "h3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "large",
        weight: "regular"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c3b8f8d03a12c5fa$export$a7357cdd1f0b0168.headerTitle)))
};
const $c3b8f8d03a12c5fa$var$autoFollowContentConfig = {
    lightImage: (0, (/*@__PURE__*/$parcel$interopDefault($bCcO6))),
    darkImage: (0, (/*@__PURE__*/$parcel$interopDefault($f4ywA))),
    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "large",
        weight: "regular",
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c3b8f8d03a12c5fa$export$a7357cdd1f0b0168.headerDescriptionV2)),
    button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c3b8f8d03a12c5fa$export$a7357cdd1f0b0168.customizeFeed)),
    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c3b8f8d03a12c5fa$export$a7357cdd1f0b0168.headerTitle))
};
const $c3b8f8d03a12c5fa$var$FeedOnboardingMessageComponent = ({ intl: intl, openActivityFilterModal: openActivityFilterModal, servingRecommendations: servingRecommendations })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [showFeature, stop, featureDiscoveryError] = (0, $9oxdN.useFeatureDiscovery)((0, $9yPX0.onboardingFeedHeaderCard));
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)((0, $dBcar.NTH_USER_AUTO_FOLLOW_SPACES).HAS_AUTO_FOLLOWED_SPACES);
    const { hasAutoFollowedSpaces: hasAutoFollowedSpaces } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const contentConfig = (0, $42omo.useMemo)(()=>{
        if (Boolean(hasAutoFollowedSpaces)) // > 10 users
        return $c3b8f8d03a12c5fa$var$autoFollowContentConfig;
        return $c3b8f8d03a12c5fa$var$defaultContentConfig;
    }, [
        hasAutoFollowedSpaces
    ]);
    const error = featureDiscoveryError || onboardingStateError;
    (0, $42omo.useEffect)(()=>{
        if ((servingRecommendations || Boolean(hasAutoFollowedSpaces)) && showFeature && !error && !onboardingStateLoading) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'feedOnboardingMessage',
                attributes: {
                    isAutoFollowContent: hasAutoFollowedSpaces
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        error,
        showFeature,
        servingRecommendations,
        onboardingStateLoading,
        hasAutoFollowedSpaces
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    if (onboardingStateLoading || !showFeature || // When spaces are auto-followed, servingRecommendations will be set to false
    // This is a workaround to ignore the value if the follow is not user-initiated
    !servingRecommendations && !hasAutoFollowedSpaces) return null;
    const handleClick = ()=>{
        openActivityFilterModal();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'feedOnboardingUpdateFeed',
                source: 'feedOnboardingMessage',
                attributes: {
                    isAutoFollowContent: Boolean(hasAutoFollowedSpaces)
                }
            }
        }).fire();
    };
    const handleDismiss = ()=>{
        stop();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'feedOnboardingDismiss',
                source: 'feedOnboardingMessage',
                attributes: {
                    isAutoFollowContent: Boolean(hasAutoFollowedSpaces)
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c3b8f8d03a12c5fa$var$BodyContainer, {
        "data-testid": "feed-onboarding-message",
        "data-vc": "feed-onboarding-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c3b8f8d03a12c5fa$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, contentConfig.title, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $c3b8f8d03a12c5fa$var$descriptionTextStyles
    }, contentConfig.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: handleClick
    }, contentConfig.button))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c3b8f8d03a12c5fa$var$OnBoardingImage, {
        src: contentConfig.lightImage,
        srcDark: contentConfig.darkImage,
        width: "200",
        height: "160",
        alt: "",
        "data-vc": "following-onboarding-image"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c3b8f8d03a12c5fa$var$CloseButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: handleDismiss,
        spacing: "compact",
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: intl.formatMessage($c3b8f8d03a12c5fa$export$a7357cdd1f0b0168.closeMessageLabel),
        isTooltipDisabled: false
    })));
};
const $c3b8f8d03a12c5fa$export$124b813167fe9112 = (0, $aXWIB.injectIntl)($c3b8f8d03a12c5fa$var$FeedOnboardingMessageComponent);
module.exports["FeedOnboardingMessage"] = $c3b8f8d03a12c5fa$export$124b813167fe9112;

});

parcelRegister("8FX3K", function(module, exports) {

var $dFUHi = parcelRequire("dFUHi");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6R5uz = parcelRequire("6R5uz");


var $laHi9 = parcelRequire("laHi9");


var $inPa6 = parcelRequire("inPa6");


var $4KS7f = parcelRequire("4KS7f");


var $9VJDA = parcelRequire("9VJDA");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");


var $dpPtd = parcelRequire("dpPtd");


var $a3fRD = parcelRequire("a3fRD");


var $cO1el = parcelRequire("cO1el");


var $308Wd = parcelRequire("308Wd");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $fgRQY = parcelRequire("fgRQY");


var $lIZtA = parcelRequire("lIZtA");


var $kPlM7 = parcelRequire("kPlM7");


var $b29u2 = parcelRequire("b29u2");

const $e3eb4432e25cc607$var$FeedRecommendationsFeedRecDismissMutation = (0, $dFUHi.default);
const $e3eb4432e25cc607$var$i18n = (0, $aXWIB.defineMessages)({
    title: {
        id: "feed.recommendation.title",
        defaultMessage: "Improve your feed"
    },
    dismiss: {
        id: "feed.recommendation.dismiss",
        defaultMessage: "Hide suggestions"
    },
    dismissDescription: {
        id: "feed.recommendation.dismiss.description",
        defaultMessage: "Don\u2019t show this card for one month"
    },
    flagErrorTitle: {
        id: "feed.recommendation.flag.dismiss.error",
        defaultMessage: "Could not dismiss recommendations"
    },
    flagErrorDescription: {
        id: "feed.recommendation.flag.dismiss.error.description",
        defaultMessage: "Please try again later"
    },
    moreIconLabel: {
        id: "feed.recommendations.more.label",
        defaultMessage: "Show more options"
    },
    leftCarouselLabel: {
        id: "feed.recommendations.carousel.left",
        defaultMessage: "Scroll left"
    },
    rightCarouselLabel: {
        id: "feed.recommendations.carousel.right",
        defaultMessage: "Scroll right"
    }
});
const $e3eb4432e25cc607$var$menuButtonTheme = (currentTheme, themeProps)=>{
    const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            backgroundColor: "var(--ds-background-input, #FFFFFF)",
            '&:hover': {
                backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
            },
            "&[aria-expanded='true']": {
                backgroundColor: "var(--ds-background-accent-gray-bolder, #6B6E76)",
                color: "var(--ds-text-inverse, #FFFFFF)"
            }
        },
        spinnerStyles: spinnerStyles
    };
};
const $e3eb4432e25cc607$var$titleAndMenuWrapperStyle = null;
const $e3eb4432e25cc607$var$menuWrapperStyle = null;
const $e3eb4432e25cc607$var$tilesWrapperStyle = null;
const $e3eb4432e25cc607$var$isIgnorableError = (error)=>{
    return error.graphQLErrors.every((0, $lIZtA.isFeedRecDeletedSpaceError));
};
const $e3eb4432e25cc607$var$updateFeedRecDismiss = (_cache, { data: data })=>{
    const timestamp = data?.updateUserPreferences?.feedRecommendedUserSettingsDismissTimestamp;
    const cachedata = (0, $l1uFv.readQueryInterop)({
        query: (0, $b29u2.FeedRecommendationQuery),
        __callerPackage__: "@confluence/feed"
    });
    if (timestamp && cachedata) {
        const newData = {
            ...cachedata
        };
        newData.userPreferences.feedRecommendedUserSettingsDismissTimestamp = timestamp;
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $b29u2.FeedRecommendationQuery),
            data: newData,
            __callerPackage__: "@confluence/feed"
        });
    }
};
const $e3eb4432e25cc607$var$FeedRecommendationsComponent = ({ position: position, recs: recs, setRecs: setRecs, feedRecError: feedRecError, setShowFeedRecs: setShowFeedRecs })=>{
    const intl = (0, $aXWIB.useIntl)();
    const bottomOfCardRef = (0, $42omo.useRef)(null);
    const tilesWrapperRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [recOffset, setRecOffset] = (0, $42omo.useState)(0);
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const recsToShow = recs.slice(recOffset, recOffset + (0, $kPlM7.PAGE_SIZE));
    const isRightmostPage = recOffset === recs.length - (0, $kPlM7.PAGE_SIZE) && recOffset !== 0;
    const onRecommendationsViewed = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'suggestionsCard',
                source: 'homeScreen',
                attributes: {
                    pos: position,
                    numSuggestions: recs.length,
                    followSuggestions: recsToShow.map((rec)=>rec.id),
                    followSuggestionTypes: recsToShow.map((rec)=>rec.type)
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        position,
        recs,
        recsToShow
    ]);
    (0, $fgRQY.useElementSeenCallback)(bottomOfCardRef, onRecommendationsViewed);
    const onDismissError = (0, $42omo.useCallback)(()=>{
        showFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e3eb4432e25cc607$var$i18n.flagErrorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e3eb4432e25cc607$var$i18n.flagErrorDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: "error",
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "spacious"
            }),
            isAutoDismiss: true
        });
    }, [
        showFlag
    ]);
    const hideFeedRecs = ()=>{
        setShowFeedRecs(false);
    };
    const [dismissFeedRec, { error: dismissError }] = (0, $308Wd.useMutationInterop)($e3eb4432e25cc607$var$FeedRecommendationsFeedRecDismissMutation, {
        onCompleted: hideFeedRecs,
        update: $e3eb4432e25cc607$var$updateFeedRecDismiss,
        onError: onDismissError,
        __callerPackage__: "@confluence/feed"
    });
    const handleDismissClick = (0, $42omo.useCallback)(()=>{
        const date = new Date();
        dismissFeedRec({
            variables: {
                dismissTime: date.toISOString()
            }
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'suggestionsDismissal',
                source: 'suggestionsCard',
                attributes: {
                    timestamp: date.toISOString(),
                    pos: position,
                    numSuggestions: recs.length,
                    followSuggestions: recsToShow.map((rec)=>rec.id),
                    followSuggestionTypes: recsToShow.map((rec)=>rec.type)
                }
            }
        }).fire();
    }, [
        dismissFeedRec,
        createAnalyticsEvent,
        position,
        recs,
        recsToShow
    ]);
    const scrollTilesWrapper = (0, $42omo.useCallback)((newRecOffset)=>{
        if (tilesWrapperRef.current) {
            const scrollPosition = newRecOffset * (tilesWrapperRef.current.offsetWidth / (0, $kPlM7.PAGE_SIZE) - (0, $kPlM7.TILE_MARGIN) / (0, $kPlM7.PAGE_SIZE));
            tilesWrapperRef.current.scroll({
                left: scrollPosition,
                behavior: 'smooth'
            });
            setRecOffset(newRecOffset);
        }
    }, [
        tilesWrapperRef,
        setRecOffset
    ]);
    const dismissTile = (0, $42omo.useCallback)((id)=>{
        const newRecs = recs.filter((rec)=>rec.id !== id);
        const newShownRecs = isRightmostPage ? newRecs.slice(recOffset - 1, recOffset - 1 + (0, $kPlM7.PAGE_SIZE)) : newRecs.slice(recOffset, recOffset + (0, $kPlM7.PAGE_SIZE));
        if (isRightmostPage) scrollTilesWrapper(recOffset - 1);
        setRecs(newRecs);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'suggestionsCard',
                source: 'homeScreen',
                attributes: {
                    pos: position,
                    numSuggestions: newRecs.length,
                    followSuggestions: newShownRecs.map((rec)=>rec.id),
                    followSuggestionTypes: newShownRecs.map((rec)=>rec.type)
                }
            }
        }).fire();
    }, [
        recs,
        recOffset,
        isRightmostPage,
        setRecs,
        createAnalyticsEvent,
        position,
        scrollTilesWrapper
    ]);
    const handleLeftCarousel = (0, $42omo.useCallback)(()=>{
        scrollTilesWrapper(Math.max(0, recOffset - 4));
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'leftCarousel',
                source: 'suggestionsCard',
                attributes: {
                    pos: position
                }
            }
        }).fire();
    }, [
        scrollTilesWrapper,
        recOffset,
        createAnalyticsEvent,
        position
    ]);
    const handleRightCarousel = (0, $42omo.useCallback)(()=>{
        scrollTilesWrapper(Math.min(recs.length - (0, $kPlM7.PAGE_SIZE), recOffset + 4));
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'rightCarousel',
                source: 'suggestionsCard',
                attributes: {
                    pos: position
                }
            }
        }).fire();
    }, [
        recs,
        scrollTilesWrapper,
        recOffset,
        createAnalyticsEvent,
        position
    ]);
    const getDropdownTriggerButton = (0, $42omo.useCallback)(({ triggerRef: triggerRef, ...props })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
            ...props,
            ref: triggerRef,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                label: intl.formatMessage($e3eb4432e25cc607$var$i18n.moreIconLabel),
                spacing: "spacious"
            }),
            theme: $e3eb4432e25cc607$var$menuButtonTheme
        });
    }, [
        intl
    ]);
    if (feedRecError && !$e3eb4432e25cc607$var$isIgnorableError(feedRecError)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: feedRecError
    });
    if (recs.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, dismissError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: dismissError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _otyru2gc"
        ]),
        "data-vc": "dwCPnHtS"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        as: "h2",
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e3eb4432e25cc607$var$i18n.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        theme: $e3eb4432e25cc607$var$menuButtonTheme,
        onClick: handleLeftCarousel,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
            label: intl.formatMessage($e3eb4432e25cc607$var$i18n.leftCarouselLabel),
            spacing: "spacious",
            size: "small"
        }),
        isDisabled: recOffset === 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        theme: $e3eb4432e25cc607$var$menuButtonTheme,
        onClick: handleRightCarousel,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
            label: intl.formatMessage($e3eb4432e25cc607$var$i18n.rightCarouselLabel),
            spacing: "spacious",
            size: "small"
        }),
        isDisabled: isRightmostPage || recs.length <= (0, $kPlM7.PAGE_SIZE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        placement: "bottom-end",
        trigger: getDropdownTriggerButton,
        testId: "feed-rec-dropdown-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: handleDismissClick,
        description: intl.formatMessage($e3eb4432e25cc607$var$i18n.dismissDescription)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e3eb4432e25cc607$var$i18n.dismiss))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: tilesWrapperRef,
        "data-testid": "feed-rec-tiles-wrapper",
        className: (0, $gMc0m.default)([
            "_18s816qb _1yt4119w _1e0c1txw _1bah1y6m _1reo1wug _rjfvx6dd _9nne7vkz _4pckglyw _1fjgglyw _lcxvglyw _1cicglyw"
        ])
    }, recs.map((rec, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kPlM7.RecommendationTile), {
            key: rec.id,
            name: rec.name,
            id: rec.id,
            url: rec.url,
            icon: rec.icon,
            type: rec.type,
            title: rec.title,
            dismissTile: dismissTile,
            cardIndex: index,
            position: position
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: bottomOfCardRef
    }));
};
const $e3eb4432e25cc607$export$e370efd4e286ab04 = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e3eb4432e25cc607$var$FeedRecommendationsComponent, props));
});
module.exports["FeedRecommendations"] = $e3eb4432e25cc607$export$e370efd4e286ab04;

});

parcelRegister("lYst4", function(module, exports) {

var $947Tc = parcelRequire("947Tc");


var $42omo = parcelRequire("42omo");


var $4qzKl = parcelRequire("4qzKl");


var $cb6fO = parcelRequire("cb6fO");


var $jlIaF = parcelRequire("jlIaF");


var $jMyy4 = parcelRequire("jMyy4");


var $kPlM7 = parcelRequire("kPlM7");

const $60781568fe3da131$var$useFeedRecommendationsFeedRecommendationQuery = (0, $947Tc.default);
const $60781568fe3da131$export$2225b8d07ada6545 = ()=>{
    const { data: data, loading: recsLoading, error: feedRecError } = (0, $jMyy4.useQueryInterop)($60781568fe3da131$var$useFeedRecommendationsFeedRecommendationQuery, {
        errorPolicy: 'all',
        // Use cache-first to avoid a redundant network roundtrip on every mount
        // when recommendations data is already cached. Mutations that dismiss
        // recommendations update the cache directly, so freshness is maintained.
        fetchPolicy: 'cache-first',
        __callerPackage__: "@confluence/feed"
    });
    const [recs, setRecs] = (0, $42omo.useState)([]);
    const [initialRecSize, setInitialRec] = (0, $42omo.useState)(0);
    const recsDismissed = data?.userPreferences?.feedRecommendedUserSettingsDismissTimestamp;
    const userRecs = data?.getRecommendedFeedUserConfig?.recommendedPeople;
    const spaceRecs = data?.getRecommendedFeedUserConfig?.recommendedSpaces;
    const msInMonth = 2629800000;
    const showRecs = recsDismissed && recsDismissed !== 'NO_VALUE_SET' ? Math.floor((new Date().getTime() - new Date(recsDismissed).getTime()) / msInMonth) >= 1 : recsDismissed === 'NO_VALUE_SET';
    const initialState = showRecs && initialRecSize >= (0, $kPlM7.PAGE_SIZE) && recs.length > 0;
    const [showFeedRecs, setShowFeedRecs] = (0, $42omo.useState)(initialState);
    if (initialState != showFeedRecs) setShowFeedRecs(initialState);
    (0, $42omo.useEffect)(()=>{
        const userRecsArray = [];
        const spaceRecsArray = [];
        if (userRecs) userRecs.forEach((user)=>{
            if (user.user && user.user.displayName && user.user.id && user.user.isActive) userRecsArray.push({
                score: user.score,
                name: user.user.displayName,
                icon: user.user.photos?.find((photo)=>photo?.isPrimary)?.value || '',
                id: user.user.id,
                url: (0, $4qzKl.getAtlassianPeopleProfileUrl)(user.user.id, 'feed-alpha', (0, $jlIaF.CONTEXT_PATH)),
                title: user.user.title || '',
                type: 'user'
            });
        });
        if (spaceRecs) spaceRecs.forEach((space)=>{
            if (space.space && space.space.name && space.space.id && space.space.key) spaceRecsArray.push({
                score: space.score,
                name: space.space.name,
                icon: space.space.icon?.path || '',
                id: space.space.id,
                url: (0, $cb6fO.getSpaceLink)(space.space.key),
                type: 'space'
            });
        });
        userRecsArray.sort((a, b)=>b.score - a.score);
        spaceRecsArray.sort((a, b)=>b.score - a.score);
        const recsArray = userRecsArray.concat(spaceRecsArray);
        setRecs(recsArray);
        setInitialRec(recsArray.length);
    }, [
        userRecs,
        spaceRecs,
        setRecs,
        setInitialRec
    ]);
    return {
        showFeedRecs: showFeedRecs,
        setShowFeedRecs: setShowFeedRecs,
        recs: recs,
        setRecs: setRecs,
        recsLoading: recsLoading,
        feedRecError: feedRecError
    };
};
module.exports["useFeedRecommendations"] = $60781568fe3da131$export$2225b8d07ada6545;

});

parcelRegister("9yPX0", function(module, exports) {
const $9ad22e8e5a126d51$export$36e0baead2aaf9c7 = 5;
const $9ad22e8e5a126d51$export$ce4fd56db4138f46 = 85;
const $9ad22e8e5a126d51$export$de13fd770567d68 = 'home.feed.header.onboarding.followed-for-you';
module.exports["FETCH_MORE_PAGE_SIZE"] = $9ad22e8e5a126d51$export$36e0baead2aaf9c7;
module.exports["COMMENT_COLLAPSE_THRESHOLD"] = $9ad22e8e5a126d51$export$ce4fd56db4138f46;
module.exports["onboardingFeedHeaderCard"] = $9ad22e8e5a126d51$export$de13fd770567d68;

});

parcelRegister("gusOH", function(module, exports) {
const $2a951a36429b05e8$export$f0c535c2629aaab2 = ()=>{
    // we are returning false here so that we can quickly clean up the LD flag without extensive refactoring. Returning false here effectively turns off the feature. Context: https://atlassian.slack.com/archives/C05PQGP2PAQ/p1732581371074749
    return false;
};
module.exports["useFeedShouldHideComments"] = $2a951a36429b05e8$export$f0c535c2629aaab2;

});

parcelRegister("8BIV2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5T18X = parcelRequire("5T18X");


var $422HI = parcelRequire("422HI");


var $gdv5Z = parcelRequire("gdv5Z");


var $9wGTI = parcelRequire("9wGTI");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $l8oxh = parcelRequire("l8oxh");


var $b3j2Y = parcelRequire("b3j2Y");


var $7Sm4c = parcelRequire("7Sm4c");


var $kvJHJ = parcelRequire("kvJHJ");


var $bQm3c = parcelRequire("bQm3c");


var $d442j = parcelRequire("d442j");

var $g9apM = parcelRequire("g9apM");


var $3HoFy = parcelRequire("3HoFy");

var $2Jztb = parcelRequire("2Jztb");


var $kVcC2 = parcelRequire("kVcC2");


var $8KJF2 = parcelRequire("8KJF2");


var $4yg2A = parcelRequire("4yg2A");


var $lIZtA = parcelRequire("lIZtA");


var $bxcP5 = parcelRequire("bxcP5");


var $g973h = parcelRequire("g973h");

const $270eb890b75251af$export$609954d45d804885 = ({ loading: loading, firstPageError: firstPageError, networkStatus: networkStatus, endCursor: endCursor, hasNextPage: hasNextPage, loadNextPage: loadNextPage, openActivityFilterModal: openActivityFilterModal, feedType: feedType, hasResults: hasResults = true, children: children, hasFollowedAnyone: hasFollowedAnyone })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const experienceTrackerStopAttributes = (0, $42omo.useMemo)(()=>({
            feedType: feedType.toLowerCase()
        }), [
        feedType
    ]);
    const [nextPageError, setNextPageError] = (0, $42omo.useState)();
    const error = firstPageError || nextPageError;
    const isExpectedError = Boolean(error && (0, $lIZtA.isExpectedApolloError)(error));
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const homeHref = `https://home.atlassian.com/o/${orgId}/discover/?cloudId=${cloudId}`;
    if (error && isExpectedError) (0, $7Sm4c.markErrorAsHandled)(error);
    const handlePagination = (0, $42omo.useCallback)(async ()=>{
        try {
            if (!loading && hasNextPage) {
                experienceTracker.start({
                    name: (0, $irVI7.FEED_EXPERIENCE),
                    attributes: {
                        pagination: true
                    }
                });
                await loadNextPage();
                setNextPageError(null);
            }
        } catch (e) {
            const apolloError = new (0, $422HI.ApolloErrorInterop)({
                errorMessage: 'Feed cards failed to fetch more data',
                graphQLErrors: e
            });
            setNextPageError(apolloError);
        }
    }, [
        loading,
        hasNextPage,
        loadNextPage,
        setNextPageError,
        experienceTracker
    ]);
    const isFirstRenderAfterSSR = $270eb890b75251af$var$useIsFirstRenderAfterSSR();
    const renderPagination = ()=>{
        if (!hasNextPage) {
            if (feedType === (0, $4yg2A.FeedType).POPULAR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8KJF2.EndOfPopularFeed), null);
            else if (feedType === (0, $4yg2A.FeedType).FOLLOWING) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kVcC2.EndOfFollowingFeed), {
                openActivityFilterModal: openActivityFilterModal,
                hasFollowedAnyone: hasFollowedAnyone,
                hasResults: hasResults
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3HoFy.EndOfFeed), {
                openActivityFilterModal: openActivityFilterModal
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l8oxh.InfiniteScroll), {
            onScrollTo: handlePagination,
            cursor: endCursor,
            observerOptions: {
                root: null,
                rootMargin: '1000px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g973h.LoadingSkeleton), {
            useEntranceAnimation: !isFirstRenderAfterSSR
        }));
    };
    const renderEndOfFeed = ()=>{
        if (error && !isExpectedError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
            name: (0, $irVI7.FEED_EXPERIENCE),
            error: error,
            attributes: experienceTrackerStopAttributes
        }), nextPageError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9apM.PaginationFeedError), {
            refetch: handlePagination
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d442j.GenericFeedError), null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.FEED_EXPERIENCE),
            key: endCursor,
            attributes: experienceTrackerStopAttributes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            metric: (0, $bxcP5.HOME_OVERVIEW_FEED_PAGE_SEGMENT)
        }), renderPagination());
    };
    const alreadyLoaded = $270eb890b75251af$var$useAlreadyLoaded(loading);
    if (loading && (networkStatus === (0, $5T18X.NetworkStatus).refetch || networkStatus === (0, $5T18X.NetworkStatus).loading && !alreadyLoaded)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g973h.LoadingSkeleton), {
        useEntranceAnimation: !isFirstRenderAfterSSR
    });
    const isInPopularTypeFeed = feedType === (0, $4yg2A.FeedType).POPULAR || feedType === (0, $4yg2A.FeedType).FAREWELL || feedType === (0, $4yg2A.FeedType).WELCOME;
    // Check if we should show our new empty state instead of the banner
    const shouldShowNewEmptyState = !hasResults && feedType === (0, $4yg2A.FeedType).POPULAR;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        id: `tabpanel-${feedType.toLowerCase()}`,
        "aria-labelledby": `tab-${feedType.toLowerCase()}`,
        role: "tabpanel",
        tabIndex: 0
    }, children), isInPopularTypeFeed && !shouldShowNewEmptyState && (0, $9wGTI.fg)('confluence_ai_feeds_home_banner') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Jztb.EndOfFeedHomeBanner), {
        linkHref: homeHref,
        feedType: feedType
    }) : renderEndOfFeed());
};
const $270eb890b75251af$var$useAlreadyLoaded = (loading)=>{
    const alreadyLoaded = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!loading) alreadyLoaded.current = true;
    }, [
        loading
    ]);
    return alreadyLoaded.current;
};
const $270eb890b75251af$var$useIsFirstRenderAfterSSR = ()=>{
    const isFirstRenderAfterSSR = (0, $42omo.useRef)(Boolean(window.__SSR_RENDERED__));
    (0, $42omo.useEffect)(()=>{
        isFirstRenderAfterSSR.current = false;
    }, []);
    return isFirstRenderAfterSSR.current;
};
module.exports["FeedCardsWrapper"] = $270eb890b75251af$export$609954d45d804885;

});

parcelRegister("6zZYs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eEA8O = parcelRequire("eEA8O");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $inPa6 = parcelRequire("inPa6");

const $403bf0cb55748477$var$i18n = (0, $aXWIB.defineMessages)({
    exitFeed: {
        id: "feed.exit-feed-button",
        defaultMessage: "Exit feed"
    }
});
const $403bf0cb55748477$var$hideStyles = (0, $ecnYn.xcss)({
    height: '0',
    overflow: 'hidden'
});
const $403bf0cb55748477$var$showStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.150',
    height: 'auto'
});
const $403bf0cb55748477$export$32879755d4094f2 = ({ onExit: onExit, source: source, feedCardIndex: feedCardIndex, isAfterRecommendations: isAfterRecommendations })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [showExitFeedButton, setShowExitFeedButton] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleOnClick = ()=>{
        onExit();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'exitFeedButton',
                attributes: {
                    feedCardIndex: feedCardIndex,
                    isAfterRecommendations: !!isAfterRecommendations
                }
            }
        }).fire();
    };
    const onFocus = ()=>{
        setShowExitFeedButton(true);
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'exitFeedButton',
                attributes: {
                    feedCardIndex: feedCardIndex,
                    isAfterRecommendations: !!isAfterRecommendations
                }
            }
        }).fire();
    };
    const onBlur = ()=>{
        setShowExitFeedButton(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: showExitFeedButton ? $403bf0cb55748477$var$showStyles : $403bf0cb55748477$var$hideStyles,
        testId: "exit-feed-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        onClick: handleOnClick,
        onFocus: onFocus,
        onBlur: onBlur,
        "data-vc": "exit-feed-a11y-button"
    }, intl.formatMessage($403bf0cb55748477$var$i18n.exitFeed))));
};
module.exports["ExitFeedAllyButton"] = $403bf0cb55748477$export$32879755d4094f2;

});

parcelRegister("6wpcc", function(module, exports) {
/* MobileAppPromo.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $gj7hi = parcelRequire("gj7hi");


var $5nBzc = parcelRequire("5nBzc");


var $lAFHW = parcelRequire("lAFHW");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");


var $6mKj3 = parcelRequire("6mKj3");


var $8G4Nr = parcelRequire("8G4Nr");


var $loTx8 = parcelRequire("loTx8");


var $6eSd4 = parcelRequire("6eSd4");


var $2JWAq = parcelRequire("2JWAq");

const $baa3febee1410499$var$GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.atlassian.android.confluence.core&referrer=utm_source%3DconfluenceWeb%26utm_medium%3DUI%26utm_campaign%3DtestWebPopularFeedAudio';
const $baa3febee1410499$var$APP_STORE_URL = 'https://apps.apple.com/app/apple-store/id1006971684?pt=696495&ct=testWebPopularFeedAudio&mt=8';
const $baa3febee1410499$var$i18n = (0, $aXWIB.defineMessages)({
    eyebrow: {
        id: "feed.mobile-app-promo.eyebrow",
        defaultMessage: "Try the mobile app"
    },
    headline: {
        id: "feed.mobile-app-promo.headline",
        defaultMessage: "Listen on-the-go with the mobile app"
    },
    description: {
        id: "feed.mobile-app-promo.description",
        defaultMessage: "Scan the QR code to listen to audio AI summaries with the Confluence mobile app. Perfect for your commute or when you need a screen break."
    },
    proTip: {
        id: "feed.mobile-app-promo.pro-tip",
        defaultMessage: "PRO TIP"
    },
    dismissLabel: {
        id: "feed.mobile-app-promo.close",
        defaultMessage: "Close"
    },
    dismissAccessibleLabel: {
        id: "feed.mobile-app-promo.dismiss.accessible-label",
        defaultMessage: "Close mobile app promotion"
    },
    qrAlt: {
        id: "feed.mobile-app-promo.qr.alt",
        defaultMessage: "QR code to download the Confluence mobile app"
    },
    googlePlayAlt: {
        id: "feed.mobile-app-promo.google-play.alt",
        defaultMessage: "Get the Confluence mobile app on Google Play"
    },
    appStoreAlt: {
        id: "feed.mobile-app-promo.app-store.alt",
        defaultMessage: "Download the Confluence mobile app on the App Store"
    }
});
const $baa3febee1410499$var$styles = {
    card: "_zulppxbi _19itia51 _2rko1mok _kqswh2mm _1e0c1txw _2lx2vrvc _1n261g80 _4cvr1h6o _ca0qpxbi _n3tdpxbi _19bvpxbi _u5f3xncg _bfhkvuon _vchhusvi _otyrpxbi",
    leadBlock: "_zulppxbi _16jlkb7n _1o9zkb7n _i0dlgx0z _1e0c1txw _2lx2vrvc _4cvr1y6m _1ul9idpf",
    logoTile: "_2rko12b0 _1e0c1txw _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _bfhk16e3 _1o9zidpf",
    eyebrow: "_11c81qyo _syaz1oa5",
    heading: "_11c81e3o",
    message: "_11c8fhey",
    proTip: "_1wpzv2br",
    badgeLink: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1e0c116y _4cvr1h6o",
    badgeImage: "_4t3i1ul9 _1bsb1wug _1e0c1ule",
    dismissButton: "_kqswstnw _154ipxbi _1xi2pxbi _1pbykb7n",
    qrCode: "_2rko12b0 _1bsb16xz _4t3i16xz _1o9zidpf _5ral1f51 _bfhkhfxm _1e0c1ule",
    storeLinks: "_zulpu2gc _1e0c1txw _2lx21bp4 _1o9zidpf _18u01wug _1n261g80 _4cvresu3"
};
const $baa3febee1410499$export$626faae193981003 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onAutoDismiss = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'autoDismissed',
                actionSubject: 'mobileAppPromo',
                source: 'homeScreen'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const { isMobileAppPromoDismissed: isMobileAppPromoDismissed, onMobileAppPromoDismiss: onMobileAppPromoDismiss, onMobileAppPromoView: onMobileAppPromoView } = (0, $2JWAq.useMobileAppPromoDismiss)({
        onAutoDismiss: onAutoDismiss
    });
    if (isMobileAppPromoDismissed || !(0, $6mKj3.expVal)('cc_mobile_app_promo_popular_feed', 'isEnabled', false)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($baa3febee1410499$var$MobileAppPromoBanner, {
        onDismiss: onMobileAppPromoDismiss,
        onView: onMobileAppPromoView
    });
};
const $baa3febee1410499$var$MobileAppPromoBanner = ({ onDismiss: onDismiss, onView: onView })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        onView?.(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'mobileAppPromo',
                source: 'homeScreen'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'mobileAppPromoDismiss',
                source: 'homeScreen'
            }
        }).fire();
        onDismiss();
    }, [
        createAnalyticsEvent,
        onDismiss
    ]);
    const handleBadgeClick = (0, $42omo.useCallback)((actionSubjectId)=>()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'link',
                    actionSubjectId: actionSubjectId,
                    source: 'homeScreen'
                }
            }).fire();
        }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "section",
        xcss: $baa3febee1410499$var$styles.card,
        testId: "mobile-app-promo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $baa3febee1410499$var$styles.dismissButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: intl.formatMessage($baa3febee1410499$var$i18n.dismissAccessibleLabel),
        tooltip: {
            content: intl.formatMessage($baa3febee1410499$var$i18n.dismissLabel)
        },
        onClick: handleDismiss,
        isTooltipDisabled: false,
        testId: "mobile-app-promo-dismiss"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $baa3febee1410499$var$styles.leadBlock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $baa3febee1410499$var$styles.logoTile,
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.ConfluenceIcon), {
        appearance: "brand",
        shouldUseNewLogoDesign: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $baa3febee1410499$var$styles.eyebrow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $baa3febee1410499$var$i18n.eyebrow)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $baa3febee1410499$var$styles.heading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $baa3febee1410499$var$i18n.headline))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $baa3febee1410499$var$styles.message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $baa3febee1410499$var$i18n.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $baa3febee1410499$var$styles.proTip,
        testId: "mobile-app-promo-pro-tip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: "discovery"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $baa3febee1410499$var$i18n.proTip))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $baa3febee1410499$var$styles.qrCode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6eSd4))),
        alt: intl.formatMessage($baa3febee1410499$var$i18n.qrAlt)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $baa3febee1410499$var$styles.storeLinks
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        xcss: $baa3febee1410499$var$styles.badgeLink,
        href: $baa3febee1410499$var$GOOGLE_PLAY_URL,
        target: "_blank",
        newWindowLabel: intl.formatMessage($baa3febee1410499$var$i18n.googlePlayAlt),
        testId: "mobile-app-promo-google-play",
        onClick: handleBadgeClick('mobileAppPromoGooglePlayBadge')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $baa3febee1410499$var$styles.badgeImage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($loTx8))),
        alt: intl.formatMessage($baa3febee1410499$var$i18n.googlePlayAlt)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        xcss: $baa3febee1410499$var$styles.badgeLink,
        href: $baa3febee1410499$var$APP_STORE_URL,
        target: "_blank",
        newWindowLabel: intl.formatMessage($baa3febee1410499$var$i18n.appStoreAlt),
        testId: "mobile-app-promo-apple-store",
        onClick: handleBadgeClick('mobileAppPromoAppStoreBadge')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $baa3febee1410499$var$styles.badgeImage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8G4Nr))),
        alt: intl.formatMessage($baa3febee1410499$var$i18n.appStoreAlt)
    })))));
};
module.exports["MobileAppPromo"] = $baa3febee1410499$export$626faae193981003;

});

parcelRegister("3xaH7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $1NBp8 = parcelRequire("1NBp8");


var $fs6LW = parcelRequire("fs6LW");


var $8rneB = parcelRequire("8rneB");


var $fgRQY = parcelRequire("fgRQY");


var $dYA5q = parcelRequire("dYA5q");


var $hXDOc = parcelRequire("hXDOc");


var $6mKj3 = parcelRequire("6mKj3");


var $1RkMx = parcelRequire("1RkMx");


var $28g78 = parcelRequire("28g78");


var $gW7vR = parcelRequire("gW7vR");


var $hsR9s = parcelRequire("hsR9s");


var $cYSIK = parcelRequire("cYSIK");


var $9HGVt = parcelRequire("9HGVt");


var $dKup5 = parcelRequire("dKup5");

const $71e84ff29d608aa6$var$avatarWrapperStyles = (0, $ecnYn.xcss)({
    paddingRight: 'space.200'
});
const $71e84ff29d608aa6$export$eb5305221596eaa9 = /*#__PURE__*/ (0, $42omo.memo)(({ feedItem: feedItem, ranking: ranking, disableAnimation: disableAnimation, timeGranularity: timeGranularity })=>{
    const isMounted = (0, $dKup5.useIsMounted)();
    const [isActionMenuOpen] = (0, $42omo.useState)(false);
    const bottomOfCardRef = (0, $42omo.useRef)(null);
    const [, setHasBeenHovered] = (0, $42omo.useState)(false);
    const authorName = feedItem?.content?.history?.createdBy?.displayName || '';
    const authorId = (0, $1RkMx.getUserAccountId)(feedItem?.content?.history?.createdBy) || '';
    const authorSrc = feedItem?.content?.history?.createdBy?.profilePicture?.path || '';
    const ownerName = feedItem?.content?.history?.ownedBy?.displayName || '';
    const ownerId = (0, $1RkMx.getUserAccountId)(feedItem?.content?.history?.ownedBy) || '';
    const ownerSrc = feedItem?.content?.history?.ownedBy?.profilePicture?.path || '';
    const contentUrl = (0, $1RkMx.getContentLink)(feedItem?.content);
    const contentId = feedItem?.content?.id || '';
    const contentType = feedItem?.content?.type || 'page';
    const contentSubType = feedItem?.content?.subType;
    const contentTitle = feedItem?.content?.title || '';
    const contentExcerpt = feedItem?.content?.excerpt;
    const creationDate = feedItem?.content?.history?.createdDate || '';
    const friendlyWhen = feedItem?.content?.version?.friendlyWhen || '';
    const spaceName = feedItem?.content?.space?.name || '';
    const spaceId = feedItem?.content?.space?.id || '';
    const spaceUrl = (0, $1RkMx.getSpaceLink)(feedItem?.content);
    const numComments = feedItem?.content?.metadata?.comments?.commentsCount || 0;
    const emoji = (0, $8rneB.getEmojiValueFromContent)(feedItem?.content);
    const isLivePage = contentType === 'page' && contentSubType === 'live';
    // V2 path: aiProperty is resolved directly on PopularFeedItem (parallel with content hop)
    // Narrow via 'in' check rather than type assertion (avoids no-unnecessary-type-assertion).
    const aiSnippetV2 = feedItem && 'aiProperty' in feedItem ? feedItem.aiProperty?.objectData : undefined;
    // V1 path: aiProperty is nested under content (serial — waits for Confluence hop)
    // Narrow via 'in' check; TS infers aiProperty's type from the narrowing.
    const v1Content = feedItem?.content;
    const aiSnippetV1 = v1Content && 'aiProperty' in v1Content ? v1Content.aiProperty?.objectData : undefined;
    // Use the NO-exposure gate variants here. PopularFeedCard renders many
    // times per scroll (one per visible card), so a non-suppressing gate
    // would over-fire exposures and skew experiment cohort/arm sizes.
    // Exposure for each gate is already logged exactly once per render at
    // the point of decision in the hook above:
    //   - `confluence_ai_snippets_popular_feed` fires in V2's `skipQuery`
    //     via `expValEquals(...)` (see usePopularFeedWithTimeGranularityStorage).
    //   - `confluence_ai_snippets_in_following_popular_feeds` fires in
    //     the V1-with-snippets path via the experiment SDK upstream.
    const hasAiSnippetV2 = aiSnippetV2 && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_popular_feed', 'isEnabled', true);
    const hasAiSnippet = hasAiSnippetV2 || aiSnippetV1 && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true);
    const aiSnippet = hasAiSnippetV2 ? aiSnippetV2 : aiSnippetV1;
    // `aiSnippet` can be `null` when the GraphQL field resolved to `null`.
    // `contentExcerpt` prop is typed as `string | undefined`, so coerce nulls.
    const summaryContent = (hasAiSnippet ? aiSnippet : contentExcerpt) ?? undefined;
    const handleMouseEnter = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        setHasBeenHovered(true);
    }, [
        setHasBeenHovered
    ]);
    const fireAnalyticsEvent = (0, $9HGVt.useFeedCardAnalyticsEvents)(contentId, spaceId, 'popular', {
        ranking: ranking,
        contentType: contentType,
        creationDate: new Date(creationDate).getTime(),
        commentsCount: numComments,
        popularFeedTimeGranularity: timeGranularity
    });
    const onObserved = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent({
            type: 'sendTrackEvent',
            action: 'observed',
            actionSubject: 'popular-feedCard'
        });
    }, [
        fireAnalyticsEvent
    ]);
    (0, $fgRQY.useElementSeenCallback)(bottomOfCardRef, onObserved);
    const feedCardContextValue = (0, $42omo.useMemo)(()=>({
            fireAnalyticsEvent: fireAnalyticsEvent
        }), [
        fireAnalyticsEvent
    ]);
    if (!contentId) return null;
    // check if page owner exists and content is not a blog
    // checking against the name here for the case of anonymous users
    const shouldUsePageOwner = ownerName && contentType === 'page';
    const preloadOptions = Boolean((0, $1NBp8.SPACE_OVERVIEW).match(contentUrl)) ? (0, $hXDOc.PreloadingPresets).onlyJSAndCriticalData : (0, $hXDOc.PreloadingPresets).onlyJS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cYSIK.FeedCardContext).Provider, {
        value: feedCardContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dYA5q.LivePagePreloader), {
        isLivePage: isLivePage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXDOc.HoverPreloader), {
        name: "popular-feed-card",
        preloadUrl: contentUrl,
        preloadOptions: preloadOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $28g78.Wrapper), {
        "data-testid": "popular-feed-card",
        isActionMenuOpen: isActionMenuOpen,
        disableAnimation: isMounted || disableAnimation,
        onMouseEnter: handleMouseEnter,
        onFocus: handleMouseEnter,
        "data-vc": "popular-feed-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hsR9s.FeedCardInvisibleFullSizedLink), {
        href: contentUrl,
        popularFeedTimeGranularity: timeGranularity,
        hasAiSnippet: !!hasAiSnippet
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $71e84ff29d608aa6$var$avatarWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: shouldUsePageOwner ? ownerId : authorId,
        src: shouldUsePageOwner ? ownerSrc : authorSrc,
        canViewProfile: true,
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gW7vR.FeedCardBody), {
        emoji: emoji,
        contentId: contentId,
        contentTitle: contentTitle,
        contentType: contentType,
        contentSubType: contentSubType,
        contentUrl: contentUrl,
        authorName: authorName,
        authorId: authorId,
        ownerName: ownerName,
        ownerId: ownerId,
        spaceId: spaceId,
        spaceName: spaceName,
        spaceUrl: spaceUrl,
        contentExcerpt: summaryContent,
        numComments: numComments,
        popularCardLayout: true,
        timestamp: friendlyWhen,
        source: "popular-feed",
        popularFeedTimeGranularity: timeGranularity,
        hasAiSnippet: !!hasAiSnippet
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: bottomOfCardRef,
        "data-vc": "AzYa3WNg"
    })))));
});
module.exports["PopularFeedCard"] = $71e84ff29d608aa6$export$eb5305221596eaa9;

});

parcelRegister("eefUQ", function(module, exports) {
module.exports = new URL("GenericErrorImg.826dcb3b.svg", import.meta.url).toString();

});

parcelRegister("1RkMx", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $7d47f5bc91bbf66b$export$6ac0c298737bc979 = (content)=>{
    if (!content?.links?.webui) return '';
    return `${0, $jlIaF.CONTEXT_PATH}${content.links.webui}`;
};
const $7d47f5bc91bbf66b$export$e86d0abb53b9a540 = (comment)=>{
    if (!comment?.links?.webui) return '';
    return `${0, $jlIaF.CONTEXT_PATH}${comment.links.webui}`;
};
const $7d47f5bc91bbf66b$export$cefcfecf0835bcd9 = (content)=>{
    const spaceKey = content?.space?.key;
    if (!spaceKey) return '';
    const spaceAlias = content?.space?.alias || spaceKey;
    return (0, $1NBp8.SPACE_OVERVIEW).toUrl({
        spaceKey: spaceAlias
    });
};
const $7d47f5bc91bbf66b$export$7b19d7075992aee9 = (user)=>{
    if (user) return 'accountId' in user ? user.accountId : null;
    return null;
};
const $7d47f5bc91bbf66b$export$5590fc0a438aa324 = (update, contentUrl, contentId)=>{
    const type = update.type;
    if (type === 'COMMENT') {
        const commentLink = update.comment?.links.webui;
        if (commentLink) return `${0, $jlIaF.CONTEXT_PATH}${commentLink}`;
        else return '';
    }
    if (type === 'CREATE' || type === 'EDITLIVE' || type === 'PUBLISHLIVE' || type === 'EDIT' && (0, $9wGTI.fg)('confluence_should_remove_versions_from_feed_link')) return contentUrl;
    if (type === 'EDIT') {
        const version = update.version;
        const params = {
            query: {
                pageId: contentId,
                selectedPageVersions: [
                    version,
                    version - 1
                ]
            }
        };
        return (0, $1NBp8.PAGE_DIFF_BY_VERSION).toUrl({}, params);
    }
    return '';
};
const $7d47f5bc91bbf66b$var$supportedEventTypes = [
    'COMMENT',
    'CREATE',
    'EDIT',
    'EDITLIVE',
    'PUBLISHLIVE'
];
const $7d47f5bc91bbf66b$export$15fc850235b13c90 = (type)=>{
    return $7d47f5bc91bbf66b$var$supportedEventTypes.includes(type);
};
module.exports["getContentLink"] = $7d47f5bc91bbf66b$export$6ac0c298737bc979;
module.exports["getCommentLink"] = $7d47f5bc91bbf66b$export$e86d0abb53b9a540;
module.exports["getSpaceLink"] = $7d47f5bc91bbf66b$export$cefcfecf0835bcd9;
module.exports["getUserAccountId"] = $7d47f5bc91bbf66b$export$7b19d7075992aee9;
module.exports["getLinkForSummaryLinkUpdate"] = $7d47f5bc91bbf66b$export$5590fc0a438aa324;
module.exports["isSupportedEvent"] = $7d47f5bc91bbf66b$export$15fc850235b13c90;

});

parcelRegister("fYx4v", function(module, exports) {
/* ActivityLineUpdateLink.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $3gadb = parcelRequire("3gadb");


var $cYSIK = parcelRequire("cYSIK");


var $dmmkE = parcelRequire("dmmkE");

const $20d90973ca3cec9c$var$i18n = (0, $aXWIB.defineMessages)({
    anonymousUser: {
        id: "feed.card.anonymousUser",
        defaultMessage: "Anonymous User"
    },
    displayName: {
        id: "feed.card.displayName",
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: "{name}"
    },
    createAction: {
        id: "feed.card.createAction",
        defaultMessage: "created"
    },
    editAction: {
        id: "feed.card.editAction",
        defaultMessage: "{num, plural,\n      one {edited}\n      other {edited {num} times}}"
    },
    updateAction: {
        id: "feed.card.updateAction",
        defaultMessage: "{num, plural,\n\t\t\tone {updated}\n\t\t\tother {updated {num} times}}"
    },
    publishLiveAction: {
        id: "feed.card.publishAction",
        defaultMessage: "published"
    },
    commentAction: {
        id: "feed.card.commentAction",
        defaultMessage: "{num, plural,\n      one {commented}\n      other {commented {num} times}}"
    },
    unknownAction: {
        id: "feed.card.unknownAction",
        defaultMessage: "Unknown update"
    }
});
const $20d90973ca3cec9c$var$NameWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _syazi7uo _k48p1wq8 _1bto1l2s _o5721q9c _2hwx1b66",
            __cmplp.className
        ])
    });
});
const $20d90973ca3cec9c$var$ActivityDescriptorContainer = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { activityDropdownLineItem: activityDropdownLineItem, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.activityDropdownLineItem ? "_p12f1ogy" : "_p12f1kw7",
            __cmplp.className
        ])
    });
});
const $20d90973ca3cec9c$var$ActionWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_p12f1ns9",
            __cmplp.className
        ])
    });
});
// This component is used by both feed activities (FeedContentQuery's FeedEventType) and recent actions activities (FeedCardAllActivityQuery's PageActivityAction, mapped in activityLineHelpers.ts to match FeedEventType)
const $20d90973ca3cec9c$var$ActivityLineUpdateLinkComponent = ({ type: type, userDisplayName: userDisplayName, link: link, groupSize: groupSize, intl: intl, activityDropdownLineItem: activityDropdownLineItem })=>{
    const displayName = userDisplayName || intl.formatMessage($20d90973ca3cec9c$var$i18n.anonymousUser);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $42omo.useContext)((0, $cYSIK.FeedCardContext));
    const [showNameWithTooltip, setShowNameWithTooltip] = (0, $42omo.useState)(false);
    const activityDescriptorNode = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        // Check if the displayName is truncated before adding tooltip; 270 represents the available
        // flex area of the parent div (fixed width from dropdown)
        if (activityDescriptorNode.current && activityDescriptorNode.current.scrollWidth >= 270 && activityDropdownLineItem) setShowNameWithTooltip(true);
    }, [
        activityDropdownLineItem
    ]);
    const handleClick = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent({
            type: 'sendUIEvent',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'feedCardActivityLink',
            includeNavdex: true,
            additionalAttributes: {
                activityType: type,
                isDropdown: activityDropdownLineItem
            }
        });
    }, [
        type,
        activityDropdownLineItem,
        fireAnalyticsEvent
    ]);
    const renderButtonBody = ()=>{
        const i18nValues = {
            num: groupSize
        };
        switch(type){
            case 'CREATE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $20d90973ca3cec9c$var$i18n.createAction);
            case 'EDIT':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...$20d90973ca3cec9c$var$i18n.updateAction,
                    values: i18nValues
                });
            case 'EDITLIVE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...$20d90973ca3cec9c$var$i18n.editAction,
                    values: i18nValues
                });
            case 'PUBLISHLIVE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $20d90973ca3cec9c$var$i18n.publishLiveAction);
            case 'COMMENT':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...$20d90973ca3cec9c$var$i18n.commentAction,
                    values: i18nValues
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $20d90973ca3cec9c$var$i18n.unknownAction);
        }
    };
    const i18nNameValues = {
        name: displayName
    };
    const activityDescriptor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20d90973ca3cec9c$var$ActivityDescriptorContainer, {
        activityDropdownLineItem: activityDropdownLineItem,
        ref: activityDescriptorNode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20d90973ca3cec9c$var$NameWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$20d90973ca3cec9c$var$i18n.displayName,
        values: i18nNameValues
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20d90973ca3cec9c$var$ActionWrapper, null, renderButtonBody()));
    const activityDescriptorTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...$20d90973ca3cec9c$var$i18n.displayName,
            values: i18nNameValues
        }),
        testId: displayName
    }, activityDescriptor);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dmmkE.SubtleLink), {
        href: link,
        onClick: handleClick,
        testId: `${displayName}-${type}-${groupSize}`
    }, showNameWithTooltip ? activityDescriptorTooltip : activityDescriptor);
};
const $20d90973ca3cec9c$export$99d1f46490b86fbf = (0, $aXWIB.injectIntl)($20d90973ca3cec9c$var$ActivityLineUpdateLinkComponent);
module.exports["ActivityLineUpdateLink"] = $20d90973ca3cec9c$export$99d1f46490b86fbf;

});

parcelRegister("6OiEk", function(module, exports) {

var $wHo13 = parcelRequire("wHo13");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $4KS7f = parcelRequire("4KS7f");


var $l8oxh = parcelRequire("l8oxh");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $lsxnT = parcelRequire("lsxnT");


var $cYSIK = parcelRequire("cYSIK");


var $aOmNU = parcelRequire("aOmNU");


var $j9RXG = parcelRequire("j9RXG");


var $9WXEQ = parcelRequire("9WXEQ");


var $ip3cc = parcelRequire("ip3cc");


var $jMyy4 = parcelRequire("jMyy4");

const $502d75b496aac139$var$AllActivityDropdownFeedCardAllActivityQuery = (0, $wHo13.default);
const $502d75b496aac139$var$i18n = (0, $aXWIB.defineMessages)({
    otherActions: {
        id: "feed.card.otherActions",
        defaultMessage: "{num} recent {num, plural, one {action} other {actions} }"
    },
    otherActionsWithoutNumber: {
        id: "feed.card.otherActionsWithoutNumber",
        defaultMessage: "Recent actions"
    }
});
// Inline dialog component wraps this with 16px 24px padding by default,
// so we need to compensate for that with a negative margin
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $502d75b496aac139$var$ActionDialog = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsbjwe6 _c71lo8uj _18m91wug _1reo15vq _19bvpxbi _u5f3pxbi _ca0qpxbi _n3tdv77o",
            __cmplp.className
        ])
    });
});
const $502d75b496aac139$var$buttonTheme = (currentTheme, themeProps)=>{
    const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            marginRight: "var(--ds-space-050, 4px)",
            fontWeight: "var(--ds-font-weight-regular, 400)",
            color: "var(--ds-text-subtle, #505258)"
        },
        spinnerStyles: spinnerStyles
    };
};
const $502d75b496aac139$var$AllActivityDropdownComponent = ({ contentUrl: contentUrl, contentId: contentId, recentActionsCount: recentActionsCount, shouldShowRecentActionsCountNumber: shouldShowRecentActionsCountNumber = true })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $42omo.useContext)((0, $cYSIK.FeedCardContext));
    const [hovered, setHovered] = (0, $42omo.useState)(false);
    const [dialogOpen, setDialogOpen] = (0, $42omo.useState)(false);
    const [nextPageError, setNextPageError] = (0, $42omo.useState)();
    const thirtyDaysAgo = (0, $42omo.useMemo)(()=>{
        const currentDate = new Date();
        const date = new Date(currentDate.setDate(currentDate.getDate() - 30));
        return date.toISOString();
    }, []);
    const { data: data, error: firstPageError, loading: loading, fetchMore: fetchMore } = (0, $jMyy4.useQueryInterop)($502d75b496aac139$var$AllActivityDropdownFeedCardAllActivityQuery, {
        variables: {
            contentId: contentId,
            fromDate: thirtyDaysAgo
        },
        skip: !(dialogOpen || hovered),
        __callerPackage__: "@confluence/feed"
    });
    const error = firstPageError || nextPageError;
    const hasNextPage = data?.pageActivity?.pageInfo?.hasNextPage;
    const endCursor = data?.pageActivity?.pageInfo?.endCursor;
    const onHover = (0, $42omo.useCallback)(()=>{
        if (!hovered) setHovered(true);
    }, [
        setHovered,
        hovered
    ]);
    const toggleDialog = (0, $42omo.useCallback)(()=>{
        setDialogOpen((open)=>!open);
    }, [
        setDialogOpen
    ]);
    const closeDialog = (0, $42omo.useCallback)(()=>{
        setDialogOpen(false);
    }, [
        setDialogOpen
    ]);
    const updates = data?.pageActivity?.nodes || [];
    (0, $42omo.useEffect)(()=>{
        if (dialogOpen) fireAnalyticsEvent({
            type: 'sendTrackEvent',
            action: 'more',
            actionSubject: 'recentActions',
            actionSubjectId: 'feedCardRecentActionsPeak'
        });
    }, [
        dialogOpen,
        fireAnalyticsEvent
    ]);
    const handlePagination = (0, $42omo.useCallback)(async ()=>{
        try {
            await fetchMore({
                variables: {
                    contentId: contentId,
                    after: endCursor,
                    fromDate: thirtyDaysAgo
                },
                updateQuery: (prevResults, { fetchMoreResult: fetchMoreResult })=>{
                    if (!fetchMoreResult) return prevResults;
                    fetchMoreResult.pageActivity.nodes = prevResults.pageActivity.nodes.concat(fetchMoreResult.pageActivity.nodes);
                    return fetchMoreResult;
                }
            });
        } catch (e) {
            setNextPageError(e);
        }
    }, [
        fetchMore,
        endCursor,
        contentId,
        thirtyDaysAgo
    ]);
    const renderEndOfActivityList = ()=>{
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $j9RXG.AllActivityError), null));
        if (!loading && hasNextPage && endCursor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l8oxh.InfiniteScroll), {
            onScrollTo: handlePagination,
            cursor: endCursor,
            observerOptions: {
                root: null,
                threshold: 0.05
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9WXEQ.ActivityLineUpdateDetailSkeleton), null));
        return null;
    };
    const renderDialogBody = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9WXEQ.ActivityLineUpdateDetailSkeleton), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, updates.map((update)=>{
            if (update) {
                const type = (0, $ip3cc.getSupportedUpdateType)(update.actionSubject, update.action);
                if (type) {
                    const userId = update.user?.id || null;
                    const avatarUrl = (0, $ip3cc.getAvatarUrl)(update.user?.photos || null);
                    const name = update.user?.displayName || null;
                    const actionTime = update.timestamp;
                    const link = (0, $ip3cc.getUpdateContentUrl)(update, contentUrl, contentId);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aOmNU.ActivityLineUpdateDetail), {
                        key: `${type}-${userId}-${actionTime}`,
                        type: type,
                        actionTime: actionTime,
                        userId: userId,
                        avatarUrl: avatarUrl,
                        userDisplayName: name,
                        link: link,
                        groupSize: update.groupSize
                    });
                }
            }
            return null;
        }), renderEndOfActivityList());
    };
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Popup, {
        isOpen: dialogOpen,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($502d75b496aac139$var$ActionDialog, null, renderDialogBody()),
        onClose: closeDialog,
        placement: "bottom-end",
        shouldRenderToParent: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
                onClick: toggleDialog,
                onMouseEnter: onHover,
                theme: $502d75b496aac139$var$buttonTheme,
                appearance: "subtle-link",
                spacing: "none",
                ...triggerProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...shouldShowRecentActionsCountNumber ? $502d75b496aac139$var$i18n.otherActions : $502d75b496aac139$var$i18n.otherActionsWithoutNumber,
                values: {
                    num: recentActionsCount
                }
            }))
    });
};
const $502d75b496aac139$export$8436016812042c6f = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).SMARTS
})($502d75b496aac139$var$AllActivityDropdownComponent);
module.exports["AllActivityDropdown"] = $502d75b496aac139$export$8436016812042c6f;

});

parcelRegister("3WnxN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $1YXTQ = parcelRequire("1YXTQ");

const $8830968965c7c211$export$dd2d586e2f48f039 = ({ actionTime: actionTime })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: new Date(actionTime).toLocaleString(),
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
        date: actionTime
    }));
};
module.exports["ActionTime"] = $8830968965c7c211$export$dd2d586e2f48f039;

});

parcelRegister("9HGVt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $56QzY = parcelRequire("56QzY");


var $6GgH7 = parcelRequire("6GgH7");

const $7a1c331147479904$var$getStatsObjectAndContainerAttributes = (contentId, spaceId, commentId)=>{
    if (commentId) return {
        containerType: 'page',
        containerId: contentId,
        objectType: 'comment',
        objectId: commentId
    };
    return {
        containerType: 'space',
        containerId: spaceId,
        objectType: 'page',
        objectId: contentId
    };
};
const $7a1c331147479904$export$6fb5b9efe5001412 = (contentId, spaceId, actionSubjectIdPrefix, baseAttributes)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const feedContext = (0, $42omo.useContext)((0, $6GgH7.FeedContext));
    return (0, $42omo.useCallback)(({ type: type, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, commentId: commentId, additionalAttributes: additionalAttributes = {}, includeNavdex: includeNavdex = false })=>{
        const objectAndContainer = $7a1c331147479904$var$getStatsObjectAndContainerAttributes(contentId, spaceId, commentId);
        const getActionSubjectId = ()=>{
            if (actionSubjectId) return `${actionSubjectIdPrefix}-${actionSubjectId}`;
            return actionSubjectIdPrefix;
        };
        createAnalyticsEvent({
            type: type,
            data: {
                source: 'homeScreen',
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: getActionSubjectId(),
                ...objectAndContainer,
                attributes: {
                    ...baseAttributes,
                    ...additionalAttributes,
                    ...includeNavdex && {
                        navdexPointType: (0, $56QzY.START_TOUCH)
                    },
                    feedSessionId: feedContext.feedSessionId
                }
            }
        }).fire();
    }, [
        contentId,
        spaceId,
        baseAttributes,
        actionSubjectIdPrefix,
        createAnalyticsEvent,
        feedContext.feedSessionId
    ]);
};
module.exports["useFeedCardAnalyticsEvents"] = $7a1c331147479904$export$6fb5b9efe5001412;

});

parcelRegister("dKup5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $0c7f1f3745818de3$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        isMounted.current = true;
    }, []);
    return isMounted.current;
};
module.exports["useIsMounted"] = $0c7f1f3745818de3$export$80c2a3957bcb42ea;

});

parcelRegister("fWjNm", function(module, exports) {
const $b52ba06964ef5ea9$export$5cecd2906004a9f9 = {
    COMMENT: 'COMMENT',
    CREATE: 'CREATE',
    EDIT: 'EDIT',
    EDITLIVE: 'EDITLIVE',
    PUBLISHLIVE: 'PUBLISHLIVE'
};
const $b52ba06964ef5ea9$export$27d1ac5a175e8bbf = {
    PERSON: 'PERSON',
    SPACE: 'SPACE'
};
module.exports["FeedEventType"] = $b52ba06964ef5ea9$export$5cecd2906004a9f9;
module.exports["FeedItemSourceType"] = $b52ba06964ef5ea9$export$27d1ac5a175e8bbf;

});

parcelRegister("cYSIK", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $cef4e67e3b7fa439$export$3d8687caae60568b = (0, $42omo.createContext)({
    fireAnalyticsEvent: ()=>{}
});
module.exports["FeedCardContext"] = $cef4e67e3b7fa439$export$3d8687caae60568b;

});

parcelRegister("gW7vR", function(module, exports) {
/* FeedCardBody.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8SCD6 = parcelRequire("8SCD6");


var $bJFcf = parcelRequire("bJFcf");


var $aG5uJ = parcelRequire("aG5uJ");


var $gk2mg = parcelRequire("gk2mg");


var $hlJJ7 = parcelRequire("hlJJ7");


var $8dkgs = parcelRequire("8dkgs");


var $37OMg = parcelRequire("37OMg");

const $73a9bc6a07a5ae59$var$FollowingCardBody = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_x3doia51 _ca0qu2gc",
            __cmplp.className
        ])
    });
});
const $73a9bc6a07a5ae59$var$PopularCardBody = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $73a9bc6a07a5ae59$var$ContentExcerpt = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _c71l1ylp _otyrutpp _1e0ccj1k _1yyjcs5v _sudp1e54 _1bto1l2s _1nmz1hna",
            __cmplp.className
        ])
    });
});
const $73a9bc6a07a5ae59$var$PageDetails = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $73a9bc6a07a5ae59$var$TitleAndActionsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1y6m _otyrutpp",
            __cmplp.className
        ])
    });
});
const $73a9bc6a07a5ae59$var$TitleAndBylineWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $73a9bc6a07a5ae59$var$PageDetailsContentWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1ul9idpf _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $73a9bc6a07a5ae59$var$CommentsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_x3doia51 _19pkutpp _ca0qutpp _n3tdidpf",
            __cmplp.className
        ])
    });
});
const $73a9bc6a07a5ae59$var$getShowCommentState = (shouldHideComments, comment, commentVisible)=>{
    if (!shouldHideComments) return (0, $8dkgs.ShowCommentState).Number;
    if (!!comment) return commentVisible ? (0, $8dkgs.ShowCommentState).HideComment : (0, $8dkgs.ShowCommentState).ShowComment;
    return (0, $8dkgs.ShowCommentState).NoShow;
};
const $73a9bc6a07a5ae59$export$12ab4c22e8a2eeb5 = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, contentTitle: contentTitle, contentType: contentType, contentSubType: contentSubType, contentUrl: contentUrl, spaceId: spaceId, spaceName: spaceName, spaceUrl: spaceUrl, authorName: authorName, authorId: authorId, ownerName: ownerName, ownerId: ownerId, emoji: emoji, customIconUrl: customIconUrl, contentExcerpt: contentExcerpt, numComments: numComments, hideSocialProof: hideSocialProof, comment: comment, renderedContent: renderedContent, popularCardLayout: popularCardLayout = false, timestamp: timestamp, hideActions: hideActions, source: source, shouldHideComments: shouldHideComments, popularFeedTimeGranularity: popularFeedTimeGranularity, followingFeedSortby: followingFeedSortby, hasAiSnippet: hasAiSnippet })=>{
    const CardBody = popularCardLayout ? $73a9bc6a07a5ae59$var$PopularCardBody : $73a9bc6a07a5ae59$var$FollowingCardBody;
    // check if page owner exists and content is not a blog
    // checking against the name here for the case of anonymous users
    const shouldUsePageOwner = ownerName && contentType === 'page';
    const [commentVisible, setCommentVisible] = (0, $42omo.useState)(false);
    const onCommentToggleClick = (0, $42omo.useCallback)(()=>{
        setCommentVisible(!commentVisible);
    }, [
        commentVisible
    ]);
    const showCommentState = $73a9bc6a07a5ae59$var$getShowCommentState(shouldHideComments, comment, commentVisible);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8SCD6.ReactionsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CardBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($73a9bc6a07a5ae59$var$PageDetails, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($73a9bc6a07a5ae59$var$PageDetailsContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($73a9bc6a07a5ae59$var$TitleAndActionsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($73a9bc6a07a5ae59$var$TitleAndBylineWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gk2mg.FeedCardTitle), {
        contentTitle: contentTitle,
        contentUrl: contentUrl,
        contentType: contentType,
        contentSubType: contentSubType,
        emoji: emoji,
        customIconUrl: customIconUrl,
        popularFeedTimeGranularity: popularFeedTimeGranularity,
        followingFeedSortby: followingFeedSortby,
        hasAiSnippet: hasAiSnippet
    }), shouldUsePageOwner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hlJJ7.FeedCardByLine), {
        spaceName: spaceName,
        spaceUrl: spaceUrl,
        ownerName: ownerName,
        ownerId: ownerId,
        timestamp: timestamp,
        popularFeedTimeGranularity: popularFeedTimeGranularity,
        followingFeedSortby: followingFeedSortby
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hlJJ7.FeedCardByLine), {
        spaceName: spaceName,
        spaceUrl: spaceUrl,
        authorName: authorName,
        authorId: authorId,
        timestamp: timestamp,
        popularFeedTimeGranularity: popularFeedTimeGranularity,
        followingFeedSortby: followingFeedSortby
    })), !hideActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $37OMg.FeedCardActions), {
        contentId: contentId
    })), contentExcerpt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($73a9bc6a07a5ae59$var$ContentExcerpt, null, contentExcerpt), !hideSocialProof && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8dkgs.FeedCardActionCounts), {
        numComments: numComments,
        contentId: contentId,
        contentType: contentType,
        spaceId: spaceId,
        source: source,
        showCommentState: showCommentState,
        onCommentToggleClick: onCommentToggleClick,
        popularFeedTimeGranularity: popularFeedTimeGranularity,
        followingFeedSortby: followingFeedSortby
    }))), comment && (!shouldHideComments || commentVisible) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($73a9bc6a07a5ae59$var$CommentsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bJFcf.Comments), {
        comments: [
            comment
        ],
        pageId: contentId,
        contentType: contentType
    })), renderedContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aG5uJ.RenderedContent), {
        content: renderedContent
    })));
});
module.exports["FeedCardBody"] = $73a9bc6a07a5ae59$export$12ab4c22e8a2eeb5;

});

parcelRegister("hsR9s", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4KS7f = parcelRequire("4KS7f");


var $fYQcF = parcelRequire("fYQcF");


var $1C3B1 = parcelRequire("1C3B1");


var $lXYVJ = parcelRequire("lXYVJ");


var $dPJCf = parcelRequire("dPJCf");


var $lpPVE = parcelRequire("lpPVE");


var $71GjD = parcelRequire("71GjD");


var $9wGTI = parcelRequire("9wGTI");


var $cYSIK = parcelRequire("cYSIK");

const $69c78bcd9639efb3$var$fullSizeButtonTheme = (currentTheme, themeProps)=>{
    const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            position: 'absolute',
            top: '0px',
            left: '0px',
            width: '100%',
            height: '100%'
        },
        spinnerStyles: spinnerStyles
    };
};
const $69c78bcd9639efb3$export$a031aa7f3c991e0 = ({ href: href, contentType: contentType, popularFeedTimeGranularity: popularFeedTimeGranularity, followingFeedSortBy: followingFeedSortBy, hasAiSnippet: hasAiSnippet })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $42omo.useContext)((0, $cYSIK.FeedCardContext));
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    const feedType = popularFeedTimeGranularity ? 'popularFeed' : 'followingFeed';
    const handleClick = (0, $42omo.useCallback)((e)=>{
        if (hasAiSnippet) trackAIResultAction(`${feedType}aiSnippetClicked`);
        if (contentType && contentType === 'page') (0, $lXYVJ.setViewTransitionSource)((0, $1C3B1.DISCOVER_ITEM_ON_HOME_PAGE_CLICK));
        fireAnalyticsEvent({
            type: 'sendUIEvent',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'feedCard',
            includeNavdex: true,
            additionalAttributes: {
                popularFeedTimeGranularity: popularFeedTimeGranularity,
                followingFeedSortBy: followingFeedSortBy
            }
        });
        if ((0, $9wGTI.fg)('confluence_frontend_insights_feature_attribution')) {
            e.preventDefault();
            if (e.metaKey || e.ctrlKey) window.open((0, $lpPVE.generatePathWithFeatureCodesQueryParam)(href, [
                (0, $71GjD.FeatureCode).HOME_FEED
            ]));
            else push((0, $lpPVE.generatePathWithFeatureCodesQueryParam)(href, [
                (0, $71GjD.FeatureCode).HOME_FEED
            ]));
        }
    }, [
        contentType,
        fireAnalyticsEvent,
        popularFeedTimeGranularity,
        followingFeedSortBy,
        href,
        push,
        hasAiSnippet,
        trackAIResultAction,
        feedType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        href: href,
        appearance: "link",
        theme: $69c78bcd9639efb3$var$fullSizeButtonTheme,
        onClick: handleClick,
        testId: "feed-card-body-link",
        "aria-hidden": true,
        tabIndex: -1
    });
};
module.exports["FeedCardInvisibleFullSizedLink"] = $69c78bcd9639efb3$export$a031aa7f3c991e0;

});

parcelRegister("kZ8dV", function(module, exports) {
/**
 * @generated SignedSource<<4b20c8dbd98debe9a6386efeb78c9c87>>
 * @relayHash aa6cdcfd10bb544288b09784eefe7c84
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2821f13a8a9d144e2ce53fda36afe64d8ae1da03d3110c5a29d7f58c140d051f
const $bc2208ff97e81e43$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "title"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v8 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v9 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 350
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:350)"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v12 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v10 /*: any*/ 
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v14 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v15 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v16 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v17 = {
        "kind": "InlineFragment",
        "selections": v16 /*: any*/ ,
        "type": "KnownUser"
    }, v18 = {
        "kind": "InlineFragment",
        "selections": v16 /*: any*/ ,
        "type": "UnknownUser"
    }, v19 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v20 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "friendlyWhen"
            }
        ]
    }, v21 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "FilterByLabelFeedQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v3 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v21 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "FilterByLabelFeedQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v3 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v22 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v22 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v21 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "aa6cdcfd10bb544288b09784eefe7c84",
            "id": "2821f13a8a9d144e2ce53fda36afe64d8ae1da03d3110c5a29d7f58c140d051f",
            "metadata": {},
            "name": "FilterByLabelFeedQuery",
            "operationKind": "query",
            "text": "query FilterByLabelFeedQuery($cql:String!,$first:Int,$after:String){search:confluence_search(cql:$cql,first:$first,after:$after){nodes{content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},excerpt(length:350),labels{nodes{name,id}},links{webui},space{id,key,name},history{createdDate,createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}}},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}},version{friendlyWhen}}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$bc2208ff97e81e43$var$node.hash = "c1730f3bbce99bdbe9fb21dac52e8191";
var $bc2208ff97e81e43$export$2e2bcd8739ae039 = $bc2208ff97e81e43$var$node;
module.exports["default"] = $bc2208ff97e81e43$export$2e2bcd8739ae039;

});

parcelRegister("k11sS", function(module, exports) {
/* FeedTypePill.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $inPa6 = parcelRequire("inPa6");

const $0a8bc1b292ee71ca$var$FeedTypePillButton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _11c8fhey _1reo15vq _18m915vq _1yt4u2gc _2rko1rr0 _vchhusvi _1e0c116y _19pkidpf _uiztglyw _p12f1osq _1bto1l2s _o5721q9c _s7n4jp4b _80omtlke _4cvr1h6o _4t3izwfg _y2mvdfik _858u1j28",
            __cmplp.selected ? "_bfhk15s3" : "_bfhki8nm",
            __cmplp.selected ? "_syaz1oa5" : "_syazi7uo",
            __cmplp.selected ? "_irr3ufnl" : "_irr3plhp",
            __cmplp.selected ? "_19itscp5" : "_19itbjo2",
            __cmplp.className
        ])
    });
});
const $0a8bc1b292ee71ca$var$IconWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4t3i1osq _4cvr1h6o _2hwx1b66",
            __cmplp.className
        ])
    });
});
const $0a8bc1b292ee71ca$export$987ad80a1f37dfd7 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ feedType: feedType, selectedFeedType: selectedFeedType, setFeedType: setFeedType, Icon: Icon, children: children, isPulseActive: isPulseActive = false, onPulseClick: onPulseClick = ()=>{} }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        if (selectedFeedType !== feedType) {
            setFeedType(feedType);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'feedTypeSelector',
                    actionSubjectId: feedType.toLowerCase(),
                    source: 'homeScreen',
                    attributes: {
                        homeVersion: 'visualRefresh'
                    }
                }
            }).fire();
        }
    }, [
        feedType,
        selectedFeedType,
        setFeedType,
        createAnalyticsEvent
    ]);
    const handleMouseDown = (0, $42omo.useCallback)((event)=>{
        // prevent focus
        event.preventDefault();
    }, []); // Fire screen event when pulse is active
    (0, $42omo.useEffect)(()=>{
        if (isPulseActive) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'feedTypeSelectorPulse',
                attributes: {
                    feedType: feedType.toLowerCase()
                }
            }
        }).fire();
    }, [
        isPulseActive,
        feedType,
        createAnalyticsEvent
    ]);
    const handlePulseClick = (0, $42omo.useCallback)(()=>{
        if (isPulseActive) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'feedTypeSelectorPulse',
                    attributes: {
                        feedType: feedType.toLowerCase(),
                        homeVersion: 'visualRefresh'
                    },
                    source: 'homeScreen'
                }
            }).fire();
            onPulseClick();
        }
    }, [
        feedType,
        isPulseActive,
        onPulseClick,
        createAnalyticsEvent
    ]);
    const selected = selectedFeedType === feedType;
    const testId = `${feedType.toLowerCase()}-feed-button`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        padding: "space.050",
        onClick: handlePulseClick,
        role: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a8bc1b292ee71ca$var$FeedTypePillButton, {
        selected: selected,
        role: "tab",
        id: `tab-${feedType.toLowerCase()}`,
        "aria-selected": selected,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        "data-testid": testId,
        ref: ref
    }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a8bc1b292ee71ca$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: "",
        color: selected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text, #292A2E)"
    })), children)));
});
module.exports["FeedTypePill"] = $0a8bc1b292ee71ca$export$987ad80a1f37dfd7;

});

parcelRegister("4baog", function(module, exports) {
module.exports = new URL("FeedOnboardingMessageDark.ce65ddfa.svg", import.meta.url).toString();

});

parcelRegister("rzvmf", function(module, exports) {
module.exports = new URL("FeedOnboardingMessageLight.ce863139.svg", import.meta.url).toString();

});

parcelRegister("f4ywA", function(module, exports) {
module.exports = new URL("FeedOnboardingMessageV2Dark.5795c228.svg", import.meta.url).toString();

});

parcelRegister("bCcO6", function(module, exports) {
module.exports = new URL("FeedOnboardingMessageV2Light.3c50255e.svg", import.meta.url).toString();

});

parcelRegister("dFUHi", function(module, exports) {
/**
 * @generated SignedSource<<dcf385b89d92f2964cff510ee5fd1f54>>
 * @relayHash b78a3d13d04f56d173c6257458e006c5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d6ffcaf3ec188b6d12846c50d9b0b45d04d314b7de466c91f3f29648c59a0a2a
const $0bffe2d62791c3e6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "dismissTime"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "feedRecommendedUserSettingsDismissTimestamp",
                            "variableName": "dismissTime"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "feedRecommendedUserSettingsDismissTimestamp"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FeedRecommendationsFeedRecDismissMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FeedRecommendationsFeedRecDismissMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "b78a3d13d04f56d173c6257458e006c5",
            "id": "d6ffcaf3ec188b6d12846c50d9b0b45d04d314b7de466c91f3f29648c59a0a2a",
            "metadata": {},
            "name": "FeedRecommendationsFeedRecDismissMutation",
            "operationKind": "mutation",
            "text": "mutation FeedRecommendationsFeedRecDismissMutation($dismissTime:String!){updateUserPreferences(userPreferences:{feedRecommendedUserSettingsDismissTimestamp:$dismissTime}){feedRecommendedUserSettingsDismissTimestamp}}"
        }
    };
}();
$0bffe2d62791c3e6$var$node.hash = "a25c0690e1d844eea2512b1cc3580eb1";
var $0bffe2d62791c3e6$export$2e2bcd8739ae039 = $0bffe2d62791c3e6$var$node;
module.exports["default"] = $0bffe2d62791c3e6$export$2e2bcd8739ae039;

});

parcelRegister("lIZtA", function(module, exports) {

var $j0RU5 = parcelRequire("j0RU5");

const $b9905c37d15f766d$export$288e4801a340fb3c = (error)=>{
    return error.graphQLErrors.every($b9905c37d15f766d$var$isExpectedGraphqlError);
};
const $b9905c37d15f766d$var$isExpectedGraphqlError = (error)=>{
    return (0, $j0RU5.isFeedConfigDeletedSpaceError)(error) || (0, $j0RU5.isFeedConfigSpacePermissionError)(error) || (0, $j0RU5.isFeedConfigUserPermissionError)(error) || $b9905c37d15f766d$var$isFeedDeletedCommentError(error) || $b9905c37d15f766d$export$457f8167a5536003(error) || $b9905c37d15f766d$export$21160c2a9f84c3b7(error);
};
const $b9905c37d15f766d$var$commentErrorPath = [
    'summaryLineUpdate',
    'comment'
];
// Deleted comment error for when the feed attempts to hydrate a deleted comment
const $b9905c37d15f766d$var$isFeedDeletedCommentError = (error)=>{
    return $b9905c37d15f766d$var$commentErrorPath.every((path)=>error.path?.includes(path)) && error.message?.includes('No comment found for the given id');
};
const $b9905c37d15f766d$var$feedRecDeletedSpacePath = [
    'getRecommendedFeedUserConfig',
    'recommendedSpaces',
    'space'
];
const $b9905c37d15f766d$export$457f8167a5536003 = (error)=>{
    return $b9905c37d15f766d$var$feedRecDeletedSpacePath.every((path)=>error.path?.includes(path)) && error.message.includes('Cannot find space with id');
};
const $b9905c37d15f766d$var$summaryLineUpdateUserPath = [
    'feed',
    'nodes',
    'summaryLineUpdate',
    'user'
];
const $b9905c37d15f766d$export$21160c2a9f84c3b7 = (error)=>{
    return $b9905c37d15f766d$var$summaryLineUpdateUserPath.every((path)=>error.path?.includes(path)) && error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $b9905c37d15f766d$export$288e4801a340fb3c;
module.exports["isFeedRecDeletedSpaceError"] = $b9905c37d15f766d$export$457f8167a5536003;

});

parcelRegister("kPlM7", function(module, exports) {

var $lSGGk = parcelRequire("lSGGk");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $4KS7f = parcelRequire("4KS7f");


var $ccHMk = parcelRequire("ccHMk");


var $hmuev = parcelRequire("hmuev");


var $inPa6 = parcelRequire("inPa6");


var $3gadb = parcelRequire("3gadb");


var $dpPtd = parcelRequire("dpPtd");


var $3sFtD = parcelRequire("3sFtD");


var $a3fRD = parcelRequire("a3fRD");


var $b3j2Y = parcelRequire("b3j2Y");


var $iKskQ = parcelRequire("iKskQ");


var $308Wd = parcelRequire("308Wd");


var $hOSkW = parcelRequire("hOSkW");

const $08135afd8c895fad$var$RecommendationTileFeedFollowRecommendationMutation = (0, $lSGGk.default);
const $08135afd8c895fad$var$i18n = (0, $aXWIB.defineMessages)({
    follow: {
        id: "feed.recommendation.tile.follow",
        defaultMessage: "Follow"
    },
    followLabel: {
        id: "feed.recommendation.tile.follow.label",
        defaultMessage: "Follow {name}"
    },
    space: {
        id: "feed.recommendation.tile.space",
        defaultMessage: "Space"
    },
    dismissLabel: {
        id: "feed.recommendation.tile.dismiss.label",
        defaultMessage: "Dismiss {name} recommendation"
    },
    flagFollowTitle: {
        id: "feed.recommendation.flag.follow.success",
        defaultMessage: "Followed {name}"
    },
    flagFollowAction: {
        id: "feed.recommendation.flag.follow.action",
        defaultMessage: "Dismiss"
    },
    flagErrorTitle: {
        id: "feed.recommendation.flag.follow.error",
        defaultMessage: "Could not follow {name}"
    },
    flagErrorDescription: {
        id: "feed.recommendation.flag.follow.error.description",
        defaultMessage: "Please try again later"
    },
    profileTile: {
        id: "feed.recommendation.tile.profile",
        defaultMessage: "{name} profile"
    }
});
const $08135afd8c895fad$export$f2a133baea81f082 = 16;
const $08135afd8c895fad$export$8ec3d08588d2eeda = 4;
const $08135afd8c895fad$var$TILE_WIDTH_PERCENT = 100 / $08135afd8c895fad$export$8ec3d08588d2eeda;
const $08135afd8c895fad$var$TILE_MARGIN_WIDTH = $08135afd8c895fad$export$f2a133baea81f082 * (($08135afd8c895fad$export$8ec3d08588d2eeda - 1) / $08135afd8c895fad$export$8ec3d08588d2eeda);
const $08135afd8c895fad$var$fullSizeButtonTheme = (currentTheme, themeProps)=>{
    const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            position: 'absolute',
            width: '100%',
            height: '100%'
        },
        spinnerStyles: spinnerStyles
    };
};
const $08135afd8c895fad$var$dismissTileButtonTheme = (currentTheme, themeProps)=>{
    const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            position: 'absolute',
            top: "var(--ds-space-050, 4px)",
            right: "var(--ds-space-050, 4px)",
            width: '28px',
            height: '28px'
        },
        spinnerStyles: spinnerStyles
    };
};
const $08135afd8c895fad$var$tileWrapperStyle = null;
const $08135afd8c895fad$var$titleHover = null;
const $08135afd8c895fad$var$loadingStyle = null;
const $08135afd8c895fad$var$userIconStyle = null;
const $08135afd8c895fad$var$nameAndTypeWrapperStyle = null;
const $08135afd8c895fad$var$nameWrapperStyle = null;
const $08135afd8c895fad$var$titlePlaceholderStyle = null;
const $08135afd8c895fad$var$titleOrTypeWrapperStyle = null;
const $08135afd8c895fad$export$debb778f17cf50d6 = ({ name: name, id: id, url: url, icon: icon, type: type, title: title, dismissTile: dismissTile, cardIndex: cardIndex, position: position })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const [tileHover, setTileHover] = (0, $42omo.useState)(true);
    const enableTileHover = (0, $42omo.useCallback)(()=>{
        setTileHover(true);
    }, [
        setTileHover
    ]);
    const disableTileHover = (0, $42omo.useCallback)(()=>{
        setTileHover(false);
    }, [
        setTileHover
    ]);
    const onFollowSuccess = (0, $42omo.useCallback)(()=>{
        dismissTile(id);
        showFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...$08135afd8c895fad$var$i18n.flagFollowTitle,
                values: {
                    name: name
                }
            }),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                color: "var(--ds-icon-success, #6A9A23)",
                label: "Success",
                spacing: "spacious"
            }),
            isAutoDismiss: true
        });
    }, [
        dismissTile,
        id,
        name,
        showFlag
    ]);
    const onFollowError = (0, $42omo.useCallback)(()=>{
        showFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...$08135afd8c895fad$var$i18n.flagErrorTitle,
                values: {
                    name: name
                }
            }),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $08135afd8c895fad$var$i18n.flagErrorDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: "error",
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "spacious"
            }),
            isAutoDismiss: true
        });
    }, [
        name,
        showFlag
    ]);
    const [changeFeedFollows, { loading: followLoading, error: followError }] = (0, $308Wd.useMutationInterop)($08135afd8c895fad$var$RecommendationTileFeedFollowRecommendationMutation, {
        onCompleted: onFollowSuccess,
        onError: onFollowError,
        refetchQueries: [
            {
                query: (0, $hOSkW.default)
            }
        ],
        __callerPackage__: "@confluence/feed"
    });
    const [dismissRecTile, { loading: unfollowLoading, error: unfollowError }] = (0, $308Wd.useMutationInterop)($08135afd8c895fad$var$RecommendationTileFeedFollowRecommendationMutation, {
        __callerPackage__: "@confluence/feed"
    });
    const handleTileLinkButton = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'item',
                actionSubjectId: 'tile',
                source: 'suggestionsCard',
                attributes: {
                    settingId: id,
                    settingType: type,
                    recommendationRank: cardIndex,
                    pos: position
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        id,
        type,
        cardIndex,
        position
    ]);
    const handleTileDismissButton = (0, $42omo.useCallback)(async ()=>{
        dismissRecTile({
            variables: type === 'user' ? {
                unfollowUser: [
                    id
                ]
            } : {
                unfollowSpace: [
                    id
                ]
            }
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismiss',
                source: 'suggestionsCard',
                attributes: {
                    settingId: id,
                    settingType: type,
                    recommendationRank: cardIndex,
                    pos: position
                }
            }
        }).fire();
        dismissTile(id);
    }, [
        dismissTile,
        id,
        dismissRecTile,
        type,
        createAnalyticsEvent,
        cardIndex,
        position
    ]);
    const handleFollowButton = (0, $42omo.useCallback)(()=>{
        changeFeedFollows({
            variables: type === 'user' ? {
                followUser: [
                    id
                ]
            } : {
                followSpace: [
                    id
                ]
            }
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'follow',
                source: 'suggestionsCard',
                attributes: {
                    settingId: id,
                    settingType: type,
                    recommendationRank: cardIndex,
                    pos: position
                }
            }
        }).fire();
    }, [
        changeFeedFollows,
        type,
        id,
        createAnalyticsEvent,
        cardIndex,
        position
    ]);
    const titleOrType = type === 'user' ? title : intl.formatMessage($08135afd8c895fad$var$i18n.space);
    const renderFollowButton = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            onClick: handleFollowButton,
            onMouseEnter: disableTileHover,
            onMouseLeave: enableTileHover,
            appearance: "primary",
            isDisabled: followLoading,
            "aria-label": intl.formatMessage($08135afd8c895fad$var$i18n.followLabel, {
                name: name
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $08135afd8c895fad$var$i18n.follow));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "feed-rec-tile-wrapper",
        className: (0, $gMc0m.default)([
            "_11q71j9a _19itia51 _2rkofajl _1yt4u2gc _kqswh2mm _1e0c1txw _2lx21bp4 _4cvr1h6o _1bahitcz _4t3ikz1e _1o9zidpf _1ul9idpf _1bsb17jj _1hu1v2br _vchhusvi _y3gn1h6o _lcxv1wug _2hwx7vkz _tzy4kb7n",
            (unfollowLoading || followLoading) && "_tzy4105o",
            tileHover && "_19lcl4ek"
        ])
    }, followError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: followError
    }), unfollowError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: unfollowError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        href: url,
        onClick: handleTileLinkButton,
        target: "_blank",
        appearance: "link",
        theme: $08135afd8c895fad$var$fullSizeButtonTheme,
        testId: "feed-rec-tile-link",
        "aria-label": intl.formatMessage($08135afd8c895fad$var$i18n.profileTile, {
            name: name
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        appearance: "subtle",
        theme: $08135afd8c895fad$var$dismissTileButtonTheme,
        onClick: handleTileDismissButton,
        onMouseEnter: disableTileHover,
        onMouseLeave: enableTileHover,
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: intl.formatMessage($08135afd8c895fad$var$i18n.dismissLabel, {
                name: name
            })
        }),
        isDisabled: unfollowLoading
    }), type === 'user' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: icon,
        alt: "",
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _1bsbzwfg _4t3izwfg"
        ]),
        "data-vc": "SPWZ8F_J"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKskQ.SpaceIcon), {
        src: icon,
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1bsb1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _1reo15vq _18m915vq _1bto1l2s _o5721q9c _kqswh2mm"
        ])
    }, name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_4t3idlk8"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: titleOrType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _1bto1l2s _o5721q9c _kqswh2mm"
        ])
    }, titleOrType)))), renderFollowButton());
};
module.exports["TILE_MARGIN"] = $08135afd8c895fad$export$f2a133baea81f082;
module.exports["PAGE_SIZE"] = $08135afd8c895fad$export$8ec3d08588d2eeda;
module.exports["RecommendationTile"] = $08135afd8c895fad$export$debb778f17cf50d6;

});

parcelRegister("b29u2", function(module, exports) {

var $22wWM = parcelRequire("22wWM");

const $31e467a602725ad9$export$db2714a6b5ad421e = (0, $22wWM.default);
module.exports["FeedRecommendationQuery"] = $31e467a602725ad9$export$db2714a6b5ad421e;

});

parcelRegister("947Tc", function(module, exports) {
/**
 * @generated SignedSource<<d1234cc75295f4d8aaea69f124c0fbdb>>
 * @relayHash 0a96cc03e37bbf3867e6744daa23017e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID efcaebfa892eb7b5401d08c3aae85bece7d435ed2ea26e7a97b3ebeb61c6ce13
const $816d87a7d012cf39$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "score"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "RecommendedFeedUserConfig",
            "kind": "LinkedField",
            "name": "getRecommendedFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "concreteType": "RecommendedSpaceItem",
                    "kind": "LinkedField",
                    "name": "recommendedSpaces",
                    "plural": true,
                    "selections": [
                        v0 /*: any*/ ,
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "RecommendedPeopleItem",
                    "kind": "LinkedField",
                    "name": "recommendedPeople",
                    "plural": true,
                    "selections": [
                        v0 /*: any*/ ,
                        {
                            "concreteType": "AtlassianUser",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isActive"
                                },
                                {
                                    "concreteType": "AtlassianUserPhoto",
                                    "kind": "LinkedField",
                                    "name": "photos",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isPrimary"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "feedRecommendedUserSettingsDismissTimestamp"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeedRecommendationsFeedRecommendationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeedRecommendationsFeedRecommendationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "0a96cc03e37bbf3867e6744daa23017e",
            "id": "efcaebfa892eb7b5401d08c3aae85bece7d435ed2ea26e7a97b3ebeb61c6ce13",
            "metadata": {},
            "name": "useFeedRecommendationsFeedRecommendationQuery",
            "operationKind": "query",
            "text": "query useFeedRecommendationsFeedRecommendationQuery{getRecommendedFeedUserConfig{recommendedSpaces{score,space{id,key,name,icon{path}}},recommendedPeople{score,user{id,title,displayName,isActive,photos{value,isPrimary}}}},userPreferences{feedRecommendedUserSettingsDismissTimestamp}}"
        }
    };
}();
$816d87a7d012cf39$var$node.hash = "f23db13107460d6f583073e645fa5821";
var $816d87a7d012cf39$export$2e2bcd8739ae039 = $816d87a7d012cf39$var$node;
module.exports["default"] = $816d87a7d012cf39$export$2e2bcd8739ae039;

});

parcelRegister("g9apM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $abC4X = parcelRequire("abC4X");


var $9YwaJ = parcelRequire("9YwaJ");


var $eefUQ = parcelRequire("eefUQ");

const $58f18573d7e609e7$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    errorHeader: {
        id: "feed.error.pagination.header",
        defaultMessage: "We couldn\u2019t load more content"
    },
    buttonText: {
        id: "feed.error.pagination.button.text",
        defaultMessage: "Try again"
    }
});
const $58f18573d7e609e7$var$PaginationFeedErrorComponent = ({ refetch: refetch, intl: intl })=>{
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const handleRefresh = (0, $42omo.useCallback)(async ()=>{
        setLoading(true);
        await refetch();
        setLoading(false);
    }, [
        refetch,
        setLoading
    ]);
    const refreshButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9YwaJ.default), {
        onClick: handleRefresh,
        isLoading: loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $58f18573d7e609e7$export$a7357cdd1f0b0168.buttonText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $abC4X.default), {
        header: intl.formatMessage($58f18573d7e609e7$export$a7357cdd1f0b0168.errorHeader),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($eefUQ))),
        imageHeight: 95,
        primaryAction: refreshButton
    });
};
const $58f18573d7e609e7$export$9d195d5a23115090 = (0, $aXWIB.injectIntl)($58f18573d7e609e7$var$PaginationFeedErrorComponent);
module.exports["PaginationFeedError"] = $58f18573d7e609e7$export$9d195d5a23115090;

});

parcelRegister("3HoFy", function(module, exports) {
/* EndOfFeed.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $gj7hi = parcelRequire("gj7hi");


var $abC4X = parcelRequire("abC4X");


var $eEA8O = parcelRequire("eEA8O");


var $f3IIx = parcelRequire("f3IIx");


var $7pEIN = parcelRequire("7pEIN");

const $63720c22c6efb9f3$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    header: {
        id: "feed.end-of-feed.header",
        defaultMessage: "No more activity"
    },
    description: {
        id: "feed.end-of-feed.description",
        defaultMessage: "Check back later or refine your feed for more updates"
    },
    buttonText: {
        id: "feed.end-of-feed.button.text",
        defaultMessage: "Edit feed"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $63720c22c6efb9f3$var$EndOfFeedImage = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $gj7hi.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_p12f1n2x _c71l1n2x",
            __cmplp.className
        ])
    });
});
const $63720c22c6efb9f3$var$EndOfFeedComponent = ({ intl: intl, openActivityFilterModal: openActivityFilterModal })=>{
    const actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        onClick: openActivityFilterModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $63720c22c6efb9f3$export$a7357cdd1f0b0168.buttonText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "end-of-feed-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $abC4X.default), {
        header: intl.formatMessage($63720c22c6efb9f3$export$a7357cdd1f0b0168.header),
        description: openActivityFilterModal ? intl.formatMessage($63720c22c6efb9f3$export$a7357cdd1f0b0168.description) : undefined,
        primaryAction: openActivityFilterModal ? actionButton : undefined,
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($63720c22c6efb9f3$var$EndOfFeedImage, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($f3IIx))),
                srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($7pEIN))),
                width: "74",
                height: "74",
                alt: ""
            }),
        imageHeight: 74
    }));
};
const $63720c22c6efb9f3$export$da82081e1e4aa68f = (0, $aXWIB.injectIntl)($63720c22c6efb9f3$var$EndOfFeedComponent);
module.exports["EndOfFeed"] = $63720c22c6efb9f3$export$da82081e1e4aa68f;

});

parcelRegister("2Jztb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $8tdj3 = parcelRequire("8tdj3");


var $fpGTa = parcelRequire("fpGTa");

var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $4Nwes = parcelRequire("4Nwes");


var $7Hi9s = parcelRequire("7Hi9s");


var $g5jMy = parcelRequire("g5jMy");


var $4yg2A = parcelRequire("4yg2A");

const $c2d7df2e9e74f714$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    popularEndBannerText: {
        id: "feed.end-of-feed-home-banner.popular-banner",
        defaultMessage: "Discover what else is popular across your organisation"
    },
    popularEndBannerLinkText: {
        id: "feed.end-of-feed-home-banner.popular-link",
        defaultMessage: "View all popular content"
    },
    welcomeEndBannerText: {
        id: "feed.end-of-feed-home-banner.welcome-banner",
        defaultMessage: "See who else is new at Atlassian"
    },
    welcomeEndBannerLinkText: {
        id: "feed.end-of-feed-home-banner.welcome-link",
        defaultMessage: "View all welcomes"
    },
    farewellEndBannerText: {
        id: "feed.end-of-feed-home-banner.farewell-banner",
        defaultMessage: "See who else is leaving Atlassian"
    },
    farewellEndBannerLinkText: {
        id: "feed.end-of-feed-home-banner.farewell-link",
        defaultMessage: "View all farewells"
    },
    welcomeIconLabel: {
        id: "feed.end-of-feed-home-banner.welcome-icon",
        defaultMessage: "Welcome"
    },
    farewellIconLabel: {
        id: "feed.end-of-feed-home-banner.farewell-icon",
        defaultMessage: "Farewell"
    }
});
const $c2d7df2e9e74f714$var$linkTextStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.100',
    marginRight: 'space.100'
});
const $c2d7df2e9e74f714$var$anchorStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    textDecoration: 'none',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderRadius: 'radius.small',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'space.100',
    paddingInline: 'space.050',
    paddingBlock: 'space.025',
    marginRight: 'space.100',
    paddingRight: 'space.100',
    ':hover': {
        textDecoration: 'none'
    },
    ':active': {
        color: 'color.link.pressed'
    },
    ':visited': {
        color: 'color.link.visited'
    },
    ':visited:active': {
        color: 'color.link.visited.pressed'
    }
});
const $c2d7df2e9e74f714$var$bannerContainerStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.input.hovered',
    borderRadius: 'radius.small',
    marginTop: 'space.100',
    padding: 'space.100',
    height: '64px'
});
const $c2d7df2e9e74f714$var$bannerTextStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.100'
});
const $c2d7df2e9e74f714$var$singleIconStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.200'
});
const $c2d7df2e9e74f714$var$homeIconStyles = (0, $ecnYn.xcss)({
    height: '32px'
});
const $c2d7df2e9e74f714$var$getBannerText = (feedType)=>{
    switch(feedType){
        case (0, $4yg2A.FeedType).WELCOME:
            return [
                $c2d7df2e9e74f714$export$a7357cdd1f0b0168.welcomeEndBannerText,
                $c2d7df2e9e74f714$export$a7357cdd1f0b0168.welcomeEndBannerLinkText
            ];
        case (0, $4yg2A.FeedType).FAREWELL:
            return [
                $c2d7df2e9e74f714$export$a7357cdd1f0b0168.farewellEndBannerText,
                $c2d7df2e9e74f714$export$a7357cdd1f0b0168.farewellEndBannerLinkText
            ];
        case (0, $4yg2A.FeedType).POPULAR:
            return [
                $c2d7df2e9e74f714$export$a7357cdd1f0b0168.popularEndBannerText,
                $c2d7df2e9e74f714$export$a7357cdd1f0b0168.popularEndBannerLinkText
            ];
        default:
            return [];
    }
};
const $c2d7df2e9e74f714$export$cadca85bfc944b3 = ({ linkHref: linkHref, feedType: feedType })=>{
    const [text, linkText] = $c2d7df2e9e74f714$var$getBannerText(feedType);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const getLinkToRender = ()=>{
        switch(feedType){
            case (0, $4yg2A.FeedType).WELCOME:
                return `${linkHref}&tab=welcome`;
            case (0, $4yg2A.FeedType).FAREWELL:
                return `${linkHref}&tab=farewell`;
            case (0, $4yg2A.FeedType).POPULAR:
            default:
                return linkHref;
        }
    };
    const renderIcons = ()=>{
        switch(feedType){
            case (0, $4yg2A.FeedType).POPULAR:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    testId: "icon-group",
                    xcss: [
                        $c2d7df2e9e74f714$var$singleIconStyles,
                        $c2d7df2e9e74f714$var$homeIconStyles
                    ]
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4Nwes.AtlassianIcon), null));
            case (0, $4yg2A.FeedType).WELCOME:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                    testId: "welcome-icon",
                    xcss: $c2d7df2e9e74f714$var$singleIconStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Hi9s))), {
                    label: $c2d7df2e9e74f714$export$a7357cdd1f0b0168.welcomeIconLabel.defaultMessage
                }));
            case (0, $4yg2A.FeedType).FAREWELL:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                    testId: "farewell-icon",
                    xcss: $c2d7df2e9e74f714$var$singleIconStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5jMy))), {
                    label: $c2d7df2e9e74f714$export$a7357cdd1f0b0168.farewellIconLabel.defaultMessage
                }));
        }
    };
    const handleLinkClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'reducedFeed',
                action: 'clicked',
                actionSubject: 'link',
                attributes: {
                    feedType: feedType
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        testId: "end-of-feed-home-banner",
        alignItems: "center",
        justifyContent: "space-between",
        xcss: $c2d7df2e9e74f714$var$bannerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $c2d7df2e9e74f714$var$bannerTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center"
    }, renderIcons(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), text)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
        xcss: $c2d7df2e9e74f714$var$anchorStyles,
        href: getLinkToRender(),
        onClick: handleLinkClick,
        target: "_blank",
        rel: "noopener noreferrer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $c2d7df2e9e74f714$var$linkTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), linkText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: "Open",
        size: "small"
    })))));
};
module.exports["EndOfFeedHomeBanner"] = $c2d7df2e9e74f714$export$cadca85bfc944b3;

});

parcelRegister("kVcC2", function(module, exports) {
/* EndOfFollowingFeed.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $abC4X = parcelRequire("abC4X");


var $eEA8O = parcelRequire("eEA8O");


var $gj7hi = parcelRequire("gj7hi");


var $5feQW = parcelRequire("5feQW");


var $kkc88 = parcelRequire("kkc88");


var $cAQiE = parcelRequire("cAQiE");


var $iYGgT = parcelRequire("iYGgT");

const $c54cc9644fd2fde7$var$messages = (0, $aXWIB.defineMessages)({
    preFollowingHeading: {
        id: "feed.end-of-following.pre-follow.header",
        defaultMessage: "Stay connected with your team"
    },
    preFollowingDescription: {
        id: "feed.end-of-following.pre-follow.description",
        defaultMessage: "Follow people and spaces to see their latest work in your feed."
    },
    preFollowingCta: {
        id: "feed.end-of-following.pre-follow.cta",
        defaultMessage: "Follow people"
    },
    postFollowingHeading: {
        id: "feed.end-of-following.post-follow.header",
        defaultMessage: "You're all caught up"
    },
    postFollowingDescription: {
        id: "feed.end-of-following.post-follow.description",
        defaultMessage: "Check back later or follow other teammates to see new updates."
    },
    postFollowingCta: {
        id: "feed.end-of-following.post-follow.cta",
        defaultMessage: "Edit feed"
    }
});
const $c54cc9644fd2fde7$var$endOfFeedImageStyles = null;
const $c54cc9644fd2fde7$var$dividerContainerStyles = null;
const $c54cc9644fd2fde7$var$EndOfFollowingFeedComponent = ({ intl: intl, openActivityFilterModal: openActivityFilterModal, hasFollowedAnyone: hasFollowedAnyone = false, hasResults: hasResults = true })=>{
    const isPreFollowing = !hasFollowedAnyone && !hasResults;
    const heading = isPreFollowing ? $c54cc9644fd2fde7$var$messages.preFollowingHeading : $c54cc9644fd2fde7$var$messages.postFollowingHeading;
    const description = isPreFollowing ? $c54cc9644fd2fde7$var$messages.preFollowingDescription : $c54cc9644fd2fde7$var$messages.postFollowingDescription;
    const ctaText = isPreFollowing ? $c54cc9644fd2fde7$var$messages.preFollowingCta : $c54cc9644fd2fde7$var$messages.postFollowingCta;
    const actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        onClick: openActivityFilterModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), ctaText));
    const emptyState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $abC4X.default), {
        header: intl.formatMessage(heading),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), description),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
                src: isPreFollowing ? (0, (/*@__PURE__*/$parcel$interopDefault($5feQW))) : (0, (/*@__PURE__*/$parcel$interopDefault($cAQiE))),
                srcDark: isPreFollowing ? (0, (/*@__PURE__*/$parcel$interopDefault($kkc88))) : (0, (/*@__PURE__*/$parcel$interopDefault($iYGgT))),
                width: "74",
                height: "74",
                alt: "",
                className: (0, $gMc0m.default)([
                    "_p12f1n2x _c71l1n2x"
                ])
            }),
        primaryAction: openActivityFilterModal ? actionButton : undefined
    });
    return isPreFollowing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_x3doia51 _ca0qpxbi _19pkpxbi"
        ]),
        "data-vc": "NErYzi3t"
    }, emptyState) : emptyState;
};
const $c54cc9644fd2fde7$export$9fb63a8d2c93fe03 = (0, $aXWIB.injectIntl)($c54cc9644fd2fde7$var$EndOfFollowingFeedComponent);
module.exports["EndOfFollowingFeed"] = $c54cc9644fd2fde7$export$9fb63a8d2c93fe03;

});

parcelRegister("8KJF2", function(module, exports) {
/* EndOfPopularFeed.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $abC4X = parcelRequire("abC4X");


var $eEA8O = parcelRequire("eEA8O");


var $gj7hi = parcelRequire("gj7hi");


var $7EIq6 = parcelRequire("7EIq6");


var $ep3mz = parcelRequire("ep3mz");


var $flZ2G = parcelRequire("flZ2G");


var $j2Cc0 = parcelRequire("j2Cc0");


var $8cpGw = parcelRequire("8cpGw");

const $0e232958555543fb$var$messages = (0, $aXWIB.defineMessages)({
    heading: {
        id: "feed.end-of-popular.header",
        defaultMessage: "Nothing's trending just yet"
    },
    description: {
        id: "feed.end-of-popular.description",
        defaultMessage: "Kick things off by creating something others will want to read, react to, and share."
    },
    ctaCreateDoc: {
        id: "feed.end-of-popular.cta.create-doc",
        defaultMessage: "Create doc"
    },
    ctaCreatePage: {
        id: "feed.end-of-popular.cta.create-page",
        defaultMessage: "Create page"
    }
});
const $0e232958555543fb$var$endOfFeedImageStyles = null;
const $0e232958555543fb$var$dividerContainerStyles = null;
const $0e232958555543fb$var$EndOfPopularFeedComponent = ({ intl: intl })=>{
    const { createDoc: createDoc } = (0, $flZ2G.useCreateDoc)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isCreateLiveDocEnabled: isCreateLiveDocEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    const actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        onClick: createDoc
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), isCreateLiveDocEnabled ? $0e232958555543fb$var$messages.ctaCreateDoc : $0e232958555543fb$var$messages.ctaCreatePage));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_x3doia51 _ca0qpxbi _19pkpxbi"
        ]),
        "data-vc": "bprA1wyg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $abC4X.default), {
        header: intl.formatMessage($0e232958555543fb$var$messages.heading),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0e232958555543fb$var$messages.description),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($j2Cc0))),
                srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($8cpGw))),
                width: "74",
                height: "74",
                alt: "",
                className: (0, $gMc0m.default)([
                    "_p12f1n2x _c71l1n2x"
                ])
            }),
        primaryAction: actionButton
    }));
};
const $0e232958555543fb$export$5546b04b9c06a7cf = (0, $aXWIB.injectIntl)($0e232958555543fb$var$EndOfPopularFeedComponent);
module.exports["EndOfPopularFeed"] = $0e232958555543fb$export$5546b04b9c06a7cf;

});

parcelRegister("g973h", function(module, exports) {
/* FeedCardSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fT2ta = parcelRequire("fT2ta");

var $bl9WW = parcelRequire("bl9WW");

const $00506369c0094ae9$var$skeletonWrapperStyle = null;
const $00506369c0094ae9$var$skeletonBodyStyle = null;
const $00506369c0094ae9$export$1e1e3a5bb38df355 = ({ useEntranceAnimation: useEntranceAnimation })=>{
    if (useEntranceAnimation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        entranceDirection: "bottom"
    }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ...animationProps,
            "data-testid": "feed-card-skeleton",
            className: (0, $gMc0m.default)([
                "_otyrpxbi _1bumglyw _sedtglyw"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "skeleton-body",
            className: (0, $gMc0m.default)([
                "_11q7izff _2rko1mok _4t3i1p3n _1bsb1osq"
            ])
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "feed-card-skeleton",
        className: (0, $gMc0m.default)([
            "_otyrpxbi _1bumglyw _sedtglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "skeleton-body",
        className: (0, $gMc0m.default)([
            "_11q7izff _2rko1mok _4t3i1p3n _1bsb1osq"
        ])
    }));
};
const $00506369c0094ae9$export$44c18d210d5de37b = /*#__PURE__*/ (0, $42omo.memo)(({ useEntranceAnimation: useEntranceAnimation })=>{
    const Wrapper = useEntranceAnimation ? (0, $bl9WW.default) : (0, $42omo.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, {
        columns: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($00506369c0094ae9$export$1e1e3a5bb38df355, {
        useEntranceAnimation: useEntranceAnimation
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($00506369c0094ae9$export$1e1e3a5bb38df355, {
        useEntranceAnimation: useEntranceAnimation
    }));
}, ()=>true);
module.exports["LoadingSkeleton"] = $00506369c0094ae9$export$44c18d210d5de37b;

});

parcelRegister("8G4Nr", function(module, exports) {
module.exports = new URL("appStoreBadge.eba12d98.svg", import.meta.url).toString();

});

parcelRegister("loTx8", function(module, exports) {
module.exports = new URL("googlePlayBadge.eb604ba3.svg", import.meta.url).toString();

});

parcelRegister("6eSd4", function(module, exports) {
module.exports = new URL("qrCode.5273b9c3.svg", import.meta.url).toString();

});

parcelRegister("2JWAq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $7d1d3b157043f9aa$var$TWO_WEEKS_MS = 1209600000;
const $7d1d3b157043f9aa$var$getIsDismissed = ()=>{
    const now = Date.now();
    const value = (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_MOBILE_APP_PROMO_DISMISSED);
    // Permanently dismissed
    if (value === 'true') return {
        isDismissed: true,
        isAutoDismissed: false
    };
    // Value is not set or blank
    if (!value || value.trim() === '') return {
        isDismissed: false,
        isAutoDismissed: false
    };
    // Check if the value is a first-seen timestamp
    const firstSeenDate = parseInt(value, 10);
    const isTimestamp = !isNaN(firstSeenDate);
    const isExpired = isTimestamp && now - firstSeenDate > $7d1d3b157043f9aa$var$TWO_WEEKS_MS;
    if (isTimestamp && !isExpired) return {
        isDismissed: false,
        isAutoDismissed: false
    };
    // Default: timestamp exceeded 2 weeks or is unrecognizable (corrupted) — dismiss
    (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_MOBILE_APP_PROMO_DISMISSED, 'true');
    // Only fire auto-dismissal analytics if it was a legitimate time-based expiry
    return {
        isDismissed: true,
        isAutoDismissed: isExpired
    };
};
const $7d1d3b157043f9aa$var$onMobileAppPromoView = ()=>{
    const now = Date.now();
    const value = (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_MOBILE_APP_PROMO_DISMISSED);
    // Only record the first-seen timestamp if nothing is stored yet
    if (!value) (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_MOBILE_APP_PROMO_DISMISSED, now.toString());
};
const $7d1d3b157043f9aa$export$69b45bc725cebf2c = (options)=>{
    const [{ isDismissed: isDismissed, isAutoDismissed: isAutoDismissed }, setDismissState] = (0, $42omo.useState)($7d1d3b157043f9aa$var$getIsDismissed);
    (0, $42omo.useEffect)(()=>{
        if (isAutoDismissed) options?.onAutoDismiss?.();
    // We only want to run this once on mount when the state is initialized
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onMobileAppPromoDismiss = (0, $42omo.useCallback)(()=>{
        (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_MOBILE_APP_PROMO_DISMISSED, 'true');
        setDismissState({
            isDismissed: true,
            isAutoDismissed: false
        });
    }, []);
    return {
        isMobileAppPromoDismissed: isDismissed,
        onMobileAppPromoDismiss: onMobileAppPromoDismiss,
        onMobileAppPromoView: $7d1d3b157043f9aa$var$onMobileAppPromoView
    };
};
module.exports["useMobileAppPromoDismiss"] = $7d1d3b157043f9aa$export$69b45bc725cebf2c;

});

parcelRegister("dmmkE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4KS7f = parcelRequire("4KS7f");

const $64085d8549e7e41d$var$subtleLinkButtonTheme = (currentTheme, themeProps)=>{
    const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            color: `${"var(--ds-text-subtle, #505258)"} !important`,
            fontWeight: "var(--ds-font-weight-regular, 400)"
        },
        spinnerStyles: spinnerStyles
    };
};
const $64085d8549e7e41d$export$902dde2c01bb0707 = ({ href: href, onClick: onClick, testId: testId, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        href: href,
        onClick: onClick,
        theme: $64085d8549e7e41d$var$subtleLinkButtonTheme,
        appearance: "subtle-link",
        spacing: "none",
        testId: testId
    }, children);
};
module.exports["SubtleLink"] = $64085d8549e7e41d$export$902dde2c01bb0707;

});

parcelRegister("wHo13", function(module, exports) {
/**
 * @generated SignedSource<<43bd1ddde52bfebcf75423782a6696aa>>
 * @relayHash ec4d8643ad14f845c672ac02c6477a9a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 294306842461964d576126c1a580088f0f38450c95ffee72c5dfabba4e5cd9f3
const $52baa5aeaf71ebad$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fromDate"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "fromDate",
            "variableName": "fromDate"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "timestamp"
    }, v5 = {
        "kind": "ScalarField",
        "name": "action"
    }, v6 = {
        "kind": "ScalarField",
        "name": "actionSubject"
    }, v7 = {
        "kind": "ScalarField",
        "name": "groupSize"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v10 = {
        "concreteType": "AtlassianUserPhoto",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "value"
            },
            {
                "kind": "ScalarField",
                "name": "isPrimary"
            }
        ]
    }, v11 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v11 /*: any*/ 
        ],
        "type": "PageActivityEventCreatedPage"
    }, v13 = {
        "kind": "ScalarField",
        "name": "pageVersion"
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ ,
            v7 /*: any*/ ,
            v11 /*: any*/ 
        ],
        "type": "PageActivityEventUpdatedPage"
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "comment",
                "plural": false,
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "concreteType": "Map_LinkType_String",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "webui"
                            }
                        ]
                    }
                ]
            },
            v11 /*: any*/ 
        ],
        "type": "PageActivityEventCreatedComment"
    }, v16 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v17 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v18 = [
        v13 /*: any*/ ,
        v7 /*: any*/ ,
        v17 /*: any*/ ,
        v16 /*: any*/ 
    ], v19 = {
        "concreteType": "PageActivityPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v20 = [
        v13 /*: any*/ ,
        v7 /*: any*/ ,
        v17 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "AllActivityDropdownFeedCardAllActivityQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedPageActivity",
                    "kind": "LinkedField",
                    "name": "pageActivity",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v12 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v18 /*: any*/ ,
                                    "type": "PageActivityEventStartedPage"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v18 /*: any*/ ,
                                    "type": "PageActivityEventSnapshottedPage"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v18 /*: any*/ ,
                                    "type": "PageActivityEventPublishedPage"
                                }
                            ]
                        },
                        v19 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "AllActivityDropdownFeedCardAllActivityQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedPageActivity",
                    "kind": "LinkedField",
                    "name": "pageActivity",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v16 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v12 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v20 /*: any*/ ,
                                    "type": "PageActivityEventStartedPage"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v20 /*: any*/ ,
                                    "type": "PageActivityEventSnapshottedPage"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v20 /*: any*/ ,
                                    "type": "PageActivityEventPublishedPage"
                                }
                            ]
                        },
                        v19 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "ec4d8643ad14f845c672ac02c6477a9a",
            "id": "294306842461964d576126c1a580088f0f38450c95ffee72c5dfabba4e5cd9f3",
            "metadata": {},
            "name": "AllActivityDropdownFeedCardAllActivityQuery",
            "operationKind": "query",
            "text": "query AllActivityDropdownFeedCardAllActivityQuery($contentId:ID!,$after:String,$fromDate:String){pageActivity(contentId:$contentId,after:$after,fromDate:$fromDate){nodes{__typename,timestamp,action,actionSubject,...on PageActivityEventCreatedPage{groupSize,user{id,displayName,photos{value,isPrimary}}},...on PageActivityEventUpdatedPage{pageVersion,groupSize,user{id,displayName,photos{value,isPrimary}}},...on PageActivityEventCreatedComment{groupSize,comment{id,links{webui}},user{id,displayName,photos{value,isPrimary}}},...on PageActivityEventStartedPage{pageVersion,groupSize,user{id,displayName,photos{value,isPrimary},__typename},__typename},...on PageActivityEventSnapshottedPage{pageVersion,groupSize,user{id,displayName,photos{value,isPrimary},__typename},__typename},...on PageActivityEventPublishedPage{pageVersion,groupSize,user{id,displayName,photos{value,isPrimary},__typename},__typename}},pageInfo{endCursor,hasNextPage}}}"
        }
    };
}();
$52baa5aeaf71ebad$var$node.hash = "ece1744e2c59bb61b408ccc9b612626e";
var $52baa5aeaf71ebad$export$2e2bcd8739ae039 = $52baa5aeaf71ebad$var$node;
module.exports["default"] = $52baa5aeaf71ebad$export$2e2bcd8739ae039;

});

parcelRegister("aOmNU", function(module, exports) {
/* ActivityLineUpdateDetail.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $fs6LW = parcelRequire("fs6LW");


var $3WnxN = parcelRequire("3WnxN");


var $fYx4v = parcelRequire("fYx4v");

const $3351eb88a16189f4$var$ActionWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1tke1u1b _otyrutpp",
            __cmplp.className
        ])
    });
});
const $3351eb88a16189f4$var$profileWrapperStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3351eb88a16189f4$var$ActionMessage = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_14yyfhey _5xy1i7uo _1msji7uo",
            __cmplp.className
        ])
    });
});
const $3351eb88a16189f4$var$ActionTimeWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _syazi7uo",
            __cmplp.className
        ])
    });
});
const $3351eb88a16189f4$export$ed487d3c096aa527 = ({ type: type, actionTime: actionTime, userId: userId, avatarUrl: avatarUrl, userDisplayName: userDisplayName, link: link, groupSize: groupSize })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3351eb88a16189f4$var$ActionWrapper, {
        "data-testid": "activity-update-detail"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3351eb88a16189f4$var$profileWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: userId,
        src: avatarUrl,
        canViewProfile: true,
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3351eb88a16189f4$var$ActionMessage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fYx4v.ActivityLineUpdateLink), {
        type: type,
        userDisplayName: userDisplayName,
        link: link,
        groupSize: groupSize,
        activityDropdownLineItem: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3351eb88a16189f4$var$ActionTimeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3WnxN.ActionTime), {
        actionTime: actionTime
    }))));
};
module.exports["ActivityLineUpdateDetail"] = $3351eb88a16189f4$export$ed487d3c096aa527;

});

parcelRegister("j9RXG", function(module, exports) {
/* AllActivityError.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $aXWIB = parcelRequire("aXWIB");


var $eefUQ = parcelRequire("eefUQ");

const $1d330f1d32728694$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    error: {
        id: "feed.card.activity.error.image.alt",
        defaultMessage: "Error"
    },
    errorMessage: {
        id: "feed.card.activity.error.generic.message",
        defaultMessage: "We couldn\u2019t load the recent actions"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d330f1d32728694$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_otyrutpp _1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $1d330f1d32728694$var$Image = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $7sObp.default)(__cmplp.height, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3i1474 _otyrpxbi",
            __cmplp.className
        ])
    });
});
const $1d330f1d32728694$export$824e2da99dfa6504 = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1d330f1d32728694$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1d330f1d32728694$var$Image, {
        height: 65,
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eefUQ))),
        alt: intl.formatMessage($1d330f1d32728694$export$a7357cdd1f0b0168.error)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $1d330f1d32728694$export$a7357cdd1f0b0168.errorMessage));
};
module.exports["AllActivityError"] = $1d330f1d32728694$export$824e2da99dfa6504;

});

parcelRegister("9WXEQ", function(module, exports) {
/* ActivityLineUpdateDetailSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $17d31874853c3173$var$SkeletonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4t3i1wpv _otyrutpp",
            __cmplp.className
        ])
    });
});
const $17d31874853c3173$var$Avatar = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7i8nm _18s8v77o _2rko1rr0 _4t3izwfg _1bsbzwfg _2hwxutpp",
            __cmplp.className
        ])
    });
});
const $17d31874853c3173$var$Action = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7i8nm _2rko1rr0 _1bsb93m8 _otyr12x7 _4t3idlk8",
            __cmplp.className
        ])
    });
});
const $17d31874853c3173$var$Time = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7i8nm _2rko1rr0 _1bsbnagk _4t3i1skh",
            __cmplp.className
        ])
    });
});
const $17d31874853c3173$export$ab8d550fbc7c1fd1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($17d31874853c3173$var$SkeletonWrapper, {
        "data-testid": "activity-detail-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($17d31874853c3173$var$Avatar, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": "hlF3jaUP"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($17d31874853c3173$var$Action, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($17d31874853c3173$var$Time, null)));
module.exports["ActivityLineUpdateDetailSkeleton"] = $17d31874853c3173$export$ab8d550fbc7c1fd1;

});

parcelRegister("ip3cc", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");


var $b6yoO = parcelRequire("b6yoO");

// We map PageActivityActionSubject to more closely match FeedContentQuery's FeedEventType
// because the FE displays them the same by ActivityLineUpdateLink, even though these are used for Recent Actions and FeedEventType is used for the feed card itself.
const $e356c594c5c0f12c$var$supportedUpdateTypes = {
    [(0, $b6yoO.PageActivityActionSubject).page]: {
        [(0, $b6yoO.PageActivityAction).created]: 'CREATE',
        [(0, $b6yoO.PageActivityAction).started]: 'CREATE',
        [(0, $b6yoO.PageActivityAction).updated]: 'EDIT',
        [(0, $b6yoO.PageActivityAction).snapshotted]: 'EDITLIVE',
        [(0, $b6yoO.PageActivityAction).published]: 'PUBLISHLIVE'
    },
    [(0, $b6yoO.PageActivityActionSubject).comment]: {
        [(0, $b6yoO.PageActivityAction).created]: 'COMMENT'
    }
};
const $e356c594c5c0f12c$export$42a9f90d0b7de10d = (actionSubject, action)=>{
    return $e356c594c5c0f12c$var$supportedUpdateTypes[actionSubject]?.[action];
};
const $e356c594c5c0f12c$export$b4f8f1f54acec99b = (photos)=>{
    return photos?.find((photo)=>photo?.isPrimary)?.value || '';
};
const $e356c594c5c0f12c$export$5c5c1edd93b1722b = (activity, contentUrl, contentId)=>{
    const type = $e356c594c5c0f12c$export$42a9f90d0b7de10d(activity.actionSubject, activity.action);
    if (type === 'COMMENT') {
        const commentLink = activity.comment.links.webui;
        if (commentLink) return `${0, $jlIaF.CONTEXT_PATH}${commentLink}`;
    }
    if (type === 'CREATE' || type === 'PUBLISHLIVE') return contentUrl;
    if (type === 'EDIT' || type === 'EDITLIVE') {
        const version = activity.pageVersion;
        const params = {
            query: {
                pageId: contentId,
                selectedPageVersions: [
                    version,
                    version - 1
                ]
            }
        };
        return (0, $1NBp8.PAGE_DIFF_BY_VERSION).toUrl({}, params);
    }
    return '';
};
module.exports["getSupportedUpdateType"] = $e356c594c5c0f12c$export$42a9f90d0b7de10d;
module.exports["getAvatarUrl"] = $e356c594c5c0f12c$export$b4f8f1f54acec99b;
module.exports["getUpdateContentUrl"] = $e356c594c5c0f12c$export$5c5c1edd93b1722b;

});

parcelRegister("bJFcf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6uluu = parcelRequire("6uluu");

const $bfdeb8aabeb4e669$export$434c217d363ea16 = /*#__PURE__*/ (0, $42omo.memo)(({ comments: comments, pageId: pageId, contentType: contentType })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "feed-card-comments"
    }, comments.map((commentData)=>{
        if (commentData?.comment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uluu.Comment), {
            key: commentData.comment.id,
            user: commentData.user,
            comment: commentData.comment,
            pageId: pageId,
            contentType: contentType
        });
        return null;
    }));
});
module.exports["Comments"] = $bfdeb8aabeb4e669$export$434c217d363ea16;

});

parcelRegister("aG5uJ", function(module, exports) {
/* RenderedContent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $eEA8O = parcelRequire("eEA8O");


var $hEeUR = parcelRequire("hEeUR");


var $9yPX0 = parcelRequire("9yPX0");


var $cYSIK = parcelRequire("cYSIK");

const $ab6d11ccc649509c$var$i18n = (0, $aXWIB.defineMessages)({
    showMore: {
        id: "feed.card.comment.showMore",
        defaultMessage: "Show more"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ab6d11ccc649509c$var$ContentWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $ab6d11ccc649509c$var$ContentBlur = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1itk1bql _4t3i1tcg _1bsb1osq _94n51i6y _kqswstnw _1pbykb7n _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $ab6d11ccc649509c$var$ExpandContent = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q71j9a _1wpzesu3",
            __cmplp.className
        ])
    });
});
const $ab6d11ccc649509c$var$ClearFix = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11rm1hrf",
            __cmplp.className
        ])
    });
});
const $ab6d11ccc649509c$export$d2a6a47af75be715 = ({ content: content })=>{
    const contentId = content.id;
    const adfValue = (!content.body.format || content.body.format === 'ADF') && JSON.parse(content.body.value);
    const [contentEl, setContentEl] = (0, $42omo.useState)(null);
    const [collapsed, setCollapsed] = (0, $42omo.useState)(false);
    const observerRef = (0, $42omo.useRef)(null);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $42omo.useContext)((0, $cYSIK.FeedCardContext));
    (0, $42omo.useEffect)(()=>{
        if (contentEl) {
            if (!observerRef.current) observerRef.current = new ResizeObserver((entries)=>{
                if (entries[0].contentRect.height > (0, $9yPX0.COMMENT_COLLAPSE_THRESHOLD)) setCollapsed(true);
            });
            observerRef.current.observe(contentEl);
        }
    }, [
        contentEl,
        observerRef
    ]);
    const expandContent = (0, $42omo.useCallback)(()=>{
        observerRef.current?.disconnect();
        setCollapsed(false);
        fireAnalyticsEvent({
            type: 'sendUIEvent',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'seeMore',
            commentId: contentId,
            contentId: contentId
        });
    }, [
        observerRef,
        setCollapsed,
        contentId,
        fireAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab6d11ccc649509c$var$ContentWrapper, {
        ref: setContentEl,
        collapsed: collapsed
    }, content.body.format === 'TEXT' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": "Ef80xpz7"
    }, content.body.value) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hEeUR.ADFRenderer), {
        document: adfValue,
        portal: contentEl ?? undefined,
        contentId: contentId,
        isTruncatedContent: collapsed,
        fadeOutHeight: 0,
        maxHeight: (0, $9yPX0.COMMENT_COLLAPSE_THRESHOLD),
        allowStickyHeaders: false,
        appearance: "comment"
    }), collapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab6d11ccc649509c$var$ContentBlur, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab6d11ccc649509c$var$ExpandContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        onClick: expandContent,
        appearance: "subtle-link",
        spacing: "none"
    }, "\u2026", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $ab6d11ccc649509c$var$i18n.showMore)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab6d11ccc649509c$var$ClearFix, null));
};
module.exports["RenderedContent"] = $ab6d11ccc649509c$export$d2a6a47af75be715;

});

parcelRegister("gk2mg", function(module, exports) {
/* FeedCardTitle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $fYQcF = parcelRequire("fYQcF");


var $9wGTI = parcelRequire("9wGTI");


var $di8q4 = parcelRequire("di8q4");


var $bCECL = parcelRequire("bCECL");


var $dPJCf = parcelRequire("dPJCf");


var $1dnxO = parcelRequire("1dnxO");


var $1C3B1 = parcelRequire("1C3B1");


var $lXYVJ = parcelRequire("lXYVJ");


var $lpPVE = parcelRequire("lpPVE");


var $71GjD = parcelRequire("71GjD");


var $7uUnJ = parcelRequire("7uUnJ");


var $cYSIK = parcelRequire("cYSIK");

const $741a9cf59ba50c0c$var$styles = null;
const $741a9cf59ba50c0c$var$tooltipContainerSelector = 'feed.TooltipContainer'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $741a9cf59ba50c0c$var$TooltipContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1e0c1txw",
            __cmplp.className
        ])
    });
});
$741a9cf59ba50c0c$var$TooltipContainer.defaultProps = {
    'data-styled-selector': $741a9cf59ba50c0c$var$tooltipContainerSelector
};
const $741a9cf59ba50c0c$var$TooltipTag = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($741a9cf59ba50c0c$var$TooltipContainer, {
        ...rest,
        ref: ref
    }, children);
});
const $741a9cf59ba50c0c$var$titleSelector = 'feed.Title'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $741a9cf59ba50c0c$var$Title = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81d4k _1reo15vq _18m915vq _18s81b66 _kqswh2mm _k48p1wq8 _o5721q9c _1bto1l2s _u5f31b66",
            __cmplp.className
        ])
    });
});
$741a9cf59ba50c0c$var$Title.defaultProps = {
    'data-styled-selector': $741a9cf59ba50c0c$var$titleSelector
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $741a9cf59ba50c0c$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _27nn1r31 _u9bwglyw _1cncnqa1 _n2s9azsu _1g4ki7uo _1es6dv2p",
            __cmplp.className
        ])
    });
});
const $741a9cf59ba50c0c$var$ContentIconWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _o0p07vkz _19lo78py",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $741a9cf59ba50c0c$var$EmojiContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _11c81d4k _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _4cvr1h6o _4t3i7vkz _1bsb7vkz _172pidpf _1hcdidpf _1oyyidpf _19h8idpf",
            __cmplp.className
        ])
    });
});
const $741a9cf59ba50c0c$export$fc776ba33c7e14ab = ({ contentTitle: contentTitle, contentUrl: contentUrl, contentType: contentType, contentSubType: contentSubType, emoji: emoji, customIconUrl: customIconUrl, popularFeedTimeGranularity: popularFeedTimeGranularity, followingFeedSortby: followingFeedSortby, hasAiSnippet: hasAiSnippet })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $42omo.useContext)((0, $cYSIK.FeedCardContext));
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    const feedType = popularFeedTimeGranularity ? 'popularFeed' : 'followingFeed';
    const handleLinkClick = (0, $42omo.useCallback)((e)=>{
        if (hasAiSnippet) trackAIResultAction(`${feedType}aiSnippetClicked`);
        if (contentType === 'page') (0, $lXYVJ.setViewTransitionSource)((0, $1C3B1.DISCOVER_ITEM_ON_HOME_PAGE_CLICK));
        fireAnalyticsEvent({
            type: 'sendUIEvent',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'feedCard',
            includeNavdex: true,
            additionalAttributes: {
                popularFeedTimeGranularity: popularFeedTimeGranularity,
                followingFeedSortby: followingFeedSortby
            }
        });
        if ((0, $9wGTI.fg)('confluence_frontend_insights_feature_attribution')) {
            e.preventDefault();
            if (e.metaKey || e.ctrlKey) window.open((0, $lpPVE.generatePathWithFeatureCodesQueryParam)(contentUrl, [
                (0, $71GjD.FeatureCode).HOME_FEED
            ]));
            else push((0, $lpPVE.generatePathWithFeatureCodesQueryParam)(contentUrl, [
                (0, $71GjD.FeatureCode).HOME_FEED
            ]));
        }
    }, [
        contentType,
        fireAnalyticsEvent,
        popularFeedTimeGranularity,
        followingFeedSortby,
        contentUrl,
        push,
        feedType,
        hasAiSnippet,
        trackAIResultAction
    ]);
    const icon = $741a9cf59ba50c0c$var$getIcon(contentType, contentSubType, customIconUrl, emoji);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($741a9cf59ba50c0c$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($741a9cf59ba50c0c$var$ContentIconWrapper, null, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: contentTitle,
        tag: $741a9cf59ba50c0c$var$TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($741a9cf59ba50c0c$var$Title, {
        href: contentUrl,
        onClick: handleLinkClick,
        "data-testid": "feed-card-title-link"
    }, contentTitle)));
};
const $741a9cf59ba50c0c$var$getIcon = (contentType, contentSubType, customIconUrl, emoji)=>{
    const isLivePage = contentType === 'page' && contentSubType === 'live';
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const color = isLivePage ? "var(--ds-icon-accent-magenta, #CD519D)" : "var(--ds-icon-accent-blue, #357DE8)";
    if (customIconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        alt: "",
        src: customIconUrl,
        width: "16",
        height: "16",
        "aria-hidden": "true",
        className: (0, $gMc0m.default)([
            "_s7n4yfq0"
        ]),
        "data-vc": "Z_KrvVT0"
    });
    if (isNav4Enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
        type: contentType,
        emoji: emoji,
        subType: contentSubType,
        color: color
    });
    if (emoji) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji,
        context: "feedCardBodyIcon",
        height: 16,
        wrapper: $741a9cf59ba50c0c$var$EmojiContainer
    });
    return isLivePage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7uUnJ.LiveDocsIconTile), {
        label: "live-doc-tile",
        testId: "live-doc-icon-tile-feed-card",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
        type: contentType
    });
};
module.exports["FeedCardTitle"] = $741a9cf59ba50c0c$export$fc776ba33c7e14ab;

});

parcelRegister("hlJJ7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $4KS7f = parcelRequire("4KS7f");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $4qzKl = parcelRequire("4qzKl");


var $a6t12 = parcelRequire("a6t12");


var $jlIaF = parcelRequire("jlIaF");


var $cYSIK = parcelRequire("cYSIK");

const $28bd75c4b6504aaa$var$styles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle'
});
const $28bd75c4b6504aaa$var$i18n = (0, $aXWIB.defineMessages)({
    createdBy: {
        id: "feed.card.byline.createdBy",
        defaultMessage: "Created by {name}"
    },
    ownedBy: {
        id: "feed.card.byline.ownedBy",
        defaultMessage: "Owned by {name}"
    },
    profile: {
        id: "feed.card.byline.profile",
        defaultMessage: "profile"
    },
    space: {
        id: "feed.card.byline.space",
        defaultMessage: "space"
    }
});
const $28bd75c4b6504aaa$export$577deec5d331f6be = (currentTheme, themeProps)=>{
    const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            textDecoration: 'underline'
        },
        spinnerStyles: spinnerStyles
    };
};
const $28bd75c4b6504aaa$var$LinkOrText = ({ children: children, url: url, analyticsId: analyticsId, label: label, popularFeedTimeGranularity: popularFeedTimeGranularity, followingFeedSortby: followingFeedSortby })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $42omo.useContext)((0, $cYSIK.FeedCardContext));
    const handleClick = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent({
            type: 'sendUIEvent',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: analyticsId,
            includeNavdex: true,
            additionalAttributes: {
                popularFeedTimeGranularity: popularFeedTimeGranularity,
                followingFeedSortby: followingFeedSortby
            }
        });
    }, [
        fireAnalyticsEvent,
        analyticsId,
        popularFeedTimeGranularity,
        followingFeedSortby
    ]);
    if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        href: url,
        "aria-label": label,
        onClick: handleClick,
        theme: $28bd75c4b6504aaa$export$577deec5d331f6be,
        appearance: "subtle-link",
        spacing: "none"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-vc": "4DOT1kGj"
    }, children);
};
const $28bd75c4b6504aaa$export$a7ff0168af7e69e = ({ spaceName: spaceName, spaceUrl: spaceUrl, authorName: authorName, authorId: authorId, ownerName: ownerName, ownerId: ownerId, timestamp: timestamp = '', popularFeedTimeGranularity: popularFeedTimeGranularity, followingFeedSortby: followingFeedSortby })=>{
    const authorUrl = (0, $4qzKl.getAtlassianPeopleProfileUrl)(authorId, 'feed-alpha', (0, $jlIaF.CONTEXT_PATH));
    const ownerUrl = (0, $4qzKl.getAtlassianPeopleProfileUrl)(ownerId, 'feed-alpha', (0, $jlIaF.CONTEXT_PATH));
    const intl = (0, $aXWIB.useIntl)();
    const id = ownerId || authorId;
    const name = ownerName || authorName;
    const url = ownerUrl || authorUrl;
    const bylineText = ownerName ? $28bd75c4b6504aaa$var$i18n.ownedBy : $28bd75c4b6504aaa$var$i18n.createdBy;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        wrap: "wrap",
        gap: "space.050",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        xcss: $28bd75c4b6504aaa$var$styles
    }, name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        tagName: "div",
        ...bylineText,
        values: {
            name: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($28bd75c4b6504aaa$var$LinkOrText, {
                label: `${name}, ${intl.formatMessage($28bd75c4b6504aaa$var$i18n.profile)}`,
                url: url,
                analyticsId: "feedCardContentAuthor",
                popularFeedTimeGranularity: popularFeedTimeGranularity,
                followingFeedSortby: followingFeedSortby
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
                userId: id
            }, name))
        }
    }), name && timestamp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, "\u2022"), timestamp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, timestamp), spaceName && (name || timestamp) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, "\u2022"), spaceName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($28bd75c4b6504aaa$var$LinkOrText, {
        label: `${spaceName}, ${intl.formatMessage($28bd75c4b6504aaa$var$i18n.space)}`,
        url: spaceUrl,
        analyticsId: "feedCardSpace",
        popularFeedTimeGranularity: popularFeedTimeGranularity,
        followingFeedSortby: followingFeedSortby
    }, spaceName));
};
module.exports["FeedCardByLine"] = $28bd75c4b6504aaa$export$a7ff0168af7e69e;

});

parcelRegister("8dkgs", function(module, exports) {
/* FeedCardActionCounts.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $1yB28 = parcelRequire("1yB28");


var $eEA8O = parcelRequire("eEA8O");


var $3FlVr = parcelRequire("3FlVr");


var $1NF8X = parcelRequire("1NF8X");


var $8SCD6 = parcelRequire("8SCD6");


var $6mKj3 = parcelRequire("6mKj3");


var $cYSIK = parcelRequire("cYSIK");

const $30952aff407ac11f$var$i18n = (0, $aXWIB.defineMessages)({
    comments: {
        id: "feed.card.comments.label",
        defaultMessage: "Comments"
    }
});
// Note: this component extracts the props that we don't want to send to the DOM
// This avoids styled errors about isGlobalReactionsAndLikesEnabled being passed to the DOM
/* eslint-disable @typescript-eslint/no-unused-vars */ const $30952aff407ac11f$var$ReactionsWrapperBase = ({ isGlobalReactionsAndLikesEnabled: isGlobalReactionsAndLikesEnabled, children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...props,
        "data-vc": "_StnUF_o"
    }, children);
}; /* eslint-enable @typescript-eslint/no-unused-vars */ 
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $30952aff407ac11f$var$ReactionsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $30952aff407ac11f$var$ReactionsWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _syazazsu _k48p1wq8 _4cvresu3",
            __cmplp.isGlobalReactionsAndLikesEnabled ? "_1bah1yb4" : "_1bahesu3",
            __cmplp.className
        ])
    });
});
const $30952aff407ac11f$var$CommentsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _19bvv77o _n3td1b66 _1bahusic _1ul9fp70 _syazazsu _k48pi7a9 _lb9e1b66",
            __cmplp.className
        ])
    });
});
var $30952aff407ac11f$export$fd58c5b798cd3548 = /*#__PURE__*/ function(ShowCommentState) {
    ShowCommentState[ShowCommentState["Number"] = 0] = "Number";
    ShowCommentState[ShowCommentState["NoShow"] = 1] = "NoShow";
    ShowCommentState[ShowCommentState["ShowComment"] = 2] = "ShowComment";
    ShowCommentState[ShowCommentState["HideComment"] = 3] = "HideComment";
    return ShowCommentState;
}({});
const $30952aff407ac11f$var$FeedCardActionCountsComponent = ({ numComments: numComments, contentId: contentId, contentType: contentType, spaceId: spaceId, intl: intl, source: source, showCommentState: showCommentState, onCommentToggleClick: onCommentToggleClick, popularFeedTimeGranularity: popularFeedTimeGranularity, followingFeedSortby: followingFeedSortby })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $42omo.useContext)((0, $cYSIK.FeedCardContext));
    const { isReactionsEnabled: isGlobalReactionsAndLikesEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    const isFollowingFeed = source === 'following-feed';
    const onToggleClick = (0, $42omo.useCallback)(()=>{
        onCommentToggleClick();
        fireAnalyticsEvent({
            type: 'sendUIEvent',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: showCommentState === 2 ? 'show-comment' : 'hide-comment',
            additionalAttributes: {
                followingFeedSortby: followingFeedSortby
            }
        });
    }, [
        onCommentToggleClick,
        fireAnalyticsEvent,
        showCommentState,
        followingFeedSortby
    ]);
    const location = contentType === 'page' ? (0, $3FlVr.ReactionLocation).FEED_PAGE : (0, $3FlVr.ReactionLocation).FEED_BLOGPOST;
    const commentToggle = showCommentState === 2 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "feed.comment.expand",
        defaultMessage: "Show comment"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "feed.comment.collapse",
        defaultMessage: "Hide comment"
    });
    const commentCount = !!numComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($30952aff407ac11f$var$CommentsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
        label: intl.formatMessage($30952aff407ac11f$var$i18n.comments)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "feed.comment.count",
        defaultMessage: "{numComments, plural, one {1 comment} other {# comments}}",
        values: {
            numComments: numComments
        }
    }));
    const optionalCommentToggle = showCommentState > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        onClick: onToggleClick,
        appearance: "subtle-link",
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
            label: intl.formatMessage($30952aff407ac11f$var$i18n.comments)
        })
    }, commentToggle);
    const renderComments = showCommentState == 0 ? commentCount : optionalCommentToggle;
    const renderReactionsAndComments = ()=>{
        if (contentId && contentType && spaceId) {
            if (isFollowingFeed) {
                if ((0, $6mKj3.expValEquals)('confluence_following_feed_remove_social_proof', 'cohort', 'remove-emojis-and-comments-counts')) return null;
                if ((0, $6mKj3.expValEquals)('confluence_following_feed_remove_social_proof', 'cohort', 'remove-emojis')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, renderComments);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($30952aff407ac11f$var$ReactionsWrapper, {
                isGlobalReactionsAndLikesEnabled: isGlobalReactionsAndLikesEnabled,
                "data-testid": "feed-content-reactions"
            }, isGlobalReactionsAndLikesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1NF8X.ReactionsLoaderBackground), {
                contentId: contentId,
                location: location,
                containerId: spaceId,
                containerType: (0, $3FlVr.ReactionContainerType).SPACE,
                popularFeedTimeGranularity: popularFeedTimeGranularity,
                limit: undefined,
                sort: undefined
            }), renderComments));
        }
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("small", null, renderReactionsAndComments());
};
const $30952aff407ac11f$export$a055795d89acf8f7 = (0, $aXWIB.injectIntl)($30952aff407ac11f$var$FeedCardActionCountsComponent);
module.exports["ShowCommentState"] = $30952aff407ac11f$export$fd58c5b798cd3548;
module.exports["FeedCardActionCounts"] = $30952aff407ac11f$export$a055795d89acf8f7;

});

parcelRegister("37OMg", function(module, exports) {

var $3aCVQ = parcelRequire("3aCVQ");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $b3j2Y = parcelRequire("b3j2Y");


var $h9jgP = parcelRequire("h9jgP");


var $jMyy4 = parcelRequire("jMyy4");

const $7d1be96f11cd1892$var$FeedCardActionsMenuQuery = (0, $3aCVQ.default);
const $7d1be96f11cd1892$var$actionsWrapperStyle = null;
const $7d1be96f11cd1892$var$ListItemWrapperStyles = (0, $ecnYn.xcss)({
    listStyleType: 'none',
    margin: '0',
    padding: '0'
});
const $7d1be96f11cd1892$export$51e8c4c01930cbec = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId })=>{
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)($7d1be96f11cd1892$var$FeedCardActionsMenuQuery, {
        variables: {
            contentId: contentId
        },
        __callerPackage__: "@confluence/feed"
    });
    const renderStarAction = ()=>{
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        const isStarred = !!data?.singleContent?.metadata?.currentuser?.favourited?.isFavourite;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h9jgP.FeedCardStarAction), {
            contentId: contentId,
            isStarred: isStarred
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "feed-card-actions",
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        as: "ul",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $7d1be96f11cd1892$var$ListItemWrapperStyles,
        as: "li"
    }, renderStarAction())));
});
module.exports["FeedCardActions"] = $7d1be96f11cd1892$export$51e8c4c01930cbec;

});

parcelRegister("lSGGk", function(module, exports) {
/**
 * @generated SignedSource<<d302ac1e01bd551b7d38cb95ae521835>>
 * @relayHash 3563e2678c4f0230602a4caec9253cda
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cac7c289c3f4e25bbc8fb98e9fe298c45cebf49bbc802f65013db2a336151d8d
const $95c9b04afdd6549f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "followSpace"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "followUser"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "unfollowSpace"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "unfollowUser"
    }, v4 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "followSpaces",
                            "variableName": "followSpace"
                        },
                        {
                            "kind": "Variable",
                            "name": "followUsers",
                            "variableName": "followUser"
                        },
                        {
                            "kind": "Variable",
                            "name": "unfollowSpaces",
                            "variableName": "unfollowSpace"
                        },
                        {
                            "kind": "Variable",
                            "name": "unfollowUsers",
                            "variableName": "unfollowUser"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "SetFeedUserConfigPayload",
            "kind": "LinkedField",
            "name": "setFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RecommendationTileFeedFollowRecommendationMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RecommendationTileFeedFollowRecommendationMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "3563e2678c4f0230602a4caec9253cda",
            "id": "cac7c289c3f4e25bbc8fb98e9fe298c45cebf49bbc802f65013db2a336151d8d",
            "metadata": {},
            "name": "RecommendationTileFeedFollowRecommendationMutation",
            "operationKind": "mutation",
            "text": "mutation RecommendationTileFeedFollowRecommendationMutation($followUser:[ID],$followSpace:[Long],$unfollowUser:[ID],$unfollowSpace:[Long]){setFeedUserConfig(input:{followUsers:$followUser,followSpaces:$followSpace,unfollowUsers:$unfollowUser,unfollowSpaces:$unfollowSpace}){success}}"
        }
    };
}();
$95c9b04afdd6549f$var$node.hash = "1a44a6518af9b607fdb62610585fe24e";
var $95c9b04afdd6549f$export$2e2bcd8739ae039 = $95c9b04afdd6549f$var$node;
module.exports["default"] = $95c9b04afdd6549f$export$2e2bcd8739ae039;

});

parcelRegister("22wWM", function(module, exports) {
/**
 * @generated SignedSource<<0a52c644151c553b94a7e465bb45b90f>>
 * @relayHash 8ab18764e7c16c14216367e856dab0c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 457ac47add6adbc0db836b0fa7db2101b18eca1437f536c81045456ccdce6549
const $dfbb3f88faf3da86$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "score"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "RecommendedFeedUserConfig",
            "kind": "LinkedField",
            "name": "getRecommendedFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "concreteType": "RecommendedSpaceItem",
                    "kind": "LinkedField",
                    "name": "recommendedSpaces",
                    "plural": true,
                    "selections": [
                        v0 /*: any*/ ,
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "RecommendedPeopleItem",
                    "kind": "LinkedField",
                    "name": "recommendedPeople",
                    "plural": true,
                    "selections": [
                        v0 /*: any*/ ,
                        {
                            "concreteType": "AtlassianUser",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isActive"
                                },
                                {
                                    "concreteType": "AtlassianUserPhoto",
                                    "kind": "LinkedField",
                                    "name": "photos",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isPrimary"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "feedRecommendedUserSettingsDismissTimestamp"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "FeedRecommendationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "FeedRecommendationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "8ab18764e7c16c14216367e856dab0c3",
            "id": "457ac47add6adbc0db836b0fa7db2101b18eca1437f536c81045456ccdce6549",
            "metadata": {},
            "name": "FeedRecommendationQuery",
            "operationKind": "query",
            "text": "query FeedRecommendationQuery{getRecommendedFeedUserConfig{recommendedSpaces{score,space{id,key,name,icon{path}}},recommendedPeople{score,user{id,title,displayName,isActive,photos{value,isPrimary}}}},userPreferences{feedRecommendedUserSettingsDismissTimestamp}}"
        }
    };
}();
$dfbb3f88faf3da86$var$node.hash = "cd2b1cf86c5bfd971e4c48e39a4c5b14";
var $dfbb3f88faf3da86$export$2e2bcd8739ae039 = $dfbb3f88faf3da86$var$node;
module.exports["default"] = $dfbb3f88faf3da86$export$2e2bcd8739ae039;

});

parcelRegister("f3IIx", function(module, exports) {
module.exports = new URL("EndOfFeedLight.17ca263f.svg", import.meta.url).toString();

});

parcelRegister("7pEIN", function(module, exports) {
module.exports = new URL("EndOfFeedDark.84fb6c4b.svg", import.meta.url).toString();

});

parcelRegister("5feQW", function(module, exports) {
module.exports = new URL("PreFollowingLight.f92d45c7.svg", import.meta.url).toString();

});

parcelRegister("kkc88", function(module, exports) {
module.exports = new URL("PreFollowingDark.38051ab6.svg", import.meta.url).toString();

});

parcelRegister("cAQiE", function(module, exports) {
module.exports = new URL("PostFollowingLight.c84c69f2.svg", import.meta.url).toString();

});

parcelRegister("iYGgT", function(module, exports) {
module.exports = new URL("PostFollowingDark.27906e92.svg", import.meta.url).toString();

});

parcelRegister("flZ2G", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $7EIq6 = parcelRequire("7EIq6");


var $dkIiA = parcelRequire("dkIiA");


var $bZSO8 = parcelRequire("bZSO8");

const $999c2987f6929bed$export$822e2e1e2e135442 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isCreateLiveDocEnabled: isCreateLiveDocEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    const createDoc = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createDoc',
                source: 'popularFeedEmptyState',
                attributes: {
                    contentType: isCreateLiveDocEnabled ? 'liveDoc' : 'page',
                    hasSpaceContext: !!spaceKey
                }
            }
        }).fire();
        const createUrl = (0, $bZSO8.buildCreationLink)({
            contentType: 'page',
            subType: isCreateLiveDocEnabled ? (0, $dkIiA.ConfluencePageSubType).LIVE : undefined,
            spaceKey: spaceKey,
            withFallback: true,
            source: 'popularFeedEmptyState'
        });
        push(createUrl);
    }, [
        createAnalyticsEvent,
        push,
        isCreateLiveDocEnabled,
        spaceKey
    ]);
    return {
        createDoc: createDoc
    };
};
module.exports["useCreateDoc"] = $999c2987f6929bed$export$822e2e1e2e135442;

});

parcelRegister("j2Cc0", function(module, exports) {
module.exports = new URL("PopularFeedLight.134f07fb.svg", import.meta.url).toString();

});

parcelRegister("8cpGw", function(module, exports) {
module.exports = new URL("PopularFeedDark.a08142ea.svg", import.meta.url).toString();

});

parcelRegister("b6yoO", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $2d94e9ff28ef8e76$export$64ac2b5f448712fd = /*#__PURE__*/ function(PageActivityAction) {
    PageActivityAction["created"] = "created";
    PageActivityAction["updated"] = "updated";
    PageActivityAction["started"] = "started";
    PageActivityAction["snapshotted"] = "snapshotted";
    PageActivityAction["published"] = "published";
    return PageActivityAction;
}({});
var $2d94e9ff28ef8e76$export$2aad1bd9e74391f = /*#__PURE__*/ function(PageActivityActionSubject) {
    PageActivityActionSubject["comment"] = "comment";
    PageActivityActionSubject["page"] = "page";
    return PageActivityActionSubject;
}({});
module.exports["PageActivityAction"] = $2d94e9ff28ef8e76$export$64ac2b5f448712fd;
module.exports["PageActivityActionSubject"] = $2d94e9ff28ef8e76$export$2aad1bd9e74391f;

});

parcelRegister("6uluu", function(module, exports) {
/* Comment.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $fs6LW = parcelRequire("fs6LW");


var $1RkMx = parcelRequire("1RkMx");


var $aG5uJ = parcelRequire("aG5uJ");


var $cYSIK = parcelRequire("cYSIK");


var $gusOH = parcelRequire("gusOH");


var $bEsCw = parcelRequire("bEsCw");

const $6555f42ec60dd986$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $6555f42ec60dd986$var$profileWrapperStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.150'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6555f42ec60dd986$var$FullWidth = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $6555f42ec60dd986$var$ContentLink = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_80omtlke _kqswstnw _1bsb1osq _4t3i1osq _1pbykb7n",
            __cmplp.className
        ])
    });
});
const $6555f42ec60dd986$var$CommentContent = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1mok _11q71j9a _kqswh2mm _otyr1b66 _syazi7uo",
            __cmplp.className
        ])
    });
});
const $6555f42ec60dd986$var$CommenterName = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _k48p1wq8 _otyr1b66 _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $6555f42ec60dd986$var$CommentInlineText = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _11q71917 _1yt41nxw _1bto1l2s _o5721q9c _1bsb1ns9 _p12f1osq _18u01i6y _19pk1i6y _otyr1b66",
            __cmplp.className
        ])
    });
});
const $6555f42ec60dd986$var$CommenterNameContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $6555f42ec60dd986$export$4d299b491347818a = ({ user: user, comment: comment, pageId: pageId, contentType: contentType })=>{
    const authorName = user.displayName;
    const url = (0, $1RkMx.getCommentLink)(comment);
    const authorId = (0, $1RkMx.getUserAccountId)(user);
    const authorAvatar = user?.profilePicture?.path;
    const inlineText = 'inlineText' in comment.location ? comment.location.inlineText : null;
    const commentId = comment.id;
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $42omo.useContext)((0, $cYSIK.FeedCardContext));
    const onContentLinkClicked = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent({
            type: 'sendUIEvent',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'feedCardViewComment',
            commentId: commentId,
            includeNavdex: true
        });
    }, [
        fireAnalyticsEvent,
        commentId
    ]);
    const compactComment = (0, $gusOH.useFeedShouldHideComments)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6555f42ec60dd986$var$Wrapper, null, !compactComment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $6555f42ec60dd986$var$profileWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: authorId,
        src: authorAvatar,
        canViewProfile: true,
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6555f42ec60dd986$var$FullWidth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6555f42ec60dd986$var$CommentContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6555f42ec60dd986$var$ContentLink, {
        href: url,
        onClick: onContentLinkClicked,
        "data-testid": "comment-content-link"
    }), !compactComment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6555f42ec60dd986$var$CommenterNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6555f42ec60dd986$var$CommenterName, null, authorName)), inlineText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6555f42ec60dd986$var$CommentInlineText, null, inlineText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aG5uJ.RenderedContent), {
        content: comment
    })), !compactComment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bEsCw.CommentInfoLine), {
        comment: comment,
        pageId: pageId,
        contentType: contentType
    })));
};
module.exports["Comment"] = $6555f42ec60dd986$export$4d299b491347818a;

});

parcelRegister("3aCVQ", function(module, exports) {
/**
 * @generated SignedSource<<a22cc46932a15e3c4c6ea7fc39ceb27d>>
 * @relayHash 9e9248aaab72f68632f4f93a01114a92
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 834ab8d6fbb4fc4059da3ccb65130de331623de4c2ed2a519b20592d4498d06c
const $0a818f05ef99c6b1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                            "kind": "LinkedField",
                            "name": "currentuser",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "FavouritedSummary",
                                    "kind": "LinkedField",
                                    "name": "favourited",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FeedCardActionsMenuQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FeedCardActionsMenuQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "9e9248aaab72f68632f4f93a01114a92",
            "id": "834ab8d6fbb4fc4059da3ccb65130de331623de4c2ed2a519b20592d4498d06c",
            "metadata": {},
            "name": "FeedCardActionsMenuQuery",
            "operationKind": "query",
            "text": "query FeedCardActionsMenuQuery($contentId:ID!){singleContent(id:$contentId){id,metadata{currentuser{favourited{isFavourite}}}}}"
        }
    };
}();
$0a818f05ef99c6b1$var$node.hash = "5b51ad676490df42bb3f9849e1afbcc7";
var $0a818f05ef99c6b1$export$2e2bcd8739ae039 = $0a818f05ef99c6b1$var$node;
module.exports["default"] = $0a818f05ef99c6b1$export$2e2bcd8739ae039;

});

parcelRegister("h9jgP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3gadb = parcelRequire("3gadb");


var $kfYj7 = parcelRequire("kfYj7");


var $b3j2Y = parcelRequire("b3j2Y");


var $bvJMy = parcelRequire("bvJMy");


var $cYSIK = parcelRequire("cYSIK");


var $lzJSA = parcelRequire("lzJSA");


var $Vc0wc = parcelRequire("Vc0wc");

const $a04196ec1f03cb0e$var$i18n = (0, $aXWIB.defineMessages)({
    star: {
        id: "feed.card.star.general",
        defaultMessage: "Star"
    },
    unstar: {
        id: "feed.card.unstar.general",
        defaultMessage: "Unstar"
    }
});
const $a04196ec1f03cb0e$var$FeedCardStarActionComponent = ({ intl: intl, contentId: contentId, isStarred: isStarred })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $42omo.useContext)((0, $cYSIK.FeedCardContext));
    const [toggleIsStar, starMutationError] = (0, $Vc0wc.useContentStar)(contentId);
    const handleStarButton = (0, $42omo.useCallback)(async ()=>{
        await toggleIsStar(isStarred);
        fireAnalyticsEvent({
            type: 'sendUIEvent',
            action: isStarred ? 'deleted' : 'created',
            actionSubject: 'favouritePage',
            actionSubjectId: 'feedCardDropdown'
        });
    }, [
        fireAnalyticsEvent,
        toggleIsStar,
        isStarred
    ]);
    const icon = isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bvJMy.StarSelectedIcon), {
        label: intl.formatMessage($a04196ec1f03cb0e$var$i18n.unstar)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kfYj7))), {
        label: intl.formatMessage($a04196ec1f03cb0e$var$i18n.star)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, starMutationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: starMutationError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), isStarred ? $a04196ec1f03cb0e$var$i18n.unstar : $a04196ec1f03cb0e$var$i18n.star),
        position: "top",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lzJSA.ActionButtonWrapper), {
        forceShow: isStarred
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lzJSA.StyledActionButton), {
        onClick: handleStarButton,
        appearance: "subtle",
        iconBefore: icon
    }))));
};
const $a04196ec1f03cb0e$export$5467f2b0a84fcc5a = (0, $aXWIB.injectIntl)($a04196ec1f03cb0e$var$FeedCardStarActionComponent);
module.exports["FeedCardStarAction"] = $a04196ec1f03cb0e$export$5467f2b0a84fcc5a;

});

parcelRegister("bEsCw", function(module, exports) {
/* CommentInfoLine.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $eEA8O = parcelRequire("eEA8O");


var $3FlVr = parcelRequire("3FlVr");


var $1NF8X = parcelRequire("1NF8X");


var $8SCD6 = parcelRequire("8SCD6");


var $6mKj3 = parcelRequire("6mKj3");


var $1RkMx = parcelRequire("1RkMx");


var $cYSIK = parcelRequire("cYSIK");

const $64eaba19d2411713$var$i18n = (0, $aXWIB.defineMessages)({
    viewComment: {
        id: "feed.card.comment.viewComment",
        defaultMessage: "View comment"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $64eaba19d2411713$var$FlexWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $64eaba19d2411713$var$ReactionsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $64eaba19d2411713$var$FlexWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazazsu _k48p1wq8 _4cvresu3",
            __cmplp.isGlobalReactionsAndLikesEnabled ? "_1bah1yb4" : "_1bahesu3",
            __cmplp.className
        ])
    });
});
const $64eaba19d2411713$var$ViewCommentWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _19bvv77o _1bahusic _1ul953f4",
            __cmplp.className
        ])
    });
});
const $64eaba19d2411713$var$ViewCommentWrapperTest = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _19bvv77o _1bah1e5h _1ul953f4",
            __cmplp.className
        ])
    });
});
const $64eaba19d2411713$var$CommentInfoLineComponent = ({ comment: comment, pageId: pageId, contentType: contentType })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $42omo.useContext)((0, $cYSIK.FeedCardContext));
    const { isReactionsEnabled: isGlobalReactionsAndLikesEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    const url = (0, $1RkMx.getCommentLink)(comment);
    const commentId = comment.id;
    const onViewCommentClick = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent({
            type: 'sendUIEvent',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'feedCardViewComment',
            commentId: commentId,
            includeNavdex: true
        });
    }, [
        fireAnalyticsEvent,
        commentId
    ]);
    const containerType = contentType === 'page' ? (0, $3FlVr.ReactionContainerType).PAGE : (0, $3FlVr.ReactionContainerType).BLOGPOST;
    const renderReactionsAndComments = ()=>{
        if (commentId && pageId && contentType) {
            if ((0, $6mKj3.expValEquals)('confluence_following_feed_remove_social_proof', 'cohort', 'remove-emojis-and-comments-counts') || (0, $6mKj3.expValEquals)('confluence_following_feed_remove_social_proof', 'cohort', 'remove-emojis')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($64eaba19d2411713$var$ViewCommentWrapperTest, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                href: url,
                onClick: onViewCommentClick,
                appearance: "subtle-link",
                spacing: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $64eaba19d2411713$var$i18n.viewComment))));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($64eaba19d2411713$var$ReactionsWrapper, {
                "data-testid": "feed-comment-reactions",
                isGlobalReactionsAndLikesEnabled: isGlobalReactionsAndLikesEnabled
            }, isGlobalReactionsAndLikesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1NF8X.ReactionsLoader), {
                contentId: commentId,
                location: (0, $3FlVr.ReactionLocation).FEED_COMMENT,
                containerId: pageId,
                containerType: containerType
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($64eaba19d2411713$var$ViewCommentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                href: url,
                onClick: onViewCommentClick,
                appearance: "subtle-link",
                spacing: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $64eaba19d2411713$var$i18n.viewComment)))));
        }
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("small", {
        "data-vc": "0mAm0HYm"
    }, renderReactionsAndComments());
};
const $64eaba19d2411713$export$731efa827102c551 = (0, $aXWIB.injectIntl)($64eaba19d2411713$var$CommentInfoLineComponent);
module.exports["CommentInfoLine"] = $64eaba19d2411713$export$731efa827102c551;

});

parcelRegister("lzJSA", function(module, exports) {
/* ActionButtonStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");

const $a537987504338da5$export$578eab857fe08277 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_701wzwfg",
            __cmplp.isSelected ? "_1w9015cr" : "_1w901rpy",
            __cmplp.className
        ])
    });
});
const $a537987504338da5$var$actionButtonWrapperStyle = null;
const $a537987504338da5$var$forceShowStyle = null; // Note: this component extracts the props that we don't want to send to the DOM
const $a537987504338da5$export$fb0bb875e597a5e3 = ({ forceShow: forceShow, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...rest,
        className: (0, $gMc0m.default)([
            "_v564fxgs _tzy41eg2",
            forceShow && "_tzy4kb7n"
        ]),
        "data-vc": "AqG40pc1"
    });
module.exports["StyledActionButton"] = $a537987504338da5$export$578eab857fe08277;
module.exports["ActionButtonWrapper"] = $a537987504338da5$export$fb0bb875e597a5e3;

});

parcelRegister("Vc0wc", function(module, exports) {

var $j5afu = parcelRequire("j5afu");


var $9T0kv = parcelRequire("9T0kv");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $a3fRD = parcelRequire("a3fRD");


var $dpPtd = parcelRequire("dpPtd");


var $308Wd = parcelRequire("308Wd");

const $c0ad904515836ea9$var$useContentStarStarMutation = (0, $9T0kv.default);
const $c0ad904515836ea9$var$useContentStarUnstarMutation = (0, $j5afu.default);
const $c0ad904515836ea9$var$i18n = (0, $aXWIB.defineMessages)({
    starMutationErrorTitle: {
        id: "feed.card.star.mutation.error.title",
        defaultMessage: "We\u2019re having trouble starring that item"
    },
    unstarMutationErrorTitle: {
        id: "feed.card.unstar.mutation.error.title",
        defaultMessage: "We\u2019re having trouble unstarring that item"
    },
    starMutationErrorDescription: {
        id: "feed.card.star.mutation.error.description",
        defaultMessage: "Try it again."
    }
});
function $c0ad904515836ea9$export$a3a3fd423fa20c0d(contentId) {
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const onMutationError = (0, $42omo.useCallback)((isStarred)=>()=>{
            showFlag({
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c0ad904515836ea9$var$i18n.starMutationErrorDescription),
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), isStarred ? $c0ad904515836ea9$var$i18n.unstarMutationErrorTitle : $c0ad904515836ea9$var$i18n.starMutationErrorTitle),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                    label: "error",
                    color: "var(--ds-icon-danger, #C9372C)",
                    spacing: "spacious"
                }),
                isAutoDismiss: true
            });
        }, [
        showFlag
    ]);
    const [mutateStar, { error: starError }] = (0, $308Wd.useMutationInterop)($c0ad904515836ea9$var$useContentStarStarMutation, {
        variables: {
            contentId: contentId
        },
        optimisticResponse: {
            favouritePage: {
                __typename: 'FavouritePagePayload',
                content: {
                    __typename: 'Content',
                    id: contentId,
                    metadata: {
                        __typename: 'ContentMetadata',
                        currentuser: {
                            __typename: 'ContentMetadata_CurrentUserMetadataProvider_currentuser',
                            favourited: {
                                __typename: 'FavouritedSummary',
                                isFavourite: true
                            }
                        }
                    }
                }
            }
        },
        onError: onMutationError(false),
        __callerPackage__: "@confluence/feed"
    });
    const [mutateUnstar, { error: unstarError }] = (0, $308Wd.useMutationInterop)($c0ad904515836ea9$var$useContentStarUnstarMutation, {
        variables: {
            contentId: contentId
        },
        optimisticResponse: {
            unfavouritePage: {
                __typename: 'FavouritePagePayload',
                content: {
                    __typename: 'Content',
                    id: contentId,
                    metadata: {
                        __typename: 'ContentMetadata',
                        currentuser: {
                            __typename: 'ContentMetadata_CurrentUserMetadataProvider_currentuser',
                            favourited: null
                        }
                    }
                }
            }
        },
        onError: onMutationError(true),
        __callerPackage__: "@confluence/feed"
    });
    const toggleStarState = (0, $42omo.useCallback)(async (starred)=>{
        try {
            if (starred) await mutateUnstar();
            else await mutateStar();
        } catch  {} // errors handled via useMutation
    }, [
        mutateStar,
        mutateUnstar
    ]);
    return [
        toggleStarState,
        starError || unstarError
    ];
}
module.exports["useContentStar"] = $c0ad904515836ea9$export$a3a3fd423fa20c0d;

});

parcelRegister("j5afu", function(module, exports) {
/**
 * @generated SignedSource<<9a42196db218155e1fe996f73fd61a1b>>
 * @relayHash f352cba41fdb7e45612ba8e8c63f4924
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 06b92e70fa740f611534cdf8a6c534986b8fd02bf146f9efe7aae5e4330ec5d3
const $0f9b28a2e9d4de51$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "contentId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "favouritePageInput"
                }
            ],
            "concreteType": "FavouritePagePayload",
            "kind": "LinkedField",
            "name": "unfavouritePage",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentStarUnstarMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentStarUnstarMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f352cba41fdb7e45612ba8e8c63f4924",
            "id": "06b92e70fa740f611534cdf8a6c534986b8fd02bf146f9efe7aae5e4330ec5d3",
            "metadata": {},
            "name": "useContentStarUnstarMutation",
            "operationKind": "mutation",
            "text": "mutation useContentStarUnstarMutation($contentId:ID!){unfavouritePage(favouritePageInput:{pageId:$contentId}){content{id,metadata{currentuser{favourited{isFavourite}}}}}}"
        }
    };
}();
$0f9b28a2e9d4de51$var$node.hash = "93f47afb6f09bd32bab5f61b3e99d199";
var $0f9b28a2e9d4de51$export$2e2bcd8739ae039 = $0f9b28a2e9d4de51$var$node;
module.exports["default"] = $0f9b28a2e9d4de51$export$2e2bcd8739ae039;

});

parcelRegister("9T0kv", function(module, exports) {
/**
 * @generated SignedSource<<09c338fe7d35c0be381524cf538c041d>>
 * @relayHash c0dd553a4d073bcedc8c1fca7c75cde7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 753d5cc9fd872f7a704bbfe19b4d5845ce0773de2f795afdbdafcad14ec14847
const $ce47c8c2a1b89c81$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "contentId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "favouritePageInput"
                }
            ],
            "concreteType": "FavouritePagePayload",
            "kind": "LinkedField",
            "name": "favouritePage",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentStarStarMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentStarStarMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c0dd553a4d073bcedc8c1fca7c75cde7",
            "id": "753d5cc9fd872f7a704bbfe19b4d5845ce0773de2f795afdbdafcad14ec14847",
            "metadata": {},
            "name": "useContentStarStarMutation",
            "operationKind": "mutation",
            "text": "mutation useContentStarStarMutation($contentId:ID!){favouritePage(favouritePageInput:{pageId:$contentId}){content{id,metadata{currentuser{favourited{isFavourite}}}}}}"
        }
    };
}();
$ce47c8c2a1b89c81$var$node.hash = "9040a024eb74fffcf9c56372e06501bd";
var $ce47c8c2a1b89c81$export$2e2bcd8739ae039 = $ce47c8c2a1b89c81$var$node;
module.exports["default"] = $ce47c8c2a1b89c81$export$2e2bcd8739ae039;

});


//# sourceMappingURL=ForYou.30ce90bb.js.map
